export default [
    {
        "kod": 531308,
        "nazev": "Jivina",
        "popis": "[531308] Jivina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531308,
        "val": "[531308] Jivina 2108 [531308] Jivina"
    },
    {
        "kod": 531316,
        "nazev": "Karlštejn",
        "popis": "[531316] Karlštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531316,
        "val": "[531316] Karlstejn 2102 [531316] Karlštejn"
    },
    {
        "kod": 531324,
        "nazev": "Komárov",
        "popis": "[531324] Komárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531324,
        "val": "[531324] Komarov 2108 [531324] Komárov"
    },
    {
        "kod": 531332,
        "nazev": "Koněprusy",
        "popis": "[531332] Koněprusy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531332,
        "val": "[531332] Koneprusy 2102 [531332] Koněprusy"
    },
    {
        "kod": 533793,
        "nazev": "Korno",
        "popis": "[533793] Korno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533793,
        "val": "[533793] Korno 2102 [533793] Korno"
    },
    {
        "kod": 534072,
        "nazev": "Kotopeky",
        "popis": "[534072] Kotopeky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 534072,
        "val": "[534072] Kotopeky 2108 [534072] Kotopeky"
    },
    {
        "kod": 533203,
        "nazev": "Králův Dvůr",
        "popis": "[533203] Králův Dvůr",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533203,
        "val": "[533203] Kraluv Dvur 2102 [533203] Králův Dvůr"
    },
    {
        "kod": 531375,
        "nazev": "Kublov",
        "popis": "[531375] Kublov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531375,
        "val": "[531375] Kublov 2102 [531375] Kublov"
    },
    {
        "kod": 533939,
        "nazev": "Lážovice",
        "popis": "[533939] Lážovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 533939,
        "val": "[533939] Lazovice 2108 [533939] Lážovice"
    },
    {
        "kod": 533335,
        "nazev": "Lhotka",
        "popis": "[533335] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 533335,
        "val": "[533335] Lhotka 2108 [533335] Lhotka"
    },
    {
        "kod": 531448,
        "nazev": "Libomyšl",
        "popis": "[531448] Libomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531448,
        "val": "[531448] Libomysl 2108 [531448] Libomyšl"
    },
    {
        "kod": 531456,
        "nazev": "Liteň",
        "popis": "[531456] Liteň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531456,
        "val": "[531456] Liten 2102 [531456] Liteň"
    },
    {
        "kod": 531464,
        "nazev": "Loděnice",
        "popis": "[531464] Loděnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531464,
        "val": "[531464] Lodenice 2102 [531464] Loděnice"
    },
    {
        "kod": 531472,
        "nazev": "Lochovice",
        "popis": "[531472] Lochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531472,
        "val": "[531472] Lochovice 2108 [531472] Lochovice"
    },
    {
        "kod": 534404,
        "nazev": "Lužce",
        "popis": "[534404] Lužce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534404,
        "val": "[534404] Luzce 2102 [534404] Lužce"
    },
    {
        "kod": 533319,
        "nazev": "Malá Víska",
        "popis": "[533319] Malá Víska",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 533319,
        "val": "[533319] Mala Viska 2108 [533319] Malá Víska"
    },
    {
        "kod": 534218,
        "nazev": "Málkov",
        "popis": "[534218] Málkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534218,
        "val": "[534218] Malkov 2102 [534218] Málkov"
    },
    {
        "kod": 531529,
        "nazev": "Měňany",
        "popis": "[531529] Měňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531529,
        "val": "[531529] Menany 2102 [531529] Měňany"
    },
    {
        "kod": 531537,
        "nazev": "Mezouň",
        "popis": "[531537] Mezouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531537,
        "val": "[531537] Mezoun 2102 [531537] Mezouň"
    },
    {
        "kod": 531545,
        "nazev": "Mořina",
        "popis": "[531545] Mořina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531545,
        "val": "[531545] Morina 2102 [531545] Mořina"
    },
    {
        "kod": 533912,
        "nazev": "Mořinka",
        "popis": "[533912] Mořinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533912,
        "val": "[533912] Morinka 2102 [533912] Mořinka"
    },
    {
        "kod": 533602,
        "nazev": "Nenačovice",
        "popis": "[533602] Nenačovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533602,
        "val": "[533602] Nenacovice 2102 [533602] Nenačovice"
    },
    {
        "kod": 534269,
        "nazev": "Nesvačily",
        "popis": "[534269] Nesvačily",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534269,
        "val": "[534269] Nesvacily 2102 [534269] Nesvačily"
    },
    {
        "kod": 531588,
        "nazev": "Neumětely",
        "popis": "[531588] Neumětely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531588,
        "val": "[531588] Neumetely 2108 [531588] Neumětely"
    },
    {
        "kod": 531596,
        "nazev": "Nižbor",
        "popis": "[531596] Nižbor",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531596,
        "val": "[531596] Nizbor 2102 [531596] Nižbor"
    },
    {
        "kod": 531600,
        "nazev": "Nový Jáchymov",
        "popis": "[531600] Nový Jáchymov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531600,
        "val": "[531600] Novy Jachymov 2102 [531600] Nový Jáchymov"
    },
    {
        "kod": 531626,
        "nazev": "Olešná",
        "popis": "[531626] Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531626,
        "val": "[531626] Olesna 2108 [531626] Olešná"
    },
    {
        "kod": 531634,
        "nazev": "Osek",
        "popis": "[531634] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531634,
        "val": "[531634] Osek 2108 [531634] Osek"
    },
    {
        "kod": 531642,
        "nazev": "Osov",
        "popis": "[531642] Osov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531642,
        "val": "[531642] Osov 2108 [531642] Osov"
    },
    {
        "kod": 534111,
        "nazev": "Otmíče",
        "popis": "[534111] Otmíče",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 534111,
        "val": "[534111] Otmice 2108 [534111] Otmíče"
    },
    {
        "kod": 531669,
        "nazev": "Otročiněves",
        "popis": "[531669] Otročiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531669,
        "val": "[531669] Otrocineves 2102 [531669] Otročiněves"
    },
    {
        "kod": 534285,
        "nazev": "Podbrdy",
        "popis": "[534285] Podbrdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534285,
        "val": "[534285] Podbrdy 2102 [534285] Podbrdy"
    },
    {
        "kod": 531685,
        "nazev": "Podluhy",
        "popis": "[531685] Podluhy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531685,
        "val": "[531685] Podluhy 2108 [531685] Podluhy"
    },
    {
        "kod": 531693,
        "nazev": "Praskolesy",
        "popis": "[531693] Praskolesy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531693,
        "val": "[531693] Praskolesy 2108 [531693] Praskolesy"
    },
    {
        "kod": 531715,
        "nazev": "Rpety",
        "popis": "[531715] Rpety",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531715,
        "val": "[531715] Rpety 2108 [531715] Rpety"
    },
    {
        "kod": 533963,
        "nazev": "Skřipel",
        "popis": "[533963] Skřipel",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 533963,
        "val": "[533963] Skripel 2108 [533963] Skřipel"
    },
    {
        "kod": 531740,
        "nazev": "Skuhrov",
        "popis": "[531740] Skuhrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531740,
        "val": "[531740] Skuhrov 2102 [531740] Skuhrov"
    },
    {
        "kod": 531758,
        "nazev": "Srbsko",
        "popis": "[531758] Srbsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531758,
        "val": "[531758] Srbsko 2102 [531758] Srbsko"
    },
    {
        "kod": 531766,
        "nazev": "Stašov",
        "popis": "[531766] Stašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531766,
        "val": "[531766] Stasov 2102 [531766] Stašov"
    },
    {
        "kod": 531782,
        "nazev": "Suchomasty",
        "popis": "[531782] Suchomasty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531782,
        "val": "[531782] Suchomasty 2102 [531782] Suchomasty"
    },
    {
        "kod": 531791,
        "nazev": "Svatá",
        "popis": "[531791] Svatá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531791,
        "val": "[531791] Svata 2102 [531791] Svatá"
    },
    {
        "kod": 531804,
        "nazev": "Svatý Jan pod Skalou",
        "popis": "[531804] Svatý Jan pod Skalou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531804,
        "val": "[531804] Svaty Jan pod Skalou 2102 [531804] Svatý Jan pod Skalou"
    },
    {
        "kod": 531812,
        "nazev": "Svinaře",
        "popis": "[531812] Svinaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531812,
        "val": "[531812] Svinare 2102 [531812] Svinaře"
    },
    {
        "kod": 531839,
        "nazev": "Tetín",
        "popis": "[531839] Tetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531839,
        "val": "[531839] Tetin 2102 [531839] Tetín"
    },
    {
        "kod": 531847,
        "nazev": "Tlustice",
        "popis": "[531847] Tlustice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531847,
        "val": "[531847] Tlustice 2108 [531847] Tlustice"
    },
    {
        "kod": 531855,
        "nazev": "Tmaň",
        "popis": "[531855] Tmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531855,
        "val": "[531855] Tman 2102 [531855] Tmaň"
    },
    {
        "kod": 534463,
        "nazev": "Točník",
        "popis": "[534463] Točník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 534463,
        "val": "[534463] Tocnik 2108 [534463] Točník"
    },
    {
        "kod": 533106,
        "nazev": "Trubín",
        "popis": "[533106] Trubín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533106,
        "val": "[533106] Trubin 2102 [533106] Trubín"
    },
    {
        "kod": 531880,
        "nazev": "Trubská",
        "popis": "[531880] Trubská",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531880,
        "val": "[531880] Trubska 2102 [531880] Trubská"
    },
    {
        "kod": 531901,
        "nazev": "Újezd",
        "popis": "[531901] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531901,
        "val": "[531901] Ujezd 2108 [531901] Újezd"
    },
    {
        "kod": 531910,
        "nazev": "Velký Chlumec",
        "popis": "[531910] Velký Chlumec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531910,
        "val": "[531910] Velky Chlumec 2108 [531910] Velký Chlumec"
    },
    {
        "kod": 534234,
        "nazev": "Vinařice",
        "popis": "[534234] Vinařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534234,
        "val": "[534234] Vinarice 2102 [534234] Vinařice"
    },
    {
        "kod": 534048,
        "nazev": "Vižina",
        "popis": "[534048] Vižina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 534048,
        "val": "[534048] Vizina 2108 [534048] Vižina"
    },
    {
        "kod": 531944,
        "nazev": "Vráž",
        "popis": "[531944] Vráž",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531944,
        "val": "[531944] Vraz 2102 [531944] Vráž"
    },
    {
        "kod": 531952,
        "nazev": "Všeradice",
        "popis": "[531952] Všeradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531952,
        "val": "[531952] Vseradice 2102 [531952] Všeradice"
    },
    {
        "kod": 531961,
        "nazev": "Vysoký Újezd",
        "popis": "[531961] Vysoký Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531961,
        "val": "[531961] Vysoky Ujezd 2102 [531961] Vysoký Újezd"
    },
    {
        "kod": 531979,
        "nazev": "Zadní Třebaň",
        "popis": "[531979] Zadní Třebaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531979,
        "val": "[531979] Zadni Treban 2102 [531979] Zadní Třebaň"
    },
    {
        "kod": 531995,
        "nazev": "Zaječov",
        "popis": "[531995] Zaječov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531995,
        "val": "[531995] Zajecov 2108 [531995] Zaječov"
    },
    {
        "kod": 532002,
        "nazev": "Záluží",
        "popis": "[532002] Záluží",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 532002,
        "val": "[532002] Zaluzi 2108 [532002] Záluží"
    },
    {
        "kod": 532011,
        "nazev": "Zdice",
        "popis": "[532011] Zdice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 532011,
        "val": "[532011] Zdice 2102 [532011] Zdice"
    },
    {
        "kod": 532029,
        "nazev": "Žebrák",
        "popis": "[532029] Žebrák",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 532029,
        "val": "[532029] Zebrak 2108 [532029] Žebrák"
    },
    {
        "kod": 599417,
        "nazev": "Železná",
        "popis": "[599417] Železná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 599417,
        "val": "[599417] Zelezna 2102 [599417] Železná"
    },
    {
        "kod": 535010,
        "nazev": "Běleč",
        "popis": "[535010] Běleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 535010,
        "val": "[535010] Belec 2109 [535010] Běleč"
    },
    {
        "kod": 532070,
        "nazev": "Běloky",
        "popis": "[532070] Běloky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532070,
        "val": "[532070] Beloky 2109 [532070] Běloky"
    },
    {
        "kod": 532088,
        "nazev": "Beřovice",
        "popis": "[532088] Beřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532088,
        "val": "[532088] Berovice 2124 [532088] Beřovice"
    },
    {
        "kod": 535125,
        "nazev": "Bílichov",
        "popis": "[535125] Bílichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 535125,
        "val": "[535125] Bilichov 2124 [535125] Bílichov"
    },
    {
        "kod": 532100,
        "nazev": "Blevice",
        "popis": "[532100] Blevice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532100,
        "val": "[532100] Blevice 2109 [532100] Blevice"
    },
    {
        "kod": 532118,
        "nazev": "Brandýsek",
        "popis": "[532118] Brandýsek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532118,
        "val": "[532118] Brandysek 2109 [532118] Brandýsek"
    },
    {
        "kod": 532126,
        "nazev": "Braškov",
        "popis": "[532126] Braškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532126,
        "val": "[532126] Braskov 2109 [532126] Braškov"
    },
    {
        "kod": 532142,
        "nazev": "Bratronice",
        "popis": "[532142] Bratronice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532142,
        "val": "[532142] Bratronice 2109 [532142] Bratronice"
    },
    {
        "kod": 532169,
        "nazev": "Buštěhrad",
        "popis": "[532169] Buštěhrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532169,
        "val": "[532169] Bustehrad 2109 [532169] Buštěhrad"
    },
    {
        "kod": 532185,
        "nazev": "Cvrčovice",
        "popis": "[532185] Cvrčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532185,
        "val": "[532185] Cvrcovice 2109 [532185] Cvrčovice"
    },
    {
        "kod": 532207,
        "nazev": "Černuc",
        "popis": "[532207] Černuc",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532207,
        "val": "[532207] Cernuc 2124 [532207] Černuc"
    },
    {
        "kod": 532223,
        "nazev": "Doksy",
        "popis": "[532223] Doksy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532223,
        "val": "[532223] Doksy 2109 [532223] Doksy"
    },
    {
        "kod": 513130,
        "nazev": "Dolany",
        "popis": "[513130] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 513130,
        "val": "[513130] Dolany 2109 [513130] Dolany"
    },
    {
        "kod": 512991,
        "nazev": "Drnek",
        "popis": "[512991] Drnek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 512991,
        "val": "[512991] Drnek 2124 [512991] Drnek"
    },
    {
        "kod": 532274,
        "nazev": "Družec",
        "popis": "[532274] Družec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532274,
        "val": "[532274] Druzec 2109 [532274] Družec"
    },
    {
        "kod": 532282,
        "nazev": "Dřetovice",
        "popis": "[532282] Dřetovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532282,
        "val": "[532282] Dretovice 2109 [532282] Dřetovice"
    },
    {
        "kod": 532291,
        "nazev": "Dřínov",
        "popis": "[532291] Dřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532291,
        "val": "[532291] Drinov 2124 [532291] Dřínov"
    },
    {
        "kod": 513075,
        "nazev": "Hobšovice",
        "popis": "[513075] Hobšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 513075,
        "val": "[513075] Hobsovice 2124 [513075] Hobšovice"
    },
    {
        "kod": 532312,
        "nazev": "Horní Bezděkov",
        "popis": "[532312] Horní Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532312,
        "val": "[532312] Horni Bezdekov 2109 [532312] Horní Bezděkov"
    },
    {
        "kod": 532321,
        "nazev": "Hořešovice",
        "popis": "[532321] Hořešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532321,
        "val": "[532321] Horesovice 2124 [532321] Hořešovice"
    },
    {
        "kod": 535150,
        "nazev": "Hořešovičky",
        "popis": "[535150] Hořešovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 535150,
        "val": "[535150] Horesovicky 2124 [535150] Hořešovičky"
    },
    {
        "kod": 532339,
        "nazev": "Hospozín",
        "popis": "[532339] Hospozín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532339,
        "val": "[532339] Hospozin 2124 [532339] Hospozín"
    },
    {
        "kod": 532347,
        "nazev": "Hostouň",
        "popis": "[532347] Hostouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532347,
        "val": "[532347] Hostoun 2109 [532347] Hostouň"
    },
    {
        "kod": 532355,
        "nazev": "Hradečno",
        "popis": "[532355] Hradečno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532355,
        "val": "[532355] Hradecno 2109 [532355] Hradečno"
    },
    {
        "kod": 532363,
        "nazev": "Hrdlív",
        "popis": "[532363] Hrdlív",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532363,
        "val": "[532363] Hrdliv 2124 [532363] Hrdlív"
    },
    {
        "kod": 532371,
        "nazev": "Hřebeč",
        "popis": "[532371] Hřebeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532371,
        "val": "[532371] Hrebec 2109 [532371] Hřebeč"
    },
    {
        "kod": 532398,
        "nazev": "Chržín",
        "popis": "[532398] Chržín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532398,
        "val": "[532398] Chrzin 2124 [532398] Chržín"
    },
    {
        "kod": 532401,
        "nazev": "Jarpice",
        "popis": "[532401] Jarpice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532401,
        "val": "[532401] Jarpice 2124 [532401] Jarpice"
    },
    {
        "kod": 532410,
        "nazev": "Jedomělice",
        "popis": "[532410] Jedomělice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532410,
        "val": "[532410] Jedomelice 2124 [532410] Jedomělice"
    },
    {
        "kod": 532428,
        "nazev": "Jemníky",
        "popis": "[532428] Jemníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532428,
        "val": "[532428] Jemniky 2124 [532428] Jemníky"
    },
    {
        "kod": 532444,
        "nazev": "Kačice",
        "popis": "[532444] Kačice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532444,
        "val": "[532444] Kacice 2109 [532444] Kačice"
    },
    {
        "kod": 532452,
        "nazev": "Kamenné Žehrovice",
        "popis": "[532452] Kamenné Žehrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532452,
        "val": "[532452] Kamenne Zehrovice 2109 [532452] Kamenné Žehrovice"
    },
    {
        "kod": 513032,
        "nazev": "Kamenný Most",
        "popis": "[513032] Kamenný Most",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 513032,
        "val": "[513032] Kamenny Most 2124 [513032] Kamenný Most"
    },
    {
        "kod": 532053,
        "nazev": "Kladno",
        "popis": "[532053] Kladno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532053,
        "val": "[532053] Kladno 2109 [532053] Kladno"
    },
    {
        "kod": 532461,
        "nazev": "Klobuky",
        "popis": "[532461] Klobuky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532461,
        "val": "[532461] Klobuky 2124 [532461] Klobuky"
    },
    {
        "kod": 532479,
        "nazev": "Kmetiněves",
        "popis": "[532479] Kmetiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532479,
        "val": "[532479] Kmetineves 2124 [532479] Kmetiněves"
    },
    {
        "kod": 532487,
        "nazev": "Knovíz",
        "popis": "[532487] Knovíz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532487,
        "val": "[532487] Knoviz 2124 [532487] Knovíz"
    },
    {
        "kod": 532495,
        "nazev": "Koleč",
        "popis": "[532495] Koleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532495,
        "val": "[532495] Kolec 2109 [532495] Koleč"
    },
    {
        "kod": 535109,
        "nazev": "Královice",
        "popis": "[535109] Královice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 535109,
        "val": "[535109] Kralovice 2124 [535109] Královice"
    },
    {
        "kod": 571512,
        "nazev": "Kutrovice",
        "popis": "[571512] Kutrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571512,
        "val": "[571512] Kutrovice 2124 [571512] Kutrovice"
    },
    {
        "kod": 532517,
        "nazev": "Kvílice",
        "popis": "[532517] Kvílice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532517,
        "val": "[532517] Kvilice 2124 [532517] Kvílice"
    },
    {
        "kod": 532525,
        "nazev": "Kyšice",
        "popis": "[532525] Kyšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532525,
        "val": "[532525] Kysice 2109 [532525] Kyšice"
    },
    {
        "kod": 541991,
        "nazev": "Lány",
        "popis": "[541991] Lány",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 541991,
        "val": "[541991] Lany 2109 [541991] Lány"
    },
    {
        "kod": 532533,
        "nazev": "Ledce",
        "popis": "[532533] Ledce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532533,
        "val": "[532533] Ledce 2124 [532533] Ledce"
    },
    {
        "kod": 513041,
        "nazev": "Lhota",
        "popis": "[513041] Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 513041,
        "val": "[513041] Lhota 2109 [513041] Lhota"
    },
    {
        "kod": 564150,
        "nazev": "Libochovičky",
        "popis": "[564150] Libochovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 564150,
        "val": "[564150] Libochovicky 2109 [564150] Libochovičky"
    },
    {
        "kod": 571601,
        "nazev": "Libovice",
        "popis": "[571601] Libovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571601,
        "val": "[571601] Libovice 2124 [571601] Libovice"
    },
    {
        "kod": 532576,
        "nazev": "Libušín",
        "popis": "[532576] Libušín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532576,
        "val": "[532576] Libusin 2109 [532576] Libušín"
    },
    {
        "kod": 532584,
        "nazev": "Lidice",
        "popis": "[532584] Lidice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532584,
        "val": "[532584] Lidice 2109 [532584] Lidice"
    },
    {
        "kod": 571555,
        "nazev": "Líský",
        "popis": "[571555] Líský",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571555,
        "val": "[571555] Lisky 2124 [571555] Líský"
    },
    {
        "kod": 535095,
        "nazev": "Loucká",
        "popis": "[535095] Loucká",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 535095,
        "val": "[535095] Loucka 2124 [535095] Loucká"
    },
    {
        "kod": 532622,
        "nazev": "Makotřasy",
        "popis": "[532622] Makotřasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532622,
        "val": "[532622] Makotrasy 2109 [532622] Makotřasy"
    },
    {
        "kod": 532631,
        "nazev": "Malé Kyšice",
        "popis": "[532631] Malé Kyšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532631,
        "val": "[532631] Male Kysice 2109 [532631] Malé Kyšice"
    },
    {
        "kod": 513113,
        "nazev": "Malé Přítočno",
        "popis": "[513113] Malé Přítočno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 513113,
        "val": "[513113] Male Pritocno 2109 [513113] Malé Přítočno"
    },
    {
        "kod": 532657,
        "nazev": "Malíkovice",
        "popis": "[532657] Malíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532657,
        "val": "[532657] Malikovice 2124 [532657] Malíkovice"
    },
    {
        "kod": 571521,
        "nazev": "Neprobylice",
        "popis": "[571521] Neprobylice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571521,
        "val": "[571521] Neprobylice 2124 [571521] Neprobylice"
    },
    {
        "kod": 532665,
        "nazev": "Neuměřice",
        "popis": "[532665] Neuměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532665,
        "val": "[532665] Neumerice 2124 [532665] Neuměřice"
    },
    {
        "kod": 532681,
        "nazev": "Otvovice",
        "popis": "[532681] Otvovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532681,
        "val": "[532681] Otvovice 2109 [532681] Otvovice"
    },
    {
        "kod": 564192,
        "nazev": "Páleč",
        "popis": "[564192] Páleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 564192,
        "val": "[564192] Palec 2124 [564192] Páleč"
    },
    {
        "kod": 532711,
        "nazev": "Pavlov",
        "popis": "[532711] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532711,
        "val": "[532711] Pavlov 2109 [532711] Pavlov"
    },
    {
        "kod": 532720,
        "nazev": "Pchery",
        "popis": "[532720] Pchery",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532720,
        "val": "[532720] Pchery 2109 [532720] Pchery"
    },
    {
        "kod": 532738,
        "nazev": "Pletený Újezd",
        "popis": "[532738] Pletený Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532738,
        "val": "[532738] Pleteny Ujezd 2109 [532738] Pletený Újezd"
    },
    {
        "kod": 564125,
        "nazev": "Plchov",
        "popis": "[564125] Plchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 564125,
        "val": "[564125] Plchov 2124 [564125] Plchov"
    },
    {
        "kod": 532754,
        "nazev": "Podlešín",
        "popis": "[532754] Podlešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532754,
        "val": "[532754] Podlesin 2124 [532754] Podlešín"
    },
    {
        "kod": 564087,
        "nazev": "Poštovice",
        "popis": "[564087] Poštovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 564087,
        "val": "[564087] Postovice 2124 [564087] Poštovice"
    },
    {
        "kod": 532762,
        "nazev": "Pozdeň",
        "popis": "[532762] Pozdeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532762,
        "val": "[532762] Pozden 2124 [532762] Pozdeň"
    },
    {
        "kod": 532771,
        "nazev": "Přelíc",
        "popis": "[532771] Přelíc",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532771,
        "val": "[532771] Prelic 2124 [532771] Přelíc"
    },
    {
        "kod": 532797,
        "nazev": "Řisuty",
        "popis": "[532797] Řisuty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532797,
        "val": "[532797] Risuty 2124 [532797] Řisuty"
    },
    {
        "kod": 532801,
        "nazev": "Sazená",
        "popis": "[532801] Sazená",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532801,
        "val": "[532801] Sazena 2124 [532801] Sazená"
    },
    {
        "kod": 532819,
        "nazev": "Slaný",
        "popis": "[532819] Slaný",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532819,
        "val": "[532819] Slany 2124 [532819] Slaný"
    },
    {
        "kod": 532827,
        "nazev": "Slatina",
        "popis": "[532827] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532827,
        "val": "[532827] Slatina 2109 [532827] Slatina"
    },
    {
        "kod": 532835,
        "nazev": "Smečno",
        "popis": "[532835] Smečno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532835,
        "val": "[532835] Smecno 2124 [532835] Smečno"
    },
    {
        "kod": 532851,
        "nazev": "Stehelčeves",
        "popis": "[532851] Stehelčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532851,
        "val": "[532851] Stehelceves 2109 [532851] Stehelčeves"
    },
    {
        "kod": 532860,
        "nazev": "Stochov",
        "popis": "[532860] Stochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532860,
        "val": "[532860] Stochov 2109 [532860] Stochov"
    },
    {
        "kod": 531430,
        "nazev": "Horka I",
        "popis": "[531430] Horka I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531430,
        "val": "[531430] Horka I 2104 [531430] Horka I"
    },
    {
        "kod": 534056,
        "nazev": "Horka II",
        "popis": "[534056] Horka II",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534056,
        "val": "[534056] Horka II 2112 [534056] Horka II"
    },
    {
        "kod": 531359,
        "nazev": "Horky",
        "popis": "[531359] Horky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531359,
        "val": "[531359] Horky 2104 [531359] Horky"
    },
    {
        "kod": 531481,
        "nazev": "Horušice",
        "popis": "[531481] Horušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531481,
        "val": "[531481] Horusice 2104 [531481] Horušice"
    },
    {
        "kod": 534064,
        "nazev": "Hostovlice",
        "popis": "[534064] Hostovlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534064,
        "val": "[534064] Hostovlice 2104 [534064] Hostovlice"
    },
    {
        "kod": 531413,
        "nazev": "Hraběšín",
        "popis": "[531413] Hraběšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531413,
        "val": "[531413] Hrabesin 2104 [531413] Hraběšín"
    },
    {
        "kod": 534081,
        "nazev": "Chabeřice",
        "popis": "[534081] Chabeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534081,
        "val": "[534081] Chaberice 2112 [534081] Chabeřice"
    },
    {
        "kod": 534099,
        "nazev": "Chlístovice",
        "popis": "[534099] Chlístovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534099,
        "val": "[534099] Chlistovice 2112 [534099] Chlístovice"
    },
    {
        "kod": 534102,
        "nazev": "Chotusice",
        "popis": "[534102] Chotusice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534102,
        "val": "[534102] Chotusice 2104 [534102] Chotusice"
    },
    {
        "kod": 534129,
        "nazev": "Kácov",
        "popis": "[534129] Kácov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534129,
        "val": "[534129] Kacov 2112 [534129] Kácov"
    },
    {
        "kod": 534137,
        "nazev": "Kluky",
        "popis": "[534137] Kluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534137,
        "val": "[534137] Kluky 2104 [534137] Kluky"
    },
    {
        "kod": 531405,
        "nazev": "Kobylnice",
        "popis": "[531405] Kobylnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531405,
        "val": "[531405] Kobylnice 2112 [531405] Kobylnice"
    },
    {
        "kod": 551465,
        "nazev": "Košice",
        "popis": "[551465] Košice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 551465,
        "val": "[551465] Kosice 2112 [551465] Košice"
    },
    {
        "kod": 534153,
        "nazev": "Krchleby",
        "popis": "[534153] Krchleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534153,
        "val": "[534153] Krchleby 2104 [534153] Krchleby"
    },
    {
        "kod": 534161,
        "nazev": "Křesetice",
        "popis": "[534161] Křesetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534161,
        "val": "[534161] Kresetice 2112 [534161] Křesetice"
    },
    {
        "kod": 533955,
        "nazev": "Kutná Hora",
        "popis": "[533955] Kutná Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 533955,
        "val": "[533955] Kutna Hora 2112 [533955] Kutná Hora"
    },
    {
        "kod": 534170,
        "nazev": "Ledečko",
        "popis": "[534170] Ledečko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534170,
        "val": "[534170] Ledecko 2112 [534170] Ledečko"
    },
    {
        "kod": 534188,
        "nazev": "Malešov",
        "popis": "[534188] Malešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534188,
        "val": "[534188] Malesov 2112 [534188] Malešov"
    },
    {
        "kod": 534200,
        "nazev": "Miskovice",
        "popis": "[534200] Miskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534200,
        "val": "[534200] Miskovice 2112 [534200] Miskovice"
    },
    {
        "kod": 530999,
        "nazev": "Močovice",
        "popis": "[530999] Močovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 530999,
        "val": "[530999] Mocovice 2104 [530999] Močovice"
    },
    {
        "kod": 534226,
        "nazev": "Nepoměřice",
        "popis": "[534226] Nepoměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534226,
        "val": "[534226] Nepomerice 2112 [534226] Nepoměřice"
    },
    {
        "kod": 534242,
        "nazev": "Nové Dvory",
        "popis": "[534242] Nové Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534242,
        "val": "[534242] Nove Dvory 2112 [534242] Nové Dvory"
    },
    {
        "kod": 534251,
        "nazev": "Okřesaneč",
        "popis": "[534251] Okřesaneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534251,
        "val": "[534251] Okresanec 2104 [534251] Okřesaneč"
    },
    {
        "kod": 534277,
        "nazev": "Onomyšl",
        "popis": "[534277] Onomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534277,
        "val": "[534277] Onomysl 2112 [534277] Onomyšl"
    },
    {
        "kod": 530956,
        "nazev": "Opatovice I",
        "popis": "[530956] Opatovice I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 530956,
        "val": "[530956] Opatovice I 2112 [530956] Opatovice I"
    },
    {
        "kod": 531278,
        "nazev": "Paběnice",
        "popis": "[531278] Paběnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531278,
        "val": "[531278] Pabenice 2112 [531278] Paběnice"
    },
    {
        "kod": 534307,
        "nazev": "Pertoltice",
        "popis": "[534307] Pertoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534307,
        "val": "[534307] Pertoltice 2112 [534307] Pertoltice"
    },
    {
        "kod": 534315,
        "nazev": "Petrovice I",
        "popis": "[534315] Petrovice I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534315,
        "val": "[534315] Petrovice I 2112 [534315] Petrovice I"
    },
    {
        "kod": 534323,
        "nazev": "Petrovice II",
        "popis": "[534323] Petrovice II",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534323,
        "val": "[534323] Petrovice II 2112 [534323] Petrovice II"
    },
    {
        "kod": 528196,
        "nazev": "Podveky",
        "popis": "[528196] Podveky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 528196,
        "val": "[528196] Podveky 2112 [528196] Podveky"
    },
    {
        "kod": 534331,
        "nazev": "Potěhy",
        "popis": "[534331] Potěhy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534331,
        "val": "[534331] Potehy 2104 [534331] Potěhy"
    },
    {
        "kod": 534340,
        "nazev": "Rašovice",
        "popis": "[534340] Rašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534340,
        "val": "[534340] Rasovice 2112 [534340] Rašovice"
    },
    {
        "kod": 534358,
        "nazev": "Rataje nad Sázavou",
        "popis": "[534358] Rataje nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534358,
        "val": "[534358] Rataje nad Sazavou 2112 [534358] Rataje nad Sázavou"
    },
    {
        "kod": 526622,
        "nazev": "Rohozec",
        "popis": "[526622] Rohozec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 526622,
        "val": "[526622] Rohozec 2104 [526622] Rohozec"
    },
    {
        "kod": 534366,
        "nazev": "Řendějov",
        "popis": "[534366] Řendějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534366,
        "val": "[534366] Rendejov 2112 [534366] Řendějov"
    },
    {
        "kod": 534374,
        "nazev": "Samopše",
        "popis": "[534374] Samopše",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534374,
        "val": "[534374] Samopse 2112 [534374] Samopše"
    },
    {
        "kod": 530859,
        "nazev": "Semtěš",
        "popis": "[530859] Semtěš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 530859,
        "val": "[530859] Semtes 2104 [530859] Semtěš"
    },
    {
        "kod": 531383,
        "nazev": "Schořov",
        "popis": "[531383] Schořov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531383,
        "val": "[531383] Schorov 2104 [531383] Schořov"
    },
    {
        "kod": 534391,
        "nazev": "Slavošov",
        "popis": "[534391] Slavošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534391,
        "val": "[534391] Slavosov 2112 [534391] Slavošov"
    },
    {
        "kod": 534293,
        "nazev": "Soběšín",
        "popis": "[534293] Soběšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534293,
        "val": "[534293] Sobesin 2112 [534293] Soběšín"
    },
    {
        "kod": 531065,
        "nazev": "Souňov",
        "popis": "[531065] Souňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531065,
        "val": "[531065] Sounov 2104 [531065] Souňov"
    },
    {
        "kod": 534412,
        "nazev": "Staňkovice",
        "popis": "[534412] Staňkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534412,
        "val": "[534412] Stankovice 2112 [534412] Staňkovice"
    },
    {
        "kod": 530875,
        "nazev": "Starkoč",
        "popis": "[530875] Starkoč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 530875,
        "val": "[530875] Starkoc 2104 [530875] Starkoč"
    },
    {
        "kod": 531391,
        "nazev": "Sudějov",
        "popis": "[531391] Sudějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531391,
        "val": "[531391] Sudejov 2112 [531391] Sudějov"
    },
    {
        "kod": 534439,
        "nazev": "Suchdol",
        "popis": "[534439] Suchdol",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534439,
        "val": "[534439] Suchdol 2112 [534439] Suchdol"
    },
    {
        "kod": 534196,
        "nazev": "Svatý Mikuláš",
        "popis": "[534196] Svatý Mikuláš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534196,
        "val": "[534196] Svaty Mikulas 2112 [534196] Svatý Mikuláš"
    },
    {
        "kod": 531421,
        "nazev": "Šebestěnice",
        "popis": "[531421] Šebestěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531421,
        "val": "[531421] Sebestenice 2104 [531421] Šebestěnice"
    },
    {
        "kod": 530930,
        "nazev": "Štipoklasy",
        "popis": "[530930] Štipoklasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 530930,
        "val": "[530930] Stipoklasy 2112 [530930] Štipoklasy"
    },
    {
        "kod": 530981,
        "nazev": "Třebešice",
        "popis": "[530981] Třebešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 530981,
        "val": "[530981] Trebesice 2104 [530981] Třebešice"
    },
    {
        "kod": 530972,
        "nazev": "Třebětín",
        "popis": "[530972] Třebětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 530972,
        "val": "[530972] Trebetin 2112 [530972] Třebětín"
    },
    {
        "kod": 571741,
        "nazev": "Třebonín",
        "popis": "[571741] Třebonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 571741,
        "val": "[571741] Trebonin 2104 [571741] Třebonín"
    },
    {
        "kod": 534480,
        "nazev": "Tupadly",
        "popis": "[534480] Tupadly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534480,
        "val": "[534480] Tupadly 2104 [534480] Tupadly"
    },
    {
        "kod": 534498,
        "nazev": "Uhlířské Janovice",
        "popis": "[534498] Uhlířské Janovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534498,
        "val": "[534498] Uhlirske Janovice 2112 [534498] Uhlířské Janovice"
    },
    {
        "kod": 534501,
        "nazev": "Úmonín",
        "popis": "[534501] Úmonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534501,
        "val": "[534501] Umonin 2112 [534501] Úmonín"
    },
    {
        "kod": 534510,
        "nazev": "Úžice",
        "popis": "[534510] Úžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534510,
        "val": "[534510] Uzice 2112 [534510] Úžice"
    },
    {
        "kod": 534528,
        "nazev": "Vavřinec",
        "popis": "[534528] Vavřinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534528,
        "val": "[534528] Vavrinec 2112 [534528] Vavřinec"
    },
    {
        "kod": 534536,
        "nazev": "Vidice",
        "popis": "[534536] Vidice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534536,
        "val": "[534536] Vidice 2112 [534536] Vidice"
    },
    {
        "kod": 534544,
        "nazev": "Vinaře",
        "popis": "[534544] Vinaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534544,
        "val": "[534544] Vinare 2104 [534544] Vinaře"
    },
    {
        "kod": 534552,
        "nazev": "Vlačice",
        "popis": "[534552] Vlačice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534552,
        "val": "[534552] Vlacice 2104 [534552] Vlačice"
    },
    {
        "kod": 534561,
        "nazev": "Vlastějovice",
        "popis": "[534561] Vlastějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534561,
        "val": "[534561] Vlastejovice 2112 [534561] Vlastějovice"
    },
    {
        "kod": 534579,
        "nazev": "Vlkaneč",
        "popis": "[534579] Vlkaneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534579,
        "val": "[534579] Vlkanec 2104 [534579] Vlkaneč"
    },
    {
        "kod": 531014,
        "nazev": "Vodranty",
        "popis": "[531014] Vodranty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531014,
        "val": "[531014] Vodranty 2104 [531014] Vodranty"
    },
    {
        "kod": 534587,
        "nazev": "Vrdy",
        "popis": "[534587] Vrdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534587,
        "val": "[534587] Vrdy 2104 [534587] Vrdy"
    },
    {
        "kod": 534595,
        "nazev": "Záboří nad Labem",
        "popis": "[534595] Záboří nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534595,
        "val": "[534595] Zabori nad Labem 2112 [534595] Záboří nad Labem"
    },
    {
        "kod": 534609,
        "nazev": "Zbizuby",
        "popis": "[534609] Zbizuby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534609,
        "val": "[534609] Zbizuby 2112 [534609] Zbizuby"
    },
    {
        "kod": 534617,
        "nazev": "Zbraslavice",
        "popis": "[534617] Zbraslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534617,
        "val": "[534617] Zbraslavice 2112 [534617] Zbraslavice"
    },
    {
        "kod": 534625,
        "nazev": "Zbýšov",
        "popis": "[534625] Zbýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534625,
        "val": "[534625] Zbysov 2104 [534625] Zbýšov"
    },
    {
        "kod": 534633,
        "nazev": "Zruč nad Sázavou",
        "popis": "[534633] Zruč nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534633,
        "val": "[534633] Zruc nad Sazavou 2112 [534633] Zruč nad Sázavou"
    },
    {
        "kod": 534641,
        "nazev": "Žáky",
        "popis": "[534641] Žáky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534641,
        "val": "[534641] Zaky 2104 [534641] Žáky"
    },
    {
        "kod": 534650,
        "nazev": "Žehušice",
        "popis": "[534650] Žehušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534650,
        "val": "[534650] Zehusice 2104 [534650] Žehušice"
    },
    {
        "kod": 534668,
        "nazev": "Žleby",
        "popis": "[534668] Žleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534668,
        "val": "[534668] Zleby 2104 [534668] Žleby"
    },
    {
        "kod": 534714,
        "nazev": "Býkev",
        "popis": "[534714] Býkev",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534714,
        "val": "[534714] Bykev 2114 [534714] Býkev"
    },
    {
        "kod": 534722,
        "nazev": "Byšice",
        "popis": "[534722] Byšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534722,
        "val": "[534722] Bysice 2114 [534722] Byšice"
    },
    {
        "kod": 534731,
        "nazev": "Cítov",
        "popis": "[534731] Cítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534731,
        "val": "[534731] Citov 2114 [534731] Cítov"
    },
    {
        "kod": 598291,
        "nazev": "Čakovičky",
        "popis": "[598291] Čakovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 598291,
        "val": "[598291] Cakovicky 2117 [598291] Čakovičky"
    },
    {
        "kod": 534749,
        "nazev": "Čečelice",
        "popis": "[534749] Čečelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534749,
        "val": "[534749] Cecelice 2114 [534749] Čečelice"
    },
    {
        "kod": 531570,
        "nazev": "Dobřeň",
        "popis": "[531570] Dobřeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531570,
        "val": "[531570] Dobren 2114 [531570] Dobřeň"
    },
    {
        "kod": 539201,
        "nazev": "Dolany",
        "popis": "[539201] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 539201,
        "val": "[539201] Dolany 2111 [539201] Dolany"
    },
    {
        "kod": 534765,
        "nazev": "Dolní Beřkovice",
        "popis": "[534765] Dolní Beřkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534765,
        "val": "[534765] Dolni Berkovice 2114 [534765] Dolní Beřkovice"
    },
    {
        "kod": 531987,
        "nazev": "Dolní Zimoř",
        "popis": "[531987] Dolní Zimoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531987,
        "val": "[531987] Dolni Zimor 2114 [531987] Dolní Zimoř"
    },
    {
        "kod": 534773,
        "nazev": "Dřínov",
        "popis": "[534773] Dřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 534773,
        "val": "[534773] Drinov 2111 [534773] Dřínov"
    },
    {
        "kod": 534790,
        "nazev": "Horní Počaply",
        "popis": "[534790] Horní Počaply",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534790,
        "val": "[534790] Horni Pocaply 2114 [534790] Horní Počaply"
    },
    {
        "kod": 534803,
        "nazev": "Hořín",
        "popis": "[534803] Hořín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534803,
        "val": "[534803] Horin 2114 [534803] Hořín"
    },
    {
        "kod": 531499,
        "nazev": "Hostín",
        "popis": "[531499] Hostín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531499,
        "val": "[531499] Hostin 2114 [531499] Hostín"
    },
    {
        "kod": 531928,
        "nazev": "Hostín u Vojkovic",
        "popis": "[531928] Hostín u Vojkovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 531928,
        "val": "[531928] Hostin u Vojkovic 2111 [531928] Hostín u Vojkovic"
    },
    {
        "kod": 534820,
        "nazev": "Chlumín",
        "popis": "[534820] Chlumín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 534820,
        "val": "[534820] Chlumin 2117 [534820] Chlumín"
    },
    {
        "kod": 534838,
        "nazev": "Chorušice",
        "popis": "[534838] Chorušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534838,
        "val": "[534838] Chorusice 2114 [534838] Chorušice"
    },
    {
        "kod": 534846,
        "nazev": "Chvatěruby",
        "popis": "[534846] Chvatěruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 534846,
        "val": "[534846] Chvateruby 2111 [534846] Chvatěruby"
    },
    {
        "kod": 531871,
        "nazev": "Jeviněves",
        "popis": "[531871] Jeviněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531871,
        "val": "[531871] Jevineves 2114 [531871] Jeviněves"
    },
    {
        "kod": 531774,
        "nazev": "Kadlín",
        "popis": "[531774] Kadlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531774,
        "val": "[531774] Kadlin 2114 [531774] Kadlín"
    },
    {
        "kod": 531651,
        "nazev": "Kanina",
        "popis": "[531651] Kanina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531651,
        "val": "[531651] Kanina 2114 [531651] Kanina"
    },
    {
        "kod": 534897,
        "nazev": "Kly",
        "popis": "[534897] Kly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534897,
        "val": "[534897] Kly 2114 [534897] Kly"
    },
    {
        "kod": 538345,
        "nazev": "Kojetice",
        "popis": "[538345] Kojetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 538345,
        "val": "[538345] Kojetice 2117 [538345] Kojetice"
    },
    {
        "kod": 534901,
        "nazev": "Kokořín",
        "popis": "[534901] Kokořín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534901,
        "val": "[534901] Kokorin 2114 [534901] Kokořín"
    },
    {
        "kod": 534935,
        "nazev": "Kostelec nad Labem",
        "popis": "[534935] Kostelec nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 534935,
        "val": "[534935] Kostelec nad Labem 2117 [534935] Kostelec nad Labem"
    },
    {
        "kod": 571792,
        "nazev": "Kozomín",
        "popis": "[571792] Kozomín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 571792,
        "val": "[571792] Kozomin 2111 [571792] Kozomín"
    },
    {
        "kod": 534951,
        "nazev": "Kralupy nad Vltavou",
        "popis": "[534951] Kralupy nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 534951,
        "val": "[534951] Kralupy nad Vltavou 2111 [534951] Kralupy nad Vltavou"
    },
    {
        "kod": 534978,
        "nazev": "Ledčice",
        "popis": "[534978] Ledčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 534978,
        "val": "[534978] Ledcice 2111 [534978] Ledčice"
    },
    {
        "kod": 531898,
        "nazev": "Lhotka",
        "popis": "[531898] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531898,
        "val": "[531898] Lhotka 2114 [531898] Lhotka"
    },
    {
        "kod": 535001,
        "nazev": "Liběchov",
        "popis": "[535001] Liběchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535001,
        "val": "[535001] Libechov 2114 [535001] Liběchov"
    },
    {
        "kod": 571784,
        "nazev": "Libiš",
        "popis": "[571784] Libiš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 571784,
        "val": "[571784] Libis 2117 [571784] Libiš"
    },
    {
        "kod": 531502,
        "nazev": "Liblice",
        "popis": "[531502] Liblice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531502,
        "val": "[531502] Liblice 2114 [531502] Liblice"
    },
    {
        "kod": 531677,
        "nazev": "Lobeč",
        "popis": "[531677] Lobeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531677,
        "val": "[531677] Lobec 2114 [531677] Lobeč"
    },
    {
        "kod": 535028,
        "nazev": "Lužec nad Vltavou",
        "popis": "[535028] Lužec nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535028,
        "val": "[535028] Luzec nad Vltavou 2114 [535028] Lužec nad Vltavou"
    },
    {
        "kod": 535036,
        "nazev": "Malý Újezd",
        "popis": "[535036] Malý Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535036,
        "val": "[535036] Maly Ujezd 2114 [535036] Malý Újezd"
    },
    {
        "kod": 529575,
        "nazev": "Medonosy",
        "popis": "[529575] Medonosy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 529575,
        "val": "[529575] Medonosy 2114 [529575] Medonosy"
    },
    {
        "kod": 535044,
        "nazev": "Mělnické Vtelno",
        "popis": "[535044] Mělnické Vtelno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535044,
        "val": "[535044] Melnicke Vtelno 2114 [535044] Mělnické Vtelno"
    },
    {
        "kod": 534676,
        "nazev": "Mělník",
        "popis": "[534676] Mělník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 534676,
        "val": "[534676] Melnik 2114 [534676] Mělník"
    },
    {
        "kod": 535052,
        "nazev": "Mšeno",
        "popis": "[535052] Mšeno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535052,
        "val": "[535052] Mseno 2114 [535052] Mšeno"
    },
    {
        "kod": 535061,
        "nazev": "Nebužely",
        "popis": "[535061] Nebužely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535061,
        "val": "[535061] Nebuzely 2114 [535061] Nebužely"
    },
    {
        "kod": 531863,
        "nazev": "Nedomice",
        "popis": "[531863] Nedomice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 531863,
        "val": "[531863] Nedomice 2117 [531863] Nedomice"
    },
    {
        "kod": 535079,
        "nazev": "Nelahozeves",
        "popis": "[535079] Nelahozeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535079,
        "val": "[535079] Nelahozeves 2111 [535079] Nelahozeves"
    },
    {
        "kod": 535087,
        "nazev": "Neratovice",
        "popis": "[535087] Neratovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535087,
        "val": "[535087] Neratovice 2117 [535087] Neratovice"
    },
    {
        "kod": 531707,
        "nazev": "Nosálov",
        "popis": "[531707] Nosálov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531707,
        "val": "[531707] Nosalov 2114 [531707] Nosálov"
    },
    {
        "kod": 535117,
        "nazev": "Nová Ves",
        "popis": "[535117] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535117,
        "val": "[535117] Nova Ves 2111 [535117] Nová Ves"
    },
    {
        "kod": 535133,
        "nazev": "Obříství",
        "popis": "[535133] Obříství",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535133,
        "val": "[535133] Obristvi 2117 [535133] Obříství"
    },
    {
        "kod": 532673,
        "nazev": "Olovnice",
        "popis": "[532673] Olovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 532673,
        "val": "[532673] Olovnice 2111 [532673] Olovnice"
    },
    {
        "kod": 535141,
        "nazev": "Ovčáry",
        "popis": "[535141] Ovčáry",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535141,
        "val": "[535141] Ovcary 2117 [535141] Ovčáry"
    },
    {
        "kod": 538647,
        "nazev": "Postřižín",
        "popis": "[538647] Postřižín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 538647,
        "val": "[538647] Postrizin 2111 [538647] Postřižín"
    },
    {
        "kod": 535168,
        "nazev": "Řepín",
        "popis": "[535168] Řepín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535168,
        "val": "[535168] Repin 2114 [535168] Řepín"
    },
    {
        "kod": 535192,
        "nazev": "Spomyšl",
        "popis": "[535192] Spomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535192,
        "val": "[535192] Spomysl 2114 [535192] Spomyšl"
    },
    {
        "kod": 531731,
        "nazev": "Stránka",
        "popis": "[531731] Stránka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531731,
        "val": "[531731] Stranka 2114 [531731] Stránka"
    },
    {
        "kod": 535214,
        "nazev": "Střemy",
        "popis": "[535214] Střemy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535214,
        "val": "[535214] Stremy 2114 [535214] Střemy"
    },
    {
        "kod": 535222,
        "nazev": "Tišice",
        "popis": "[535222] Tišice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535222,
        "val": "[535222] Tisice 2117 [535222] Tišice"
    },
    {
        "kod": 531561,
        "nazev": "Tuhaň",
        "popis": "[531561] Tuhaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531561,
        "val": "[531561] Tuhan 2114 [531561] Tuhaň"
    },
    {
        "kod": 529583,
        "nazev": "Tupadly",
        "popis": "[529583] Tupadly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 529583,
        "val": "[529583] Tupadly 2114 [529583] Tupadly"
    },
    {
        "kod": 599492,
        "nazev": "Újezdec",
        "popis": "[599492] Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 599492,
        "val": "[599492] Ujezdec 2111 [599492] Újezdec"
    },
    {
        "kod": 535257,
        "nazev": "Úžice",
        "popis": "[535257] Úžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535257,
        "val": "[535257] Uzice 2111 [535257] Úžice"
    },
    {
        "kod": 535265,
        "nazev": "Velký Borek",
        "popis": "[535265] Velký Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535265,
        "val": "[535265] Velky Borek 2114 [535265] Velký Borek"
    },
    {
        "kod": 535273,
        "nazev": "Veltrusy",
        "popis": "[535273] Veltrusy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535273,
        "val": "[535273] Veltrusy 2111 [535273] Veltrusy"
    },
    {
        "kod": 531936,
        "nazev": "Vidim",
        "popis": "[531936] Vidim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 531936,
        "val": "[531936] Vidim 2114 [531936] Vidim"
    },
    {
        "kod": 535290,
        "nazev": "Vojkovice",
        "popis": "[535290] Vojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535290,
        "val": "[535290] Vojkovice 2111 [535290] Vojkovice"
    },
    {
        "kod": 599441,
        "nazev": "Stradonice",
        "popis": "[599441] Stradonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 599441,
        "val": "[599441] Stradonice 2124 [599441] Stradonice"
    },
    {
        "kod": 551457,
        "nazev": "Studeněves",
        "popis": "[551457] Studeněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 551457,
        "val": "[551457] Studeneves 2124 [551457] Studeněves"
    },
    {
        "kod": 599433,
        "nazev": "Svárov",
        "popis": "[599433] Svárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 599433,
        "val": "[599433] Svarov 2109 [599433] Svárov"
    },
    {
        "kod": 532908,
        "nazev": "Svinařov",
        "popis": "[532908] Svinařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532908,
        "val": "[532908] Svinarov 2109 [532908] Svinařov"
    },
    {
        "kod": 532916,
        "nazev": "Šlapanice",
        "popis": "[532916] Šlapanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532916,
        "val": "[532916] Slapanice 2124 [532916] Šlapanice"
    },
    {
        "kod": 532959,
        "nazev": "Třebichovice",
        "popis": "[532959] Třebichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532959,
        "val": "[532959] Trebichovice 2109 [532959] Třebichovice"
    },
    {
        "kod": 532967,
        "nazev": "Třebíz",
        "popis": "[532967] Třebíz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532967,
        "val": "[532967] Trebiz 2124 [532967] Třebíz"
    },
    {
        "kod": 532975,
        "nazev": "Třebusice",
        "popis": "[532975] Třebusice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532975,
        "val": "[532975] Trebusice 2109 [532975] Třebusice"
    },
    {
        "kod": 532983,
        "nazev": "Tuchlovice",
        "popis": "[532983] Tuchlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 532983,
        "val": "[532983] Tuchlovice 2109 [532983] Tuchlovice"
    },
    {
        "kod": 532177,
        "nazev": "Tuřany",
        "popis": "[532177] Tuřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 532177,
        "val": "[532177] Turany 2124 [532177] Tuřany"
    },
    {
        "kod": 533009,
        "nazev": "Uhy",
        "popis": "[533009] Uhy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533009,
        "val": "[533009] Uhy 2124 [533009] Uhy"
    },
    {
        "kod": 533017,
        "nazev": "Unhošť",
        "popis": "[533017] Unhošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533017,
        "val": "[533017] Unhost 2109 [533017] Unhošť"
    },
    {
        "kod": 533025,
        "nazev": "Velká Dobrá",
        "popis": "[533025] Velká Dobrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533025,
        "val": "[533025] Velka Dobra 2109 [533025] Velká Dobrá"
    },
    {
        "kod": 533033,
        "nazev": "Velké Přítočno",
        "popis": "[533033] Velké Přítočno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533033,
        "val": "[533033] Velke Pritocno 2109 [533033] Velké Přítočno"
    },
    {
        "kod": 533041,
        "nazev": "Velvary",
        "popis": "[533041] Velvary",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533041,
        "val": "[533041] Velvary 2124 [533041] Velvary"
    },
    {
        "kod": 533050,
        "nazev": "Vinařice",
        "popis": "[533050] Vinařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533050,
        "val": "[533050] Vinarice 2109 [533050] Vinařice"
    },
    {
        "kod": 533068,
        "nazev": "Vraný",
        "popis": "[533068] Vraný",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533068,
        "val": "[533068] Vrany 2124 [533068] Vraný"
    },
    {
        "kod": 571431,
        "nazev": "Vrbičany",
        "popis": "[571431] Vrbičany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571431,
        "val": "[571431] Vrbicany 2124 [571431] Vrbičany"
    },
    {
        "kod": 571598,
        "nazev": "Zájezd",
        "popis": "[571598] Zájezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 571598,
        "val": "[571598] Zajezd 2109 [571598] Zájezd"
    },
    {
        "kod": 533092,
        "nazev": "Zákolany",
        "popis": "[533092] Zákolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533092,
        "val": "[533092] Zakolany 2109 [533092] Zákolany"
    },
    {
        "kod": 571423,
        "nazev": "Zichovec",
        "popis": "[571423] Zichovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 571423,
        "val": "[571423] Zichovec 2124 [571423] Zichovec"
    },
    {
        "kod": 533114,
        "nazev": "Zlonice",
        "popis": "[533114] Zlonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533114,
        "val": "[533114] Zlonice 2124 [533114] Zlonice"
    },
    {
        "kod": 533122,
        "nazev": "Zvoleněves",
        "popis": "[533122] Zvoleněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533122,
        "val": "[533122] Zvoleneves 2124 [533122] Zvoleněves"
    },
    {
        "kod": 599425,
        "nazev": "Želenice",
        "popis": "[599425] Želenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 599425,
        "val": "[599425] Zelenice 2124 [599425] Želenice"
    },
    {
        "kod": 533149,
        "nazev": "Žilina",
        "popis": "[533149] Žilina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2109,
        "iczuj": 533149,
        "val": "[533149] Zilina 2109 [533149] Žilina"
    },
    {
        "kod": 533157,
        "nazev": "Žižice",
        "popis": "[533157] Žižice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2124,
        "iczuj": 533157,
        "val": "[533157] Zizice 2124 [533157] Žižice"
    },
    {
        "kod": 533173,
        "nazev": "Barchovice",
        "popis": "[533173] Barchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533173,
        "val": "[533173] Barchovice 2110 [533173] Barchovice"
    },
    {
        "kod": 533181,
        "nazev": "Bečváry",
        "popis": "[533181] Bečváry",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533181,
        "val": "[533181] Becvary 2110 [533181] Bečváry"
    },
    {
        "kod": 533190,
        "nazev": "Bělušice",
        "popis": "[533190] Bělušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533190,
        "val": "[533190] Belusice 2110 [533190] Bělušice"
    },
    {
        "kod": 533211,
        "nazev": "Břežany I",
        "popis": "[533211] Břežany I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533211,
        "val": "[533211] Brezany I 2110 [533211] Břežany I"
    },
    {
        "kod": 533220,
        "nazev": "Břežany II",
        "popis": "[533220] Břežany II",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533220,
        "val": "[533220] Brezany II 2106 [533220] Břežany II"
    },
    {
        "kod": 533238,
        "nazev": "Býchory",
        "popis": "[533238] Býchory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533238,
        "val": "[533238] Bychory 2110 [533238] Býchory"
    },
    {
        "kod": 533246,
        "nazev": "Cerhenice",
        "popis": "[533246] Cerhenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533246,
        "val": "[533246] Cerhenice 2110 [533246] Cerhenice"
    },
    {
        "kod": 599476,
        "nazev": "Církvice",
        "popis": "[599476] Církvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 599476,
        "val": "[599476] Cirkvice 2110 [599476] Církvice"
    },
    {
        "kod": 533262,
        "nazev": "Červené Pečky",
        "popis": "[533262] Červené Pečky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533262,
        "val": "[533262] Cervene Pecky 2110 [533262] Červené Pečky"
    },
    {
        "kod": 533271,
        "nazev": "Český Brod",
        "popis": "[533271] Český Brod",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533271,
        "val": "[533271] Cesky Brod 2106 [533271] Český Brod"
    },
    {
        "kod": 533289,
        "nazev": "Dobřichov",
        "popis": "[533289] Dobřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533289,
        "val": "[533289] Dobrichov 2110 [533289] Dobřichov"
    },
    {
        "kod": 533297,
        "nazev": "Dolní Chvatliny",
        "popis": "[533297] Dolní Chvatliny",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533297,
        "val": "[533297] Dolni Chvatliny 2110 [533297] Dolní Chvatliny"
    },
    {
        "kod": 513181,
        "nazev": "Dománovice",
        "popis": "[513181] Dománovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513181,
        "val": "[513181] Domanovice 2110 [513181] Dománovice"
    },
    {
        "kod": 533301,
        "nazev": "Doubravčice",
        "popis": "[533301] Doubravčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533301,
        "val": "[533301] Doubravcice 2106 [533301] Doubravčice"
    },
    {
        "kod": 564681,
        "nazev": "Drahobudice",
        "popis": "[564681] Drahobudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 564681,
        "val": "[564681] Drahobudice 2110 [564681] Drahobudice"
    },
    {
        "kod": 599450,
        "nazev": "Grunta",
        "popis": "[599450] Grunta",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 599450,
        "val": "[599450] Grunta 2110 [599450] Grunta"
    },
    {
        "kod": 533327,
        "nazev": "Horní Kruty",
        "popis": "[533327] Horní Kruty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533327,
        "val": "[533327] Horni Kruty 2110 [533327] Horní Kruty"
    },
    {
        "kod": 564800,
        "nazev": "Hradešín",
        "popis": "[564800] Hradešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 564800,
        "val": "[564800] Hradesin 2106 [564800] Hradešín"
    },
    {
        "kod": 534994,
        "nazev": "Choťovice",
        "popis": "[534994] Choťovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 534994,
        "val": "[534994] Chotovice 2110 [534994] Choťovice"
    },
    {
        "kod": 533343,
        "nazev": "Chotutice",
        "popis": "[533343] Chotutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533343,
        "val": "[533343] Chotutice 2110 [533343] Chotutice"
    },
    {
        "kod": 533351,
        "nazev": "Chrášťany",
        "popis": "[533351] Chrášťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533351,
        "val": "[533351] Chrastany 2106 [533351] Chrášťany"
    },
    {
        "kod": 533360,
        "nazev": "Jestřabí Lhota",
        "popis": "[533360] Jestřabí Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533360,
        "val": "[533360] Jestrabi Lhota 2110 [533360] Jestřabí Lhota"
    },
    {
        "kod": 513415,
        "nazev": "Kbel",
        "popis": "[513415] Kbel",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513415,
        "val": "[513415] Kbel 2110 [513415] Kbel"
    },
    {
        "kod": 571687,
        "nazev": "Klášterní Skalice",
        "popis": "[571687] Klášterní Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 571687,
        "val": "[571687] Klasterni Skalice 2110 [571687] Klášterní Skalice"
    },
    {
        "kod": 533386,
        "nazev": "Klučov",
        "popis": "[533386] Klučov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533386,
        "val": "[533386] Klucov 2106 [533386] Klučov"
    },
    {
        "kod": 533165,
        "nazev": "Kolín",
        "popis": "[533165] Kolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533165,
        "val": "[533165] Kolin 2110 [533165] Kolín"
    },
    {
        "kod": 533394,
        "nazev": "Konárovice",
        "popis": "[533394] Konárovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533394,
        "val": "[533394] Konarovice 2110 [533394] Konárovice"
    },
    {
        "kod": 533408,
        "nazev": "Kořenice",
        "popis": "[533408] Kořenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533408,
        "val": "[533408] Korenice 2110 [533408] Kořenice"
    },
    {
        "kod": 533424,
        "nazev": "Kouřim",
        "popis": "[533424] Kouřim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533424,
        "val": "[533424] Kourim 2110 [533424] Kouřim"
    },
    {
        "kod": 533441,
        "nazev": "Krakovany",
        "popis": "[533441] Krakovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533441,
        "val": "[533441] Krakovany 2110 [533441] Krakovany"
    },
    {
        "kod": 533459,
        "nazev": "Krupá",
        "popis": "[533459] Krupá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533459,
        "val": "[533459] Krupa 2106 [533459] Krupá"
    },
    {
        "kod": 599484,
        "nazev": "Krychnov",
        "popis": "[599484] Krychnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 599484,
        "val": "[599484] Krychnov 2110 [599484] Krychnov"
    },
    {
        "kod": 533467,
        "nazev": "Křečhoř",
        "popis": "[533467] Křečhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533467,
        "val": "[533467] Krechor 2110 [533467] Křečhoř"
    },
    {
        "kod": 571717,
        "nazev": "Kšely",
        "popis": "[571717] Kšely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 571717,
        "val": "[571717] Ksely 2106 [571717] Kšely"
    },
    {
        "kod": 533475,
        "nazev": "Libenice",
        "popis": "[533475] Libenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533475,
        "val": "[533475] Libenice 2110 [533475] Libenice"
    },
    {
        "kod": 533483,
        "nazev": "Libodřice",
        "popis": "[533483] Libodřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533483,
        "val": "[533483] Libodrice 2110 [533483] Libodřice"
    },
    {
        "kod": 513270,
        "nazev": "Lipec",
        "popis": "[513270] Lipec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513270,
        "val": "[513270] Lipec 2110 [513270] Lipec"
    },
    {
        "kod": 533505,
        "nazev": "Lošany",
        "popis": "[533505] Lošany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533505,
        "val": "[533505] Losany 2110 [533505] Lošany"
    },
    {
        "kod": 533513,
        "nazev": "Malotice",
        "popis": "[533513] Malotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533513,
        "val": "[533513] Malotice 2110 [533513] Malotice"
    },
    {
        "kod": 564702,
        "nazev": "Masojedy",
        "popis": "[564702] Masojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 564702,
        "val": "[564702] Masojedy 2106 [564702] Masojedy"
    },
    {
        "kod": 513288,
        "nazev": "Mrzky",
        "popis": "[513288] Mrzky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 513288,
        "val": "[513288] Mrzky 2106 [513288] Mrzky"
    },
    {
        "kod": 533521,
        "nazev": "Nebovidy",
        "popis": "[533521] Nebovidy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533521,
        "val": "[533521] Nebovidy 2110 [533521] Nebovidy"
    },
    {
        "kod": 571636,
        "nazev": "Němčice",
        "popis": "[571636] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 571636,
        "val": "[571636] Nemcice 2110 [571636] Němčice"
    },
    {
        "kod": 533530,
        "nazev": "Nová Ves I",
        "popis": "[533530] Nová Ves I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533530,
        "val": "[533530] Nova Ves I 2110 [533530] Nová Ves I"
    },
    {
        "kod": 533556,
        "nazev": "Ohaře",
        "popis": "[533556] Ohaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533556,
        "val": "[533556] Ohare 2110 [533556] Ohaře"
    },
    {
        "kod": 533572,
        "nazev": "Ovčáry",
        "popis": "[533572] Ovčáry",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533572,
        "val": "[533572] Ovcary 2110 [533572] Ovčáry"
    },
    {
        "kod": 513423,
        "nazev": "Pašinka",
        "popis": "[513423] Pašinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513423,
        "val": "[513423] Pasinka 2110 [513423] Pašinka"
    },
    {
        "kod": 537641,
        "nazev": "Pečky",
        "popis": "[537641] Pečky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 537641,
        "val": "[537641] Pecky 2110 [537641] Pečky"
    },
    {
        "kod": 533581,
        "nazev": "Plaňany",
        "popis": "[533581] Plaňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533581,
        "val": "[533581] Planany 2110 [533581] Plaňany"
    },
    {
        "kod": 537675,
        "nazev": "Pňov-Předhradí",
        "popis": "[537675] Pňov-Předhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 537675,
        "val": "[537675] Pnov-Predhradi 2110 [537675] Pňov-Předhradí"
    },
    {
        "kod": 533599,
        "nazev": "Polepy",
        "popis": "[533599] Polepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533599,
        "val": "[533599] Polepy 2110 [533599] Polepy"
    },
    {
        "kod": 513237,
        "nazev": "Polní Chrčice",
        "popis": "[513237] Polní Chrčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513237,
        "val": "[513237] Polni Chrcice 2110 [513237] Polní Chrčice"
    },
    {
        "kod": 513148,
        "nazev": "Polní Voděrady",
        "popis": "[513148] Polní Voděrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513148,
        "val": "[513148] Polni Voderady 2110 [513148] Polní Voděrady"
    },
    {
        "kod": 537705,
        "nazev": "Poříčany",
        "popis": "[537705] Poříčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 537705,
        "val": "[537705] Poricany 2106 [537705] Poříčany"
    },
    {
        "kod": 513369,
        "nazev": "Přehvozdí",
        "popis": "[513369] Přehvozdí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 513369,
        "val": "[513369] Prehvozdi 2106 [513369] Přehvozdí"
    },
    {
        "kod": 513393,
        "nazev": "Přistoupim",
        "popis": "[513393] Přistoupim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 513393,
        "val": "[513393] Pristoupim 2106 [513393] Přistoupim"
    },
    {
        "kod": 533611,
        "nazev": "Přišimasy",
        "popis": "[533611] Přišimasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533611,
        "val": "[533611] Prisimasy 2106 [533611] Přišimasy"
    },
    {
        "kod": 533629,
        "nazev": "Radim",
        "popis": "[533629] Radim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533629,
        "val": "[533629] Radim 2110 [533629] Radim"
    },
    {
        "kod": 533637,
        "nazev": "Radovesnice I",
        "popis": "[533637] Radovesnice I",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533637,
        "val": "[533637] Radovesnice I 2110 [533637] Radovesnice I"
    },
    {
        "kod": 533645,
        "nazev": "Radovesnice II",
        "popis": "[533645] Radovesnice II",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533645,
        "val": "[533645] Radovesnice II 2110 [533645] Radovesnice II"
    },
    {
        "kod": 533653,
        "nazev": "Ratboř",
        "popis": "[533653] Ratboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533653,
        "val": "[533653] Ratbor 2110 [533653] Ratboř"
    },
    {
        "kod": 537748,
        "nazev": "Ratenice",
        "popis": "[537748] Ratenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 537748,
        "val": "[537748] Ratenice 2110 [537748] Ratenice"
    },
    {
        "kod": 533661,
        "nazev": "Rostoklaty",
        "popis": "[533661] Rostoklaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533661,
        "val": "[533661] Rostoklaty 2106 [533661] Rostoklaty"
    },
    {
        "kod": 533696,
        "nazev": "Skvrňov",
        "popis": "[533696] Skvrňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533696,
        "val": "[533696] Skvrnov 2110 [533696] Skvrňov"
    },
    {
        "kod": 533700,
        "nazev": "Starý Kolín",
        "popis": "[533700] Starý Kolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533700,
        "val": "[533700] Stary Kolin 2110 [533700] Starý Kolín"
    },
    {
        "kod": 533726,
        "nazev": "Svojšice",
        "popis": "[533726] Svojšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533726,
        "val": "[533726] Svojsice 2110 [533726] Svojšice"
    },
    {
        "kod": 537888,
        "nazev": "Tatce",
        "popis": "[537888] Tatce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 537888,
        "val": "[537888] Tatce 2110 [537888] Tatce"
    },
    {
        "kod": 533734,
        "nazev": "Tismice",
        "popis": "[533734] Tismice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533734,
        "val": "[533734] Tismice 2106 [533734] Tismice"
    },
    {
        "kod": 533742,
        "nazev": "Toušice",
        "popis": "[533742] Toušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533742,
        "val": "[533742] Tousice 2110 [533742] Toušice"
    },
    {
        "kod": 533751,
        "nazev": "Třebovle",
        "popis": "[533751] Třebovle",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533751,
        "val": "[533751] Trebovle 2110 [533751] Třebovle"
    },
    {
        "kod": 533769,
        "nazev": "Tři Dvory",
        "popis": "[533769] Tři Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533769,
        "val": "[533769] Tri Dvory 2110 [533769] Tři Dvory"
    },
    {
        "kod": 533777,
        "nazev": "Tuchoraz",
        "popis": "[533777] Tuchoraz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533777,
        "val": "[533777] Tuchoraz 2106 [533777] Tuchoraz"
    },
    {
        "kod": 533785,
        "nazev": "Tuklaty",
        "popis": "[533785] Tuklaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533785,
        "val": "[533785] Tuklaty 2106 [533785] Tuklaty"
    },
    {
        "kod": 533807,
        "nazev": "Týnec nad Labem",
        "popis": "[533807] Týnec nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533807,
        "val": "[533807] Tynec nad Labem 2110 [533807] Týnec nad Labem"
    },
    {
        "kod": 533815,
        "nazev": "Uhlířská Lhota",
        "popis": "[533815] Uhlířská Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533815,
        "val": "[533815] Uhlirska Lhota 2110 [533815] Uhlířská Lhota"
    },
    {
        "kod": 533823,
        "nazev": "Veletov",
        "popis": "[533823] Veletov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533823,
        "val": "[533823] Veletov 2110 [533823] Veletov"
    },
    {
        "kod": 533831,
        "nazev": "Velim",
        "popis": "[533831] Velim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533831,
        "val": "[533831] Velim 2110 [533831] Velim"
    },
    {
        "kod": 533840,
        "nazev": "Velký Osek",
        "popis": "[533840] Velký Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533840,
        "val": "[533840] Velky Osek 2110 [533840] Velký Osek"
    },
    {
        "kod": 533858,
        "nazev": "Veltruby",
        "popis": "[533858] Veltruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533858,
        "val": "[533858] Veltruby 2110 [533858] Veltruby"
    },
    {
        "kod": 533866,
        "nazev": "Vitice",
        "popis": "[533866] Vitice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 533866,
        "val": "[533866] Vitice 2106 [533866] Vitice"
    },
    {
        "kod": 533882,
        "nazev": "Volárna",
        "popis": "[533882] Volárna",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533882,
        "val": "[533882] Volarna 2110 [533882] Volárna"
    },
    {
        "kod": 564826,
        "nazev": "Vrátkov",
        "popis": "[564826] Vrátkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 564826,
        "val": "[564826] Vratkov 2106 [564826] Vrátkov"
    },
    {
        "kod": 533891,
        "nazev": "Vrbčany",
        "popis": "[533891] Vrbčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533891,
        "val": "[533891] Vrbcany 2110 [533891] Vrbčany"
    },
    {
        "kod": 513202,
        "nazev": "Zalešany",
        "popis": "[513202] Zalešany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513202,
        "val": "[513202] Zalesany 2110 [513202] Zalešany"
    },
    {
        "kod": 533921,
        "nazev": "Zásmuky",
        "popis": "[533921] Zásmuky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533921,
        "val": "[533921] Zasmuky 2110 [533921] Zásmuky"
    },
    {
        "kod": 513261,
        "nazev": "Žabonosy",
        "popis": "[513261] Žabonosy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513261,
        "val": "[513261] Zabonosy 2110 [513261] Žabonosy"
    },
    {
        "kod": 513164,
        "nazev": "Ždánice",
        "popis": "[513164] Ždánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 513164,
        "val": "[513164] Zdanice 2110 [513164] Ždánice"
    },
    {
        "kod": 538035,
        "nazev": "Žehuň",
        "popis": "[538035] Žehuň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 538035,
        "val": "[538035] Zehun 2110 [538035] Žehuň"
    },
    {
        "kod": 533947,
        "nazev": "Žiželice",
        "popis": "[533947] Žiželice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2110,
        "iczuj": 533947,
        "val": "[533947] Zizelice 2110 [533947] Žiželice"
    },
    {
        "kod": 531367,
        "nazev": "Adamov",
        "popis": "[531367] Adamov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531367,
        "val": "[531367] Adamov 2104 [531367] Adamov"
    },
    {
        "kod": 531111,
        "nazev": "Bernardov",
        "popis": "[531111] Bernardov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531111,
        "val": "[531111] Bernardov 2112 [531111] Bernardov"
    },
    {
        "kod": 533971,
        "nazev": "Bílé Podolí",
        "popis": "[533971] Bílé Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 533971,
        "val": "[533971] Bile Podoli 2104 [533971] Bílé Podolí"
    },
    {
        "kod": 530964,
        "nazev": "Bludov",
        "popis": "[530964] Bludov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 530964,
        "val": "[530964] Bludov 2112 [530964] Bludov"
    },
    {
        "kod": 533980,
        "nazev": "Bohdaneč",
        "popis": "[533980] Bohdaneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 533980,
        "val": "[533980] Bohdanec 2112 [533980] Bohdaneč"
    },
    {
        "kod": 530832,
        "nazev": "Brambory",
        "popis": "[530832] Brambory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 530832,
        "val": "[530832] Brambory 2104 [530832] Brambory"
    },
    {
        "kod": 531286,
        "nazev": "Bratčice",
        "popis": "[531286] Bratčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531286,
        "val": "[531286] Bratcice 2104 [531286] Bratčice"
    },
    {
        "kod": 533998,
        "nazev": "Církvice",
        "popis": "[533998] Církvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 533998,
        "val": "[533998] Cirkvice 2112 [533998] Církvice"
    },
    {
        "kod": 534005,
        "nazev": "Čáslav",
        "popis": "[534005] Čáslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 534005,
        "val": "[534005] Caslav 2104 [534005] Čáslav"
    },
    {
        "kod": 529524,
        "nazev": "Čejkovice",
        "popis": "[529524] Čejkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 529524,
        "val": "[529524] Cejkovice 2104 [529524] Čejkovice"
    },
    {
        "kod": 534013,
        "nazev": "Černíny",
        "popis": "[534013] Černíny",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534013,
        "val": "[534013] Cerniny 2112 [534013] Černíny"
    },
    {
        "kod": 534021,
        "nazev": "Červené Janovice",
        "popis": "[534021] Červené Janovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534021,
        "val": "[534021] Cervene Janovice 2112 [534021] Červené Janovice"
    },
    {
        "kod": 534030,
        "nazev": "Čestín",
        "popis": "[534030] Čestín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 534030,
        "val": "[534030] Cestin 2112 [534030] Čestín"
    },
    {
        "kod": 529559,
        "nazev": "Dobrovítov",
        "popis": "[529559] Dobrovítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 529559,
        "val": "[529559] Dobrovitov 2104 [529559] Dobrovítov"
    },
    {
        "kod": 531260,
        "nazev": "Dolní Pohleď",
        "popis": "[531260] Dolní Pohleď",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531260,
        "val": "[531260] Dolni Pohled 2112 [531260] Dolní Pohleď"
    },
    {
        "kod": 531341,
        "nazev": "Drobovice",
        "popis": "[531341] Drobovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2104,
        "iczuj": 531341,
        "val": "[531341] Drobovice 2104 [531341] Drobovice"
    },
    {
        "kod": 531197,
        "nazev": "Hlízov",
        "popis": "[531197] Hlízov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2112,
        "iczuj": 531197,
        "val": "[531197] Hlizov 2112 [531197] Hlízov"
    },
    {
        "kod": 535303,
        "nazev": "Vraňany",
        "popis": "[535303] Vraňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535303,
        "val": "[535303] Vranany 2114 [535303] Vraňany"
    },
    {
        "kod": 535311,
        "nazev": "Všestudy",
        "popis": "[535311] Všestudy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535311,
        "val": "[535311] Vsestudy 2111 [535311] Všestudy"
    },
    {
        "kod": 535320,
        "nazev": "Všetaty",
        "popis": "[535320] Všetaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535320,
        "val": "[535320] Vsetaty 2117 [535320] Všetaty"
    },
    {
        "kod": 535338,
        "nazev": "Vysoká",
        "popis": "[535338] Vysoká",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535338,
        "val": "[535338] Vysoka 2114 [535338] Vysoká"
    },
    {
        "kod": 535354,
        "nazev": "Zálezlice",
        "popis": "[535354] Zálezlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2117,
        "iczuj": 535354,
        "val": "[535354] Zalezlice 2117 [535354] Zálezlice"
    },
    {
        "kod": 531511,
        "nazev": "Zlončice",
        "popis": "[531511] Zlončice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 531511,
        "val": "[531511] Zloncice 2111 [531511] Zlončice"
    },
    {
        "kod": 535389,
        "nazev": "Zlosyň",
        "popis": "[535389] Zlosyň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2111,
        "iczuj": 535389,
        "val": "[535389] Zlosyn 2111 [535389] Zlosyň"
    },
    {
        "kod": 535397,
        "nazev": "Želízy",
        "popis": "[535397] Želízy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2114,
        "iczuj": 535397,
        "val": "[535397] Zelizy 2114 [535397] Želízy"
    },
    {
        "kod": 535427,
        "nazev": "Bakov nad Jizerou",
        "popis": "[535427] Bakov nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535427,
        "val": "[535427] Bakov nad Jizerou 2115 [535427] Bakov nad Jizerou"
    },
    {
        "kod": 535443,
        "nazev": "Bělá pod Bezdězem",
        "popis": "[535443] Bělá pod Bezdězem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535443,
        "val": "[535443] Bela pod Bezdezem 2115 [535443] Bělá pod Bezdězem"
    },
    {
        "kod": 535451,
        "nazev": "Benátky nad Jizerou",
        "popis": "[535451] Benátky nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535451,
        "val": "[535451] Benatky nad Jizerou 2115 [535451] Benátky nad Jizerou"
    },
    {
        "kod": 535478,
        "nazev": "Bezno",
        "popis": "[535478] Bezno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535478,
        "val": "[535478] Bezno 2115 [535478] Bezno"
    },
    {
        "kod": 565750,
        "nazev": "Bílá Hlína",
        "popis": "[565750] Bílá Hlína",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 565750,
        "val": "[565750] Bila Hlina 2116 [565750] Bílá Hlína"
    },
    {
        "kod": 535486,
        "nazev": "Bítouchov",
        "popis": "[535486] Bítouchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535486,
        "val": "[535486] Bitouchov 2115 [535486] Bítouchov"
    },
    {
        "kod": 535508,
        "nazev": "Boreč",
        "popis": "[535508] Boreč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535508,
        "val": "[535508] Borec 2115 [535508] Boreč"
    },
    {
        "kod": 535516,
        "nazev": "Boseň",
        "popis": "[535516] Boseň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535516,
        "val": "[535516] Bosen 2116 [535516] Boseň"
    },
    {
        "kod": 570788,
        "nazev": "Bradlec",
        "popis": "[570788] Bradlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570788,
        "val": "[570788] Bradlec 2115 [570788] Bradlec"
    },
    {
        "kod": 571946,
        "nazev": "Branžež",
        "popis": "[571946] Branžež",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 571946,
        "val": "[571946] Branzez 2116 [571946] Branžež"
    },
    {
        "kod": 535559,
        "nazev": "Brodce",
        "popis": "[535559] Brodce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535559,
        "val": "[535559] Brodce 2115 [535559] Brodce"
    },
    {
        "kod": 535567,
        "nazev": "Březina",
        "popis": "[535567] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535567,
        "val": "[535567] Brezina 2116 [535567] Březina"
    },
    {
        "kod": 535583,
        "nazev": "Březno",
        "popis": "[535583] Březno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535583,
        "val": "[535583] Brezno 2115 [535583] Březno"
    },
    {
        "kod": 599514,
        "nazev": "Březovice",
        "popis": "[599514] Březovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 599514,
        "val": "[599514] Brezovice 2115 [599514] Březovice"
    },
    {
        "kod": 535605,
        "nazev": "Bukovno",
        "popis": "[535605] Bukovno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535605,
        "val": "[535605] Bukovno 2115 [535605] Bukovno"
    },
    {
        "kod": 570991,
        "nazev": "Ctiměřice",
        "popis": "[570991] Ctiměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570991,
        "val": "[570991] Ctimerice 2115 [570991] Ctiměřice"
    },
    {
        "kod": 535621,
        "nazev": "Čachovice",
        "popis": "[535621] Čachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535621,
        "val": "[535621] Cachovice 2115 [535621] Čachovice"
    },
    {
        "kod": 535630,
        "nazev": "Čistá",
        "popis": "[535630] Čistá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535630,
        "val": "[535630] Cista 2115 [535630] Čistá"
    },
    {
        "kod": 570818,
        "nazev": "Dalovice",
        "popis": "[570818] Dalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570818,
        "val": "[570818] Dalovice 2115 [570818] Dalovice"
    },
    {
        "kod": 535656,
        "nazev": "Dlouhá Lhota",
        "popis": "[535656] Dlouhá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535656,
        "val": "[535656] Dlouha Lhota 2115 [535656] Dlouhá Lhota"
    },
    {
        "kod": 535672,
        "nazev": "Dobrovice",
        "popis": "[535672] Dobrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535672,
        "val": "[535672] Dobrovice 2115 [535672] Dobrovice"
    },
    {
        "kod": 571989,
        "nazev": "Dobšín",
        "popis": "[571989] Dobšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571989,
        "val": "[571989] Dobsin 2115 [571989] Dobšín"
    },
    {
        "kod": 535702,
        "nazev": "Dolní Bousov",
        "popis": "[535702] Dolní Bousov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535702,
        "val": "[535702] Dolni Bousov 2115 [535702] Dolní Bousov"
    },
    {
        "kod": 535711,
        "nazev": "Dolní Krupá",
        "popis": "[535711] Dolní Krupá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535711,
        "val": "[535711] Dolni Krupa 2116 [535711] Dolní Krupá"
    },
    {
        "kod": 535729,
        "nazev": "Dolní Slivno",
        "popis": "[535729] Dolní Slivno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535729,
        "val": "[535729] Dolni Slivno 2115 [535729] Dolní Slivno"
    },
    {
        "kod": 570940,
        "nazev": "Dolní Stakory",
        "popis": "[570940] Dolní Stakory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570940,
        "val": "[570940] Dolni Stakory 2115 [570940] Dolní Stakory"
    },
    {
        "kod": 535745,
        "nazev": "Domousnice",
        "popis": "[535745] Domousnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535745,
        "val": "[535745] Domousnice 2115 [535745] Domousnice"
    },
    {
        "kod": 571067,
        "nazev": "Doubravička",
        "popis": "[571067] Doubravička",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571067,
        "val": "[571067] Doubravicka 2115 [571067] Doubravička"
    },
    {
        "kod": 535818,
        "nazev": "Horky nad Jizerou",
        "popis": "[535818] Horky nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535818,
        "val": "[535818] Horky nad Jizerou 2115 [535818] Horky nad Jizerou"
    },
    {
        "kod": 535834,
        "nazev": "Horní Bukovina",
        "popis": "[535834] Horní Bukovina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535834,
        "val": "[535834] Horni Bukovina 2116 [535834] Horní Bukovina"
    },
    {
        "kod": 599531,
        "nazev": "Horní Slivno",
        "popis": "[599531] Horní Slivno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 599531,
        "val": "[599531] Horni Slivno 2115 [599531] Horní Slivno"
    },
    {
        "kod": 535869,
        "nazev": "Hrdlořezy",
        "popis": "[535869] Hrdlořezy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535869,
        "val": "[535869] Hrdlorezy 2115 [535869] Hrdlořezy"
    },
    {
        "kod": 565733,
        "nazev": "Hrušov",
        "popis": "[565733] Hrušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565733,
        "val": "[565733] Hrusov 2115 [565733] Hrušov"
    },
    {
        "kod": 599522,
        "nazev": "Husí Lhota",
        "popis": "[599522] Husí Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 599522,
        "val": "[599522] Husi Lhota 2115 [599522] Husí Lhota"
    },
    {
        "kod": 565784,
        "nazev": "Charvatce",
        "popis": "[565784] Charvatce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565784,
        "val": "[565784] Charvatce 2115 [565784] Charvatce"
    },
    {
        "kod": 535923,
        "nazev": "Chocnějovice",
        "popis": "[535923] Chocnějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535923,
        "val": "[535923] Chocnejovice 2116 [535923] Chocnějovice"
    },
    {
        "kod": 535931,
        "nazev": "Chotětov",
        "popis": "[535931] Chotětov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535931,
        "val": "[535931] Chotetov 2115 [535931] Chotětov"
    },
    {
        "kod": 571849,
        "nazev": "Chudíř",
        "popis": "[571849] Chudíř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571849,
        "val": "[571849] Chudir 2115 [571849] Chudíř"
    },
    {
        "kod": 535966,
        "nazev": "Jabkenice",
        "popis": "[535966] Jabkenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535966,
        "val": "[535966] Jabkenice 2115 [535966] Jabkenice"
    },
    {
        "kod": 535974,
        "nazev": "Jivina",
        "popis": "[535974] Jivina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 535974,
        "val": "[535974] Jivina 2116 [535974] Jivina"
    },
    {
        "kod": 566039,
        "nazev": "Jizerní Vtelno",
        "popis": "[566039] Jizerní Vtelno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 566039,
        "val": "[566039] Jizerni Vtelno 2115 [566039] Jizerní Vtelno"
    },
    {
        "kod": 529613,
        "nazev": "Josefův Důl",
        "popis": "[529613] Josefův Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 529613,
        "val": "[529613] Josefuv Dul 2115 [529613] Josefův Důl"
    },
    {
        "kod": 536008,
        "nazev": "Katusice",
        "popis": "[536008] Katusice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536008,
        "val": "[536008] Katusice 2115 [536008] Katusice"
    },
    {
        "kod": 536024,
        "nazev": "Klášter Hradiště nad Jizerou",
        "popis": "[536024] Klášter Hradiště nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 536024,
        "val": "[536024] Klaster Hradiste nad Jizerou 2116 [536024] Klášter Hradiště nad Jizerou"
    },
    {
        "kod": 571075,
        "nazev": "Kluky",
        "popis": "[571075] Kluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571075,
        "val": "[571075] Kluky 2115 [571075] Kluky"
    },
    {
        "kod": 536041,
        "nazev": "Kněžmost",
        "popis": "[536041] Kněžmost",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 536041,
        "val": "[536041] Knezmost 2116 [536041] Kněžmost"
    },
    {
        "kod": 571172,
        "nazev": "Kobylnice",
        "popis": "[571172] Kobylnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571172,
        "val": "[571172] Kobylnice 2115 [571172] Kobylnice"
    },
    {
        "kod": 536067,
        "nazev": "Kochánky",
        "popis": "[536067] Kochánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536067,
        "val": "[536067] Kochanky 2115 [536067] Kochánky"
    },
    {
        "kod": 570974,
        "nazev": "Kolomuty",
        "popis": "[570974] Kolomuty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570974,
        "val": "[570974] Kolomuty 2115 [570974] Kolomuty"
    },
    {
        "kod": 599557,
        "nazev": "Koryta",
        "popis": "[599557] Koryta",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 599557,
        "val": "[599557] Koryta 2116 [599557] Koryta"
    },
    {
        "kod": 570826,
        "nazev": "Kosmonosy",
        "popis": "[570826] Kosmonosy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570826,
        "val": "[570826] Kosmonosy 2115 [570826] Kosmonosy"
    },
    {
        "kod": 536121,
        "nazev": "Kosořice",
        "popis": "[536121] Kosořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536121,
        "val": "[536121] Kosorice 2115 [536121] Kosořice"
    },
    {
        "kod": 566047,
        "nazev": "Košátky",
        "popis": "[566047] Košátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 566047,
        "val": "[566047] Kosatky 2115 [566047] Košátky"
    },
    {
        "kod": 571971,
        "nazev": "Kováň",
        "popis": "[571971] Kováň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571971,
        "val": "[571971] Kovan 2115 [571971] Kováň"
    },
    {
        "kod": 572012,
        "nazev": "Kovanec",
        "popis": "[572012] Kovanec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 572012,
        "val": "[572012] Kovanec 2115 [572012] Kovanec"
    },
    {
        "kod": 536164,
        "nazev": "Krásná Ves",
        "popis": "[536164] Krásná Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536164,
        "val": "[536164] Krasna Ves 2115 [536164] Krásná Ves"
    },
    {
        "kod": 536172,
        "nazev": "Krnsko",
        "popis": "[536172] Krnsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536172,
        "val": "[536172] Krnsko 2115 [536172] Krnsko"
    },
    {
        "kod": 536181,
        "nazev": "Kropáčova Vrutice",
        "popis": "[536181] Kropáčova Vrutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536181,
        "val": "[536181] Kropacova Vrutice 2115 [536181] Kropáčova Vrutice"
    },
    {
        "kod": 536202,
        "nazev": "Ledce",
        "popis": "[536202] Ledce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536202,
        "val": "[536202] Ledce 2115 [536202] Ledce"
    },
    {
        "kod": 536211,
        "nazev": "Lhotky",
        "popis": "[536211] Lhotky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536211,
        "val": "[536211] Lhotky 2115 [536211] Lhotky"
    },
    {
        "kod": 565563,
        "nazev": "Lipník",
        "popis": "[565563] Lipník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565563,
        "val": "[565563] Lipnik 2115 [565563] Lipník"
    },
    {
        "kod": 570770,
        "nazev": "Loukov",
        "popis": "[570770] Loukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 570770,
        "val": "[570770] Loukov 2116 [570770] Loukov"
    },
    {
        "kod": 536261,
        "nazev": "Loukovec",
        "popis": "[536261] Loukovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 536261,
        "val": "[536261] Loukovec 2116 [536261] Loukovec"
    },
    {
        "kod": 536270,
        "nazev": "Luštěnice",
        "popis": "[536270] Luštěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536270,
        "val": "[536270] Lustenice 2115 [536270] Luštěnice"
    },
    {
        "kod": 565644,
        "nazev": "Mečeříž",
        "popis": "[565644] Mečeříž",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565644,
        "val": "[565644] Meceriz 2115 [565644] Mečeříž"
    },
    {
        "kod": 535419,
        "nazev": "Mladá Boleslav",
        "popis": "[535419] Mladá Boleslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 535419,
        "val": "[535419] Mlada Boleslav 2115 [535419] Mladá Boleslav"
    },
    {
        "kod": 536326,
        "nazev": "Mnichovo Hradiště",
        "popis": "[536326] Mnichovo Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 536326,
        "val": "[536326] Mnichovo Hradiste 2116 [536326] Mnichovo Hradiště"
    },
    {
        "kod": 565822,
        "nazev": "Mohelnice nad Jizerou",
        "popis": "[565822] Mohelnice nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 565822,
        "val": "[565822] Mohelnice nad Jizerou 2116 [565822] Mohelnice nad Jizerou"
    },
    {
        "kod": 571865,
        "nazev": "Mukařov",
        "popis": "[571865] Mukařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 571865,
        "val": "[571865] Mukarov 2116 [571865] Mukařov"
    },
    {
        "kod": 536334,
        "nazev": "Němčice",
        "popis": "[536334] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536334,
        "val": "[536334] Nemcice 2115 [536334] Němčice"
    },
    {
        "kod": 571156,
        "nazev": "Nemyslovice",
        "popis": "[571156] Nemyslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571156,
        "val": "[571156] Nemyslovice 2115 [571156] Nemyslovice"
    },
    {
        "kod": 536351,
        "nazev": "Nepřevázka",
        "popis": "[536351] Nepřevázka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536351,
        "val": "[536351] Neprevazka 2115 [536351] Nepřevázka"
    },
    {
        "kod": 571997,
        "nazev": "Neveklovice",
        "popis": "[571997] Neveklovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 571997,
        "val": "[571997] Neveklovice 2116 [571997] Neveklovice"
    },
    {
        "kod": 571121,
        "nazev": "Niměřice",
        "popis": "[571121] Niměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571121,
        "val": "[571121] Nimerice 2115 [571121] Niměřice"
    },
    {
        "kod": 536377,
        "nazev": "Nová Telib",
        "popis": "[536377] Nová Telib",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536377,
        "val": "[536377] Nova Telib 2115 [536377] Nová Telib"
    },
    {
        "kod": 571806,
        "nazev": "Nová Ves u Bakova",
        "popis": "[571806] Nová Ves u Bakova",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571806,
        "val": "[571806] Nova Ves u Bakova 2115 [571806] Nová Ves u Bakova"
    },
    {
        "kod": 570893,
        "nazev": "Obrubce",
        "popis": "[570893] Obrubce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570893,
        "val": "[570893] Obrubce 2115 [570893] Obrubce"
    },
    {
        "kod": 536407,
        "nazev": "Obruby",
        "popis": "[536407] Obruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536407,
        "val": "[536407] Obruby 2115 [536407] Obruby"
    },
    {
        "kod": 571032,
        "nazev": "Pěčice",
        "popis": "[571032] Pěčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571032,
        "val": "[571032] Pecice 2115 [571032] Pěčice"
    },
    {
        "kod": 598241,
        "nazev": "Pětikozly",
        "popis": "[598241] Pětikozly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 598241,
        "val": "[598241] Petikozly 2115 [598241] Pětikozly"
    },
    {
        "kod": 536431,
        "nazev": "Petkovy",
        "popis": "[536431] Petkovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536431,
        "val": "[536431] Petkovy 2115 [536431] Petkovy"
    },
    {
        "kod": 536440,
        "nazev": "Písková Lhota",
        "popis": "[536440] Písková Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536440,
        "val": "[536440] Piskova Lhota 2115 [536440] Písková Lhota"
    },
    {
        "kod": 536458,
        "nazev": "Plazy",
        "popis": "[536458] Plazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536458,
        "val": "[536458] Plazy 2115 [536458] Plazy"
    },
    {
        "kod": 565580,
        "nazev": "Plužná",
        "popis": "[565580] Plužná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565580,
        "val": "[565580] Pluzna 2115 [565580] Plužná"
    },
    {
        "kod": 570753,
        "nazev": "Prodašice",
        "popis": "[570753] Prodašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570753,
        "val": "[570753] Prodasice 2115 [570753] Prodašice"
    },
    {
        "kod": 536491,
        "nazev": "Předměřice nad Jizerou",
        "popis": "[536491] Předměřice nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536491,
        "val": "[536491] Predmerice nad Jizerou 2115 [536491] Předměřice nad Jizerou"
    },
    {
        "kod": 570923,
        "nazev": "Přepeře",
        "popis": "[570923] Přepeře",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570923,
        "val": "[570923] Prepere 2115 [570923] Přepeře"
    },
    {
        "kod": 571938,
        "nazev": "Ptýrov",
        "popis": "[571938] Ptýrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 571938,
        "val": "[571938] Ptyrov 2116 [571938] Ptýrov"
    },
    {
        "kod": 565652,
        "nazev": "Rabakov",
        "popis": "[565652] Rabakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565652,
        "val": "[565652] Rabakov 2115 [565652] Rabakov"
    },
    {
        "kod": 565636,
        "nazev": "Rohatsko",
        "popis": "[565636] Rohatsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565636,
        "val": "[565636] Rohatsko 2115 [565636] Rohatsko"
    },
    {
        "kod": 529605,
        "nazev": "Rokytá",
        "popis": "[529605] Rokytá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 529605,
        "val": "[529605] Rokyta 2116 [529605] Rokytá"
    },
    {
        "kod": 571148,
        "nazev": "Rokytovec",
        "popis": "[571148] Rokytovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571148,
        "val": "[571148] Rokytovec 2115 [571148] Rokytovec"
    },
    {
        "kod": 536580,
        "nazev": "Řepov",
        "popis": "[536580] Řepov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536580,
        "val": "[536580] Repov 2115 [536580] Řepov"
    },
    {
        "kod": 565661,
        "nazev": "Řitonice",
        "popis": "[565661] Řitonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565661,
        "val": "[565661] Ritonice 2115 [565661] Řitonice"
    },
    {
        "kod": 529591,
        "nazev": "Sedlec",
        "popis": "[529591] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 529591,
        "val": "[529591] Sedlec 2115 [529591] Sedlec"
    },
    {
        "kod": 536610,
        "nazev": "Semčice",
        "popis": "[536610] Semčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536610,
        "val": "[536610] Semcice 2115 [536610] Semčice"
    },
    {
        "kod": 599573,
        "nazev": "Sezemice",
        "popis": "[599573] Sezemice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 599573,
        "val": "[599573] Sezemice 2116 [599573] Sezemice"
    },
    {
        "kod": 536636,
        "nazev": "Skalsko",
        "popis": "[536636] Skalsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536636,
        "val": "[536636] Skalsko 2115 [536636] Skalsko"
    },
    {
        "kod": 557030,
        "nazev": "Skorkov",
        "popis": "[557030] Skorkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 557030,
        "val": "[557030] Skorkov 2115 [557030] Skorkov"
    },
    {
        "kod": 536652,
        "nazev": "Smilovice",
        "popis": "[536652] Smilovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536652,
        "val": "[536652] Smilovice 2115 [536652] Smilovice"
    },
    {
        "kod": 536661,
        "nazev": "Sojovice",
        "popis": "[536661] Sojovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536661,
        "val": "[536661] Sojovice 2115 [536661] Sojovice"
    },
    {
        "kod": 565539,
        "nazev": "Sovínky",
        "popis": "[565539] Sovínky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565539,
        "val": "[565539] Sovinky 2115 [565539] Sovínky"
    },
    {
        "kod": 536709,
        "nazev": "Strašnov",
        "popis": "[536709] Strašnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536709,
        "val": "[536709] Strasnov 2115 [536709] Strašnov"
    },
    {
        "kod": 571881,
        "nazev": "Strážiště",
        "popis": "[571881] Strážiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 571881,
        "val": "[571881] Straziste 2116 [571881] Strážiště"
    },
    {
        "kod": 536717,
        "nazev": "Strenice",
        "popis": "[536717] Strenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536717,
        "val": "[536717] Strenice 2115 [536717] Strenice"
    },
    {
        "kod": 565920,
        "nazev": "Sudoměř",
        "popis": "[565920] Sudoměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565920,
        "val": "[565920] Sudomer 2115 [565920] Sudoměř"
    },
    {
        "kod": 536768,
        "nazev": "Sukorady",
        "popis": "[536768] Sukorady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536768,
        "val": "[536768] Sukorady 2115 [536768] Sukorady"
    },
    {
        "kod": 570982,
        "nazev": "Tuřice",
        "popis": "[570982] Tuřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570982,
        "val": "[570982] Turice 2115 [570982] Tuřice"
    },
    {
        "kod": 570761,
        "nazev": "Ujkovice",
        "popis": "[570761] Ujkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570761,
        "val": "[570761] Ujkovice 2115 [570761] Ujkovice"
    },
    {
        "kod": 536857,
        "nazev": "Velké Všelisy",
        "popis": "[536857] Velké Všelisy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536857,
        "val": "[536857] Velke Vselisy 2115 [536857] Velké Všelisy"
    },
    {
        "kod": 565725,
        "nazev": "Veselice",
        "popis": "[565725] Veselice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565725,
        "val": "[565725] Veselice 2115 [565725] Veselice"
    },
    {
        "kod": 565628,
        "nazev": "Vinařice",
        "popis": "[565628] Vinařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565628,
        "val": "[565628] Vinarice 2115 [565628] Vinařice"
    },
    {
        "kod": 570842,
        "nazev": "Vinec",
        "popis": "[570842] Vinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 570842,
        "val": "[570842] Vinec 2115 [570842] Vinec"
    },
    {
        "kod": 565571,
        "nazev": "Vlkava",
        "popis": "[565571] Vlkava",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 565571,
        "val": "[565571] Vlkava 2115 [565571] Vlkava"
    },
    {
        "kod": 572021,
        "nazev": "Vrátno",
        "popis": "[572021] Vrátno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 572021,
        "val": "[572021] Vratno 2115 [572021] Vrátno"
    },
    {
        "kod": 536938,
        "nazev": "Všejany",
        "popis": "[536938] Všejany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536938,
        "val": "[536938] Vsejany 2115 [536938] Všejany"
    },
    {
        "kod": 571814,
        "nazev": "Zdětín",
        "popis": "[571814] Zdětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 571814,
        "val": "[571814] Zdetin 2115 [571814] Zdětín"
    },
    {
        "kod": 536971,
        "nazev": "Žďár",
        "popis": "[536971] Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 2116,
        "iczuj": 536971,
        "val": "[536971] Zdar 2116 [536971] Žďár"
    },
    {
        "kod": 536989,
        "nazev": "Žerčice",
        "popis": "[536989] Žerčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536989,
        "val": "[536989] Zercice 2115 [536989] Žerčice"
    },
    {
        "kod": 536997,
        "nazev": "Židněves",
        "popis": "[536997] Židněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2115,
        "iczuj": 536997,
        "val": "[536997] Zidneves 2115 [536997] Židněves"
    },
    {
        "kod": 537021,
        "nazev": "Běrunice",
        "popis": "[537021] Běrunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537021,
        "val": "[537021] Berunice 2119 [537021] Běrunice"
    },
    {
        "kod": 537039,
        "nazev": "Bobnice",
        "popis": "[537039] Bobnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537039,
        "val": "[537039] Bobnice 2118 [537039] Bobnice"
    },
    {
        "kod": 529303,
        "nazev": "Benešov",
        "popis": "[529303] Benešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529303,
        "val": "[529303] Benesov 2101 [529303] Benešov"
    },
    {
        "kod": 532568,
        "nazev": "Bernartice",
        "popis": "[532568] Bernartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532568,
        "val": "[532568] Bernartice 2125 [532568] Bernartice"
    },
    {
        "kod": 530743,
        "nazev": "Bílkovice",
        "popis": "[530743] Bílkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530743,
        "val": "[530743] Bilkovice 2125 [530743] Bílkovice"
    },
    {
        "kod": 532380,
        "nazev": "Blažejovice",
        "popis": "[532380] Blažejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532380,
        "val": "[532380] Blazejovice 2125 [532380] Blažejovice"
    },
    {
        "kod": 532096,
        "nazev": "Borovnice",
        "popis": "[532096] Borovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532096,
        "val": "[532096] Borovnice 2125 [532096] Borovnice"
    },
    {
        "kod": 532924,
        "nazev": "Bukovany",
        "popis": "[532924] Bukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532924,
        "val": "[532924] Bukovany 2101 [532924] Bukovany"
    },
    {
        "kod": 529451,
        "nazev": "Bystřice",
        "popis": "[529451] Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529451,
        "val": "[529451] Bystrice 2101 [529451] Bystřice"
    },
    {
        "kod": 532690,
        "nazev": "Ctiboř",
        "popis": "[532690] Ctiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532690,
        "val": "[532690] Ctibor 2125 [532690] Ctiboř"
    },
    {
        "kod": 529478,
        "nazev": "Čakov",
        "popis": "[529478] Čakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529478,
        "val": "[529478] Cakov 2101 [529478] Čakov"
    },
    {
        "kod": 529486,
        "nazev": "Čechtice",
        "popis": "[529486] Čechtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529486,
        "val": "[529486] Cechtice 2125 [529486] Čechtice"
    },
    {
        "kod": 529516,
        "nazev": "Čerčany",
        "popis": "[529516] Čerčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529516,
        "val": "[529516] Cercany 2101 [529516] Čerčany"
    },
    {
        "kod": 529532,
        "nazev": "Červený Újezd",
        "popis": "[529532] Červený Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 529532,
        "val": "[529532] Cerveny Ujezd 2126 [529532] Červený Újezd"
    },
    {
        "kod": 529541,
        "nazev": "Český Šternberk",
        "popis": "[529541] Český Šternberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529541,
        "val": "[529541] Cesky Sternberk 2101 [529541] Český Šternberk"
    },
    {
        "kod": 529567,
        "nazev": "Čtyřkoly",
        "popis": "[529567] Čtyřkoly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529567,
        "val": "[529567] Ctyrkoly 2101 [529567] Čtyřkoly"
    },
    {
        "kod": 532746,
        "nazev": "Děkanovice",
        "popis": "[532746] Děkanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532746,
        "val": "[532746] Dekanovice 2125 [532746] Děkanovice"
    },
    {
        "kod": 529621,
        "nazev": "Divišov",
        "popis": "[529621] Divišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529621,
        "val": "[529621] Divisov 2101 [529621] Divišov"
    },
    {
        "kod": 529648,
        "nazev": "Dolní Kralovice",
        "popis": "[529648] Dolní Kralovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529648,
        "val": "[529648] Dolni Kralovice 2125 [529648] Dolní Kralovice"
    },
    {
        "kod": 532151,
        "nazev": "Drahňovice",
        "popis": "[532151] Drahňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532151,
        "val": "[532151] Drahnovice 2101 [532151] Drahňovice"
    },
    {
        "kod": 532843,
        "nazev": "Dunice",
        "popis": "[532843] Dunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532843,
        "val": "[532843] Dunice 2125 [532843] Dunice"
    },
    {
        "kod": 529702,
        "nazev": "Heřmaničky",
        "popis": "[529702] Heřmaničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 529702,
        "val": "[529702] Hermanicky 2126 [529702] Heřmaničky"
    },
    {
        "kod": 532932,
        "nazev": "Hradiště",
        "popis": "[532932] Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532932,
        "val": "[532932] Hradiste 2125 [532932] Hradiště"
    },
    {
        "kod": 529737,
        "nazev": "Hulice",
        "popis": "[529737] Hulice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529737,
        "val": "[529737] Hulice 2125 [529737] Hulice"
    },
    {
        "kod": 529745,
        "nazev": "Hvězdonice",
        "popis": "[529745] Hvězdonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529745,
        "val": "[529745] Hvezdonice 2101 [529745] Hvězdonice"
    },
    {
        "kod": 532886,
        "nazev": "Chářovice",
        "popis": "[532886] Chářovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532886,
        "val": "[532886] Charovice 2101 [532886] Chářovice"
    },
    {
        "kod": 532878,
        "nazev": "Chleby",
        "popis": "[532878] Chleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532878,
        "val": "[532878] Chleby 2101 [532878] Chleby"
    },
    {
        "kod": 532045,
        "nazev": "Chlístov",
        "popis": "[532045] Chlístov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532045,
        "val": "[532045] Chlistov 2101 [532045] Chlístov"
    },
    {
        "kod": 529770,
        "nazev": "Chlum",
        "popis": "[529770] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529770,
        "val": "[529770] Chlum 2125 [529770] Chlum"
    },
    {
        "kod": 529788,
        "nazev": "Chmelná",
        "popis": "[529788] Chmelná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529788,
        "val": "[529788] Chmelna 2125 [529788] Chmelná"
    },
    {
        "kod": 529796,
        "nazev": "Chocerady",
        "popis": "[529796] Chocerady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529796,
        "val": "[529796] Chocerady 2101 [529796] Chocerady"
    },
    {
        "kod": 532606,
        "nazev": "Choratice",
        "popis": "[532606] Choratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532606,
        "val": "[532606] Choratice 2101 [532606] Choratice"
    },
    {
        "kod": 529818,
        "nazev": "Chotýšany",
        "popis": "[529818] Chotýšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529818,
        "val": "[529818] Chotysany 2101 [529818] Chotýšany"
    },
    {
        "kod": 532037,
        "nazev": "Chrášťany",
        "popis": "[532037] Chrášťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532037,
        "val": "[532037] Chrastany 2101 [532037] Chrášťany"
    },
    {
        "kod": 529842,
        "nazev": "Jankov",
        "popis": "[529842] Jankov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 529842,
        "val": "[529842] Jankov 2126 [529842] Jankov"
    },
    {
        "kod": 529851,
        "nazev": "Javorník",
        "popis": "[529851] Javorník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529851,
        "val": "[529851] Javornik 2125 [529851] Javorník"
    },
    {
        "kod": 532134,
        "nazev": "Ješetice",
        "popis": "[532134] Ješetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 532134,
        "val": "[532134] Jesetice 2126 [532134] Ješetice"
    },
    {
        "kod": 531031,
        "nazev": "Kamberk",
        "popis": "[531031] Kamberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 531031,
        "val": "[531031] Kamberk 2125 [531031] Kamberk"
    },
    {
        "kod": 529907,
        "nazev": "Keblov",
        "popis": "[529907] Keblov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529907,
        "val": "[529907] Keblov 2125 [529907] Keblov"
    },
    {
        "kod": 533084,
        "nazev": "Kladruby",
        "popis": "[533084] Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 533084,
        "val": "[533084] Kladruby 2125 [533084] Kladruby"
    },
    {
        "kod": 529931,
        "nazev": "Kondrac",
        "popis": "[529931] Kondrac",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 529931,
        "val": "[529931] Kondrac 2125 [529931] Kondrac"
    },
    {
        "kod": 529940,
        "nazev": "Kozmice",
        "popis": "[529940] Kozmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529940,
        "val": "[529940] Kozmice 2101 [529940] Kozmice"
    },
    {
        "kod": 529958,
        "nazev": "Krhanice",
        "popis": "[529958] Krhanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529958,
        "val": "[529958] Krhanice 2101 [529958] Krhanice"
    },
    {
        "kod": 529974,
        "nazev": "Krňany",
        "popis": "[529974] Krňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529974,
        "val": "[529974] Krnany 2101 [529974] Krňany"
    },
    {
        "kod": 529991,
        "nazev": "Křečovice",
        "popis": "[529991] Křečovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 529991,
        "val": "[529991] Krecovice 2101 [529991] Křečovice"
    },
    {
        "kod": 530000,
        "nazev": "Křivsoudov",
        "popis": "[530000] Křivsoudov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530000,
        "val": "[530000] Krivsoudov 2125 [530000] Křivsoudov"
    },
    {
        "kod": 530026,
        "nazev": "Kuňovice",
        "popis": "[530026] Kuňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530026,
        "val": "[530026] Kunovice 2125 [530026] Kuňovice"
    },
    {
        "kod": 530051,
        "nazev": "Lešany",
        "popis": "[530051] Lešany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530051,
        "val": "[530051] Lesany 2101 [530051] Lešany"
    },
    {
        "kod": 530069,
        "nazev": "Libež",
        "popis": "[530069] Libež",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530069,
        "val": "[530069] Libez 2125 [530069] Libež"
    },
    {
        "kod": 532258,
        "nazev": "Litichovice",
        "popis": "[532258] Litichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532258,
        "val": "[532258] Litichovice 2101 [532258] Litichovice"
    },
    {
        "kod": 530093,
        "nazev": "Loket",
        "popis": "[530093] Loket",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530093,
        "val": "[530093] Loket 2125 [530093] Loket"
    },
    {
        "kod": 530107,
        "nazev": "Louňovice pod Blaníkem",
        "popis": "[530107] Louňovice pod Blaníkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530107,
        "val": "[530107] Lounovice pod Blanikem 2125 [530107] Louňovice pod Blaníkem"
    },
    {
        "kod": 532193,
        "nazev": "Lštění",
        "popis": "[532193] Lštění",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532193,
        "val": "[532193] Lsteni 2101 [532193] Lštění"
    },
    {
        "kod": 530115,
        "nazev": "Maršovice",
        "popis": "[530115] Maršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530115,
        "val": "[530115] Marsovice 2101 [530115] Maršovice"
    },
    {
        "kod": 530158,
        "nazev": "Mezno",
        "popis": "[530158] Mezno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530158,
        "val": "[530158] Mezno 2126 [530158] Mezno"
    },
    {
        "kod": 530166,
        "nazev": "Miličín",
        "popis": "[530166] Miličín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530166,
        "val": "[530166] Milicin 2126 [530166] Miličín"
    },
    {
        "kod": 530174,
        "nazev": "Miřetice",
        "popis": "[530174] Miřetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530174,
        "val": "[530174] Miretice 2125 [530174] Miřetice"
    },
    {
        "kod": 530191,
        "nazev": "Mnichovice",
        "popis": "[530191] Mnichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530191,
        "val": "[530191] Mnichovice 2125 [530191] Mnichovice"
    },
    {
        "kod": 530204,
        "nazev": "Mrač",
        "popis": "[530204] Mrač",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530204,
        "val": "[530204] Mrac 2101 [530204] Mrač"
    },
    {
        "kod": 530212,
        "nazev": "Načeradec",
        "popis": "[530212] Načeradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530212,
        "val": "[530212] Naceradec 2125 [530212] Načeradec"
    },
    {
        "kod": 530263,
        "nazev": "Nespeky",
        "popis": "[530263] Nespeky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530263,
        "val": "[530263] Nespeky 2101 [530263] Nespeky"
    },
    {
        "kod": 530298,
        "nazev": "Netvořice",
        "popis": "[530298] Netvořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530298,
        "val": "[530298] Netvorice 2101 [530298] Netvořice"
    },
    {
        "kod": 530301,
        "nazev": "Neustupov",
        "popis": "[530301] Neustupov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530301,
        "val": "[530301] Neustupov 2126 [530301] Neustupov"
    },
    {
        "kod": 530310,
        "nazev": "Neveklov",
        "popis": "[530310] Neveklov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530310,
        "val": "[530310] Neveklov 2101 [530310] Neveklov"
    },
    {
        "kod": 530344,
        "nazev": "Olbramovice",
        "popis": "[530344] Olbramovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530344,
        "val": "[530344] Olbramovice 2126 [530344] Olbramovice"
    },
    {
        "kod": 599395,
        "nazev": "Ostrov",
        "popis": "[599395] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 599395,
        "val": "[599395] Ostrov 2125 [599395] Ostrov"
    },
    {
        "kod": 530352,
        "nazev": "Ostředek",
        "popis": "[530352] Ostředek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530352,
        "val": "[530352] Ostredek 2101 [530352] Ostředek"
    },
    {
        "kod": 533076,
        "nazev": "Pavlovice",
        "popis": "[533076] Pavlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 533076,
        "val": "[533076] Pavlovice 2125 [533076] Pavlovice"
    },
    {
        "kod": 530409,
        "nazev": "Petroupim",
        "popis": "[530409] Petroupim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530409,
        "val": "[530409] Petroupim 2101 [530409] Petroupim"
    },
    {
        "kod": 532649,
        "nazev": "Popovice",
        "popis": "[532649] Popovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532649,
        "val": "[532649] Popovice 2101 [532649] Popovice"
    },
    {
        "kod": 530441,
        "nazev": "Poříčí nad Sázavou",
        "popis": "[530441] Poříčí nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530441,
        "val": "[530441] Porici nad Sazavou 2101 [530441] Poříčí nad Sázavou"
    },
    {
        "kod": 530450,
        "nazev": "Postupice",
        "popis": "[530450] Postupice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530450,
        "val": "[530450] Postupice 2101 [530450] Postupice"
    },
    {
        "kod": 530476,
        "nazev": "Pravonín",
        "popis": "[530476] Pravonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530476,
        "val": "[530476] Pravonin 2125 [530476] Pravonín"
    },
    {
        "kod": 530492,
        "nazev": "Přestavlky u Čerčan",
        "popis": "[530492] Přestavlky u Čerčan",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530492,
        "val": "[530492] Prestavlky u Cercan 2101 [530492] Přestavlky u Čerčan"
    },
    {
        "kod": 530514,
        "nazev": "Psáře",
        "popis": "[530514] Psáře",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530514,
        "val": "[530514] Psare 2125 [530514] Psáře"
    },
    {
        "kod": 538680,
        "nazev": "Pyšely",
        "popis": "[538680] Pyšely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 538680,
        "val": "[538680] Pysely 2101 [538680] Pyšely"
    },
    {
        "kod": 530522,
        "nazev": "Rabyně",
        "popis": "[530522] Rabyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530522,
        "val": "[530522] Rabyne 2101 [530522] Rabyně"
    },
    {
        "kod": 530531,
        "nazev": "Radošovice",
        "popis": "[530531] Radošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530531,
        "val": "[530531] Radosovice 2125 [530531] Radošovice"
    },
    {
        "kod": 530549,
        "nazev": "Rataje",
        "popis": "[530549] Rataje",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530549,
        "val": "[530549] Rataje 2125 [530549] Rataje"
    },
    {
        "kod": 532550,
        "nazev": "Ratměřice",
        "popis": "[532550] Ratměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 532550,
        "val": "[532550] Ratmerice 2126 [532550] Ratměřice"
    },
    {
        "kod": 538710,
        "nazev": "Řehenice",
        "popis": "[538710] Řehenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 538710,
        "val": "[538710] Rehenice 2101 [538710] Řehenice"
    },
    {
        "kod": 532941,
        "nazev": "Řimovice",
        "popis": "[532941] Řimovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532941,
        "val": "[532941] Rimovice 2125 [532941] Řimovice"
    },
    {
        "kod": 534382,
        "nazev": "Sázava",
        "popis": "[534382] Sázava",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 534382,
        "val": "[534382] Sazava 2101 [534382] Sázava"
    },
    {
        "kod": 532231,
        "nazev": "Slověnice",
        "popis": "[532231] Slověnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532231,
        "val": "[532231] Slovenice 2125 [532231] Slověnice"
    },
    {
        "kod": 530611,
        "nazev": "Smilkov",
        "popis": "[530611] Smilkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530611,
        "val": "[530611] Smilkov 2126 [530611] Smilkov"
    },
    {
        "kod": 532436,
        "nazev": "Snět",
        "popis": "[532436] Snět",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532436,
        "val": "[532436] Snet 2125 [532436] Snět"
    },
    {
        "kod": 530638,
        "nazev": "Soběhrdy",
        "popis": "[530638] Soběhrdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530638,
        "val": "[530638] Sobehrdy 2101 [530638] Soběhrdy"
    },
    {
        "kod": 599387,
        "nazev": "Soutice",
        "popis": "[599387] Soutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 599387,
        "val": "[599387] Soutice 2125 [599387] Soutice"
    },
    {
        "kod": 599379,
        "nazev": "Stranný",
        "popis": "[599379] Stranný",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 599379,
        "val": "[599379] Stranny 2101 [599379] Stranný"
    },
    {
        "kod": 599361,
        "nazev": "Strojetice",
        "popis": "[599361] Strojetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 599361,
        "val": "[599361] Strojetice 2125 [599361] Strojetice"
    },
    {
        "kod": 530689,
        "nazev": "Struhařov",
        "popis": "[530689] Struhařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530689,
        "val": "[530689] Struharov 2101 [530689] Struhařov"
    },
    {
        "kod": 530701,
        "nazev": "Střezimíř",
        "popis": "[530701] Střezimíř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530701,
        "val": "[530701] Strezimir 2126 [530701] Střezimíř"
    },
    {
        "kod": 530719,
        "nazev": "Studený",
        "popis": "[530719] Studený",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530719,
        "val": "[530719] Studeny 2125 [530719] Studený"
    },
    {
        "kod": 532509,
        "nazev": "Šetějovice",
        "popis": "[532509] Šetějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532509,
        "val": "[532509] Setejovice 2125 [532509] Šetějovice"
    },
    {
        "kod": 530751,
        "nazev": "Tehov",
        "popis": "[530751] Tehov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530751,
        "val": "[530751] Tehov 2125 [530751] Tehov"
    },
    {
        "kod": 530760,
        "nazev": "Teplýšovice",
        "popis": "[530760] Teplýšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530760,
        "val": "[530760] Teplysovice 2101 [530760] Teplýšovice"
    },
    {
        "kod": 530778,
        "nazev": "Tichonice",
        "popis": "[530778] Tichonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530778,
        "val": "[530778] Tichonice 2125 [530778] Tichonice"
    },
    {
        "kod": 532592,
        "nazev": "Tisem",
        "popis": "[532592] Tisem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532592,
        "val": "[532592] Tisem 2101 [532592] Tisem"
    },
    {
        "kod": 532541,
        "nazev": "Tomice",
        "popis": "[532541] Tomice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532541,
        "val": "[532541] Tomice 2125 [532541] Tomice"
    },
    {
        "kod": 530816,
        "nazev": "Trhový Štěpánov",
        "popis": "[530816] Trhový Štěpánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530816,
        "val": "[530816] Trhovy Stepanov 2125 [530816] Trhový Štěpánov"
    },
    {
        "kod": 532304,
        "nazev": "Třebešice",
        "popis": "[532304] Třebešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532304,
        "val": "[532304] Trebesice 2101 [532304] Třebešice"
    },
    {
        "kod": 530841,
        "nazev": "Týnec nad Sázavou",
        "popis": "[530841] Týnec nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530841,
        "val": "[530841] Tynec nad Sazavou 2101 [530841] Týnec nad Sázavou"
    },
    {
        "kod": 532061,
        "nazev": "Václavice",
        "popis": "[532061] Václavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532061,
        "val": "[532061] Vaclavice 2101 [532061] Václavice"
    },
    {
        "kod": 530867,
        "nazev": "Veliš",
        "popis": "[530867] Veliš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530867,
        "val": "[530867] Velis 2125 [530867] Veliš"
    },
    {
        "kod": 530883,
        "nazev": "Vlašim",
        "popis": "[530883] Vlašim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530883,
        "val": "[530883] Vlasim 2125 [530883] Vlašim"
    },
    {
        "kod": 532614,
        "nazev": "Vodslivy",
        "popis": "[532614] Vodslivy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 532614,
        "val": "[532614] Vodslivy 2101 [532614] Vodslivy"
    },
    {
        "kod": 530891,
        "nazev": "Vojkov",
        "popis": "[530891] Vojkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530891,
        "val": "[530891] Vojkov 2126 [530891] Vojkov"
    },
    {
        "kod": 530905,
        "nazev": "Votice",
        "popis": "[530905] Votice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530905,
        "val": "[530905] Votice 2126 [530905] Votice"
    },
    {
        "kod": 530913,
        "nazev": "Vracovice",
        "popis": "[530913] Vracovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 530913,
        "val": "[530913] Vracovice 2125 [530913] Vracovice"
    },
    {
        "kod": 530921,
        "nazev": "Vranov",
        "popis": "[530921] Vranov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 530921,
        "val": "[530921] Vranov 2101 [530921] Vranov"
    },
    {
        "kod": 530948,
        "nazev": "Vrchotovy Janovice",
        "popis": "[530948] Vrchotovy Janovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 530948,
        "val": "[530948] Vrchotovy Janovice 2126 [530948] Vrchotovy Janovice"
    },
    {
        "kod": 532266,
        "nazev": "Všechlapy",
        "popis": "[532266] Všechlapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 532266,
        "val": "[532266] Vsechlapy 2125 [532266] Všechlapy"
    },
    {
        "kod": 513482,
        "nazev": "Vysoký Újezd",
        "popis": "[513482] Vysoký Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 513482,
        "val": "[513482] Vysoky Ujezd 2101 [513482] Vysoký Újezd"
    },
    {
        "kod": 571415,
        "nazev": "Xaverov",
        "popis": "[571415] Xaverov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2101,
        "iczuj": 571415,
        "val": "[571415] Xaverov 2101 [571415] Xaverov"
    },
    {
        "kod": 531022,
        "nazev": "Zdislavice",
        "popis": "[531022] Zdislavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2125,
        "iczuj": 531022,
        "val": "[531022] Zdislavice 2125 [531022] Zdislavice"
    },
    {
        "kod": 531049,
        "nazev": "Zvěstov",
        "popis": "[531049] Zvěstov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2126,
        "iczuj": 531049,
        "val": "[531049] Zvestov 2126 [531049] Zvěstov"
    },
    {
        "kod": 534421,
        "nazev": "Bavoryně",
        "popis": "[534421] Bavoryně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534421,
        "val": "[534421] Bavoryne 2102 [534421] Bavoryně"
    },
    {
        "kod": 531057,
        "nazev": "Beroun",
        "popis": "[531057] Beroun",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531057,
        "val": "[531057] Beroun 2102 [531057] Beroun"
    },
    {
        "kod": 531073,
        "nazev": "Běštín",
        "popis": "[531073] Běštín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531073,
        "val": "[531073] Bestin 2108 [531073] Běštín"
    },
    {
        "kod": 531081,
        "nazev": "Broumy",
        "popis": "[531081] Broumy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531081,
        "val": "[531081] Broumy 2102 [531081] Broumy"
    },
    {
        "kod": 531090,
        "nazev": "Březová",
        "popis": "[531090] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531090,
        "val": "[531090] Brezova 2108 [531090] Březová"
    },
    {
        "kod": 531103,
        "nazev": "Bubovice",
        "popis": "[531103] Bubovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531103,
        "val": "[531103] Bubovice 2102 [531103] Bubovice"
    },
    {
        "kod": 534145,
        "nazev": "Bykoš",
        "popis": "[534145] Bykoš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534145,
        "val": "[534145] Bykos 2102 [534145] Bykoš"
    },
    {
        "kod": 531120,
        "nazev": "Bzová",
        "popis": "[531120] Bzová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531120,
        "val": "[531120] Bzova 2108 [531120] Bzová"
    },
    {
        "kod": 531138,
        "nazev": "Cerhovice",
        "popis": "[531138] Cerhovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531138,
        "val": "[531138] Cerhovice 2108 [531138] Cerhovice"
    },
    {
        "kod": 531154,
        "nazev": "Drozdov",
        "popis": "[531154] Drozdov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531154,
        "val": "[531154] Drozdov 2108 [531154] Drozdov"
    },
    {
        "kod": 531162,
        "nazev": "Felbabka",
        "popis": "[531162] Felbabka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531162,
        "val": "[531162] Felbabka 2108 [531162] Felbabka"
    },
    {
        "kod": 531171,
        "nazev": "Hlásná Třebaň",
        "popis": "[531171] Hlásná Třebaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531171,
        "val": "[531171] Hlasna Treban 2102 [531171] Hlásná Třebaň"
    },
    {
        "kod": 531189,
        "nazev": "Hořovice",
        "popis": "[531189] Hořovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531189,
        "val": "[531189] Horovice 2108 [531189] Hořovice"
    },
    {
        "kod": 531201,
        "nazev": "Hostomice",
        "popis": "[531201] Hostomice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531201,
        "val": "[531201] Hostomice 2108 [531201] Hostomice"
    },
    {
        "kod": 531219,
        "nazev": "Hředle",
        "popis": "[531219] Hředle",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531219,
        "val": "[531219] Hredle 2108 [531219] Hředle"
    },
    {
        "kod": 531227,
        "nazev": "Hudlice",
        "popis": "[531227] Hudlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531227,
        "val": "[531227] Hudlice 2102 [531227] Hudlice"
    },
    {
        "kod": 531235,
        "nazev": "Hvozdec",
        "popis": "[531235] Hvozdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531235,
        "val": "[531235] Hvozdec 2108 [531235] Hvozdec"
    },
    {
        "kod": 531243,
        "nazev": "Hýskov",
        "popis": "[531243] Hýskov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531243,
        "val": "[531243] Hyskov 2102 [531243] Hýskov"
    },
    {
        "kod": 531251,
        "nazev": "Chaloupky",
        "popis": "[531251] Chaloupky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 531251,
        "val": "[531251] Chaloupky 2108 [531251] Chaloupky"
    },
    {
        "kod": 534455,
        "nazev": "Chlustina",
        "popis": "[534455] Chlustina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2108,
        "iczuj": 534455,
        "val": "[534455] Chlustina 2108 [534455] Chlustina"
    },
    {
        "kod": 534447,
        "nazev": "Chodouň",
        "popis": "[534447] Chodouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 534447,
        "val": "[534447] Chodoun 2102 [534447] Chodouň"
    },
    {
        "kod": 533670,
        "nazev": "Chrustenice",
        "popis": "[533670] Chrustenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 533670,
        "val": "[533670] Chrustenice 2102 [533670] Chrustenice"
    },
    {
        "kod": 531294,
        "nazev": "Chyňava",
        "popis": "[531294] Chyňava",
        "datum_od": "",
        "datum_do": "",
        "orp": 2102,
        "iczuj": 531294,
        "val": "[531294] Chynava 2102 [531294] Chyňava"
    },
    {
        "kod": 560987,
        "nazev": "Drunče",
        "popis": "[560987] Drunče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 560987,
        "val": "[560987] Drunce 3105 [560987] Drunče"
    },
    {
        "kod": 562815,
        "nazev": "Dunajovice",
        "popis": "[562815] Dunajovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562815,
        "val": "[562815] Dunajovice 3114 [562815] Dunajovice"
    },
    {
        "kod": 509141,
        "nazev": "Dvory nad Lužnicí",
        "popis": "[509141] Dvory nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 509141,
        "val": "[509141] Dvory nad Luznici 3114 [509141] Dvory nad Lužnicí"
    },
    {
        "kod": 562637,
        "nazev": "Frahelž",
        "popis": "[562637] Frahelž",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562637,
        "val": "[562637] Frahelz 3114 [562637] Frahelž"
    },
    {
        "kod": 562696,
        "nazev": "Hadravova Rosička",
        "popis": "[562696] Hadravova Rosička",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562696,
        "val": "[562696] Hadravova Rosicka 3105 [562696] Hadravova Rosička"
    },
    {
        "kod": 562807,
        "nazev": "Halámky",
        "popis": "[562807] Halámky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562807,
        "val": "[562807] Halamky 3114 [562807] Halámky"
    },
    {
        "kod": 562386,
        "nazev": "Hamr",
        "popis": "[562386] Hamr",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562386,
        "val": "[562386] Hamr 3114 [562386] Hamr"
    },
    {
        "kod": 546291,
        "nazev": "Hatín",
        "popis": "[546291] Hatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546291,
        "val": "[546291] Hatin 3105 [546291] Hatín"
    },
    {
        "kod": 546305,
        "nazev": "Heřmaneč",
        "popis": "[546305] Heřmaneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546305,
        "val": "[546305] Hermanec 3104 [546305] Heřmaneč"
    },
    {
        "kod": 598658,
        "nazev": "Horní Meziříčko",
        "popis": "[598658] Horní Meziříčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 598658,
        "val": "[598658] Horni Meziricko 3104 [598658] Horní Meziříčko"
    },
    {
        "kod": 562785,
        "nazev": "Horní Němčice",
        "popis": "[562785] Horní Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562785,
        "val": "[562785] Horni Nemcice 3104 [562785] Horní Němčice"
    },
    {
        "kod": 546364,
        "nazev": "Horní Pěna",
        "popis": "[546364] Horní Pěna",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546364,
        "val": "[546364] Horni Pena 3105 [546364] Horní Pěna"
    },
    {
        "kod": 546381,
        "nazev": "Horní Radouň",
        "popis": "[546381] Horní Radouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546381,
        "val": "[546381] Horni Radoun 3105 [546381] Horní Radouň"
    },
    {
        "kod": 561061,
        "nazev": "Horní Skrýchov",
        "popis": "[561061] Horní Skrýchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561061,
        "val": "[561061] Horni Skrychov 3105 [561061] Horní Skrýchov"
    },
    {
        "kod": 562319,
        "nazev": "Horní Slatina",
        "popis": "[562319] Horní Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562319,
        "val": "[562319] Horni Slatina 3104 [562319] Horní Slatina"
    },
    {
        "kod": 546402,
        "nazev": "Hospříz",
        "popis": "[546402] Hospříz",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546402,
        "val": "[546402] Hospriz 3105 [546402] Hospříz"
    },
    {
        "kod": 562831,
        "nazev": "Hrachoviště",
        "popis": "[562831] Hrachoviště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562831,
        "val": "[562831] Hrachoviste 3114 [562831] Hrachoviště"
    },
    {
        "kod": 546445,
        "nazev": "Hříšice",
        "popis": "[546445] Hříšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546445,
        "val": "[546445] Hrisice 3104 [546445] Hříšice"
    },
    {
        "kod": 546461,
        "nazev": "Chlum u Třeboně",
        "popis": "[546461] Chlum u Třeboně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 546461,
        "val": "[546461] Chlum u Trebone 3114 [546461] Chlum u Třeboně"
    },
    {
        "kod": 546500,
        "nazev": "Jarošov nad Nežárkou",
        "popis": "[546500] Jarošov nad Nežárkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546500,
        "val": "[546500] Jarosov nad Nezarkou 3105 [546500] Jarošov nad Nežárkou"
    },
    {
        "kod": 562769,
        "nazev": "Jilem",
        "popis": "[562769] Jilem",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562769,
        "val": "[562769] Jilem 3105 [562769] Jilem"
    },
    {
        "kod": 545881,
        "nazev": "Jindřichův Hradec",
        "popis": "[545881] Jindřichův Hradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 545881,
        "val": "[545881] Jindrichuv Hradec 3105 [545881] Jindřichův Hradec"
    },
    {
        "kod": 562491,
        "nazev": "Kačlehy",
        "popis": "[562491] Kačlehy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562491,
        "val": "[562491] Kaclehy 3105 [562491] Kačlehy"
    },
    {
        "kod": 598631,
        "nazev": "Kamenný Malíkov",
        "popis": "[598631] Kamenný Malíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 598631,
        "val": "[598631] Kamenny Malikov 3105 [598631] Kamenný Malíkov"
    },
    {
        "kod": 546542,
        "nazev": "Kardašova Řečice",
        "popis": "[546542] Kardašova Řečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546542,
        "val": "[546542] Kardasova Recice 3105 [546542] Kardašova Řečice"
    },
    {
        "kod": 562688,
        "nazev": "Klec",
        "popis": "[562688] Klec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562688,
        "val": "[562688] Klec 3114 [562688] Klec"
    },
    {
        "kod": 509108,
        "nazev": "Kostelní Radouň",
        "popis": "[509108] Kostelní Radouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 509108,
        "val": "[509108] Kostelni Radoun 3105 [509108] Kostelní Radouň"
    },
    {
        "kod": 508357,
        "nazev": "Kostelní Vydří",
        "popis": "[508357] Kostelní Vydří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 508357,
        "val": "[508357] Kostelni Vydri 3104 [508357] Kostelní Vydří"
    },
    {
        "kod": 546615,
        "nazev": "Kunžak",
        "popis": "[546615] Kunžak",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546615,
        "val": "[546615] Kunzak 3105 [546615] Kunžak"
    },
    {
        "kod": 546623,
        "nazev": "Lásenice",
        "popis": "[546623] Lásenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546623,
        "val": "[546623] Lasenice 3105 [546623] Lásenice"
    },
    {
        "kod": 546666,
        "nazev": "Lodhéřov",
        "popis": "[546666] Lodhéřov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546666,
        "val": "[546666] Lodherov 3105 [546666] Lodhéřov"
    },
    {
        "kod": 546674,
        "nazev": "Lomnice nad Lužnicí",
        "popis": "[546674] Lomnice nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 546674,
        "val": "[546674] Lomnice nad Luznici 3114 [546674] Lomnice nad Lužnicí"
    },
    {
        "kod": 508501,
        "nazev": "Lužnice",
        "popis": "[508501] Lužnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 508501,
        "val": "[508501] Luznice 3114 [508501] Lužnice"
    },
    {
        "kod": 546712,
        "nazev": "Majdalena",
        "popis": "[546712] Majdalena",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 546712,
        "val": "[546712] Majdalena 3114 [546712] Majdalena"
    },
    {
        "kod": 546798,
        "nazev": "Nová Bystřice",
        "popis": "[546798] Nová Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546798,
        "val": "[546798] Nova Bystrice 3105 [546798] Nová Bystřice"
    },
    {
        "kod": 562734,
        "nazev": "Nová Olešná",
        "popis": "[562734] Nová Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562734,
        "val": "[562734] Nova Olesna 3105 [562734] Nová Olešná"
    },
    {
        "kod": 546801,
        "nazev": "Nová Včelnice",
        "popis": "[546801] Nová Včelnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546801,
        "val": "[546801] Nova Vcelnice 3105 [546801] Nová Včelnice"
    },
    {
        "kod": 562360,
        "nazev": "Nová Ves nad Lužnicí",
        "popis": "[562360] Nová Ves nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562360,
        "val": "[562360] Nova Ves nad Luznici 3114 [562360] Nová Ves nad Lužnicí"
    },
    {
        "kod": 546844,
        "nazev": "Novosedly nad Nežárkou",
        "popis": "[546844] Novosedly nad Nežárkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 546844,
        "val": "[546844] Novosedly nad Nezarkou 3114 [546844] Novosedly nad Nežárkou"
    },
    {
        "kod": 562475,
        "nazev": "Okrouhlá Radouň",
        "popis": "[562475] Okrouhlá Radouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562475,
        "val": "[562475] Okrouhla Radoun 3105 [562475] Okrouhlá Radouň"
    },
    {
        "kod": 507717,
        "nazev": "Peč",
        "popis": "[507717] Peč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 507717,
        "val": "[507717] Pec 3104 [507717] Peč"
    },
    {
        "kod": 546917,
        "nazev": "Písečné",
        "popis": "[546917] Písečné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546917,
        "val": "[546917] Pisecne 3104 [546917] Písečné"
    },
    {
        "kod": 561070,
        "nazev": "Pístina",
        "popis": "[561070] Pístina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561070,
        "val": "[561070] Pistina 3105 [561070] Pístina"
    },
    {
        "kod": 509078,
        "nazev": "Plavsko",
        "popis": "[509078] Plavsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 509078,
        "val": "[509078] Plavsko 3105 [509078] Plavsko"
    },
    {
        "kod": 507628,
        "nazev": "Pleše",
        "popis": "[507628] Pleše",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507628,
        "val": "[507628] Plese 3105 [507628] Pleše"
    },
    {
        "kod": 546968,
        "nazev": "Pluhův Žďár",
        "popis": "[546968] Pluhův Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546968,
        "val": "[546968] Pluhuv Zdar 3105 [546968] Pluhův Žďár"
    },
    {
        "kod": 562459,
        "nazev": "Polště",
        "popis": "[562459] Polště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562459,
        "val": "[562459] Polste 3105 [562459] Polště"
    },
    {
        "kod": 562670,
        "nazev": "Ponědraž",
        "popis": "[562670] Ponědraž",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562670,
        "val": "[562670] Ponedraz 3114 [562670] Ponědraž"
    },
    {
        "kod": 562653,
        "nazev": "Ponědrážka",
        "popis": "[562653] Ponědrážka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562653,
        "val": "[562653] Ponedrazka 3114 [562653] Ponědrážka"
    },
    {
        "kod": 546992,
        "nazev": "Popelín",
        "popis": "[546992] Popelín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546992,
        "val": "[546992] Popelin 3105 [546992] Popelín"
    },
    {
        "kod": 561088,
        "nazev": "Příbraz",
        "popis": "[561088] Příbraz",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561088,
        "val": "[561088] Pribraz 3105 [561088] Příbraz"
    },
    {
        "kod": 547069,
        "nazev": "Rapšach",
        "popis": "[547069] Rapšach",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 547069,
        "val": "[547069] Rapsach 3114 [547069] Rapšach"
    },
    {
        "kod": 507784,
        "nazev": "Ratiboř",
        "popis": "[507784] Ratiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507784,
        "val": "[507784] Ratibor 3105 [507784] Ratiboř"
    },
    {
        "kod": 547085,
        "nazev": "Rodvínov",
        "popis": "[547085] Rodvínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 547085,
        "val": "[547085] Rodvinov 3105 [547085] Rodvínov"
    },
    {
        "kod": 508004,
        "nazev": "Roseč",
        "popis": "[508004] Roseč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 508004,
        "val": "[508004] Rosec 3105 [508004] Roseč"
    },
    {
        "kod": 560995,
        "nazev": "Rosička",
        "popis": "[560995] Rosička",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 560995,
        "val": "[560995] Rosicka 3105 [560995] Rosička"
    },
    {
        "kod": 547166,
        "nazev": "Slavonice",
        "popis": "[547166] Slavonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 547166,
        "val": "[547166] Slavonice 3104 [547166] Slavonice"
    },
    {
        "kod": 561045,
        "nazev": "Smržov",
        "popis": "[561045] Smržov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 561045,
        "val": "[561045] Smrzov 3114 [561045] Smržov"
    },
    {
        "kod": 562378,
        "nazev": "Staňkov",
        "popis": "[562378] Staňkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562378,
        "val": "[562378] Stankov 3114 [562378] Staňkov"
    },
    {
        "kod": 547204,
        "nazev": "Staré Hobzí",
        "popis": "[547204] Staré Hobzí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 547204,
        "val": "[547204] Stare Hobzi 3104 [547204] Staré Hobzí"
    },
    {
        "kod": 547212,
        "nazev": "Staré Město pod Landštejnem",
        "popis": "[547212] Staré Město pod Landštejnem",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 547212,
        "val": "[547212] Stare Mesto pod Landstejnem 3105 [547212] Staré Město pod Landštejnem"
    },
    {
        "kod": 547221,
        "nazev": "Stráž nad Nežárkou",
        "popis": "[547221] Stráž nad Nežárkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 547221,
        "val": "[547221] Straz nad Nezarkou 3105 [547221] Stráž nad Nežárkou"
    },
    {
        "kod": 547239,
        "nazev": "Strmilov",
        "popis": "[547239] Strmilov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 547239,
        "val": "[547239] Strmilov 3105 [547239] Strmilov"
    },
    {
        "kod": 547247,
        "nazev": "Stříbřec",
        "popis": "[547247] Stříbřec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 547247,
        "val": "[547247] Stribrec 3114 [547247] Stříbřec"
    },
    {
        "kod": 508152,
        "nazev": "Střížovice",
        "popis": "[508152] Střížovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 508152,
        "val": "[508152] Strizovice 3105 [508152] Střížovice"
    },
    {
        "kod": 547263,
        "nazev": "Studená",
        "popis": "[547263] Studená",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 547263,
        "val": "[547263] Studena 3104 [547263] Studená"
    },
    {
        "kod": 547280,
        "nazev": "Suchdol nad Lužnicí",
        "popis": "[547280] Suchdol nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 547280,
        "val": "[547280] Suchdol nad Luznici 3114 [547280] Suchdol nad Lužnicí"
    },
    {
        "kod": 561029,
        "nazev": "Světce",
        "popis": "[561029] Světce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561029,
        "val": "[561029] Svetce 3105 [561029] Světce"
    },
    {
        "kod": 562327,
        "nazev": "Třebětice",
        "popis": "[562327] Třebětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562327,
        "val": "[562327] Trebetice 3104 [562327] Třebětice"
    },
    {
        "kod": 547336,
        "nazev": "Třeboň",
        "popis": "[547336] Třeboň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 547336,
        "val": "[547336] Trebon 3114 [547336] Třeboň"
    },
    {
        "kod": 507644,
        "nazev": "Újezdec",
        "popis": "[507644] Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507644,
        "val": "[507644] Ujezdec 3105 [507644] Újezdec"
    },
    {
        "kod": 562599,
        "nazev": "Velký Ratmírov",
        "popis": "[562599] Velký Ratmírov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562599,
        "val": "[562599] Velky Ratmirov 3105 [562599] Velký Ratmírov"
    },
    {
        "kod": 561037,
        "nazev": "Vícemil",
        "popis": "[561037] Vícemil",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561037,
        "val": "[561037] Vicemil 3105 [561037] Vícemil"
    },
    {
        "kod": 507652,
        "nazev": "Višňová",
        "popis": "[507652] Višňová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507652,
        "val": "[507652] Visnova 3105 [507652] Višňová"
    },
    {
        "kod": 598640,
        "nazev": "Vlčetínec",
        "popis": "[598640] Vlčetínec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 598640,
        "val": "[598640] Vlcetinec 3105 [598640] Vlčetínec"
    },
    {
        "kod": 547441,
        "nazev": "Volfířov",
        "popis": "[547441] Volfířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 547441,
        "val": "[547441] Volfirov 3104 [547441] Volfířov"
    },
    {
        "kod": 562629,
        "nazev": "Vydří",
        "popis": "[562629] Vydří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562629,
        "val": "[562629] Vydri 3105 [562629] Vydří"
    },
    {
        "kod": 508683,
        "nazev": "Záblatí",
        "popis": "[508683] Záblatí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 508683,
        "val": "[508683] Zablati 3114 [508683] Záblatí"
    },
    {
        "kod": 507695,
        "nazev": "Záhoří",
        "popis": "[507695] Záhoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507695,
        "val": "[507695] Zahori 3105 [507695] Záhoří"
    },
    {
        "kod": 547468,
        "nazev": "Zahrádky",
        "popis": "[547468] Zahrádky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 547468,
        "val": "[547468] Zahradky 3105 [547468] Zahrádky"
    },
    {
        "kod": 529761,
        "nazev": "Žďár",
        "popis": "[529761] Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 529761,
        "val": "[529761] Zdar 3105 [529761] Žďár"
    },
    {
        "kod": 562424,
        "nazev": "Županovice",
        "popis": "[562424] Županovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562424,
        "val": "[562424] Zupanovice 3104 [562424] Županovice"
    },
    {
        "kod": 549258,
        "nazev": "Albrechtice nad Vltavou",
        "popis": "[549258] Albrechtice nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549258,
        "val": "[549258] Albrechtice nad Vltavou 3108 [549258] Albrechtice nad Vltavou"
    },
    {
        "kod": 549266,
        "nazev": "Bernartice",
        "popis": "[549266] Bernartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549266,
        "val": "[549266] Bernartice 3107 [549266] Bernartice"
    },
    {
        "kod": 598780,
        "nazev": "Borovany",
        "popis": "[598780] Borovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 598780,
        "val": "[598780] Borovany 3107 [598780] Borovany"
    },
    {
        "kod": 562122,
        "nazev": "Boudy",
        "popis": "[562122] Boudy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562122,
        "val": "[562122] Boudy 3108 [562122] Boudy"
    },
    {
        "kod": 549291,
        "nazev": "Božetice",
        "popis": "[549291] Božetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549291,
        "val": "[549291] Bozetice 3107 [549291] Božetice"
    },
    {
        "kod": 549304,
        "nazev": "Branice",
        "popis": "[549304] Branice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549304,
        "val": "[549304] Branice 3107 [549304] Branice"
    },
    {
        "kod": 549321,
        "nazev": "Cerhonice",
        "popis": "[549321] Cerhonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549321,
        "val": "[549321] Cerhonice 3108 [549321] Cerhonice"
    },
    {
        "kod": 549339,
        "nazev": "Čimelice",
        "popis": "[549339] Čimelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549339,
        "val": "[549339] Cimelice 3108 [549339] Čimelice"
    },
    {
        "kod": 549347,
        "nazev": "Čížová",
        "popis": "[549347] Čížová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549347,
        "val": "[549347] Cizova 3108 [549347] Čížová"
    },
    {
        "kod": 549363,
        "nazev": "Dobev",
        "popis": "[549363] Dobev",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549363,
        "val": "[549363] Dobev 3108 [549363] Dobev"
    },
    {
        "kod": 562301,
        "nazev": "Dolní Novosedly",
        "popis": "[562301] Dolní Novosedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562301,
        "val": "[562301] Dolni Novosedly 3108 [562301] Dolní Novosedly"
    },
    {
        "kod": 549380,
        "nazev": "Drhovle",
        "popis": "[549380] Drhovle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549380,
        "val": "[549380] Drhovle 3108 [549380] Drhovle"
    },
    {
        "kod": 549398,
        "nazev": "Heřmaň",
        "popis": "[549398] Heřmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549398,
        "val": "[549398] Herman 3108 [549398] Heřmaň"
    },
    {
        "kod": 561525,
        "nazev": "Horosedly",
        "popis": "[561525] Horosedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 561525,
        "val": "[561525] Horosedly 3108 [561525] Horosedly"
    },
    {
        "kod": 549410,
        "nazev": "Hrazany",
        "popis": "[549410] Hrazany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549410,
        "val": "[549410] Hrazany 3107 [549410] Hrazany"
    },
    {
        "kod": 549428,
        "nazev": "Hrejkovice",
        "popis": "[549428] Hrejkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549428,
        "val": "[549428] Hrejkovice 3107 [549428] Hrejkovice"
    },
    {
        "kod": 549452,
        "nazev": "Chyšky",
        "popis": "[549452] Chyšky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549452,
        "val": "[549452] Chysky 3107 [549452] Chyšky"
    },
    {
        "kod": 549479,
        "nazev": "Jetětice",
        "popis": "[549479] Jetětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549479,
        "val": "[549479] Jetetice 3107 [549479] Jetětice"
    },
    {
        "kod": 562084,
        "nazev": "Jickovice",
        "popis": "[562084] Jickovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 562084,
        "val": "[562084] Jickovice 3107 [562084] Jickovice"
    },
    {
        "kod": 549487,
        "nazev": "Kestřany",
        "popis": "[549487] Kestřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549487,
        "val": "[549487] Kestrany 3108 [549487] Kestřany"
    },
    {
        "kod": 549495,
        "nazev": "Kluky",
        "popis": "[549495] Kluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549495,
        "val": "[549495] Kluky 3108 [549495] Kluky"
    },
    {
        "kod": 549509,
        "nazev": "Kostelec nad Vltavou",
        "popis": "[549509] Kostelec nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549509,
        "val": "[549509] Kostelec nad Vltavou 3107 [549509] Kostelec nad Vltavou"
    },
    {
        "kod": 549517,
        "nazev": "Kovářov",
        "popis": "[549517] Kovářov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549517,
        "val": "[549517] Kovarov 3107 [549517] Kovářov"
    },
    {
        "kod": 561550,
        "nazev": "Kožlí",
        "popis": "[561550] Kožlí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 561550,
        "val": "[561550] Kozli 3108 [561550] Kožlí"
    },
    {
        "kod": 549525,
        "nazev": "Králova Lhota",
        "popis": "[549525] Králova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549525,
        "val": "[549525] Kralova Lhota 3108 [549525] Králova Lhota"
    },
    {
        "kod": 562181,
        "nazev": "Křenovice",
        "popis": "[562181] Křenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562181,
        "val": "[562181] Krenovice 3108 [562181] Křenovice"
    },
    {
        "kod": 509752,
        "nazev": "Křižanov",
        "popis": "[509752] Křižanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 509752,
        "val": "[509752] Krizanov 3107 [509752] Křižanov"
    },
    {
        "kod": 549541,
        "nazev": "Kučeř",
        "popis": "[549541] Kučeř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549541,
        "val": "[549541] Kucer 3107 [549541] Kučeř"
    },
    {
        "kod": 598801,
        "nazev": "Květov",
        "popis": "[598801] Květov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 598801,
        "val": "[598801] Kvetov 3107 [598801] Květov"
    },
    {
        "kod": 549568,
        "nazev": "Lety",
        "popis": "[549568] Lety",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549568,
        "val": "[549568] Lety 3108 [549568] Lety"
    },
    {
        "kod": 549576,
        "nazev": "Milevsko",
        "popis": "[549576] Milevsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549576,
        "val": "[549576] Milevsko 3107 [549576] Milevsko"
    },
    {
        "kod": 562149,
        "nazev": "Minice",
        "popis": "[562149] Minice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562149,
        "val": "[562149] Minice 3108 [562149] Minice"
    },
    {
        "kod": 549584,
        "nazev": "Mirotice",
        "popis": "[549584] Mirotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549584,
        "val": "[549584] Mirotice 3108 [549584] Mirotice"
    },
    {
        "kod": 549592,
        "nazev": "Mirovice",
        "popis": "[549592] Mirovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549592,
        "val": "[549592] Mirovice 3108 [549592] Mirovice"
    },
    {
        "kod": 549606,
        "nazev": "Mišovice",
        "popis": "[549606] Mišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549606,
        "val": "[549606] Misovice 3108 [549606] Mišovice"
    },
    {
        "kod": 549614,
        "nazev": "Myslín",
        "popis": "[549614] Myslín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549614,
        "val": "[549614] Myslin 3108 [549614] Myslín"
    },
    {
        "kod": 562157,
        "nazev": "Nerestce",
        "popis": "[562157] Nerestce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562157,
        "val": "[562157] Nerestce 3108 [562157] Nerestce"
    },
    {
        "kod": 549657,
        "nazev": "Nevězice",
        "popis": "[549657] Nevězice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549657,
        "val": "[549657] Nevezice 3108 [549657] Nevězice"
    },
    {
        "kod": 529877,
        "nazev": "Okrouhlá",
        "popis": "[529877] Okrouhlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 529877,
        "val": "[529877] Okrouhla 3107 [529877] Okrouhlá"
    },
    {
        "kod": 562190,
        "nazev": "Olešná",
        "popis": "[562190] Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562190,
        "val": "[562190] Olesna 3108 [562190] Olešná"
    },
    {
        "kod": 549681,
        "nazev": "Orlík nad Vltavou",
        "popis": "[549681] Orlík nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549681,
        "val": "[549681] Orlik nad Vltavou 3108 [549681] Orlík nad Vltavou"
    },
    {
        "kod": 598828,
        "nazev": "Osek",
        "popis": "[598828] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 598828,
        "val": "[598828] Osek 3107 [598828] Osek"
    },
    {
        "kod": 549703,
        "nazev": "Oslov",
        "popis": "[549703] Oslov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549703,
        "val": "[549703] Oslov 3108 [549703] Oslov"
    },
    {
        "kod": 549711,
        "nazev": "Ostrovec",
        "popis": "[549711] Ostrovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549711,
        "val": "[549711] Ostrovec 3108 [549711] Ostrovec"
    },
    {
        "kod": 537047,
        "nazev": "Bříství",
        "popis": "[537047] Bříství",
        "datum_od": "",
        "datum_do": 2020,
        "orp": 2106,
        "iczuj": 537047,
        "val": "[537047] Bristvi 2106 [537047] Bříství"
    },
    {
        "kod": 537055,
        "nazev": "Budiměřice",
        "popis": "[537055] Budiměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537055,
        "val": "[537055] Budimerice 2118 [537055] Budiměřice"
    },
    {
        "kod": 599301,
        "nazev": "Černíky",
        "popis": "[599301] Černíky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2106,
        "iczuj": 599301,
        "val": "[599301] Cerniky 2106 [599301] Černíky"
    },
    {
        "kod": 599671,
        "nazev": "Čilec",
        "popis": "[599671] Čilec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 599671,
        "val": "[599671] Cilec 2118 [599671] Čilec"
    },
    {
        "kod": 537080,
        "nazev": "Činěves",
        "popis": "[537080] Činěves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537080,
        "val": "[537080] Cineves 2119 [537080] Činěves"
    },
    {
        "kod": 537098,
        "nazev": "Dlouhopolsko",
        "popis": "[537098] Dlouhopolsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537098,
        "val": "[537098] Dlouhopolsko 2119 [537098] Dlouhopolsko"
    },
    {
        "kod": 537101,
        "nazev": "Dobšice",
        "popis": "[537101] Dobšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537101,
        "val": "[537101] Dobsice 2119 [537101] Dobšice"
    },
    {
        "kod": 537110,
        "nazev": "Dvory",
        "popis": "[537110] Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537110,
        "val": "[537110] Dvory 2118 [537110] Dvory"
    },
    {
        "kod": 537128,
        "nazev": "Dymokury",
        "popis": "[537128] Dymokury",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537128,
        "val": "[537128] Dymokury 2119 [537128] Dymokury"
    },
    {
        "kod": 534854,
        "nazev": "Hořany",
        "popis": "[534854] Hořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 534854,
        "val": "[534854] Horany 2118 [534854] Hořany"
    },
    {
        "kod": 537152,
        "nazev": "Hořátev",
        "popis": "[537152] Hořátev",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537152,
        "val": "[537152] Horatev 2118 [537152] Hořátev"
    },
    {
        "kod": 537161,
        "nazev": "Hradčany",
        "popis": "[537161] Hradčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537161,
        "val": "[537161] Hradcany 2119 [537161] Hradčany"
    },
    {
        "kod": 537179,
        "nazev": "Hradištko",
        "popis": "[537179] Hradištko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537179,
        "val": "[537179] Hradistko 2118 [537179] Hradištko"
    },
    {
        "kod": 599638,
        "nazev": "Hrubý Jeseník",
        "popis": "[599638] Hrubý Jeseník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 599638,
        "val": "[599638] Hruby Jesenik 2118 [599638] Hrubý Jeseník"
    },
    {
        "kod": 599620,
        "nazev": "Chleby",
        "popis": "[599620] Chleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 599620,
        "val": "[599620] Chleby 2118 [599620] Chleby"
    },
    {
        "kod": 537217,
        "nazev": "Choťánky",
        "popis": "[537217] Choťánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537217,
        "val": "[537217] Chotanky 2119 [537217] Choťánky"
    },
    {
        "kod": 537225,
        "nazev": "Chotěšice",
        "popis": "[537225] Chotěšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537225,
        "val": "[537225] Chotesice 2119 [537225] Chotěšice"
    },
    {
        "kod": 537233,
        "nazev": "Chrást",
        "popis": "[537233] Chrást",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537233,
        "val": "[537233] Chrast 2118 [537233] Chrást"
    },
    {
        "kod": 534706,
        "nazev": "Chroustov",
        "popis": "[534706] Chroustov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 534706,
        "val": "[534706] Chroustov 2119 [534706] Chroustov"
    },
    {
        "kod": 537250,
        "nazev": "Jíkev",
        "popis": "[537250] Jíkev",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537250,
        "val": "[537250] Jikev 2118 [537250] Jíkev"
    },
    {
        "kod": 599581,
        "nazev": "Jiřice",
        "popis": "[599581] Jiřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 599581,
        "val": "[599581] Jirice 2113 [599581] Jiřice"
    },
    {
        "kod": 537268,
        "nazev": "Jizbice",
        "popis": "[537268] Jizbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537268,
        "val": "[537268] Jizbice 2118 [537268] Jizbice"
    },
    {
        "kod": 537276,
        "nazev": "Kamenné Zboží",
        "popis": "[537276] Kamenné Zboží",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537276,
        "val": "[537276] Kamenne Zbozi 2118 [537276] Kamenné Zboží"
    },
    {
        "kod": 537292,
        "nazev": "Kněžice",
        "popis": "[537292] Kněžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537292,
        "val": "[537292] Knezice 2119 [537292] Kněžice"
    },
    {
        "kod": 551481,
        "nazev": "Kněžičky",
        "popis": "[551481] Kněžičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 551481,
        "val": "[551481] Knezicky 2119 [551481] Kněžičky"
    },
    {
        "kod": 537306,
        "nazev": "Kolaje",
        "popis": "[537306] Kolaje",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537306,
        "val": "[537306] Kolaje 2119 [537306] Kolaje"
    },
    {
        "kod": 537314,
        "nazev": "Kostelní Lhota",
        "popis": "[537314] Kostelní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537314,
        "val": "[537314] Kostelni Lhota 2118 [537314] Kostelní Lhota"
    },
    {
        "kod": 529630,
        "nazev": "Kostomlátky",
        "popis": "[529630] Kostomlátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 529630,
        "val": "[529630] Kostomlatky 2118 [529630] Kostomlátky"
    },
    {
        "kod": 537331,
        "nazev": "Kostomlaty nad Labem",
        "popis": "[537331] Kostomlaty nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537331,
        "val": "[537331] Kostomlaty nad Labem 2118 [537331] Kostomlaty nad Labem"
    },
    {
        "kod": 537349,
        "nazev": "Košík",
        "popis": "[537349] Košík",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537349,
        "val": "[537349] Kosik 2118 [537349] Košík"
    },
    {
        "kod": 537357,
        "nazev": "Kounice",
        "popis": "[537357] Kounice",
        "datum_od": "",
        "datum_do": 2020,
        "orp": 2106,
        "iczuj": 537357,
        "val": "[537357] Kounice 2106 [537357] Kounice"
    },
    {
        "kod": 534943,
        "nazev": "Kouty",
        "popis": "[534943] Kouty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 534943,
        "val": "[534943] Kouty 2119 [534943] Kouty"
    },
    {
        "kod": 537373,
        "nazev": "Kovanice",
        "popis": "[537373] Kovanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537373,
        "val": "[537373] Kovanice 2118 [537373] Kovanice"
    },
    {
        "kod": 537390,
        "nazev": "Krchleby",
        "popis": "[537390] Krchleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537390,
        "val": "[537390] Krchleby 2118 [537390] Krchleby"
    },
    {
        "kod": 537403,
        "nazev": "Křečkov",
        "popis": "[537403] Křečkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537403,
        "val": "[537403] Kreckov 2119 [537403] Křečkov"
    },
    {
        "kod": 537411,
        "nazev": "Křinec",
        "popis": "[537411] Křinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537411,
        "val": "[537411] Krinec 2118 [537411] Křinec"
    },
    {
        "kod": 537438,
        "nazev": "Libice nad Cidlinou",
        "popis": "[537438] Libice nad Cidlinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537438,
        "val": "[537438] Libice nad Cidlinou 2119 [537438] Libice nad Cidlinou"
    },
    {
        "kod": 537446,
        "nazev": "Loučeň",
        "popis": "[537446] Loučeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537446,
        "val": "[537446] Loucen 2118 [537446] Loučeň"
    },
    {
        "kod": 537454,
        "nazev": "Lysá nad Labem",
        "popis": "[537454] Lysá nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537454,
        "val": "[537454] Lysa nad Labem 2113 [537454] Lysá nad Labem"
    },
    {
        "kod": 537462,
        "nazev": "Mcely",
        "popis": "[537462] Mcely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537462,
        "val": "[537462] Mcely 2118 [537462] Mcely"
    },
    {
        "kod": 537489,
        "nazev": "Městec Králové",
        "popis": "[537489] Městec Králové",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537489,
        "val": "[537489] Mestec Kralove 2119 [537489] Městec Králové"
    },
    {
        "kod": 537497,
        "nazev": "Milčice",
        "popis": "[537497] Milčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537497,
        "val": "[537497] Milcice 2118 [537497] Milčice"
    },
    {
        "kod": 537501,
        "nazev": "Milovice",
        "popis": "[537501] Milovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537501,
        "val": "[537501] Milovice 2113 [537501] Milovice"
    },
    {
        "kod": 534919,
        "nazev": "Netřebice",
        "popis": "[534919] Netřebice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 534919,
        "val": "[534919] Netrebice 2118 [534919] Netřebice"
    },
    {
        "kod": 599654,
        "nazev": "Nový Dvůr",
        "popis": "[599654] Nový Dvůr",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 599654,
        "val": "[599654] Novy Dvur 2118 [599654] Nový Dvůr"
    },
    {
        "kod": 537004,
        "nazev": "Nymburk",
        "popis": "[537004] Nymburk",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537004,
        "val": "[537004] Nymburk 2118 [537004] Nymburk"
    },
    {
        "kod": 537551,
        "nazev": "Odřepsy",
        "popis": "[537551] Odřepsy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537551,
        "val": "[537551] Odrepsy 2119 [537551] Odřepsy"
    },
    {
        "kod": 537560,
        "nazev": "Okřínek",
        "popis": "[537560] Okřínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537560,
        "val": "[537560] Okrinek 2119 [537560] Okřínek"
    },
    {
        "kod": 537578,
        "nazev": "Opočnice",
        "popis": "[537578] Opočnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537578,
        "val": "[537578] Opocnice 2119 [537578] Opočnice"
    },
    {
        "kod": 537586,
        "nazev": "Opolany",
        "popis": "[537586] Opolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537586,
        "val": "[537586] Opolany 2119 [537586] Opolany"
    },
    {
        "kod": 599662,
        "nazev": "Oseček",
        "popis": "[599662] Oseček",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 599662,
        "val": "[599662] Osecek 2119 [599662] Oseček"
    },
    {
        "kod": 537616,
        "nazev": "Oskořínek",
        "popis": "[537616] Oskořínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537616,
        "val": "[537616] Oskorinek 2118 [537616] Oskořínek"
    },
    {
        "kod": 537624,
        "nazev": "Ostrá",
        "popis": "[537624] Ostrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537624,
        "val": "[537624] Ostra 2113 [537624] Ostrá"
    },
    {
        "kod": 537632,
        "nazev": "Pátek",
        "popis": "[537632] Pátek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537632,
        "val": "[537632] Patek 2119 [537632] Pátek"
    },
    {
        "kod": 537659,
        "nazev": "Písková Lhota",
        "popis": "[537659] Písková Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537659,
        "val": "[537659] Piskova Lhota 2119 [537659] Písková Lhota"
    },
    {
        "kod": 537667,
        "nazev": "Písty",
        "popis": "[537667] Písty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537667,
        "val": "[537667] Pisty 2118 [537667] Písty"
    },
    {
        "kod": 537683,
        "nazev": "Poděbrady",
        "popis": "[537683] Poděbrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537683,
        "val": "[537683] Podebrady 2119 [537683] Poděbrady"
    },
    {
        "kod": 599590,
        "nazev": "Podmoky",
        "popis": "[599590] Podmoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 599590,
        "val": "[599590] Podmoky 2119 [599590] Podmoky"
    },
    {
        "kod": 537721,
        "nazev": "Přerov nad Labem",
        "popis": "[537721] Přerov nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537721,
        "val": "[537721] Prerov nad Labem 2113 [537721] Přerov nad Labem"
    },
    {
        "kod": 537756,
        "nazev": "Rožďalovice",
        "popis": "[537756] Rožďalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537756,
        "val": "[537756] Rozdalovice 2118 [537756] Rožďalovice"
    },
    {
        "kod": 537764,
        "nazev": "Sadská",
        "popis": "[537764] Sadská",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537764,
        "val": "[537764] Sadska 2118 [537764] Sadská"
    },
    {
        "kod": 537772,
        "nazev": "Sány",
        "popis": "[537772] Sány",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537772,
        "val": "[537772] Sany 2119 [537772] Sány"
    },
    {
        "kod": 534757,
        "nazev": "Seletice",
        "popis": "[534757] Seletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 534757,
        "val": "[534757] Seletice 2118 [534757] Seletice"
    },
    {
        "kod": 537781,
        "nazev": "Semice",
        "popis": "[537781] Semice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537781,
        "val": "[537781] Semice 2113 [537781] Semice"
    },
    {
        "kod": 537799,
        "nazev": "Senice",
        "popis": "[537799] Senice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537799,
        "val": "[537799] Senice 2119 [537799] Senice"
    },
    {
        "kod": 537802,
        "nazev": "Sloveč",
        "popis": "[537802] Sloveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537802,
        "val": "[537802] Slovec 2119 [537802] Sloveč"
    },
    {
        "kod": 537811,
        "nazev": "Sokoleč",
        "popis": "[537811] Sokoleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537811,
        "val": "[537811] Sokolec 2119 [537811] Sokoleč"
    },
    {
        "kod": 537837,
        "nazev": "Stará Lysá",
        "popis": "[537837] Stará Lysá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537837,
        "val": "[537837] Stara Lysa 2113 [537837] Stará Lysá"
    },
    {
        "kod": 534889,
        "nazev": "Starý Vestec",
        "popis": "[534889] Starý Vestec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 534889,
        "val": "[534889] Stary Vestec 2113 [534889] Starý Vestec"
    },
    {
        "kod": 537853,
        "nazev": "Straky",
        "popis": "[537853] Straky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537853,
        "val": "[537853] Straky 2118 [537853] Straky"
    },
    {
        "kod": 537861,
        "nazev": "Stratov",
        "popis": "[537861] Stratov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537861,
        "val": "[537861] Stratov 2113 [537861] Stratov"
    },
    {
        "kod": 537896,
        "nazev": "Třebestovice",
        "popis": "[537896] Třebestovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537896,
        "val": "[537896] Trebestovice 2118 [537896] Třebestovice"
    },
    {
        "kod": 537900,
        "nazev": "Úmyslovice",
        "popis": "[537900] Úmyslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537900,
        "val": "[537900] Umyslovice 2119 [537900] Úmyslovice"
    },
    {
        "kod": 536083,
        "nazev": "Velenice",
        "popis": "[536083] Velenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 536083,
        "val": "[536083] Velenice 2119 [536083] Velenice"
    },
    {
        "kod": 534871,
        "nazev": "Velenka",
        "popis": "[534871] Velenka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 534871,
        "val": "[534871] Velenka 2118 [534871] Velenka"
    },
    {
        "kod": 537942,
        "nazev": "Vestec",
        "popis": "[537942] Vestec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537942,
        "val": "[537942] Vestec 2118 [537942] Vestec"
    },
    {
        "kod": 537951,
        "nazev": "Vlkov pod Oškobrhem",
        "popis": "[537951] Vlkov pod Oškobrhem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537951,
        "val": "[537951] Vlkov pod Oskobrhem 2119 [537951] Vlkov pod Oškobrhem"
    },
    {
        "kod": 599611,
        "nazev": "Vrbice",
        "popis": "[599611] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 599611,
        "val": "[599611] Vrbice 2119 [599611] Vrbice"
    },
    {
        "kod": 537977,
        "nazev": "Vrbová Lhota",
        "popis": "[537977] Vrbová Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 537977,
        "val": "[537977] Vrbova Lhota 2119 [537977] Vrbová Lhota"
    },
    {
        "kod": 537985,
        "nazev": "Všechlapy",
        "popis": "[537985] Všechlapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 537985,
        "val": "[537985] Vsechlapy 2118 [537985] Všechlapy"
    },
    {
        "kod": 537993,
        "nazev": "Vykáň",
        "popis": "[537993] Vykáň",
        "datum_od": "",
        "datum_do": 2020,
        "orp": 2106,
        "iczuj": 537993,
        "val": "[537993] Vykan 2106 [537993] Vykáň"
    },
    {
        "kod": 534471,
        "nazev": "Záhornice",
        "popis": "[534471] Záhornice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2119,
        "iczuj": 534471,
        "val": "[534471] Zahornice 2119 [534471] Záhornice"
    },
    {
        "kod": 599697,
        "nazev": "Zbožíčko",
        "popis": "[599697] Zbožíčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 599697,
        "val": "[599697] Zbozicko 2118 [599697] Zbožíčko"
    },
    {
        "kod": 534862,
        "nazev": "Zvěřínek",
        "popis": "[534862] Zvěřínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 534862,
        "val": "[534862] Zverinek 2118 [534862] Zvěřínek"
    },
    {
        "kod": 503410,
        "nazev": "Žitovlice",
        "popis": "[503410] Žitovlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2118,
        "iczuj": 503410,
        "val": "[503410] Zitovlice 2118 [503410] Žitovlice"
    },
    {
        "kod": 538043,
        "nazev": "Babice",
        "popis": "[538043] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538043,
        "val": "[538043] Babice 2122 [538043] Babice"
    },
    {
        "kod": 538051,
        "nazev": "Bašť",
        "popis": "[538051] Bašť",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538051,
        "val": "[538051] Bast 2103 [538051] Bašť"
    },
    {
        "kod": 534684,
        "nazev": "Borek",
        "popis": "[534684] Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 534684,
        "val": "[534684] Borek 2103 [534684] Borek"
    },
    {
        "kod": 538086,
        "nazev": "Bořanovice",
        "popis": "[538086] Bořanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538086,
        "val": "[538086] Boranovice 2103 [538086] Bořanovice"
    },
    {
        "kod": 538094,
        "nazev": "Brandýs nad Labem-Stará Boleslav",
        "popis": "[538094] Brandýs nad Labem-Stará Boleslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538094,
        "val": "[538094] Brandys nad Labem-Stara Boleslav 2103 [538094] Brandýs nad Labem-Stará Boleslav"
    },
    {
        "kod": 538108,
        "nazev": "Brázdim",
        "popis": "[538108] Brázdim",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538108,
        "val": "[538108] Brazdim 2103 [538108] Brázdim"
    },
    {
        "kod": 564869,
        "nazev": "Březí",
        "popis": "[564869] Březí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564869,
        "val": "[564869] Brezi 2122 [564869] Březí"
    },
    {
        "kod": 538132,
        "nazev": "Čelákovice",
        "popis": "[538132] Čelákovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538132,
        "val": "[538132] Celakovice 2103 [538132] Čelákovice"
    },
    {
        "kod": 533254,
        "nazev": "Černé Voděrady",
        "popis": "[533254] Černé Voděrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533254,
        "val": "[533254] Cerne Voderady 2122 [533254] Černé Voděrady"
    },
    {
        "kod": 538141,
        "nazev": "Čestlice",
        "popis": "[538141] Čestlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538141,
        "val": "[538141] Cestlice 2122 [538141] Čestlice"
    },
    {
        "kod": 565008,
        "nazev": "Dobročovice",
        "popis": "[565008] Dobročovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 565008,
        "val": "[565008] Dobrocovice 2103 [565008] Dobročovice"
    },
    {
        "kod": 538167,
        "nazev": "Dobřejovice",
        "popis": "[538167] Dobřejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538167,
        "val": "[538167] Dobrejovice 2122 [538167] Dobřejovice"
    },
    {
        "kod": 564885,
        "nazev": "Doubek",
        "popis": "[564885] Doubek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564885,
        "val": "[564885] Doubek 2122 [564885] Doubek"
    },
    {
        "kod": 538191,
        "nazev": "Dřevčice",
        "popis": "[538191] Dřevčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538191,
        "val": "[538191] Drevcice 2103 [538191] Dřevčice"
    },
    {
        "kod": 534781,
        "nazev": "Dřísy",
        "popis": "[534781] Dřísy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 534781,
        "val": "[534781] Drisy 2103 [534781] Dřísy"
    },
    {
        "kod": 564915,
        "nazev": "Herink",
        "popis": "[564915] Herink",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564915,
        "val": "[564915] Herink 2122 [564915] Herink"
    },
    {
        "kod": 565989,
        "nazev": "Hlavenec",
        "popis": "[565989] Hlavenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 565989,
        "val": "[565989] Hlavenec 2103 [565989] Hlavenec"
    },
    {
        "kod": 538221,
        "nazev": "Horoušany",
        "popis": "[538221] Horoušany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538221,
        "val": "[538221] Horousany 2103 [538221] Horoušany"
    },
    {
        "kod": 538230,
        "nazev": "Hovorčovice",
        "popis": "[538230] Hovorčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538230,
        "val": "[538230] Hovorcovice 2103 [538230] Hovorčovice"
    },
    {
        "kod": 538248,
        "nazev": "Hrusice",
        "popis": "[538248] Hrusice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538248,
        "val": "[538248] Hrusice 2122 [538248] Hrusice"
    },
    {
        "kod": 538256,
        "nazev": "Husinec",
        "popis": "[538256] Husinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538256,
        "val": "[538256] Husinec 2103 [538256] Husinec"
    },
    {
        "kod": 538264,
        "nazev": "Jenštejn",
        "popis": "[538264] Jenštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538264,
        "val": "[538264] Jenstejn 2103 [538264] Jenštejn"
    },
    {
        "kod": 533378,
        "nazev": "Jevany",
        "popis": "[533378] Jevany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533378,
        "val": "[533378] Jevany 2122 [533378] Jevany"
    },
    {
        "kod": 538272,
        "nazev": "Jirny",
        "popis": "[538272] Jirny",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538272,
        "val": "[538272] Jirny 2103 [538272] Jirny"
    },
    {
        "kod": 538281,
        "nazev": "Kaliště",
        "popis": "[538281] Kaliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538281,
        "val": "[538281] Kaliste 2122 [538281] Kaliště"
    },
    {
        "kod": 538299,
        "nazev": "Kamenice",
        "popis": "[538299] Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538299,
        "val": "[538299] Kamenice 2122 [538299] Kamenice"
    },
    {
        "kod": 564974,
        "nazev": "Káraný",
        "popis": "[564974] Káraný",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 564974,
        "val": "[564974] Karany 2103 [564974] Káraný"
    },
    {
        "kod": 538311,
        "nazev": "Klecany",
        "popis": "[538311] Klecany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538311,
        "val": "[538311] Klecany 2103 [538311] Klecany"
    },
    {
        "kod": 538329,
        "nazev": "Klíčany",
        "popis": "[538329] Klíčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538329,
        "val": "[538329] Klicany 2103 [538329] Klíčany"
    },
    {
        "kod": 513628,
        "nazev": "Klokočná",
        "popis": "[513628] Klokočná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 513628,
        "val": "[513628] Klokocna 2122 [513628] Klokočná"
    },
    {
        "kod": 531553,
        "nazev": "Konětopy",
        "popis": "[531553] Konětopy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 531553,
        "val": "[531553] Konetopy 2103 [531553] Konětopy"
    },
    {
        "kod": 564761,
        "nazev": "Konojedy",
        "popis": "[564761] Konojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564761,
        "val": "[564761] Konojedy 2122 [564761] Konojedy"
    },
    {
        "kod": 533416,
        "nazev": "Kostelec nad Černými lesy",
        "popis": "[533416] Kostelec nad Černými lesy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533416,
        "val": "[533416] Kostelec nad Cernymi lesy 2122 [533416] Kostelec nad Černými lesy"
    },
    {
        "kod": 538370,
        "nazev": "Kostelec u Křížků",
        "popis": "[538370] Kostelec u Křížků",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538370,
        "val": "[538370] Kostelec u Krizku 2122 [538370] Kostelec u Křížků"
    },
    {
        "kod": 536130,
        "nazev": "Kostelní Hlavno",
        "popis": "[536130] Kostelní Hlavno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 536130,
        "val": "[536130] Kostelni Hlavno 2103 [536130] Kostelní Hlavno"
    },
    {
        "kod": 533432,
        "nazev": "Kozojedy",
        "popis": "[533432] Kozojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533432,
        "val": "[533432] Kozojedy 2122 [533432] Kozojedy"
    },
    {
        "kod": 534960,
        "nazev": "Křenek",
        "popis": "[534960] Křenek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 534960,
        "val": "[534960] Krenek 2103 [534960] Křenek"
    },
    {
        "kod": 564991,
        "nazev": "Křenice",
        "popis": "[564991] Křenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564991,
        "val": "[564991] Krenice 2122 [564991] Křenice"
    },
    {
        "kod": 538418,
        "nazev": "Křížkový Újezdec",
        "popis": "[538418] Křížkový Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538418,
        "val": "[538418] Krizkovy Ujezdec 2122 [538418] Křížkový Újezdec"
    },
    {
        "kod": 538426,
        "nazev": "Kunice",
        "popis": "[538426] Kunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538426,
        "val": "[538426] Kunice 2122 [538426] Kunice"
    },
    {
        "kod": 564982,
        "nazev": "Květnice",
        "popis": "[564982] Květnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 564982,
        "val": "[564982] Kvetnice 2103 [564982] Květnice"
    },
    {
        "kod": 538914,
        "nazev": "Lázně Toušeň",
        "popis": "[538914] Lázně Toušeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538914,
        "val": "[538914] Lazne Tousen 2103 [538914] Lázně Toušeň"
    },
    {
        "kod": 534986,
        "nazev": "Lhota",
        "popis": "[534986] Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 534986,
        "val": "[534986] Lhota 2103 [534986] Lhota"
    },
    {
        "kod": 538442,
        "nazev": "Líbeznice",
        "popis": "[538442] Líbeznice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538442,
        "val": "[538442] Libeznice 2103 [538442] Líbeznice"
    },
    {
        "kod": 538451,
        "nazev": "Louňovice",
        "popis": "[538451] Louňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538451,
        "val": "[538451] Lounovice 2122 [538451] Louňovice"
    },
    {
        "kod": 538469,
        "nazev": "Máslovice",
        "popis": "[538469] Máslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538469,
        "val": "[538469] Maslovice 2103 [538469] Máslovice"
    },
    {
        "kod": 564338,
        "nazev": "Županovice",
        "popis": "[564338] Županovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 564338,
        "val": "[564338] Zupanovice 2107 [564338] Županovice"
    },
    {
        "kod": 551261,
        "nazev": "Kraselov",
        "popis": "[551261] Kraselov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551261,
        "val": "[551261] Kraselov 3111 [551261] Kraselov"
    },
    {
        "kod": 536806,
        "nazev": "Krašlovice",
        "popis": "[536806] Krašlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 536806,
        "val": "[536806] Kraslovice 3117 [536806] Krašlovice"
    },
    {
        "kod": 536954,
        "nazev": "Krejnice",
        "popis": "[536954] Krejnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536954,
        "val": "[536954] Krejnice 3111 [536954] Krejnice"
    },
    {
        "kod": 536555,
        "nazev": "Krty-Hradec",
        "popis": "[536555] Krty-Hradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536555,
        "val": "[536555] Krty-Hradec 3111 [536555] Krty-Hradec"
    },
    {
        "kod": 560391,
        "nazev": "Kuřimany",
        "popis": "[560391] Kuřimany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560391,
        "val": "[560391] Kurimany 3111 [560391] Kuřimany"
    },
    {
        "kod": 536750,
        "nazev": "Kváskovice",
        "popis": "[536750] Kváskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536750,
        "val": "[536750] Kvaskovice 3111 [536750] Kváskovice"
    },
    {
        "kod": 598950,
        "nazev": "Lažánky",
        "popis": "[598950] Lažánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 598950,
        "val": "[598950] Lazanky 3101 [598950] Lažánky"
    },
    {
        "kod": 560197,
        "nazev": "Lažany",
        "popis": "[560197] Lažany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 560197,
        "val": "[560197] Lazany 3101 [560197] Lažany"
    },
    {
        "kod": 551333,
        "nazev": "Libějovice",
        "popis": "[551333] Libějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 551333,
        "val": "[551333] Libejovice 3117 [551333] Libějovice"
    },
    {
        "kod": 536831,
        "nazev": "Libětice",
        "popis": "[536831] Libětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536831,
        "val": "[536831] Libetice 3111 [536831] Libětice"
    },
    {
        "kod": 551341,
        "nazev": "Litochovice",
        "popis": "[551341] Litochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551341,
        "val": "[551341] Litochovice 3111 [551341] Litochovice"
    },
    {
        "kod": 551350,
        "nazev": "Lnáře",
        "popis": "[551350] Lnáře",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551350,
        "val": "[551350] Lnare 3101 [551350] Lnáře"
    },
    {
        "kod": 536822,
        "nazev": "Lom",
        "popis": "[536822] Lom",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536822,
        "val": "[536822] Lom 3101 [536822] Lom"
    },
    {
        "kod": 536466,
        "nazev": "Mačkov",
        "popis": "[536466] Mačkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536466,
        "val": "[536466] Mackov 3101 [536466] Mačkov"
    },
    {
        "kod": 551384,
        "nazev": "Malenice",
        "popis": "[551384] Malenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551384,
        "val": "[551384] Malenice 3111 [551384] Malenice"
    },
    {
        "kod": 551392,
        "nazev": "Mečichov",
        "popis": "[551392] Mečichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551392,
        "val": "[551392] Mecichov 3111 [551392] Mečichov"
    },
    {
        "kod": 536415,
        "nazev": "Měkynec",
        "popis": "[536415] Měkynec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 536415,
        "val": "[536415] Mekynec 3117 [536415] Měkynec"
    },
    {
        "kod": 536539,
        "nazev": "Milejovice",
        "popis": "[536539] Milejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536539,
        "val": "[536539] Milejovice 3111 [536539] Milejovice"
    },
    {
        "kod": 551414,
        "nazev": "Miloňovice",
        "popis": "[551414] Miloňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551414,
        "val": "[551414] Milonovice 3111 [551414] Miloňovice"
    },
    {
        "kod": 536563,
        "nazev": "Mnichov",
        "popis": "[536563] Mnichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536563,
        "val": "[536563] Mnichov 3111 [536563] Mnichov"
    },
    {
        "kod": 560278,
        "nazev": "Mutěnice",
        "popis": "[560278] Mutěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560278,
        "val": "[560278] Mutenice 3111 [560278] Mutěnice"
    },
    {
        "kod": 551473,
        "nazev": "Myštice",
        "popis": "[551473] Myštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551473,
        "val": "[551473] Mystice 3101 [551473] Myštice"
    },
    {
        "kod": 536644,
        "nazev": "Nebřehovice",
        "popis": "[536644] Nebřehovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536644,
        "val": "[536644] Nebrehovice 3111 [536644] Nebřehovice"
    },
    {
        "kod": 536474,
        "nazev": "Němčice",
        "popis": "[536474] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536474,
        "val": "[536474] Nemcice 3111 [536474] Němčice"
    },
    {
        "kod": 536725,
        "nazev": "Němětice",
        "popis": "[536725] Němětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536725,
        "val": "[536725] Nemetice 3111 [536725] Němětice"
    },
    {
        "kod": 551520,
        "nazev": "Nihošovice",
        "popis": "[551520] Nihošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551520,
        "val": "[551520] Nihosovice 3111 [551520] Nihošovice"
    },
    {
        "kod": 536962,
        "nazev": "Nišovice",
        "popis": "[536962] Nišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536962,
        "val": "[536962] Nisovice 3111 [536962] Nišovice"
    },
    {
        "kod": 560201,
        "nazev": "Nová Ves",
        "popis": "[560201] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560201,
        "val": "[560201] Nova Ves 3111 [560201] Nová Ves"
    },
    {
        "kod": 551554,
        "nazev": "Novosedly",
        "popis": "[551554] Novosedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551554,
        "val": "[551554] Novosedly 3111 [551554] Novosedly"
    },
    {
        "kod": 551562,
        "nazev": "Osek",
        "popis": "[551562] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551562,
        "val": "[551562] Osek 3111 [551562] Osek"
    },
    {
        "kod": 551571,
        "nazev": "Paračov",
        "popis": "[551571] Paračov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551571,
        "val": "[551571] Paracov 3111 [551571] Paračov"
    },
    {
        "kod": 598887,
        "nazev": "Pivkovice",
        "popis": "[598887] Pivkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 598887,
        "val": "[598887] Pivkovice 3117 [598887] Pivkovice"
    },
    {
        "kod": 536911,
        "nazev": "Pohorovice",
        "popis": "[536911] Pohorovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 536911,
        "val": "[536911] Pohorovice 3117 [536911] Pohorovice"
    },
    {
        "kod": 551619,
        "nazev": "Pracejovice",
        "popis": "[551619] Pracejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551619,
        "val": "[551619] Pracejovice 3111 [551619] Pracejovice"
    },
    {
        "kod": 551627,
        "nazev": "Předmíř",
        "popis": "[551627] Předmíř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551627,
        "val": "[551627] Predmir 3101 [551627] Předmíř"
    },
    {
        "kod": 536792,
        "nazev": "Přední Zborovice",
        "popis": "[536792] Přední Zborovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536792,
        "val": "[536792] Predni Zborovice 3111 [536792] Přední Zborovice"
    },
    {
        "kod": 551635,
        "nazev": "Předslavice",
        "popis": "[551635] Předslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551635,
        "val": "[551635] Predslavice 3111 [551635] Předslavice"
    },
    {
        "kod": 536547,
        "nazev": "Přechovice",
        "popis": "[536547] Přechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536547,
        "val": "[536547] Prechovice 3111 [536547] Přechovice"
    },
    {
        "kod": 551643,
        "nazev": "Přešťovice",
        "popis": "[551643] Přešťovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551643,
        "val": "[551643] Prestovice 3111 [551643] Přešťovice"
    },
    {
        "kod": 536423,
        "nazev": "Radějovice",
        "popis": "[536423] Radějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536423,
        "val": "[536423] Radejovice 3111 [536423] Radějovice"
    },
    {
        "kod": 551660,
        "nazev": "Radomyšl",
        "popis": "[551660] Radomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551660,
        "val": "[551660] Radomysl 3111 [551660] Radomyšl"
    },
    {
        "kod": 551678,
        "nazev": "Radošovice",
        "popis": "[551678] Radošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551678,
        "val": "[551678] Radosovice 3111 [551678] Radošovice"
    },
    {
        "kod": 536865,
        "nazev": "Rovná",
        "popis": "[536865] Rovná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536865,
        "val": "[536865] Rovna 3111 [536865] Rovná"
    },
    {
        "kod": 536849,
        "nazev": "Řepice",
        "popis": "[536849] Řepice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536849,
        "val": "[536849] Repice 3111 [536849] Řepice"
    },
    {
        "kod": 551716,
        "nazev": "Sedlice",
        "popis": "[551716] Sedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551716,
        "val": "[551716] Sedlice 3101 [551716] Sedlice"
    },
    {
        "kod": 598909,
        "nazev": "Skály",
        "popis": "[598909] Skály",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 598909,
        "val": "[598909] Skaly 3111 [598909] Skály"
    },
    {
        "kod": 551741,
        "nazev": "Skočice",
        "popis": "[551741] Skočice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 551741,
        "val": "[551741] Skocice 3117 [551741] Skočice"
    },
    {
        "kod": 536776,
        "nazev": "Slaník",
        "popis": "[536776] Slaník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536776,
        "val": "[536776] Slanik 3111 [536776] Slaník"
    },
    {
        "kod": 551759,
        "nazev": "Sousedovice",
        "popis": "[551759] Sousedovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551759,
        "val": "[551759] Sousedovice 3111 [551759] Sousedovice"
    },
    {
        "kod": 530034,
        "nazev": "Stožice",
        "popis": "[530034] Stožice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 530034,
        "val": "[530034] Stozice 3117 [530034] Stožice"
    },
    {
        "kod": 550787,
        "nazev": "Strakonice",
        "popis": "[550787] Strakonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550787,
        "val": "[550787] Strakonice 3111 [550787] Strakonice"
    },
    {
        "kod": 551775,
        "nazev": "Strašice",
        "popis": "[551775] Strašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551775,
        "val": "[551775] Strasice 3111 [551775] Strašice"
    },
    {
        "kod": 536784,
        "nazev": "Strunkovice nad Volyňkou",
        "popis": "[536784] Strunkovice nad Volyňkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536784,
        "val": "[536784] Strunkovice nad Volynkou 3111 [536784] Strunkovice nad Volyňkou"
    },
    {
        "kod": 551791,
        "nazev": "Střelské Hoštice",
        "popis": "[551791] Střelské Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551791,
        "val": "[551791] Strelske Hostice 3111 [551791] Střelské Hoštice"
    },
    {
        "kod": 551830,
        "nazev": "Škvořetice",
        "popis": "[551830] Škvořetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551830,
        "val": "[551830] Skvoretice 3101 [551830] Škvořetice"
    },
    {
        "kod": 536920,
        "nazev": "Štěchovice",
        "popis": "[536920] Štěchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536920,
        "val": "[536920] Stechovice 3111 [536920] Štěchovice"
    },
    {
        "kod": 551856,
        "nazev": "Štěkeň",
        "popis": "[551856] Štěkeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551856,
        "val": "[551856] Steken 3111 [551856] Štěkeň"
    },
    {
        "kod": 536598,
        "nazev": "Tchořovice",
        "popis": "[536598] Tchořovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536598,
        "val": "[536598] Tchorovice 3101 [536598] Tchořovice"
    },
    {
        "kod": 536512,
        "nazev": "Truskovice",
        "popis": "[536512] Truskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 536512,
        "val": "[536512] Truskovice 3117 [536512] Truskovice"
    },
    {
        "kod": 551899,
        "nazev": "Třebohostice",
        "popis": "[551899] Třebohostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551899,
        "val": "[551899] Trebohostice 3111 [551899] Třebohostice"
    },
    {
        "kod": 536679,
        "nazev": "Třešovice",
        "popis": "[536679] Třešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536679,
        "val": "[536679] Tresovice 3111 [536679] Třešovice"
    },
    {
        "kod": 536695,
        "nazev": "Úlehle",
        "popis": "[536695] Úlehle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536695,
        "val": "[536695] Ulehle 3111 [536695] Úlehle"
    },
    {
        "kod": 563951,
        "nazev": "Únice",
        "popis": "[563951] Únice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 563951,
        "val": "[563951] Unice 3111 [563951] Únice"
    },
    {
        "kod": 551937,
        "nazev": "Uzenice",
        "popis": "[551937] Uzenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551937,
        "val": "[551937] Uzenice 3101 [551937] Uzenice"
    },
    {
        "kod": 536890,
        "nazev": "Uzeničky",
        "popis": "[536890] Uzeničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536890,
        "val": "[536890] Uzenicky 3101 [536890] Uzeničky"
    },
    {
        "kod": 536504,
        "nazev": "Vacovice",
        "popis": "[536504] Vacovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536504,
        "val": "[536504] Vacovice 3111 [536504] Vacovice"
    },
    {
        "kod": 536741,
        "nazev": "Velká Turná",
        "popis": "[536741] Velká Turná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536741,
        "val": "[536741] Velka Turna 3111 [536741] Velká Turná"
    },
    {
        "kod": 551953,
        "nazev": "Vodňany",
        "popis": "[551953] Vodňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 551953,
        "val": "[551953] Vodnany 3117 [551953] Vodňany"
    },
    {
        "kod": 551961,
        "nazev": "Volenice",
        "popis": "[551961] Volenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551961,
        "val": "[551961] Volenice 3111 [551961] Volenice"
    },
    {
        "kod": 551970,
        "nazev": "Volyně",
        "popis": "[551970] Volyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551970,
        "val": "[551970] Volyne 3111 [551970] Volyně"
    },
    {
        "kod": 551988,
        "nazev": "Záboří",
        "popis": "[551988] Záboří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551988,
        "val": "[551988] Zabori 3101 [551988] Záboří"
    },
    {
        "kod": 536482,
        "nazev": "Zahorčice",
        "popis": "[536482] Zahorčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536482,
        "val": "[536482] Zahorcice 3111 [536482] Zahorčice"
    },
    {
        "kod": 536873,
        "nazev": "Zvotoky",
        "popis": "[536873] Zvotoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536873,
        "val": "[536873] Zvotoky 3111 [536873] Zvotoky"
    },
    {
        "kod": 563251,
        "nazev": "Balkova Lhota",
        "popis": "[563251] Balkova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563251,
        "val": "[563251] Balkova Lhota 3112 [563251] Balkova Lhota"
    },
    {
        "kod": 563366,
        "nazev": "Bečice",
        "popis": "[563366] Bečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563366,
        "val": "[563366] Becice 3112 [563366] Bečice"
    },
    {
        "kod": 552054,
        "nazev": "Bechyně",
        "popis": "[552054] Bechyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552054,
        "val": "[552054] Bechyne 3112 [552054] Bechyně"
    },
    {
        "kod": 560448,
        "nazev": "Běleč",
        "popis": "[560448] Běleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560448,
        "val": "[560448] Belec 3112 [560448] Běleč"
    },
    {
        "kod": 552097,
        "nazev": "Borkovice",
        "popis": "[552097] Borkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552097,
        "val": "[552097] Borkovice 3110 [552097] Borkovice"
    },
    {
        "kod": 552101,
        "nazev": "Borotín",
        "popis": "[552101] Borotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552101,
        "val": "[552101] Borotin 3112 [552101] Borotín"
    },
    {
        "kod": 552127,
        "nazev": "Bradáčov",
        "popis": "[552127] Bradáčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552127,
        "val": "[552127] Bradacov 3112 [552127] Bradáčov"
    },
    {
        "kod": 552135,
        "nazev": "Březnice",
        "popis": "[552135] Březnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552135,
        "val": "[552135] Breznice 3112 [552135] Březnice"
    },
    {
        "kod": 552143,
        "nazev": "Budislav",
        "popis": "[552143] Budislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552143,
        "val": "[552143] Budislav 3110 [552143] Budislav"
    },
    {
        "kod": 563722,
        "nazev": "Černýšovice",
        "popis": "[563722] Černýšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563722,
        "val": "[563722] Cernysovice 3112 [563722] Černýšovice"
    },
    {
        "kod": 552208,
        "nazev": "Dírná",
        "popis": "[552208] Dírná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552208,
        "val": "[552208] Dirna 3110 [552208] Dírná"
    },
    {
        "kod": 563650,
        "nazev": "Dlouhá Lhota",
        "popis": "[563650] Dlouhá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563650,
        "val": "[563650] Dlouha Lhota 3112 [563650] Dlouhá Lhota"
    },
    {
        "kod": 552224,
        "nazev": "Dobronice u Bechyně",
        "popis": "[552224] Dobronice u Bechyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552224,
        "val": "[552224] Dobronice u Bechyne 3112 [552224] Dobronice u Bechyně"
    },
    {
        "kod": 552241,
        "nazev": "Dolní Hořice",
        "popis": "[552241] Dolní Hořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552241,
        "val": "[552241] Dolni Horice 3112 [552241] Dolní Hořice"
    },
    {
        "kod": 560529,
        "nazev": "Dolní Hrachovice",
        "popis": "[560529] Dolní Hrachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560529,
        "val": "[560529] Dolni Hrachovice 3112 [560529] Dolní Hrachovice"
    },
    {
        "kod": 563765,
        "nazev": "Drahov",
        "popis": "[563765] Drahov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 563765,
        "val": "[563765] Drahov 3110 [563765] Drahov"
    },
    {
        "kod": 552275,
        "nazev": "Dráchov",
        "popis": "[552275] Dráchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552275,
        "val": "[552275] Drachov 3110 [552275] Dráchov"
    },
    {
        "kod": 552283,
        "nazev": "Dražice",
        "popis": "[552283] Dražice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552283,
        "val": "[552283] Drazice 3112 [552283] Dražice"
    },
    {
        "kod": 552291,
        "nazev": "Dražičky",
        "popis": "[552291] Dražičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552291,
        "val": "[552291] Drazicky 3112 [552291] Dražičky"
    },
    {
        "kod": 563307,
        "nazev": "Drhovice",
        "popis": "[563307] Drhovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563307,
        "val": "[563307] Drhovice 3112 [563307] Drhovice"
    },
    {
        "kod": 563625,
        "nazev": "Haškovcova Lhota",
        "popis": "[563625] Haškovcova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563625,
        "val": "[563625] Haskovcova Lhota 3112 [563625] Haškovcova Lhota"
    },
    {
        "kod": 560481,
        "nazev": "Hlasivo",
        "popis": "[560481] Hlasivo",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560481,
        "val": "[560481] Hlasivo 3112 [560481] Hlasivo"
    },
    {
        "kod": 552321,
        "nazev": "Hlavatce",
        "popis": "[552321] Hlavatce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552321,
        "val": "[552321] Hlavatce 3110 [552321] Hlavatce"
    },
    {
        "kod": 598992,
        "nazev": "Hodětín",
        "popis": "[598992] Hodětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 598992,
        "val": "[598992] Hodetin 3112 [598992] Hodětín"
    },
    {
        "kod": 562904,
        "nazev": "Hodonice",
        "popis": "[562904] Hodonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 562904,
        "val": "[562904] Hodonice 3112 [562904] Hodonice"
    },
    {
        "kod": 552453,
        "nazev": "Chotěmice",
        "popis": "[552453] Chotěmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552453,
        "val": "[552453] Chotemice 3110 [552453] Chotěmice"
    },
    {
        "kod": 552461,
        "nazev": "Chotoviny",
        "popis": "[552461] Chotoviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552461,
        "val": "[552461] Chotoviny 3112 [552461] Chotoviny"
    },
    {
        "kod": 552470,
        "nazev": "Choustník",
        "popis": "[552470] Choustník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552470,
        "val": "[552470] Choustnik 3112 [552470] Choustník"
    },
    {
        "kod": 563145,
        "nazev": "Chrbonín",
        "popis": "[563145] Chrbonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563145,
        "val": "[563145] Chrbonin 3112 [563145] Chrbonín"
    },
    {
        "kod": 552496,
        "nazev": "Chýnov",
        "popis": "[552496] Chýnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552496,
        "val": "[552496] Chynov 3112 [552496] Chýnov"
    },
    {
        "kod": 562963,
        "nazev": "Jedlany",
        "popis": "[562963] Jedlany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 562963,
        "val": "[562963] Jedlany 3112 [562963] Jedlany"
    },
    {
        "kod": 552534,
        "nazev": "Jistebnice",
        "popis": "[552534] Jistebnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552534,
        "val": "[552534] Jistebnice 3112 [552534] Jistebnice"
    },
    {
        "kod": 530042,
        "nazev": "Katov",
        "popis": "[530042] Katov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 530042,
        "val": "[530042] Katov 3110 [530042] Katov"
    },
    {
        "kod": 563986,
        "nazev": "Klenovice",
        "popis": "[563986] Klenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 563986,
        "val": "[563986] Klenovice 3110 [563986] Klenovice"
    },
    {
        "kod": 599280,
        "nazev": "Komárov",
        "popis": "[599280] Komárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 599280,
        "val": "[599280] Komarov 3110 [599280] Komárov"
    },
    {
        "kod": 552585,
        "nazev": "Košice",
        "popis": "[552585] Košice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552585,
        "val": "[552585] Kosice 3112 [552585] Košice"
    },
    {
        "kod": 562955,
        "nazev": "Košín",
        "popis": "[562955] Košín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 562955,
        "val": "[562955] Kosin 3112 [562955] Košín"
    },
    {
        "kod": 560634,
        "nazev": "Krátošice",
        "popis": "[560634] Krátošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560634,
        "val": "[560634] Kratosice 3112 [560634] Krátošice"
    },
    {
        "kod": 563030,
        "nazev": "Krtov",
        "popis": "[563030] Krtov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563030,
        "val": "[563030] Krtov 3112 [563030] Krtov"
    },
    {
        "kod": 563544,
        "nazev": "Libějice",
        "popis": "[563544] Libějice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563544,
        "val": "[563544] Libejice 3112 [563544] Libějice"
    },
    {
        "kod": 563587,
        "nazev": "Lom",
        "popis": "[563587] Lom",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563587,
        "val": "[563587] Lom 3112 [563587] Lom"
    },
    {
        "kod": 552666,
        "nazev": "Malšice",
        "popis": "[552666] Malšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552666,
        "val": "[552666] Malsice 3112 [552666] Malšice"
    },
    {
        "kod": 562866,
        "nazev": "Mažice",
        "popis": "[562866] Mažice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 562866,
        "val": "[562866] Mazice 3110 [562866] Mažice"
    },
    {
        "kod": 563234,
        "nazev": "Meziříčí",
        "popis": "[563234] Meziříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563234,
        "val": "[563234] Mezirici 3112 [563234] Meziříčí"
    },
    {
        "kod": 599255,
        "nazev": "Mezná",
        "popis": "[599255] Mezná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 599255,
        "val": "[599255] Mezna 3110 [599255] Mezná"
    },
    {
        "kod": 552704,
        "nazev": "Mladá Vožice",
        "popis": "[552704] Mladá Vožice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552704,
        "val": "[552704] Mlada Vozice 3112 [552704] Mladá Vožice"
    },
    {
        "kod": 552712,
        "nazev": "Mlýny",
        "popis": "[552712] Mlýny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552712,
        "val": "[552712] Mlyny 3112 [552712] Mlýny"
    },
    {
        "kod": 552721,
        "nazev": "Myslkovice",
        "popis": "[552721] Myslkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552721,
        "val": "[552721] Myslkovice 3110 [552721] Myslkovice"
    },
    {
        "kod": 549631,
        "nazev": "Nadějkov",
        "popis": "[549631] Nadějkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 549631,
        "val": "[549631] Nadejkov 3112 [549631] Nadějkov"
    },
    {
        "kod": 559016,
        "nazev": "Nasavrky",
        "popis": "[559016] Nasavrky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 559016,
        "val": "[559016] Nasavrky 3112 [559016] Nasavrky"
    },
    {
        "kod": 552747,
        "nazev": "Nemyšl",
        "popis": "[552747] Nemyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552747,
        "val": "[552747] Nemysl 3112 [552747] Nemyšl"
    },
    {
        "kod": 552763,
        "nazev": "Nová Ves u Chýnova",
        "popis": "[552763] Nová Ves u Chýnova",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552763,
        "val": "[552763] Nova Ves u Chynova 3112 [552763] Nová Ves u Chýnova"
    },
    {
        "kod": 563455,
        "nazev": "Nová Ves u Mladé Vožice",
        "popis": "[563455] Nová Ves u Mladé Vožice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563455,
        "val": "[563455] Nova Ves u Mlade Vozice 3112 [563455] Nová Ves u Mladé Vožice"
    },
    {
        "kod": 552798,
        "nazev": "Oldřichov",
        "popis": "[552798] Oldřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552798,
        "val": "[552798] Oldrichov 3112 [552798] Oldřichov"
    },
    {
        "kod": 552801,
        "nazev": "Opařany",
        "popis": "[552801] Opařany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552801,
        "val": "[552801] Oparany 3112 [552801] Opařany"
    },
    {
        "kod": 552828,
        "nazev": "Planá nad Lužnicí",
        "popis": "[552828] Planá nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552828,
        "val": "[552828] Plana nad Luznici 3112 [552828] Planá nad Lužnicí"
    },
    {
        "kod": 560553,
        "nazev": "Pohnánec",
        "popis": "[560553] Pohnánec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560553,
        "val": "[560553] Pohnanec 3112 [560553] Pohnánec"
    },
    {
        "kod": 565423,
        "nazev": "Bdín",
        "popis": "[565423] Bdín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565423,
        "val": "[565423] Bdin 2121 [565423] Bdín"
    },
    {
        "kod": 541672,
        "nazev": "Branov",
        "popis": "[541672] Branov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541672,
        "val": "[541672] Branov 2121 [541672] Branov"
    },
    {
        "kod": 565041,
        "nazev": "Břežany",
        "popis": "[565041] Břežany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565041,
        "val": "[565041] Brezany 2121 [565041] Břežany"
    },
    {
        "kod": 541699,
        "nazev": "Čistá",
        "popis": "[541699] Čistá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541699,
        "val": "[541699] Cista 2121 [541699] Čistá"
    },
    {
        "kod": 565181,
        "nazev": "Děkov",
        "popis": "[565181] Děkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565181,
        "val": "[565181] Dekov 2121 [565181] Děkov"
    },
    {
        "kod": 529711,
        "nazev": "Drahouš",
        "popis": "[529711] Drahouš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 529711,
        "val": "[529711] Drahous 2121 [529711] Drahouš"
    },
    {
        "kod": 541729,
        "nazev": "Hořesedly",
        "popis": "[541729] Hořesedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541729,
        "val": "[541729] Horesedly 2121 [541729] Hořesedly"
    },
    {
        "kod": 541737,
        "nazev": "Hořovičky",
        "popis": "[541737] Hořovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541737,
        "val": "[541737] Horovicky 2121 [541737] Hořovičky"
    },
    {
        "kod": 565202,
        "nazev": "Hracholusky",
        "popis": "[565202] Hracholusky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565202,
        "val": "[565202] Hracholusky 2121 [565202] Hracholusky"
    },
    {
        "kod": 541761,
        "nazev": "Hřebečníky",
        "popis": "[541761] Hřebečníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541761,
        "val": "[541761] Hrebecniky 2121 [541761] Hřebečníky"
    },
    {
        "kod": 541770,
        "nazev": "Hředle",
        "popis": "[541770] Hředle",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541770,
        "val": "[541770] Hredle 2121 [541770] Hředle"
    },
    {
        "kod": 565334,
        "nazev": "Hvozd",
        "popis": "[565334] Hvozd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565334,
        "val": "[565334] Hvozd 2121 [565334] Hvozd"
    },
    {
        "kod": 541818,
        "nazev": "Chrášťany",
        "popis": "[541818] Chrášťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541818,
        "val": "[541818] Chrastany 2121 [541818] Chrášťany"
    },
    {
        "kod": 565270,
        "nazev": "Janov",
        "popis": "[565270] Janov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565270,
        "val": "[565270] Janov 2121 [565270] Janov"
    },
    {
        "kod": 541834,
        "nazev": "Jesenice",
        "popis": "[541834] Jesenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541834,
        "val": "[541834] Jesenice 2121 [541834] Jesenice"
    },
    {
        "kod": 565440,
        "nazev": "Kalivody",
        "popis": "[565440] Kalivody",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565440,
        "val": "[565440] Kalivody 2121 [565440] Kalivody"
    },
    {
        "kod": 565288,
        "nazev": "Karlova Ves",
        "popis": "[565288] Karlova Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565288,
        "val": "[565288] Karlova Ves 2121 [565288] Karlova Ves"
    },
    {
        "kod": 541877,
        "nazev": "Kněževes",
        "popis": "[541877] Kněževes",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541877,
        "val": "[541877] Knezeves 2121 [541877] Kněževes"
    },
    {
        "kod": 565199,
        "nazev": "Kolešov",
        "popis": "[565199] Kolešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565199,
        "val": "[565199] Kolesov 2121 [565199] Kolešov"
    },
    {
        "kod": 541893,
        "nazev": "Kolešovice",
        "popis": "[541893] Kolešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541893,
        "val": "[541893] Kolesovice 2121 [541893] Kolešovice"
    },
    {
        "kod": 541907,
        "nazev": "Kounov",
        "popis": "[541907] Kounov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541907,
        "val": "[541907] Kounov 2121 [541907] Kounov"
    },
    {
        "kod": 565385,
        "nazev": "Kozojedy",
        "popis": "[565385] Kozojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565385,
        "val": "[565385] Kozojedy 2121 [565385] Kozojedy"
    },
    {
        "kod": 565351,
        "nazev": "Krakov",
        "popis": "[565351] Krakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565351,
        "val": "[565351] Krakov 2121 [565351] Krakov"
    },
    {
        "kod": 565369,
        "nazev": "Krakovec",
        "popis": "[565369] Krakovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565369,
        "val": "[565369] Krakovec 2121 [565369] Krakovec"
    },
    {
        "kod": 541940,
        "nazev": "Kroučová",
        "popis": "[541940] Kroučová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541940,
        "val": "[541940] Kroucova 2121 [541940] Kroučová"
    },
    {
        "kod": 598500,
        "nazev": "Krty",
        "popis": "[598500] Krty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598500,
        "val": "[598500] Krty 2121 [598500] Krty"
    },
    {
        "kod": 541966,
        "nazev": "Krupá",
        "popis": "[541966] Krupá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541966,
        "val": "[541966] Krupa 2121 [541966] Krupá"
    },
    {
        "kod": 541974,
        "nazev": "Krušovice",
        "popis": "[541974] Krušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541974,
        "val": "[541974] Krusovice 2121 [541974] Krušovice"
    },
    {
        "kod": 541982,
        "nazev": "Křivoklát",
        "popis": "[541982] Křivoklát",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541982,
        "val": "[541982] Krivoklat 2121 [541982] Křivoklát"
    },
    {
        "kod": 542008,
        "nazev": "Lašovice",
        "popis": "[542008] Lašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542008,
        "val": "[542008] Lasovice 2121 [542008] Lašovice"
    },
    {
        "kod": 542016,
        "nazev": "Lišany",
        "popis": "[542016] Lišany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542016,
        "val": "[542016] Lisany 2121 [542016] Lišany"
    },
    {
        "kod": 542032,
        "nazev": "Lubná",
        "popis": "[542032] Lubná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542032,
        "val": "[542032] Lubna 2121 [542032] Lubná"
    },
    {
        "kod": 542041,
        "nazev": "Lužná",
        "popis": "[542041] Lužná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542041,
        "val": "[542041] Luzna 2121 [542041] Lužná"
    },
    {
        "kod": 565377,
        "nazev": "Malinová",
        "popis": "[565377] Malinová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565377,
        "val": "[565377] Malinova 2121 [565377] Malinová"
    },
    {
        "kod": 542067,
        "nazev": "Městečko",
        "popis": "[542067] Městečko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542067,
        "val": "[542067] Mestecko 2121 [542067] Městečko"
    },
    {
        "kod": 542075,
        "nazev": "Milostín",
        "popis": "[542075] Milostín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542075,
        "val": "[542075] Milostin 2121 [542075] Milostín"
    },
    {
        "kod": 565466,
        "nazev": "Milý",
        "popis": "[565466] Milý",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565466,
        "val": "[565466] Mily 2121 [565466] Milý"
    },
    {
        "kod": 542105,
        "nazev": "Mšec",
        "popis": "[542105] Mšec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542105,
        "val": "[542105] Msec 2121 [542105] Mšec"
    },
    {
        "kod": 542113,
        "nazev": "Mšecké Žehrovice",
        "popis": "[542113] Mšecké Žehrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542113,
        "val": "[542113] Msecke Zehrovice 2121 [542113] Mšecké Žehrovice"
    },
    {
        "kod": 542121,
        "nazev": "Mutějovice",
        "popis": "[542121] Mutějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542121,
        "val": "[542121] Mutejovice 2121 [542121] Mutějovice"
    },
    {
        "kod": 542130,
        "nazev": "Nesuchyně",
        "popis": "[542130] Nesuchyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542130,
        "val": "[542130] Nesuchyne 2121 [542130] Nesuchyně"
    },
    {
        "kod": 598585,
        "nazev": "Nezabudice",
        "popis": "[598585] Nezabudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598585,
        "val": "[598585] Nezabudice 2121 [598585] Nezabudice"
    },
    {
        "kod": 542164,
        "nazev": "Nové Strašecí",
        "popis": "[542164] Nové Strašecí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542164,
        "val": "[542164] Nove Straseci 2121 [542164] Nové Strašecí"
    },
    {
        "kod": 542181,
        "nazev": "Nový Dům",
        "popis": "[542181] Nový Dům",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542181,
        "val": "[542181] Novy Dum 2121 [542181] Nový Dům"
    },
    {
        "kod": 542199,
        "nazev": "Olešná",
        "popis": "[542199] Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542199,
        "val": "[542199] Olesna 2121 [542199] Olešná"
    },
    {
        "kod": 542202,
        "nazev": "Oráčov",
        "popis": "[542202] Oráčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542202,
        "val": "[542202] Oracov 2121 [542202] Oráčov"
    },
    {
        "kod": 542211,
        "nazev": "Panoší Újezd",
        "popis": "[542211] Panoší Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542211,
        "val": "[542211] Panosi Ujezd 2121 [542211] Panoší Újezd"
    },
    {
        "kod": 544248,
        "nazev": "Pavlíkov",
        "popis": "[544248] Pavlíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 544248,
        "val": "[544248] Pavlikov 2121 [544248] Pavlíkov"
    },
    {
        "kod": 542229,
        "nazev": "Petrovice",
        "popis": "[542229] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542229,
        "val": "[542229] Petrovice 2121 [542229] Petrovice"
    },
    {
        "kod": 542237,
        "nazev": "Pochvalov",
        "popis": "[542237] Pochvalov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542237,
        "val": "[542237] Pochvalov 2121 [542237] Pochvalov"
    },
    {
        "kod": 598577,
        "nazev": "Přerubenice",
        "popis": "[598577] Přerubenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598577,
        "val": "[598577] Prerubenice 2121 [598577] Přerubenice"
    },
    {
        "kod": 542253,
        "nazev": "Příčina",
        "popis": "[542253] Příčina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542253,
        "val": "[542253] Pricina 2121 [542253] Příčina"
    },
    {
        "kod": 565261,
        "nazev": "Přílepy",
        "popis": "[565261] Přílepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565261,
        "val": "[565261] Prilepy 2121 [565261] Přílepy"
    },
    {
        "kod": 542270,
        "nazev": "Pšovlky",
        "popis": "[542270] Pšovlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542270,
        "val": "[542270] Psovlky 2121 [542270] Pšovlky"
    },
    {
        "kod": 542288,
        "nazev": "Pustověty",
        "popis": "[542288] Pustověty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542288,
        "val": "[542288] Pustovety 2121 [542288] Pustověty"
    },
    {
        "kod": 599760,
        "nazev": "Račice",
        "popis": "[599760] Račice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 599760,
        "val": "[599760] Racice 2121 [599760] Račice"
    },
    {
        "kod": 541656,
        "nazev": "Rakovník",
        "popis": "[541656] Rakovník",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 541656,
        "val": "[541656] Rakovnik 2121 [541656] Rakovník"
    },
    {
        "kod": 598526,
        "nazev": "Roztoky",
        "popis": "[598526] Roztoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598526,
        "val": "[598526] Roztoky 2121 [598526] Roztoky"
    },
    {
        "kod": 542326,
        "nazev": "Ruda",
        "popis": "[542326] Ruda",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542326,
        "val": "[542326] Ruda 2121 [542326] Ruda"
    },
    {
        "kod": 542334,
        "nazev": "Rynholec",
        "popis": "[542334] Rynholec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542334,
        "val": "[542334] Rynholec 2121 [542334] Rynholec"
    },
    {
        "kod": 565504,
        "nazev": "Řeřichy",
        "popis": "[565504] Řeřichy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565504,
        "val": "[565504] Rerichy 2121 [565504] Řeřichy"
    },
    {
        "kod": 542351,
        "nazev": "Řevničov",
        "popis": "[542351] Řevničov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542351,
        "val": "[542351] Revnicov 2121 [542351] Řevničov"
    },
    {
        "kod": 542369,
        "nazev": "Senec",
        "popis": "[542369] Senec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542369,
        "val": "[542369] Senec 2121 [542369] Senec"
    },
    {
        "kod": 542377,
        "nazev": "Senomaty",
        "popis": "[542377] Senomaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542377,
        "val": "[542377] Senomaty 2121 [542377] Senomaty"
    },
    {
        "kod": 542385,
        "nazev": "Skryje",
        "popis": "[542385] Skryje",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542385,
        "val": "[542385] Skryje 2121 [542385] Skryje"
    },
    {
        "kod": 542415,
        "nazev": "Slabce",
        "popis": "[542415] Slabce",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542415,
        "val": "[542415] Slabce 2121 [542415] Slabce"
    },
    {
        "kod": 565407,
        "nazev": "Smilovice",
        "popis": "[565407] Smilovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565407,
        "val": "[565407] Smilovice 2121 [565407] Smilovice"
    },
    {
        "kod": 542431,
        "nazev": "Srbeč",
        "popis": "[542431] Srbeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542431,
        "val": "[542431] Srbec 2121 [542431] Srbeč"
    },
    {
        "kod": 542458,
        "nazev": "Svojetín",
        "popis": "[542458] Svojetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542458,
        "val": "[542458] Svojetin 2121 [542458] Svojetín"
    },
    {
        "kod": 542466,
        "nazev": "Sýkořice",
        "popis": "[542466] Sýkořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542466,
        "val": "[542466] Sykorice 2121 [542466] Sýkořice"
    },
    {
        "kod": 542474,
        "nazev": "Šanov",
        "popis": "[542474] Šanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542474,
        "val": "[542474] Sanov 2121 [542474] Šanov"
    },
    {
        "kod": 598496,
        "nazev": "Šípy",
        "popis": "[598496] Šípy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598496,
        "val": "[598496] Sipy 2121 [598496] Šípy"
    },
    {
        "kod": 565326,
        "nazev": "Švihov",
        "popis": "[565326] Švihov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565326,
        "val": "[565326] Svihov 2121 [565326] Švihov"
    },
    {
        "kod": 542504,
        "nazev": "Třeboc",
        "popis": "[542504] Třeboc",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542504,
        "val": "[542504] Treboc 2121 [542504] Třeboc"
    },
    {
        "kod": 542512,
        "nazev": "Třtice",
        "popis": "[542512] Třtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542512,
        "val": "[542512] Trtice 2121 [542512] Třtice"
    },
    {
        "kod": 565512,
        "nazev": "Václavy",
        "popis": "[565512] Václavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565512,
        "val": "[565512] Vaclavy 2121 [565512] Václavy"
    },
    {
        "kod": 542563,
        "nazev": "Velká Buková",
        "popis": "[542563] Velká Buková",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542563,
        "val": "[542563] Velka Bukova 2121 [542563] Velká Buková"
    },
    {
        "kod": 529699,
        "nazev": "Velká Chmelištná",
        "popis": "[529699] Velká Chmelištná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 529699,
        "val": "[529699] Velka Chmelistna 2121 [529699] Velká Chmelištná"
    },
    {
        "kod": 565130,
        "nazev": "Všesulov",
        "popis": "[565130] Všesulov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 565130,
        "val": "[565130] Vsesulov 2121 [565130] Všesulov"
    },
    {
        "kod": 542598,
        "nazev": "Všetaty",
        "popis": "[542598] Všetaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542598,
        "val": "[542598] Vsetaty 2121 [542598] Všetaty"
    },
    {
        "kod": 542601,
        "nazev": "Zavidov",
        "popis": "[542601] Zavidov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542601,
        "val": "[542601] Zavidov 2121 [542601] Zavidov"
    },
    {
        "kod": 542610,
        "nazev": "Zbečno",
        "popis": "[542610] Zbečno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 542610,
        "val": "[542610] Zbecno 2121 [542610] Zbečno"
    },
    {
        "kod": 598518,
        "nazev": "Žďár",
        "popis": "[598518] Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 2121,
        "iczuj": 598518,
        "val": "[598518] Zdar 2121 [598518] Žďár"
    },
    {
        "kod": 535826,
        "nazev": "Adamov",
        "popis": "[535826] Adamov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535826,
        "val": "[535826] Adamov 3102 [535826] Adamov"
    },
    {
        "kod": 536156,
        "nazev": "Bečice",
        "popis": "[536156] Bečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 536156,
        "val": "[536156] Becice 3115 [536156] Bečice"
    },
    {
        "kod": 544272,
        "nazev": "Borek",
        "popis": "[544272] Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544272,
        "val": "[544272] Borek 3102 [544272] Borek"
    },
    {
        "kod": 544281,
        "nazev": "Borovany",
        "popis": "[544281] Borovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544281,
        "val": "[544281] Borovany 3113 [544281] Borovany"
    },
    {
        "kod": 535681,
        "nazev": "Borovnice",
        "popis": "[535681] Borovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535681,
        "val": "[535681] Borovnice 3102 [535681] Borovnice"
    },
    {
        "kod": 544299,
        "nazev": "Boršov nad Vltavou",
        "popis": "[544299] Boršov nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544299,
        "val": "[544299] Borsov nad Vltavou 3102 [544299] Boršov nad Vltavou"
    },
    {
        "kod": 535401,
        "nazev": "Bošilec",
        "popis": "[535401] Bošilec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535401,
        "val": "[535401] Bosilec 3102 [535401] Bošilec"
    },
    {
        "kod": 551490,
        "nazev": "Branišov",
        "popis": "[551490] Branišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 551490,
        "val": "[551490] Branisov 3102 [551490] Branišov"
    },
    {
        "kod": 536059,
        "nazev": "Břehov",
        "popis": "[536059] Břehov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 536059,
        "val": "[536059] Brehov 3102 [536059] Břehov"
    },
    {
        "kod": 535541,
        "nazev": "Čakov",
        "popis": "[535541] Čakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535541,
        "val": "[535541] Cakov 3102 [535541] Čakov"
    },
    {
        "kod": 544329,
        "nazev": "Čejkovice",
        "popis": "[544329] Čejkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544329,
        "val": "[544329] Cejkovice 3102 [544329] Čejkovice"
    },
    {
        "kod": 598976,
        "nazev": "Čenkov u Bechyně",
        "popis": "[598976] Čenkov u Bechyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 598976,
        "val": "[598976] Cenkov u Bechyne 3115 [598976] Čenkov u Bechyně"
    },
    {
        "kod": 544256,
        "nazev": "České Budějovice",
        "popis": "[544256] České Budějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544256,
        "val": "[544256] Ceske Budejovice 3102 [544256] České Budějovice"
    },
    {
        "kod": 551503,
        "nazev": "Čížkrajice",
        "popis": "[551503] Čížkrajice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 551503,
        "val": "[551503] Cizkrajice 3113 [551503] Čížkrajice"
    },
    {
        "kod": 535249,
        "nazev": "Dasný",
        "popis": "[535249] Dasný",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535249,
        "val": "[535249] Dasny 3102 [535249] Dasný"
    },
    {
        "kod": 544361,
        "nazev": "Dívčice",
        "popis": "[544361] Dívčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544361,
        "val": "[544361] Divcice 3102 [544361] Dívčice"
    },
    {
        "kod": 535206,
        "nazev": "Dobrá Voda u Českých Budějovic",
        "popis": "[535206] Dobrá Voda u Českých Budějovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535206,
        "val": "[535206] Dobra Voda u Ceskych Budejovic 3102 [535206] Dobrá Voda u Českých Budějovic"
    },
    {
        "kod": 536199,
        "nazev": "Dobšice",
        "popis": "[536199] Dobšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 536199,
        "val": "[536199] Dobsice 3115 [536199] Dobšice"
    },
    {
        "kod": 544388,
        "nazev": "Dolní Bukovsko",
        "popis": "[544388] Dolní Bukovsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 544388,
        "val": "[544388] Dolni Bukovsko 3115 [544388] Dolní Bukovsko"
    },
    {
        "kod": 535664,
        "nazev": "Doubravice",
        "popis": "[535664] Doubravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535664,
        "val": "[535664] Doubravice 3102 [535664] Doubravice"
    },
    {
        "kod": 544400,
        "nazev": "Doudleby",
        "popis": "[544400] Doudleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544400,
        "val": "[544400] Doudleby 3102 [544400] Doudleby"
    },
    {
        "kod": 535958,
        "nazev": "Drahotěšice",
        "popis": "[535958] Drahotěšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535958,
        "val": "[535958] Drahotesice 3102 [535958] Drahotěšice"
    },
    {
        "kod": 549371,
        "nazev": "Dražíč",
        "popis": "[549371] Dražíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 549371,
        "val": "[549371] Drazic 3115 [549371] Dražíč"
    },
    {
        "kod": 544426,
        "nazev": "Dříteň",
        "popis": "[544426] Dříteň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544426,
        "val": "[544426] Driten 3102 [544426] Dříteň"
    },
    {
        "kod": 535788,
        "nazev": "Dubičné",
        "popis": "[535788] Dubičné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535788,
        "val": "[535788] Dubicne 3102 [535788] Dubičné"
    },
    {
        "kod": 544442,
        "nazev": "Dubné",
        "popis": "[544442] Dubné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544442,
        "val": "[544442] Dubne 3102 [544442] Dubné"
    },
    {
        "kod": 544451,
        "nazev": "Dynín",
        "popis": "[544451] Dynín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544451,
        "val": "[544451] Dynin 3102 [544451] Dynín"
    },
    {
        "kod": 535575,
        "nazev": "Habří",
        "popis": "[535575] Habří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535575,
        "val": "[535575] Habri 3102 [535575] Habří"
    },
    {
        "kod": 536075,
        "nazev": "Hartmanice",
        "popis": "[536075] Hartmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 536075,
        "val": "[536075] Hartmanice 3115 [536075] Hartmanice"
    },
    {
        "kod": 598593,
        "nazev": "Heřmaň",
        "popis": "[598593] Heřmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 598593,
        "val": "[598593] Herman 3102 [598593] Heřmaň"
    },
    {
        "kod": 535851,
        "nazev": "Hlavatce",
        "popis": "[535851] Hlavatce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535851,
        "val": "[535851] Hlavatce 3102 [535851] Hlavatce"
    },
    {
        "kod": 598607,
        "nazev": "Hlincová Hora",
        "popis": "[598607] Hlincová Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 598607,
        "val": "[598607] Hlincova Hora 3102 [598607] Hlincová Hora"
    },
    {
        "kod": 544485,
        "nazev": "Hluboká nad Vltavou",
        "popis": "[544485] Hluboká nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544485,
        "val": "[544485] Hluboka nad Vltavou 3102 [544485] Hluboká nad Vltavou"
    },
    {
        "kod": 544493,
        "nazev": "Homole",
        "popis": "[544493] Homole",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544493,
        "val": "[544493] Homole 3102 [544493] Homole"
    },
    {
        "kod": 536105,
        "nazev": "Horní Kněžeklady",
        "popis": "[536105] Horní Kněžeklady",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 536105,
        "val": "[536105] Horni Knezeklady 3115 [536105] Horní Kněžeklady"
    },
    {
        "kod": 544515,
        "nazev": "Horní Stropnice",
        "popis": "[544515] Horní Stropnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544515,
        "val": "[544515] Horni Stropnice 3113 [544515] Horní Stropnice"
    },
    {
        "kod": 544523,
        "nazev": "Hosín",
        "popis": "[544523] Hosín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544523,
        "val": "[544523] Hosin 3102 [544523] Hosín"
    },
    {
        "kod": 535524,
        "nazev": "Hosty",
        "popis": "[535524] Hosty",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 535524,
        "val": "[535524] Hosty 3115 [535524] Hosty"
    },
    {
        "kod": 535460,
        "nazev": "Hradce",
        "popis": "[535460] Hradce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535460,
        "val": "[535460] Hradce 3102 [535460] Hradce"
    },
    {
        "kod": 544540,
        "nazev": "Hranice",
        "popis": "[544540] Hranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544540,
        "val": "[544540] Hranice 3113 [544540] Hranice"
    },
    {
        "kod": 544558,
        "nazev": "Hrdějovice",
        "popis": "[544558] Hrdějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544558,
        "val": "[544558] Hrdejovice 3102 [544558] Hrdějovice"
    },
    {
        "kod": 535753,
        "nazev": "Hůry",
        "popis": "[535753] Hůry",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535753,
        "val": "[535753] Hury 3102 [535753] Hůry"
    },
    {
        "kod": 535613,
        "nazev": "Hvozdec",
        "popis": "[535613] Hvozdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535613,
        "val": "[535613] Hvozdec 3102 [535613] Hvozdec"
    },
    {
        "kod": 535907,
        "nazev": "Chotýčany",
        "popis": "[535907] Chotýčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535907,
        "val": "[535907] Chotycany 3102 [535907] Chotýčany"
    },
    {
        "kod": 544591,
        "nazev": "Chrášťany",
        "popis": "[544591] Chrášťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 544591,
        "val": "[544591] Chrastany 3115 [544591] Chrášťany"
    },
    {
        "kod": 544612,
        "nazev": "Jankov",
        "popis": "[544612] Jankov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544612,
        "val": "[544612] Jankov 3102 [544612] Jankov"
    },
    {
        "kod": 544639,
        "nazev": "Jílovice",
        "popis": "[544639] Jílovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544639,
        "val": "[544639] Jilovice 3113 [544639] Jílovice"
    },
    {
        "kod": 535761,
        "nazev": "Jivno",
        "popis": "[535761] Jivno",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535761,
        "val": "[535761] Jivno 3102 [535761] Jivno"
    },
    {
        "kod": 535982,
        "nazev": "Kamenná",
        "popis": "[535982] Kamenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 535982,
        "val": "[535982] Kamenna 3113 [535982] Kamenná"
    },
    {
        "kod": 544663,
        "nazev": "Kamenný Újezd",
        "popis": "[544663] Kamenný Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544663,
        "val": "[544663] Kamenny Ujezd 3102 [544663] Kamenný Újezd"
    },
    {
        "kod": 538477,
        "nazev": "Měšice",
        "popis": "[538477] Měšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538477,
        "val": "[538477] Mesice 2103 [538477] Měšice"
    },
    {
        "kod": 538485,
        "nazev": "Mirošovice",
        "popis": "[538485] Mirošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538485,
        "val": "[538485] Mirosovice 2122 [538485] Mirošovice"
    },
    {
        "kod": 538493,
        "nazev": "Mnichovice",
        "popis": "[538493] Mnichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538493,
        "val": "[538493] Mnichovice 2122 [538493] Mnichovice"
    },
    {
        "kod": 598267,
        "nazev": "Modletice",
        "popis": "[598267] Modletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 598267,
        "val": "[598267] Modletice 2122 [598267] Modletice"
    },
    {
        "kod": 538507,
        "nazev": "Mochov",
        "popis": "[538507] Mochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538507,
        "val": "[538507] Mochov 2103 [538507] Mochov"
    },
    {
        "kod": 538515,
        "nazev": "Mratín",
        "popis": "[538515] Mratín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538515,
        "val": "[538515] Mratin 2103 [538515] Mratín"
    },
    {
        "kod": 538523,
        "nazev": "Mukařov",
        "popis": "[538523] Mukařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538523,
        "val": "[538523] Mukarov 2122 [538523] Mukařov"
    },
    {
        "kod": 538540,
        "nazev": "Nehvizdy",
        "popis": "[538540] Nehvizdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538540,
        "val": "[538540] Nehvizdy 2103 [538540] Nehvizdy"
    },
    {
        "kod": 538558,
        "nazev": "Nová Ves",
        "popis": "[538558] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538558,
        "val": "[538558] Nova Ves 2103 [538558] Nová Ves"
    },
    {
        "kod": 538566,
        "nazev": "Nový Vestec",
        "popis": "[538566] Nový Vestec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538566,
        "val": "[538566] Novy Vestec 2103 [538566] Nový Vestec"
    },
    {
        "kod": 533548,
        "nazev": "Nučice",
        "popis": "[533548] Nučice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533548,
        "val": "[533548] Nucice 2122 [533548] Nučice"
    },
    {
        "kod": 564907,
        "nazev": "Nupaky",
        "popis": "[564907] Nupaky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564907,
        "val": "[564907] Nupaky 2122 [564907] Nupaky"
    },
    {
        "kod": 538574,
        "nazev": "Odolena Voda",
        "popis": "[538574] Odolena Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538574,
        "val": "[538574] Odolena Voda 2103 [538574] Odolena Voda"
    },
    {
        "kod": 533564,
        "nazev": "Oleška",
        "popis": "[533564] Oleška",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533564,
        "val": "[533564] Oleska 2122 [533564] Oleška"
    },
    {
        "kod": 538582,
        "nazev": "Ondřejov",
        "popis": "[538582] Ondřejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538582,
        "val": "[538582] Ondrejov 2122 [538582] Ondřejov"
    },
    {
        "kod": 571679,
        "nazev": "Oplany",
        "popis": "[571679] Oplany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 571679,
        "val": "[571679] Oplany 2122 [571679] Oplany"
    },
    {
        "kod": 538604,
        "nazev": "Panenské Břežany",
        "popis": "[538604] Panenské Břežany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538604,
        "val": "[538604] Panenske Brezany 2103 [538604] Panenské Břežany"
    },
    {
        "kod": 529656,
        "nazev": "Pětihosty",
        "popis": "[529656] Pětihosty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 529656,
        "val": "[529656] Petihosty 2122 [529656] Pětihosty"
    },
    {
        "kod": 538612,
        "nazev": "Petříkov",
        "popis": "[538612] Petříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538612,
        "val": "[538612] Petrikov 2122 [538612] Petříkov"
    },
    {
        "kod": 538621,
        "nazev": "Podolanka",
        "popis": "[538621] Podolanka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538621,
        "val": "[538621] Podolanka 2103 [538621] Podolanka"
    },
    {
        "kod": 538639,
        "nazev": "Polerady",
        "popis": "[538639] Polerady",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538639,
        "val": "[538639] Polerady 2103 [538639] Polerady"
    },
    {
        "kod": 599221,
        "nazev": "Popovičky",
        "popis": "[599221] Popovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 599221,
        "val": "[599221] Popovicky 2122 [599221] Popovičky"
    },
    {
        "kod": 564788,
        "nazev": "Prusice",
        "popis": "[564788] Prusice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564788,
        "val": "[564788] Prusice 2122 [564788] Prusice"
    },
    {
        "kod": 538655,
        "nazev": "Předboj",
        "popis": "[538655] Předboj",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538655,
        "val": "[538655] Predboj 2103 [538655] Předboj"
    },
    {
        "kod": 538671,
        "nazev": "Přezletice",
        "popis": "[538671] Přezletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538671,
        "val": "[538671] Prezletice 2103 [538671] Přezletice"
    },
    {
        "kod": 538698,
        "nazev": "Radějovice",
        "popis": "[538698] Radějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538698,
        "val": "[538698] Radejovice 2122 [538698] Radějovice"
    },
    {
        "kod": 538701,
        "nazev": "Radonice",
        "popis": "[538701] Radonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538701,
        "val": "[538701] Radonice 2103 [538701] Radonice"
    },
    {
        "kod": 538728,
        "nazev": "Říčany",
        "popis": "[538728] Říčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538728,
        "val": "[538728] Ricany 2122 [538728] Říčany"
    },
    {
        "kod": 598283,
        "nazev": "Sedlec",
        "popis": "[598283] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 598283,
        "val": "[598283] Sedlec 2103 [598283] Sedlec"
    },
    {
        "kod": 538752,
        "nazev": "Senohraby",
        "popis": "[538752] Senohraby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538752,
        "val": "[538752] Senohraby 2122 [538752] Senohraby"
    },
    {
        "kod": 538761,
        "nazev": "Sibřina",
        "popis": "[538761] Sibřina",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538761,
        "val": "[538761] Sibrina 2103 [538761] Sibřina"
    },
    {
        "kod": 538779,
        "nazev": "Sluhy",
        "popis": "[538779] Sluhy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538779,
        "val": "[538779] Sluhy 2103 [538779] Sluhy"
    },
    {
        "kod": 538787,
        "nazev": "Sluštice",
        "popis": "[538787] Sluštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538787,
        "val": "[538787] Slustice 2122 [538787] Sluštice"
    },
    {
        "kod": 538809,
        "nazev": "Strančice",
        "popis": "[538809] Strančice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538809,
        "val": "[538809] Strancice 2122 [538809] Strančice"
    },
    {
        "kod": 538825,
        "nazev": "Struhařov",
        "popis": "[538825] Struhařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538825,
        "val": "[538825] Struharov 2122 [538825] Struhařov"
    },
    {
        "kod": 533718,
        "nazev": "Stříbrná Skalice",
        "popis": "[533718] Stříbrná Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533718,
        "val": "[533718] Stribrna Skalice 2122 [533718] Stříbrná Skalice"
    },
    {
        "kod": 571954,
        "nazev": "Sudovo Hlavno",
        "popis": "[571954] Sudovo Hlavno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 571954,
        "val": "[571954] Sudovo Hlavno 2103 [571954] Sudovo Hlavno"
    },
    {
        "kod": 538833,
        "nazev": "Sulice",
        "popis": "[538833] Sulice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538833,
        "val": "[538833] Sulice 2122 [538833] Sulice"
    },
    {
        "kod": 598305,
        "nazev": "Svémyslice",
        "popis": "[598305] Svémyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 598305,
        "val": "[598305] Svemyslice 2103 [598305] Svémyslice"
    },
    {
        "kod": 538841,
        "nazev": "Světice",
        "popis": "[538841] Světice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538841,
        "val": "[538841] Svetice 2122 [538841] Světice"
    },
    {
        "kod": 538850,
        "nazev": "Svojetice",
        "popis": "[538850] Svojetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538850,
        "val": "[538850] Svojetice 2122 [538850] Svojetice"
    },
    {
        "kod": 538876,
        "nazev": "Šestajovice",
        "popis": "[538876] Šestajovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538876,
        "val": "[538876] Sestajovice 2103 [538876] Šestajovice"
    },
    {
        "kod": 538884,
        "nazev": "Škvorec",
        "popis": "[538884] Škvorec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538884,
        "val": "[538884] Skvorec 2103 [538884] Škvorec"
    },
    {
        "kod": 571644,
        "nazev": "Štíhlice",
        "popis": "[571644] Štíhlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 571644,
        "val": "[571644] Stihlice 2122 [571644] Štíhlice"
    },
    {
        "kod": 538892,
        "nazev": "Tehov",
        "popis": "[538892] Tehov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538892,
        "val": "[538892] Tehov 2122 [538892] Tehov"
    },
    {
        "kod": 599719,
        "nazev": "Tehovec",
        "popis": "[599719] Tehovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 599719,
        "val": "[599719] Tehovec 2122 [599719] Tehovec"
    },
    {
        "kod": 538957,
        "nazev": "Úvaly",
        "popis": "[538957] Úvaly",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538957,
        "val": "[538957] Uvaly 2103 [538957] Úvaly"
    },
    {
        "kod": 538965,
        "nazev": "Veleň",
        "popis": "[538965] Veleň",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538965,
        "val": "[538965] Velen 2103 [538965] Veleň"
    },
    {
        "kod": 538973,
        "nazev": "Veliká Ves",
        "popis": "[538973] Veliká Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538973,
        "val": "[538973] Velika Ves 2103 [538973] Veliká Ves"
    },
    {
        "kod": 538981,
        "nazev": "Velké Popovice",
        "popis": "[538981] Velké Popovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 538981,
        "val": "[538981] Velke Popovice 2122 [538981] Velké Popovice"
    },
    {
        "kod": 538990,
        "nazev": "Větrušice",
        "popis": "[538990] Větrušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 538990,
        "val": "[538990] Vetrusice 2103 [538990] Větrušice"
    },
    {
        "kod": 533874,
        "nazev": "Vlkančice",
        "popis": "[533874] Vlkančice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533874,
        "val": "[533874] Vlkancice 2122 [533874] Vlkančice"
    },
    {
        "kod": 539015,
        "nazev": "Vodochody",
        "popis": "[539015] Vodochody",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 539015,
        "val": "[539015] Vodochody 2103 [539015] Vodochody"
    },
    {
        "kod": 539031,
        "nazev": "Všestary",
        "popis": "[539031] Všestary",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 539031,
        "val": "[539031] Vsestary 2122 [539031] Všestary"
    },
    {
        "kod": 539040,
        "nazev": "Vyšehořovice",
        "popis": "[539040] Vyšehořovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 539040,
        "val": "[539040] Vysehorovice 2103 [539040] Vyšehořovice"
    },
    {
        "kod": 564796,
        "nazev": "Výžerky",
        "popis": "[564796] Výžerky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 564796,
        "val": "[564796] Vyzerky 2122 [564796] Výžerky"
    },
    {
        "kod": 533904,
        "nazev": "Vyžlovka",
        "popis": "[533904] Vyžlovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 533904,
        "val": "[533904] Vyzlovka 2122 [533904] Vyžlovka"
    },
    {
        "kod": 505781,
        "nazev": "Zápy",
        "popis": "[505781] Zápy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 505781,
        "val": "[505781] Zapy 2103 [505781] Zápy"
    },
    {
        "kod": 535362,
        "nazev": "Záryby",
        "popis": "[535362] Záryby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 535362,
        "val": "[535362] Zaryby 2103 [535362] Záryby"
    },
    {
        "kod": 539058,
        "nazev": "Zdiby",
        "popis": "[539058] Zdiby",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 539058,
        "val": "[539058] Zdiby 2103 [539058] Zdiby"
    },
    {
        "kod": 539066,
        "nazev": "Zeleneč",
        "popis": "[539066] Zeleneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 539066,
        "val": "[539066] Zelenec 2103 [539066] Zeleneč"
    },
    {
        "kod": 513644,
        "nazev": "Zlatá",
        "popis": "[513644] Zlatá",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 513644,
        "val": "[513644] Zlata 2103 [513644] Zlatá"
    },
    {
        "kod": 539082,
        "nazev": "Zlonín",
        "popis": "[539082] Zlonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2103,
        "iczuj": 539082,
        "val": "[539082] Zlonin 2103 [539082] Zlonín"
    },
    {
        "kod": 539091,
        "nazev": "Zvánovice",
        "popis": "[539091] Zvánovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2122,
        "iczuj": 539091,
        "val": "[539091] Zvanovice 2122 [539091] Zvánovice"
    },
    {
        "kod": 539104,
        "nazev": "Bojanovice",
        "popis": "[539104] Bojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539104,
        "val": "[539104] Bojanovice 2105 [539104] Bojanovice"
    },
    {
        "kod": 571199,
        "nazev": "Bratřínov",
        "popis": "[571199] Bratřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571199,
        "val": "[571199] Bratrinov 2105 [571199] Bratřínov"
    },
    {
        "kod": 599735,
        "nazev": "Březová-Oleško",
        "popis": "[599735] Březová-Oleško",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 599735,
        "val": "[599735] Brezova-Olesko 2105 [599735] Březová-Oleško"
    },
    {
        "kod": 540048,
        "nazev": "Buš",
        "popis": "[540048] Buš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 540048,
        "val": "[540048] Bus 2105 [540048] Buš"
    },
    {
        "kod": 539121,
        "nazev": "Černolice",
        "popis": "[539121] Černolice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539121,
        "val": "[539121] Cernolice 2105 [539121] Černolice"
    },
    {
        "kod": 539139,
        "nazev": "Černošice",
        "popis": "[539139] Černošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539139,
        "val": "[539139] Cernosice 2105 [539139] Černošice"
    },
    {
        "kod": 532215,
        "nazev": "Červený Újezd",
        "popis": "[532215] Červený Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 532215,
        "val": "[532215] Cerveny Ujezd 2105 [532215] Červený Újezd"
    },
    {
        "kod": 539147,
        "nazev": "Číčovice",
        "popis": "[539147] Číčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539147,
        "val": "[539147] Cicovice 2105 [539147] Číčovice"
    },
    {
        "kod": 539155,
        "nazev": "Čisovice",
        "popis": "[539155] Čisovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539155,
        "val": "[539155] Cisovice 2105 [539155] Čisovice"
    },
    {
        "kod": 539163,
        "nazev": "Davle",
        "popis": "[539163] Davle",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539163,
        "val": "[539163] Davle 2105 [539163] Davle"
    },
    {
        "kod": 539171,
        "nazev": "Dobrovíz",
        "popis": "[539171] Dobrovíz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539171,
        "val": "[539171] Dobroviz 2105 [539171] Dobrovíz"
    },
    {
        "kod": 539180,
        "nazev": "Dobříč",
        "popis": "[539180] Dobříč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539180,
        "val": "[539180] Dobric 2105 [539180] Dobříč"
    },
    {
        "kod": 539198,
        "nazev": "Dobřichovice",
        "popis": "[539198] Dobřichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539198,
        "val": "[539198] Dobrichovice 2105 [539198] Dobřichovice"
    },
    {
        "kod": 539210,
        "nazev": "Dolní Břežany",
        "popis": "[539210] Dolní Břežany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539210,
        "val": "[539210] Dolni Brezany 2105 [539210] Dolní Břežany"
    },
    {
        "kod": 531146,
        "nazev": "Drahelčice",
        "popis": "[531146] Drahelčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 531146,
        "val": "[531146] Drahelcice 2105 [531146] Drahelčice"
    },
    {
        "kod": 539228,
        "nazev": "Holubice",
        "popis": "[539228] Holubice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539228,
        "val": "[539228] Holubice 2105 [539228] Holubice"
    },
    {
        "kod": 539236,
        "nazev": "Horoměřice",
        "popis": "[539236] Horoměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539236,
        "val": "[539236] Horomerice 2105 [539236] Horoměřice"
    },
    {
        "kod": 539244,
        "nazev": "Hostivice",
        "popis": "[539244] Hostivice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539244,
        "val": "[539244] Hostivice 2105 [539244] Hostivice"
    },
    {
        "kod": 539252,
        "nazev": "Hradištko",
        "popis": "[539252] Hradištko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539252,
        "val": "[539252] Hradistko 2105 [539252] Hradištko"
    },
    {
        "kod": 539261,
        "nazev": "Hvozdnice",
        "popis": "[539261] Hvozdnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539261,
        "val": "[539261] Hvozdnice 2105 [539261] Hvozdnice"
    },
    {
        "kod": 539287,
        "nazev": "Choteč",
        "popis": "[539287] Choteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539287,
        "val": "[539287] Chotec 2105 [539287] Choteč"
    },
    {
        "kod": 539295,
        "nazev": "Chrášťany",
        "popis": "[539295] Chrášťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539295,
        "val": "[539295] Chrastany 2105 [539295] Chrášťany"
    },
    {
        "kod": 539309,
        "nazev": "Chýně",
        "popis": "[539309] Chýně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539309,
        "val": "[539309] Chyne 2105 [539309] Chýně"
    },
    {
        "kod": 513431,
        "nazev": "Chýnice",
        "popis": "[513431] Chýnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 513431,
        "val": "[513431] Chynice 2105 [513431] Chýnice"
    },
    {
        "kod": 539317,
        "nazev": "Jeneč",
        "popis": "[539317] Jeneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539317,
        "val": "[539317] Jenec 2105 [539317] Jeneč"
    },
    {
        "kod": 539325,
        "nazev": "Jesenice",
        "popis": "[539325] Jesenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539325,
        "val": "[539325] Jesenice 2105 [539325] Jesenice"
    },
    {
        "kod": 539333,
        "nazev": "Jílové u Prahy",
        "popis": "[539333] Jílové u Prahy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539333,
        "val": "[539333] Jilove u Prahy 2105 [539333] Jílové u Prahy"
    },
    {
        "kod": 539341,
        "nazev": "Jíloviště",
        "popis": "[539341] Jíloviště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539341,
        "val": "[539341] Jiloviste 2105 [539341] Jíloviště"
    },
    {
        "kod": 539350,
        "nazev": "Jinočany",
        "popis": "[539350] Jinočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539350,
        "val": "[539350] Jinocany 2105 [539350] Jinočany"
    },
    {
        "kod": 539368,
        "nazev": "Kamenný Přívoz",
        "popis": "[539368] Kamenný Přívoz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539368,
        "val": "[539368] Kamenny Privoz 2105 [539368] Kamenný Přívoz"
    },
    {
        "kod": 599727,
        "nazev": "Karlík",
        "popis": "[599727] Karlík",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 599727,
        "val": "[599727] Karlik 2105 [599727] Karlík"
    },
    {
        "kod": 571211,
        "nazev": "Klínec",
        "popis": "[571211] Klínec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571211,
        "val": "[571211] Klinec 2105 [571211] Klínec"
    },
    {
        "kod": 539384,
        "nazev": "Kněževes",
        "popis": "[539384] Kněževes",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539384,
        "val": "[539384] Knezeves 2105 [539384] Kněževes"
    },
    {
        "kod": 539392,
        "nazev": "Kosoř",
        "popis": "[539392] Kosoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539392,
        "val": "[539392] Kosor 2105 [539392] Kosoř"
    },
    {
        "kod": 571261,
        "nazev": "Kytín",
        "popis": "[571261] Kytín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571261,
        "val": "[571261] Kytin 2105 [571261] Kytín"
    },
    {
        "kod": 539406,
        "nazev": "Lety",
        "popis": "[539406] Lety",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539406,
        "val": "[539406] Lety 2105 [539406] Lety"
    },
    {
        "kod": 539414,
        "nazev": "Libčice nad Vltavou",
        "popis": "[539414] Libčice nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539414,
        "val": "[539414] Libcice nad Vltavou 2105 [539414] Libčice nad Vltavou"
    },
    {
        "kod": 539422,
        "nazev": "Libeř",
        "popis": "[539422] Libeř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539422,
        "val": "[539422] Liber 2105 [539422] Libeř"
    },
    {
        "kod": 571326,
        "nazev": "Lichoceves",
        "popis": "[571326] Lichoceves",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571326,
        "val": "[571326] Lichoceves 2105 [571326] Lichoceves"
    },
    {
        "kod": 539457,
        "nazev": "Líšnice",
        "popis": "[539457] Líšnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539457,
        "val": "[539457] Lisnice 2105 [539457] Líšnice"
    },
    {
        "kod": 539490,
        "nazev": "Měchenice",
        "popis": "[539490] Měchenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539490,
        "val": "[539490] Mechenice 2105 [539490] Měchenice"
    },
    {
        "kod": 540765,
        "nazev": "Mníšek pod Brdy",
        "popis": "[540765] Mníšek pod Brdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 540765,
        "val": "[540765] Mnisek pod Brdy 2105 [540765] Mníšek pod Brdy"
    },
    {
        "kod": 531618,
        "nazev": "Nučice",
        "popis": "[531618] Nučice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 531618,
        "val": "[531618] Nucice 2105 [531618] Nučice"
    },
    {
        "kod": 539503,
        "nazev": "Ohrobec",
        "popis": "[539503] Ohrobec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539503,
        "val": "[539503] Ohrobec 2105 [539503] Ohrobec"
    },
    {
        "kod": 571334,
        "nazev": "Okoř",
        "popis": "[571334] Okoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571334,
        "val": "[571334] Okor 2105 [571334] Okoř"
    },
    {
        "kod": 539511,
        "nazev": "Okrouhlo",
        "popis": "[539511] Okrouhlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539511,
        "val": "[539511] Okrouhlo 2105 [539511] Okrouhlo"
    },
    {
        "kod": 539520,
        "nazev": "Ořech",
        "popis": "[539520] Ořech",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539520,
        "val": "[539520] Orech 2105 [539520] Ořech"
    },
    {
        "kod": 539546,
        "nazev": "Petrov",
        "popis": "[539546] Petrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539546,
        "val": "[539546] Petrov 2105 [539546] Petrov"
    },
    {
        "kod": 539562,
        "nazev": "Pohoří",
        "popis": "[539562] Pohoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539562,
        "val": "[539562] Pohori 2105 [539562] Pohoří"
    },
    {
        "kod": 539571,
        "nazev": "Průhonice",
        "popis": "[539571] Průhonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539571,
        "val": "[539571] Pruhonice 2105 [539571] Průhonice"
    },
    {
        "kod": 539597,
        "nazev": "Psáry",
        "popis": "[539597] Psáry",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539597,
        "val": "[539597] Psary 2105 [539597] Psáry"
    },
    {
        "kod": 532789,
        "nazev": "Ptice",
        "popis": "[532789] Ptice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 532789,
        "val": "[532789] Ptice 2105 [532789] Ptice"
    },
    {
        "kod": 571318,
        "nazev": "Roblín",
        "popis": "[571318] Roblín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571318,
        "val": "[571318] Roblin 2105 [571318] Roblín"
    },
    {
        "kod": 539627,
        "nazev": "Roztoky",
        "popis": "[539627] Roztoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539627,
        "val": "[539627] Roztoky 2105 [539627] Roztoky"
    },
    {
        "kod": 531723,
        "nazev": "Rudná",
        "popis": "[531723] Rudná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 531723,
        "val": "[531723] Rudna 2105 [531723] Rudná"
    },
    {
        "kod": 539643,
        "nazev": "Řevnice",
        "popis": "[539643] Řevnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539643,
        "val": "[539643] Revnice 2105 [539643] Řevnice"
    },
    {
        "kod": 539651,
        "nazev": "Řitka",
        "popis": "[539651] Řitka",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539651,
        "val": "[539651] Ritka 2105 [539651] Řitka"
    },
    {
        "kod": 539660,
        "nazev": "Slapy",
        "popis": "[539660] Slapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539660,
        "val": "[539660] Slapy 2105 [539660] Slapy"
    },
    {
        "kod": 539686,
        "nazev": "Statenice",
        "popis": "[539686] Statenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539686,
        "val": "[539686] Statenice 2105 [539686] Statenice"
    },
    {
        "kod": 539708,
        "nazev": "Středokluky",
        "popis": "[539708] Středokluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539708,
        "val": "[539708] Stredokluky 2105 [539708] Středokluky"
    },
    {
        "kod": 571342,
        "nazev": "Svrkyně",
        "popis": "[571342] Svrkyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571342,
        "val": "[571342] Svrkyne 2105 [571342] Svrkyně"
    },
    {
        "kod": 539732,
        "nazev": "Štěchovice",
        "popis": "[539732] Štěchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539732,
        "val": "[539732] Stechovice 2105 [539732] Štěchovice"
    },
    {
        "kod": 531821,
        "nazev": "Tachlovice",
        "popis": "[531821] Tachlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 531821,
        "val": "[531821] Tachlovice 2105 [531821] Tachlovice"
    },
    {
        "kod": 598313,
        "nazev": "Trnová",
        "popis": "[598313] Trnová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 598313,
        "val": "[598313] Trnova 2105 [598313] Trnová"
    },
    {
        "kod": 539759,
        "nazev": "Třebotov",
        "popis": "[539759] Třebotov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539759,
        "val": "[539759] Trebotov 2105 [539759] Třebotov"
    },
    {
        "kod": 539767,
        "nazev": "Tuchoměřice",
        "popis": "[539767] Tuchoměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539767,
        "val": "[539767] Tuchomerice 2105 [539767] Tuchoměřice"
    },
    {
        "kod": 539775,
        "nazev": "Tursko",
        "popis": "[539775] Tursko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539775,
        "val": "[539775] Tursko 2105 [539775] Tursko"
    },
    {
        "kod": 571351,
        "nazev": "Úholičky",
        "popis": "[571351] Úholičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571351,
        "val": "[571351] Uholicky 2105 [571351] Úholičky"
    },
    {
        "kod": 532991,
        "nazev": "Úhonice",
        "popis": "[532991] Úhonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 532991,
        "val": "[532991] Uhonice 2105 [532991] Úhonice"
    },
    {
        "kod": 539805,
        "nazev": "Únětice",
        "popis": "[539805] Únětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539805,
        "val": "[539805] Unetice 2105 [539805] Únětice"
    },
    {
        "kod": 562254,
        "nazev": "Paseky",
        "popis": "[562254] Paseky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562254,
        "val": "[562254] Paseky 3108 [562254] Paseky"
    },
    {
        "kod": 549240,
        "nazev": "Písek",
        "popis": "[549240] Písek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549240,
        "val": "[549240] Pisek 3108 [549240] Písek"
    },
    {
        "kod": 549754,
        "nazev": "Podolí I",
        "popis": "[549754] Podolí I",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549754,
        "val": "[549754] Podoli I 3108 [549754] Podolí I"
    },
    {
        "kod": 561509,
        "nazev": "Probulov",
        "popis": "[561509] Probulov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 561509,
        "val": "[561509] Probulov 3108 [561509] Probulov"
    },
    {
        "kod": 549771,
        "nazev": "Protivín",
        "popis": "[549771] Protivín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549771,
        "val": "[549771] Protivin 3108 [549771] Protivín"
    },
    {
        "kod": 561517,
        "nazev": "Přeborov",
        "popis": "[561517] Přeborov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 561517,
        "val": "[561517] Preborov 3107 [561517] Přeborov"
    },
    {
        "kod": 509621,
        "nazev": "Předotice",
        "popis": "[509621] Předotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 509621,
        "val": "[509621] Predotice 3108 [509621] Předotice"
    },
    {
        "kod": 549797,
        "nazev": "Přeštěnice",
        "popis": "[549797] Přeštěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549797,
        "val": "[549797] Prestenice 3107 [549797] Přeštěnice"
    },
    {
        "kod": 549801,
        "nazev": "Putim",
        "popis": "[549801] Putim",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549801,
        "val": "[549801] Putim 3108 [549801] Putim"
    },
    {
        "kod": 562068,
        "nazev": "Rakovice",
        "popis": "[562068] Rakovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562068,
        "val": "[562068] Rakovice 3108 [562068] Rakovice"
    },
    {
        "kod": 549827,
        "nazev": "Ražice",
        "popis": "[549827] Ražice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549827,
        "val": "[549827] Razice 3108 [549827] Ražice"
    },
    {
        "kod": 549843,
        "nazev": "Sepekov",
        "popis": "[549843] Sepekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549843,
        "val": "[549843] Sepekov 3107 [549843] Sepekov"
    },
    {
        "kod": 549851,
        "nazev": "Skály",
        "popis": "[549851] Skály",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549851,
        "val": "[549851] Skaly 3108 [549851] Skály"
    },
    {
        "kod": 549860,
        "nazev": "Slabčice",
        "popis": "[549860] Slabčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549860,
        "val": "[549860] Slabcice 3108 [549860] Slabčice"
    },
    {
        "kod": 549878,
        "nazev": "Smetanova Lhota",
        "popis": "[549878] Smetanova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549878,
        "val": "[549878] Smetanova Lhota 3108 [549878] Smetanova Lhota"
    },
    {
        "kod": 529885,
        "nazev": "Stehlovice",
        "popis": "[529885] Stehlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 529885,
        "val": "[529885] Stehlovice 3107 [529885] Stehlovice"
    },
    {
        "kod": 549932,
        "nazev": "Tálín",
        "popis": "[549932] Tálín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549932,
        "val": "[549932] Talin 3108 [549932] Tálín"
    },
    {
        "kod": 562271,
        "nazev": "Temešvár",
        "popis": "[562271] Temešvár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562271,
        "val": "[562271] Temesvar 3108 [562271] Temešvár"
    },
    {
        "kod": 562211,
        "nazev": "Varvažov",
        "popis": "[562211] Varvažov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562211,
        "val": "[562211] Varvazov 3108 [562211] Varvažov"
    },
    {
        "kod": 549975,
        "nazev": "Veselíčko",
        "popis": "[549975] Veselíčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 549975,
        "val": "[549975] Veselicko 3107 [549975] Veselíčko"
    },
    {
        "kod": 598844,
        "nazev": "Vlastec",
        "popis": "[598844] Vlastec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 598844,
        "val": "[598844] Vlastec 3108 [598844] Vlastec"
    },
    {
        "kod": 598852,
        "nazev": "Vlksice",
        "popis": "[598852] Vlksice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 598852,
        "val": "[598852] Vlksice 3107 [598852] Vlksice"
    },
    {
        "kod": 562289,
        "nazev": "Vojníkov",
        "popis": "[562289] Vojníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562289,
        "val": "[562289] Vojnikov 3108 [562289] Vojníkov"
    },
    {
        "kod": 549991,
        "nazev": "Vráž",
        "popis": "[549991] Vráž",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 549991,
        "val": "[549991] Vraz 3108 [549991] Vráž"
    },
    {
        "kod": 550001,
        "nazev": "Vrcovice",
        "popis": "[550001] Vrcovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 550001,
        "val": "[550001] Vrcovice 3108 [550001] Vrcovice"
    },
    {
        "kod": 550027,
        "nazev": "Záhoří",
        "popis": "[550027] Záhoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 550027,
        "val": "[550027] Zahori 3108 [550027] Záhoří"
    },
    {
        "kod": 550035,
        "nazev": "Zbelítov",
        "popis": "[550035] Zbelítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 550035,
        "val": "[550035] Zbelitov 3107 [550035] Zbelítov"
    },
    {
        "kod": 550043,
        "nazev": "Zběšičky",
        "popis": "[550043] Zběšičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 550043,
        "val": "[550043] Zbesicky 3107 [550043] Zběšičky"
    },
    {
        "kod": 550060,
        "nazev": "Zhoř",
        "popis": "[550060] Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3107,
        "iczuj": 550060,
        "val": "[550060] Zhor 3107 [550060] Zhoř"
    },
    {
        "kod": 562165,
        "nazev": "Zvíkovské Podhradí",
        "popis": "[562165] Zvíkovské Podhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 562165,
        "val": "[562165] Zvikovske Podhradi 3108 [562165] Zvíkovské Podhradí"
    },
    {
        "kod": 598861,
        "nazev": "Žďár",
        "popis": "[598861] Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3108,
        "iczuj": 598861,
        "val": "[598861] Zdar 3108 [598861] Žďár"
    },
    {
        "kod": 537241,
        "nazev": "Babice",
        "popis": "[537241] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537241,
        "val": "[537241] Babice 3109 [537241] Babice"
    },
    {
        "kod": 550116,
        "nazev": "Bohumilice",
        "popis": "[550116] Bohumilice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550116,
        "val": "[550116] Bohumilice 3116 [550116] Bohumilice"
    },
    {
        "kod": 537527,
        "nazev": "Bohunice",
        "popis": "[537527] Bohunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537527,
        "val": "[537527] Bohunice 3109 [537527] Bohunice"
    },
    {
        "kod": 545902,
        "nazev": "Borová Lada",
        "popis": "[545902] Borová Lada",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 545902,
        "val": "[545902] Borova Lada 3116 [545902] Borová Lada"
    },
    {
        "kod": 550124,
        "nazev": "Bošice",
        "popis": "[550124] Bošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550124,
        "val": "[550124] Bosice 3116 [550124] Bošice"
    },
    {
        "kod": 561576,
        "nazev": "Budkov",
        "popis": "[561576] Budkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 561576,
        "val": "[561576] Budkov 3109 [561576] Budkov"
    },
    {
        "kod": 537519,
        "nazev": "Buk",
        "popis": "[537519] Buk",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 537519,
        "val": "[537519] Buk 3116 [537519] Buk"
    },
    {
        "kod": 550159,
        "nazev": "Bušanovice",
        "popis": "[550159] Bušanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550159,
        "val": "[550159] Busanovice 3109 [550159] Bušanovice"
    },
    {
        "kod": 550167,
        "nazev": "Čkyně",
        "popis": "[550167] Čkyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550167,
        "val": "[550167] Ckyne 3116 [550167] Čkyně"
    },
    {
        "kod": 537187,
        "nazev": "Drslavice",
        "popis": "[537187] Drslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537187,
        "val": "[537187] Drslavice 3109 [537187] Drslavice"
    },
    {
        "kod": 550183,
        "nazev": "Dub",
        "popis": "[550183] Dub",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550183,
        "val": "[550183] Dub 3109 [550183] Dub"
    },
    {
        "kod": 537144,
        "nazev": "Dvory",
        "popis": "[537144] Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537144,
        "val": "[537144] Dvory 3109 [537144] Dvory"
    },
    {
        "kod": 550205,
        "nazev": "Horní Vltavice",
        "popis": "[550205] Horní Vltavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550205,
        "val": "[550205] Horni Vltavice 3116 [550205] Horní Vltavice"
    },
    {
        "kod": 550221,
        "nazev": "Hracholusky",
        "popis": "[550221] Hracholusky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550221,
        "val": "[550221] Hracholusky 3109 [550221] Hracholusky"
    },
    {
        "kod": 550230,
        "nazev": "Husinec",
        "popis": "[550230] Husinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550230,
        "val": "[550230] Husinec 3109 [550230] Husinec"
    },
    {
        "kod": 550248,
        "nazev": "Chlumany",
        "popis": "[550248] Chlumany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550248,
        "val": "[550248] Chlumany 3109 [550248] Chlumany"
    },
    {
        "kod": 550264,
        "nazev": "Chroboly",
        "popis": "[550264] Chroboly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550264,
        "val": "[550264] Chroboly 3109 [550264] Chroboly"
    },
    {
        "kod": 537420,
        "nazev": "Chvalovice",
        "popis": "[537420] Chvalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537420,
        "val": "[537420] Chvalovice 3109 [537420] Chvalovice"
    },
    {
        "kod": 537136,
        "nazev": "Kratušín",
        "popis": "[537136] Kratušín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537136,
        "val": "[537136] Kratusin 3109 [537136] Kratušín"
    },
    {
        "kod": 561673,
        "nazev": "Křišťanov",
        "popis": "[561673] Křišťanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 561673,
        "val": "[561673] Kristanov 3109 [561673] Křišťanov"
    },
    {
        "kod": 550329,
        "nazev": "Ktiš",
        "popis": "[550329] Ktiš",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550329,
        "val": "[550329] Ktis 3109 [550329] Ktiš"
    },
    {
        "kod": 563978,
        "nazev": "Kubova Huť",
        "popis": "[563978] Kubova Huť",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 563978,
        "val": "[563978] Kubova Hut 3116 [563978] Kubova Huť"
    },
    {
        "kod": 550337,
        "nazev": "Kvilda",
        "popis": "[550337] Kvilda",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550337,
        "val": "[550337] Kvilda 3116 [550337] Kvilda"
    },
    {
        "kod": 550345,
        "nazev": "Lažiště",
        "popis": "[550345] Lažiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550345,
        "val": "[550345] Laziste 3109 [550345] Lažiště"
    },
    {
        "kod": 561649,
        "nazev": "Lčovice",
        "popis": "[561649] Lčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 561649,
        "val": "[561649] Lcovice 3116 [561649] Lčovice"
    },
    {
        "kod": 550353,
        "nazev": "Lenora",
        "popis": "[550353] Lenora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550353,
        "val": "[550353] Lenora 3109 [550353] Lenora"
    },
    {
        "kod": 550361,
        "nazev": "Lhenice",
        "popis": "[550361] Lhenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550361,
        "val": "[550361] Lhenice 3109 [550361] Lhenice"
    },
    {
        "kod": 537071,
        "nazev": "Lipovice",
        "popis": "[537071] Lipovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537071,
        "val": "[537071] Lipovice 3109 [537071] Lipovice"
    },
    {
        "kod": 537322,
        "nazev": "Lužice",
        "popis": "[537322] Lužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537322,
        "val": "[537322] Luzice 3109 [537322] Lužice"
    },
    {
        "kod": 537381,
        "nazev": "Mahouš",
        "popis": "[537381] Mahouš",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537381,
        "val": "[537381] Mahous 3109 [537381] Mahouš"
    },
    {
        "kod": 550418,
        "nazev": "Malovice",
        "popis": "[550418] Malovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550418,
        "val": "[550418] Malovice 3109 [550418] Malovice"
    },
    {
        "kod": 550426,
        "nazev": "Mičovice",
        "popis": "[550426] Mičovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550426,
        "val": "[550426] Micovice 3109 [550426] Mičovice"
    },
    {
        "kod": 550434,
        "nazev": "Nebahovy",
        "popis": "[550434] Nebahovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550434,
        "val": "[550434] Nebahovy 3109 [550434] Nebahovy"
    },
    {
        "kod": 550396,
        "nazev": "Němčice",
        "popis": "[550396] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550396,
        "val": "[550396] Nemcice 3109 [550396] Němčice"
    },
    {
        "kod": 550442,
        "nazev": "Netolice",
        "popis": "[550442] Netolice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550442,
        "val": "[550442] Netolice 3109 [550442] Netolice"
    },
    {
        "kod": 529893,
        "nazev": "Nicov",
        "popis": "[529893] Nicov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 529893,
        "val": "[529893] Nicov 3116 [529893] Nicov"
    },
    {
        "kod": 550451,
        "nazev": "Nová Pec",
        "popis": "[550451] Nová Pec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550451,
        "val": "[550451] Nova Pec 3109 [550451] Nová Pec"
    },
    {
        "kod": 561568,
        "nazev": "Nové Hutě",
        "popis": "[561568] Nové Hutě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 561568,
        "val": "[561568] Nove Hute 3116 [561568] Nové Hutě"
    },
    {
        "kod": 537365,
        "nazev": "Olšovice",
        "popis": "[537365] Olšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537365,
        "val": "[537365] Olsovice 3109 [537365] Olšovice"
    },
    {
        "kod": 537543,
        "nazev": "Pěčnov",
        "popis": "[537543] Pěčnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537543,
        "val": "[537543] Pecnov 3109 [537543] Pěčnov"
    },
    {
        "kod": 550094,
        "nazev": "Prachatice",
        "popis": "[550094] Prachatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550094,
        "val": "[550094] Prachatice 3109 [550094] Prachatice"
    },
    {
        "kod": 550485,
        "nazev": "Radhostice",
        "popis": "[550485] Radhostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550485,
        "val": "[550485] Radhostice 3109 [550485] Radhostice"
    },
    {
        "kod": 550515,
        "nazev": "Stachy",
        "popis": "[550515] Stachy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550515,
        "val": "[550515] Stachy 3116 [550515] Stachy"
    },
    {
        "kod": 550523,
        "nazev": "Stožec",
        "popis": "[550523] Stožec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550523,
        "val": "[550523] Stozec 3109 [550523] Stožec"
    },
    {
        "kod": 550531,
        "nazev": "Strážný",
        "popis": "[550531] Strážný",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550531,
        "val": "[550531] Strazny 3116 [550531] Strážný"
    },
    {
        "kod": 550540,
        "nazev": "Strunkovice nad Blanicí",
        "popis": "[550540] Strunkovice nad Blanicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550540,
        "val": "[550540] Strunkovice nad Blanici 3109 [550540] Strunkovice nad Blanicí"
    },
    {
        "kod": 550558,
        "nazev": "Svatá Maří",
        "popis": "[550558] Svatá Maří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550558,
        "val": "[550558] Svata Mari 3116 [550558] Svatá Maří"
    },
    {
        "kod": 550574,
        "nazev": "Šumavské Hoštice",
        "popis": "[550574] Šumavské Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550574,
        "val": "[550574] Sumavske Hostice 3116 [550574] Šumavské Hoštice"
    },
    {
        "kod": 550582,
        "nazev": "Těšovice",
        "popis": "[550582] Těšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550582,
        "val": "[550582] Tesovice 3109 [550582] Těšovice"
    },
    {
        "kod": 550604,
        "nazev": "Tvrzice",
        "popis": "[550604] Tvrzice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550604,
        "val": "[550604] Tvrzice 3109 [550604] Tvrzice"
    },
    {
        "kod": 537535,
        "nazev": "Újezdec",
        "popis": "[537535] Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537535,
        "val": "[537535] Ujezdec 3109 [537535] Újezdec"
    },
    {
        "kod": 550621,
        "nazev": "Vacov",
        "popis": "[550621] Vacov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550621,
        "val": "[550621] Vacov 3116 [550621] Vacov"
    },
    {
        "kod": 550647,
        "nazev": "Vimperk",
        "popis": "[550647] Vimperk",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550647,
        "val": "[550647] Vimperk 3116 [550647] Vimperk"
    },
    {
        "kod": 550655,
        "nazev": "Vitějovice",
        "popis": "[550655] Vitějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550655,
        "val": "[550655] Vitejovice 3109 [550655] Vitějovice"
    },
    {
        "kod": 550663,
        "nazev": "Vlachovo Březí",
        "popis": "[550663] Vlachovo Březí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550663,
        "val": "[550663] Vlachovo Brezi 3109 [550663] Vlachovo Březí"
    },
    {
        "kod": 550671,
        "nazev": "Volary",
        "popis": "[550671] Volary",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550671,
        "val": "[550671] Volary 3109 [550671] Volary"
    },
    {
        "kod": 529915,
        "nazev": "Vrbice",
        "popis": "[529915] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 529915,
        "val": "[529915] Vrbice 3116 [529915] Vrbice"
    },
    {
        "kod": 550680,
        "nazev": "Záblatí",
        "popis": "[550680] Záblatí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550680,
        "val": "[550680] Zablati 3109 [550680] Záblatí"
    },
    {
        "kod": 537195,
        "nazev": "Zábrdí",
        "popis": "[537195] Zábrdí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537195,
        "val": "[537195] Zabrdi 3109 [537195] Zábrdí"
    },
    {
        "kod": 550698,
        "nazev": "Zálezly",
        "popis": "[550698] Zálezly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550698,
        "val": "[550698] Zalezly 3116 [550698] Zálezly"
    },
    {
        "kod": 550701,
        "nazev": "Zbytiny",
        "popis": "[550701] Zbytiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550701,
        "val": "[550701] Zbytiny 3109 [550701] Zbytiny"
    },
    {
        "kod": 550728,
        "nazev": "Zdíkov",
        "popis": "[550728] Zdíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 550728,
        "val": "[550728] Zdikov 3116 [550728] Zdíkov"
    },
    {
        "kod": 529923,
        "nazev": "Žárovná",
        "popis": "[529923] Žárovná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3116,
        "iczuj": 529923,
        "val": "[529923] Zarovna 3116 [529923] Žárovná"
    },
    {
        "kod": 550761,
        "nazev": "Želnava",
        "popis": "[550761] Želnava",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 550761,
        "val": "[550761] Zelnava 3109 [550761] Želnava"
    },
    {
        "kod": 537209,
        "nazev": "Žernovice",
        "popis": "[537209] Žernovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3109,
        "iczuj": 537209,
        "val": "[537209] Zernovice 3109 [537209] Žernovice"
    },
    {
        "kod": 550809,
        "nazev": "Bavorov",
        "popis": "[550809] Bavorov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 550809,
        "val": "[550809] Bavorov 3117 [550809] Bavorov"
    },
    {
        "kod": 550817,
        "nazev": "Bělčice",
        "popis": "[550817] Bělčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 550817,
        "val": "[550817] Belcice 3101 [550817] Bělčice"
    },
    {
        "kod": 598895,
        "nazev": "Bezdědovice",
        "popis": "[598895] Bezdědovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 598895,
        "val": "[598895] Bezdedovice 3101 [598895] Bezdědovice"
    },
    {
        "kod": 550833,
        "nazev": "Bílsko",
        "popis": "[550833] Bílsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 550833,
        "val": "[550833] Bilsko 3117 [550833] Bílsko"
    },
    {
        "kod": 550850,
        "nazev": "Blatná",
        "popis": "[550850] Blatná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 550850,
        "val": "[550850] Blatna 3101 [550850] Blatná"
    },
    {
        "kod": 537063,
        "nazev": "Bratronice",
        "popis": "[537063] Bratronice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 537063,
        "val": "[537063] Bratronice 3101 [537063] Bratronice"
    },
    {
        "kod": 530018,
        "nazev": "Březí",
        "popis": "[530018] Březí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 530018,
        "val": "[530018] Brezi 3101 [530018] Březí"
    },
    {
        "kod": 560171,
        "nazev": "Budyně",
        "popis": "[560171] Budyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 560171,
        "val": "[560171] Budyne 3117 [560171] Budyně"
    },
    {
        "kod": 529966,
        "nazev": "Buzice",
        "popis": "[529966] Buzice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 529966,
        "val": "[529966] Buzice 3101 [529966] Buzice"
    },
    {
        "kod": 550906,
        "nazev": "Cehnice",
        "popis": "[550906] Cehnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550906,
        "val": "[550906] Cehnice 3111 [550906] Cehnice"
    },
    {
        "kod": 510068,
        "nazev": "Čečelovice",
        "popis": "[510068] Čečelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 510068,
        "val": "[510068] Cecelovice 3101 [510068] Čečelovice"
    },
    {
        "kod": 550922,
        "nazev": "Čejetice",
        "popis": "[550922] Čejetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550922,
        "val": "[550922] Cejetice 3111 [550922] Čejetice"
    },
    {
        "kod": 550949,
        "nazev": "Čepřovice",
        "popis": "[550949] Čepřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550949,
        "val": "[550949] Ceprovice 3111 [550949] Čepřovice"
    },
    {
        "kod": 550957,
        "nazev": "Čestice",
        "popis": "[550957] Čestice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550957,
        "val": "[550957] Cestice 3111 [550957] Čestice"
    },
    {
        "kod": 550965,
        "nazev": "Číčenice",
        "popis": "[550965] Číčenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 550965,
        "val": "[550965] Cicenice 3117 [550965] Číčenice"
    },
    {
        "kod": 550981,
        "nazev": "Doubravice",
        "popis": "[550981] Doubravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 550981,
        "val": "[550981] Doubravice 3111 [550981] Doubravice"
    },
    {
        "kod": 551015,
        "nazev": "Drahonice",
        "popis": "[551015] Drahonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 551015,
        "val": "[551015] Drahonice 3117 [551015] Drahonice"
    },
    {
        "kod": 560219,
        "nazev": "Drachkov",
        "popis": "[560219] Drachkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560219,
        "val": "[560219] Drachkov 3111 [560219] Drachkov"
    },
    {
        "kod": 551023,
        "nazev": "Drážov",
        "popis": "[551023] Drážov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551023,
        "val": "[551023] Drazov 3111 [551023] Drážov"
    },
    {
        "kod": 560243,
        "nazev": "Droužetice",
        "popis": "[560243] Droužetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560243,
        "val": "[560243] Drouzetice 3111 [560243] Droužetice"
    },
    {
        "kod": 551040,
        "nazev": "Dřešín",
        "popis": "[551040] Dřešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551040,
        "val": "[551040] Dresin 3111 [551040] Dřešín"
    },
    {
        "kod": 551597,
        "nazev": "Hajany",
        "popis": "[551597] Hajany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551597,
        "val": "[551597] Hajany 3101 [551597] Hajany"
    },
    {
        "kod": 561690,
        "nazev": "Hájek",
        "popis": "[561690] Hájek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 561690,
        "val": "[561690] Hajek 3117 [561690] Hájek"
    },
    {
        "kod": 536628,
        "nazev": "Hlupín",
        "popis": "[536628] Hlupín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536628,
        "val": "[536628] Hlupin 3111 [536628] Hlupín"
    },
    {
        "kod": 536881,
        "nazev": "Horní Poříčí",
        "popis": "[536881] Horní Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536881,
        "val": "[536881] Horni Porici 3111 [536881] Horní Poříčí"
    },
    {
        "kod": 536369,
        "nazev": "Hornosín",
        "popis": "[536369] Hornosín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536369,
        "val": "[536369] Hornosin 3101 [536369] Hornosín"
    },
    {
        "kod": 551104,
        "nazev": "Hoslovice",
        "popis": "[551104] Hoslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551104,
        "val": "[551104] Hoslovice 3111 [551104] Hoslovice"
    },
    {
        "kod": 551121,
        "nazev": "Hoštice",
        "popis": "[551121] Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551121,
        "val": "[551121] Hostice 3111 [551121] Hoštice"
    },
    {
        "kod": 551139,
        "nazev": "Chelčice",
        "popis": "[551139] Chelčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 551139,
        "val": "[551139] Chelcice 3117 [551139] Chelčice"
    },
    {
        "kod": 529982,
        "nazev": "Chlum",
        "popis": "[529982] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 529982,
        "val": "[529982] Chlum 3101 [529982] Chlum"
    },
    {
        "kod": 536903,
        "nazev": "Chobot",
        "popis": "[536903] Chobot",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536903,
        "val": "[536903] Chobot 3101 [536903] Chobot"
    },
    {
        "kod": 551155,
        "nazev": "Chrášťovice",
        "popis": "[551155] Chrášťovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551155,
        "val": "[551155] Chrastovice 3111 [551155] Chrášťovice"
    },
    {
        "kod": 551163,
        "nazev": "Jinín",
        "popis": "[551163] Jinín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551163,
        "val": "[551163] Jinin 3111 [551163] Jinín"
    },
    {
        "kod": 551180,
        "nazev": "Kadov",
        "popis": "[551180] Kadov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 551180,
        "val": "[551180] Kadov 3101 [551180] Kadov"
    },
    {
        "kod": 536946,
        "nazev": "Kalenice",
        "popis": "[536946] Kalenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 536946,
        "val": "[536946] Kalenice 3111 [536946] Kalenice"
    },
    {
        "kod": 551201,
        "nazev": "Katovice",
        "popis": "[551201] Katovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 551201,
        "val": "[551201] Katovice 3111 [551201] Katovice"
    },
    {
        "kod": 560405,
        "nazev": "Kladruby",
        "popis": "[560405] Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3111,
        "iczuj": 560405,
        "val": "[560405] Kladruby 3111 [560405] Kladruby"
    },
    {
        "kod": 536601,
        "nazev": "Kocelovice",
        "popis": "[536601] Kocelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3101,
        "iczuj": 536601,
        "val": "[536601] Kocelovice 3101 [536601] Kocelovice"
    },
    {
        "kod": 536342,
        "nazev": "Krajníčko",
        "popis": "[536342] Krajníčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3117,
        "iczuj": 536342,
        "val": "[536342] Krajnicko 3117 [536342] Krajníčko"
    },
    {
        "kod": 539813,
        "nazev": "Velké Přílepy",
        "popis": "[539813] Velké Přílepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539813,
        "val": "[539813] Velke Prilepy 2105 [539813] Velké Přílepy"
    },
    {
        "kod": 513458,
        "nazev": "Vestec",
        "popis": "[513458] Vestec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 513458,
        "val": "[513458] Vestec 2105 [513458] Vestec"
    },
    {
        "kod": 539830,
        "nazev": "Vonoklasy",
        "popis": "[539830] Vonoklasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539830,
        "val": "[539830] Vonoklasy 2105 [539830] Vonoklasy"
    },
    {
        "kod": 539848,
        "nazev": "Vrané nad Vltavou",
        "popis": "[539848] Vrané nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539848,
        "val": "[539848] Vrane nad Vltavou 2105 [539848] Vrané nad Vltavou"
    },
    {
        "kod": 539856,
        "nazev": "Všenory",
        "popis": "[539856] Všenory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539856,
        "val": "[539856] Vsenory 2105 [539856] Všenory"
    },
    {
        "kod": 571288,
        "nazev": "Zahořany",
        "popis": "[571288] Zahořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 571288,
        "val": "[571288] Zahorany 2105 [571288] Zahořany"
    },
    {
        "kod": 539872,
        "nazev": "Zbuzany",
        "popis": "[539872] Zbuzany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539872,
        "val": "[539872] Zbuzany 2105 [539872] Zbuzany"
    },
    {
        "kod": 539881,
        "nazev": "Zlatníky-Hodkovice",
        "popis": "[539881] Zlatníky-Hodkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539881,
        "val": "[539881] Zlatniky-Hodkovice 2105 [539881] Zlatníky-Hodkovice"
    },
    {
        "kod": 539902,
        "nazev": "Zvole",
        "popis": "[539902] Zvole",
        "datum_od": "",
        "datum_do": "",
        "orp": 2105,
        "iczuj": 539902,
        "val": "[539902] Zvole 2105 [539902] Zvole"
    },
    {
        "kod": 529672,
        "nazev": "Bezděkov pod Třemšínem",
        "popis": "[529672] Bezděkov pod Třemšínem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 529672,
        "val": "[529672] Bezdekov pod Tremsinem 2120 [529672] Bezděkov pod Třemšínem"
    },
    {
        "kod": 564559,
        "nazev": "Bohostice",
        "popis": "[564559] Bohostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564559,
        "val": "[564559] Bohostice 2120 [564559] Bohostice"
    },
    {
        "kod": 539953,
        "nazev": "Bohutín",
        "popis": "[539953] Bohutín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 539953,
        "val": "[539953] Bohutin 2120 [539953] Bohutín"
    },
    {
        "kod": 539970,
        "nazev": "Borotice",
        "popis": "[539970] Borotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 539970,
        "val": "[539970] Borotice 2107 [539970] Borotice"
    },
    {
        "kod": 539988,
        "nazev": "Bratkovice",
        "popis": "[539988] Bratkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 539988,
        "val": "[539988] Bratkovice 2120 [539988] Bratkovice"
    },
    {
        "kod": 539996,
        "nazev": "Brdy",
        "popis": "[539996] Brdy",
        "datum_od": "",
        "datum_do": 2015,
        "orp": 2120,
        "iczuj": 539996,
        "val": "[539996] Brdy 2120 [539996] Brdy"
    },
    {
        "kod": 540013,
        "nazev": "Březnice",
        "popis": "[540013] Březnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540013,
        "val": "[540013] Breznice 2120 [540013] Březnice"
    },
    {
        "kod": 540021,
        "nazev": "Buková u Příbramě",
        "popis": "[540021] Buková u Příbramě",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540021,
        "val": "[540021] Bukova u Pribrame 2120 [540021] Buková u Příbramě"
    },
    {
        "kod": 564664,
        "nazev": "Bukovany",
        "popis": "[564664] Bukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564664,
        "val": "[564664] Bukovany 2120 [564664] Bukovany"
    },
    {
        "kod": 564419,
        "nazev": "Cetyně",
        "popis": "[564419] Cetyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564419,
        "val": "[564419] Cetyne 2120 [564419] Cetyně"
    },
    {
        "kod": 540072,
        "nazev": "Čenkov",
        "popis": "[540072] Čenkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540072,
        "val": "[540072] Cenkov 2120 [540072] Čenkov"
    },
    {
        "kod": 540081,
        "nazev": "Čím",
        "popis": "[540081] Čím",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540081,
        "val": "[540081] Cim 2107 [540081] Čím"
    },
    {
        "kod": 540099,
        "nazev": "Daleké Dušníky",
        "popis": "[540099] Daleké Dušníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540099,
        "val": "[540099] Daleke Dusniky 2107 [540099] Daleké Dušníky"
    },
    {
        "kod": 513504,
        "nazev": "Dlouhá Lhota",
        "popis": "[513504] Dlouhá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513504,
        "val": "[513504] Dlouha Lhota 2120 [513504] Dlouhá Lhota"
    },
    {
        "kod": 540111,
        "nazev": "Dobříš",
        "popis": "[540111] Dobříš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540111,
        "val": "[540111] Dobris 2107 [540111] Dobříš"
    },
    {
        "kod": 540129,
        "nazev": "Dolní Hbity",
        "popis": "[540129] Dolní Hbity",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540129,
        "val": "[540129] Dolni Hbity 2120 [540129] Dolní Hbity"
    },
    {
        "kod": 599298,
        "nazev": "Drahenice",
        "popis": "[599298] Drahenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 599298,
        "val": "[599298] Drahenice 2120 [599298] Drahenice"
    },
    {
        "kod": 540145,
        "nazev": "Drahlín",
        "popis": "[540145] Drahlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540145,
        "val": "[540145] Drahlin 2120 [540145] Drahlín"
    },
    {
        "kod": 540153,
        "nazev": "Drásov",
        "popis": "[540153] Drásov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540153,
        "val": "[540153] Drasov 2120 [540153] Drásov"
    },
    {
        "kod": 540170,
        "nazev": "Drevníky",
        "popis": "[540170] Drevníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540170,
        "val": "[540170] Drevniky 2107 [540170] Drevníky"
    },
    {
        "kod": 540188,
        "nazev": "Drhovy",
        "popis": "[540188] Drhovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540188,
        "val": "[540188] Drhovy 2107 [540188] Drhovy"
    },
    {
        "kod": 598381,
        "nazev": "Dubenec",
        "popis": "[598381] Dubenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598381,
        "val": "[598381] Dubenec 2120 [598381] Dubenec"
    },
    {
        "kod": 540218,
        "nazev": "Dublovice",
        "popis": "[540218] Dublovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540218,
        "val": "[540218] Dublovice 2123 [540218] Dublovice"
    },
    {
        "kod": 564508,
        "nazev": "Dubno",
        "popis": "[564508] Dubno",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564508,
        "val": "[564508] Dubno 2120 [564508] Dubno"
    },
    {
        "kod": 598402,
        "nazev": "Háje",
        "popis": "[598402] Háje",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598402,
        "val": "[598402] Haje 2120 [598402] Háje"
    },
    {
        "kod": 540242,
        "nazev": "Hluboš",
        "popis": "[540242] Hluboš",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540242,
        "val": "[540242] Hlubos 2120 [540242] Hluboš"
    },
    {
        "kod": 564605,
        "nazev": "Hlubyně",
        "popis": "[564605] Hlubyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564605,
        "val": "[564605] Hlubyne 2120 [564605] Hlubyně"
    },
    {
        "kod": 564257,
        "nazev": "Horčápsko",
        "popis": "[564257] Horčápsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564257,
        "val": "[564257] Horcapsko 2120 [564257] Horčápsko"
    },
    {
        "kod": 540285,
        "nazev": "Hřiměždice",
        "popis": "[540285] Hřiměždice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540285,
        "val": "[540285] Hrimezdice 2107 [540285] Hřiměždice"
    },
    {
        "kod": 513580,
        "nazev": "Hudčice",
        "popis": "[513580] Hudčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513580,
        "val": "[513580] Hudcice 2120 [513580] Hudčice"
    },
    {
        "kod": 540315,
        "nazev": "Hvožďany",
        "popis": "[540315] Hvožďany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540315,
        "val": "[540315] Hvozdany 2120 [540315] Hvožďany"
    },
    {
        "kod": 540323,
        "nazev": "Chotilsko",
        "popis": "[540323] Chotilsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540323,
        "val": "[540323] Chotilsko 2107 [540323] Chotilsko"
    },
    {
        "kod": 564249,
        "nazev": "Chrást",
        "popis": "[564249] Chrást",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564249,
        "val": "[564249] Chrast 2120 [564249] Chrást"
    },
    {
        "kod": 540358,
        "nazev": "Chraštice",
        "popis": "[540358] Chraštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540358,
        "val": "[540358] Chrastice 2120 [540358] Chraštice"
    },
    {
        "kod": 540374,
        "nazev": "Jablonná",
        "popis": "[540374] Jablonná",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540374,
        "val": "[540374] Jablonna 2120 [540374] Jablonná"
    },
    {
        "kod": 540391,
        "nazev": "Jesenice",
        "popis": "[540391] Jesenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540391,
        "val": "[540391] Jesenice 2123 [540391] Jesenice"
    },
    {
        "kod": 540404,
        "nazev": "Jince",
        "popis": "[540404] Jince",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540404,
        "val": "[540404] Jince 2120 [540404] Jince"
    },
    {
        "kod": 540439,
        "nazev": "Kamýk nad Vltavou",
        "popis": "[540439] Kamýk nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540439,
        "val": "[540439] Kamyk nad Vltavou 2120 [540439] Kamýk nad Vltavou"
    },
    {
        "kod": 540447,
        "nazev": "Klučenice",
        "popis": "[540447] Klučenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540447,
        "val": "[540447] Klucenice 2123 [540447] Klučenice"
    },
    {
        "kod": 598461,
        "nazev": "Kňovice",
        "popis": "[598461] Kňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 598461,
        "val": "[598461] Knovice 2123 [598461] Kňovice"
    },
    {
        "kod": 599204,
        "nazev": "Korkyně",
        "popis": "[599204] Korkyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 599204,
        "val": "[599204] Korkyne 2107 [599204] Korkyně"
    },
    {
        "kod": 540498,
        "nazev": "Kosova Hora",
        "popis": "[540498] Kosova Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540498,
        "val": "[540498] Kosova Hora 2123 [540498] Kosova Hora"
    },
    {
        "kod": 513555,
        "nazev": "Kotenčice",
        "popis": "[513555] Kotenčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513555,
        "val": "[513555] Kotencice 2120 [513555] Kotenčice"
    },
    {
        "kod": 529681,
        "nazev": "Koupě",
        "popis": "[529681] Koupě",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 529681,
        "val": "[529681] Koupe 2120 [529681] Koupě"
    },
    {
        "kod": 540536,
        "nazev": "Kozárovice",
        "popis": "[540536] Kozárovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540536,
        "val": "[540536] Kozarovice 2120 [540536] Kozárovice"
    },
    {
        "kod": 540552,
        "nazev": "Krásná Hora nad Vltavou",
        "popis": "[540552] Krásná Hora nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540552,
        "val": "[540552] Krasna Hora nad Vltavou 2123 [540552] Krásná Hora nad Vltavou"
    },
    {
        "kod": 540579,
        "nazev": "Křepenice",
        "popis": "[540579] Křepenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540579,
        "val": "[540579] Krepenice 2123 [540579] Křepenice"
    },
    {
        "kod": 540587,
        "nazev": "Křešín",
        "popis": "[540587] Křešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540587,
        "val": "[540587] Kresin 2120 [540587] Křešín"
    },
    {
        "kod": 540625,
        "nazev": "Láz",
        "popis": "[540625] Láz",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540625,
        "val": "[540625] Laz 2120 [540625] Láz"
    },
    {
        "kod": 564346,
        "nazev": "Lazsko",
        "popis": "[564346] Lazsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564346,
        "val": "[564346] Lazsko 2120 [564346] Lazsko"
    },
    {
        "kod": 513521,
        "nazev": "Lešetice",
        "popis": "[513521] Lešetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513521,
        "val": "[513521] Lesetice 2120 [513521] Lešetice"
    },
    {
        "kod": 598411,
        "nazev": "Lhota u Příbramě",
        "popis": "[598411] Lhota u Příbramě",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598411,
        "val": "[598411] Lhota u Pribrame 2120 [598411] Lhota u Příbramě"
    },
    {
        "kod": 540714,
        "nazev": "Malá Hraštice",
        "popis": "[540714] Malá Hraštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540714,
        "val": "[540714] Mala Hrastice 2107 [540714] Malá Hraštice"
    },
    {
        "kod": 540749,
        "nazev": "Milešov",
        "popis": "[540749] Milešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540749,
        "val": "[540749] Milesov 2123 [540749] Milešov"
    },
    {
        "kod": 540757,
        "nazev": "Milín",
        "popis": "[540757] Milín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540757,
        "val": "[540757] Milin 2120 [540757] Milín"
    },
    {
        "kod": 599751,
        "nazev": "Modřovice",
        "popis": "[599751] Modřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 599751,
        "val": "[599751] Modrovice 2120 [599751] Modřovice"
    },
    {
        "kod": 540781,
        "nazev": "Mokrovraty",
        "popis": "[540781] Mokrovraty",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540781,
        "val": "[540781] Mokrovraty 2107 [540781] Mokrovraty"
    },
    {
        "kod": 540790,
        "nazev": "Nalžovice",
        "popis": "[540790] Nalžovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540790,
        "val": "[540790] Nalzovice 2123 [540790] Nalžovice"
    },
    {
        "kod": 564478,
        "nazev": "Narysov",
        "popis": "[564478] Narysov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564478,
        "val": "[564478] Narysov 2120 [564478] Narysov"
    },
    {
        "kod": 540811,
        "nazev": "Nečín",
        "popis": "[540811] Nečín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540811,
        "val": "[540811] Necin 2107 [540811] Nečín"
    },
    {
        "kod": 540820,
        "nazev": "Nedrahovice",
        "popis": "[540820] Nedrahovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540820,
        "val": "[540820] Nedrahovice 2123 [540820] Nedrahovice"
    },
    {
        "kod": 540846,
        "nazev": "Nechvalice",
        "popis": "[540846] Nechvalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 540846,
        "val": "[540846] Nechvalice 2123 [540846] Nechvalice"
    },
    {
        "kod": 564524,
        "nazev": "Nepomuk",
        "popis": "[564524] Nepomuk",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564524,
        "val": "[564524] Nepomuk 2120 [564524] Nepomuk"
    },
    {
        "kod": 564222,
        "nazev": "Nestrašovice",
        "popis": "[564222] Nestrašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564222,
        "val": "[564222] Nestrasovice 2120 [564222] Nestrašovice"
    },
    {
        "kod": 540889,
        "nazev": "Nová Ves pod Pleší",
        "popis": "[540889] Nová Ves pod Pleší",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540889,
        "val": "[540889] Nova Ves pod Plesi 2107 [540889] Nová Ves pod Pleší"
    },
    {
        "kod": 540897,
        "nazev": "Nové Dvory",
        "popis": "[540897] Nové Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540897,
        "val": "[540897] Nove Dvory 2107 [540897] Nové Dvory"
    },
    {
        "kod": 540901,
        "nazev": "Nový Knín",
        "popis": "[540901] Nový Knín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540901,
        "val": "[540901] Novy Knin 2107 [540901] Nový Knín"
    },
    {
        "kod": 513571,
        "nazev": "Občov",
        "popis": "[513571] Občov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513571,
        "val": "[513571] Obcov 2120 [513571] Občov"
    },
    {
        "kod": 540935,
        "nazev": "Obecnice",
        "popis": "[540935] Obecnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540935,
        "val": "[540935] Obecnice 2120 [540935] Obecnice"
    },
    {
        "kod": 540943,
        "nazev": "Obory",
        "popis": "[540943] Obory",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540943,
        "val": "[540943] Obory 2120 [540943] Obory"
    },
    {
        "kod": 540951,
        "nazev": "Obořiště",
        "popis": "[540951] Obořiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 540951,
        "val": "[540951] Oboriste 2107 [540951] Obořiště"
    },
    {
        "kod": 540960,
        "nazev": "Ohrazenice",
        "popis": "[540960] Ohrazenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 540960,
        "val": "[540960] Ohrazenice 2120 [540960] Ohrazenice"
    },
    {
        "kod": 598470,
        "nazev": "Osečany",
        "popis": "[598470] Osečany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 598470,
        "val": "[598470] Osecany 2123 [598470] Osečany"
    },
    {
        "kod": 598372,
        "nazev": "Ostrov",
        "popis": "[598372] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598372,
        "val": "[598372] Ostrov 2120 [598372] Ostrov"
    },
    {
        "kod": 541010,
        "nazev": "Ouběnice",
        "popis": "[541010] Ouběnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541010,
        "val": "[541010] Oubenice 2107 [541010] Ouběnice"
    },
    {
        "kod": 541028,
        "nazev": "Pečice",
        "popis": "[541028] Pečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541028,
        "val": "[541028] Pecice 2120 [541028] Pečice"
    },
    {
        "kod": 541044,
        "nazev": "Petrovice",
        "popis": "[541044] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541044,
        "val": "[541044] Petrovice 2123 [541044] Petrovice"
    },
    {
        "kod": 541052,
        "nazev": "Pičín",
        "popis": "[541052] Pičín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541052,
        "val": "[541052] Picin 2120 [541052] Pičín"
    },
    {
        "kod": 564214,
        "nazev": "Počaply",
        "popis": "[564214] Počaply",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564214,
        "val": "[564214] Pocaply 2120 [564214] Počaply"
    },
    {
        "kod": 541087,
        "nazev": "Počepice",
        "popis": "[541087] Počepice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541087,
        "val": "[541087] Pocepice 2123 [541087] Počepice"
    },
    {
        "kod": 564486,
        "nazev": "Podlesí",
        "popis": "[564486] Podlesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564486,
        "val": "[564486] Podlesi 2120 [564486] Podlesí"
    },
    {
        "kod": 541133,
        "nazev": "Prosenická Lhota",
        "popis": "[541133] Prosenická Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541133,
        "val": "[541133] Prosenicka Lhota 2123 [541133] Prosenická Lhota"
    },
    {
        "kod": 539911,
        "nazev": "Příbram",
        "popis": "[539911] Příbram",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 539911,
        "val": "[539911] Pribram 2120 [539911] Příbram"
    },
    {
        "kod": 513547,
        "nazev": "Příčovy",
        "popis": "[513547] Příčovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 513547,
        "val": "[513547] Pricovy 2123 [513547] Příčovy"
    },
    {
        "kod": 564389,
        "nazev": "Radětice",
        "popis": "[564389] Radětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564389,
        "val": "[564389] Radetice 2120 [564389] Radětice"
    },
    {
        "kod": 598488,
        "nazev": "Radíč",
        "popis": "[598488] Radíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 598488,
        "val": "[598488] Radic 2123 [598488] Radíč"
    },
    {
        "kod": 541206,
        "nazev": "Rosovice",
        "popis": "[541206] Rosovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541206,
        "val": "[541206] Rosovice 2107 [541206] Rosovice"
    },
    {
        "kod": 541231,
        "nazev": "Rožmitál pod Třemšínem",
        "popis": "[541231] Rožmitál pod Třemšínem",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541231,
        "val": "[541231] Rozmital pod Tremsinem 2120 [541231] Rožmitál pod Třemšínem"
    },
    {
        "kod": 541257,
        "nazev": "Rybníky",
        "popis": "[541257] Rybníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541257,
        "val": "[541257] Rybniky 2107 [541257] Rybníky"
    },
    {
        "kod": 541273,
        "nazev": "Sádek",
        "popis": "[541273] Sádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541273,
        "val": "[541273] Sadek 2120 [541273] Sádek"
    },
    {
        "kod": 541281,
        "nazev": "Sedlčany",
        "popis": "[541281] Sedlčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541281,
        "val": "[541281] Sedlcany 2123 [541281] Sedlčany"
    },
    {
        "kod": 530573,
        "nazev": "Sedlec-Prčice",
        "popis": "[530573] Sedlec-Prčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 530573,
        "val": "[530573] Sedlec-Prcice 2123 [530573] Sedlec-Prčice"
    },
    {
        "kod": 564630,
        "nazev": "Sedlice",
        "popis": "[564630] Sedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564630,
        "val": "[564630] Sedlice 2120 [564630] Sedlice"
    },
    {
        "kod": 541311,
        "nazev": "Smolotely",
        "popis": "[541311] Smolotely",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541311,
        "val": "[541311] Smolotely 2120 [541311] Smolotely"
    },
    {
        "kod": 541320,
        "nazev": "Solenice",
        "popis": "[541320] Solenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541320,
        "val": "[541320] Solenice 2120 [541320] Solenice"
    },
    {
        "kod": 541338,
        "nazev": "Stará Huť",
        "popis": "[541338] Stará Huť",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541338,
        "val": "[541338] Stara Hut 2107 [541338] Stará Huť"
    },
    {
        "kod": 564583,
        "nazev": "Starosedlský Hrádek",
        "popis": "[564583] Starosedlský Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564583,
        "val": "[564583] Starosedlsky Hradek 2120 [564583] Starosedlský Hrádek"
    },
    {
        "kod": 541371,
        "nazev": "Suchodol",
        "popis": "[541371] Suchodol",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541371,
        "val": "[541371] Suchodol 2120 [541371] Suchodol"
    },
    {
        "kod": 541389,
        "nazev": "Svaté Pole",
        "popis": "[541389] Svaté Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541389,
        "val": "[541389] Svate Pole 2107 [541389] Svaté Pole"
    },
    {
        "kod": 541397,
        "nazev": "Svatý Jan",
        "popis": "[541397] Svatý Jan",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541397,
        "val": "[541397] Svaty Jan 2123 [541397] Svatý Jan"
    },
    {
        "kod": 564273,
        "nazev": "Svojšice",
        "popis": "[564273] Svojšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564273,
        "val": "[564273] Svojsice 2120 [564273] Svojšice"
    },
    {
        "kod": 541419,
        "nazev": "Štětkovice",
        "popis": "[541419] Štětkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541419,
        "val": "[541419] Stetkovice 2123 [541419] Štětkovice"
    },
    {
        "kod": 529664,
        "nazev": "Těchařovice",
        "popis": "[529664] Těchařovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 529664,
        "val": "[529664] Techarovice 2120 [529664] Těchařovice"
    },
    {
        "kod": 541427,
        "nazev": "Tochovice",
        "popis": "[541427] Tochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541427,
        "val": "[541427] Tochovice 2120 [541427] Tochovice"
    },
    {
        "kod": 598429,
        "nazev": "Trhové Dušníky",
        "popis": "[598429] Trhové Dušníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598429,
        "val": "[598429] Trhove Dusniky 2120 [598429] Trhové Dušníky"
    },
    {
        "kod": 541451,
        "nazev": "Třebsko",
        "popis": "[541451] Třebsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541451,
        "val": "[541451] Trebsko 2120 [541451] Třebsko"
    },
    {
        "kod": 598330,
        "nazev": "Tušovice",
        "popis": "[598330] Tušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598330,
        "val": "[598330] Tusovice 2120 [598330] Tušovice"
    },
    {
        "kod": 513539,
        "nazev": "Velká Lečice",
        "popis": "[513539] Velká Lečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 513539,
        "val": "[513539] Velka Lecice 2107 [513539] Velká Lečice"
    },
    {
        "kod": 541508,
        "nazev": "Věšín",
        "popis": "[541508] Věšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541508,
        "val": "[541508] Vesin 2120 [541508] Věšín"
    },
    {
        "kod": 541516,
        "nazev": "Višňová",
        "popis": "[541516] Višňová",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541516,
        "val": "[541516] Visnova 2120 [541516] Višňová"
    },
    {
        "kod": 541524,
        "nazev": "Volenice",
        "popis": "[541524] Volenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541524,
        "val": "[541524] Volenice 2120 [541524] Volenice"
    },
    {
        "kod": 541541,
        "nazev": "Voznice",
        "popis": "[541541] Voznice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2107,
        "iczuj": 541541,
        "val": "[541541] Voznice 2107 [541541] Voznice"
    },
    {
        "kod": 564362,
        "nazev": "Vrančice",
        "popis": "[564362] Vrančice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564362,
        "val": "[564362] Vrancice 2120 [564362] Vrančice"
    },
    {
        "kod": 541567,
        "nazev": "Vranovice",
        "popis": "[541567] Vranovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541567,
        "val": "[541567] Vranovice 2120 [541567] Vranovice"
    },
    {
        "kod": 598437,
        "nazev": "Vševily",
        "popis": "[598437] Vševily",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 598437,
        "val": "[598437] Vsevily 2120 [598437] Vševily"
    },
    {
        "kod": 541583,
        "nazev": "Vysoká u Příbramě",
        "popis": "[541583] Vysoká u Příbramě",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541583,
        "val": "[541583] Vysoka u Pribrame 2120 [541583] Vysoká u Příbramě"
    },
    {
        "kod": 541591,
        "nazev": "Vysoký Chlumec",
        "popis": "[541591] Vysoký Chlumec",
        "datum_od": "",
        "datum_do": "",
        "orp": 2123,
        "iczuj": 541591,
        "val": "[541591] Vysoky Chlumec 2123 [541591] Vysoký Chlumec"
    },
    {
        "kod": 541613,
        "nazev": "Zalužany",
        "popis": "[541613] Zalužany",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 541613,
        "val": "[541613] Zaluzany 2120 [541613] Zalužany"
    },
    {
        "kod": 564320,
        "nazev": "Zbenice",
        "popis": "[564320] Zbenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 564320,
        "val": "[564320] Zbenice 2120 [564320] Zbenice"
    },
    {
        "kod": 513512,
        "nazev": "Zduchovice",
        "popis": "[513512] Zduchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 2120,
        "iczuj": 513512,
        "val": "[513512] Zduchovice 2120 [513512] Zduchovice"
    },
    {
        "kod": 535877,
        "nazev": "Komařice",
        "popis": "[535877] Komařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535877,
        "val": "[535877] Komarice 3102 [535877] Komařice"
    },
    {
        "kod": 529729,
        "nazev": "Kvítkovice",
        "popis": "[529729] Kvítkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 529729,
        "val": "[529729] Kvitkovice 3102 [529729] Kvítkovice"
    },
    {
        "kod": 544736,
        "nazev": "Ledenice",
        "popis": "[544736] Ledenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544736,
        "val": "[544736] Ledenice 3102 [544736] Ledenice"
    },
    {
        "kod": 544744,
        "nazev": "Libín",
        "popis": "[544744] Libín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544744,
        "val": "[544744] Libin 3102 [544744] Libín"
    },
    {
        "kod": 535800,
        "nazev": "Libníč",
        "popis": "[535800] Libníč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535800,
        "val": "[535800] Libnic 3102 [535800] Libníč"
    },
    {
        "kod": 544761,
        "nazev": "Lipí",
        "popis": "[544761] Lipí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544761,
        "val": "[544761] Lipi 3102 [544761] Lipí"
    },
    {
        "kod": 544779,
        "nazev": "Lišov",
        "popis": "[544779] Lišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544779,
        "val": "[544779] Lisov 3102 [544779] Lišov"
    },
    {
        "kod": 544795,
        "nazev": "Litvínovice",
        "popis": "[544795] Litvínovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544795,
        "val": "[544795] Litvinovice 3102 [544795] Litvínovice"
    },
    {
        "kod": 544809,
        "nazev": "Ločenice",
        "popis": "[544809] Ločenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544809,
        "val": "[544809] Locenice 3113 [544809] Ločenice"
    },
    {
        "kod": 535940,
        "nazev": "Mazelov",
        "popis": "[535940] Mazelov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535940,
        "val": "[535940] Mazelov 3102 [535940] Mazelov"
    },
    {
        "kod": 544817,
        "nazev": "Mladošovice",
        "popis": "[544817] Mladošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544817,
        "val": "[544817] Mladosovice 3113 [544817] Mladošovice"
    },
    {
        "kod": 598615,
        "nazev": "Modrá Hůrka",
        "popis": "[598615] Modrá Hůrka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 598615,
        "val": "[598615] Modra Hurka 3115 [598615] Modrá Hůrka"
    },
    {
        "kod": 535842,
        "nazev": "Mokrý Lom",
        "popis": "[535842] Mokrý Lom",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535842,
        "val": "[535842] Mokry Lom 3102 [535842] Mokrý Lom"
    },
    {
        "kod": 535281,
        "nazev": "Mydlovary",
        "popis": "[535281] Mydlovary",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535281,
        "val": "[535281] Mydlovary 3102 [535281] Mydlovary"
    },
    {
        "kod": 535371,
        "nazev": "Nákří",
        "popis": "[535371] Nákří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535371,
        "val": "[535371] Nakri 3102 [535371] Nákří"
    },
    {
        "kod": 544825,
        "nazev": "Nedabyle",
        "popis": "[544825] Nedabyle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544825,
        "val": "[544825] Nedabyle 3102 [544825] Nedabyle"
    },
    {
        "kod": 535435,
        "nazev": "Neplachov",
        "popis": "[535435] Neplachov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535435,
        "val": "[535435] Neplachov 3102 [535435] Neplachov"
    },
    {
        "kod": 535648,
        "nazev": "Nová Ves",
        "popis": "[535648] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535648,
        "val": "[535648] Nova Ves 3102 [535648] Nová Ves"
    },
    {
        "kod": 544868,
        "nazev": "Nové Hrady",
        "popis": "[544868] Nové Hrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544868,
        "val": "[544868] Nove Hrady 3113 [544868] Nové Hrady"
    },
    {
        "kod": 544884,
        "nazev": "Olešnice",
        "popis": "[544884] Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 544884,
        "val": "[544884] Olesnice 3113 [544884] Olešnice"
    },
    {
        "kod": 544892,
        "nazev": "Olešník",
        "popis": "[544892] Olešník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544892,
        "val": "[544892] Olesnik 3102 [544892] Olešník"
    },
    {
        "kod": 535231,
        "nazev": "Ostrolovský Újezd",
        "popis": "[535231] Ostrolovský Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 535231,
        "val": "[535231] Ostrolovsky Ujezd 3113 [535231] Ostrolovský Újezd"
    },
    {
        "kod": 535699,
        "nazev": "Petříkov",
        "popis": "[535699] Petříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 535699,
        "val": "[535699] Petrikov 3113 [535699] Petříkov"
    },
    {
        "kod": 535991,
        "nazev": "Pištín",
        "popis": "[535991] Pištín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535991,
        "val": "[535991] Pistin 3102 [535991] Pištín"
    },
    {
        "kod": 535176,
        "nazev": "Planá",
        "popis": "[535176] Planá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535176,
        "val": "[535176] Plana 3102 [535176] Planá"
    },
    {
        "kod": 535346,
        "nazev": "Plav",
        "popis": "[535346] Plav",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535346,
        "val": "[535346] Plav 3102 [535346] Plav"
    },
    {
        "kod": 544965,
        "nazev": "Radošovice",
        "popis": "[544965] Radošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544965,
        "val": "[544965] Radosovice 3102 [544965] Radošovice"
    },
    {
        "kod": 544973,
        "nazev": "Roudné",
        "popis": "[544973] Roudné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544973,
        "val": "[544973] Roudne 3102 [544973] Roudné"
    },
    {
        "kod": 544981,
        "nazev": "Rudolfov",
        "popis": "[544981] Rudolfov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 544981,
        "val": "[544981] Rudolfov 3102 [544981] Rudolfov"
    },
    {
        "kod": 545007,
        "nazev": "Římov",
        "popis": "[545007] Římov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545007,
        "val": "[545007] Rimov 3102 [545007] Římov"
    },
    {
        "kod": 545015,
        "nazev": "Sedlec",
        "popis": "[545015] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545015,
        "val": "[545015] Sedlec 3102 [545015] Sedlec"
    },
    {
        "kod": 545023,
        "nazev": "Slavče",
        "popis": "[545023] Slavče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 545023,
        "val": "[545023] Slavce 3113 [545023] Slavče"
    },
    {
        "kod": 545066,
        "nazev": "Srubec",
        "popis": "[545066] Srubec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545066,
        "val": "[545066] Srubec 3102 [545066] Srubec"
    },
    {
        "kod": 545074,
        "nazev": "Staré Hodějovice",
        "popis": "[545074] Staré Hodějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545074,
        "val": "[545074] Stare Hodejovice 3102 [545074] Staré Hodějovice"
    },
    {
        "kod": 545082,
        "nazev": "Strážkovice",
        "popis": "[545082] Strážkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545082,
        "val": "[545082] Strazkovice 3102 [545082] Strážkovice"
    },
    {
        "kod": 536032,
        "nazev": "Strýčice",
        "popis": "[536032] Strýčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 536032,
        "val": "[536032] Strycice 3102 [536032] Strýčice"
    },
    {
        "kod": 545091,
        "nazev": "Střížov",
        "popis": "[545091] Střížov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545091,
        "val": "[545091] Strizov 3102 [545091] Střížov"
    },
    {
        "kod": 545104,
        "nazev": "Svatý Jan nad Malší",
        "popis": "[545104] Svatý Jan nad Malší",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 545104,
        "val": "[545104] Svaty Jan nad Malsi 3113 [545104] Svatý Jan nad Malší"
    },
    {
        "kod": 545121,
        "nazev": "Ševětín",
        "popis": "[545121] Ševětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545121,
        "val": "[545121] Sevetin 3102 [545121] Ševětín"
    },
    {
        "kod": 545139,
        "nazev": "Štěpánovice",
        "popis": "[545139] Štěpánovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545139,
        "val": "[545139] Stepanovice 3102 [545139] Štěpánovice"
    },
    {
        "kod": 545155,
        "nazev": "Temelín",
        "popis": "[545155] Temelín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 545155,
        "val": "[545155] Temelin 3115 [545155] Temelín"
    },
    {
        "kod": 545171,
        "nazev": "Trhové Sviny",
        "popis": "[545171] Trhové Sviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 545171,
        "val": "[545171] Trhove Sviny 3113 [545171] Trhové Sviny"
    },
    {
        "kod": 545201,
        "nazev": "Týn nad Vltavou",
        "popis": "[545201] Týn nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 545201,
        "val": "[545201] Tyn nad Vltavou 3115 [545201] Týn nad Vltavou"
    },
    {
        "kod": 535494,
        "nazev": "Úsilné",
        "popis": "[535494] Úsilné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535494,
        "val": "[535494] Usilne 3102 [535494] Úsilné"
    },
    {
        "kod": 545228,
        "nazev": "Včelná",
        "popis": "[545228] Včelná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545228,
        "val": "[545228] Vcelna 3102 [545228] Včelná"
    },
    {
        "kod": 535737,
        "nazev": "Vidov",
        "popis": "[535737] Vidov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535737,
        "val": "[535737] Vidov 3102 [535737] Vidov"
    },
    {
        "kod": 535893,
        "nazev": "Vitín",
        "popis": "[535893] Vitín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535893,
        "val": "[535893] Vitin 3102 [535893] Vitín"
    },
    {
        "kod": 535915,
        "nazev": "Vlkov",
        "popis": "[535915] Vlkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535915,
        "val": "[535915] Vlkov 3102 [535915] Vlkov"
    },
    {
        "kod": 545261,
        "nazev": "Vrábče",
        "popis": "[545261] Vrábče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545261,
        "val": "[545261] Vrabce 3102 [545261] Vrábče"
    },
    {
        "kod": 535796,
        "nazev": "Vráto",
        "popis": "[535796] Vráto",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535796,
        "val": "[535796] Vrato 3102 [535796] Vráto"
    },
    {
        "kod": 545287,
        "nazev": "Všemyslice",
        "popis": "[545287] Všemyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 545287,
        "val": "[545287] Vsemyslice 3115 [545287] Všemyslice"
    },
    {
        "kod": 545317,
        "nazev": "Záboří",
        "popis": "[545317] Záboří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545317,
        "val": "[545317] Zabori 3102 [545317] Záboří"
    },
    {
        "kod": 536016,
        "nazev": "Zahájí",
        "popis": "[536016] Zahájí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 536016,
        "val": "[536016] Zahaji 3102 [536016] Zahájí"
    },
    {
        "kod": 599778,
        "nazev": "Závraty",
        "popis": "[599778] Závraty",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 599778,
        "val": "[599778] Zavraty 3102 [599778] Závraty"
    },
    {
        "kod": 545341,
        "nazev": "Zliv",
        "popis": "[545341] Zliv",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545341,
        "val": "[545341] Zliv 3102 [545341] Zliv"
    },
    {
        "kod": 535591,
        "nazev": "Zvíkov",
        "popis": "[535591] Zvíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 535591,
        "val": "[535591] Zvikov 3102 [535591] Zvíkov"
    },
    {
        "kod": 545368,
        "nazev": "Žabovřesky",
        "popis": "[545368] Žabovřesky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3102,
        "iczuj": 545368,
        "val": "[545368] Zabovresky 3102 [545368] Žabovřesky"
    },
    {
        "kod": 545376,
        "nazev": "Žár",
        "popis": "[545376] Žár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3113,
        "iczuj": 545376,
        "val": "[545376] Zar 3113 [545376] Žár"
    },
    {
        "kod": 545384,
        "nazev": "Žimutice",
        "popis": "[545384] Žimutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3115,
        "iczuj": 545384,
        "val": "[545384] Zimutice 3115 [545384] Žimutice"
    },
    {
        "kod": 545406,
        "nazev": "Benešov nad Černou",
        "popis": "[545406] Benešov nad Černou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545406,
        "val": "[545406] Benesov nad Cernou 3106 [545406] Benešov nad Černou"
    },
    {
        "kod": 545414,
        "nazev": "Besednice",
        "popis": "[545414] Besednice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545414,
        "val": "[545414] Besednice 3106 [545414] Besednice"
    },
    {
        "kod": 536253,
        "nazev": "Bohdalovice",
        "popis": "[536253] Bohdalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 536253,
        "val": "[536253] Bohdalovice 3103 [536253] Bohdalovice"
    },
    {
        "kod": 545422,
        "nazev": "Boletice",
        "popis": "[545422] Boletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545422,
        "val": "[545422] Boletice 3103 [545422] Boletice"
    },
    {
        "kod": 545431,
        "nazev": "Brloh",
        "popis": "[545431] Brloh",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545431,
        "val": "[545431] Brloh 3103 [545431] Brloh"
    },
    {
        "kod": 545449,
        "nazev": "Bujanov",
        "popis": "[545449] Bujanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545449,
        "val": "[545449] Bujanov 3106 [545449] Bujanov"
    },
    {
        "kod": 545457,
        "nazev": "Černá v Pošumaví",
        "popis": "[545457] Černá v Pošumaví",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545457,
        "val": "[545457] Cerna v Posumavi 3103 [545457] Černá v Pošumaví"
    },
    {
        "kod": 545392,
        "nazev": "Český Krumlov",
        "popis": "[545392] Český Krumlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545392,
        "val": "[545392] Cesky Krumlov 3103 [545392] Český Krumlov"
    },
    {
        "kod": 545465,
        "nazev": "Dolní Dvořiště",
        "popis": "[545465] Dolní Dvořiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545465,
        "val": "[545465] Dolni Dvoriste 3106 [545465] Dolní Dvořiště"
    },
    {
        "kod": 545473,
        "nazev": "Dolní Třebonín",
        "popis": "[545473] Dolní Třebonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545473,
        "val": "[545473] Dolni Trebonin 3103 [545473] Dolní Třebonín"
    },
    {
        "kod": 545481,
        "nazev": "Frymburk",
        "popis": "[545481] Frymburk",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545481,
        "val": "[545481] Frymburk 3103 [545481] Frymburk"
    },
    {
        "kod": 545490,
        "nazev": "Holubov",
        "popis": "[545490] Holubov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545490,
        "val": "[545490] Holubov 3103 [545490] Holubov"
    },
    {
        "kod": 545503,
        "nazev": "Horní Dvořiště",
        "popis": "[545503] Horní Dvořiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545503,
        "val": "[545503] Horni Dvoriste 3106 [545503] Horní Dvořiště"
    },
    {
        "kod": 545511,
        "nazev": "Horní Planá",
        "popis": "[545511] Horní Planá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545511,
        "val": "[545511] Horni Plana 3103 [545511] Horní Planá"
    },
    {
        "kod": 545520,
        "nazev": "Hořice na Šumavě",
        "popis": "[545520] Hořice na Šumavě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545520,
        "val": "[545520] Horice na Sumave 3103 [545520] Hořice na Šumavě"
    },
    {
        "kod": 536229,
        "nazev": "Chlumec",
        "popis": "[536229] Chlumec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 536229,
        "val": "[536229] Chlumec 3103 [536229] Chlumec"
    },
    {
        "kod": 545546,
        "nazev": "Chvalšiny",
        "popis": "[545546] Chvalšiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545546,
        "val": "[545546] Chvalsiny 3103 [545546] Chvalšiny"
    },
    {
        "kod": 545554,
        "nazev": "Kájov",
        "popis": "[545554] Kájov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545554,
        "val": "[545554] Kajov 3103 [545554] Kájov"
    },
    {
        "kod": 545562,
        "nazev": "Kaplice",
        "popis": "[545562] Kaplice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545562,
        "val": "[545562] Kaplice 3106 [545562] Kaplice"
    },
    {
        "kod": 545571,
        "nazev": "Křemže",
        "popis": "[545571] Křemže",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545571,
        "val": "[545571] Kremze 3103 [545571] Křemže"
    },
    {
        "kod": 545597,
        "nazev": "Lipno nad Vltavou",
        "popis": "[545597] Lipno nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545597,
        "val": "[545597] Lipno nad Vltavou 3103 [545597] Lipno nad Vltavou"
    },
    {
        "kod": 545601,
        "nazev": "Loučovice",
        "popis": "[545601] Loučovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545601,
        "val": "[545601] Loucovice 3103 [545601] Loučovice"
    },
    {
        "kod": 545619,
        "nazev": "Malonty",
        "popis": "[545619] Malonty",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545619,
        "val": "[545619] Malonty 3106 [545619] Malonty"
    },
    {
        "kod": 536296,
        "nazev": "Malšín",
        "popis": "[536296] Malšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 536296,
        "val": "[536296] Malsin 3103 [536296] Malšín"
    },
    {
        "kod": 545627,
        "nazev": "Mirkovice",
        "popis": "[545627] Mirkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545627,
        "val": "[545627] Mirkovice 3103 [545627] Mirkovice"
    },
    {
        "kod": 598623,
        "nazev": "Mojné",
        "popis": "[598623] Mojné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 598623,
        "val": "[598623] Mojne 3103 [598623] Mojné"
    },
    {
        "kod": 545643,
        "nazev": "Netřebice",
        "popis": "[545643] Netřebice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545643,
        "val": "[545643] Netrebice 3106 [545643] Netřebice"
    },
    {
        "kod": 513661,
        "nazev": "Nová Ves",
        "popis": "[513661] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 513661,
        "val": "[513661] Nova Ves 3103 [513661] Nová Ves"
    },
    {
        "kod": 545660,
        "nazev": "Omlenice",
        "popis": "[545660] Omlenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545660,
        "val": "[545660] Omlenice 3106 [545660] Omlenice"
    },
    {
        "kod": 545694,
        "nazev": "Pohorská Ves",
        "popis": "[545694] Pohorská Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545694,
        "val": "[545694] Pohorska Ves 3106 [545694] Pohorská Ves"
    },
    {
        "kod": 545716,
        "nazev": "Přední Výtoň",
        "popis": "[545716] Přední Výtoň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545716,
        "val": "[545716] Predni Vyton 3103 [545716] Přední Výtoň"
    },
    {
        "kod": 545724,
        "nazev": "Přídolí",
        "popis": "[545724] Přídolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545724,
        "val": "[545724] Pridoli 3103 [545724] Přídolí"
    },
    {
        "kod": 545732,
        "nazev": "Přísečná",
        "popis": "[545732] Přísečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545732,
        "val": "[545732] Prisecna 3103 [545732] Přísečná"
    },
    {
        "kod": 545767,
        "nazev": "Rožmberk nad Vltavou",
        "popis": "[545767] Rožmberk nad Vltavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545767,
        "val": "[545767] Rozmberk nad Vltavou 3103 [545767] Rožmberk nad Vltavou"
    },
    {
        "kod": 545775,
        "nazev": "Rožmitál na Šumavě",
        "popis": "[545775] Rožmitál na Šumavě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545775,
        "val": "[545775] Rozmital na Sumave 3106 [545775] Rožmitál na Šumavě"
    },
    {
        "kod": 545805,
        "nazev": "Soběnov",
        "popis": "[545805] Soběnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545805,
        "val": "[545805] Sobenov 3106 [545805] Soběnov"
    },
    {
        "kod": 536245,
        "nazev": "Srnín",
        "popis": "[536245] Srnín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 536245,
        "val": "[536245] Srnin 3103 [536245] Srnín"
    },
    {
        "kod": 551538,
        "nazev": "Střítež",
        "popis": "[551538] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 551538,
        "val": "[551538] Stritez 3106 [551538] Střítež"
    },
    {
        "kod": 545813,
        "nazev": "Světlík",
        "popis": "[545813] Světlík",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545813,
        "val": "[545813] Svetlik 3103 [545813] Světlík"
    },
    {
        "kod": 545821,
        "nazev": "Velešín",
        "popis": "[545821] Velešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 545821,
        "val": "[545821] Velesin 3106 [545821] Velešín"
    },
    {
        "kod": 545830,
        "nazev": "Větřní",
        "popis": "[545830] Větřní",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545830,
        "val": "[545830] Vetrni 3103 [545830] Větřní"
    },
    {
        "kod": 536300,
        "nazev": "Věžovatá Pláně",
        "popis": "[536300] Věžovatá Pláně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 536300,
        "val": "[536300] Vezovata Plane 3103 [536300] Věžovatá Pláně"
    },
    {
        "kod": 545848,
        "nazev": "Vyšší Brod",
        "popis": "[545848] Vyšší Brod",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545848,
        "val": "[545848] Vyssi Brod 3103 [545848] Vyšší Brod"
    },
    {
        "kod": 545864,
        "nazev": "Zlatá Koruna",
        "popis": "[545864] Zlatá Koruna",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545864,
        "val": "[545864] Zlata Koruna 3103 [545864] Zlatá Koruna"
    },
    {
        "kod": 545872,
        "nazev": "Zubčice",
        "popis": "[545872] Zubčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3103,
        "iczuj": 545872,
        "val": "[545872] Zubcice 3103 [545872] Zubčice"
    },
    {
        "kod": 536237,
        "nazev": "Zvíkov",
        "popis": "[536237] Zvíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3106,
        "iczuj": 536237,
        "val": "[536237] Zvikov 3106 [536237] Zvíkov"
    },
    {
        "kod": 562726,
        "nazev": "Báňovice",
        "popis": "[562726] Báňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562726,
        "val": "[562726] Banovice 3104 [562726] Báňovice"
    },
    {
        "kod": 562548,
        "nazev": "Bednárec",
        "popis": "[562548] Bednárec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562548,
        "val": "[562548] Bednarec 3105 [562548] Bednárec"
    },
    {
        "kod": 561053,
        "nazev": "Bednáreček",
        "popis": "[561053] Bednáreček",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561053,
        "val": "[561053] Bednarecek 3105 [561053] Bednáreček"
    },
    {
        "kod": 561711,
        "nazev": "Blažejov",
        "popis": "[561711] Blažejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561711,
        "val": "[561711] Blazejov 3105 [561711] Blažejov"
    },
    {
        "kod": 562742,
        "nazev": "Bořetín",
        "popis": "[562742] Bořetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562742,
        "val": "[562742] Boretin 3105 [562742] Bořetín"
    },
    {
        "kod": 507733,
        "nazev": "Březina",
        "popis": "[507733] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507733,
        "val": "[507733] Brezina 3105 [507733] Březina"
    },
    {
        "kod": 546020,
        "nazev": "Budeč",
        "popis": "[546020] Budeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546020,
        "val": "[546020] Budec 3104 [546020] Budeč"
    },
    {
        "kod": 546038,
        "nazev": "Budíškovice",
        "popis": "[546038] Budíškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546038,
        "val": "[546038] Budiskovice 3104 [546038] Budíškovice"
    },
    {
        "kod": 509191,
        "nazev": "Cep",
        "popis": "[509191] Cep",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 509191,
        "val": "[509191] Cep 3114 [509191] Cep"
    },
    {
        "kod": 546054,
        "nazev": "Cizkrajov",
        "popis": "[546054] Cizkrajov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546054,
        "val": "[546054] Cizkrajov 3104 [546054] Cizkrajov"
    },
    {
        "kod": 509116,
        "nazev": "Červený Hrádek",
        "popis": "[509116] Červený Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 509116,
        "val": "[509116] Cerveny Hradek 3104 [509116] Červený Hrádek"
    },
    {
        "kod": 546089,
        "nazev": "České Velenice",
        "popis": "[546089] České Velenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 546089,
        "val": "[546089] Ceske Velenice 3114 [546089] České Velenice"
    },
    {
        "kod": 546097,
        "nazev": "Český Rudolec",
        "popis": "[546097] Český Rudolec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546097,
        "val": "[546097] Cesky Rudolec 3104 [546097] Český Rudolec"
    },
    {
        "kod": 546101,
        "nazev": "Číměř",
        "popis": "[546101] Číměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546101,
        "val": "[546101] Cimer 3105 [546101] Číměř"
    },
    {
        "kod": 561703,
        "nazev": "Člunek",
        "popis": "[561703] Člunek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 561703,
        "val": "[561703] Clunek 3105 [561703] Člunek"
    },
    {
        "kod": 546127,
        "nazev": "Dačice",
        "popis": "[546127] Dačice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546127,
        "val": "[546127] Dacice 3104 [546127] Dačice"
    },
    {
        "kod": 546143,
        "nazev": "Dešná",
        "popis": "[546143] Dešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 546143,
        "val": "[546143] Desna 3104 [546143] Dešná"
    },
    {
        "kod": 546151,
        "nazev": "Deštná",
        "popis": "[546151] Deštná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 546151,
        "val": "[546151] Destna 3105 [546151] Deštná"
    },
    {
        "kod": 529753,
        "nazev": "Dívčí Kopy",
        "popis": "[529753] Dívčí Kopy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 529753,
        "val": "[529753] Divci Kopy 3105 [529753] Dívčí Kopy"
    },
    {
        "kod": 562416,
        "nazev": "Dobrohošť",
        "popis": "[562416] Dobrohošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 3104,
        "iczuj": 562416,
        "val": "[562416] Dobrohost 3104 [562416] Dobrohošť"
    },
    {
        "kod": 562467,
        "nazev": "Dolní Pěna",
        "popis": "[562467] Dolní Pěna",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562467,
        "val": "[562467] Dolni Pena 3105 [562467] Dolní Pěna"
    },
    {
        "kod": 562602,
        "nazev": "Dolní Žďár",
        "popis": "[562602] Dolní Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 562602,
        "val": "[562602] Dolni Zdar 3105 [562602] Dolní Žďár"
    },
    {
        "kod": 562840,
        "nazev": "Domanín",
        "popis": "[562840] Domanín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3114,
        "iczuj": 562840,
        "val": "[562840] Domanin 3114 [562840] Domanín"
    },
    {
        "kod": 507610,
        "nazev": "Doňov",
        "popis": "[507610] Doňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3105,
        "iczuj": 507610,
        "val": "[507610] Donov 3105 [507610] Doňov"
    },
    {
        "kod": 552852,
        "nazev": "Pohnání",
        "popis": "[552852] Pohnání",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552852,
        "val": "[552852] Pohnani 3112 [552852] Pohnání"
    },
    {
        "kod": 552861,
        "nazev": "Pojbuky",
        "popis": "[552861] Pojbuky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552861,
        "val": "[552861] Pojbuky 3112 [552861] Pojbuky"
    },
    {
        "kod": 552895,
        "nazev": "Přehořov",
        "popis": "[552895] Přehořov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 552895,
        "val": "[552895] Prehorov 3110 [552895] Přehořov"
    },
    {
        "kod": 563374,
        "nazev": "Psárov",
        "popis": "[563374] Psárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563374,
        "val": "[563374] Psarov 3112 [563374] Psárov"
    },
    {
        "kod": 552917,
        "nazev": "Radenín",
        "popis": "[552917] Radenín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552917,
        "val": "[552917] Radenin 3112 [552917] Radenín"
    },
    {
        "kod": 552925,
        "nazev": "Radětice",
        "popis": "[552925] Radětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552925,
        "val": "[552925] Radetice 3112 [552925] Radětice"
    },
    {
        "kod": 563196,
        "nazev": "Radimovice u Tábora",
        "popis": "[563196] Radimovice u Tábora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563196,
        "val": "[563196] Radimovice u Tabora 3112 [563196] Radimovice u Tábora"
    },
    {
        "kod": 552933,
        "nazev": "Radimovice u Želče",
        "popis": "[552933] Radimovice u Želče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552933,
        "val": "[552933] Radimovice u Zelce 3112 [552933] Radimovice u Želče"
    },
    {
        "kod": 552941,
        "nazev": "Radkov",
        "popis": "[552941] Radkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552941,
        "val": "[552941] Radkov 3112 [552941] Radkov"
    },
    {
        "kod": 552976,
        "nazev": "Rataje",
        "popis": "[552976] Rataje",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552976,
        "val": "[552976] Rataje 3112 [552976] Rataje"
    },
    {
        "kod": 552992,
        "nazev": "Ratibořské Hory",
        "popis": "[552992] Ratibořské Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552992,
        "val": "[552992] Ratiborske Hory 3112 [552992] Ratibořské Hory"
    },
    {
        "kod": 560626,
        "nazev": "Rodná",
        "popis": "[560626] Rodná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560626,
        "val": "[560626] Rodna 3112 [560626] Rodná"
    },
    {
        "kod": 553018,
        "nazev": "Roudná",
        "popis": "[553018] Roudná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553018,
        "val": "[553018] Roudna 3110 [553018] Roudná"
    },
    {
        "kod": 560511,
        "nazev": "Řemíčov",
        "popis": "[560511] Řemíčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560511,
        "val": "[560511] Remicov 3112 [560511] Řemíčov"
    },
    {
        "kod": 553034,
        "nazev": "Řepeč",
        "popis": "[553034] Řepeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553034,
        "val": "[553034] Repec 3112 [553034] Řepeč"
    },
    {
        "kod": 599115,
        "nazev": "Řípec",
        "popis": "[599115] Řípec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 599115,
        "val": "[599115] Ripec 3110 [599115] Řípec"
    },
    {
        "kod": 599263,
        "nazev": "Sedlečko u Soběslavě",
        "popis": "[599263] Sedlečko u Soběslavě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 599263,
        "val": "[599263] Sedlecko u Sobeslave 3110 [599263] Sedlečko u Soběslavě"
    },
    {
        "kod": 553069,
        "nazev": "Sezimovo Ústí",
        "popis": "[553069] Sezimovo Ústí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553069,
        "val": "[553069] Sezimovo Usti 3112 [553069] Sezimovo Ústí"
    },
    {
        "kod": 553077,
        "nazev": "Skalice",
        "popis": "[553077] Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553077,
        "val": "[553077] Skalice 3110 [553077] Skalice"
    },
    {
        "kod": 553085,
        "nazev": "Skopytce",
        "popis": "[553085] Skopytce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553085,
        "val": "[553085] Skopytce 3112 [553085] Skopytce"
    },
    {
        "kod": 560669,
        "nazev": "Skrýchov u Malšic",
        "popis": "[560669] Skrýchov u Malšic",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560669,
        "val": "[560669] Skrychov u Malsic 3112 [560669] Skrýchov u Malšic"
    },
    {
        "kod": 599026,
        "nazev": "Slapsko",
        "popis": "[599026] Slapsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 599026,
        "val": "[599026] Slapsko 3112 [599026] Slapsko"
    },
    {
        "kod": 599042,
        "nazev": "Slapy",
        "popis": "[599042] Slapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 599042,
        "val": "[599042] Slapy 3112 [599042] Slapy"
    },
    {
        "kod": 553123,
        "nazev": "Smilovy Hory",
        "popis": "[553123] Smilovy Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553123,
        "val": "[553123] Smilovy Hory 3112 [553123] Smilovy Hory"
    },
    {
        "kod": 553131,
        "nazev": "Soběslav",
        "popis": "[553131] Soběslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553131,
        "val": "[553131] Sobeslav 3110 [553131] Soběslav"
    },
    {
        "kod": 553140,
        "nazev": "Stádlec",
        "popis": "[553140] Stádlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553140,
        "val": "[553140] Stadlec 3112 [553140] Stádlec"
    },
    {
        "kod": 553166,
        "nazev": "Sudoměřice u Bechyně",
        "popis": "[553166] Sudoměřice u Bechyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553166,
        "val": "[553166] Sudomerice u Bechyne 3112 [553166] Sudoměřice u Bechyně"
    },
    {
        "kod": 553174,
        "nazev": "Sudoměřice u Tábora",
        "popis": "[553174] Sudoměřice u Tábora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553174,
        "val": "[553174] Sudomerice u Tabora 3112 [553174] Sudoměřice u Tábora"
    },
    {
        "kod": 553182,
        "nazev": "Sviny",
        "popis": "[553182] Sviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553182,
        "val": "[553182] Sviny 3110 [553182] Sviny"
    },
    {
        "kod": 563170,
        "nazev": "Svrabov",
        "popis": "[563170] Svrabov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563170,
        "val": "[563170] Svrabov 3112 [563170] Svrabov"
    },
    {
        "kod": 553204,
        "nazev": "Šebířov",
        "popis": "[553204] Šebířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553204,
        "val": "[553204] Sebirov 3112 [553204] Šebířov"
    },
    {
        "kod": 552046,
        "nazev": "Tábor",
        "popis": "[552046] Tábor",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 552046,
        "val": "[552046] Tabor 3112 [552046] Tábor"
    },
    {
        "kod": 563153,
        "nazev": "Třebějice",
        "popis": "[563153] Třebějice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 563153,
        "val": "[563153] Trebejice 3110 [563153] Třebějice"
    },
    {
        "kod": 553239,
        "nazev": "Tučapy",
        "popis": "[553239] Tučapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553239,
        "val": "[553239] Tucapy 3110 [553239] Tučapy"
    },
    {
        "kod": 551601,
        "nazev": "Turovec",
        "popis": "[551601] Turovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 551601,
        "val": "[551601] Turovec 3112 [551601] Turovec"
    },
    {
        "kod": 599123,
        "nazev": "Ústrašice",
        "popis": "[599123] Ústrašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 599123,
        "val": "[599123] Ustrasice 3112 [599123] Ústrašice"
    },
    {
        "kod": 553255,
        "nazev": "Val",
        "popis": "[553255] Val",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553255,
        "val": "[553255] Val 3110 [553255] Val"
    },
    {
        "kod": 553263,
        "nazev": "Vesce",
        "popis": "[553263] Vesce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553263,
        "val": "[553263] Vesce 3110 [553263] Vesce"
    },
    {
        "kod": 553271,
        "nazev": "Veselí nad Lužnicí",
        "popis": "[553271] Veselí nad Lužnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553271,
        "val": "[553271] Veseli nad Luznici 3110 [553271] Veselí nad Lužnicí"
    },
    {
        "kod": 553280,
        "nazev": "Vilice",
        "popis": "[553280] Vilice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553280,
        "val": "[553280] Vilice 3112 [553280] Vilice"
    },
    {
        "kod": 553298,
        "nazev": "Vlastiboř",
        "popis": "[553298] Vlastiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553298,
        "val": "[553298] Vlastibor 3110 [553298] Vlastiboř"
    },
    {
        "kod": 563447,
        "nazev": "Vlčeves",
        "popis": "[563447] Vlčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563447,
        "val": "[563447] Vlceves 3112 [563447] Vlčeves"
    },
    {
        "kod": 553310,
        "nazev": "Vlkov",
        "popis": "[553310] Vlkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553310,
        "val": "[553310] Vlkov 3110 [553310] Vlkov"
    },
    {
        "kod": 553328,
        "nazev": "Vodice",
        "popis": "[553328] Vodice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553328,
        "val": "[553328] Vodice 3112 [553328] Vodice"
    },
    {
        "kod": 563927,
        "nazev": "Zadní Střítež",
        "popis": "[563927] Zadní Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 563927,
        "val": "[563927] Zadni Stritez 3112 [563927] Zadní Střítež"
    },
    {
        "kod": 599000,
        "nazev": "Záhoří",
        "popis": "[599000] Záhoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 599000,
        "val": "[599000] Zahori 3112 [599000] Záhoří"
    },
    {
        "kod": 553361,
        "nazev": "Zálší",
        "popis": "[553361] Zálší",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553361,
        "val": "[553361] Zalsi 3110 [553361] Zálší"
    },
    {
        "kod": 599034,
        "nazev": "Zhoř u Mladé Vožice",
        "popis": "[599034] Zhoř u Mladé Vožice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 599034,
        "val": "[599034] Zhor u Mlade Vozice 3112 [599034] Zhoř u Mladé Vožice"
    },
    {
        "kod": 560430,
        "nazev": "Zhoř u Tábora",
        "popis": "[560430] Zhoř u Tábora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 560430,
        "val": "[560430] Zhor u Tabora 3112 [560430] Zhoř u Tábora"
    },
    {
        "kod": 599271,
        "nazev": "Zlukov",
        "popis": "[599271] Zlukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 599271,
        "val": "[599271] Zlukov 3110 [599271] Zlukov"
    },
    {
        "kod": 553409,
        "nazev": "Zvěrotice",
        "popis": "[553409] Zvěrotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 553409,
        "val": "[553409] Zverotice 3110 [553409] Zvěrotice"
    },
    {
        "kod": 553417,
        "nazev": "Želeč",
        "popis": "[553417] Želeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3112,
        "iczuj": 553417,
        "val": "[553417] Zelec 3112 [553417] Želeč"
    },
    {
        "kod": 563897,
        "nazev": "Žíšov",
        "popis": "[563897] Žíšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3110,
        "iczuj": 563897,
        "val": "[563897] Zisov 3110 [563897] Žíšov"
    },
    {
        "kod": 553433,
        "nazev": "Babylon",
        "popis": "[553433] Babylon",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553433,
        "val": "[553433] Babylon 3202 [553433] Babylon"
    },
    {
        "kod": 553441,
        "nazev": "Bělá nad Radbuzou",
        "popis": "[553441] Bělá nad Radbuzou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553441,
        "val": "[553441] Bela nad Radbuzou 3202 [553441] Bělá nad Radbuzou"
    },
    {
        "kod": 553450,
        "nazev": "Blížejov",
        "popis": "[553450] Blížejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553450,
        "val": "[553450] Blizejov 3204 [553450] Blížejov"
    },
    {
        "kod": 566136,
        "nazev": "Brnířov",
        "popis": "[566136] Brnířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566136,
        "val": "[566136] Brnirov 3202 [566136] Brnířov"
    },
    {
        "kod": 553506,
        "nazev": "Bukovec",
        "popis": "[553506] Bukovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 553506,
        "val": "[553506] Bukovec 3212 [553506] Bukovec"
    },
    {
        "kod": 566080,
        "nazev": "Čečovice",
        "popis": "[566080] Čečovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 566080,
        "val": "[566080] Cecovice 3212 [566080] Čečovice"
    },
    {
        "kod": 553514,
        "nazev": "Čermná",
        "popis": "[553514] Čermná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553514,
        "val": "[553514] Cermna 3204 [553514] Čermná"
    },
    {
        "kod": 566098,
        "nazev": "Černovice",
        "popis": "[566098] Černovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 566098,
        "val": "[566098] Cernovice 3212 [566098] Černovice"
    },
    {
        "kod": 553549,
        "nazev": "Česká Kubice",
        "popis": "[553549] Česká Kubice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553549,
        "val": "[553549] Ceska Kubice 3202 [553549] Česká Kubice"
    },
    {
        "kod": 553557,
        "nazev": "Díly",
        "popis": "[553557] Díly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553557,
        "val": "[553557] Dily 3202 [553557] Díly"
    },
    {
        "kod": 553425,
        "nazev": "Domažlice",
        "popis": "[553425] Domažlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553425,
        "val": "[553425] Domazlice 3202 [553425] Domažlice"
    },
    {
        "kod": 553573,
        "nazev": "Drahotín",
        "popis": "[553573] Drahotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553573,
        "val": "[553573] Drahotin 3202 [553573] Drahotín"
    },
    {
        "kod": 553581,
        "nazev": "Draženov",
        "popis": "[553581] Draženov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553581,
        "val": "[553581] Drazenov 3202 [553581] Draženov"
    },
    {
        "kod": 553620,
        "nazev": "Hlohová",
        "popis": "[553620] Hlohová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553620,
        "val": "[553620] Hlohova 3204 [553620] Hlohová"
    },
    {
        "kod": 566641,
        "nazev": "Hlohovčice",
        "popis": "[566641] Hlohovčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 566641,
        "val": "[566641] Hlohovcice 3204 [566641] Hlohovčice"
    },
    {
        "kod": 553654,
        "nazev": "Holýšov",
        "popis": "[553654] Holýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 553654,
        "val": "[553654] Holysov 3212 [553654] Holýšov"
    },
    {
        "kod": 566276,
        "nazev": "Hora Svatého Václava",
        "popis": "[566276] Hora Svatého Václava",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566276,
        "val": "[566276] Hora Svateho Vaclava 3202 [566276] Hora Svatého Václava"
    },
    {
        "kod": 553662,
        "nazev": "Horní Kamenice",
        "popis": "[553662] Horní Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 553662,
        "val": "[553662] Horni Kamenice 3212 [553662] Horní Kamenice"
    },
    {
        "kod": 553671,
        "nazev": "Horšovský Týn",
        "popis": "[553671] Horšovský Týn",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553671,
        "val": "[553671] Horsovsky Tyn 3204 [553671] Horšovský Týn"
    },
    {
        "kod": 553689,
        "nazev": "Hostouň",
        "popis": "[553689] Hostouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553689,
        "val": "[553689] Hostoun 3202 [553689] Hostouň"
    },
    {
        "kod": 566179,
        "nazev": "Hradiště",
        "popis": "[566179] Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566179,
        "val": "[566179] Hradiste 3202 [566179] Hradiště"
    },
    {
        "kod": 566331,
        "nazev": "Hvožďany",
        "popis": "[566331] Hvožďany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566331,
        "val": "[566331] Hvozdany 3202 [566331] Hvožďany"
    },
    {
        "kod": 553727,
        "nazev": "Chocomyšl",
        "popis": "[553727] Chocomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553727,
        "val": "[553727] Chocomysl 3202 [553727] Chocomyšl"
    },
    {
        "kod": 553735,
        "nazev": "Chodov",
        "popis": "[553735] Chodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553735,
        "val": "[553735] Chodov 3202 [553735] Chodov"
    },
    {
        "kod": 553743,
        "nazev": "Chodská Lhota",
        "popis": "[553743] Chodská Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553743,
        "val": "[553743] Chodska Lhota 3202 [553743] Chodská Lhota"
    },
    {
        "kod": 553751,
        "nazev": "Chrastavice",
        "popis": "[553751] Chrastavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553751,
        "val": "[553751] Chrastavice 3202 [553751] Chrastavice"
    },
    {
        "kod": 566144,
        "nazev": "Kanice",
        "popis": "[566144] Kanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566144,
        "val": "[566144] Kanice 3202 [566144] Kanice"
    },
    {
        "kod": 553778,
        "nazev": "Kaničky",
        "popis": "[553778] Kaničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553778,
        "val": "[553778] Kanicky 3202 [553778] Kaničky"
    },
    {
        "kod": 553786,
        "nazev": "Kdyně",
        "popis": "[553786] Kdyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553786,
        "val": "[553786] Kdyne 3202 [553786] Kdyně"
    },
    {
        "kod": 553794,
        "nazev": "Klenčí pod Čerchovem",
        "popis": "[553794] Klenčí pod Čerchovem",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553794,
        "val": "[553794] Klenci pod Cerchovem 3202 [553794] Klenčí pod Čerchovem"
    },
    {
        "kod": 553816,
        "nazev": "Koloveč",
        "popis": "[553816] Koloveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553816,
        "val": "[553816] Kolovec 3202 [553816] Koloveč"
    },
    {
        "kod": 553824,
        "nazev": "Kout na Šumavě",
        "popis": "[553824] Kout na Šumavě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553824,
        "val": "[553824] Kout na Sumave 3202 [553824] Kout na Šumavě"
    },
    {
        "kod": 553832,
        "nazev": "Křenovy",
        "popis": "[553832] Křenovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553832,
        "val": "[553832] Krenovy 3204 [553832] Křenovy"
    },
    {
        "kod": 553841,
        "nazev": "Kvíčovice",
        "popis": "[553841] Kvíčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 553841,
        "val": "[553841] Kvicovice 3212 [553841] Kvíčovice"
    },
    {
        "kod": 553859,
        "nazev": "Libkov",
        "popis": "[553859] Libkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553859,
        "val": "[553859] Libkov 3202 [553859] Libkov"
    },
    {
        "kod": 553867,
        "nazev": "Loučim",
        "popis": "[553867] Loučim",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553867,
        "val": "[553867] Loucim 3202 [553867] Loučim"
    },
    {
        "kod": 553891,
        "nazev": "Luženičky",
        "popis": "[553891] Luženičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553891,
        "val": "[553891] Luzenicky 3202 [553891] Luženičky"
    },
    {
        "kod": 553913,
        "nazev": "Meclov",
        "popis": "[553913] Meclov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553913,
        "val": "[553913] Meclov 3204 [553913] Meclov"
    },
    {
        "kod": 553921,
        "nazev": "Mezholezy (dříve okres Domažlice)",
        "popis": "[553921] Mezholezy (dříve okres Domažlice)",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553921,
        "val": "[553921] Mezholezy (drive okres Domazlice) 3202 [553921] Mezholezy (dříve okres Domažlice)"
    },
    {
        "kod": 553930,
        "nazev": "Mezholezy (dříve okres Horšovský Týn)",
        "popis": "[553930] Mezholezy (dříve okres Horšovský Týn)",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553930,
        "val": "[553930] Mezholezy (drive okres Horsovsky Tyn) 3204 [553930] Mezholezy (dříve okres Horšovský Týn)"
    },
    {
        "kod": 553948,
        "nazev": "Milavče",
        "popis": "[553948] Milavče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553948,
        "val": "[553948] Milavce 3202 [553948] Milavče"
    },
    {
        "kod": 553956,
        "nazev": "Mířkov",
        "popis": "[553956] Mířkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 553956,
        "val": "[553956] Mirkov 3204 [553956] Mířkov"
    },
    {
        "kod": 566292,
        "nazev": "Mnichov",
        "popis": "[566292] Mnichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566292,
        "val": "[566292] Mnichov 3202 [566292] Mnichov"
    },
    {
        "kod": 599174,
        "nazev": "Močerady",
        "popis": "[599174] Močerady",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 599174,
        "val": "[599174] Mocerady 3204 [599174] Močerady"
    },
    {
        "kod": 553981,
        "nazev": "Mrákov",
        "popis": "[553981] Mrákov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553981,
        "val": "[553981] Mrakov 3202 [553981] Mrákov"
    },
    {
        "kod": 553999,
        "nazev": "Mutěnín",
        "popis": "[553999] Mutěnín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 553999,
        "val": "[553999] Mutenin 3202 [553999] Mutěnín"
    },
    {
        "kod": 554006,
        "nazev": "Nemanice",
        "popis": "[554006] Nemanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554006,
        "val": "[554006] Nemanice 3202 [554006] Nemanice"
    },
    {
        "kod": 599166,
        "nazev": "Němčice",
        "popis": "[599166] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 599166,
        "val": "[599166] Nemcice 3202 [599166] Němčice"
    },
    {
        "kod": 554022,
        "nazev": "Neuměř",
        "popis": "[554022] Neuměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 554022,
        "val": "[554022] Neumer 3212 [554022] Neuměř"
    },
    {
        "kod": 554031,
        "nazev": "Nevolice",
        "popis": "[554031] Nevolice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554031,
        "val": "[554031] Nevolice 3202 [554031] Nevolice"
    },
    {
        "kod": 599131,
        "nazev": "Nová Ves",
        "popis": "[599131] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 599131,
        "val": "[599131] Nova Ves 3202 [599131] Nová Ves"
    },
    {
        "kod": 554057,
        "nazev": "Nový Kramolín",
        "popis": "[554057] Nový Kramolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554057,
        "val": "[554057] Novy Kramolin 3202 [554057] Nový Kramolín"
    },
    {
        "kod": 554073,
        "nazev": "Osvračín",
        "popis": "[554073] Osvračín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554073,
        "val": "[554073] Osvracin 3204 [554073] Osvračín"
    },
    {
        "kod": 566209,
        "nazev": "Otov",
        "popis": "[566209] Otov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566209,
        "val": "[566209] Otov 3202 [566209] Otov"
    },
    {
        "kod": 599182,
        "nazev": "Pařezov",
        "popis": "[599182] Pařezov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 599182,
        "val": "[599182] Parezov 3202 [599182] Pařezov"
    },
    {
        "kod": 554081,
        "nazev": "Pasečnice",
        "popis": "[554081] Pasečnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554081,
        "val": "[554081] Pasecnice 3202 [554081] Pasečnice"
    },
    {
        "kod": 554090,
        "nazev": "Pec",
        "popis": "[554090] Pec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554090,
        "val": "[554090] Pec 3202 [554090] Pec"
    },
    {
        "kod": 566373,
        "nazev": "Pelechy",
        "popis": "[566373] Pelechy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566373,
        "val": "[566373] Pelechy 3202 [566373] Pelechy"
    },
    {
        "kod": 554111,
        "nazev": "Poběžovice",
        "popis": "[554111] Poběžovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554111,
        "val": "[554111] Pobezovice 3202 [554111] Poběžovice"
    },
    {
        "kod": 554120,
        "nazev": "Pocinovice",
        "popis": "[554120] Pocinovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554120,
        "val": "[554120] Pocinovice 3202 [554120] Pocinovice"
    },
    {
        "kod": 566365,
        "nazev": "Poděvousy",
        "popis": "[566365] Poděvousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 566365,
        "val": "[566365] Podevousy 3204 [566365] Poděvousy"
    },
    {
        "kod": 554138,
        "nazev": "Postřekov",
        "popis": "[554138] Postřekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554138,
        "val": "[554138] Postrekov 3202 [554138] Postřekov"
    },
    {
        "kod": 554154,
        "nazev": "Puclice",
        "popis": "[554154] Puclice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554154,
        "val": "[554154] Puclice 3204 [554154] Puclice"
    },
    {
        "kod": 554189,
        "nazev": "Rybník",
        "popis": "[554189] Rybník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554189,
        "val": "[554189] Rybnik 3202 [554189] Rybník"
    },
    {
        "kod": 554201,
        "nazev": "Semněvice",
        "popis": "[554201] Semněvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554201,
        "val": "[554201] Semnevice 3204 [554201] Semněvice"
    },
    {
        "kod": 554251,
        "nazev": "Spáňov",
        "popis": "[554251] Spáňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554251,
        "val": "[554251] Spanov 3202 [554251] Spáňov"
    },
    {
        "kod": 554260,
        "nazev": "Srbice",
        "popis": "[554260] Srbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554260,
        "val": "[554260] Srbice 3202 [554260] Srbice"
    },
    {
        "kod": 554278,
        "nazev": "Srby",
        "popis": "[554278] Srby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554278,
        "val": "[554278] Srby 3204 [554278] Srby"
    },
    {
        "kod": 554294,
        "nazev": "Staňkov",
        "popis": "[554294] Staňkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554294,
        "val": "[554294] Stankov 3204 [554294] Staňkov"
    },
    {
        "kod": 554316,
        "nazev": "Stráž",
        "popis": "[554316] Stráž",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554316,
        "val": "[554316] Straz 3202 [554316] Stráž"
    },
    {
        "kod": 566101,
        "nazev": "Štichov",
        "popis": "[566101] Štichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 566101,
        "val": "[566101] Stichov 3212 [566101] Štichov"
    },
    {
        "kod": 554341,
        "nazev": "Tlumačov",
        "popis": "[554341] Tlumačov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554341,
        "val": "[554341] Tlumacov 3202 [554341] Tlumačov"
    },
    {
        "kod": 554359,
        "nazev": "Trhanov",
        "popis": "[554359] Trhanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554359,
        "val": "[554359] Trhanov 3202 [554359] Trhanov"
    },
    {
        "kod": 566161,
        "nazev": "Úboč",
        "popis": "[566161] Úboč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566161,
        "val": "[566161] Uboc 3202 [566161] Úboč"
    },
    {
        "kod": 554383,
        "nazev": "Újezd",
        "popis": "[554383] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554383,
        "val": "[554383] Ujezd 3202 [554383] Újezd"
    },
    {
        "kod": 554391,
        "nazev": "Únějovice",
        "popis": "[554391] Únějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554391,
        "val": "[554391] Unejovice 3202 [554391] Únějovice"
    },
    {
        "kod": 554405,
        "nazev": "Úsilov",
        "popis": "[554405] Úsilov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554405,
        "val": "[554405] Usilov 3202 [554405] Úsilov"
    },
    {
        "kod": 554413,
        "nazev": "Velký Malahov",
        "popis": "[554413] Velký Malahov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554413,
        "val": "[554413] Velky Malahov 3204 [554413] Velký Malahov"
    },
    {
        "kod": 554421,
        "nazev": "Vidice",
        "popis": "[554421] Vidice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3204,
        "iczuj": 554421,
        "val": "[554421] Vidice 3204 [554421] Vidice"
    },
    {
        "kod": 566250,
        "nazev": "Vlkanov",
        "popis": "[566250] Vlkanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 566250,
        "val": "[566250] Vlkanov 3202 [566250] Vlkanov"
    },
    {
        "kod": 566071,
        "nazev": "Všekary",
        "popis": "[566071] Všekary",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 566071,
        "val": "[566071] Vsekary 3212 [566071] Všekary"
    },
    {
        "kod": 554448,
        "nazev": "Všepadly",
        "popis": "[554448] Všepadly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554448,
        "val": "[554448] Vsepadly 3202 [554448] Všepadly"
    },
    {
        "kod": 554456,
        "nazev": "Všeruby",
        "popis": "[554456] Všeruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554456,
        "val": "[554456] Vseruby 3202 [554456] Všeruby"
    },
    {
        "kod": 554464,
        "nazev": "Zahořany",
        "popis": "[554464] Zahořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554464,
        "val": "[554464] Zahorany 3202 [554464] Zahořany"
    },
    {
        "kod": 554472,
        "nazev": "Ždánov",
        "popis": "[554472] Ždánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3202,
        "iczuj": 554472,
        "val": "[554472] Zdanov 3202 [554472] Ždánov"
    },
    {
        "kod": 541842,
        "nazev": "Běhařov",
        "popis": "[541842] Běhařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541842,
        "val": "[541842] Beharov 3205 [541842] Běhařov"
    },
    {
        "kod": 555797,
        "nazev": "Běšiny",
        "popis": "[555797] Běšiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 555797,
        "val": "[555797] Besiny 3205 [555797] Běšiny"
    },
    {
        "kod": 555801,
        "nazev": "Bezděkov",
        "popis": "[555801] Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 555801,
        "val": "[555801] Bezdekov 3205 [555801] Bezděkov"
    },
    {
        "kod": 578088,
        "nazev": "Biřkov",
        "popis": "[578088] Biřkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578088,
        "val": "[578088] Birkov 3205 [578088] Biřkov"
    },
    {
        "kod": 555835,
        "nazev": "Bolešiny",
        "popis": "[555835] Bolešiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 555835,
        "val": "[555835] Bolesiny 3205 [555835] Bolešiny"
    },
    {
        "kod": 541923,
        "nazev": "Břežany",
        "popis": "[541923] Břežany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 541923,
        "val": "[541923] Brezany 3203 [541923] Břežany"
    },
    {
        "kod": 555894,
        "nazev": "Budětice",
        "popis": "[555894] Budětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 555894,
        "val": "[555894] Budetice 3214 [555894] Budětice"
    },
    {
        "kod": 530085,
        "nazev": "Bukovník",
        "popis": "[530085] Bukovník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 530085,
        "val": "[530085] Bukovnik 3214 [530085] Bukovník"
    },
    {
        "kod": 555941,
        "nazev": "Čachrov",
        "popis": "[555941] Čachrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 555941,
        "val": "[555941] Cachrov 3205 [555941] Čachrov"
    },
    {
        "kod": 553531,
        "nazev": "Černíkov",
        "popis": "[553531] Černíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 553531,
        "val": "[553531] Cernikov 3205 [553531] Černíkov"
    },
    {
        "kod": 542172,
        "nazev": "Červené Poříčí",
        "popis": "[542172] Červené Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 542172,
        "val": "[542172] Cervene Porici 3205 [542172] Červené Poříčí"
    },
    {
        "kod": 542024,
        "nazev": "Číhaň",
        "popis": "[542024] Číhaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 542024,
        "val": "[542024] Cihan 3205 [542024] Číhaň"
    },
    {
        "kod": 578495,
        "nazev": "Čímice",
        "popis": "[578495] Čímice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 578495,
        "val": "[578495] Cimice 3214 [578495] Čímice"
    },
    {
        "kod": 556041,
        "nazev": "Dešenice",
        "popis": "[556041] Dešenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556041,
        "val": "[556041] Desenice 3205 [556041] Dešenice"
    },
    {
        "kod": 556068,
        "nazev": "Dlažov",
        "popis": "[556068] Dlažov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556068,
        "val": "[556068] Dlazov 3205 [556068] Dlažov"
    },
    {
        "kod": 556076,
        "nazev": "Dlouhá Ves",
        "popis": "[556076] Dlouhá Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556076,
        "val": "[556076] Dlouha Ves 3214 [556076] Dlouhá Ves"
    },
    {
        "kod": 530123,
        "nazev": "Dobršín",
        "popis": "[530123] Dobršín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 530123,
        "val": "[530123] Dobrsin 3214 [530123] Dobršín"
    },
    {
        "kod": 556106,
        "nazev": "Dolany",
        "popis": "[556106] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556106,
        "val": "[556106] Dolany 3205 [556106] Dolany"
    },
    {
        "kod": 578517,
        "nazev": "Domoraz",
        "popis": "[578517] Domoraz",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 578517,
        "val": "[578517] Domoraz 3214 [578517] Domoraz"
    },
    {
        "kod": 566683,
        "nazev": "Dražovice",
        "popis": "[566683] Dražovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 566683,
        "val": "[566683] Drazovice 3214 [566683] Dražovice"
    },
    {
        "kod": 578525,
        "nazev": "Frymburk",
        "popis": "[578525] Frymburk",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 578525,
        "val": "[578525] Frymburk 3214 [578525] Frymburk"
    },
    {
        "kod": 578240,
        "nazev": "Hamry",
        "popis": "[578240] Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578240,
        "val": "[578240] Hamry 3205 [578240] Hamry"
    },
    {
        "kod": 556181,
        "nazev": "Hartmanice",
        "popis": "[556181] Hartmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556181,
        "val": "[556181] Hartmanice 3214 [556181] Hartmanice"
    },
    {
        "kod": 541796,
        "nazev": "Hejná",
        "popis": "[541796] Hejná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 541796,
        "val": "[541796] Hejna 3203 [541796] Hejná"
    },
    {
        "kod": 556203,
        "nazev": "Hlavňovice",
        "popis": "[556203] Hlavňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556203,
        "val": "[556203] Hlavnovice 3214 [556203] Hlavňovice"
    },
    {
        "kod": 542083,
        "nazev": "Hnačov",
        "popis": "[542083] Hnačov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 542083,
        "val": "[542083] Hnacov 3205 [542083] Hnačov"
    },
    {
        "kod": 556254,
        "nazev": "Horažďovice",
        "popis": "[556254] Horažďovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556254,
        "val": "[556254] Horazdovice 3203 [556254] Horažďovice"
    },
    {
        "kod": 542091,
        "nazev": "Horská Kvilda",
        "popis": "[542091] Horská Kvilda",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 542091,
        "val": "[542091] Horska Kvilda 3214 [542091] Horská Kvilda"
    },
    {
        "kod": 556301,
        "nazev": "Hrádek",
        "popis": "[556301] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556301,
        "val": "[556301] Hradek 3214 [556301] Hrádek"
    },
    {
        "kod": 556319,
        "nazev": "Hradešice",
        "popis": "[556319] Hradešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556319,
        "val": "[556319] Hradesice 3203 [556319] Hradešice"
    },
    {
        "kod": 556335,
        "nazev": "Chanovice",
        "popis": "[556335] Chanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556335,
        "val": "[556335] Chanovice 3203 [556335] Chanovice"
    },
    {
        "kod": 556343,
        "nazev": "Chlistov",
        "popis": "[556343] Chlistov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556343,
        "val": "[556343] Chlistov 3205 [556343] Chlistov"
    },
    {
        "kod": 556378,
        "nazev": "Chudenice",
        "popis": "[556378] Chudenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556378,
        "val": "[556378] Chudenice 3205 [556378] Chudenice"
    },
    {
        "kod": 556386,
        "nazev": "Chudenín",
        "popis": "[556386] Chudenín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556386,
        "val": "[556386] Chudenin 3205 [556386] Chudenín"
    },
    {
        "kod": 556394,
        "nazev": "Janovice nad Úhlavou",
        "popis": "[556394] Janovice nad Úhlavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556394,
        "val": "[556394] Janovice nad Uhlavou 3205 [556394] Janovice nad Úhlavou"
    },
    {
        "kod": 541869,
        "nazev": "Javor",
        "popis": "[541869] Javor",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541869,
        "val": "[541869] Javor 3205 [541869] Javor"
    },
    {
        "kod": 541753,
        "nazev": "Ježovy",
        "popis": "[541753] Ježovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541753,
        "val": "[541753] Jezovy 3205 [541753] Ježovy"
    },
    {
        "kod": 556432,
        "nazev": "Kašperské Hory",
        "popis": "[556432] Kašperské Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556432,
        "val": "[556432] Kasperske Hory 3214 [556432] Kašperské Hory"
    },
    {
        "kod": 541826,
        "nazev": "Kejnice",
        "popis": "[541826] Kejnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 541826,
        "val": "[541826] Kejnice 3203 [541826] Kejnice"
    },
    {
        "kod": 555771,
        "nazev": "Klatovy",
        "popis": "[555771] Klatovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 555771,
        "val": "[555771] Klatovy 3205 [555771] Klatovy"
    },
    {
        "kod": 541851,
        "nazev": "Klenová",
        "popis": "[541851] Klenová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541851,
        "val": "[541851] Klenova 3205 [541851] Klenová"
    },
    {
        "kod": 556467,
        "nazev": "Kolinec",
        "popis": "[556467] Kolinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556467,
        "val": "[556467] Kolinec 3214 [556467] Kolinec"
    },
    {
        "kod": 578177,
        "nazev": "Kovčín",
        "popis": "[578177] Kovčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 578177,
        "val": "[578177] Kovcin 3203 [578177] Kovčín"
    },
    {
        "kod": 556505,
        "nazev": "Křenice",
        "popis": "[556505] Křenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556505,
        "val": "[556505] Krenice 3205 [556505] Křenice"
    },
    {
        "kod": 541931,
        "nazev": "Kvášňovice",
        "popis": "[541931] Kvášňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 541931,
        "val": "[541931] Kvasnovice 3203 [541931] Kvášňovice"
    },
    {
        "kod": 578070,
        "nazev": "Lomec",
        "popis": "[578070] Lomec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578070,
        "val": "[578070] Lomec 3205 [578070] Lomec"
    },
    {
        "kod": 556629,
        "nazev": "Malý Bor",
        "popis": "[556629] Malý Bor",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556629,
        "val": "[556629] Maly Bor 3203 [556629] Malý Bor"
    },
    {
        "kod": 578410,
        "nazev": "Maňovice",
        "popis": "[578410] Maňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 578410,
        "val": "[578410] Manovice 3203 [578410] Maňovice"
    },
    {
        "kod": 556637,
        "nazev": "Měčín",
        "popis": "[556637] Měčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556637,
        "val": "[556637] Mecin 3205 [556637] Měčín"
    },
    {
        "kod": 578461,
        "nazev": "Mezihoří",
        "popis": "[578461] Mezihoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578461,
        "val": "[578461] Mezihori 3205 [578461] Mezihoří"
    },
    {
        "kod": 542059,
        "nazev": "Mlýnské Struhadlo",
        "popis": "[542059] Mlýnské Struhadlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 542059,
        "val": "[542059] Mlynske Struhadlo 3205 [542059] Mlýnské Struhadlo"
    },
    {
        "kod": 542148,
        "nazev": "Modrava",
        "popis": "[542148] Modrava",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 542148,
        "val": "[542148] Modrava 3214 [542148] Modrava"
    },
    {
        "kod": 556718,
        "nazev": "Mochtín",
        "popis": "[556718] Mochtín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556718,
        "val": "[556718] Mochtin 3205 [556718] Mochtín"
    },
    {
        "kod": 556726,
        "nazev": "Mokrosuky",
        "popis": "[556726] Mokrosuky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556726,
        "val": "[556726] Mokrosuky 3214 [556726] Mokrosuky"
    },
    {
        "kod": 556734,
        "nazev": "Myslív",
        "popis": "[556734] Myslív",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556734,
        "val": "[556734] Mysliv 3203 [556734] Myslív"
    },
    {
        "kod": 541745,
        "nazev": "Myslovice",
        "popis": "[541745] Myslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541745,
        "val": "[541745] Myslovice 3205 [541745] Myslovice"
    },
    {
        "kod": 556751,
        "nazev": "Nalžovské Hory",
        "popis": "[556751] Nalžovské Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556751,
        "val": "[556751] Nalzovske Hory 3203 [556751] Nalžovské Hory"
    },
    {
        "kod": 578223,
        "nazev": "Nehodiv",
        "popis": "[578223] Nehodiv",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 578223,
        "val": "[578223] Nehodiv 3203 [578223] Nehodiv"
    },
    {
        "kod": 578533,
        "nazev": "Nezamyslice",
        "popis": "[578533] Nezamyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 578533,
        "val": "[578533] Nezamyslice 3214 [578533] Nezamyslice"
    },
    {
        "kod": 556815,
        "nazev": "Nezdice na Šumavě",
        "popis": "[556815] Nezdice na Šumavě",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556815,
        "val": "[556815] Nezdice na Sumave 3214 [556815] Nezdice na Šumavě"
    },
    {
        "kod": 556831,
        "nazev": "Nýrsko",
        "popis": "[556831] Nýrsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556831,
        "val": "[556831] Nyrsko 3205 [556831] Nýrsko"
    },
    {
        "kod": 541915,
        "nazev": "Obytce",
        "popis": "[541915] Obytce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541915,
        "val": "[541915] Obytce 3205 [541915] Obytce"
    },
    {
        "kod": 541958,
        "nazev": "Olšany",
        "popis": "[541958] Olšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 541958,
        "val": "[541958] Olsany 3203 [541958] Olšany"
    },
    {
        "kod": 578061,
        "nazev": "Ostřetice",
        "popis": "[578061] Ostřetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578061,
        "val": "[578061] Ostretice 3205 [578061] Ostřetice"
    },
    {
        "kod": 556912,
        "nazev": "Pačejov",
        "popis": "[556912] Pačejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 556912,
        "val": "[556912] Pacejov 3203 [556912] Pačejov"
    },
    {
        "kod": 556921,
        "nazev": "Petrovice u Sušice",
        "popis": "[556921] Petrovice u Sušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556921,
        "val": "[556921] Petrovice u Susice 3214 [556921] Petrovice u Sušice"
    },
    {
        "kod": 556955,
        "nazev": "Plánice",
        "popis": "[556955] Plánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 556955,
        "val": "[556955] Planice 3205 [556955] Plánice"
    },
    {
        "kod": 551686,
        "nazev": "Podmokly",
        "popis": "[551686] Podmokly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 551686,
        "val": "[551686] Podmokly 3214 [551686] Podmokly"
    },
    {
        "kod": 541788,
        "nazev": "Poleň",
        "popis": "[541788] Poleň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541788,
        "val": "[541788] Polen 3205 [541788] Poleň"
    },
    {
        "kod": 556084,
        "nazev": "Prášily",
        "popis": "[556084] Prášily",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 556084,
        "val": "[556084] Prasily 3214 [556084] Prášily"
    },
    {
        "kod": 557005,
        "nazev": "Předslav",
        "popis": "[557005] Předslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557005,
        "val": "[557005] Predslav 3205 [557005] Předslav"
    },
    {
        "kod": 557013,
        "nazev": "Rabí",
        "popis": "[557013] Rabí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557013,
        "val": "[557013] Rabi 3214 [557013] Rabí"
    },
    {
        "kod": 557021,
        "nazev": "Rejštejn",
        "popis": "[557021] Rejštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557021,
        "val": "[557021] Rejstejn 3214 [557021] Rejštejn"
    },
    {
        "kod": 578436,
        "nazev": "Slatina",
        "popis": "[578436] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 578436,
        "val": "[578436] Slatina 3203 [578436] Slatina"
    },
    {
        "kod": 557099,
        "nazev": "Soběšice",
        "popis": "[557099] Soběšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557099,
        "val": "[557099] Sobesice 3214 [557099] Soběšice"
    },
    {
        "kod": 557111,
        "nazev": "Srní",
        "popis": "[557111] Srní",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557111,
        "val": "[557111] Srni 3214 [557111] Srní"
    },
    {
        "kod": 557129,
        "nazev": "Strašín",
        "popis": "[557129] Strašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557129,
        "val": "[557129] Strasin 3214 [557129] Strašín"
    },
    {
        "kod": 557137,
        "nazev": "Strážov",
        "popis": "[557137] Strážov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557137,
        "val": "[557137] Strazov 3205 [557137] Strážov"
    },
    {
        "kod": 557153,
        "nazev": "Sušice",
        "popis": "[557153] Sušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557153,
        "val": "[557153] Susice 3214 [557153] Sušice"
    },
    {
        "kod": 557161,
        "nazev": "Svéradice",
        "popis": "[557161] Svéradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 557161,
        "val": "[557161] Sveradice 3203 [557161] Svéradice"
    },
    {
        "kod": 557200,
        "nazev": "Švihov",
        "popis": "[557200] Švihov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557200,
        "val": "[557200] Svihov 3205 [557200] Švihov"
    },
    {
        "kod": 553522,
        "nazev": "Tužice",
        "popis": "[553522] Tužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 553522,
        "val": "[553522] Tuzice 3203 [553522] Tužice"
    },
    {
        "kod": 541885,
        "nazev": "Týnec",
        "popis": "[541885] Týnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 541885,
        "val": "[541885] Tynec 3205 [541885] Týnec"
    },
    {
        "kod": 578321,
        "nazev": "Újezd u Plánice",
        "popis": "[578321] Újezd u Plánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578321,
        "val": "[578321] Ujezd u Planice 3205 [578321] Újezd u Plánice"
    },
    {
        "kod": 557366,
        "nazev": "Velhartice",
        "popis": "[557366] Velhartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557366,
        "val": "[557366] Velhartice 3214 [557366] Velhartice"
    },
    {
        "kod": 557374,
        "nazev": "Velké Hydčice",
        "popis": "[557374] Velké Hydčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 557374,
        "val": "[557374] Velke Hydcice 3203 [557374] Velké Hydčice"
    },
    {
        "kod": 557382,
        "nazev": "Velký Bor",
        "popis": "[557382] Velký Bor",
        "datum_od": "",
        "datum_do": "",
        "orp": 3203,
        "iczuj": 557382,
        "val": "[557382] Velky Bor 3203 [557382] Velký Bor"
    },
    {
        "kod": 557455,
        "nazev": "Vrhaveč",
        "popis": "[557455] Vrhaveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557455,
        "val": "[557455] Vrhavec 3205 [557455] Vrhaveč"
    },
    {
        "kod": 566055,
        "nazev": "Vřeskovice",
        "popis": "[566055] Vřeskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 566055,
        "val": "[566055] Vreskovice 3205 [566055] Vřeskovice"
    },
    {
        "kod": 557463,
        "nazev": "Zavlekov",
        "popis": "[557463] Zavlekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557463,
        "val": "[557463] Zavlekov 3205 [557463] Zavlekov"
    },
    {
        "kod": 578312,
        "nazev": "Zborovy",
        "popis": "[578312] Zborovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 578312,
        "val": "[578312] Zborovy 3205 [578312] Zborovy"
    },
    {
        "kod": 557528,
        "nazev": "Železná Ruda",
        "popis": "[557528] Železná Ruda",
        "datum_od": "",
        "datum_do": "",
        "orp": 3205,
        "iczuj": 557528,
        "val": "[557528] Zelezna Ruda 3205 [557528] Železná Ruda"
    },
    {
        "kod": 557536,
        "nazev": "Žihobce",
        "popis": "[557536] Žihobce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557536,
        "val": "[557536] Zihobce 3214 [557536] Žihobce"
    },
    {
        "kod": 557544,
        "nazev": "Žichovice",
        "popis": "[557544] Žichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3214,
        "iczuj": 557544,
        "val": "[557544] Zichovice 3214 [557544] Žichovice"
    },
    {
        "kod": 558851,
        "nazev": "Dýšina",
        "popis": "[558851] Dýšina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558851,
        "val": "[558851] Dysina 3209 [558851] Dýšina"
    },
    {
        "kod": 558966,
        "nazev": "Chrást",
        "popis": "[558966] Chrást",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558966,
        "val": "[558966] Chrast 3209 [558966] Chrást"
    },
    {
        "kod": 557846,
        "nazev": "Chválenice",
        "popis": "[557846] Chválenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 557846,
        "val": "[557846] Chvalenice 3209 [557846] Chválenice"
    },
    {
        "kod": 559130,
        "nazev": "Kyšice",
        "popis": "[559130] Kyšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 559130,
        "val": "[559130] Kysice 3209 [559130] Kyšice"
    },
    {
        "kod": 540561,
        "nazev": "Letkov",
        "popis": "[540561] Letkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 540561,
        "val": "[540561] Letkov 3209 [540561] Letkov"
    },
    {
        "kod": 578606,
        "nazev": "Lhůta",
        "popis": "[578606] Lhůta",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 578606,
        "val": "[578606] Lhuta 3209 [578606] Lhůta"
    },
    {
        "kod": 558001,
        "nazev": "Losiná",
        "popis": "[558001] Losiná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558001,
        "val": "[558001] Losina 3209 [558001] Losiná"
    },
    {
        "kod": 540641,
        "nazev": "Mokrouše",
        "popis": "[540641] Mokrouše",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 540641,
        "val": "[540641] Mokrouse 3209 [540641] Mokrouše"
    },
    {
        "kod": 553590,
        "nazev": "Nezbavětice",
        "popis": "[553590] Nezbavětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 553590,
        "val": "[553590] Nezbavetice 3209 [553590] Nezbavětice"
    },
    {
        "kod": 558141,
        "nazev": "Nezvěstice",
        "popis": "[558141] Nezvěstice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558141,
        "val": "[558141] Nezvestice 3209 [558141] Nezvěstice"
    },
    {
        "kod": 558371,
        "nazev": "Starý Plzenec",
        "popis": "[558371] Starý Plzenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558371,
        "val": "[558371] Stary Plzenec 3209 [558371] Starý Plzenec"
    },
    {
        "kod": 558427,
        "nazev": "Šťáhlavy",
        "popis": "[558427] Šťáhlavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558427,
        "val": "[558427] Stahlavy 3209 [558427] Šťáhlavy"
    },
    {
        "kod": 539741,
        "nazev": "Štěnovický Borek",
        "popis": "[539741] Štěnovický Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 539741,
        "val": "[539741] Stenovicky Borek 3209 [539741] Štěnovický Borek"
    },
    {
        "kod": 558460,
        "nazev": "Tymákov",
        "popis": "[558460] Tymákov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 558460,
        "val": "[558460] Tymakov 3209 [558460] Tymákov"
    },
    {
        "kod": 557587,
        "nazev": "Blovice",
        "popis": "[557587] Blovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 557587,
        "val": "[557587] Blovice 3201 [557587] Blovice"
    },
    {
        "kod": 540463,
        "nazev": "Bolkov",
        "popis": "[540463] Bolkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 540463,
        "val": "[540463] Bolkov 3210 [540463] Bolkov"
    },
    {
        "kod": 566705,
        "nazev": "Borovno",
        "popis": "[566705] Borovno",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 566705,
        "val": "[566705] Borovno 3201 [566705] Borovno"
    },
    {
        "kod": 542156,
        "nazev": "Borovy",
        "popis": "[542156] Borovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 542156,
        "val": "[542156] Borovy 3210 [542156] Borovy"
    },
    {
        "kod": 546372,
        "nazev": "Buková",
        "popis": "[546372] Buková",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 546372,
        "val": "[546372] Bukova 3210 [546372] Buková"
    },
    {
        "kod": 557641,
        "nazev": "Čižice",
        "popis": "[557641] Čižice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 557641,
        "val": "[557641] Cizice 3210 [557641] Čižice"
    },
    {
        "kod": 557650,
        "nazev": "Čížkov",
        "popis": "[557650] Čížkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 557650,
        "val": "[557650] Cizkov 3207 [557650] Čížkov"
    },
    {
        "kod": 578568,
        "nazev": "Čmelíny",
        "popis": "[578568] Čmelíny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 578568,
        "val": "[578568] Cmeliny 3207 [578568] Čmelíny"
    },
    {
        "kod": 557668,
        "nazev": "Dnešice",
        "popis": "[557668] Dnešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 557668,
        "val": "[557668] Dnesice 3212 [557668] Dnešice"
    },
    {
        "kod": 557676,
        "nazev": "Dobřany",
        "popis": "[557676] Dobřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 557676,
        "val": "[557676] Dobrany 3212 [557676] Dobřany"
    },
    {
        "kod": 539945,
        "nazev": "Dolce",
        "popis": "[539945] Dolce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 539945,
        "val": "[539945] Dolce 3210 [539945] Dolce"
    },
    {
        "kod": 557684,
        "nazev": "Dolní Lukavice",
        "popis": "[557684] Dolní Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 557684,
        "val": "[557684] Dolni Lukavice 3210 [557684] Dolní Lukavice"
    },
    {
        "kod": 540251,
        "nazev": "Drahkov",
        "popis": "[540251] Drahkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 540251,
        "val": "[540251] Drahkov 3201 [540251] Drahkov"
    },
    {
        "kod": 540668,
        "nazev": "Honezovice",
        "popis": "[540668] Honezovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540668,
        "val": "[540668] Honezovice 3212 [540668] Honezovice"
    },
    {
        "kod": 539821,
        "nazev": "Horní Lukavice",
        "popis": "[539821] Horní Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 539821,
        "val": "[539821] Horni Lukavice 3210 [539821] Horní Lukavice"
    },
    {
        "kod": 557722,
        "nazev": "Horšice",
        "popis": "[557722] Horšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 557722,
        "val": "[557722] Horsice 3210 [557722] Horšice"
    },
    {
        "kod": 557731,
        "nazev": "Hradec",
        "popis": "[557731] Hradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 557731,
        "val": "[557731] Hradec 3212 [557731] Hradec"
    },
    {
        "kod": 557749,
        "nazev": "Hradiště",
        "popis": "[557749] Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 557749,
        "val": "[557749] Hradiste 3207 [557749] Hradiště"
    },
    {
        "kod": 557773,
        "nazev": "Chlum",
        "popis": "[557773] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 557773,
        "val": "[557773] Chlum 3201 [557773] Chlum"
    },
    {
        "kod": 557781,
        "nazev": "Chlumčany",
        "popis": "[557781] Chlumčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 557781,
        "val": "[557781] Chlumcany 3210 [557781] Chlumčany"
    },
    {
        "kod": 540307,
        "nazev": "Chlumy",
        "popis": "[540307] Chlumy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540307,
        "val": "[540307] Chlumy 3207 [540307] Chlumy"
    },
    {
        "kod": 557803,
        "nazev": "Chocenice",
        "popis": "[557803] Chocenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 557803,
        "val": "[557803] Chocenice 3201 [557803] Chocenice"
    },
    {
        "kod": 557838,
        "nazev": "Chotěšov",
        "popis": "[557838] Chotěšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 557838,
        "val": "[557838] Chotesov 3212 [557838] Chotěšov"
    },
    {
        "kod": 578541,
        "nazev": "Jarov",
        "popis": "[578541] Jarov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 578541,
        "val": "[578541] Jarov 3201 [578541] Jarov"
    },
    {
        "kod": 557862,
        "nazev": "Kasejovice",
        "popis": "[557862] Kasejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 557862,
        "val": "[557862] Kasejovice 3207 [557862] Kasejovice"
    },
    {
        "kod": 557871,
        "nazev": "Kbel",
        "popis": "[557871] Kbel",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 557871,
        "val": "[557871] Kbel 3210 [557871] Kbel"
    },
    {
        "kod": 557897,
        "nazev": "Klášter",
        "popis": "[557897] Klášter",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 557897,
        "val": "[557897] Klaster 3207 [557897] Klášter"
    },
    {
        "kod": 540633,
        "nazev": "Kotovice",
        "popis": "[540633] Kotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540633,
        "val": "[540633] Kotovice 3212 [540633] Kotovice"
    },
    {
        "kod": 540200,
        "nazev": "Kozlovice",
        "popis": "[540200] Kozlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540200,
        "val": "[540200] Kozlovice 3207 [540200] Kozlovice"
    },
    {
        "kod": 557943,
        "nazev": "Kramolín",
        "popis": "[557943] Kramolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 557943,
        "val": "[557943] Kramolin 3207 [557943] Kramolín"
    },
    {
        "kod": 557951,
        "nazev": "Letiny",
        "popis": "[557951] Letiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 557951,
        "val": "[557951] Letiny 3201 [557951] Letiny"
    },
    {
        "kod": 540064,
        "nazev": "Lisov",
        "popis": "[540064] Lisov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540064,
        "val": "[540064] Lisov 3212 [540064] Lisov"
    },
    {
        "kod": 540617,
        "nazev": "Líšina",
        "popis": "[540617] Líšina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540617,
        "val": "[540617] Lisina 3212 [540617] Líšina"
    },
    {
        "kod": 558010,
        "nazev": "Louňová",
        "popis": "[558010] Louňová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558010,
        "val": "[558010] Lounova 3201 [558010] Louňová"
    },
    {
        "kod": 558028,
        "nazev": "Lužany",
        "popis": "[558028] Lužany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558028,
        "val": "[558028] Luzany 3210 [558028] Lužany"
    },
    {
        "kod": 539716,
        "nazev": "Měcholupy",
        "popis": "[539716] Měcholupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 539716,
        "val": "[539716] Mecholupy 3207 [539716] Měcholupy"
    },
    {
        "kod": 558044,
        "nazev": "Merklín",
        "popis": "[558044] Merklín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558044,
        "val": "[558044] Merklin 3210 [558044] Merklín"
    },
    {
        "kod": 558052,
        "nazev": "Mileč",
        "popis": "[558052] Mileč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558052,
        "val": "[558052] Milec 3207 [558052] Mileč"
    },
    {
        "kod": 530140,
        "nazev": "Milínov",
        "popis": "[530140] Milínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 530140,
        "val": "[530140] Milinov 3201 [530140] Milínov"
    },
    {
        "kod": 546399,
        "nazev": "Míšov",
        "popis": "[546399] Míšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 546399,
        "val": "[546399] Misov 3201 [546399] Míšov"
    },
    {
        "kod": 558061,
        "nazev": "Mladý Smolivec",
        "popis": "[558061] Mladý Smolivec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558061,
        "val": "[558061] Mlady Smolivec 3207 [558061] Mladý Smolivec"
    },
    {
        "kod": 558079,
        "nazev": "Mohelnice",
        "popis": "[558079] Mohelnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558079,
        "val": "[558079] Mohelnice 3207 [558079] Mohelnice"
    },
    {
        "kod": 540340,
        "nazev": "Nebílovy",
        "popis": "[540340] Nebílovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 540340,
        "val": "[540340] Nebilovy 3210 [540340] Nebílovy"
    },
    {
        "kod": 558095,
        "nazev": "Nekvasovy",
        "popis": "[558095] Nekvasovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558095,
        "val": "[558095] Nekvasovy 3207 [558095] Nekvasovy"
    },
    {
        "kod": 558109,
        "nazev": "Nepomuk",
        "popis": "[558109] Nepomuk",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558109,
        "val": "[558109] Nepomuk 3207 [558109] Nepomuk"
    },
    {
        "kod": 558117,
        "nazev": "Netunice",
        "popis": "[558117] Netunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558117,
        "val": "[558117] Netunice 3210 [558117] Netunice"
    },
    {
        "kod": 558125,
        "nazev": "Neurazy",
        "popis": "[558125] Neurazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558125,
        "val": "[558125] Neurazy 3207 [558125] Neurazy"
    },
    {
        "kod": 542296,
        "nazev": "Nezdice",
        "popis": "[542296] Nezdice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 542296,
        "val": "[542296] Nezdice 3210 [542296] Nezdice"
    },
    {
        "kod": 540102,
        "nazev": "Nezdřev",
        "popis": "[540102] Nezdřev",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540102,
        "val": "[540102] Nezdrev 3207 [540102] Nezdřev"
    },
    {
        "kod": 540269,
        "nazev": "Nová Ves",
        "popis": "[540269] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540269,
        "val": "[540269] Nova Ves 3212 [540269] Nová Ves"
    },
    {
        "kod": 558176,
        "nazev": "Nové Mitrovice",
        "popis": "[558176] Nové Mitrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558176,
        "val": "[558176] Nove Mitrovice 3201 [558176] Nové Mitrovice"
    },
    {
        "kod": 539783,
        "nazev": "Oplot",
        "popis": "[539783] Oplot",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 539783,
        "val": "[539783] Oplot 3210 [539783] Oplot"
    },
    {
        "kod": 558184,
        "nazev": "Oselce",
        "popis": "[558184] Oselce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558184,
        "val": "[558184] Oselce 3207 [558184] Oselce"
    },
    {
        "kod": 540293,
        "nazev": "Otěšice",
        "popis": "[540293] Otěšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 540293,
        "val": "[540293] Otesice 3210 [540293] Otěšice"
    },
    {
        "kod": 553565,
        "nazev": "Polánka",
        "popis": "[553565] Polánka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 553565,
        "val": "[553565] Polanka 3207 [553565] Polánka"
    },
    {
        "kod": 558231,
        "nazev": "Prádlo",
        "popis": "[558231] Prádlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558231,
        "val": "[558231] Pradlo 3207 [558231] Prádlo"
    },
    {
        "kod": 540412,
        "nazev": "Předenice",
        "popis": "[540412] Předenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 540412,
        "val": "[540412] Predenice 3210 [540412] Předenice"
    },
    {
        "kod": 530131,
        "nazev": "Přestavlky",
        "popis": "[530131] Přestavlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 530131,
        "val": "[530131] Prestavlky 3212 [530131] Přestavlky"
    },
    {
        "kod": 558249,
        "nazev": "Přeštice",
        "popis": "[558249] Přeštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558249,
        "val": "[558249] Prestice 3210 [558249] Přeštice"
    },
    {
        "kod": 558257,
        "nazev": "Příchovice",
        "popis": "[558257] Příchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558257,
        "val": "[558257] Prichovice 3210 [558257] Příchovice"
    },
    {
        "kod": 558265,
        "nazev": "Ptenín",
        "popis": "[558265] Ptenín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558265,
        "val": "[558265] Ptenin 3210 [558265] Ptenín"
    },
    {
        "kod": 540421,
        "nazev": "Radkovice",
        "popis": "[540421] Radkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 540421,
        "val": "[540421] Radkovice 3210 [540421] Radkovice"
    },
    {
        "kod": 558290,
        "nazev": "Roupov",
        "popis": "[558290] Roupov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558290,
        "val": "[558290] Roupov 3210 [558290] Roupov"
    },
    {
        "kod": 558303,
        "nazev": "Řenče",
        "popis": "[558303] Řenče",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558303,
        "val": "[558303] Rence 3210 [558303] Řenče"
    },
    {
        "kod": 558311,
        "nazev": "Seč",
        "popis": "[558311] Seč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558311,
        "val": "[558311] Sec 3201 [558311] Seč"
    },
    {
        "kod": 540692,
        "nazev": "Sedliště",
        "popis": "[540692] Sedliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540692,
        "val": "[540692] Sedliste 3207 [540692] Sedliště"
    },
    {
        "kod": 539937,
        "nazev": "Skašov",
        "popis": "[539937] Skašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 539937,
        "val": "[539937] Skasov 3210 [539937] Skašov"
    },
    {
        "kod": 558346,
        "nazev": "Soběkury",
        "popis": "[558346] Soběkury",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558346,
        "val": "[558346] Sobekury 3210 [558346] Soběkury"
    },
    {
        "kod": 558362,
        "nazev": "Spálené Poříčí",
        "popis": "[558362] Spálené Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558362,
        "val": "[558362] Spalene Porici 3201 [558362] Spálené Poříčí"
    },
    {
        "kod": 540676,
        "nazev": "Srby",
        "popis": "[540676] Srby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540676,
        "val": "[540676] Srby 3207 [540676] Srby"
    },
    {
        "kod": 558389,
        "nazev": "Stod",
        "popis": "[558389] Stod",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 558389,
        "val": "[558389] Stod 3212 [558389] Stod"
    },
    {
        "kod": 540056,
        "nazev": "Střelice",
        "popis": "[540056] Střelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 540056,
        "val": "[540056] Strelice 3212 [540056] Střelice"
    },
    {
        "kod": 558401,
        "nazev": "Střížovice",
        "popis": "[558401] Střížovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558401,
        "val": "[558401] Strizovice 3201 [558401] Střížovice"
    },
    {
        "kod": 558435,
        "nazev": "Štěnovice",
        "popis": "[558435] Štěnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558435,
        "val": "[558435] Stenovice 3210 [558435] Štěnovice"
    },
    {
        "kod": 578614,
        "nazev": "Tojice",
        "popis": "[578614] Tojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 578614,
        "val": "[578614] Tojice 3207 [578614] Tojice"
    },
    {
        "kod": 578592,
        "nazev": "Třebčice",
        "popis": "[578592] Třebčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 578592,
        "val": "[578592] Trebcice 3207 [578592] Třebčice"
    },
    {
        "kod": 539929,
        "nazev": "Týniště",
        "popis": "[539929] Týniště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 539929,
        "val": "[539929] Tyniste 3210 [539929] Týniště"
    },
    {
        "kod": 540528,
        "nazev": "Únětice",
        "popis": "[540528] Únětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 540528,
        "val": "[540528] Unetice 3201 [540528] Únětice"
    },
    {
        "kod": 558486,
        "nazev": "Útušice",
        "popis": "[558486] Útušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 558486,
        "val": "[558486] Utusice 3210 [558486] Útušice"
    },
    {
        "kod": 558494,
        "nazev": "Ves Touškov",
        "popis": "[558494] Ves Touškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 558494,
        "val": "[558494] Ves Touskov 3212 [558494] Ves Touškov"
    },
    {
        "kod": 566691,
        "nazev": "Vlčí",
        "popis": "[566691] Vlčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3210,
        "iczuj": 566691,
        "val": "[566691] Vlci 3210 [566691] Vlčí"
    },
    {
        "kod": 540706,
        "nazev": "Vlčtejn",
        "popis": "[540706] Vlčtejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 540706,
        "val": "[540706] Vlctejn 3201 [540706] Vlčtejn"
    },
    {
        "kod": 558559,
        "nazev": "Vrčeň",
        "popis": "[558559] Vrčeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558559,
        "val": "[558559] Vrcen 3207 [558559] Vrčeň"
    },
    {
        "kod": 558567,
        "nazev": "Vstiš",
        "popis": "[558567] Vstiš",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 558567,
        "val": "[558567] Vstis 3212 [558567] Vstiš"
    },
    {
        "kod": 558583,
        "nazev": "Zdemyslice",
        "popis": "[558583] Zdemyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558583,
        "val": "[558583] Zdemyslice 3201 [558583] Zdemyslice"
    },
    {
        "kod": 558591,
        "nazev": "Zemětice",
        "popis": "[558591] Zemětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3212,
        "iczuj": 558591,
        "val": "[558591] Zemetice 3212 [558591] Zemětice"
    },
    {
        "kod": 530182,
        "nazev": "Žákava",
        "popis": "[530182] Žákava",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 530182,
        "val": "[530182] Zakava 3201 [530182] Žákava"
    },
    {
        "kod": 558605,
        "nazev": "Ždírec",
        "popis": "[558605] Ždírec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3201,
        "iczuj": 558605,
        "val": "[558605] Zdirec 3201 [558605] Ždírec"
    },
    {
        "kod": 558630,
        "nazev": "Žinkovy",
        "popis": "[558630] Žinkovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 558630,
        "val": "[558630] Zinkovy 3207 [558630] Žinkovy"
    },
    {
        "kod": 540137,
        "nazev": "Životice",
        "popis": "[540137] Životice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3207,
        "iczuj": 540137,
        "val": "[540137] Zivotice 3207 [540137] Životice"
    },
    {
        "kod": 566756,
        "nazev": "Bdeněves",
        "popis": "[566756] Bdeněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 566756,
        "val": "[566756] Bdeneves 3208 [566756] Bdeněves"
    },
    {
        "kod": 558656,
        "nazev": "Bezvěrov",
        "popis": "[558656] Bezvěrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558656,
        "val": "[558656] Bezverov 3206 [558656] Bezvěrov"
    },
    {
        "kod": 530239,
        "nazev": "Bílov",
        "popis": "[530239] Bílov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 530239,
        "val": "[530239] Bilov 3206 [530239] Bílov"
    },
    {
        "kod": 558672,
        "nazev": "Blatnice",
        "popis": "[558672] Blatnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558672,
        "val": "[558672] Blatnice 3208 [558672] Blatnice"
    },
    {
        "kod": 566764,
        "nazev": "Blažim",
        "popis": "[566764] Blažim",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 566764,
        "val": "[566764] Blazim 3208 [566764] Blažim"
    },
    {
        "kod": 566471,
        "nazev": "Bohy",
        "popis": "[566471] Bohy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566471,
        "val": "[566471] Bohy 3206 [566471] Bohy"
    },
    {
        "kod": 566489,
        "nazev": "Brodeslavy",
        "popis": "[566489] Brodeslavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566489,
        "val": "[566489] Brodeslavy 3206 [566489] Brodeslavy"
    },
    {
        "kod": 558699,
        "nazev": "Bučí",
        "popis": "[558699] Bučí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558699,
        "val": "[558699] Buci 3208 [558699] Bučí"
    },
    {
        "kod": 558711,
        "nazev": "Čeminy",
        "popis": "[558711] Čeminy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558711,
        "val": "[558711] Ceminy 3208 [558711] Čeminy"
    },
    {
        "kod": 566632,
        "nazev": "Černíkovice",
        "popis": "[566632] Černíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566632,
        "val": "[566632] Cernikovice 3206 [566632] Černíkovice"
    },
    {
        "kod": 530328,
        "nazev": "Čerňovice",
        "popis": "[530328] Čerňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 530328,
        "val": "[530328] Cernovice 3208 [530328] Čerňovice"
    },
    {
        "kod": 558745,
        "nazev": "Česká Bříza",
        "popis": "[558745] Česká Bříza",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558745,
        "val": "[558745] Ceska Briza 3208 [558745] Česká Bříza"
    },
    {
        "kod": 558770,
        "nazev": "Dobříč",
        "popis": "[558770] Dobříč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558770,
        "val": "[558770] Dobric 3206 [558770] Dobříč"
    },
    {
        "kod": 558788,
        "nazev": "Dolany",
        "popis": "[558788] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558788,
        "val": "[558788] Dolany 3208 [558788] Dolany"
    },
    {
        "kod": 558796,
        "nazev": "Dolní Bělá",
        "popis": "[558796] Dolní Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558796,
        "val": "[558796] Dolni Bela 3206 [558796] Dolní Bělá"
    },
    {
        "kod": 558800,
        "nazev": "Dolní Hradiště",
        "popis": "[558800] Dolní Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558800,
        "val": "[558800] Dolni Hradiste 3206 [558800] Dolní Hradiště"
    },
    {
        "kod": 578665,
        "nazev": "Dražeň",
        "popis": "[578665] Dražeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 578665,
        "val": "[578665] Drazen 3206 [578665] Dražeň"
    },
    {
        "kod": 558834,
        "nazev": "Druztová",
        "popis": "[558834] Druztová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558834,
        "val": "[558834] Druztova 3208 [558834] Druztová"
    },
    {
        "kod": 558869,
        "nazev": "Heřmanova Huť",
        "popis": "[558869] Heřmanova Huť",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558869,
        "val": "[558869] Hermanova Hut 3208 [558869] Heřmanova Huť"
    },
    {
        "kod": 566390,
        "nazev": "Hlince",
        "popis": "[566390] Hlince",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566390,
        "val": "[566390] Hlince 3206 [566390] Hlince"
    },
    {
        "kod": 530221,
        "nazev": "Hněvnice",
        "popis": "[530221] Hněvnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 530221,
        "val": "[530221] Hnevnice 3208 [530221] Hněvnice"
    },
    {
        "kod": 566730,
        "nazev": "Holovousy",
        "popis": "[566730] Holovousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566730,
        "val": "[566730] Holovousy 3206 [566730] Holovousy"
    },
    {
        "kod": 558877,
        "nazev": "Horní Bělá",
        "popis": "[558877] Horní Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558877,
        "val": "[558877] Horni Bela 3206 [558877] Horní Bělá"
    },
    {
        "kod": 558885,
        "nazev": "Horní Bříza",
        "popis": "[558885] Horní Bříza",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558885,
        "val": "[558885] Horni Briza 3208 [558885] Horní Bříza"
    },
    {
        "kod": 558915,
        "nazev": "Hromnice",
        "popis": "[558915] Hromnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558915,
        "val": "[558915] Hromnice 3208 [558915] Hromnice"
    },
    {
        "kod": 558931,
        "nazev": "Hvozd",
        "popis": "[558931] Hvozd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558931,
        "val": "[558931] Hvozd 3206 [558931] Hvozd"
    },
    {
        "kod": 558940,
        "nazev": "Chotíkov",
        "popis": "[558940] Chotíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558940,
        "val": "[558940] Chotikov 3208 [558940] Chotíkov"
    },
    {
        "kod": 558974,
        "nazev": "Chříč",
        "popis": "[558974] Chříč",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558974,
        "val": "[558974] Chric 3206 [558974] Chříč"
    },
    {
        "kod": 558982,
        "nazev": "Jarov",
        "popis": "[558982] Jarov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 558982,
        "val": "[558982] Jarov 3206 [558982] Jarov"
    },
    {
        "kod": 558991,
        "nazev": "Kaceřov",
        "popis": "[558991] Kaceřov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 558991,
        "val": "[558991] Kacerov 3208 [558991] Kaceřov"
    },
    {
        "kod": 559008,
        "nazev": "Kaznějov",
        "popis": "[559008] Kaznějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559008,
        "val": "[559008] Kaznejov 3206 [559008] Kaznějov"
    },
    {
        "kod": 538183,
        "nazev": "Kbelany",
        "popis": "[538183] Kbelany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 538183,
        "val": "[538183] Kbelany 3208 [538183] Kbelany"
    },
    {
        "kod": 578771,
        "nazev": "Kočín",
        "popis": "[578771] Kočín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 578771,
        "val": "[578771] Kocin 3206 [578771] Kočín"
    },
    {
        "kod": 559024,
        "nazev": "Kopidlo",
        "popis": "[559024] Kopidlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559024,
        "val": "[559024] Kopidlo 3206 [559024] Kopidlo"
    },
    {
        "kod": 559032,
        "nazev": "Koryta",
        "popis": "[559032] Koryta",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559032,
        "val": "[559032] Koryta 3206 [559032] Koryta"
    },
    {
        "kod": 559041,
        "nazev": "Kozojedy",
        "popis": "[559041] Kozojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559041,
        "val": "[559041] Kozojedy 3206 [559041] Kozojedy"
    },
    {
        "kod": 559059,
        "nazev": "Kozolupy",
        "popis": "[559059] Kozolupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559059,
        "val": "[559059] Kozolupy 3208 [559059] Kozolupy"
    },
    {
        "kod": 559067,
        "nazev": "Kožlany",
        "popis": "[559067] Kožlany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559067,
        "val": "[559067] Kozlany 3206 [559067] Kožlany"
    },
    {
        "kod": 559075,
        "nazev": "Kralovice",
        "popis": "[559075] Kralovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559075,
        "val": "[559075] Kralovice 3206 [559075] Kralovice"
    },
    {
        "kod": 559083,
        "nazev": "Krašovice",
        "popis": "[559083] Krašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559083,
        "val": "[559083] Krasovice 3208 [559083] Krašovice"
    },
    {
        "kod": 559091,
        "nazev": "Krsy",
        "popis": "[559091] Krsy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559091,
        "val": "[559091] Krsy 3208 [559091] Krsy"
    },
    {
        "kod": 559105,
        "nazev": "Křelovice",
        "popis": "[559105] Křelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559105,
        "val": "[559105] Krelovice 3208 [559105] Křelovice"
    },
    {
        "kod": 559121,
        "nazev": "Kunějovice",
        "popis": "[559121] Kunějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559121,
        "val": "[559121] Kunejovice 3208 [559121] Kunějovice"
    },
    {
        "kod": 559148,
        "nazev": "Ledce",
        "popis": "[559148] Ledce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559148,
        "val": "[559148] Ledce 3208 [559148] Ledce"
    },
    {
        "kod": 559164,
        "nazev": "Líně",
        "popis": "[559164] Líně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559164,
        "val": "[559164] Line 3208 [559164] Líně"
    },
    {
        "kod": 559172,
        "nazev": "Líšťany",
        "popis": "[559172] Líšťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559172,
        "val": "[559172] Listany 3208 [559172] Líšťany"
    },
    {
        "kod": 566420,
        "nazev": "Líté",
        "popis": "[566420] Líté",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566420,
        "val": "[566420] Lite 3206 [566420] Líté"
    },
    {
        "kod": 566462,
        "nazev": "Lochousice",
        "popis": "[566462] Lochousice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 566462,
        "val": "[566462] Lochousice 3208 [566462] Lochousice"
    },
    {
        "kod": 566446,
        "nazev": "Loza",
        "popis": "[566446] Loza",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566446,
        "val": "[566446] Loza 3206 [566446] Loza"
    },
    {
        "kod": 559202,
        "nazev": "Manětín",
        "popis": "[559202] Manětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559202,
        "val": "[559202] Manetin 3206 [559202] Manětín"
    },
    {
        "kod": 559211,
        "nazev": "Město Touškov",
        "popis": "[559211] Město Touškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559211,
        "val": "[559211] Mesto Touskov 3208 [559211] Město Touškov"
    },
    {
        "kod": 559237,
        "nazev": "Mladotice",
        "popis": "[559237] Mladotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559237,
        "val": "[559237] Mladotice 3206 [559237] Mladotice"
    },
    {
        "kod": 559245,
        "nazev": "Mrtník",
        "popis": "[559245] Mrtník",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559245,
        "val": "[559245] Mrtnik 3206 [559245] Mrtník"
    },
    {
        "kod": 566543,
        "nazev": "Myslinka",
        "popis": "[566543] Myslinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 566543,
        "val": "[566543] Myslinka 3208 [566543] Myslinka"
    },
    {
        "kod": 559253,
        "nazev": "Nadryby",
        "popis": "[559253] Nadryby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559253,
        "val": "[559253] Nadryby 3208 [559253] Nadryby"
    },
    {
        "kod": 559261,
        "nazev": "Nečtiny",
        "popis": "[559261] Nečtiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559261,
        "val": "[559261] Nectiny 3206 [559261] Nečtiny"
    },
    {
        "kod": 559270,
        "nazev": "Nekmíř",
        "popis": "[559270] Nekmíř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559270,
        "val": "[559270] Nekmir 3208 [559270] Nekmíř"
    },
    {
        "kod": 559288,
        "nazev": "Nevřeň",
        "popis": "[559288] Nevřeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559288,
        "val": "[559288] Nevren 3208 [559288] Nevřeň"
    },
    {
        "kod": 559300,
        "nazev": "Nýřany",
        "popis": "[559300] Nýřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559300,
        "val": "[559300] Nyrany 3208 [559300] Nýřany"
    },
    {
        "kod": 559318,
        "nazev": "Obora",
        "popis": "[559318] Obora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559318,
        "val": "[559318] Obora 3206 [559318] Obora"
    },
    {
        "kod": 559326,
        "nazev": "Ostrov u Bezdružic",
        "popis": "[559326] Ostrov u Bezdružic",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559326,
        "val": "[559326] Ostrov u Bezdruzic 3208 [559326] Ostrov u Bezdružic"
    },
    {
        "kod": 566781,
        "nazev": "Pastuchovice",
        "popis": "[566781] Pastuchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566781,
        "val": "[566781] Pastuchovice 3206 [566781] Pastuchovice"
    },
    {
        "kod": 559334,
        "nazev": "Pernarec",
        "popis": "[559334] Pernarec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559334,
        "val": "[559334] Pernarec 3208 [559334] Pernarec"
    },
    {
        "kod": 530336,
        "nazev": "Pláně",
        "popis": "[530336] Pláně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 530336,
        "val": "[530336] Plane 3206 [530336] Pláně"
    },
    {
        "kod": 559351,
        "nazev": "Plasy",
        "popis": "[559351] Plasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559351,
        "val": "[559351] Plasy 3206 [559351] Plasy"
    },
    {
        "kod": 559369,
        "nazev": "Plešnice",
        "popis": "[559369] Plešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559369,
        "val": "[559369] Plesnice 3208 [559369] Plešnice"
    },
    {
        "kod": 559377,
        "nazev": "Pňovany",
        "popis": "[559377] Pňovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559377,
        "val": "[559377] Pnovany 3208 [559377] Pňovany"
    },
    {
        "kod": 530247,
        "nazev": "Potvorov",
        "popis": "[530247] Potvorov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 530247,
        "val": "[530247] Potvorov 3206 [530247] Potvorov"
    },
    {
        "kod": 559393,
        "nazev": "Přehýšov",
        "popis": "[559393] Přehýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559393,
        "val": "[559393] Prehysov 3208 [559393] Přehýšov"
    },
    {
        "kod": 567086,
        "nazev": "Příšov",
        "popis": "[567086] Příšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 567086,
        "val": "[567086] Prisov 3208 [567086] Příšov"
    },
    {
        "kod": 559423,
        "nazev": "Rochlov",
        "popis": "[559423] Rochlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559423,
        "val": "[559423] Rochlov 3208 [559423] Rochlov"
    },
    {
        "kod": 559431,
        "nazev": "Rybnice",
        "popis": "[559431] Rybnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559431,
        "val": "[559431] Rybnice 3206 [559431] Rybnice"
    },
    {
        "kod": 530271,
        "nazev": "Sedlec",
        "popis": "[530271] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 530271,
        "val": "[530271] Sedlec 3206 [530271] Sedlec"
    },
    {
        "kod": 566748,
        "nazev": "Slatina",
        "popis": "[566748] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566748,
        "val": "[566748] Slatina 3206 [566748] Slatina"
    },
    {
        "kod": 553603,
        "nazev": "Studená",
        "popis": "[553603] Studená",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 553603,
        "val": "[553603] Studena 3206 [553603] Studená"
    },
    {
        "kod": 578797,
        "nazev": "Štichovice",
        "popis": "[578797] Štichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 578797,
        "val": "[578797] Stichovice 3206 [578797] Štichovice"
    },
    {
        "kod": 578983,
        "nazev": "Tatiná",
        "popis": "[578983] Tatiná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 578983,
        "val": "[578983] Tatina 3208 [578983] Tatiná"
    },
    {
        "kod": 559482,
        "nazev": "Tis u Blatna",
        "popis": "[559482] Tis u Blatna",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559482,
        "val": "[559482] Tis u Blatna 3206 [559482] Tis u Blatna"
    },
    {
        "kod": 559491,
        "nazev": "Tlučná",
        "popis": "[559491] Tlučná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559491,
        "val": "[559491] Tlucna 3208 [559491] Tlučná"
    },
    {
        "kod": 559504,
        "nazev": "Trnová",
        "popis": "[559504] Trnová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559504,
        "val": "[559504] Trnova 3208 [559504] Trnová"
    },
    {
        "kod": 559521,
        "nazev": "Třemošná",
        "popis": "[559521] Třemošná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559521,
        "val": "[559521] Tremosna 3208 [559521] Třemošná"
    },
    {
        "kod": 546411,
        "nazev": "Úherce",
        "popis": "[546411] Úherce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 546411,
        "val": "[546411] Uherce 3208 [546411] Úherce"
    },
    {
        "kod": 566594,
        "nazev": "Újezd nade Mží",
        "popis": "[566594] Újezd nade Mží",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 566594,
        "val": "[566594] Ujezd nade Mzi 3208 [566594] Újezd nade Mží"
    },
    {
        "kod": 559555,
        "nazev": "Úlice",
        "popis": "[559555] Úlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559555,
        "val": "[559555] Ulice 3208 [559555] Úlice"
    },
    {
        "kod": 559563,
        "nazev": "Úněšov",
        "popis": "[559563] Úněšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559563,
        "val": "[559563] Unesov 3208 [559563] Úněšov"
    },
    {
        "kod": 559571,
        "nazev": "Úterý",
        "popis": "[559571] Úterý",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559571,
        "val": "[559571] Utery 3208 [559571] Úterý"
    },
    {
        "kod": 559580,
        "nazev": "Vejprnice",
        "popis": "[559580] Vejprnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559580,
        "val": "[559580] Vejprnice 3208 [559580] Vejprnice"
    },
    {
        "kod": 578924,
        "nazev": "Velečín",
        "popis": "[578924] Velečín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 578924,
        "val": "[578924] Velecin 3206 [578924] Velečín"
    },
    {
        "kod": 559601,
        "nazev": "Vochov",
        "popis": "[559601] Vochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559601,
        "val": "[559601] Vochov 3208 [559601] Vochov"
    },
    {
        "kod": 566497,
        "nazev": "Všehrdy",
        "popis": "[566497] Všehrdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566497,
        "val": "[566497] Vsehrdy 3206 [566497] Všehrdy"
    },
    {
        "kod": 559628,
        "nazev": "Všeruby",
        "popis": "[559628] Všeruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559628,
        "val": "[559628] Vseruby 3208 [559628] Všeruby"
    },
    {
        "kod": 566969,
        "nazev": "Výrov",
        "popis": "[566969] Výrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 566969,
        "val": "[566969] Vyrov 3206 [566969] Výrov"
    },
    {
        "kod": 530280,
        "nazev": "Vysoká Libyně",
        "popis": "[530280] Vysoká Libyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 530280,
        "val": "[530280] Vysoka Libyne 3206 [530280] Vysoká Libyně"
    },
    {
        "kod": 578827,
        "nazev": "Zahrádka",
        "popis": "[578827] Zahrádka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 578827,
        "val": "[578827] Zahradka 3208 [578827] Zahrádka"
    },
    {
        "kod": 559661,
        "nazev": "Zbůch",
        "popis": "[559661] Zbůch",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559661,
        "val": "[559661] Zbuch 3208 [559661] Zbůch"
    },
    {
        "kod": 559679,
        "nazev": "Zruč-Senec",
        "popis": "[559679] Zruč-Senec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559679,
        "val": "[559679] Zruc-Senec 3208 [559679] Zruč-Senec"
    },
    {
        "kod": 559695,
        "nazev": "Žihle",
        "popis": "[559695] Žihle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3206,
        "iczuj": 559695,
        "val": "[559695] Zihle 3206 [559695] Žihle"
    },
    {
        "kod": 559709,
        "nazev": "Žilov",
        "popis": "[559709] Žilov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3208,
        "iczuj": 559709,
        "val": "[559709] Zilov 3208 [559709] Žilov"
    },
    {
        "kod": 541095,
        "nazev": "Bezděkov",
        "popis": "[541095] Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541095,
        "val": "[541095] Bezdekov 3211 [541095] Bezděkov"
    },
    {
        "kod": 559725,
        "nazev": "Břasy",
        "popis": "[559725] Břasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559725,
        "val": "[559725] Brasy 3211 [559725] Břasy"
    },
    {
        "kod": 559733,
        "nazev": "Březina",
        "popis": "[559733] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559733,
        "val": "[559733] Brezina 3211 [559733] Březina"
    },
    {
        "kod": 559741,
        "nazev": "Bujesily",
        "popis": "[559741] Bujesily",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559741,
        "val": "[559741] Bujesily 3211 [559741] Bujesily"
    },
    {
        "kod": 559750,
        "nazev": "Bušovice",
        "popis": "[559750] Bušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559750,
        "val": "[559750] Busovice 3211 [559750] Bušovice"
    },
    {
        "kod": 559768,
        "nazev": "Cekov",
        "popis": "[559768] Cekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559768,
        "val": "[559768] Cekov 3211 [559768] Cekov"
    },
    {
        "kod": 540927,
        "nazev": "Čilá",
        "popis": "[540927] Čilá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 540927,
        "val": "[540927] Cila 3211 [540927] Čilá"
    },
    {
        "kod": 559776,
        "nazev": "Dobřív",
        "popis": "[559776] Dobřív",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559776,
        "val": "[559776] Dobriv 3211 [559776] Dobřív"
    },
    {
        "kod": 530379,
        "nazev": "Drahoňův Újezd",
        "popis": "[530379] Drahoňův Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 530379,
        "val": "[530379] Drahonuv Ujezd 3211 [530379] Drahoňův Újezd"
    },
    {
        "kod": 559792,
        "nazev": "Ejpovice",
        "popis": "[559792] Ejpovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559792,
        "val": "[559792] Ejpovice 3211 [559792] Ejpovice"
    },
    {
        "kod": 559806,
        "nazev": "Hlohovice",
        "popis": "[559806] Hlohovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559806,
        "val": "[559806] Hlohovice 3211 [559806] Hlohovice"
    },
    {
        "kod": 559814,
        "nazev": "Holoubkov",
        "popis": "[559814] Holoubkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559814,
        "val": "[559814] Holoubkov 3211 [559814] Holoubkov"
    },
    {
        "kod": 559822,
        "nazev": "Hrádek",
        "popis": "[559822] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559822,
        "val": "[559822] Hradek 3211 [559822] Hrádek"
    },
    {
        "kod": 541001,
        "nazev": "Hradiště",
        "popis": "[541001] Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541001,
        "val": "[541001] Hradiste 3211 [541001] Hradiště"
    },
    {
        "kod": 559849,
        "nazev": "Hůrky",
        "popis": "[559849] Hůrky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559849,
        "val": "[559849] Hurky 3211 [559849] Hůrky"
    },
    {
        "kod": 559857,
        "nazev": "Cheznovice",
        "popis": "[559857] Cheznovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559857,
        "val": "[559857] Cheznovice 3211 [559857] Cheznovice"
    },
    {
        "kod": 540803,
        "nazev": "Chlum",
        "popis": "[540803] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 540803,
        "val": "[540803] Chlum 3211 [540803] Chlum"
    },
    {
        "kod": 541141,
        "nazev": "Chomle",
        "popis": "[541141] Chomle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541141,
        "val": "[541141] Chomle 3211 [541141] Chomle"
    },
    {
        "kod": 579017,
        "nazev": "Kakejcov",
        "popis": "[579017] Kakejcov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579017,
        "val": "[579017] Kakejcov 3211 [579017] Kakejcov"
    },
    {
        "kod": 566811,
        "nazev": "Kamenec",
        "popis": "[566811] Kamenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566811,
        "val": "[566811] Kamenec 3211 [566811] Kamenec"
    },
    {
        "kod": 541150,
        "nazev": "Kamenný Újezd",
        "popis": "[541150] Kamenný Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541150,
        "val": "[541150] Kamenny Ujezd 3211 [541150] Kamenný Újezd"
    },
    {
        "kod": 559903,
        "nazev": "Kařez",
        "popis": "[559903] Kařez",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559903,
        "val": "[559903] Karez 3211 [559903] Kařez"
    },
    {
        "kod": 530361,
        "nazev": "Kařízek",
        "popis": "[530361] Kařízek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 530361,
        "val": "[530361] Karizek 3211 [530361] Kařízek"
    },
    {
        "kod": 559911,
        "nazev": "Klabava",
        "popis": "[559911] Klabava",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559911,
        "val": "[559911] Klabava 3211 [559911] Klabava"
    },
    {
        "kod": 559920,
        "nazev": "Kladruby",
        "popis": "[559920] Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559920,
        "val": "[559920] Kladruby 3211 [559920] Kladruby"
    },
    {
        "kod": 579033,
        "nazev": "Kornatice",
        "popis": "[579033] Kornatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579033,
        "val": "[579033] Kornatice 3211 [579033] Kornatice"
    },
    {
        "kod": 567001,
        "nazev": "Lhota pod Radčem",
        "popis": "[567001] Lhota pod Radčem",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 567001,
        "val": "[567001] Lhota pod Radcem 3211 [567001] Lhota pod Radčem"
    },
    {
        "kod": 559946,
        "nazev": "Lhotka u Radnic",
        "popis": "[559946] Lhotka u Radnic",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559946,
        "val": "[559946] Lhotka u Radnic 3211 [559946] Lhotka u Radnic"
    },
    {
        "kod": 559954,
        "nazev": "Liblín",
        "popis": "[559954] Liblín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559954,
        "val": "[559954] Liblin 3211 [559954] Liblín"
    },
    {
        "kod": 559962,
        "nazev": "Líšná",
        "popis": "[559962] Líšná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559962,
        "val": "[559962] Lisna 3211 [559962] Líšná"
    },
    {
        "kod": 553611,
        "nazev": "Litohlavy",
        "popis": "[553611] Litohlavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 553611,
        "val": "[553611] Litohlavy 3211 [553611] Litohlavy"
    },
    {
        "kod": 579009,
        "nazev": "Medový Újezd",
        "popis": "[579009] Medový Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579009,
        "val": "[579009] Medovy Ujezd 3211 [579009] Medový Újezd"
    },
    {
        "kod": 579084,
        "nazev": "Mešno",
        "popis": "[579084] Mešno",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579084,
        "val": "[579084] Mesno 3211 [579084] Mešno"
    },
    {
        "kod": 559997,
        "nazev": "Mirošov",
        "popis": "[559997] Mirošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559997,
        "val": "[559997] Mirosov 3211 [559997] Mirošov"
    },
    {
        "kod": 560006,
        "nazev": "Mlečice",
        "popis": "[560006] Mlečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560006,
        "val": "[560006] Mlecice 3211 [560006] Mlečice"
    },
    {
        "kod": 560014,
        "nazev": "Mýto",
        "popis": "[560014] Mýto",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560014,
        "val": "[560014] Myto 3211 [560014] Mýto"
    },
    {
        "kod": 566837,
        "nazev": "Němčovice",
        "popis": "[566837] Němčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566837,
        "val": "[566837] Nemcovice 3211 [566837] Němčovice"
    },
    {
        "kod": 541192,
        "nazev": "Nevid",
        "popis": "[541192] Nevid",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541192,
        "val": "[541192] Nevid 3211 [541192] Nevid"
    },
    {
        "kod": 560057,
        "nazev": "Osek",
        "popis": "[560057] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560057,
        "val": "[560057] Osek 3211 [560057] Osek"
    },
    {
        "kod": 566993,
        "nazev": "Ostrovec-Lhotka",
        "popis": "[566993] Ostrovec-Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566993,
        "val": "[566993] Ostrovec-Lhotka 3211 [566993] Ostrovec-Lhotka"
    },
    {
        "kod": 566861,
        "nazev": "Plískov",
        "popis": "[566861] Plískov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566861,
        "val": "[566861] Pliskov 3211 [566861] Plískov"
    },
    {
        "kod": 560081,
        "nazev": "Podmokly",
        "popis": "[560081] Podmokly",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560081,
        "val": "[560081] Podmokly 3211 [560081] Podmokly"
    },
    {
        "kod": 579131,
        "nazev": "Příkosice",
        "popis": "[579131] Příkosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579131,
        "val": "[579131] Prikosice 3211 [579131] Příkosice"
    },
    {
        "kod": 560111,
        "nazev": "Přívětice",
        "popis": "[560111] Přívětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560111,
        "val": "[560111] Privetice 3211 [560111] Přívětice"
    },
    {
        "kod": 560120,
        "nazev": "Radnice",
        "popis": "[560120] Radnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560120,
        "val": "[560120] Radnice 3211 [560120] Radnice"
    },
    {
        "kod": 566942,
        "nazev": "Raková",
        "popis": "[566942] Raková",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566942,
        "val": "[566942] Rakova 3211 [566942] Raková"
    },
    {
        "kod": 559717,
        "nazev": "Rokycany",
        "popis": "[559717] Rokycany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 559717,
        "val": "[559717] Rokycany 3211 [559717] Rokycany"
    },
    {
        "kod": 560146,
        "nazev": "Sebečice",
        "popis": "[560146] Sebečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560146,
        "val": "[560146] Sebecice 3211 [560146] Sebečice"
    },
    {
        "kod": 546488,
        "nazev": "Sirá",
        "popis": "[546488] Sirá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 546488,
        "val": "[546488] Sira 3211 [546488] Sirá"
    },
    {
        "kod": 566845,
        "nazev": "Skomelno",
        "popis": "[566845] Skomelno",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566845,
        "val": "[566845] Skomelno 3211 [566845] Skomelno"
    },
    {
        "kod": 506664,
        "nazev": "Skořice",
        "popis": "[506664] Skořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 506664,
        "val": "[506664] Skorice 3211 [506664] Skořice"
    },
    {
        "kod": 540722,
        "nazev": "Smědčice",
        "popis": "[540722] Smědčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 540722,
        "val": "[540722] Smedcice 3211 [540722] Smědčice"
    },
    {
        "kod": 560162,
        "nazev": "Strašice",
        "popis": "[560162] Strašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560162,
        "val": "[560162] Strasice 3211 [560162] Strašice"
    },
    {
        "kod": 541176,
        "nazev": "Svojkovice",
        "popis": "[541176] Svojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541176,
        "val": "[541176] Svojkovice 3211 [541176] Svojkovice"
    },
    {
        "kod": 579343,
        "nazev": "Štítov",
        "popis": "[579343] Štítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579343,
        "val": "[579343] Stitov 3211 [579343] Štítov"
    },
    {
        "kod": 560189,
        "nazev": "Těně",
        "popis": "[560189] Těně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560189,
        "val": "[560189] Tene 3211 [560189] Těně"
    },
    {
        "kod": 566802,
        "nazev": "Terešov",
        "popis": "[566802] Terešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566802,
        "val": "[566802] Teresov 3211 [566802] Terešov"
    },
    {
        "kod": 546526,
        "nazev": "Těškov",
        "popis": "[546526] Těškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 546526,
        "val": "[546526] Teskov 3211 [546526] Těškov"
    },
    {
        "kod": 579246,
        "nazev": "Trokavec",
        "popis": "[579246] Trokavec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579246,
        "val": "[579246] Trokavec 3211 [579246] Trokavec"
    },
    {
        "kod": 546534,
        "nazev": "Týček",
        "popis": "[546534] Týček",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 546534,
        "val": "[546534] Tycek 3211 [546534] Týček"
    },
    {
        "kod": 546551,
        "nazev": "Újezd u Svatého Kříže",
        "popis": "[546551] Újezd u Svatého Kříže",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 546551,
        "val": "[546551] Ujezd u Svateho Krize 3211 [546551] Újezd u Svatého Kříže"
    },
    {
        "kod": 560227,
        "nazev": "Vejvanov",
        "popis": "[560227] Vejvanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560227,
        "val": "[560227] Vejvanov 3211 [560227] Vejvanov"
    },
    {
        "kod": 560235,
        "nazev": "Veselá",
        "popis": "[560235] Veselá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560235,
        "val": "[560235] Vesela 3211 [560235] Veselá"
    },
    {
        "kod": 579289,
        "nazev": "Vísky",
        "popis": "[579289] Vísky",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 579289,
        "val": "[579289] Visky 3211 [579289] Vísky"
    },
    {
        "kod": 560251,
        "nazev": "Volduchy",
        "popis": "[560251] Volduchy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560251,
        "val": "[560251] Volduchy 3211 [560251] Volduchy"
    },
    {
        "kod": 566799,
        "nazev": "Všenice",
        "popis": "[566799] Všenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 566799,
        "val": "[566799] Vsenice 3211 [566799] Všenice"
    },
    {
        "kod": 560260,
        "nazev": "Zbiroh",
        "popis": "[560260] Zbiroh",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 560260,
        "val": "[560260] Zbiroh 3211 [560260] Zbiroh"
    },
    {
        "kod": 541061,
        "nazev": "Zvíkovec",
        "popis": "[541061] Zvíkovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3211,
        "iczuj": 541061,
        "val": "[541061] Zvikovec 3211 [541061] Zvíkovec"
    },
    {
        "kod": 560723,
        "nazev": "Benešovice",
        "popis": "[560723] Benešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560723,
        "val": "[560723] Benesovice 3213 [560723] Benešovice"
    },
    {
        "kod": 560740,
        "nazev": "Bezdružice",
        "popis": "[560740] Bezdružice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560740,
        "val": "[560740] Bezdruzice 3213 [560740] Bezdružice"
    },
    {
        "kod": 560758,
        "nazev": "Bor",
        "popis": "[560758] Bor",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560758,
        "val": "[560758] Bor 3215 [560758] Bor"
    },
    {
        "kod": 541605,
        "nazev": "Brod nad Tichou",
        "popis": "[541605] Brod nad Tichou",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541605,
        "val": "[541605] Brod nad Tichou 3215 [541605] Brod nad Tichou"
    },
    {
        "kod": 541401,
        "nazev": "Broumov",
        "popis": "[541401] Broumov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541401,
        "val": "[541401] Broumov 3215 [541401] Broumov"
    },
    {
        "kod": 560782,
        "nazev": "Cebiv",
        "popis": "[560782] Cebiv",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560782,
        "val": "[560782] Cebiv 3213 [560782] Cebiv"
    },
    {
        "kod": 579459,
        "nazev": "Ctiboř",
        "popis": "[579459] Ctiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 579459,
        "val": "[579459] Ctibor 3215 [579459] Ctiboř"
    },
    {
        "kod": 560804,
        "nazev": "Částkov",
        "popis": "[560804] Částkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560804,
        "val": "[560804] Castkov 3215 [560804] Částkov"
    },
    {
        "kod": 560812,
        "nazev": "Černošín",
        "popis": "[560812] Černošín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560812,
        "val": "[560812] Cernosin 3213 [560812] Černošín"
    },
    {
        "kod": 560839,
        "nazev": "Dlouhý Újezd",
        "popis": "[560839] Dlouhý Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560839,
        "val": "[560839] Dlouhy Ujezd 3215 [560839] Dlouhý Újezd"
    },
    {
        "kod": 560855,
        "nazev": "Erpužice",
        "popis": "[560855] Erpužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560855,
        "val": "[560855] Erpuzice 3213 [560855] Erpužice"
    },
    {
        "kod": 560863,
        "nazev": "Halže",
        "popis": "[560863] Halže",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560863,
        "val": "[560863] Halze 3215 [560863] Halže"
    },
    {
        "kod": 541290,
        "nazev": "Horní Kozolupy",
        "popis": "[541290] Horní Kozolupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541290,
        "val": "[541290] Horni Kozolupy 3213 [541290] Horní Kozolupy"
    },
    {
        "kod": 560898,
        "nazev": "Hošťka",
        "popis": "[560898] Hošťka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560898,
        "val": "[560898] Hostka 3215 [560898] Hošťka"
    },
    {
        "kod": 560901,
        "nazev": "Chodová Planá",
        "popis": "[560901] Chodová Planá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560901,
        "val": "[560901] Chodova Plana 3215 [560901] Chodová Planá"
    },
    {
        "kod": 560910,
        "nazev": "Chodský Újezd",
        "popis": "[560910] Chodský Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560910,
        "val": "[560910] Chodsky Ujezd 3215 [560910] Chodský Újezd"
    },
    {
        "kod": 560928,
        "nazev": "Kladruby",
        "popis": "[560928] Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560928,
        "val": "[560928] Kladruby 3213 [560928] Kladruby"
    },
    {
        "kod": 541559,
        "nazev": "Kočov",
        "popis": "[541559] Kočov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541559,
        "val": "[541559] Kocov 3215 [541559] Kočov"
    },
    {
        "kod": 541494,
        "nazev": "Kokašice",
        "popis": "[541494] Kokašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541494,
        "val": "[541494] Kokasice 3213 [541494] Kokašice"
    },
    {
        "kod": 560952,
        "nazev": "Konstantinovy Lázně",
        "popis": "[560952] Konstantinovy Lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560952,
        "val": "[560952] Konstantinovy Lazne 3213 [560952] Konstantinovy Lázně"
    },
    {
        "kod": 503916,
        "nazev": "Kostelec",
        "popis": "[503916] Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 503916,
        "val": "[503916] Kostelec 3213 [503916] Kostelec"
    },
    {
        "kod": 560979,
        "nazev": "Kšice",
        "popis": "[560979] Kšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 560979,
        "val": "[560979] Ksice 3213 [560979] Kšice"
    },
    {
        "kod": 561002,
        "nazev": "Lesná",
        "popis": "[561002] Lesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561002,
        "val": "[561002] Lesna 3215 [561002] Lesná"
    },
    {
        "kod": 561011,
        "nazev": "Lestkov",
        "popis": "[561011] Lestkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561011,
        "val": "[561011] Lestkov 3215 [561011] Lestkov"
    },
    {
        "kod": 541702,
        "nazev": "Lom u Tachova",
        "popis": "[541702] Lom u Tachova",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541702,
        "val": "[541702] Lom u Tachova 3215 [541702] Lom u Tachova"
    },
    {
        "kod": 541532,
        "nazev": "Milíře",
        "popis": "[541532] Milíře",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541532,
        "val": "[541532] Milire 3215 [541532] Milíře"
    },
    {
        "kod": 541443,
        "nazev": "Obora",
        "popis": "[541443] Obora",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541443,
        "val": "[541443] Obora 3215 [541443] Obora"
    },
    {
        "kod": 566888,
        "nazev": "Olbramov",
        "popis": "[566888] Olbramov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 566888,
        "val": "[566888] Olbramov 3213 [566888] Olbramov"
    },
    {
        "kod": 541681,
        "nazev": "Ošelín",
        "popis": "[541681] Ošelín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541681,
        "val": "[541681] Oselin 3213 [541681] Ošelín"
    },
    {
        "kod": 561134,
        "nazev": "Planá",
        "popis": "[561134] Planá",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561134,
        "val": "[561134] Plana 3215 [561134] Planá"
    },
    {
        "kod": 541486,
        "nazev": "Prostiboř",
        "popis": "[541486] Prostiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541486,
        "val": "[541486] Prostibor 3213 [541486] Prostiboř"
    },
    {
        "kod": 561151,
        "nazev": "Přimda",
        "popis": "[561151] Přimda",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561151,
        "val": "[561151] Primda 3215 [561151] Přimda"
    },
    {
        "kod": 561169,
        "nazev": "Rozvadov",
        "popis": "[561169] Rozvadov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561169,
        "val": "[561169] Rozvadov 3215 [561169] Rozvadov"
    },
    {
        "kod": 579467,
        "nazev": "Skapce",
        "popis": "[579467] Skapce",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 579467,
        "val": "[579467] Skapce 3213 [579467] Skapce"
    },
    {
        "kod": 561185,
        "nazev": "Staré Sedliště",
        "popis": "[561185] Staré Sedliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561185,
        "val": "[561185] Stare Sedliste 3215 [561185] Staré Sedliště"
    },
    {
        "kod": 561193,
        "nazev": "Staré Sedlo",
        "popis": "[561193] Staré Sedlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561193,
        "val": "[561193] Stare Sedlo 3215 [561193] Staré Sedlo"
    },
    {
        "kod": 561207,
        "nazev": "Stráž",
        "popis": "[561207] Stráž",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561207,
        "val": "[561207] Straz 3215 [561207] Stráž"
    },
    {
        "kod": 561215,
        "nazev": "Stříbro",
        "popis": "[561215] Stříbro",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 561215,
        "val": "[561215] Stribro 3213 [561215] Stříbro"
    },
    {
        "kod": 561223,
        "nazev": "Studánka",
        "popis": "[561223] Studánka",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561223,
        "val": "[561223] Studanka 3215 [561223] Studánka"
    },
    {
        "kod": 561231,
        "nazev": "Sulislav",
        "popis": "[561231] Sulislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 561231,
        "val": "[561231] Sulislav 3213 [561231] Sulislav"
    },
    {
        "kod": 561258,
        "nazev": "Svojšín",
        "popis": "[561258] Svojšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 561258,
        "val": "[561258] Svojsin 3213 [561258] Svojšín"
    },
    {
        "kod": 557081,
        "nazev": "Sytno",
        "popis": "[557081] Sytno",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 557081,
        "val": "[557081] Sytno 3213 [557081] Sytno"
    },
    {
        "kod": 560715,
        "nazev": "Tachov",
        "popis": "[560715] Tachov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 560715,
        "val": "[560715] Tachov 3215 [560715] Tachov"
    },
    {
        "kod": 541621,
        "nazev": "Tisová",
        "popis": "[541621] Tisová",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541621,
        "val": "[541621] Tisova 3215 [541621] Tisová"
    },
    {
        "kod": 561291,
        "nazev": "Trpísty",
        "popis": "[561291] Trpísty",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 561291,
        "val": "[561291] Trpisty 3213 [561291] Trpísty"
    },
    {
        "kod": 561304,
        "nazev": "Třemešné",
        "popis": "[561304] Třemešné",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 561304,
        "val": "[561304] Tremesne 3215 [561304] Třemešné"
    },
    {
        "kod": 541435,
        "nazev": "Únehle",
        "popis": "[541435] Únehle",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541435,
        "val": "[541435] Unehle 3213 [541435] Únehle"
    },
    {
        "kod": 579491,
        "nazev": "Vranov",
        "popis": "[579491] Vranov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 579491,
        "val": "[579491] Vranov 3213 [579491] Vranov"
    },
    {
        "kod": 541362,
        "nazev": "Zadní Chodov",
        "popis": "[541362] Zadní Chodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 3215,
        "iczuj": 541362,
        "val": "[541362] Zadni Chodov 3215 [541362] Zadní Chodov"
    },
    {
        "kod": 541664,
        "nazev": "Záchlumí",
        "popis": "[541664] Záchlumí",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541664,
        "val": "[541664] Zachlumi 3213 [541664] Záchlumí"
    },
    {
        "kod": 541460,
        "nazev": "Zhoř",
        "popis": "[541460] Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 3213,
        "iczuj": 541460,
        "val": "[541460] Zhor 3213 [541460] Zhoř"
    },
    {
        "kod": 554499,
        "nazev": "Aš",
        "popis": "[554499] Aš",
        "datum_od": "",
        "datum_do": "",
        "orp": 4101,
        "iczuj": 554499,
        "val": "[554499] As 4101 [554499] Aš"
    },
    {
        "kod": 554502,
        "nazev": "Dolní Žandov",
        "popis": "[554502] Dolní Žandov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554502,
        "val": "[554502] Dolni Zandov 4102 [554502] Dolní Žandov"
    },
    {
        "kod": 554511,
        "nazev": "Drmoul",
        "popis": "[554511] Drmoul",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554511,
        "val": "[554511] Drmoul 4105 [554511] Drmoul"
    },
    {
        "kod": 554529,
        "nazev": "Františkovy Lázně",
        "popis": "[554529] Františkovy Lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554529,
        "val": "[554529] Frantiskovy Lazne 4102 [554529] Františkovy Lázně"
    },
    {
        "kod": 554545,
        "nazev": "Hazlov",
        "popis": "[554545] Hazlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4101,
        "iczuj": 554545,
        "val": "[554545] Hazlov 4101 [554545] Hazlov"
    },
    {
        "kod": 554553,
        "nazev": "Hranice",
        "popis": "[554553] Hranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4101,
        "iczuj": 554553,
        "val": "[554553] Hranice 4101 [554553] Hranice"
    },
    {
        "kod": 554481,
        "nazev": "Cheb",
        "popis": "[554481] Cheb",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554481,
        "val": "[554481] Cheb 4102 [554481] Cheb"
    },
    {
        "kod": 538795,
        "nazev": "Krásná",
        "popis": "[538795] Krásná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4101,
        "iczuj": 538795,
        "val": "[538795] Krasna 4101 [538795] Krásná"
    },
    {
        "kod": 554596,
        "nazev": "Křižovatka",
        "popis": "[554596] Křižovatka",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554596,
        "val": "[554596] Krizovatka 4102 [554596] Křižovatka"
    },
    {
        "kod": 554600,
        "nazev": "Lázně Kynžvart",
        "popis": "[554600] Lázně Kynžvart",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554600,
        "val": "[554600] Lazne Kynzvart 4105 [554600] Lázně Kynžvart"
    },
    {
        "kod": 554618,
        "nazev": "Libá",
        "popis": "[554618] Libá",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554618,
        "val": "[554618] Liba 4102 [554618] Libá"
    },
    {
        "kod": 554626,
        "nazev": "Lipová",
        "popis": "[554626] Lipová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554626,
        "val": "[554626] Lipova 4102 [554626] Lipová"
    },
    {
        "kod": 554634,
        "nazev": "Luby",
        "popis": "[554634] Luby",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554634,
        "val": "[554634] Luby 4102 [554634] Luby"
    },
    {
        "kod": 554642,
        "nazev": "Mariánské Lázně",
        "popis": "[554642] Mariánské Lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554642,
        "val": "[554642] Marianske Lazne 4105 [554642] Mariánské Lázně"
    },
    {
        "kod": 554651,
        "nazev": "Milhostov",
        "popis": "[554651] Milhostov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554651,
        "val": "[554651] Milhostov 4102 [554651] Milhostov"
    },
    {
        "kod": 538906,
        "nazev": "Milíkov",
        "popis": "[538906] Milíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 538906,
        "val": "[538906] Milikov 4102 [538906] Milíkov"
    },
    {
        "kod": 554677,
        "nazev": "Mnichov",
        "popis": "[554677] Mnichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554677,
        "val": "[554677] Mnichov 4105 [554677] Mnichov"
    },
    {
        "kod": 554693,
        "nazev": "Nebanice",
        "popis": "[554693] Nebanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554693,
        "val": "[554693] Nebanice 4102 [554693] Nebanice"
    },
    {
        "kod": 554707,
        "nazev": "Nový Kostel",
        "popis": "[554707] Nový Kostel",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554707,
        "val": "[554707] Novy Kostel 4102 [554707] Nový Kostel"
    },
    {
        "kod": 539554,
        "nazev": "Odrava",
        "popis": "[539554] Odrava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 539554,
        "val": "[539554] Odrava 4102 [539554] Odrava"
    },
    {
        "kod": 538922,
        "nazev": "Okrouhlá",
        "popis": "[538922] Okrouhlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 538922,
        "val": "[538922] Okrouhla 4102 [538922] Okrouhlá"
    },
    {
        "kod": 539473,
        "nazev": "Ovesné Kladruby",
        "popis": "[539473] Ovesné Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539473,
        "val": "[539473] Ovesne Kladruby 4105 [539473] Ovesné Kladruby"
    },
    {
        "kod": 554740,
        "nazev": "Plesná",
        "popis": "[554740] Plesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554740,
        "val": "[554740] Plesna 4102 [554740] Plesná"
    },
    {
        "kod": 538817,
        "nazev": "Podhradí",
        "popis": "[538817] Podhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4101,
        "iczuj": 538817,
        "val": "[538817] Podhradi 4101 [538817] Podhradí"
    },
    {
        "kod": 538868,
        "nazev": "Pomezí nad Ohří",
        "popis": "[538868] Pomezí nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 538868,
        "val": "[538868] Pomezi nad Ohri 4102 [538868] Pomezí nad Ohří"
    },
    {
        "kod": 577979,
        "nazev": "Poustka",
        "popis": "[577979] Poustka",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 577979,
        "val": "[577979] Poustka 4102 [577979] Poustka"
    },
    {
        "kod": 539538,
        "nazev": "Prameny",
        "popis": "[539538] Prameny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539538,
        "val": "[539538] Prameny 4105 [539538] Prameny"
    },
    {
        "kod": 554812,
        "nazev": "Skalná",
        "popis": "[554812] Skalná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 554812,
        "val": "[554812] Skalna 4102 [554812] Skalná"
    },
    {
        "kod": 539112,
        "nazev": "Stará Voda",
        "popis": "[539112] Stará Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539112,
        "val": "[539112] Stara Voda 4105 [539112] Stará Voda"
    },
    {
        "kod": 555631,
        "nazev": "Teplá",
        "popis": "[555631] Teplá",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 555631,
        "val": "[555631] Tepla 4105 [555631] Teplá"
    },
    {
        "kod": 554855,
        "nazev": "Trstěnice",
        "popis": "[554855] Trstěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554855,
        "val": "[554855] Trstenice 4105 [554855] Trstěnice"
    },
    {
        "kod": 539023,
        "nazev": "Třebeň",
        "popis": "[539023] Třebeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 539023,
        "val": "[539023] Treben 4102 [539023] Třebeň"
    },
    {
        "kod": 554880,
        "nazev": "Tři Sekery",
        "popis": "[554880] Tři Sekery",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 554880,
        "val": "[554880] Tri Sekery 4105 [554880] Tři Sekery"
    },
    {
        "kod": 539619,
        "nazev": "Tuřany",
        "popis": "[539619] Tuřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 539619,
        "val": "[539619] Turany 4102 [539619] Tuřany"
    },
    {
        "kod": 539481,
        "nazev": "Valy",
        "popis": "[539481] Valy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539481,
        "val": "[539481] Valy 4105 [539481] Valy"
    },
    {
        "kod": 539279,
        "nazev": "Velká Hleďsebe",
        "popis": "[539279] Velká Hleďsebe",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539279,
        "val": "[539279] Velka Hledsebe 4105 [539279] Velká Hleďsebe"
    },
    {
        "kod": 578002,
        "nazev": "Velký Luh",
        "popis": "[578002] Velký Luh",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 578002,
        "val": "[578002] Velky Luh 4102 [578002] Velký Luh"
    },
    {
        "kod": 539376,
        "nazev": "Vlkovice",
        "popis": "[539376] Vlkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539376,
        "val": "[539376] Vlkovice 4105 [539376] Vlkovice"
    },
    {
        "kod": 539074,
        "nazev": "Vojtanov",
        "popis": "[539074] Vojtanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4102,
        "iczuj": 539074,
        "val": "[539074] Vojtanov 4102 [539074] Vojtanov"
    },
    {
        "kod": 539431,
        "nazev": "Zádub-Závišín",
        "popis": "[539431] Zádub-Závišín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4105,
        "iczuj": 539431,
        "val": "[539431] Zadub-Zavisin 4105 [539431] Zádub-Závišín"
    },
    {
        "kod": 554979,
        "nazev": "Abertamy",
        "popis": "[554979] Abertamy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 554979,
        "val": "[554979] Abertamy 4106 [554979] Abertamy"
    },
    {
        "kod": 538001,
        "nazev": "Andělská Hora",
        "popis": "[538001] Andělská Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 538001,
        "val": "[538001] Andelska Hora 4103 [538001] Andělská Hora"
    },
    {
        "kod": 554995,
        "nazev": "Bečov nad Teplou",
        "popis": "[554995] Bečov nad Teplou",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 554995,
        "val": "[554995] Becov nad Teplou 4103 [554995] Bečov nad Teplou"
    },
    {
        "kod": 555029,
        "nazev": "Bochov",
        "popis": "[555029] Bochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555029,
        "val": "[555029] Bochov 4103 [555029] Bochov"
    },
    {
        "kod": 506486,
        "nazev": "Boží Dar",
        "popis": "[506486] Boží Dar",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 506486,
        "val": "[506486] Bozi Dar 4106 [506486] Boží Dar"
    },
    {
        "kod": 555045,
        "nazev": "Božičany",
        "popis": "[555045] Božičany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555045,
        "val": "[555045] Bozicany 4103 [555045] Božičany"
    },
    {
        "kod": 537870,
        "nazev": "Březová",
        "popis": "[537870] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537870,
        "val": "[537870] Brezova 4103 [537870] Březová"
    },
    {
        "kod": 538019,
        "nazev": "Černava",
        "popis": "[538019] Černava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 538019,
        "val": "[538019] Cernava 4103 [538019] Černava"
    },
    {
        "kod": 506621,
        "nazev": "Čichalov",
        "popis": "[506621] Čichalov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 506621,
        "val": "[506621] Cichalov 4103 [506621] Čichalov"
    },
    {
        "kod": 537918,
        "nazev": "Dalovice",
        "popis": "[537918] Dalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537918,
        "val": "[537918] Dalovice 4103 [537918] Dalovice"
    },
    {
        "kod": 538116,
        "nazev": "Děpoltovice",
        "popis": "[538116] Děpoltovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 538116,
        "val": "[538116] Depoltovice 4103 [538116] Děpoltovice"
    },
    {
        "kod": 538159,
        "nazev": "Hájek",
        "popis": "[538159] Hájek",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 538159,
        "val": "[538159] Hajek 4106 [538159] Hájek"
    },
    {
        "kod": 555169,
        "nazev": "Horní Blatná",
        "popis": "[555169] Horní Blatná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555169,
        "val": "[555169] Horni Blatna 4106 [555169] Horní Blatná"
    },
    {
        "kod": 551651,
        "nazev": "Hory",
        "popis": "[551651] Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 551651,
        "val": "[551651] Hory 4103 [551651] Hory"
    },
    {
        "kod": 555177,
        "nazev": "Hradiště",
        "popis": "[555177] Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555177,
        "val": "[555177] Hradiste 4103 [555177] Hradiště"
    },
    {
        "kod": 555185,
        "nazev": "Hroznětín",
        "popis": "[555185] Hroznětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555185,
        "val": "[555185] Hroznetin 4106 [555185] Hroznětín"
    },
    {
        "kod": 578011,
        "nazev": "Chodov",
        "popis": "[578011] Chodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 578011,
        "val": "[578011] Chodov 4103 [578011] Chodov"
    },
    {
        "kod": 555207,
        "nazev": "Chyše",
        "popis": "[555207] Chyše",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555207,
        "val": "[555207] Chyse 4103 [555207] Chyše"
    },
    {
        "kod": 555215,
        "nazev": "Jáchymov",
        "popis": "[555215] Jáchymov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555215,
        "val": "[555215] Jachymov 4106 [555215] Jáchymov"
    },
    {
        "kod": 537926,
        "nazev": "Jenišov",
        "popis": "[537926] Jenišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537926,
        "val": "[537926] Jenisov 4103 [537926] Jenišov"
    },
    {
        "kod": 554961,
        "nazev": "Karlovy Vary",
        "popis": "[554961] Karlovy Vary",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 554961,
        "val": "[554961] Karlovy Vary 4103 [554961] Karlovy Vary"
    },
    {
        "kod": 555258,
        "nazev": "Kolová",
        "popis": "[555258] Kolová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555258,
        "val": "[555258] Kolova 4103 [555258] Kolová"
    },
    {
        "kod": 555304,
        "nazev": "Krásné Údolí",
        "popis": "[555304] Krásné Údolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555304,
        "val": "[555304] Krasne Udoli 4103 [555304] Krásné Údolí"
    },
    {
        "kod": 578045,
        "nazev": "Krásný Les",
        "popis": "[578045] Krásný Les",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 578045,
        "val": "[578045] Krasny Les 4106 [578045] Krásný Les"
    },
    {
        "kod": 555347,
        "nazev": "Kyselka",
        "popis": "[555347] Kyselka",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555347,
        "val": "[555347] Kyselka 4103 [555347] Kyselka"
    },
    {
        "kod": 555363,
        "nazev": "Merklín",
        "popis": "[555363] Merklín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555363,
        "val": "[555363] Merklin 4106 [555363] Merklín"
    },
    {
        "kod": 537934,
        "nazev": "Mírová",
        "popis": "[537934] Mírová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537934,
        "val": "[537934] Mirova 4103 [537934] Mírová"
    },
    {
        "kod": 555380,
        "nazev": "Nejdek",
        "popis": "[555380] Nejdek",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555380,
        "val": "[555380] Nejdek 4103 [555380] Nejdek"
    },
    {
        "kod": 555398,
        "nazev": "Nová Role",
        "popis": "[555398] Nová Role",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555398,
        "val": "[555398] Nova Role 4103 [555398] Nová Role"
    },
    {
        "kod": 506494,
        "nazev": "Nové Hamry",
        "popis": "[506494] Nové Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 506494,
        "val": "[506494] Nove Hamry 4103 [506494] Nové Hamry"
    },
    {
        "kod": 555428,
        "nazev": "Ostrov",
        "popis": "[555428] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555428,
        "val": "[555428] Ostrov 4106 [555428] Ostrov"
    },
    {
        "kod": 537969,
        "nazev": "Otovice",
        "popis": "[537969] Otovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537969,
        "val": "[537969] Otovice 4103 [537969] Otovice"
    },
    {
        "kod": 555444,
        "nazev": "Otročín",
        "popis": "[555444] Otročín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555444,
        "val": "[555444] Otrocin 4103 [555444] Otročín"
    },
    {
        "kod": 555452,
        "nazev": "Pernink",
        "popis": "[555452] Pernink",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555452,
        "val": "[555452] Pernink 4106 [555452] Pernink"
    },
    {
        "kod": 556947,
        "nazev": "Pila",
        "popis": "[556947] Pila",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 556947,
        "val": "[556947] Pila 4103 [556947] Pila"
    },
    {
        "kod": 555479,
        "nazev": "Potůčky",
        "popis": "[555479] Potůčky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555479,
        "val": "[555479] Potucky 4106 [555479] Potůčky"
    },
    {
        "kod": 555525,
        "nazev": "Pšov",
        "popis": "[555525] Pšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555525,
        "val": "[555525] Psov 4103 [555525] Pšov"
    },
    {
        "kod": 555533,
        "nazev": "Sadov",
        "popis": "[555533] Sadov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555533,
        "val": "[555533] Sadov 4103 [555533] Sadov"
    },
    {
        "kod": 538027,
        "nazev": "Smolné Pece",
        "popis": "[538027] Smolné Pece",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 538027,
        "val": "[538027] Smolne Pece 4103 [538027] Smolné Pece"
    },
    {
        "kod": 555550,
        "nazev": "Stanovice",
        "popis": "[555550] Stanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555550,
        "val": "[555550] Stanovice 4103 [555550] Stanovice"
    },
    {
        "kod": 555584,
        "nazev": "Stráž nad Ohří",
        "popis": "[555584] Stráž nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555584,
        "val": "[555584] Straz nad Ohri 4106 [555584] Stráž nad Ohří"
    },
    {
        "kod": 555592,
        "nazev": "Stružná",
        "popis": "[555592] Stružná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555592,
        "val": "[555592] Struzna 4103 [555592] Stružná"
    },
    {
        "kod": 555614,
        "nazev": "Šemnice",
        "popis": "[555614] Šemnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555614,
        "val": "[555614] Semnice 4103 [555614] Šemnice"
    },
    {
        "kod": 555622,
        "nazev": "Štědrá",
        "popis": "[555622] Štědrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555622,
        "val": "[555622] Stedra 4103 [555622] Štědrá"
    },
    {
        "kod": 537845,
        "nazev": "Teplička",
        "popis": "[537845] Teplička",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 537845,
        "val": "[537845] Teplicka 4103 [537845] Teplička"
    },
    {
        "kod": 555657,
        "nazev": "Toužim",
        "popis": "[555657] Toužim",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555657,
        "val": "[555657] Touzim 4103 [555657] Toužim"
    },
    {
        "kod": 555681,
        "nazev": "Útvina",
        "popis": "[555681] Útvina",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555681,
        "val": "[555681] Utvina 4103 [555681] Útvina"
    },
    {
        "kod": 555690,
        "nazev": "Valeč",
        "popis": "[555690] Valeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555690,
        "val": "[555690] Valec 4103 [555690] Valeč"
    },
    {
        "kod": 555703,
        "nazev": "Velichov",
        "popis": "[555703] Velichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555703,
        "val": "[555703] Velichov 4106 [555703] Velichov"
    },
    {
        "kod": 555711,
        "nazev": "Verušičky",
        "popis": "[555711] Verušičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555711,
        "val": "[555711] Verusicky 4103 [555711] Verušičky"
    },
    {
        "kod": 555738,
        "nazev": "Vojkovice",
        "popis": "[555738] Vojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4106,
        "iczuj": 555738,
        "val": "[555738] Vojkovice 4106 [555738] Vojkovice"
    },
    {
        "kod": 566675,
        "nazev": "Vrbice",
        "popis": "[566675] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 566675,
        "val": "[566675] Vrbice 4103 [566675] Vrbice"
    },
    {
        "kod": 578029,
        "nazev": "Vysoká Pec",
        "popis": "[578029] Vysoká Pec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 578029,
        "val": "[578029] Vysoka Pec 4103 [578029] Vysoká Pec"
    },
    {
        "kod": 555762,
        "nazev": "Žlutice",
        "popis": "[555762] Žlutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4103,
        "iczuj": 555762,
        "val": "[555762] Zlutice 4103 [555762] Žlutice"
    },
    {
        "kod": 560294,
        "nazev": "Březová",
        "popis": "[560294] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560294,
        "val": "[560294] Brezova 4107 [560294] Březová"
    },
    {
        "kod": 560308,
        "nazev": "Bublava",
        "popis": "[560308] Bublava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560308,
        "val": "[560308] Bublava 4104 [560308] Bublava"
    },
    {
        "kod": 560316,
        "nazev": "Bukovany",
        "popis": "[560316] Bukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560316,
        "val": "[560316] Bukovany 4107 [560316] Bukovany"
    },
    {
        "kod": 560324,
        "nazev": "Citice",
        "popis": "[560324] Citice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560324,
        "val": "[560324] Citice 4107 [560324] Citice"
    },
    {
        "kod": 560332,
        "nazev": "Dasnice",
        "popis": "[560332] Dasnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560332,
        "val": "[560332] Dasnice 4107 [560332] Dasnice"
    },
    {
        "kod": 560341,
        "nazev": "Dolní Nivy",
        "popis": "[560341] Dolní Nivy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560341,
        "val": "[560341] Dolni Nivy 4107 [560341] Dolní Nivy"
    },
    {
        "kod": 538591,
        "nazev": "Dolní Rychnov",
        "popis": "[538591] Dolní Rychnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 538591,
        "val": "[538591] Dolni Rychnov 4107 [538591] Dolní Rychnov"
    },
    {
        "kod": 560359,
        "nazev": "Habartov",
        "popis": "[560359] Habartov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560359,
        "val": "[560359] Habartov 4107 [560359] Habartov"
    },
    {
        "kod": 560367,
        "nazev": "Horní Slavkov",
        "popis": "[560367] Horní Slavkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560367,
        "val": "[560367] Horni Slavkov 4107 [560367] Horní Slavkov"
    },
    {
        "kod": 560375,
        "nazev": "Chlum Svaté Maří",
        "popis": "[560375] Chlum Svaté Maří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560375,
        "val": "[560375] Chlum Svate Mari 4107 [560375] Chlum Svaté Maří"
    },
    {
        "kod": 560383,
        "nazev": "Chodov",
        "popis": "[560383] Chodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560383,
        "val": "[560383] Chodov 4107 [560383] Chodov"
    },
    {
        "kod": 560413,
        "nazev": "Jindřichovice",
        "popis": "[560413] Jindřichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560413,
        "val": "[560413] Jindrichovice 4104 [560413] Jindřichovice"
    },
    {
        "kod": 511587,
        "nazev": "Josefov",
        "popis": "[511587] Josefov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 511587,
        "val": "[511587] Josefov 4107 [511587] Josefov"
    },
    {
        "kod": 560421,
        "nazev": "Kaceřov",
        "popis": "[560421] Kaceřov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560421,
        "val": "[560421] Kacerov 4107 [560421] Kaceřov"
    },
    {
        "kod": 560456,
        "nazev": "Krajková",
        "popis": "[560456] Krajková",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560456,
        "val": "[560456] Krajkova 4107 [560456] Krajková"
    },
    {
        "kod": 560464,
        "nazev": "Královské Poříčí",
        "popis": "[560464] Královské Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560464,
        "val": "[560464] Kralovske Porici 4107 [560464] Královské Poříčí"
    },
    {
        "kod": 560472,
        "nazev": "Kraslice",
        "popis": "[560472] Kraslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560472,
        "val": "[560472] Kraslice 4104 [560472] Kraslice"
    },
    {
        "kod": 538337,
        "nazev": "Krásno",
        "popis": "[538337] Krásno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 538337,
        "val": "[538337] Krasno 4107 [538337] Krásno"
    },
    {
        "kod": 560499,
        "nazev": "Kynšperk nad Ohří",
        "popis": "[560499] Kynšperk nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560499,
        "val": "[560499] Kynsperk nad Ohri 4107 [560499] Kynšperk nad Ohří"
    },
    {
        "kod": 560502,
        "nazev": "Libavské Údolí",
        "popis": "[560502] Libavské Údolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560502,
        "val": "[560502] Libavske Udoli 4107 [560502] Libavské Údolí"
    },
    {
        "kod": 560537,
        "nazev": "Loket",
        "popis": "[560537] Loket",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560537,
        "val": "[560537] Loket 4107 [560537] Loket"
    },
    {
        "kod": 560545,
        "nazev": "Lomnice",
        "popis": "[560545] Lomnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560545,
        "val": "[560545] Lomnice 4107 [560545] Lomnice"
    },
    {
        "kod": 560561,
        "nazev": "Nová Ves",
        "popis": "[560561] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560561,
        "val": "[560561] Nova Ves 4107 [560561] Nová Ves"
    },
    {
        "kod": 560570,
        "nazev": "Nové Sedlo",
        "popis": "[560570] Nové Sedlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560570,
        "val": "[560570] Nove Sedlo 4107 [560570] Nové Sedlo"
    },
    {
        "kod": 560588,
        "nazev": "Oloví",
        "popis": "[560588] Oloví",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560588,
        "val": "[560588] Olovi 4104 [560588] Oloví"
    },
    {
        "kod": 560596,
        "nazev": "Přebuz",
        "popis": "[560596] Přebuz",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560596,
        "val": "[560596] Prebuz 4104 [560596] Přebuz"
    },
    {
        "kod": 560600,
        "nazev": "Rotava",
        "popis": "[560600] Rotava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560600,
        "val": "[560600] Rotava 4104 [560600] Rotava"
    },
    {
        "kod": 560618,
        "nazev": "Rovná",
        "popis": "[560618] Rovná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560618,
        "val": "[560618] Rovna 4107 [560618] Rovná"
    },
    {
        "kod": 560286,
        "nazev": "Sokolov",
        "popis": "[560286] Sokolov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560286,
        "val": "[560286] Sokolov 4107 [560286] Sokolov"
    },
    {
        "kod": 560642,
        "nazev": "Staré Sedlo",
        "popis": "[560642] Staré Sedlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560642,
        "val": "[560642] Stare Sedlo 4107 [560642] Staré Sedlo"
    },
    {
        "kod": 560651,
        "nazev": "Stříbrná",
        "popis": "[560651] Stříbrná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560651,
        "val": "[560651] Stribrna 4104 [560651] Stříbrná"
    },
    {
        "kod": 538434,
        "nazev": "Svatava",
        "popis": "[538434] Svatava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 538434,
        "val": "[538434] Svatava 4107 [538434] Svatava"
    },
    {
        "kod": 538396,
        "nazev": "Šabina",
        "popis": "[538396] Šabina",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 538396,
        "val": "[538396] Sabina 4107 [538396] Šabina"
    },
    {
        "kod": 560677,
        "nazev": "Šindelová",
        "popis": "[560677] Šindelová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4104,
        "iczuj": 560677,
        "val": "[560677] Sindelova 4104 [560677] Šindelová"
    },
    {
        "kod": 538663,
        "nazev": "Tatrovice",
        "popis": "[538663] Tatrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 538663,
        "val": "[538663] Tatrovice 4107 [538663] Tatrovice"
    },
    {
        "kod": 579360,
        "nazev": "Těšovice",
        "popis": "[579360] Těšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 579360,
        "val": "[579360] Tesovice 4107 [579360] Těšovice"
    },
    {
        "kod": 560685,
        "nazev": "Vintířov",
        "popis": "[560685] Vintířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560685,
        "val": "[560685] Vintirov 4107 [560685] Vintířov"
    },
    {
        "kod": 560707,
        "nazev": "Vřesová",
        "popis": "[560707] Vřesová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4107,
        "iczuj": 560707,
        "val": "[560707] Vresova 4107 [560707] Vřesová"
    },
    {
        "kod": 562343,
        "nazev": "Arnoltice",
        "popis": "[562343] Arnoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562343,
        "val": "[562343] Arnoltice 4202 [562343] Arnoltice"
    },
    {
        "kod": 562351,
        "nazev": "Benešov nad Ploučnicí",
        "popis": "[562351] Benešov nad Ploučnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562351,
        "val": "[562351] Benesov nad Ploucnici 4202 [562351] Benešov nad Ploučnicí"
    },
    {
        "kod": 544647,
        "nazev": "Bynovec",
        "popis": "[544647] Bynovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 544647,
        "val": "[544647] Bynovec 4202 [544647] Bynovec"
    },
    {
        "kod": 562394,
        "nazev": "Česká Kamenice",
        "popis": "[562394] Česká Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562394,
        "val": "[562394] Ceska Kamenice 4202 [562394] Česká Kamenice"
    },
    {
        "kod": 562335,
        "nazev": "Děčín",
        "popis": "[562335] Děčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562335,
        "val": "[562335] Decin 4202 [562335] Děčín"
    },
    {
        "kod": 562408,
        "nazev": "Dobkovice",
        "popis": "[562408] Dobkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562408,
        "val": "[562408] Dobkovice 4202 [562408] Dobkovice"
    },
    {
        "kod": 545783,
        "nazev": "Dobrná",
        "popis": "[545783] Dobrná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545783,
        "val": "[545783] Dobrna 4202 [545783] Dobrná"
    },
    {
        "kod": 545856,
        "nazev": "Dolní Habartice",
        "popis": "[545856] Dolní Habartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545856,
        "val": "[545856] Dolni Habartice 4202 [545856] Dolní Habartice"
    },
    {
        "kod": 562432,
        "nazev": "Dolní Podluží",
        "popis": "[562432] Dolní Podluží",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562432,
        "val": "[562432] Dolni Podluzi 4215 [562432] Dolní Podluží"
    },
    {
        "kod": 562441,
        "nazev": "Dolní Poustevna",
        "popis": "[562441] Dolní Poustevna",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562441,
        "val": "[562441] Dolni Poustevna 4212 [562441] Dolní Poustevna"
    },
    {
        "kod": 530417,
        "nazev": "Doubice",
        "popis": "[530417] Doubice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 530417,
        "val": "[530417] Doubice 4212 [530417] Doubice"
    },
    {
        "kod": 545899,
        "nazev": "Františkov nad Ploučnicí",
        "popis": "[545899] Františkov nad Ploučnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545899,
        "val": "[545899] Frantiskov nad Ploucnici 4202 [545899] Františkov nad Ploučnicí"
    },
    {
        "kod": 562483,
        "nazev": "Heřmanov",
        "popis": "[562483] Heřmanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562483,
        "val": "[562483] Hermanov 4202 [562483] Heřmanov"
    },
    {
        "kod": 545929,
        "nazev": "Horní Habartice",
        "popis": "[545929] Horní Habartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545929,
        "val": "[545929] Horni Habartice 4202 [545929] Horní Habartice"
    },
    {
        "kod": 562505,
        "nazev": "Horní Podluží",
        "popis": "[562505] Horní Podluží",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562505,
        "val": "[562505] Horni Podluzi 4215 [562505] Horní Podluží"
    },
    {
        "kod": 562513,
        "nazev": "Hřensko",
        "popis": "[562513] Hřensko",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562513,
        "val": "[562513] Hrensko 4202 [562513] Hřensko"
    },
    {
        "kod": 562521,
        "nazev": "Huntířov",
        "popis": "[562521] Huntířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562521,
        "val": "[562521] Huntirov 4202 [562521] Huntířov"
    },
    {
        "kod": 562530,
        "nazev": "Chřibská",
        "popis": "[562530] Chřibská",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562530,
        "val": "[562530] Chribska 4215 [562530] Chřibská"
    },
    {
        "kod": 544680,
        "nazev": "Janov",
        "popis": "[544680] Janov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 544680,
        "val": "[544680] Janov 4202 [544680] Janov"
    },
    {
        "kod": 530395,
        "nazev": "Janská",
        "popis": "[530395] Janská",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 530395,
        "val": "[530395] Janska 4202 [530395] Janská"
    },
    {
        "kod": 562556,
        "nazev": "Jetřichovice",
        "popis": "[562556] Jetřichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562556,
        "val": "[562556] Jetrichovice 4202 [562556] Jetřichovice"
    },
    {
        "kod": 562564,
        "nazev": "Jílové",
        "popis": "[562564] Jílové",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562564,
        "val": "[562564] Jilove 4202 [562564] Jílové"
    },
    {
        "kod": 562572,
        "nazev": "Jiřetín pod Jedlovou",
        "popis": "[562572] Jiřetín pod Jedlovou",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562572,
        "val": "[562572] Jiretin pod Jedlovou 4215 [562572] Jiřetín pod Jedlovou"
    },
    {
        "kod": 562581,
        "nazev": "Jiříkov",
        "popis": "[562581] Jiříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562581,
        "val": "[562581] Jirikov 4212 [562581] Jiříkov"
    },
    {
        "kod": 546453,
        "nazev": "Kámen",
        "popis": "[546453] Kámen",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 546453,
        "val": "[546453] Kamen 4202 [546453] Kámen"
    },
    {
        "kod": 562611,
        "nazev": "Krásná Lípa",
        "popis": "[562611] Krásná Lípa",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562611,
        "val": "[562611] Krasna Lipa 4212 [562611] Krásná Lípa"
    },
    {
        "kod": 546330,
        "nazev": "Kunratice",
        "popis": "[546330] Kunratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 546330,
        "val": "[546330] Kunratice 4202 [546330] Kunratice"
    },
    {
        "kod": 562645,
        "nazev": "Kytlice",
        "popis": "[562645] Kytlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562645,
        "val": "[562645] Kytlice 4202 [562645] Kytlice"
    },
    {
        "kod": 544701,
        "nazev": "Labská Stráň",
        "popis": "[544701] Labská Stráň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 544701,
        "val": "[544701] Labska Stran 4202 [544701] Labská Stráň"
    },
    {
        "kod": 562661,
        "nazev": "Lipová",
        "popis": "[562661] Lipová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562661,
        "val": "[562661] Lipova 4212 [562661] Lipová"
    },
    {
        "kod": 545708,
        "nazev": "Lobendava",
        "popis": "[545708] Lobendava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 545708,
        "val": "[545708] Lobendava 4212 [545708] Lobendava"
    },
    {
        "kod": 546496,
        "nazev": "Ludvíkovice",
        "popis": "[546496] Ludvíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 546496,
        "val": "[546496] Ludvikovice 4202 [546496] Ludvíkovice"
    },
    {
        "kod": 562700,
        "nazev": "Malá Veleň",
        "popis": "[562700] Malá Veleň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562700,
        "val": "[562700] Mala Velen 4202 [562700] Malá Veleň"
    },
    {
        "kod": 562718,
        "nazev": "Malšovice",
        "popis": "[562718] Malšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562718,
        "val": "[562718] Malsovice 4202 [562718] Malšovice"
    },
    {
        "kod": 545678,
        "nazev": "Markvartice",
        "popis": "[545678] Markvartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545678,
        "val": "[545678] Markvartice 4202 [545678] Markvartice"
    },
    {
        "kod": 545791,
        "nazev": "Merboltice",
        "popis": "[545791] Merboltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545791,
        "val": "[545791] Merboltice 4202 [545791] Merboltice"
    },
    {
        "kod": 562751,
        "nazev": "Mikulášovice",
        "popis": "[562751] Mikulášovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562751,
        "val": "[562751] Mikulasovice 4212 [562751] Mikulášovice"
    },
    {
        "kod": 562777,
        "nazev": "Rumburk",
        "popis": "[562777] Rumburk",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562777,
        "val": "[562777] Rumburk 4212 [562777] Rumburk"
    },
    {
        "kod": 566900,
        "nazev": "Růžová",
        "popis": "[566900] Růžová",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 566900,
        "val": "[566900] Ruzova 4202 [566900] Růžová"
    },
    {
        "kod": 562793,
        "nazev": "Rybniště",
        "popis": "[562793] Rybniště",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562793,
        "val": "[562793] Rybniste 4215 [562793] Rybniště"
    },
    {
        "kod": 546348,
        "nazev": "Srbská Kamenice",
        "popis": "[546348] Srbská Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 546348,
        "val": "[546348] Srbska Kamenice 4202 [546348] Srbská Kamenice"
    },
    {
        "kod": 562823,
        "nazev": "Staré Křečany",
        "popis": "[562823] Staré Křečany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562823,
        "val": "[562823] Stare Krecany 4212 [562823] Staré Křečany"
    },
    {
        "kod": 545538,
        "nazev": "Starý Šachov",
        "popis": "[545538] Starý Šachov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 545538,
        "val": "[545538] Stary Sachov 4202 [545538] Starý Šachov"
    },
    {
        "kod": 562858,
        "nazev": "Šluknov",
        "popis": "[562858] Šluknov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562858,
        "val": "[562858] Sluknov 4212 [562858] Šluknov"
    },
    {
        "kod": 555193,
        "nazev": "Těchlovice",
        "popis": "[555193] Těchlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 555193,
        "val": "[555193] Techlovice 4202 [555193] Těchlovice"
    },
    {
        "kod": 562874,
        "nazev": "Valkeřice",
        "popis": "[562874] Valkeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562874,
        "val": "[562874] Valkerice 4202 [562874] Valkeřice"
    },
    {
        "kod": 562882,
        "nazev": "Varnsdorf",
        "popis": "[562882] Varnsdorf",
        "datum_od": "",
        "datum_do": "",
        "orp": 4215,
        "iczuj": 562882,
        "val": "[562882] Varnsdorf 4215 [562882] Varnsdorf"
    },
    {
        "kod": 562891,
        "nazev": "Velká Bukovina",
        "popis": "[562891] Velká Bukovina",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562891,
        "val": "[562891] Velka Bukovina 4202 [562891] Velká Bukovina"
    },
    {
        "kod": 562912,
        "nazev": "Velký Šenov",
        "popis": "[562912] Velký Šenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562912,
        "val": "[562912] Velky Senov 4212 [562912] Velký Šenov"
    },
    {
        "kod": 562921,
        "nazev": "Verneřice",
        "popis": "[562921] Verneřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562921,
        "val": "[562921] Vernerice 4202 [562921] Verneřice"
    },
    {
        "kod": 562939,
        "nazev": "Veselé",
        "popis": "[562939] Veselé",
        "datum_od": "",
        "datum_do": "",
        "orp": 4202,
        "iczuj": 562939,
        "val": "[562939] Vesele 4202 [562939] Veselé"
    },
    {
        "kod": 562947,
        "nazev": "Vilémov",
        "popis": "[562947] Vilémov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4212,
        "iczuj": 562947,
        "val": "[562947] Vilemov 4212 [562947] Vilémov"
    },
    {
        "kod": 562980,
        "nazev": "Bílence",
        "popis": "[562980] Bílence",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 562980,
        "val": "[562980] Bilence 4203 [562980] Bílence"
    },
    {
        "kod": 562998,
        "nazev": "Blatno",
        "popis": "[562998] Blatno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 562998,
        "val": "[562998] Blatno 4203 [562998] Blatno"
    },
    {
        "kod": 563005,
        "nazev": "Boleboř",
        "popis": "[563005] Boleboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563005,
        "val": "[563005] Bolebor 4203 [563005] Boleboř"
    },
    {
        "kod": 563013,
        "nazev": "Březno",
        "popis": "[563013] Březno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563013,
        "val": "[563013] Brezno 4203 [563013] Březno"
    },
    {
        "kod": 563021,
        "nazev": "Černovice",
        "popis": "[563021] Černovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563021,
        "val": "[563021] Cernovice 4203 [563021] Černovice"
    },
    {
        "kod": 563048,
        "nazev": "Domašín",
        "popis": "[563048] Domašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563048,
        "val": "[563048] Domasin 4204 [563048] Domašín"
    },
    {
        "kod": 563056,
        "nazev": "Droužkovice",
        "popis": "[563056] Droužkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563056,
        "val": "[563056] Drouzkovice 4203 [563056] Droužkovice"
    },
    {
        "kod": 563064,
        "nazev": "Hora Svatého Šebestiána",
        "popis": "[563064] Hora Svatého Šebestiána",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563064,
        "val": "[563064] Hora Svateho Sebestiana 4203 [563064] Hora Svatého Šebestiána"
    },
    {
        "kod": 563072,
        "nazev": "Hrušovany",
        "popis": "[563072] Hrušovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563072,
        "val": "[563072] Hrusovany 4203 [563072] Hrušovany"
    },
    {
        "kod": 563081,
        "nazev": "Chbany",
        "popis": "[563081] Chbany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563081,
        "val": "[563081] Chbany 4204 [563081] Chbany"
    },
    {
        "kod": 562971,
        "nazev": "Chomutov",
        "popis": "[562971] Chomutov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 562971,
        "val": "[562971] Chomutov 4203 [562971] Chomutov"
    },
    {
        "kod": 563099,
        "nazev": "Jirkov",
        "popis": "[563099] Jirkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563099,
        "val": "[563099] Jirkov 4203 [563099] Jirkov"
    },
    {
        "kod": 563102,
        "nazev": "Kadaň",
        "popis": "[563102] Kadaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563102,
        "val": "[563102] Kadan 4204 [563102] Kadaň"
    },
    {
        "kod": 563111,
        "nazev": "Kalek",
        "popis": "[563111] Kalek",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563111,
        "val": "[563111] Kalek 4203 [563111] Kalek"
    },
    {
        "kod": 563129,
        "nazev": "Klášterec nad Ohří",
        "popis": "[563129] Klášterec nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563129,
        "val": "[563129] Klasterec nad Ohri 4204 [563129] Klášterec nad Ohří"
    },
    {
        "kod": 563137,
        "nazev": "Kovářská",
        "popis": "[563137] Kovářská",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563137,
        "val": "[563137] Kovarska 4204 [563137] Kovářská"
    },
    {
        "kod": 563315,
        "nazev": "Kryštofovy Hamry",
        "popis": "[563315] Kryštofovy Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563315,
        "val": "[563315] Krystofovy Hamry 4204 [563315] Kryštofovy Hamry"
    },
    {
        "kod": 563161,
        "nazev": "Křimov",
        "popis": "[563161] Křimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563161,
        "val": "[563161] Krimov 4203 [563161] Křimov"
    },
    {
        "kod": 563188,
        "nazev": "Libědice",
        "popis": "[563188] Libědice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563188,
        "val": "[563188] Libedice 4204 [563188] Libědice"
    },
    {
        "kod": 546518,
        "nazev": "Loučná pod Klínovcem",
        "popis": "[546518] Loučná pod Klínovcem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 546518,
        "val": "[546518] Loucna pod Klinovcem 4204 [546518] Loučná pod Klínovcem"
    },
    {
        "kod": 563200,
        "nazev": "Málkov",
        "popis": "[563200] Málkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563200,
        "val": "[563200] Malkov 4203 [563200] Málkov"
    },
    {
        "kod": 563218,
        "nazev": "Mašťov",
        "popis": "[563218] Mašťov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563218,
        "val": "[563218] Mastov 4204 [563218] Mašťov"
    },
    {
        "kod": 563226,
        "nazev": "Měděnec",
        "popis": "[563226] Měděnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563226,
        "val": "[563226] Medenec 4204 [563226] Měděnec"
    },
    {
        "kod": 563242,
        "nazev": "Místo",
        "popis": "[563242] Místo",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563242,
        "val": "[563242] Misto 4203 [563242] Místo"
    },
    {
        "kod": 546160,
        "nazev": "Nezabylice",
        "popis": "[546160] Nezabylice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 546160,
        "val": "[546160] Nezabylice 4203 [546160] Nezabylice"
    },
    {
        "kod": 563269,
        "nazev": "Okounov",
        "popis": "[563269] Okounov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563269,
        "val": "[563269] Okounov 4204 [563269] Okounov"
    },
    {
        "kod": 563277,
        "nazev": "Otvice",
        "popis": "[563277] Otvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563277,
        "val": "[563277] Otvice 4203 [563277] Otvice"
    },
    {
        "kod": 563285,
        "nazev": "Perštejn",
        "popis": "[563285] Perštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563285,
        "val": "[563285] Perstejn 4204 [563285] Perštejn"
    },
    {
        "kod": 546062,
        "nazev": "Pesvice",
        "popis": "[546062] Pesvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 546062,
        "val": "[546062] Pesvice 4203 [546062] Pesvice"
    },
    {
        "kod": 563293,
        "nazev": "Pětipsy",
        "popis": "[563293] Pětipsy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563293,
        "val": "[563293] Petipsy 4204 [563293] Pětipsy"
    },
    {
        "kod": 546071,
        "nazev": "Račetice",
        "popis": "[546071] Račetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 546071,
        "val": "[546071] Racetice 4204 [546071] Račetice"
    },
    {
        "kod": 563323,
        "nazev": "Radonice",
        "popis": "[563323] Radonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563323,
        "val": "[563323] Radonice 4204 [563323] Radonice"
    },
    {
        "kod": 563331,
        "nazev": "Rokle",
        "popis": "[563331] Rokle",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563331,
        "val": "[563331] Rokle 4204 [563331] Rokle"
    },
    {
        "kod": 563340,
        "nazev": "Spořice",
        "popis": "[563340] Spořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563340,
        "val": "[563340] Sporice 4203 [563340] Spořice"
    },
    {
        "kod": 563358,
        "nazev": "Strupčice",
        "popis": "[563358] Strupčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563358,
        "val": "[563358] Strupcice 4203 [563358] Strupčice"
    },
    {
        "kod": 563382,
        "nazev": "Údlice",
        "popis": "[563382] Údlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563382,
        "val": "[563382] Udlice 4203 [563382] Údlice"
    },
    {
        "kod": 563404,
        "nazev": "Vejprty",
        "popis": "[563404] Vejprty",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563404,
        "val": "[563404] Vejprty 4204 [563404] Vejprty"
    },
    {
        "kod": 563412,
        "nazev": "Veliká Ves",
        "popis": "[563412] Veliká Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563412,
        "val": "[563412] Velika Ves 4204 [563412] Veliká Ves"
    },
    {
        "kod": 563439,
        "nazev": "Vilémov",
        "popis": "[563439] Vilémov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4204,
        "iczuj": 563439,
        "val": "[563439] Vilemov 4204 [563439] Vilémov"
    },
    {
        "kod": 563463,
        "nazev": "Vrskmaň",
        "popis": "[563463] Vrskmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563463,
        "val": "[563463] Vrskman 4203 [563463] Vrskmaň"
    },
    {
        "kod": 563471,
        "nazev": "Všehrdy",
        "popis": "[563471] Všehrdy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563471,
        "val": "[563471] Vsehrdy 4203 [563471] Všehrdy"
    },
    {
        "kod": 563480,
        "nazev": "Všestudy",
        "popis": "[563480] Všestudy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563480,
        "val": "[563480] Vsestudy 4203 [563480] Všestudy"
    },
    {
        "kod": 563498,
        "nazev": "Výsluní",
        "popis": "[563498] Výsluní",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563498,
        "val": "[563498] Vysluni 4203 [563498] Výsluní"
    },
    {
        "kod": 563501,
        "nazev": "Vysoká Pec",
        "popis": "[563501] Vysoká Pec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4203,
        "iczuj": 563501,
        "val": "[563501] Vysoka Pec 4203 [563501] Vysoká Pec"
    },
    {
        "kod": 564575,
        "nazev": "Bechlín",
        "popis": "[564575] Bechlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564575,
        "val": "[564575] Bechlin 4211 [564575] Bechlín"
    },
    {
        "kod": 564591,
        "nazev": "Bohušovice nad Ohří",
        "popis": "[564591] Bohušovice nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564591,
        "val": "[564591] Bohusovice nad Ohri 4205 [564591] Bohušovice nad Ohří"
    },
    {
        "kod": 564613,
        "nazev": "Brňany",
        "popis": "[564613] Brňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564613,
        "val": "[564613] Brnany 4205 [564613] Brňany"
    },
    {
        "kod": 564621,
        "nazev": "Brozany nad Ohří",
        "popis": "[564621] Brozany nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564621,
        "val": "[564621] Brozany nad Ohri 4205 [564621] Brozany nad Ohří"
    },
    {
        "kod": 546755,
        "nazev": "Brzánky",
        "popis": "[546755] Brzánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 546755,
        "val": "[546755] Brzanky 4211 [546755] Brzánky"
    },
    {
        "kod": 564648,
        "nazev": "Bříza",
        "popis": "[564648] Bříza",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564648,
        "val": "[564648] Briza 4211 [564648] Bříza"
    },
    {
        "kod": 564656,
        "nazev": "Budyně nad Ohří",
        "popis": "[564656] Budyně nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564656,
        "val": "[564656] Budyne nad Ohri 4211 [564656] Budyně nad Ohří"
    },
    {
        "kod": 546780,
        "nazev": "Býčkovice",
        "popis": "[546780] Býčkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 546780,
        "val": "[546780] Byckovice 4205 [546780] Býčkovice"
    },
    {
        "kod": 564672,
        "nazev": "Ctiněves",
        "popis": "[564672] Ctiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564672,
        "val": "[564672] Ctineves 4211 [564672] Ctiněves"
    },
    {
        "kod": 546852,
        "nazev": "Černěves",
        "popis": "[546852] Černěves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 546852,
        "val": "[546852] Cerneves 4211 [546852] Černěves"
    },
    {
        "kod": 564699,
        "nazev": "Černiv",
        "popis": "[564699] Černiv",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564699,
        "val": "[564699] Cerniv 4208 [564699] Černiv"
    },
    {
        "kod": 542423,
        "nazev": "Černouček",
        "popis": "[542423] Černouček",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 542423,
        "val": "[542423] Cernoucek 4211 [542423] Černouček"
    },
    {
        "kod": 564711,
        "nazev": "Čížkovice",
        "popis": "[564711] Čížkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564711,
        "val": "[564711] Cizkovice 4208 [564711] Čížkovice"
    },
    {
        "kod": 564729,
        "nazev": "Děčany",
        "popis": "[564729] Děčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564729,
        "val": "[564729] Decany 4208 [564729] Děčany"
    },
    {
        "kod": 564737,
        "nazev": "Dlažkovice",
        "popis": "[564737] Dlažkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564737,
        "val": "[564737] Dlazkovice 4208 [564737] Dlažkovice"
    },
    {
        "kod": 564745,
        "nazev": "Dobříň",
        "popis": "[564745] Dobříň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564745,
        "val": "[564745] Dobrin 4211 [564745] Dobříň"
    },
    {
        "kod": 564753,
        "nazev": "Doksany",
        "popis": "[564753] Doksany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564753,
        "val": "[564753] Doksany 4211 [564753] Doksany"
    },
    {
        "kod": 553646,
        "nazev": "Dolánky nad Ohří",
        "popis": "[553646] Dolánky nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 553646,
        "val": "[553646] Dolanky nad Ohri 4205 [553646] Dolánky nad Ohří"
    },
    {
        "kod": 564770,
        "nazev": "Drahobuz",
        "popis": "[564770] Drahobuz",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564770,
        "val": "[564770] Drahobuz 4205 [564770] Drahobuz"
    },
    {
        "kod": 564818,
        "nazev": "Dušníky",
        "popis": "[564818] Dušníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564818,
        "val": "[564818] Dusniky 4211 [564818] Dušníky"
    },
    {
        "kod": 564834,
        "nazev": "Evaň",
        "popis": "[564834] Evaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564834,
        "val": "[564834] Evan 4208 [564834] Evaň"
    },
    {
        "kod": 564842,
        "nazev": "Hlinná",
        "popis": "[564842] Hlinná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564842,
        "val": "[564842] Hlinna 4205 [564842] Hlinná"
    },
    {
        "kod": 564851,
        "nazev": "Horní Beřkovice",
        "popis": "[564851] Horní Beřkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564851,
        "val": "[564851] Horni Berkovice 4211 [564851] Horní Beřkovice"
    },
    {
        "kod": 546763,
        "nazev": "Horní Řepčice",
        "popis": "[546763] Horní Řepčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 546763,
        "val": "[546763] Horni Repcice 4205 [546763] Horní Řepčice"
    },
    {
        "kod": 564877,
        "nazev": "Hoštka",
        "popis": "[564877] Hoštka",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564877,
        "val": "[564877] Hostka 4205 [564877] Hoštka"
    },
    {
        "kod": 564893,
        "nazev": "Hrobce",
        "popis": "[564893] Hrobce",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564893,
        "val": "[564893] Hrobce 4211 [564893] Hrobce"
    },
    {
        "kod": 564923,
        "nazev": "Chodouny",
        "popis": "[564923] Chodouny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 564923,
        "val": "[564923] Chodouny 4211 [564923] Chodouny"
    },
    {
        "kod": 564931,
        "nazev": "Chodovlice",
        "popis": "[564931] Chodovlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564931,
        "val": "[564931] Chodovlice 4208 [564931] Chodovlice"
    },
    {
        "kod": 564940,
        "nazev": "Chotěšov",
        "popis": "[564940] Chotěšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564940,
        "val": "[564940] Chotesov 4208 [564940] Chotěšov"
    },
    {
        "kod": 564958,
        "nazev": "Chotiměř",
        "popis": "[564958] Chotiměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 564958,
        "val": "[564958] Chotimer 4208 [564958] Chotiměř"
    },
    {
        "kod": 564966,
        "nazev": "Chotiněves",
        "popis": "[564966] Chotiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564966,
        "val": "[564966] Chotineves 4205 [564966] Chotiněves"
    },
    {
        "kod": 546810,
        "nazev": "Chudoslavice",
        "popis": "[546810] Chudoslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 546810,
        "val": "[546810] Chudoslavice 4205 [546810] Chudoslavice"
    },
    {
        "kod": 505528,
        "nazev": "Jenčice",
        "popis": "[505528] Jenčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 505528,
        "val": "[505528] Jencice 4208 [505528] Jenčice"
    },
    {
        "kod": 546771,
        "nazev": "Kamýk",
        "popis": "[546771] Kamýk",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 546771,
        "val": "[546771] Kamyk 4205 [546771] Kamýk"
    },
    {
        "kod": 565016,
        "nazev": "Keblice",
        "popis": "[565016] Keblice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565016,
        "val": "[565016] Keblice 4208 [565016] Keblice"
    },
    {
        "kod": 565024,
        "nazev": "Klapý",
        "popis": "[565024] Klapý",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565024,
        "val": "[565024] Klapy 4208 [565024] Klapý"
    },
    {
        "kod": 565032,
        "nazev": "Kleneč",
        "popis": "[565032] Kleneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565032,
        "val": "[565032] Klenec 4211 [565032] Kleneč"
    },
    {
        "kod": 565059,
        "nazev": "Kostomlaty pod Řípem",
        "popis": "[565059] Kostomlaty pod Řípem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565059,
        "val": "[565059] Kostomlaty pod Ripem 4211 [565059] Kostomlaty pod Řípem"
    },
    {
        "kod": 565067,
        "nazev": "Krabčice",
        "popis": "[565067] Krabčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565067,
        "val": "[565067] Krabcice 4211 [565067] Krabčice"
    },
    {
        "kod": 565075,
        "nazev": "Křesín",
        "popis": "[565075] Křesín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565075,
        "val": "[565075] Kresin 4208 [565075] Křesín"
    },
    {
        "kod": 565083,
        "nazev": "Křešice",
        "popis": "[565083] Křešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565083,
        "val": "[565083] Kresice 4205 [565083] Křešice"
    },
    {
        "kod": 565091,
        "nazev": "Kyškovice",
        "popis": "[565091] Kyškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565091,
        "val": "[565091] Kyskovice 4211 [565091] Kyškovice"
    },
    {
        "kod": 565105,
        "nazev": "Levín",
        "popis": "[565105] Levín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565105,
        "val": "[565105] Levin 4205 [565105] Levín"
    },
    {
        "kod": 565113,
        "nazev": "Lhotka nad Labem",
        "popis": "[565113] Lhotka nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565113,
        "val": "[565113] Lhotka nad Labem 4208 [565113] Lhotka nad Labem"
    },
    {
        "kod": 565121,
        "nazev": "Liběšice",
        "popis": "[565121] Liběšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565121,
        "val": "[565121] Libesice 4205 [565121] Liběšice"
    },
    {
        "kod": 565148,
        "nazev": "Libkovice pod Řípem",
        "popis": "[565148] Libkovice pod Řípem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565148,
        "val": "[565148] Libkovice pod Ripem 4211 [565148] Libkovice pod Řípem"
    },
    {
        "kod": 565156,
        "nazev": "Libochovany",
        "popis": "[565156] Libochovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565156,
        "val": "[565156] Libochovany 4205 [565156] Libochovany"
    },
    {
        "kod": 565164,
        "nazev": "Libochovice",
        "popis": "[565164] Libochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565164,
        "val": "[565164] Libochovice 4208 [565164] Libochovice"
    },
    {
        "kod": 565172,
        "nazev": "Libotenice",
        "popis": "[565172] Libotenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565172,
        "val": "[565172] Libotenice 4211 [565172] Libotenice"
    },
    {
        "kod": 564567,
        "nazev": "Litoměřice",
        "popis": "[564567] Litoměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 564567,
        "val": "[564567] Litomerice 4205 [564567] Litoměřice"
    },
    {
        "kod": 546691,
        "nazev": "Lkáň",
        "popis": "[546691] Lkáň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 546691,
        "val": "[546691] Lkan 4208 [546691] Lkáň"
    },
    {
        "kod": 565211,
        "nazev": "Lovečkovice",
        "popis": "[565211] Lovečkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565211,
        "val": "[565211] Loveckovice 4205 [565211] Lovečkovice"
    },
    {
        "kod": 565229,
        "nazev": "Lovosice",
        "popis": "[565229] Lovosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565229,
        "val": "[565229] Lovosice 4208 [565229] Lovosice"
    },
    {
        "kod": 565237,
        "nazev": "Lukavec",
        "popis": "[565237] Lukavec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565237,
        "val": "[565237] Lukavec 4208 [565237] Lukavec"
    },
    {
        "kod": 565245,
        "nazev": "Malé Žernoseky",
        "popis": "[565245] Malé Žernoseky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565245,
        "val": "[565245] Male Zernoseky 4208 [565245] Malé Žernoseky"
    },
    {
        "kod": 542491,
        "nazev": "Malíč",
        "popis": "[542491] Malíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 542491,
        "val": "[542491] Malic 4205 [542491] Malíč"
    },
    {
        "kod": 565253,
        "nazev": "Martiněves",
        "popis": "[565253] Martiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565253,
        "val": "[565253] Martineves 4211 [565253] Martiněves"
    },
    {
        "kod": 542521,
        "nazev": "Michalovice",
        "popis": "[542521] Michalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 542521,
        "val": "[542521] Michalovice 4205 [542521] Michalovice"
    },
    {
        "kod": 530506,
        "nazev": "Miřejovice",
        "popis": "[530506] Miřejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 530506,
        "val": "[530506] Mirejovice 4205 [530506] Miřejovice"
    },
    {
        "kod": 565296,
        "nazev": "Mlékojedy",
        "popis": "[565296] Mlékojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565296,
        "val": "[565296] Mlekojedy 4205 [565296] Mlékojedy"
    },
    {
        "kod": 565300,
        "nazev": "Mnetěš",
        "popis": "[565300] Mnetěš",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565300,
        "val": "[565300] Mnetes 4211 [565300] Mnetěš"
    },
    {
        "kod": 565318,
        "nazev": "Mšené-lázně",
        "popis": "[565318] Mšené-lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565318,
        "val": "[565318] Msene-lazne 4211 [565318] Mšené-lázně"
    },
    {
        "kod": 565342,
        "nazev": "Nové Dvory",
        "popis": "[565342] Nové Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565342,
        "val": "[565342] Nove Dvory 4211 [565342] Nové Dvory"
    },
    {
        "kod": 542440,
        "nazev": "Oleško",
        "popis": "[542440] Oleško",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 542440,
        "val": "[542440] Olesko 4205 [542440] Oleško"
    },
    {
        "kod": 542539,
        "nazev": "Píšťany",
        "popis": "[542539] Píšťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 542539,
        "val": "[542539] Pistany 4205 [542539] Píšťany"
    },
    {
        "kod": 565393,
        "nazev": "Ploskovice",
        "popis": "[565393] Ploskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565393,
        "val": "[565393] Ploskovice 4205 [565393] Ploskovice"
    },
    {
        "kod": 565415,
        "nazev": "Podsedice",
        "popis": "[565415] Podsedice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565415,
        "val": "[565415] Podsedice 4208 [565415] Podsedice"
    },
    {
        "kod": 565431,
        "nazev": "Polepy",
        "popis": "[565431] Polepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565431,
        "val": "[565431] Polepy 4205 [565431] Polepy"
    },
    {
        "kod": 565458,
        "nazev": "Prackovice nad Labem",
        "popis": "[565458] Prackovice nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565458,
        "val": "[565458] Prackovice nad Labem 4208 [565458] Prackovice nad Labem"
    },
    {
        "kod": 565474,
        "nazev": "Přestavlky",
        "popis": "[565474] Přestavlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565474,
        "val": "[565474] Prestavlky 4211 [565474] Přestavlky"
    },
    {
        "kod": 565482,
        "nazev": "Račice",
        "popis": "[565482] Račice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565482,
        "val": "[565482] Racice 4205 [565482] Račice"
    },
    {
        "kod": 565491,
        "nazev": "Račiněves",
        "popis": "[565491] Račiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565491,
        "val": "[565491] Racineves 4211 [565491] Račiněves"
    },
    {
        "kod": 565521,
        "nazev": "Radovesice",
        "popis": "[565521] Radovesice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565521,
        "val": "[565521] Radovesice 4208 [565521] Radovesice"
    },
    {
        "kod": 565547,
        "nazev": "Rochov",
        "popis": "[565547] Rochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565547,
        "val": "[565547] Rochov 4205 [565547] Rochov"
    },
    {
        "kod": 565555,
        "nazev": "Roudnice nad Labem",
        "popis": "[565555] Roudnice nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565555,
        "val": "[565555] Roudnice nad Labem 4211 [565555] Roudnice nad Labem"
    },
    {
        "kod": 546721,
        "nazev": "Sedlec",
        "popis": "[546721] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 546721,
        "val": "[546721] Sedlec 4208 [546721] Sedlec"
    },
    {
        "kod": 565598,
        "nazev": "Siřejovice",
        "popis": "[565598] Siřejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565598,
        "val": "[565598] Sirejovice 4208 [565598] Siřejovice"
    },
    {
        "kod": 565601,
        "nazev": "Slatina",
        "popis": "[565601] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565601,
        "val": "[565601] Slatina 4208 [565601] Slatina"
    },
    {
        "kod": 565610,
        "nazev": "Snědovice",
        "popis": "[565610] Snědovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565610,
        "val": "[565610] Snedovice 4205 [565610] Snědovice"
    },
    {
        "kod": 546828,
        "nazev": "Staňkovice",
        "popis": "[546828] Staňkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 546828,
        "val": "[546828] Stankovice 4205 [546828] Staňkovice"
    },
    {
        "kod": 565679,
        "nazev": "Straškov-Vodochody",
        "popis": "[565679] Straškov-Vodochody",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565679,
        "val": "[565679] Straskov-Vodochody 4211 [565679] Straškov-Vodochody"
    },
    {
        "kod": 565695,
        "nazev": "Sulejovice",
        "popis": "[565695] Sulejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565695,
        "val": "[565695] Sulejovice 4208 [565695] Sulejovice"
    },
    {
        "kod": 565709,
        "nazev": "Štětí",
        "popis": "[565709] Štětí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565709,
        "val": "[565709] Steti 4205 [565709] Štětí"
    },
    {
        "kod": 565717,
        "nazev": "Terezín",
        "popis": "[565717] Terezín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565717,
        "val": "[565717] Terezin 4205 [565717] Terezín"
    },
    {
        "kod": 565741,
        "nazev": "Travčice",
        "popis": "[565741] Travčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565741,
        "val": "[565741] Travcice 4205 [565741] Travčice"
    },
    {
        "kod": 542407,
        "nazev": "Trnovany",
        "popis": "[542407] Trnovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 542407,
        "val": "[542407] Trnovany 4205 [542407] Trnovany"
    },
    {
        "kod": 565768,
        "nazev": "Třebenice",
        "popis": "[565768] Třebenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565768,
        "val": "[565768] Trebenice 4208 [565768] Třebenice"
    },
    {
        "kod": 565776,
        "nazev": "Třebívlice",
        "popis": "[565776] Třebívlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565776,
        "val": "[565776] Trebivlice 4208 [565776] Třebívlice"
    },
    {
        "kod": 565792,
        "nazev": "Třebušín",
        "popis": "[565792] Třebušín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565792,
        "val": "[565792] Trebusin 4205 [565792] Třebušín"
    },
    {
        "kod": 565806,
        "nazev": "Úpohlavy",
        "popis": "[565806] Úpohlavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565806,
        "val": "[565806] Upohlavy 4208 [565806] Úpohlavy"
    },
    {
        "kod": 565814,
        "nazev": "Úštěk",
        "popis": "[565814] Úštěk",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565814,
        "val": "[565814] Ustek 4205 [565814] Úštěk"
    },
    {
        "kod": 565831,
        "nazev": "Vědomice",
        "popis": "[565831] Vědomice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565831,
        "val": "[565831] Vedomice 4211 [565831] Vědomice"
    },
    {
        "kod": 565849,
        "nazev": "Velemín",
        "popis": "[565849] Velemín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565849,
        "val": "[565849] Velemin 4208 [565849] Velemín"
    },
    {
        "kod": 565857,
        "nazev": "Velké Žernoseky",
        "popis": "[565857] Velké Žernoseky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565857,
        "val": "[565857] Velke Zernoseky 4205 [565857] Velké Žernoseky"
    },
    {
        "kod": 565865,
        "nazev": "Vchynice",
        "popis": "[565865] Vchynice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565865,
        "val": "[565865] Vchynice 4208 [565865] Vchynice"
    },
    {
        "kod": 565873,
        "nazev": "Vlastislav",
        "popis": "[565873] Vlastislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565873,
        "val": "[565873] Vlastislav 4208 [565873] Vlastislav"
    },
    {
        "kod": 565881,
        "nazev": "Vražkov",
        "popis": "[565881] Vražkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565881,
        "val": "[565881] Vrazkov 4211 [565881] Vražkov"
    },
    {
        "kod": 565890,
        "nazev": "Vrbice",
        "popis": "[565890] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565890,
        "val": "[565890] Vrbice 4211 [565890] Vrbice"
    },
    {
        "kod": 565903,
        "nazev": "Vrbičany",
        "popis": "[565903] Vrbičany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4208,
        "iczuj": 565903,
        "val": "[565903] Vrbicany 4208 [565903] Vrbičany"
    },
    {
        "kod": 565911,
        "nazev": "Vrutice",
        "popis": "[565911] Vrutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565911,
        "val": "[565911] Vrutice 4205 [565911] Vrutice"
    },
    {
        "kod": 542482,
        "nazev": "Záluží",
        "popis": "[542482] Záluží",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 542482,
        "val": "[542482] Zaluzi 4211 [542482] Záluží"
    },
    {
        "kod": 565938,
        "nazev": "Žabovřesky nad Ohří",
        "popis": "[565938] Žabovřesky nad Ohří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565938,
        "val": "[565938] Zabovresky nad Ohri 4211 [565938] Žabovřesky nad Ohří"
    },
    {
        "kod": 565946,
        "nazev": "Žalhostice",
        "popis": "[565946] Žalhostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565946,
        "val": "[565946] Zalhostice 4205 [565946] Žalhostice"
    },
    {
        "kod": 565954,
        "nazev": "Židovice",
        "popis": "[565954] Židovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4211,
        "iczuj": 565954,
        "val": "[565954] Zidovice 4211 [565954] Židovice"
    },
    {
        "kod": 565962,
        "nazev": "Žitenice",
        "popis": "[565962] Žitenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4205,
        "iczuj": 565962,
        "val": "[565962] Zitenice 4205 [565962] Žitenice"
    },
    {
        "kod": 565997,
        "nazev": "Bitozeves",
        "popis": "[565997] Bitozeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 565997,
        "val": "[565997] Bitozeves 4216 [565997] Bitozeves"
    },
    {
        "kod": 566004,
        "nazev": "Blatno",
        "popis": "[566004] Blatno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566004,
        "val": "[566004] Blatno 4210 [566004] Blatno"
    },
    {
        "kod": 566012,
        "nazev": "Blažim",
        "popis": "[566012] Blažim",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566012,
        "val": "[566012] Blazim 4216 [566012] Blažim"
    },
    {
        "kod": 566021,
        "nazev": "Blšany",
        "popis": "[566021] Blšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566021,
        "val": "[566021] Blsany 4210 [566021] Blšany"
    },
    {
        "kod": 542547,
        "nazev": "Blšany u Loun",
        "popis": "[542547] Blšany u Loun",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542547,
        "val": "[542547] Blsany u Loun 4207 [542547] Blšany u Loun"
    },
    {
        "kod": 546895,
        "nazev": "Brodec",
        "popis": "[546895] Brodec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546895,
        "val": "[546895] Brodec 4207 [546895] Brodec"
    },
    {
        "kod": 566063,
        "nazev": "Břvany",
        "popis": "[566063] Břvany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566063,
        "val": "[566063] Brvany 4207 [566063] Břvany"
    },
    {
        "kod": 542571,
        "nazev": "Cítoliby",
        "popis": "[542571] Cítoliby",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542571,
        "val": "[542571] Citoliby 4207 [542571] Cítoliby"
    },
    {
        "kod": 530581,
        "nazev": "Čeradice",
        "popis": "[530581] Čeradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 530581,
        "val": "[530581] Ceradice 4216 [530581] Čeradice"
    },
    {
        "kod": 542628,
        "nazev": "Černčice",
        "popis": "[542628] Černčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542628,
        "val": "[542628] Cerncice 4207 [542628] Černčice"
    },
    {
        "kod": 566128,
        "nazev": "Deštnice",
        "popis": "[566128] Deštnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566128,
        "val": "[566128] Destnice 4216 [566128] Deštnice"
    },
    {
        "kod": 546861,
        "nazev": "Dobroměřice",
        "popis": "[546861] Dobroměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546861,
        "val": "[546861] Dobromerice 4207 [546861] Dobroměřice"
    },
    {
        "kod": 566152,
        "nazev": "Domoušice",
        "popis": "[566152] Domoušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566152,
        "val": "[566152] Domousice 4207 [566152] Domoušice"
    },
    {
        "kod": 566187,
        "nazev": "Holedeč",
        "popis": "[566187] Holedeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566187,
        "val": "[566187] Holedec 4216 [566187] Holedeč"
    },
    {
        "kod": 566195,
        "nazev": "Hříškov",
        "popis": "[566195] Hříškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566195,
        "val": "[566195] Hriskov 4207 [566195] Hříškov"
    },
    {
        "kod": 566217,
        "nazev": "Hřivice",
        "popis": "[566217] Hřivice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566217,
        "val": "[566217] Hrivice 4207 [566217] Hřivice"
    },
    {
        "kod": 566233,
        "nazev": "Chlumčany",
        "popis": "[566233] Chlumčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566233,
        "val": "[566233] Chlumcany 4207 [566233] Chlumčany"
    },
    {
        "kod": 566241,
        "nazev": "Chožov",
        "popis": "[566241] Chožov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566241,
        "val": "[566241] Chozov 4207 [566241] Chožov"
    },
    {
        "kod": 546429,
        "nazev": "Chraberce",
        "popis": "[546429] Chraberce",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546429,
        "val": "[546429] Chraberce 4207 [546429] Chraberce"
    },
    {
        "kod": 546011,
        "nazev": "Jimlín",
        "popis": "[546011] Jimlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546011,
        "val": "[546011] Jimlin 4207 [546011] Jimlín"
    },
    {
        "kod": 566284,
        "nazev": "Koštice",
        "popis": "[566284] Koštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566284,
        "val": "[566284] Kostice 4207 [566284] Koštice"
    },
    {
        "kod": 530557,
        "nazev": "Kozly",
        "popis": "[530557] Kozly",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 530557,
        "val": "[530557] Kozly 4207 [530557] Kozly"
    },
    {
        "kod": 566306,
        "nazev": "Krásný Dvůr",
        "popis": "[566306] Krásný Dvůr",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566306,
        "val": "[566306] Krasny Dvur 4210 [566306] Krásný Dvůr"
    },
    {
        "kod": 566314,
        "nazev": "Kryry",
        "popis": "[566314] Kryry",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566314,
        "val": "[566314] Kryry 4210 [566314] Kryry"
    },
    {
        "kod": 566322,
        "nazev": "Lenešice",
        "popis": "[566322] Lenešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566322,
        "val": "[566322] Lenesice 4207 [566322] Lenešice"
    },
    {
        "kod": 566349,
        "nazev": "Libčeves",
        "popis": "[566349] Libčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566349,
        "val": "[566349] Libceves 4207 [566349] Libčeves"
    },
    {
        "kod": 566357,
        "nazev": "Liběšice",
        "popis": "[566357] Liběšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566357,
        "val": "[566357] Libesice 4216 [566357] Liběšice"
    },
    {
        "kod": 530590,
        "nazev": "Libočany",
        "popis": "[530590] Libočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 530590,
        "val": "[530590] Libocany 4216 [530590] Libočany"
    },
    {
        "kod": 566381,
        "nazev": "Libořice",
        "popis": "[566381] Libořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566381,
        "val": "[566381] Liborice 4216 [566381] Libořice"
    },
    {
        "kod": 566403,
        "nazev": "Lipno",
        "popis": "[566403] Lipno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566403,
        "val": "[566403] Lipno 4216 [566403] Lipno"
    },
    {
        "kod": 566411,
        "nazev": "Lišany",
        "popis": "[566411] Lišany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566411,
        "val": "[566411] Lisany 4216 [566411] Lišany"
    },
    {
        "kod": 546879,
        "nazev": "Líšťany",
        "popis": "[546879] Líšťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546879,
        "val": "[546879] Listany 4207 [546879] Líšťany"
    },
    {
        "kod": 565971,
        "nazev": "Louny",
        "popis": "[565971] Louny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 565971,
        "val": "[565971] Louny 4207 [565971] Louny"
    },
    {
        "kod": 566438,
        "nazev": "Lubenec",
        "popis": "[566438] Lubenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566438,
        "val": "[566438] Lubenec 4210 [566438] Lubenec"
    },
    {
        "kod": 566454,
        "nazev": "Měcholupy",
        "popis": "[566454] Měcholupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566454,
        "val": "[566454] Mecholupy 4216 [566454] Měcholupy"
    },
    {
        "kod": 566501,
        "nazev": "Nepomyšl",
        "popis": "[566501] Nepomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566501,
        "val": "[566501] Nepomysl 4210 [566501] Nepomyšl"
    },
    {
        "kod": 542636,
        "nazev": "Nová Ves",
        "popis": "[542636] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542636,
        "val": "[542636] Nova Ves 4207 [542636] Nová Ves"
    },
    {
        "kod": 566519,
        "nazev": "Nové Sedlo",
        "popis": "[566519] Nové Sedlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566519,
        "val": "[566519] Nove Sedlo 4216 [566519] Nové Sedlo"
    },
    {
        "kod": 542580,
        "nazev": "Obora",
        "popis": "[542580] Obora",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542580,
        "val": "[542580] Obora 4207 [542580] Obora"
    },
    {
        "kod": 576212,
        "nazev": "České Meziříčí",
        "popis": "[576212] České Meziříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576212,
        "val": "[576212] Ceske Mezirici 5202 [576212] České Meziříčí"
    },
    {
        "kod": 576221,
        "nazev": "Čestice",
        "popis": "[576221] Čestice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576221,
        "val": "[576221] Cestice 5208 [576221] Čestice"
    },
    {
        "kod": 576247,
        "nazev": "Deštné v Orlických horách",
        "popis": "[576247] Deštné v Orlických horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576247,
        "val": "[576247] Destne v Orlickych horach 5202 [576247] Deštné v Orlických horách"
    },
    {
        "kod": 576263,
        "nazev": "Dobré",
        "popis": "[576263] Dobré",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576263,
        "val": "[576263] Dobre 5202 [576263] Dobré"
    },
    {
        "kod": 576271,
        "nazev": "Dobruška",
        "popis": "[576271] Dobruška",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576271,
        "val": "[576271] Dobruska 5202 [576271] Dobruška"
    },
    {
        "kod": 576280,
        "nazev": "Dobřany",
        "popis": "[576280] Dobřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576280,
        "val": "[576280] Dobrany 5202 [576280] Dobřany"
    },
    {
        "kod": 576301,
        "nazev": "Doudleby nad Orlicí",
        "popis": "[576301] Doudleby nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576301,
        "val": "[576301] Doudleby nad Orlici 5208 [576301] Doudleby nad Orlicí"
    },
    {
        "kod": 548642,
        "nazev": "Hřibiny-Ledská",
        "popis": "[548642] Hřibiny-Ledská",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 548642,
        "val": "[548642] Hribiny-Ledska 5208 [548642] Hřibiny-Ledská"
    },
    {
        "kod": 576310,
        "nazev": "Chleny",
        "popis": "[576310] Chleny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576310,
        "val": "[576310] Chleny 5208 [576310] Chleny"
    },
    {
        "kod": 548791,
        "nazev": "Chlístov",
        "popis": "[548791] Chlístov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 548791,
        "val": "[548791] Chlistov 5202 [548791] Chlístov"
    },
    {
        "kod": 548782,
        "nazev": "Jahodov",
        "popis": "[548782] Jahodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 548782,
        "val": "[548782] Jahodov 5213 [548782] Jahodov"
    },
    {
        "kod": 576328,
        "nazev": "Janov",
        "popis": "[576328] Janov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576328,
        "val": "[576328] Janov 5202 [576328] Janov"
    },
    {
        "kod": 576336,
        "nazev": "Javornice",
        "popis": "[576336] Javornice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576336,
        "val": "[576336] Javornice 5213 [576336] Javornice"
    },
    {
        "kod": 576361,
        "nazev": "Kostelec nad Orlicí",
        "popis": "[576361] Kostelec nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576361,
        "val": "[576361] Kostelec nad Orlici 5208 [576361] Kostelec nad Orlicí"
    },
    {
        "kod": 576387,
        "nazev": "Kostelecké Horky",
        "popis": "[576387] Kostelecké Horky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576387,
        "val": "[576387] Kostelecke Horky 5208 [576387] Kostelecké Horky"
    },
    {
        "kod": 576395,
        "nazev": "Kounov",
        "popis": "[576395] Kounov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576395,
        "val": "[576395] Kounov 5202 [576395] Kounov"
    },
    {
        "kod": 576409,
        "nazev": "Králova Lhota",
        "popis": "[576409] Králova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576409,
        "val": "[576409] Kralova Lhota 5202 [576409] Králova Lhota"
    },
    {
        "kod": 548685,
        "nazev": "Krchleby",
        "popis": "[548685] Krchleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 548685,
        "val": "[548685] Krchleby 5208 [548685] Krchleby"
    },
    {
        "kod": 576425,
        "nazev": "Kvasiny",
        "popis": "[576425] Kvasiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576425,
        "val": "[576425] Kvasiny 5213 [576425] Kvasiny"
    },
    {
        "kod": 576441,
        "nazev": "Lhoty u Potštejna",
        "popis": "[576441] Lhoty u Potštejna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576441,
        "val": "[576441] Lhoty u Potstejna 5213 [576441] Lhoty u Potštejna"
    },
    {
        "kod": 548651,
        "nazev": "Libel",
        "popis": "[548651] Libel",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 548651,
        "val": "[548651] Libel 5213 [548651] Libel"
    },
    {
        "kod": 576450,
        "nazev": "Liberk",
        "popis": "[576450] Liberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576450,
        "val": "[576450] Liberk 5213 [576450] Liberk"
    },
    {
        "kod": 576468,
        "nazev": "Lično",
        "popis": "[576468] Lično",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576468,
        "val": "[576468] Licno 5213 [576468] Lično"
    },
    {
        "kod": 576476,
        "nazev": "Lípa nad Orlicí",
        "popis": "[576476] Lípa nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576476,
        "val": "[576476] Lipa nad Orlici 5208 [576476] Lípa nad Orlicí"
    },
    {
        "kod": 576492,
        "nazev": "Lukavice",
        "popis": "[576492] Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576492,
        "val": "[576492] Lukavice 5213 [576492] Lukavice"
    },
    {
        "kod": 576506,
        "nazev": "Lupenice",
        "popis": "[576506] Lupenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576506,
        "val": "[576506] Lupenice 5213 [576506] Lupenice"
    },
    {
        "kod": 576522,
        "nazev": "Mokré",
        "popis": "[576522] Mokré",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576522,
        "val": "[576522] Mokre 5202 [576522] Mokré"
    },
    {
        "kod": 576549,
        "nazev": "Nová Ves",
        "popis": "[576549] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576549,
        "val": "[576549] Nova Ves 5208 [576549] Nová Ves"
    },
    {
        "kod": 576557,
        "nazev": "Očelice",
        "popis": "[576557] Očelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576557,
        "val": "[576557] Ocelice 5202 [576557] Očelice"
    },
    {
        "kod": 576565,
        "nazev": "Ohnišov",
        "popis": "[576565] Ohnišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576565,
        "val": "[576565] Ohnisov 5202 [576565] Ohnišov"
    },
    {
        "kod": 576581,
        "nazev": "Olešnice",
        "popis": "[576581] Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576581,
        "val": "[576581] Olesnice 5208 [576581] Olešnice"
    },
    {
        "kod": 576573,
        "nazev": "Olešnice v Orlických horách",
        "popis": "[576573] Olešnice v Orlických horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576573,
        "val": "[576573] Olesnice v Orlickych horach 5202 [576573] Olešnice v Orlických horách"
    },
    {
        "kod": 576590,
        "nazev": "Opočno",
        "popis": "[576590] Opočno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576590,
        "val": "[576590] Opocno 5202 [576590] Opočno"
    },
    {
        "kod": 576603,
        "nazev": "Orlické Záhoří",
        "popis": "[576603] Orlické Záhoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576603,
        "val": "[576603] Orlicke Zahori 5213 [576603] Orlické Záhoří"
    },
    {
        "kod": 576611,
        "nazev": "Osečnice",
        "popis": "[576611] Osečnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576611,
        "val": "[576611] Osecnice 5213 [576611] Osečnice"
    },
    {
        "kod": 576620,
        "nazev": "Pěčín",
        "popis": "[576620] Pěčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576620,
        "val": "[576620] Pecin 5213 [576620] Pěčín"
    },
    {
        "kod": 576654,
        "nazev": "Podbřezí",
        "popis": "[576654] Podbřezí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576654,
        "val": "[576654] Podbrezi 5202 [576654] Podbřezí"
    },
    {
        "kod": 576662,
        "nazev": "Pohoří",
        "popis": "[576662] Pohoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576662,
        "val": "[576662] Pohori 5202 [576662] Pohoří"
    },
    {
        "kod": 548723,
        "nazev": "Polom",
        "popis": "[548723] Polom",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 548723,
        "val": "[548723] Polom 5213 [548723] Polom"
    },
    {
        "kod": 576671,
        "nazev": "Potštejn",
        "popis": "[576671] Potštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576671,
        "val": "[576671] Potstejn 5213 [576671] Potštejn"
    },
    {
        "kod": 548758,
        "nazev": "Proruby",
        "popis": "[548758] Proruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 548758,
        "val": "[548758] Proruby 5213 [548758] Proruby"
    },
    {
        "kod": 576689,
        "nazev": "Přepychy",
        "popis": "[576689] Přepychy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576689,
        "val": "[576689] Prepychy 5202 [576689] Přepychy"
    },
    {
        "kod": 548669,
        "nazev": "Rohenice",
        "popis": "[548669] Rohenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 548669,
        "val": "[548669] Rohenice 5202 [548669] Rohenice"
    },
    {
        "kod": 576701,
        "nazev": "Rokytnice v Orlických horách",
        "popis": "[576701] Rokytnice v Orlických horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576701,
        "val": "[576701] Rokytnice v Orlickych horach 5213 [576701] Rokytnice v Orlických horách"
    },
    {
        "kod": 576727,
        "nazev": "Rybná nad Zdobnicí",
        "popis": "[576727] Rybná nad Zdobnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576727,
        "val": "[576727] Rybna nad Zdobnici 5213 [576727] Rybná nad Zdobnicí"
    },
    {
        "kod": 576069,
        "nazev": "Rychnov nad Kněžnou",
        "popis": "[576069] Rychnov nad Kněžnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576069,
        "val": "[576069] Rychnov nad Kneznou 5213 [576069] Rychnov nad Kněžnou"
    },
    {
        "kod": 576735,
        "nazev": "Říčky v Orlických horách",
        "popis": "[576735] Říčky v Orlických horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576735,
        "val": "[576735] Ricky v Orlickych horach 5213 [576735] Říčky v Orlických horách"
    },
    {
        "kod": 576743,
        "nazev": "Sedloňov",
        "popis": "[576743] Sedloňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576743,
        "val": "[576743] Sedlonov 5202 [576743] Sedloňov"
    },
    {
        "kod": 576751,
        "nazev": "Semechnice",
        "popis": "[576751] Semechnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576751,
        "val": "[576751] Semechnice 5202 [576751] Semechnice"
    },
    {
        "kod": 576778,
        "nazev": "Skuhrov nad Bělou",
        "popis": "[576778] Skuhrov nad Bělou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576778,
        "val": "[576778] Skuhrov nad Belou 5213 [576778] Skuhrov nad Bělou"
    },
    {
        "kod": 576786,
        "nazev": "Slatina nad Zdobnicí",
        "popis": "[576786] Slatina nad Zdobnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576786,
        "val": "[576786] Slatina nad Zdobnici 5213 [576786] Slatina nad Zdobnicí"
    },
    {
        "kod": 576794,
        "nazev": "Sněžné",
        "popis": "[576794] Sněžné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576794,
        "val": "[576794] Snezne 5202 [576794] Sněžné"
    },
    {
        "kod": 576808,
        "nazev": "Solnice",
        "popis": "[576808] Solnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576808,
        "val": "[576808] Solnice 5213 [576808] Solnice"
    },
    {
        "kod": 548693,
        "nazev": "Svídnice",
        "popis": "[548693] Svídnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 548693,
        "val": "[548693] Svidnice 5208 [548693] Svídnice"
    },
    {
        "kod": 576816,
        "nazev": "Synkov-Slemeno",
        "popis": "[576816] Synkov-Slemeno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576816,
        "val": "[576816] Synkov-Slemeno 5213 [576816] Synkov-Slemeno"
    },
    {
        "kod": 576824,
        "nazev": "Trnov",
        "popis": "[576824] Trnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576824,
        "val": "[576824] Trnov 5202 [576824] Trnov"
    },
    {
        "kod": 576832,
        "nazev": "Třebešov",
        "popis": "[576832] Třebešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576832,
        "val": "[576832] Trebesov 5213 [576832] Třebešov"
    },
    {
        "kod": 576841,
        "nazev": "Tutleky",
        "popis": "[576841] Tutleky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576841,
        "val": "[576841] Tutleky 5208 [576841] Tutleky"
    },
    {
        "kod": 576859,
        "nazev": "Týniště nad Orlicí",
        "popis": "[576859] Týniště nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576859,
        "val": "[576859] Tyniste nad Orlici 5208 [576859] Týniště nad Orlicí"
    },
    {
        "kod": 576875,
        "nazev": "Val",
        "popis": "[576875] Val",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576875,
        "val": "[576875] Val 5202 [576875] Val"
    },
    {
        "kod": 576883,
        "nazev": "Vamberk",
        "popis": "[576883] Vamberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576883,
        "val": "[576883] Vamberk 5213 [576883] Vamberk"
    },
    {
        "kod": 576891,
        "nazev": "Voděrady",
        "popis": "[576891] Voděrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576891,
        "val": "[576891] Voderady 5213 [576891] Voděrady"
    },
    {
        "kod": 548707,
        "nazev": "Vrbice",
        "popis": "[548707] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 548707,
        "val": "[548707] Vrbice 5208 [548707] Vrbice"
    },
    {
        "kod": 576921,
        "nazev": "Záměl",
        "popis": "[576921] Záměl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576921,
        "val": "[576921] Zamel 5213 [576921] Záměl"
    },
    {
        "kod": 576930,
        "nazev": "Zdelov",
        "popis": "[576930] Zdelov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576930,
        "val": "[576930] Zdelov 5208 [576930] Zdelov"
    },
    {
        "kod": 576948,
        "nazev": "Zdobnice",
        "popis": "[576948] Zdobnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576948,
        "val": "[576948] Zdobnice 5213 [576948] Zdobnice"
    },
    {
        "kod": 576956,
        "nazev": "Žďár nad Orlicí",
        "popis": "[576956] Žďár nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576956,
        "val": "[576956] Zdar nad Orlici 5208 [576956] Žďár nad Orlicí"
    },
    {
        "kod": 579041,
        "nazev": "Batňovice",
        "popis": "[579041] Batňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579041,
        "val": "[579041] Batnovice 5214 [579041] Batňovice"
    },
    {
        "kod": 579050,
        "nazev": "Bernartice",
        "popis": "[579050] Bernartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579050,
        "val": "[579050] Bernartice 5214 [579050] Bernartice"
    },
    {
        "kod": 579068,
        "nazev": "Bílá Třemešná",
        "popis": "[579068] Bílá Třemešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579068,
        "val": "[579068] Bila Tremesna 5203 [579068] Bílá Třemešná"
    },
    {
        "kod": 579076,
        "nazev": "Bílé Poličany",
        "popis": "[579076] Bílé Poličany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579076,
        "val": "[579076] Bile Policany 5203 [579076] Bílé Poličany"
    },
    {
        "kod": 579092,
        "nazev": "Borovnice",
        "popis": "[579092] Borovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579092,
        "val": "[579092] Borovnice 5203 [579092] Borovnice"
    },
    {
        "kod": 548821,
        "nazev": "Borovnička",
        "popis": "[548821] Borovnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 548821,
        "val": "[548821] Borovnicka 5203 [548821] Borovnička"
    },
    {
        "kod": 579106,
        "nazev": "Čermná",
        "popis": "[579106] Čermná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579106,
        "val": "[579106] Cermna 5215 [579106] Čermná"
    },
    {
        "kod": 579114,
        "nazev": "Černý Důl",
        "popis": "[579114] Černý Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579114,
        "val": "[579114] Cerny Dul 5215 [579114] Černý Důl"
    },
    {
        "kod": 579122,
        "nazev": "Dolní Branná",
        "popis": "[579122] Dolní Branná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579122,
        "val": "[579122] Dolni Branna 5215 [579122] Dolní Branná"
    },
    {
        "kod": 554863,
        "nazev": "Dolní Brusnice",
        "popis": "[554863] Dolní Brusnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 554863,
        "val": "[554863] Dolni Brusnice 5203 [554863] Dolní Brusnice"
    },
    {
        "kod": 579149,
        "nazev": "Dolní Dvůr",
        "popis": "[579149] Dolní Dvůr",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579149,
        "val": "[579149] Dolni Dvur 5215 [579149] Dolní Dvůr"
    },
    {
        "kod": 579157,
        "nazev": "Dolní Kalná",
        "popis": "[579157] Dolní Kalná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579157,
        "val": "[579157] Dolni Kalna 5215 [579157] Dolní Kalná"
    },
    {
        "kod": 579165,
        "nazev": "Dolní Lánov",
        "popis": "[579165] Dolní Lánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579165,
        "val": "[579165] Dolni Lanov 5215 [579165] Dolní Lánov"
    },
    {
        "kod": 579173,
        "nazev": "Dolní Olešnice",
        "popis": "[579173] Dolní Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579173,
        "val": "[579173] Dolni Olesnice 5214 [579173] Dolní Olešnice"
    },
    {
        "kod": 579181,
        "nazev": "Doubravice",
        "popis": "[579181] Doubravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579181,
        "val": "[579181] Doubravice 5203 [579181] Doubravice"
    },
    {
        "kod": 579190,
        "nazev": "Dubenec",
        "popis": "[579190] Dubenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579190,
        "val": "[579190] Dubenec 5203 [579190] Dubenec"
    },
    {
        "kod": 579203,
        "nazev": "Dvůr Králové nad Labem",
        "popis": "[579203] Dvůr Králové nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579203,
        "val": "[579203] Dvur Kralove nad Labem 5203 [579203] Dvůr Králové nad Labem"
    },
    {
        "kod": 579211,
        "nazev": "Hajnice",
        "popis": "[579211] Hajnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579211,
        "val": "[579211] Hajnice 5214 [579211] Hajnice"
    },
    {
        "kod": 579220,
        "nazev": "Havlovice",
        "popis": "[579220] Havlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579220,
        "val": "[579220] Havlovice 5214 [579220] Havlovice"
    },
    {
        "kod": 579238,
        "nazev": "Horní Brusnice",
        "popis": "[579238] Horní Brusnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579238,
        "val": "[579238] Horni Brusnice 5203 [579238] Horní Brusnice"
    },
    {
        "kod": 579254,
        "nazev": "Horní Kalná",
        "popis": "[579254] Horní Kalná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579254,
        "val": "[579254] Horni Kalna 5215 [579254] Horní Kalná"
    },
    {
        "kod": 579262,
        "nazev": "Horní Maršov",
        "popis": "[579262] Horní Maršov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579262,
        "val": "[579262] Horni Marsov 5214 [579262] Horní Maršov"
    },
    {
        "kod": 579271,
        "nazev": "Horní Olešnice",
        "popis": "[579271] Horní Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579271,
        "val": "[579271] Horni Olesnice 5214 [579271] Horní Olešnice"
    },
    {
        "kod": 579297,
        "nazev": "Hostinné",
        "popis": "[579297] Hostinné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579297,
        "val": "[579297] Hostinne 5215 [579297] Hostinné"
    },
    {
        "kod": 579301,
        "nazev": "Hřibojedy",
        "popis": "[579301] Hřibojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579301,
        "val": "[579301] Hribojedy 5203 [579301] Hřibojedy"
    },
    {
        "kod": 579319,
        "nazev": "Chotěvice",
        "popis": "[579319] Chotěvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579319,
        "val": "[579319] Chotevice 5214 [579319] Chotěvice"
    },
    {
        "kod": 579327,
        "nazev": "Choustníkovo Hradiště",
        "popis": "[579327] Choustníkovo Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579327,
        "val": "[579327] Choustnikovo Hradiste 5203 [579327] Choustníkovo Hradiště"
    },
    {
        "kod": 579335,
        "nazev": "Chvaleč",
        "popis": "[579335] Chvaleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579335,
        "val": "[579335] Chvalec 5214 [579335] Chvaleč"
    },
    {
        "kod": 579351,
        "nazev": "Janské Lázně",
        "popis": "[579351] Janské Lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579351,
        "val": "[579351] Janske Lazne 5214 [579351] Janské Lázně"
    },
    {
        "kod": 579378,
        "nazev": "Jívka",
        "popis": "[579378] Jívka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579378,
        "val": "[579378] Jivka 5214 [579378] Jívka"
    },
    {
        "kod": 579386,
        "nazev": "Klášterská Lhota",
        "popis": "[579386] Klášterská Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579386,
        "val": "[579386] Klasterska Lhota 5215 [579386] Klášterská Lhota"
    },
    {
        "kod": 579394,
        "nazev": "Kocbeře",
        "popis": "[579394] Kocbeře",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579394,
        "val": "[579394] Kocbere 5203 [579394] Kocbeře"
    },
    {
        "kod": 579408,
        "nazev": "Kohoutov",
        "popis": "[579408] Kohoutov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579408,
        "val": "[579408] Kohoutov 5203 [579408] Kohoutov"
    },
    {
        "kod": 530808,
        "nazev": "Královec",
        "popis": "[530808] Královec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 530808,
        "val": "[530808] Kralovec 5214 [530808] Královec"
    },
    {
        "kod": 579416,
        "nazev": "Kuks",
        "popis": "[579416] Kuks",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579416,
        "val": "[579416] Kuks 5203 [579416] Kuks"
    },
    {
        "kod": 579424,
        "nazev": "Kunčice nad Labem",
        "popis": "[579424] Kunčice nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579424,
        "val": "[579424] Kuncice nad Labem 5215 [579424] Kunčice nad Labem"
    },
    {
        "kod": 548804,
        "nazev": "Lampertice",
        "popis": "[548804] Lampertice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 548804,
        "val": "[548804] Lampertice 5214 [548804] Lampertice"
    },
    {
        "kod": 579432,
        "nazev": "Lánov",
        "popis": "[579432] Lánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579432,
        "val": "[579432] Lanov 5215 [579432] Lánov"
    },
    {
        "kod": 579441,
        "nazev": "Lanžov",
        "popis": "[579441] Lanžov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579441,
        "val": "[579441] Lanzov 5203 [579441] Lanžov"
    },
    {
        "kod": 579475,
        "nazev": "Libňatov",
        "popis": "[579475] Libňatov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579475,
        "val": "[579475] Libnatov 5214 [579475] Libňatov"
    },
    {
        "kod": 579483,
        "nazev": "Libotov",
        "popis": "[579483] Libotov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579483,
        "val": "[579483] Libotov 5203 [579483] Libotov"
    },
    {
        "kod": 546470,
        "nazev": "Litíč",
        "popis": "[546470] Litíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 546470,
        "val": "[546470] Litic 5203 [546470] Litíč"
    },
    {
        "kod": 579505,
        "nazev": "Malá Úpa",
        "popis": "[579505] Malá Úpa",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579505,
        "val": "[579505] Mala Upa 5214 [579505] Malá Úpa"
    },
    {
        "kod": 579513,
        "nazev": "Malé Svatoňovice",
        "popis": "[579513] Malé Svatoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579513,
        "val": "[579513] Male Svatonovice 5214 [579513] Malé Svatoňovice"
    },
    {
        "kod": 579530,
        "nazev": "Maršov u Úpice",
        "popis": "[579530] Maršov u Úpice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579530,
        "val": "[579530] Marsov u Upice 5214 [579530] Maršov u Úpice"
    },
    {
        "kod": 579548,
        "nazev": "Mladé Buky",
        "popis": "[579548] Mladé Buky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579548,
        "val": "[579548] Mlade Buky 5214 [579548] Mladé Buky"
    },
    {
        "kod": 579556,
        "nazev": "Mostek",
        "popis": "[579556] Mostek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579556,
        "val": "[579556] Mostek 5203 [579556] Mostek"
    },
    {
        "kod": 579564,
        "nazev": "Nemojov",
        "popis": "[579564] Nemojov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579564,
        "val": "[579564] Nemojov 5203 [579564] Nemojov"
    },
    {
        "kod": 579581,
        "nazev": "Pec pod Sněžkou",
        "popis": "[579581] Pec pod Sněžkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579581,
        "val": "[579581] Pec pod Snezkou 5214 [579581] Pec pod Sněžkou"
    },
    {
        "kod": 579599,
        "nazev": "Pilníkov",
        "popis": "[579599] Pilníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579599,
        "val": "[579599] Pilnikov 5214 [579599] Pilníkov"
    },
    {
        "kod": 579602,
        "nazev": "Prosečné",
        "popis": "[579602] Prosečné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579602,
        "val": "[579602] Prosecne 5215 [579602] Prosečné"
    },
    {
        "kod": 579629,
        "nazev": "Radvanice",
        "popis": "[579629] Radvanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579629,
        "val": "[579629] Radvanice 5214 [579629] Radvanice"
    },
    {
        "kod": 579637,
        "nazev": "Rtyně v Podkrkonoší",
        "popis": "[579637] Rtyně v Podkrkonoší",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579637,
        "val": "[579637] Rtyne v Podkrkonosi 5214 [579637] Rtyně v Podkrkonoší"
    },
    {
        "kod": 579645,
        "nazev": "Rudník",
        "popis": "[579645] Rudník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579645,
        "val": "[579645] Rudnik 5215 [579645] Rudník"
    },
    {
        "kod": 548812,
        "nazev": "Stanovice",
        "popis": "[548812] Stanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 548812,
        "val": "[548812] Stanovice 5203 [548812] Stanovice"
    },
    {
        "kod": 579661,
        "nazev": "Staré Buky",
        "popis": "[579661] Staré Buky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579661,
        "val": "[579661] Stare Buky 5214 [579661] Staré Buky"
    },
    {
        "kod": 579696,
        "nazev": "Strážné",
        "popis": "[579696] Strážné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579696,
        "val": "[579696] Strazne 5215 [579696] Strážné"
    },
    {
        "kod": 579726,
        "nazev": "Suchovršice",
        "popis": "[579726] Suchovršice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579726,
        "val": "[579726] Suchovrsice 5214 [579726] Suchovršice"
    },
    {
        "kod": 579734,
        "nazev": "Svoboda nad Úpou",
        "popis": "[579734] Svoboda nad Úpou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579734,
        "val": "[579734] Svoboda nad Upou 5214 [579734] Svoboda nad Úpou"
    },
    {
        "kod": 579742,
        "nazev": "Špindlerův Mlýn",
        "popis": "[579742] Špindlerův Mlýn",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579742,
        "val": "[579742] Spindleruv Mlyn 5215 [579742] Špindlerův Mlýn"
    },
    {
        "kod": 579751,
        "nazev": "Trotina",
        "popis": "[579751] Trotina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579751,
        "val": "[579751] Trotina 5203 [579751] Trotina"
    },
    {
        "kod": 579025,
        "nazev": "Trutnov",
        "popis": "[579025] Trutnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579025,
        "val": "[579025] Trutnov 5214 [579025] Trutnov"
    },
    {
        "kod": 579769,
        "nazev": "Třebihošť",
        "popis": "[579769] Třebihošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579769,
        "val": "[579769] Trebihost 5203 [579769] Třebihošť"
    },
    {
        "kod": 579777,
        "nazev": "Úpice",
        "popis": "[579777] Úpice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579777,
        "val": "[579777] Upice 5214 [579777] Úpice"
    },
    {
        "kod": 579785,
        "nazev": "Velké Svatoňovice",
        "popis": "[579785] Velké Svatoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579785,
        "val": "[579785] Velke Svatonovice 5214 [579785] Velké Svatoňovice"
    },
    {
        "kod": 579793,
        "nazev": "Velký Vřešťov",
        "popis": "[579793] Velký Vřešťov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579793,
        "val": "[579793] Velky Vrestov 5203 [579793] Velký Vřešťov"
    },
    {
        "kod": 574597,
        "nazev": "Vilantice",
        "popis": "[574597] Vilantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 574597,
        "val": "[574597] Vilantice 5203 [574597] Vilantice"
    },
    {
        "kod": 579815,
        "nazev": "Vítězná",
        "popis": "[579815] Vítězná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579815,
        "val": "[579815] Vitezna 5203 [579815] Vítězná"
    },
    {
        "kod": 579823,
        "nazev": "Vlčice",
        "popis": "[579823] Vlčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579823,
        "val": "[579823] Vlcice 5214 [579823] Vlčice"
    },
    {
        "kod": 579831,
        "nazev": "Vlčkovice v Podkrkonoší",
        "popis": "[579831] Vlčkovice v Podkrkonoší",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 579831,
        "val": "[579831] Vlckovice v Podkrkonosi 5203 [579831] Vlčkovice v Podkrkonoší"
    },
    {
        "kod": 579858,
        "nazev": "Vrchlabí",
        "popis": "[579858] Vrchlabí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5215,
        "iczuj": 579858,
        "val": "[579858] Vrchlabi 5215 [579858] Vrchlabí"
    },
    {
        "kod": 548839,
        "nazev": "Zábřezí-Řečice",
        "popis": "[548839] Zábřezí-Řečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 548839,
        "val": "[548839] Zabrezi-Recice 5203 [548839] Zábřezí-Řečice"
    },
    {
        "kod": 548847,
        "nazev": "Zdobín",
        "popis": "[548847] Zdobín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5203,
        "iczuj": 548847,
        "val": "[548847] Zdobin 5203 [548847] Zdobín"
    },
    {
        "kod": 579866,
        "nazev": "Zlatá Olešnice",
        "popis": "[579866] Zlatá Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579866,
        "val": "[579866] Zlata Olesnice 5214 [579866] Zlatá Olešnice"
    },
    {
        "kod": 579874,
        "nazev": "Žacléř",
        "popis": "[579874] Žacléř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5214,
        "iczuj": 579874,
        "val": "[579874] Zacler 5214 [579874] Žacléř"
    },
    {
        "kod": 571181,
        "nazev": "Běstvina",
        "popis": "[571181] Běstvina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571181,
        "val": "[571181] Bestvina 5304 [571181] Běstvina"
    },
    {
        "kod": 573949,
        "nazev": "Biskupice",
        "popis": "[573949] Biskupice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 573949,
        "val": "[573949] Biskupice 5304 [573949] Biskupice"
    },
    {
        "kod": 505005,
        "nazev": "Bítovany",
        "popis": "[505005] Bítovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 505005,
        "val": "[505005] Bitovany 5304 [505005] Bítovany"
    },
    {
        "kod": 571202,
        "nazev": "Bojanov",
        "popis": "[571202] Bojanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571202,
        "val": "[571202] Bojanov 5304 [571202] Bojanov"
    },
    {
        "kod": 547867,
        "nazev": "Bor u Skutče",
        "popis": "[547867] Bor u Skutče",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547867,
        "val": "[547867] Bor u Skutce 5304 [547867] Bor u Skutče"
    },
    {
        "kod": 571229,
        "nazev": "Bořice",
        "popis": "[571229] Bořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571229,
        "val": "[571229] Borice 5304 [571229] Bořice"
    },
    {
        "kod": 571237,
        "nazev": "Bousov",
        "popis": "[571237] Bousov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571237,
        "val": "[571237] Bousov 5304 [571237] Bousov"
    },
    {
        "kod": 571245,
        "nazev": "Bylany",
        "popis": "[571245] Bylany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571245,
        "val": "[571245] Bylany 5304 [571245] Bylany"
    },
    {
        "kod": 571253,
        "nazev": "Ctětín",
        "popis": "[571253] Ctětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571253,
        "val": "[571253] Ctetin 5304 [571253] Ctětín"
    },
    {
        "kod": 571270,
        "nazev": "Čankovice",
        "popis": "[571270] Čankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571270,
        "val": "[571270] Cankovice 5304 [571270] Čankovice"
    },
    {
        "kod": 571296,
        "nazev": "České Lhotice",
        "popis": "[571296] České Lhotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571296,
        "val": "[571296] Ceske Lhotice 5304 [571296] České Lhotice"
    },
    {
        "kod": 571300,
        "nazev": "Dědová",
        "popis": "[571300] Dědová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571300,
        "val": "[571300] Dedova 5302 [571300] Dědová"
    },
    {
        "kod": 505030,
        "nazev": "Dolní Bezděkov",
        "popis": "[505030] Dolní Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 505030,
        "val": "[505030] Dolni Bezdekov 5304 [505030] Dolní Bezděkov"
    },
    {
        "kod": 504301,
        "nazev": "Dřenice",
        "popis": "[504301] Dřenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 504301,
        "val": "[504301] Drenice 5304 [504301] Dřenice"
    },
    {
        "kod": 504955,
        "nazev": "Dvakačovice",
        "popis": "[504955] Dvakačovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 504955,
        "val": "[504955] Dvakacovice 5304 [504955] Dvakačovice"
    },
    {
        "kod": 571377,
        "nazev": "Hamry",
        "popis": "[571377] Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571377,
        "val": "[571377] Hamry 5302 [571377] Hamry"
    },
    {
        "kod": 571385,
        "nazev": "Heřmanův Městec",
        "popis": "[571385] Heřmanův Městec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571385,
        "val": "[571385] Hermanuv Mestec 5304 [571385] Heřmanův Městec"
    },
    {
        "kod": 571393,
        "nazev": "Hlinsko",
        "popis": "[571393] Hlinsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571393,
        "val": "[571393] Hlinsko 5302 [571393] Hlinsko"
    },
    {
        "kod": 571407,
        "nazev": "Hluboká",
        "popis": "[571407] Hluboká",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571407,
        "val": "[571407] Hluboka 5304 [571407] Hluboká"
    },
    {
        "kod": 547794,
        "nazev": "Hodonín",
        "popis": "[547794] Hodonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547794,
        "val": "[547794] Hodonin 5304 [547794] Hodonín"
    },
    {
        "kod": 571440,
        "nazev": "Holetín",
        "popis": "[571440] Holetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571440,
        "val": "[571440] Holetin 5302 [571440] Holetín"
    },
    {
        "kod": 571458,
        "nazev": "Honbice",
        "popis": "[571458] Honbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571458,
        "val": "[571458] Honbice 5304 [571458] Honbice"
    },
    {
        "kod": 571466,
        "nazev": "Horka",
        "popis": "[571466] Horka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571466,
        "val": "[571466] Horka 5304 [571466] Horka"
    },
    {
        "kod": 571474,
        "nazev": "Horní Bradlo",
        "popis": "[571474] Horní Bradlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571474,
        "val": "[571474] Horni Bradlo 5304 [571474] Horní Bradlo"
    },
    {
        "kod": 571482,
        "nazev": "Hošťalovice",
        "popis": "[571482] Hošťalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571482,
        "val": "[571482] Hostalovice 5304 [571482] Hošťalovice"
    },
    {
        "kod": 571491,
        "nazev": "Hrochův Týnec",
        "popis": "[571491] Hrochův Týnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571491,
        "val": "[571491] Hrochuv Tynec 5304 [571491] Hrochův Týnec"
    },
    {
        "kod": 571504,
        "nazev": "Hroubovice",
        "popis": "[571504] Hroubovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571504,
        "val": "[571504] Hroubovice 5304 [571504] Hroubovice"
    },
    {
        "kod": 571539,
        "nazev": "Chrast",
        "popis": "[571539] Chrast",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571539,
        "val": "[571539] Chrast 5304 [571539] Chrast"
    },
    {
        "kod": 571547,
        "nazev": "Chroustovice",
        "popis": "[571547] Chroustovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571547,
        "val": "[571547] Chroustovice 5304 [571547] Chroustovice"
    },
    {
        "kod": 571164,
        "nazev": "Chrudim",
        "popis": "[571164] Chrudim",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571164,
        "val": "[571164] Chrudim 5304 [571164] Chrudim"
    },
    {
        "kod": 547816,
        "nazev": "Jeníkov",
        "popis": "[547816] Jeníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 547816,
        "val": "[547816] Jenikov 5302 [547816] Jeníkov"
    },
    {
        "kod": 571563,
        "nazev": "Jenišovice",
        "popis": "[571563] Jenišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571563,
        "val": "[571563] Jenisovice 5304 [571563] Jenišovice"
    },
    {
        "kod": 571571,
        "nazev": "Kameničky",
        "popis": "[571571] Kameničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571571,
        "val": "[571571] Kamenicky 5302 [571571] Kameničky"
    },
    {
        "kod": 571580,
        "nazev": "Kladno",
        "popis": "[571580] Kladno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571580,
        "val": "[571580] Kladno 5302 [571580] Kladno"
    },
    {
        "kod": 573787,
        "nazev": "Klešice",
        "popis": "[573787] Klešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 573787,
        "val": "[573787] Klesice 5304 [573787] Klešice"
    },
    {
        "kod": 574007,
        "nazev": "Kněžice",
        "popis": "[574007] Kněžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 574007,
        "val": "[574007] Knezice 5304 [574007] Kněžice"
    },
    {
        "kod": 571610,
        "nazev": "Kočí",
        "popis": "[571610] Kočí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571610,
        "val": "[571610] Koci 5304 [571610] Kočí"
    },
    {
        "kod": 571628,
        "nazev": "Kostelec u Heřmanova Městce",
        "popis": "[571628] Kostelec u Heřmanova Městce",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571628,
        "val": "[571628] Kostelec u Hermanova Mestce 5304 [571628] Kostelec u Heřmanova Městce"
    },
    {
        "kod": 571652,
        "nazev": "Krásné",
        "popis": "[571652] Krásné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571652,
        "val": "[571652] Krasne 5304 [571652] Krásné"
    },
    {
        "kod": 571661,
        "nazev": "Krouna",
        "popis": "[571661] Krouna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571661,
        "val": "[571661] Krouna 5302 [571661] Krouna"
    },
    {
        "kod": 547824,
        "nazev": "Křižanovice",
        "popis": "[547824] Křižanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547824,
        "val": "[547824] Krizanovice 5304 [547824] Křižanovice"
    },
    {
        "kod": 504807,
        "nazev": "Lány",
        "popis": "[504807] Lány",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 504807,
        "val": "[504807] Lany 5304 [504807] Lány"
    },
    {
        "kod": 571709,
        "nazev": "Leštinka",
        "popis": "[571709] Leštinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571709,
        "val": "[571709] Lestinka 5304 [571709] Leštinka"
    },
    {
        "kod": 571725,
        "nazev": "Libkov",
        "popis": "[571725] Libkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571725,
        "val": "[571725] Libkov 5304 [571725] Libkov"
    },
    {
        "kod": 571733,
        "nazev": "Liboměřice",
        "popis": "[571733] Liboměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571733,
        "val": "[571733] Libomerice 5304 [571733] Liboměřice"
    },
    {
        "kod": 547832,
        "nazev": "Licibořice",
        "popis": "[547832] Licibořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547832,
        "val": "[547832] Liciborice 5304 [547832] Licibořice"
    },
    {
        "kod": 547875,
        "nazev": "Lipovec",
        "popis": "[547875] Lipovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547875,
        "val": "[547875] Lipovec 5304 [547875] Lipovec"
    },
    {
        "kod": 571750,
        "nazev": "Lozice",
        "popis": "[571750] Lozice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571750,
        "val": "[571750] Lozice 5304 [571750] Lozice"
    },
    {
        "kod": 571768,
        "nazev": "Lukavice",
        "popis": "[571768] Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571768,
        "val": "[571768] Lukavice 5304 [571768] Lukavice"
    },
    {
        "kod": 571776,
        "nazev": "Luže",
        "popis": "[571776] Luže",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571776,
        "val": "[571776] Luze 5304 [571776] Luže"
    },
    {
        "kod": 571822,
        "nazev": "Míčov-Sušice",
        "popis": "[571822] Míčov-Sušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571822,
        "val": "[571822] Micov-Susice 5304 [571822] Míčov-Sušice"
    },
    {
        "kod": 571831,
        "nazev": "Miřetice",
        "popis": "[571831] Miřetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 571831,
        "val": "[571831] Miretice 5302 [571831] Miřetice"
    },
    {
        "kod": 571857,
        "nazev": "Mladoňovice",
        "popis": "[571857] Mladoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571857,
        "val": "[571857] Mladonovice 5304 [571857] Mladoňovice"
    },
    {
        "kod": 571873,
        "nazev": "Morašice",
        "popis": "[571873] Morašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571873,
        "val": "[571873] Morasice 5304 [571873] Morašice"
    },
    {
        "kod": 554847,
        "nazev": "Mrákotín",
        "popis": "[554847] Mrákotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 554847,
        "val": "[554847] Mrakotin 5304 [554847] Mrákotín"
    },
    {
        "kod": 571890,
        "nazev": "Nabočany",
        "popis": "[571890] Nabočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571890,
        "val": "[571890] Nabocany 5304 [571890] Nabočany"
    },
    {
        "kod": 571903,
        "nazev": "Načešice",
        "popis": "[571903] Načešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571903,
        "val": "[571903] Nacesice 5304 [571903] Načešice"
    },
    {
        "kod": 571911,
        "nazev": "Nasavrky",
        "popis": "[571911] Nasavrky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571911,
        "val": "[571911] Nasavrky 5304 [571911] Nasavrky"
    },
    {
        "kod": 571962,
        "nazev": "Orel",
        "popis": "[571962] Orel",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 571962,
        "val": "[571962] Orel 5304 [571962] Orel"
    },
    {
        "kod": 574104,
        "nazev": "Ostrov",
        "popis": "[574104] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 574104,
        "val": "[574104] Ostrov 5304 [574104] Ostrov"
    },
    {
        "kod": 554952,
        "nazev": "Otradov",
        "popis": "[554952] Otradov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 554952,
        "val": "[554952] Otradov 5302 [554952] Otradov"
    },
    {
        "kod": 572004,
        "nazev": "Perálec",
        "popis": "[572004] Perálec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572004,
        "val": "[572004] Peralec 5304 [572004] Perálec"
    },
    {
        "kod": 572039,
        "nazev": "Podhořany u Ronova",
        "popis": "[572039] Podhořany u Ronova",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572039,
        "val": "[572039] Podhorany u Ronova 5304 [572039] Podhořany u Ronova"
    },
    {
        "kod": 572063,
        "nazev": "Pokřikov",
        "popis": "[572063] Pokřikov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572063,
        "val": "[572063] Pokrikov 5302 [572063] Pokřikov"
    },
    {
        "kod": 572071,
        "nazev": "Prachovice",
        "popis": "[572071] Prachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572071,
        "val": "[572071] Prachovice 5304 [572071] Prachovice"
    },
    {
        "kod": 572080,
        "nazev": "Proseč",
        "popis": "[572080] Proseč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572080,
        "val": "[572080] Prosec 5304 [572080] Proseč"
    },
    {
        "kod": 572098,
        "nazev": "Prosetín",
        "popis": "[572098] Prosetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572098,
        "val": "[572098] Prosetin 5304 [572098] Prosetín"
    },
    {
        "kod": 572101,
        "nazev": "Předhradí",
        "popis": "[572101] Předhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572101,
        "val": "[572101] Predhradi 5304 [572101] Předhradí"
    },
    {
        "kod": 572110,
        "nazev": "Přestavlky",
        "popis": "[572110] Přestavlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572110,
        "val": "[572110] Prestavlky 5304 [572110] Přestavlky"
    },
    {
        "kod": 556882,
        "nazev": "Rabštejnská Lhota",
        "popis": "[556882] Rabštejnská Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 556882,
        "val": "[556882] Rabstejnska Lhota 5304 [556882] Rabštejnská Lhota"
    },
    {
        "kod": 572152,
        "nazev": "Raná",
        "popis": "[572152] Raná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572152,
        "val": "[572152] Rana 5302 [572152] Raná"
    },
    {
        "kod": 572161,
        "nazev": "Ronov nad Doubravou",
        "popis": "[572161] Ronov nad Doubravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572161,
        "val": "[572161] Ronov nad Doubravou 5304 [572161] Ronov nad Doubravou"
    },
    {
        "kod": 572179,
        "nazev": "Rosice",
        "popis": "[572179] Rosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572179,
        "val": "[572179] Rosice 5304 [572179] Rosice"
    },
    {
        "kod": 547808,
        "nazev": "Rozhovice",
        "popis": "[547808] Rozhovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547808,
        "val": "[547808] Rozhovice 5304 [547808] Rozhovice"
    },
    {
        "kod": 572217,
        "nazev": "Řestoky",
        "popis": "[572217] Řestoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572217,
        "val": "[572217] Restoky 5304 [572217] Řestoky"
    },
    {
        "kod": 572225,
        "nazev": "Seč",
        "popis": "[572225] Seč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572225,
        "val": "[572225] Sec 5304 [572225] Seč"
    },
    {
        "kod": 572241,
        "nazev": "Skuteč",
        "popis": "[572241] Skuteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572241,
        "val": "[572241] Skutec 5304 [572241] Skuteč"
    },
    {
        "kod": 572268,
        "nazev": "Slatiňany",
        "popis": "[572268] Slatiňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572268,
        "val": "[572268] Slatinany 5304 [572268] Slatiňany"
    },
    {
        "kod": 573817,
        "nazev": "Smrček",
        "popis": "[573817] Smrček",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 573817,
        "val": "[573817] Smrcek 5304 [573817] Smrček"
    },
    {
        "kod": 572276,
        "nazev": "Sobětuchy",
        "popis": "[572276] Sobětuchy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572276,
        "val": "[572276] Sobetuchy 5304 [572276] Sobětuchy"
    },
    {
        "kod": 547891,
        "nazev": "Stolany",
        "popis": "[547891] Stolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547891,
        "val": "[547891] Stolany 5304 [547891] Stolany"
    },
    {
        "kod": 572314,
        "nazev": "Střemošice",
        "popis": "[572314] Střemošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572314,
        "val": "[572314] Stremosice 5304 [572314] Střemošice"
    },
    {
        "kod": 572322,
        "nazev": "Studnice",
        "popis": "[572322] Studnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572322,
        "val": "[572322] Studnice 5302 [572322] Studnice"
    },
    {
        "kod": 572331,
        "nazev": "Svídnice",
        "popis": "[572331] Svídnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572331,
        "val": "[572331] Svidnice 5304 [572331] Svídnice"
    },
    {
        "kod": 572349,
        "nazev": "Svratouch",
        "popis": "[572349] Svratouch",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572349,
        "val": "[572349] Svratouch 5302 [572349] Svratouch"
    },
    {
        "kod": 572381,
        "nazev": "Tisovec",
        "popis": "[572381] Tisovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572381,
        "val": "[572381] Tisovec 5302 [572381] Tisovec"
    },
    {
        "kod": 572390,
        "nazev": "Trhová Kamenice",
        "popis": "[572390] Trhová Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572390,
        "val": "[572390] Trhova Kamenice 5302 [572390] Trhová Kamenice"
    },
    {
        "kod": 572403,
        "nazev": "Trojovice",
        "popis": "[572403] Trojovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572403,
        "val": "[572403] Trojovice 5304 [572403] Trojovice"
    },
    {
        "kod": 572411,
        "nazev": "Třemošnice",
        "popis": "[572411] Třemošnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572411,
        "val": "[572411] Tremosnice 5304 [572411] Třemošnice"
    },
    {
        "kod": 504921,
        "nazev": "Třibřichy",
        "popis": "[504921] Třibřichy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 504921,
        "val": "[504921] Tribrichy 5304 [504921] Třibřichy"
    },
    {
        "kod": 572420,
        "nazev": "Tuněchody",
        "popis": "[572420] Tuněchody",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572420,
        "val": "[572420] Tunechody 5304 [572420] Tuněchody"
    },
    {
        "kod": 530697,
        "nazev": "Úherčice",
        "popis": "[530697] Úherčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 530697,
        "val": "[530697] Uhercice 5304 [530697] Úherčice"
    },
    {
        "kod": 572446,
        "nazev": "Úhřetice",
        "popis": "[572446] Úhřetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572446,
        "val": "[572446] Uhretice 5304 [572446] Úhřetice"
    },
    {
        "kod": 572454,
        "nazev": "Vápenný Podol",
        "popis": "[572454] Vápenný Podol",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572454,
        "val": "[572454] Vapenny Podol 5304 [572454] Vápenný Podol"
    },
    {
        "kod": 572462,
        "nazev": "Včelákov",
        "popis": "[572462] Včelákov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572462,
        "val": "[572462] Vcelakov 5302 [572462] Včelákov"
    },
    {
        "kod": 572471,
        "nazev": "Vejvanovice",
        "popis": "[572471] Vejvanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572471,
        "val": "[572471] Vejvanovice 5304 [572471] Vejvanovice"
    },
    {
        "kod": 572497,
        "nazev": "Vítanov",
        "popis": "[572497] Vítanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572497,
        "val": "[572497] Vitanov 5302 [572497] Vítanov"
    },
    {
        "kod": 572501,
        "nazev": "Vojtěchov",
        "popis": "[572501] Vojtěchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572501,
        "val": "[572501] Vojtechov 5302 [572501] Vojtěchov"
    },
    {
        "kod": 572527,
        "nazev": "Vortová",
        "popis": "[572527] Vortová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572527,
        "val": "[572527] Vortova 5302 [572527] Vortová"
    },
    {
        "kod": 572535,
        "nazev": "Vrbatův Kostelec",
        "popis": "[572535] Vrbatův Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572535,
        "val": "[572535] Vrbatuv Kostelec 5304 [572535] Vrbatův Kostelec"
    },
    {
        "kod": 572543,
        "nazev": "Všeradov",
        "popis": "[572543] Všeradov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572543,
        "val": "[572543] Vseradov 5302 [572543] Všeradov"
    },
    {
        "kod": 572551,
        "nazev": "Vysočina",
        "popis": "[572551] Vysočina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5302,
        "iczuj": 572551,
        "val": "[572551] Vysocina 5302 [572551] Vysočina"
    },
    {
        "kod": 547841,
        "nazev": "Vyžice",
        "popis": "[547841] Vyžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547841,
        "val": "[547841] Vyzice 5304 [547841] Vyžice"
    },
    {
        "kod": 572578,
        "nazev": "Zaječice",
        "popis": "[572578] Zaječice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572578,
        "val": "[572578] Zajecice 5304 [572578] Zaječice"
    },
    {
        "kod": 547859,
        "nazev": "Zájezdec",
        "popis": "[547859] Zájezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 547859,
        "val": "[547859] Zajezdec 5304 [547859] Zájezdec"
    },
    {
        "kod": 570435,
        "nazev": "Mžany",
        "popis": "[570435] Mžany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570435,
        "val": "[570435] Mzany 5205 [570435] Mžany"
    },
    {
        "kod": 573876,
        "nazev": "Zderaz",
        "popis": "[573876] Zderaz",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 573876,
        "val": "[573876] Zderaz 5304 [573876] Zderaz"
    },
    {
        "kod": 574091,
        "nazev": "Žlebské Chvalovice",
        "popis": "[574091] Žlebské Chvalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 574091,
        "val": "[574091] Zlebske Chvalovice 5304 [574091] Žlebské Chvalovice"
    },
    {
        "kod": 572641,
        "nazev": "Žumberk",
        "popis": "[572641] Žumberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5304,
        "iczuj": 572641,
        "val": "[572641] Zumberk 5304 [572641] Žumberk"
    },
    {
        "kod": 574724,
        "nazev": "Barchov",
        "popis": "[574724] Barchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574724,
        "val": "[574724] Barchov 5309 [574724] Barchov"
    },
    {
        "kod": 574741,
        "nazev": "Bezděkov",
        "popis": "[574741] Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574741,
        "val": "[574741] Bezdekov 5309 [574741] Bezděkov"
    },
    {
        "kod": 574783,
        "nazev": "Borek",
        "popis": "[574783] Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574783,
        "val": "[574783] Borek 5309 [574783] Borek"
    },
    {
        "kod": 574791,
        "nazev": "Brloh",
        "popis": "[574791] Brloh",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 574791,
        "val": "[574791] Brloh 5311 [574791] Brloh"
    },
    {
        "kod": 574805,
        "nazev": "Břehy",
        "popis": "[574805] Břehy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 574805,
        "val": "[574805] Brehy 5311 [574805] Břehy"
    },
    {
        "kod": 574813,
        "nazev": "Bukovina nad Labem",
        "popis": "[574813] Bukovina nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574813,
        "val": "[574813] Bukovina nad Labem 5309 [574813] Bukovina nad Labem"
    },
    {
        "kod": 574821,
        "nazev": "Bukovina u Přelouče",
        "popis": "[574821] Bukovina u Přelouče",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 574821,
        "val": "[574821] Bukovina u Prelouce 5311 [574821] Bukovina u Přelouče"
    },
    {
        "kod": 574830,
        "nazev": "Bukovka",
        "popis": "[574830] Bukovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574830,
        "val": "[574830] Bukovka 5309 [574830] Bukovka"
    },
    {
        "kod": 574848,
        "nazev": "Býšť",
        "popis": "[574848] Býšť",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 574848,
        "val": "[574848] Byst 5303 [574848] Býšť"
    },
    {
        "kod": 572799,
        "nazev": "Časy",
        "popis": "[572799] Časy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572799,
        "val": "[572799] Casy 5309 [572799] Časy"
    },
    {
        "kod": 574856,
        "nazev": "Čeperka",
        "popis": "[574856] Čeperka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574856,
        "val": "[574856] Ceperka 5309 [574856] Čeperka"
    },
    {
        "kod": 574864,
        "nazev": "Čepí",
        "popis": "[574864] Čepí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574864,
        "val": "[574864] Cepi 5309 [574864] Čepí"
    },
    {
        "kod": 572896,
        "nazev": "Černá u Bohdanče",
        "popis": "[572896] Černá u Bohdanče",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572896,
        "val": "[572896] Cerna u Bohdance 5309 [572896] Černá u Bohdanče"
    },
    {
        "kod": 574899,
        "nazev": "Dašice",
        "popis": "[574899] Dašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574899,
        "val": "[574899] Dasice 5309 [574899] Dašice"
    },
    {
        "kod": 574902,
        "nazev": "Dolany",
        "popis": "[574902] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574902,
        "val": "[574902] Dolany 5309 [574902] Dolany"
    },
    {
        "kod": 574911,
        "nazev": "Dolní Roveň",
        "popis": "[574911] Dolní Roveň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 574911,
        "val": "[574911] Dolni Roven 5303 [574911] Dolní Roveň"
    },
    {
        "kod": 574929,
        "nazev": "Dolní Ředice",
        "popis": "[574929] Dolní Ředice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 574929,
        "val": "[574929] Dolni Redice 5303 [574929] Dolní Ředice"
    },
    {
        "kod": 574953,
        "nazev": "Dříteč",
        "popis": "[574953] Dříteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574953,
        "val": "[574953] Dritec 5309 [574953] Dříteč"
    },
    {
        "kod": 572977,
        "nazev": "Dubany",
        "popis": "[572977] Dubany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572977,
        "val": "[572977] Dubany 5309 [572977] Dubany"
    },
    {
        "kod": 574961,
        "nazev": "Hlavečník",
        "popis": "[574961] Hlavečník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 574961,
        "val": "[574961] Hlavecnik 5311 [574961] Hlavečník"
    },
    {
        "kod": 574988,
        "nazev": "Holice",
        "popis": "[574988] Holice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 574988,
        "val": "[574988] Holice 5303 [574988] Holice"
    },
    {
        "kod": 573019,
        "nazev": "Holotín",
        "popis": "[573019] Holotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 573019,
        "val": "[573019] Holotin 5311 [573019] Holotín"
    },
    {
        "kod": 574996,
        "nazev": "Horní Jelení",
        "popis": "[574996] Horní Jelení",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 574996,
        "val": "[574996] Horni Jeleni 5303 [574996] Horní Jelení"
    },
    {
        "kod": 575011,
        "nazev": "Horní Ředice",
        "popis": "[575011] Horní Ředice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575011,
        "val": "[575011] Horni Redice 5303 [575011] Horní Ředice"
    },
    {
        "kod": 575046,
        "nazev": "Hrobice",
        "popis": "[575046] Hrobice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575046,
        "val": "[575046] Hrobice 5309 [575046] Hrobice"
    },
    {
        "kod": 575054,
        "nazev": "Choltice",
        "popis": "[575054] Choltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575054,
        "val": "[575054] Choltice 5311 [575054] Choltice"
    },
    {
        "kod": 575062,
        "nazev": "Choteč",
        "popis": "[575062] Choteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575062,
        "val": "[575062] Chotec 5309 [575062] Choteč"
    },
    {
        "kod": 572764,
        "nazev": "Chrtníky",
        "popis": "[572764] Chrtníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 572764,
        "val": "[572764] Chrtniky 5311 [572764] Chrtníky"
    },
    {
        "kod": 575071,
        "nazev": "Chvaletice",
        "popis": "[575071] Chvaletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575071,
        "val": "[575071] Chvaletice 5311 [575071] Chvaletice"
    },
    {
        "kod": 575089,
        "nazev": "Chvojenec",
        "popis": "[575089] Chvojenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575089,
        "val": "[575089] Chvojenec 5303 [575089] Chvojenec"
    },
    {
        "kod": 575097,
        "nazev": "Chýšť",
        "popis": "[575097] Chýšť",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575097,
        "val": "[575097] Chyst 5309 [575097] Chýšť"
    },
    {
        "kod": 575101,
        "nazev": "Jankovice",
        "popis": "[575101] Jankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575101,
        "val": "[575101] Jankovice 5311 [575101] Jankovice"
    },
    {
        "kod": 575119,
        "nazev": "Jaroslav",
        "popis": "[575119] Jaroslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575119,
        "val": "[575119] Jaroslav 5303 [575119] Jaroslav"
    },
    {
        "kod": 575127,
        "nazev": "Jedousov",
        "popis": "[575127] Jedousov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575127,
        "val": "[575127] Jedousov 5311 [575127] Jedousov"
    },
    {
        "kod": 575135,
        "nazev": "Jeníkovice",
        "popis": "[575135] Jeníkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575135,
        "val": "[575135] Jenikovice 5311 [575135] Jeníkovice"
    },
    {
        "kod": 575143,
        "nazev": "Jezbořice",
        "popis": "[575143] Jezbořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575143,
        "val": "[575143] Jezborice 5309 [575143] Jezbořice"
    },
    {
        "kod": 575151,
        "nazev": "Kasalice",
        "popis": "[575151] Kasalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575151,
        "val": "[575151] Kasalice 5309 [575151] Kasalice"
    },
    {
        "kod": 575178,
        "nazev": "Kladruby nad Labem",
        "popis": "[575178] Kladruby nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575178,
        "val": "[575178] Kladruby nad Labem 5311 [575178] Kladruby nad Labem"
    },
    {
        "kod": 575194,
        "nazev": "Kojice",
        "popis": "[575194] Kojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575194,
        "val": "[575194] Kojice 5311 [575194] Kojice"
    },
    {
        "kod": 575232,
        "nazev": "Kostěnice",
        "popis": "[575232] Kostěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575232,
        "val": "[575232] Kostenice 5309 [575232] Kostěnice"
    },
    {
        "kod": 572861,
        "nazev": "Křičeň",
        "popis": "[572861] Křičeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572861,
        "val": "[572861] Kricen 5309 [572861] Křičeň"
    },
    {
        "kod": 573515,
        "nazev": "Kunětice",
        "popis": "[573515] Kunětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 573515,
        "val": "[573515] Kunetice 5309 [573515] Kunětice"
    },
    {
        "kod": 575259,
        "nazev": "Labské Chrčice",
        "popis": "[575259] Labské Chrčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575259,
        "val": "[575259] Labske Chrcice 5311 [575259] Labské Chrčice"
    },
    {
        "kod": 572845,
        "nazev": "Lány u Dašic",
        "popis": "[572845] Lány u Dašic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572845,
        "val": "[572845] Lany u Dasic 5309 [572845] Lány u Dašic"
    },
    {
        "kod": 574767,
        "nazev": "Lázně Bohdaneč",
        "popis": "[574767] Lázně Bohdaneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574767,
        "val": "[574767] Lazne Bohdanec 5309 [574767] Lázně Bohdaneč"
    },
    {
        "kod": 575305,
        "nazev": "Libišany",
        "popis": "[575305] Libišany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575305,
        "val": "[575305] Libisany 5309 [575305] Libišany"
    },
    {
        "kod": 575313,
        "nazev": "Lipoltice",
        "popis": "[575313] Lipoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575313,
        "val": "[575313] Lipoltice 5311 [575313] Lipoltice"
    },
    {
        "kod": 575330,
        "nazev": "Litošice",
        "popis": "[575330] Litošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575330,
        "val": "[575330] Litosice 5311 [575330] Litošice"
    },
    {
        "kod": 572802,
        "nazev": "Malé Výkleky",
        "popis": "[572802] Malé Výkleky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572802,
        "val": "[572802] Male Vykleky 5309 [572802] Malé Výkleky"
    },
    {
        "kod": 575372,
        "nazev": "Mikulovice",
        "popis": "[575372] Mikulovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575372,
        "val": "[575372] Mikulovice 5309 [575372] Mikulovice"
    },
    {
        "kod": 575381,
        "nazev": "Mokošín",
        "popis": "[575381] Mokošín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575381,
        "val": "[575381] Mokosin 5311 [575381] Mokošín"
    },
    {
        "kod": 573035,
        "nazev": "Morašice",
        "popis": "[573035] Morašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 573035,
        "val": "[573035] Morasice 5311 [573035] Morašice"
    },
    {
        "kod": 575399,
        "nazev": "Moravany",
        "popis": "[575399] Moravany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575399,
        "val": "[575399] Moravany 5309 [575399] Moravany"
    },
    {
        "kod": 572870,
        "nazev": "Němčice",
        "popis": "[572870] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572870,
        "val": "[572870] Nemcice 5309 [572870] Němčice"
    },
    {
        "kod": 573078,
        "nazev": "Neratov",
        "popis": "[573078] Neratov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 573078,
        "val": "[573078] Neratov 5309 [573078] Neratov"
    },
    {
        "kod": 575429,
        "nazev": "Opatovice nad Labem",
        "popis": "[575429] Opatovice nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575429,
        "val": "[575429] Opatovice nad Labem 5309 [575429] Opatovice nad Labem"
    },
    {
        "kod": 575437,
        "nazev": "Ostřešany",
        "popis": "[575437] Ostřešany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575437,
        "val": "[575437] Ostresany 5309 [575437] Ostřešany"
    },
    {
        "kod": 575445,
        "nazev": "Ostřetín",
        "popis": "[575445] Ostřetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575445,
        "val": "[575445] Ostretin 5303 [575445] Ostřetín"
    },
    {
        "kod": 572942,
        "nazev": "Plch",
        "popis": "[572942] Plch",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572942,
        "val": "[572942] Plch 5309 [572942] Plch"
    },
    {
        "kod": 575461,
        "nazev": "Poběžovice u Holic",
        "popis": "[575461] Poběžovice u Holic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575461,
        "val": "[575461] Pobezovice u Holic 5303 [575461] Poběžovice u Holic"
    },
    {
        "kod": 575470,
        "nazev": "Poběžovice u Přelouče",
        "popis": "[575470] Poběžovice u Přelouče",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575470,
        "val": "[575470] Pobezovice u Prelouce 5311 [575470] Poběžovice u Přelouče"
    },
    {
        "kod": 572951,
        "nazev": "Podůlšany",
        "popis": "[572951] Podůlšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572951,
        "val": "[572951] Podulsany 5309 [572951] Podůlšany"
    },
    {
        "kod": 572853,
        "nazev": "Pravy",
        "popis": "[572853] Pravy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572853,
        "val": "[572853] Pravy 5309 [572853] Pravy"
    },
    {
        "kod": 575500,
        "nazev": "Přelouč",
        "popis": "[575500] Přelouč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575500,
        "val": "[575500] Prelouc 5311 [575500] Přelouč"
    },
    {
        "kod": 575518,
        "nazev": "Přelovice",
        "popis": "[575518] Přelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575518,
        "val": "[575518] Prelovice 5311 [575518] Přelovice"
    },
    {
        "kod": 575526,
        "nazev": "Přepychy",
        "popis": "[575526] Přepychy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575526,
        "val": "[575526] Prepychy 5311 [575526] Přepychy"
    },
    {
        "kod": 575534,
        "nazev": "Ráby",
        "popis": "[575534] Ráby",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575534,
        "val": "[575534] Raby 5309 [575534] Ráby"
    },
    {
        "kod": 575551,
        "nazev": "Rohovládova Bělá",
        "popis": "[575551] Rohovládova Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575551,
        "val": "[575551] Rohovladova Bela 5309 [575551] Rohovládova Bělá"
    },
    {
        "kod": 575569,
        "nazev": "Rohoznice",
        "popis": "[575569] Rohoznice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575569,
        "val": "[575569] Rohoznice 5309 [575569] Rohoznice"
    },
    {
        "kod": 575577,
        "nazev": "Rokytno",
        "popis": "[575577] Rokytno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575577,
        "val": "[575577] Rokytno 5309 [575577] Rokytno"
    },
    {
        "kod": 575593,
        "nazev": "Rybitví",
        "popis": "[575593] Rybitví",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575593,
        "val": "[575593] Rybitvi 5309 [575593] Rybitví"
    },
    {
        "kod": 575607,
        "nazev": "Řečany nad Labem",
        "popis": "[575607] Řečany nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575607,
        "val": "[575607] Recany nad Labem 5311 [575607] Řečany nad Labem"
    },
    {
        "kod": 575615,
        "nazev": "Selmice",
        "popis": "[575615] Selmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575615,
        "val": "[575615] Selmice 5311 [575615] Selmice"
    },
    {
        "kod": 575623,
        "nazev": "Semín",
        "popis": "[575623] Semín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575623,
        "val": "[575623] Semin 5311 [575623] Semín"
    },
    {
        "kod": 575640,
        "nazev": "Sezemice",
        "popis": "[575640] Sezemice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575640,
        "val": "[575640] Sezemice 5309 [575640] Sezemice"
    },
    {
        "kod": 575658,
        "nazev": "Slepotice",
        "popis": "[575658] Slepotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575658,
        "val": "[575658] Slepotice 5309 [575658] Slepotice"
    },
    {
        "kod": 575666,
        "nazev": "Sopřeč",
        "popis": "[575666] Sopřeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575666,
        "val": "[575666] Soprec 5311 [575666] Sopřeč"
    },
    {
        "kod": 573027,
        "nazev": "Sovolusky",
        "popis": "[573027] Sovolusky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 573027,
        "val": "[573027] Sovolusky 5311 [573027] Sovolusky"
    },
    {
        "kod": 574198,
        "nazev": "Spojil",
        "popis": "[574198] Spojil",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 574198,
        "val": "[574198] Spojil 5309 [574198] Spojil"
    },
    {
        "kod": 575682,
        "nazev": "Srch",
        "popis": "[575682] Srch",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575682,
        "val": "[575682] Srch 5309 [575682] Srch"
    },
    {
        "kod": 553719,
        "nazev": "Srnojedy",
        "popis": "[553719] Srnojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 553719,
        "val": "[553719] Srnojedy 5309 [553719] Srnojedy"
    },
    {
        "kod": 575704,
        "nazev": "Staré Hradiště",
        "popis": "[575704] Staré Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575704,
        "val": "[575704] Stare Hradiste 5309 [575704] Staré Hradiště"
    },
    {
        "kod": 575712,
        "nazev": "Staré Jesenčany",
        "popis": "[575712] Staré Jesenčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575712,
        "val": "[575712] Stare Jesencany 5309 [575712] Staré Jesenčany"
    },
    {
        "kod": 575721,
        "nazev": "Staré Ždánice",
        "popis": "[575721] Staré Ždánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575721,
        "val": "[575721] Stare Zdanice 5309 [575721] Staré Ždánice"
    },
    {
        "kod": 575739,
        "nazev": "Starý Mateřov",
        "popis": "[575739] Starý Mateřov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575739,
        "val": "[575739] Stary Materov 5309 [575739] Starý Mateřov"
    },
    {
        "kod": 572934,
        "nazev": "Stéblová",
        "popis": "[572934] Stéblová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572934,
        "val": "[572934] Steblova 5309 [572934] Stéblová"
    },
    {
        "kod": 575755,
        "nazev": "Stojice",
        "popis": "[575755] Stojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575755,
        "val": "[575755] Stojice 5311 [575755] Stojice"
    },
    {
        "kod": 575763,
        "nazev": "Strašov",
        "popis": "[575763] Strašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575763,
        "val": "[575763] Strasov 5311 [575763] Strašov"
    },
    {
        "kod": 575771,
        "nazev": "Svinčany",
        "popis": "[575771] Svinčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575771,
        "val": "[575771] Svincany 5311 [575771] Svinčany"
    },
    {
        "kod": 575780,
        "nazev": "Svojšice",
        "popis": "[575780] Svojšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575780,
        "val": "[575780] Svojsice 5311 [575780] Svojšice"
    },
    {
        "kod": 575810,
        "nazev": "Tetov",
        "popis": "[575810] Tetov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575810,
        "val": "[575810] Tetov 5311 [575810] Tetov"
    },
    {
        "kod": 530794,
        "nazev": "Trnávka",
        "popis": "[530794] Trnávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 530794,
        "val": "[530794] Trnavka 5311 [530794] Trnávka"
    },
    {
        "kod": 575828,
        "nazev": "Trusnov",
        "popis": "[575828] Trusnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575828,
        "val": "[575828] Trusnov 5303 [575828] Trusnov"
    },
    {
        "kod": 572985,
        "nazev": "Třebosice",
        "popis": "[572985] Třebosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572985,
        "val": "[572985] Trebosice 5309 [572985] Třebosice"
    },
    {
        "kod": 575844,
        "nazev": "Turkovice",
        "popis": "[575844] Turkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575844,
        "val": "[575844] Turkovice 5311 [575844] Turkovice"
    },
    {
        "kod": 575879,
        "nazev": "Uhersko",
        "popis": "[575879] Uhersko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575879,
        "val": "[575879] Uhersko 5303 [575879] Uhersko"
    },
    {
        "kod": 575887,
        "nazev": "Úhřetická Lhota",
        "popis": "[575887] Úhřetická Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575887,
        "val": "[575887] Uhreticka Lhota 5309 [575887] Úhřetická Lhota"
    },
    {
        "kod": 575909,
        "nazev": "Újezd u Přelouče",
        "popis": "[575909] Újezd u Přelouče",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575909,
        "val": "[575909] Ujezd u Prelouce 5311 [575909] Újezd u Přelouče"
    },
    {
        "kod": 572888,
        "nazev": "Újezd u Sezemic",
        "popis": "[572888] Újezd u Sezemic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 572888,
        "val": "[572888] Ujezd u Sezemic 5309 [572888] Újezd u Sezemic"
    },
    {
        "kod": 575917,
        "nazev": "Urbanice",
        "popis": "[575917] Urbanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575917,
        "val": "[575917] Urbanice 5311 [575917] Urbanice"
    },
    {
        "kod": 575925,
        "nazev": "Valy",
        "popis": "[575925] Valy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575925,
        "val": "[575925] Valy 5311 [575925] Valy"
    },
    {
        "kod": 575933,
        "nazev": "Vápno",
        "popis": "[575933] Vápno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575933,
        "val": "[575933] Vapno 5311 [575933] Vápno"
    },
    {
        "kod": 575941,
        "nazev": "Veliny",
        "popis": "[575941] Veliny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 575941,
        "val": "[575941] Veliny 5303 [575941] Veliny"
    },
    {
        "kod": 575968,
        "nazev": "Veselí",
        "popis": "[575968] Veselí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 575968,
        "val": "[575968] Veseli 5311 [575968] Veselí"
    },
    {
        "kod": 575984,
        "nazev": "Vlčí Habřina",
        "popis": "[575984] Vlčí Habřina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575984,
        "val": "[575984] Vlci Habrina 5309 [575984] Vlčí Habřina"
    },
    {
        "kod": 575992,
        "nazev": "Voleč",
        "popis": "[575992] Voleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 575992,
        "val": "[575992] Volec 5309 [575992] Voleč"
    },
    {
        "kod": 576000,
        "nazev": "Vysoké Chvojno",
        "popis": "[576000] Vysoké Chvojno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5303,
        "iczuj": 576000,
        "val": "[576000] Vysoke Chvojno 5303 [576000] Vysoké Chvojno"
    },
    {
        "kod": 576018,
        "nazev": "Vyšehněvice",
        "popis": "[576018] Vyšehněvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 576018,
        "val": "[576018] Vysehnevice 5311 [576018] Vyšehněvice"
    },
    {
        "kod": 576026,
        "nazev": "Zdechovice",
        "popis": "[576026] Zdechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 576026,
        "val": "[576026] Zdechovice 5311 [576026] Zdechovice"
    },
    {
        "kod": 576042,
        "nazev": "Žáravice",
        "popis": "[576042] Žáravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5311,
        "iczuj": 576042,
        "val": "[576042] Zaravice 5311 [576042] Žáravice"
    },
    {
        "kod": 576051,
        "nazev": "Živanice",
        "popis": "[576051] Živanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 576051,
        "val": "[576051] Zivanice 5309 [576051] Živanice"
    },
    {
        "kod": 572560,
        "nazev": "Banín",
        "popis": "[572560] Banín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572560,
        "val": "[572560] Banin 5312 [572560] Banín"
    },
    {
        "kod": 572586,
        "nazev": "Bělá nad Svitavou",
        "popis": "[572586] Bělá nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572586,
        "val": "[572586] Bela nad Svitavou 5312 [572586] Bělá nad Svitavou"
    },
    {
        "kod": 505391,
        "nazev": "Bělá u Jevíčka",
        "popis": "[505391] Bělá u Jevíčka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 505391,
        "val": "[505391] Bela u Jevicka 5308 [505391] Bělá u Jevíčka"
    },
    {
        "kod": 577774,
        "nazev": "Benátky",
        "popis": "[577774] Benátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577774,
        "val": "[577774] Benatky 5307 [577774] Benátky"
    },
    {
        "kod": 574309,
        "nazev": "Bezděčí u Trnávky",
        "popis": "[574309] Bezděčí u Trnávky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 574309,
        "val": "[574309] Bezdeci u Trnavky 5308 [574309] Bezděčí u Trnávky"
    },
    {
        "kod": 572519,
        "nazev": "Biskupice",
        "popis": "[572519] Biskupice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572519,
        "val": "[572519] Biskupice 5308 [572519] Biskupice"
    },
    {
        "kod": 577812,
        "nazev": "Bohuňov",
        "popis": "[577812] Bohuňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 577812,
        "val": "[577812] Bohunov 5312 [577812] Bohuňov"
    },
    {
        "kod": 577821,
        "nazev": "Bohuňovice",
        "popis": "[577821] Bohuňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577821,
        "val": "[577821] Bohunovice 5307 [577821] Bohuňovice"
    },
    {
        "kod": 577839,
        "nazev": "Borová",
        "popis": "[577839] Borová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 577839,
        "val": "[577839] Borova 5310 [577839] Borová"
    },
    {
        "kod": 572632,
        "nazev": "Borušov",
        "popis": "[572632] Borušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572632,
        "val": "[572632] Borusov 5308 [572632] Borušov"
    },
    {
        "kod": 577863,
        "nazev": "Brněnec",
        "popis": "[577863] Brněnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 577863,
        "val": "[577863] Brnenec 5312 [577863] Brněnec"
    },
    {
        "kod": 570443,
        "nazev": "Neděliště",
        "popis": "[570443] Neděliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570443,
        "val": "[570443] Nedeliste 5205 [570443] Neděliště"
    },
    {
        "kod": 570451,
        "nazev": "Nechanice",
        "popis": "[570451] Nechanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570451,
        "val": "[570451] Nechanice 5205 [570451] Nechanice"
    },
    {
        "kod": 570478,
        "nazev": "Nepolisy",
        "popis": "[570478] Nepolisy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570478,
        "val": "[570478] Nepolisy 5212 [570478] Nepolisy"
    },
    {
        "kod": 570494,
        "nazev": "Nové Město",
        "popis": "[570494] Nové Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570494,
        "val": "[570494] Nove Mesto 5205 [570494] Nové Město"
    },
    {
        "kod": 570508,
        "nazev": "Nový Bydžov",
        "popis": "[570508] Nový Bydžov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570508,
        "val": "[570508] Novy Bydzov 5212 [570508] Nový Bydžov"
    },
    {
        "kod": 548065,
        "nazev": "Obědovice",
        "popis": "[548065] Obědovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 548065,
        "val": "[548065] Obedovice 5205 [548065] Obědovice"
    },
    {
        "kod": 570516,
        "nazev": "Ohnišťany",
        "popis": "[570516] Ohnišťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570516,
        "val": "[570516] Ohnistany 5212 [570516] Ohnišťany"
    },
    {
        "kod": 570524,
        "nazev": "Olešnice",
        "popis": "[570524] Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570524,
        "val": "[570524] Olesnice 5205 [570524] Olešnice"
    },
    {
        "kod": 570532,
        "nazev": "Osice",
        "popis": "[570532] Osice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570532,
        "val": "[570532] Osice 5205 [570532] Osice"
    },
    {
        "kod": 570541,
        "nazev": "Osičky",
        "popis": "[570541] Osičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570541,
        "val": "[570541] Osicky 5205 [570541] Osičky"
    },
    {
        "kod": 570567,
        "nazev": "Petrovice",
        "popis": "[570567] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570567,
        "val": "[570567] Petrovice 5212 [570567] Petrovice"
    },
    {
        "kod": 570575,
        "nazev": "Písek",
        "popis": "[570575] Písek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570575,
        "val": "[570575] Pisek 5205 [570575] Písek"
    },
    {
        "kod": 570648,
        "nazev": "Prasek",
        "popis": "[570648] Prasek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570648,
        "val": "[570648] Prasek 5212 [570648] Prasek"
    },
    {
        "kod": 570656,
        "nazev": "Praskačka",
        "popis": "[570656] Praskačka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570656,
        "val": "[570656] Praskacka 5205 [570656] Praskačka"
    },
    {
        "kod": 570672,
        "nazev": "Předměřice nad Labem",
        "popis": "[570672] Předměřice nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570672,
        "val": "[570672] Predmerice nad Labem 5205 [570672] Předměřice nad Labem"
    },
    {
        "kod": 570681,
        "nazev": "Převýšov",
        "popis": "[570681] Převýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570681,
        "val": "[570681] Prevysov 5205 [570681] Převýšov"
    },
    {
        "kod": 530671,
        "nazev": "Pšánky",
        "popis": "[530671] Pšánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 530671,
        "val": "[530671] Psanky 5205 [530671] Pšánky"
    },
    {
        "kod": 573531,
        "nazev": "Puchlovice",
        "popis": "[573531] Puchlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 573531,
        "val": "[573531] Puchlovice 5205 [573531] Puchlovice"
    },
    {
        "kod": 570702,
        "nazev": "Račice nad Trotinou",
        "popis": "[570702] Račice nad Trotinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570702,
        "val": "[570702] Racice nad Trotinou 5205 [570702] Račice nad Trotinou"
    },
    {
        "kod": 570711,
        "nazev": "Radíkovice",
        "popis": "[570711] Radíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570711,
        "val": "[570711] Radikovice 5205 [570711] Radíkovice"
    },
    {
        "kod": 570729,
        "nazev": "Radostov",
        "popis": "[570729] Radostov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570729,
        "val": "[570729] Radostov 5205 [570729] Radostov"
    },
    {
        "kod": 570745,
        "nazev": "Roudnice",
        "popis": "[570745] Roudnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570745,
        "val": "[570745] Roudnice 5205 [570745] Roudnice"
    },
    {
        "kod": 573191,
        "nazev": "Sadová",
        "popis": "[573191] Sadová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 573191,
        "val": "[573191] Sadova 5205 [573191] Sadová"
    },
    {
        "kod": 570796,
        "nazev": "Sendražice",
        "popis": "[570796] Sendražice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570796,
        "val": "[570796] Sendrazice 5205 [570796] Sendražice"
    },
    {
        "kod": 570800,
        "nazev": "Skalice",
        "popis": "[570800] Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570800,
        "val": "[570800] Skalice 5205 [570800] Skalice"
    },
    {
        "kod": 570834,
        "nazev": "Skřivany",
        "popis": "[570834] Skřivany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570834,
        "val": "[570834] Skrivany 5212 [570834] Skřivany"
    },
    {
        "kod": 570851,
        "nazev": "Sloupno",
        "popis": "[570851] Sloupno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570851,
        "val": "[570851] Sloupno 5212 [570851] Sloupno"
    },
    {
        "kod": 570869,
        "nazev": "Smidary",
        "popis": "[570869] Smidary",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570869,
        "val": "[570869] Smidary 5212 [570869] Smidary"
    },
    {
        "kod": 570877,
        "nazev": "Smiřice",
        "popis": "[570877] Smiřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570877,
        "val": "[570877] Smirice 5205 [570877] Smiřice"
    },
    {
        "kod": 570885,
        "nazev": "Smržov",
        "popis": "[570885] Smržov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570885,
        "val": "[570885] Smrzov 5205 [570885] Smržov"
    },
    {
        "kod": 570907,
        "nazev": "Sovětice",
        "popis": "[570907] Sovětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570907,
        "val": "[570907] Sovetice 5205 [570907] Sovětice"
    },
    {
        "kod": 570915,
        "nazev": "Stará Voda",
        "popis": "[570915] Stará Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570915,
        "val": "[570915] Stara Voda 5205 [570915] Stará Voda"
    },
    {
        "kod": 573132,
        "nazev": "Starý Bydžov",
        "popis": "[573132] Starý Bydžov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 573132,
        "val": "[573132] Stary Bydzov 5212 [573132] Starý Bydžov"
    },
    {
        "kod": 570931,
        "nazev": "Stěžery",
        "popis": "[570931] Stěžery",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570931,
        "val": "[570931] Stezery 5205 [570931] Stěžery"
    },
    {
        "kod": 570958,
        "nazev": "Stračov",
        "popis": "[570958] Stračov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570958,
        "val": "[570958] Stracov 5205 [570958] Stračov"
    },
    {
        "kod": 570966,
        "nazev": "Střezetice",
        "popis": "[570966] Střezetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570966,
        "val": "[570966] Strezetice 5205 [570966] Střezetice"
    },
    {
        "kod": 548154,
        "nazev": "Světí",
        "popis": "[548154] Světí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 548154,
        "val": "[548154] Sveti 5205 [548154] Světí"
    },
    {
        "kod": 571008,
        "nazev": "Syrovátka",
        "popis": "[571008] Syrovátka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571008,
        "val": "[571008] Syrovatka 5205 [571008] Syrovátka"
    },
    {
        "kod": 571016,
        "nazev": "Šaplava",
        "popis": "[571016] Šaplava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 571016,
        "val": "[571016] Saplava 5212 [571016] Šaplava"
    },
    {
        "kod": 571024,
        "nazev": "Těchlovice",
        "popis": "[571024] Těchlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571024,
        "val": "[571024] Techlovice 5205 [571024] Těchlovice"
    },
    {
        "kod": 571041,
        "nazev": "Třebechovice pod Orebem",
        "popis": "[571041] Třebechovice pod Orebem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571041,
        "val": "[571041] Trebechovice pod Orebem 5205 [571041] Třebechovice pod Orebem"
    },
    {
        "kod": 571059,
        "nazev": "Třesovice",
        "popis": "[571059] Třesovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571059,
        "val": "[571059] Tresovice 5205 [571059] Třesovice"
    },
    {
        "kod": 513717,
        "nazev": "Urbanice",
        "popis": "[513717] Urbanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 513717,
        "val": "[513717] Urbanice 5205 [513717] Urbanice"
    },
    {
        "kod": 571083,
        "nazev": "Vinary",
        "popis": "[571083] Vinary",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 571083,
        "val": "[571083] Vinary 5212 [571083] Vinary"
    },
    {
        "kod": 548057,
        "nazev": "Vrchovnice",
        "popis": "[548057] Vrchovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 548057,
        "val": "[548057] Vrchovnice 5205 [548057] Vrchovnice"
    },
    {
        "kod": 571091,
        "nazev": "Všestary",
        "popis": "[571091] Všestary",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571091,
        "val": "[571091] Vsestary 5205 [571091] Všestary"
    },
    {
        "kod": 571105,
        "nazev": "Výrava",
        "popis": "[571105] Výrava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571105,
        "val": "[571105] Vyrava 5205 [571105] Výrava"
    },
    {
        "kod": 571113,
        "nazev": "Vysoká nad Labem",
        "popis": "[571113] Vysoká nad Labem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 571113,
        "val": "[571113] Vysoka nad Labem 5205 [571113] Vysoká nad Labem"
    },
    {
        "kod": 548677,
        "nazev": "Vysoký Újezd",
        "popis": "[548677] Vysoký Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 548677,
        "val": "[548677] Vysoky Ujezd 5205 [548677] Vysoký Újezd"
    },
    {
        "kod": 571130,
        "nazev": "Zachrašťany",
        "popis": "[571130] Zachrašťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 571130,
        "val": "[571130] Zachrastany 5212 [571130] Zachrašťany"
    },
    {
        "kod": 573744,
        "nazev": "Zdechovice",
        "popis": "[573744] Zdechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 573744,
        "val": "[573744] Zdechovice 5212 [573744] Zdechovice"
    },
    {
        "kod": 553701,
        "nazev": "Bačalky",
        "popis": "[553701] Bačalky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 553701,
        "val": "[553701] Bacalky 5207 [553701] Bačalky"
    },
    {
        "kod": 572667,
        "nazev": "Bašnice",
        "popis": "[572667] Bašnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572667,
        "val": "[572667] Basnice 5204 [572667] Bašnice"
    },
    {
        "kod": 572675,
        "nazev": "Běchary",
        "popis": "[572675] Běchary",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572675,
        "val": "[572675] Bechary 5207 [572675] Běchary"
    },
    {
        "kod": 548901,
        "nazev": "Bílsko u Hořic",
        "popis": "[548901] Bílsko u Hořic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548901,
        "val": "[548901] Bilsko u Horic 5204 [548901] Bílsko u Hořic"
    },
    {
        "kod": 572705,
        "nazev": "Boháňka",
        "popis": "[572705] Boháňka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572705,
        "val": "[572705] Bohanka 5204 [572705] Boháňka"
    },
    {
        "kod": 548979,
        "nazev": "Borek",
        "popis": "[548979] Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548979,
        "val": "[548979] Borek 5204 [548979] Borek"
    },
    {
        "kod": 549100,
        "nazev": "Brada-Rybníček",
        "popis": "[549100] Brada-Rybníček",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549100,
        "val": "[549100] Brada-Rybnicek 5207 [549100] Brada-Rybníček"
    },
    {
        "kod": 549070,
        "nazev": "Březina",
        "popis": "[549070] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549070,
        "val": "[549070] Brezina 5207 [549070] Březina"
    },
    {
        "kod": 548855,
        "nazev": "Bříšťany",
        "popis": "[548855] Bříšťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548855,
        "val": "[548855] Bristany 5204 [548855] Bříšťany"
    },
    {
        "kod": 548952,
        "nazev": "Budčeves",
        "popis": "[548952] Budčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548952,
        "val": "[548952] Budceves 5207 [548952] Budčeves"
    },
    {
        "kod": 573353,
        "nazev": "Bukvice",
        "popis": "[573353] Bukvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573353,
        "val": "[573353] Bukvice 5207 [573353] Bukvice"
    },
    {
        "kod": 549282,
        "nazev": "Butoves",
        "popis": "[549282] Butoves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549282,
        "val": "[549282] Butoves 5207 [549282] Butoves"
    },
    {
        "kod": 572772,
        "nazev": "Bystřice",
        "popis": "[572772] Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572772,
        "val": "[572772] Bystrice 5207 [572772] Bystřice"
    },
    {
        "kod": 572781,
        "nazev": "Cerekvice nad Bystřicí",
        "popis": "[572781] Cerekvice nad Bystřicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572781,
        "val": "[572781] Cerekvice nad Bystrici 5204 [572781] Cerekvice nad Bystřicí"
    },
    {
        "kod": 548995,
        "nazev": "Červená Třemešná",
        "popis": "[548995] Červená Třemešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548995,
        "val": "[548995] Cervena Tremesna 5204 [548995] Červená Třemešná"
    },
    {
        "kod": 572811,
        "nazev": "Češov",
        "popis": "[572811] Češov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572811,
        "val": "[572811] Cesov 5207 [572811] Češov"
    },
    {
        "kod": 572829,
        "nazev": "Dětenice",
        "popis": "[572829] Dětenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572829,
        "val": "[572829] Detenice 5207 [572829] Dětenice"
    },
    {
        "kod": 549118,
        "nazev": "Dílce",
        "popis": "[549118] Dílce",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549118,
        "val": "[549118] Dilce 5207 [549118] Dílce"
    },
    {
        "kod": 572837,
        "nazev": "Dobrá Voda u Hořic",
        "popis": "[572837] Dobrá Voda u Hořic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572837,
        "val": "[572837] Dobra Voda u Horic 5204 [572837] Dobrá Voda u Hořic"
    },
    {
        "kod": 549088,
        "nazev": "Dolní Lochov",
        "popis": "[549088] Dolní Lochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549088,
        "val": "[549088] Dolni Lochov 5207 [549088] Dolní Lochov"
    },
    {
        "kod": 573337,
        "nazev": "Dřevěnice",
        "popis": "[573337] Dřevěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573337,
        "val": "[573337] Drevenice 5207 [573337] Dřevěnice"
    },
    {
        "kod": 572900,
        "nazev": "Holín",
        "popis": "[572900] Holín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572900,
        "val": "[572900] Holin 5207 [572900] Holín"
    },
    {
        "kod": 572918,
        "nazev": "Holovousy",
        "popis": "[572918] Holovousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572918,
        "val": "[572918] Holovousy 5204 [572918] Holovousy"
    },
    {
        "kod": 572926,
        "nazev": "Hořice",
        "popis": "[572926] Hořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572926,
        "val": "[572926] Horice 5204 [572926] Hořice"
    },
    {
        "kod": 549355,
        "nazev": "Cholenice",
        "popis": "[549355] Cholenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549355,
        "val": "[549355] Cholenice 5207 [549355] Cholenice"
    },
    {
        "kod": 572969,
        "nazev": "Chomutice",
        "popis": "[572969] Chomutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572969,
        "val": "[572969] Chomutice 5204 [572969] Chomutice"
    },
    {
        "kod": 549037,
        "nazev": "Choteč",
        "popis": "[549037] Choteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549037,
        "val": "[549037] Chotec 5207 [549037] Choteč"
    },
    {
        "kod": 549223,
        "nazev": "Chyjice",
        "popis": "[549223] Chyjice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549223,
        "val": "[549223] Chyjice 5207 [549223] Chyjice"
    },
    {
        "kod": 572993,
        "nazev": "Jeřice",
        "popis": "[572993] Jeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572993,
        "val": "[572993] Jerice 5204 [572993] Jeřice"
    },
    {
        "kod": 572659,
        "nazev": "Jičín",
        "popis": "[572659] Jičín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572659,
        "val": "[572659] Jicin 5207 [572659] Jičín"
    },
    {
        "kod": 573001,
        "nazev": "Jičíněves",
        "popis": "[573001] Jičíněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573001,
        "val": "[573001] Jicineves 5207 [573001] Jičíněves"
    },
    {
        "kod": 549151,
        "nazev": "Jinolice",
        "popis": "[549151] Jinolice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549151,
        "val": "[549151] Jinolice 5207 [549151] Jinolice"
    },
    {
        "kod": 549312,
        "nazev": "Kacákova Lhota",
        "popis": "[549312] Kacákova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549312,
        "val": "[549312] Kacakova Lhota 5207 [549312] Kacákova Lhota"
    },
    {
        "kod": 549169,
        "nazev": "Kbelnice",
        "popis": "[549169] Kbelnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549169,
        "val": "[549169] Kbelnice 5207 [549169] Kbelnice"
    },
    {
        "kod": 573043,
        "nazev": "Kněžnice",
        "popis": "[573043] Kněžnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573043,
        "val": "[573043] Kneznice 5207 [573043] Kněžnice"
    },
    {
        "kod": 573051,
        "nazev": "Konecchlumí",
        "popis": "[573051] Konecchlumí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573051,
        "val": "[573051] Konecchlumi 5207 [573051] Konecchlumí"
    },
    {
        "kod": 573060,
        "nazev": "Kopidlno",
        "popis": "[573060] Kopidlno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573060,
        "val": "[573060] Kopidlno 5207 [573060] Kopidlno"
    },
    {
        "kod": 548928,
        "nazev": "Kostelec",
        "popis": "[548928] Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548928,
        "val": "[548928] Kostelec 5207 [548928] Kostelec"
    },
    {
        "kod": 548944,
        "nazev": "Kovač",
        "popis": "[548944] Kovač",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548944,
        "val": "[548944] Kovac 5207 [548944] Kovač"
    },
    {
        "kod": 572136,
        "nazev": "Kozojedy",
        "popis": "[572136] Kozojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572136,
        "val": "[572136] Kozojedy 5207 [572136] Kozojedy"
    },
    {
        "kod": 572047,
        "nazev": "Kyje",
        "popis": "[572047] Kyje",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572047,
        "val": "[572047] Kyje 5207 [572047] Kyje"
    },
    {
        "kod": 573094,
        "nazev": "Lázně Bělohrad",
        "popis": "[573094] Lázně Bělohrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573094,
        "val": "[573094] Lazne Belohrad 5207 [573094] Lázně Bělohrad"
    },
    {
        "kod": 573108,
        "nazev": "Libáň",
        "popis": "[573108] Libáň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573108,
        "val": "[573108] Liban 5207 [573108] Libáň"
    },
    {
        "kod": 573116,
        "nazev": "Libošovice",
        "popis": "[573116] Libošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573116,
        "val": "[573116] Libosovice 5207 [573116] Libošovice"
    },
    {
        "kod": 573124,
        "nazev": "Libuň",
        "popis": "[573124] Libuň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573124,
        "val": "[573124] Libun 5207 [573124] Libuň"
    },
    {
        "kod": 573086,
        "nazev": "Lískovice",
        "popis": "[573086] Lískovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573086,
        "val": "[573086] Liskovice 5204 [573086] Lískovice"
    },
    {
        "kod": 573141,
        "nazev": "Lukavec u Hořic",
        "popis": "[573141] Lukavec u Hořic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573141,
        "val": "[573141] Lukavec u Horic 5204 [573141] Lukavec u Hořic"
    },
    {
        "kod": 573159,
        "nazev": "Lužany",
        "popis": "[573159] Lužany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573159,
        "val": "[573159] Luzany 5207 [573159] Lužany"
    },
    {
        "kod": 573167,
        "nazev": "Markvartice",
        "popis": "[573167] Markvartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573167,
        "val": "[573167] Markvartice 5207 [573167] Markvartice"
    },
    {
        "kod": 573175,
        "nazev": "Miletín",
        "popis": "[573175] Miletín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573175,
        "val": "[573175] Miletin 5204 [573175] Miletín"
    },
    {
        "kod": 548863,
        "nazev": "Milovice u Hořic",
        "popis": "[548863] Milovice u Hořic",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548863,
        "val": "[548863] Milovice u Horic 5204 [548863] Milovice u Hořic"
    },
    {
        "kod": 573205,
        "nazev": "Mladějov",
        "popis": "[573205] Mladějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573205,
        "val": "[573205] Mladejov 5207 [573205] Mladějov"
    },
    {
        "kod": 573213,
        "nazev": "Mlázovice",
        "popis": "[573213] Mlázovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573213,
        "val": "[573213] Mlazovice 5207 [573213] Mlázovice"
    },
    {
        "kod": 573230,
        "nazev": "Nemyčeves",
        "popis": "[573230] Nemyčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573230,
        "val": "[573230] Nemyceves 5207 [573230] Nemyčeves"
    },
    {
        "kod": 549207,
        "nazev": "Nevratice",
        "popis": "[549207] Nevratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 549207,
        "val": "[549207] Nevratice 5204 [549207] Nevratice"
    },
    {
        "kod": 573248,
        "nazev": "Nová Paka",
        "popis": "[573248] Nová Paka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5210,
        "iczuj": 573248,
        "val": "[573248] Nova Paka 5210 [573248] Nová Paka"
    },
    {
        "kod": 549185,
        "nazev": "Ohařice",
        "popis": "[549185] Ohařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549185,
        "val": "[549185] Oharice 5207 [549185] Ohařice"
    },
    {
        "kod": 548910,
        "nazev": "Ohaveč",
        "popis": "[548910] Ohaveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548910,
        "val": "[548910] Ohavec 5207 [548910] Ohaveč"
    },
    {
        "kod": 573264,
        "nazev": "Osek",
        "popis": "[573264] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573264,
        "val": "[573264] Osek 5207 [573264] Osek"
    },
    {
        "kod": 573272,
        "nazev": "Ostroměř",
        "popis": "[573272] Ostroměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573272,
        "val": "[573272] Ostromer 5204 [573272] Ostroměř"
    },
    {
        "kod": 573281,
        "nazev": "Ostružno",
        "popis": "[573281] Ostružno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573281,
        "val": "[573281] Ostruzno 5207 [573281] Ostružno"
    },
    {
        "kod": 573299,
        "nazev": "Pecka",
        "popis": "[573299] Pecka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5210,
        "iczuj": 573299,
        "val": "[573299] Pecka 5210 [573299] Pecka"
    },
    {
        "kod": 548871,
        "nazev": "Petrovičky",
        "popis": "[548871] Petrovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548871,
        "val": "[548871] Petrovicky 5204 [548871] Petrovičky"
    },
    {
        "kod": 573311,
        "nazev": "Podhorní Újezd a Vojice",
        "popis": "[573311] Podhorní Újezd a Vojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573311,
        "val": "[573311] Podhorni Ujezd a Vojice 5204 [573311] Podhorní Újezd a Vojice"
    },
    {
        "kod": 573329,
        "nazev": "Podhradí",
        "popis": "[573329] Podhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573329,
        "val": "[573329] Podhradi 5207 [573329] Podhradí"
    },
    {
        "kod": 573345,
        "nazev": "Podůlší",
        "popis": "[573345] Podůlší",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573345,
        "val": "[573345] Podulsi 5207 [573345] Podůlší"
    },
    {
        "kod": 573370,
        "nazev": "Radim",
        "popis": "[573370] Radim",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573370,
        "val": "[573370] Radim 5207 [573370] Radim"
    },
    {
        "kod": 549274,
        "nazev": "Rašín",
        "popis": "[549274] Rašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 549274,
        "val": "[549274] Rasin 5204 [549274] Rašín"
    },
    {
        "kod": 573221,
        "nazev": "Rohoznice",
        "popis": "[573221] Rohoznice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573221,
        "val": "[573221] Rohoznice 5204 [573221] Rohoznice"
    },
    {
        "kod": 548898,
        "nazev": "Rokytňany",
        "popis": "[548898] Rokytňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548898,
        "val": "[548898] Rokytnany 5207 [548898] Rokytňany"
    },
    {
        "kod": 573442,
        "nazev": "Samšina",
        "popis": "[573442] Samšina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573442,
        "val": "[573442] Samsina 5207 [573442] Samšina"
    },
    {
        "kod": 573451,
        "nazev": "Sběř",
        "popis": "[573451] Sběř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573451,
        "val": "[573451] Sber 5207 [573451] Sběř"
    },
    {
        "kod": 548961,
        "nazev": "Sedliště",
        "popis": "[548961] Sedliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 548961,
        "val": "[548961] Sedliste 5207 [548961] Sedliště"
    },
    {
        "kod": 572144,
        "nazev": "Sekeřice",
        "popis": "[572144] Sekeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572144,
        "val": "[572144] Sekerice 5207 [572144] Sekeřice"
    },
    {
        "kod": 573469,
        "nazev": "Slatiny",
        "popis": "[573469] Slatiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573469,
        "val": "[573469] Slatiny 5207 [573469] Slatiny"
    },
    {
        "kod": 572187,
        "nazev": "Slavhostice",
        "popis": "[572187] Slavhostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572187,
        "val": "[572187] Slavhostice 5207 [572187] Slavhostice"
    },
    {
        "kod": 573477,
        "nazev": "Sobčice",
        "popis": "[573477] Sobčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573477,
        "val": "[573477] Sobcice 5204 [573477] Sobčice"
    },
    {
        "kod": 573361,
        "nazev": "Soběraz",
        "popis": "[573361] Soběraz",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573361,
        "val": "[573361] Soberaz 5207 [573361] Soběraz"
    },
    {
        "kod": 573493,
        "nazev": "Sobotka",
        "popis": "[573493] Sobotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573493,
        "val": "[573493] Sobotka 5207 [573493] Sobotka"
    },
    {
        "kod": 566527,
        "nazev": "Očihov",
        "popis": "[566527] Očihov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566527,
        "val": "[566527] Ocihov 4210 [566527] Očihov"
    },
    {
        "kod": 542555,
        "nazev": "Opočno",
        "popis": "[542555] Opočno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 542555,
        "val": "[542555] Opocno 4207 [542555] Opočno"
    },
    {
        "kod": 566535,
        "nazev": "Panenský Týnec",
        "popis": "[566535] Panenský Týnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566535,
        "val": "[566535] Panensky Tynec 4207 [566535] Panenský Týnec"
    },
    {
        "kod": 566551,
        "nazev": "Peruc",
        "popis": "[566551] Peruc",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566551,
        "val": "[566551] Peruc 4207 [566551] Peruc"
    },
    {
        "kod": 566560,
        "nazev": "Petrohrad",
        "popis": "[566560] Petrohrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566560,
        "val": "[566560] Petrohrad 4210 [566560] Petrohrad"
    },
    {
        "kod": 566578,
        "nazev": "Pnětluky",
        "popis": "[566578] Pnětluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566578,
        "val": "[566578] Pnetluky 4207 [566578] Pnětluky"
    },
    {
        "kod": 566586,
        "nazev": "Počedělice",
        "popis": "[566586] Počedělice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566586,
        "val": "[566586] Pocedelice 4207 [566586] Počedělice"
    },
    {
        "kod": 566608,
        "nazev": "Podbořanský Rohozec",
        "popis": "[566608] Podbořanský Rohozec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566608,
        "val": "[566608] Podboransky Rohozec 4210 [566608] Podbořanský Rohozec"
    },
    {
        "kod": 566616,
        "nazev": "Podbořany",
        "popis": "[566616] Podbořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566616,
        "val": "[566616] Podborany 4210 [566616] Podbořany"
    },
    {
        "kod": 566624,
        "nazev": "Postoloprty",
        "popis": "[566624] Postoloprty",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566624,
        "val": "[566624] Postoloprty 4207 [566624] Postoloprty"
    },
    {
        "kod": 566659,
        "nazev": "Raná",
        "popis": "[566659] Raná",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566659,
        "val": "[566659] Rana 4207 [566659] Raná"
    },
    {
        "kod": 566667,
        "nazev": "Ročov",
        "popis": "[566667] Ročov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566667,
        "val": "[566667] Rocov 4207 [566667] Ročov"
    },
    {
        "kod": 566713,
        "nazev": "Slavětín",
        "popis": "[566713] Slavětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566713,
        "val": "[566713] Slavetin 4207 [566713] Slavětín"
    },
    {
        "kod": 566721,
        "nazev": "Smolnice",
        "popis": "[566721] Smolnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566721,
        "val": "[566721] Smolnice 4207 [566721] Smolnice"
    },
    {
        "kod": 543128,
        "nazev": "Staňkovice",
        "popis": "[543128] Staňkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 543128,
        "val": "[543128] Stankovice 4216 [543128] Staňkovice"
    },
    {
        "kod": 566829,
        "nazev": "Toužetín",
        "popis": "[566829] Toužetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566829,
        "val": "[566829] Touzetin 4207 [566829] Toužetín"
    },
    {
        "kod": 566853,
        "nazev": "Tuchořice",
        "popis": "[566853] Tuchořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566853,
        "val": "[566853] Tuchorice 4216 [566853] Tuchořice"
    },
    {
        "kod": 546178,
        "nazev": "Úherce",
        "popis": "[546178] Úherce",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546178,
        "val": "[546178] Uherce 4207 [546178] Úherce"
    },
    {
        "kod": 566870,
        "nazev": "Velemyšleves",
        "popis": "[566870] Velemyšleves",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566870,
        "val": "[566870] Velemysleves 4216 [566870] Velemyšleves"
    },
    {
        "kod": 566896,
        "nazev": "Veltěže",
        "popis": "[566896] Veltěže",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566896,
        "val": "[566896] Velteze 4207 [566896] Veltěže"
    },
    {
        "kod": 566918,
        "nazev": "Vinařice",
        "popis": "[566918] Vinařice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566918,
        "val": "[566918] Vinarice 4207 [566918] Vinařice"
    },
    {
        "kod": 566926,
        "nazev": "Vrbno nad Lesy",
        "popis": "[566926] Vrbno nad Lesy",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566926,
        "val": "[566926] Vrbno nad Lesy 4207 [566926] Vrbno nad Lesy"
    },
    {
        "kod": 566934,
        "nazev": "Vroutek",
        "popis": "[566934] Vroutek",
        "datum_od": "",
        "datum_do": "",
        "orp": 4210,
        "iczuj": 566934,
        "val": "[566934] Vroutek 4210 [566934] Vroutek"
    },
    {
        "kod": 546887,
        "nazev": "Vršovice",
        "popis": "[546887] Vršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 546887,
        "val": "[546887] Vrsovice 4207 [546887] Vršovice"
    },
    {
        "kod": 566951,
        "nazev": "Výškov",
        "popis": "[566951] Výškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566951,
        "val": "[566951] Vyskov 4207 [566951] Výškov"
    },
    {
        "kod": 530603,
        "nazev": "Zálužice",
        "popis": "[530603] Zálužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 530603,
        "val": "[530603] Zaluzice 4216 [530603] Zálužice"
    },
    {
        "kod": 566977,
        "nazev": "Zbrašín",
        "popis": "[566977] Zbrašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 566977,
        "val": "[566977] Zbrasin 4207 [566977] Zbrašín"
    },
    {
        "kod": 566985,
        "nazev": "Žatec",
        "popis": "[566985] Žatec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 566985,
        "val": "[566985] Zatec 4216 [566985] Žatec"
    },
    {
        "kod": 530565,
        "nazev": "Želkovice",
        "popis": "[530565] Želkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 530565,
        "val": "[530565] Zelkovice 4207 [530565] Želkovice"
    },
    {
        "kod": 543012,
        "nazev": "Žerotín",
        "popis": "[543012] Žerotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4207,
        "iczuj": 543012,
        "val": "[543012] Zerotin 4207 [543012] Žerotín"
    },
    {
        "kod": 567019,
        "nazev": "Žiželice",
        "popis": "[567019] Žiželice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4216,
        "iczuj": 567019,
        "val": "[567019] Zizelice 4216 [567019] Žiželice"
    },
    {
        "kod": 567043,
        "nazev": "Bečov",
        "popis": "[567043] Bečov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567043,
        "val": "[567043] Becov 4209 [567043] Bečov"
    },
    {
        "kod": 567051,
        "nazev": "Bělušice",
        "popis": "[567051] Bělušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567051,
        "val": "[567051] Belusice 4209 [567051] Bělušice"
    },
    {
        "kod": 567060,
        "nazev": "Braňany",
        "popis": "[567060] Braňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567060,
        "val": "[567060] Branany 4209 [567060] Braňany"
    },
    {
        "kod": 567078,
        "nazev": "Brandov",
        "popis": "[567078] Brandov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567078,
        "val": "[567078] Brandov 4206 [567078] Brandov"
    },
    {
        "kod": 567108,
        "nazev": "Český Jiřetín",
        "popis": "[567108] Český Jiřetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567108,
        "val": "[567108] Cesky Jiretin 4206 [567108] Český Jiřetín"
    },
    {
        "kod": 567141,
        "nazev": "Havraň",
        "popis": "[567141] Havraň",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567141,
        "val": "[567141] Havran 4209 [567141] Havraň"
    },
    {
        "kod": 567167,
        "nazev": "Hora Svaté Kateřiny",
        "popis": "[567167] Hora Svaté Kateřiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567167,
        "val": "[567167] Hora Svate Kateriny 4206 [567167] Hora Svaté Kateřiny"
    },
    {
        "kod": 567175,
        "nazev": "Horní Jiřetín",
        "popis": "[567175] Horní Jiřetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567175,
        "val": "[567175] Horni Jiretin 4206 [567175] Horní Jiřetín"
    },
    {
        "kod": 567191,
        "nazev": "Klíny",
        "popis": "[567191] Klíny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567191,
        "val": "[567191] Kliny 4206 [567191] Klíny"
    },
    {
        "kod": 567221,
        "nazev": "Korozluky",
        "popis": "[567221] Korozluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567221,
        "val": "[567221] Korozluky 4209 [567221] Korozluky"
    },
    {
        "kod": 567248,
        "nazev": "Lišnice",
        "popis": "[567248] Lišnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567248,
        "val": "[567248] Lisnice 4209 [567248] Lišnice"
    },
    {
        "kod": 567256,
        "nazev": "Litvínov",
        "popis": "[567256] Litvínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567256,
        "val": "[567256] Litvinov 4206 [567256] Litvínov"
    },
    {
        "kod": 567264,
        "nazev": "Lom",
        "popis": "[567264] Lom",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567264,
        "val": "[567264] Lom 4206 [567264] Lom"
    },
    {
        "kod": 567272,
        "nazev": "Louka u Litvínova",
        "popis": "[567272] Louka u Litvínova",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567272,
        "val": "[567272] Louka u Litvinova 4206 [567272] Louka u Litvínova"
    },
    {
        "kod": 567281,
        "nazev": "Lužice",
        "popis": "[567281] Lužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567281,
        "val": "[567281] Luzice 4209 [567281] Lužice"
    },
    {
        "kod": 567299,
        "nazev": "Malé Březno",
        "popis": "[567299] Malé Březno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567299,
        "val": "[567299] Male Brezno 4209 [567299] Malé Březno"
    },
    {
        "kod": 567302,
        "nazev": "Mariánské Radčice",
        "popis": "[567302] Mariánské Radčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567302,
        "val": "[567302] Marianske Radcice 4206 [567302] Mariánské Radčice"
    },
    {
        "kod": 567311,
        "nazev": "Meziboří",
        "popis": "[567311] Meziboří",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567311,
        "val": "[567311] Mezibori 4206 [567311] Meziboří"
    },
    {
        "kod": 567027,
        "nazev": "Most",
        "popis": "[567027] Most",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567027,
        "val": "[567027] Most 4209 [567027] Most"
    },
    {
        "kod": 567329,
        "nazev": "Nová Ves v Horách",
        "popis": "[567329] Nová Ves v Horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 4206,
        "iczuj": 567329,
        "val": "[567329] Nova Ves v Horach 4206 [567329] Nová Ves v Horách"
    },
    {
        "kod": 567337,
        "nazev": "Obrnice",
        "popis": "[567337] Obrnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567337,
        "val": "[567337] Obrnice 4209 [567337] Obrnice"
    },
    {
        "kod": 567345,
        "nazev": "Patokryje",
        "popis": "[567345] Patokryje",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567345,
        "val": "[567345] Patokryje 4209 [567345] Patokryje"
    },
    {
        "kod": 567353,
        "nazev": "Polerady",
        "popis": "[567353] Polerady",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567353,
        "val": "[567353] Polerady 4209 [567353] Polerady"
    },
    {
        "kod": 567361,
        "nazev": "Skršín",
        "popis": "[567361] Skršín",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567361,
        "val": "[567361] Skrsin 4209 [567361] Skršín"
    },
    {
        "kod": 546437,
        "nazev": "Volevčice",
        "popis": "[546437] Volevčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 546437,
        "val": "[546437] Volevcice 4209 [546437] Volevčice"
    },
    {
        "kod": 567426,
        "nazev": "Želenice",
        "popis": "[567426] Želenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4209,
        "iczuj": 567426,
        "val": "[567426] Zelenice 4209 [567426] Želenice"
    },
    {
        "kod": 567451,
        "nazev": "Bílina",
        "popis": "[567451] Bílina",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567451,
        "val": "[567451] Bilina 4201 [567451] Bílina"
    },
    {
        "kod": 567469,
        "nazev": "Bořislav",
        "popis": "[567469] Bořislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567469,
        "val": "[567469] Borislav 4213 [567469] Bořislav"
    },
    {
        "kod": 567477,
        "nazev": "Bystřany",
        "popis": "[567477] Bystřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567477,
        "val": "[567477] Bystrany 4213 [567477] Bystřany"
    },
    {
        "kod": 567485,
        "nazev": "Bžany",
        "popis": "[567485] Bžany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567485,
        "val": "[567485] Bzany 4213 [567485] Bžany"
    },
    {
        "kod": 567507,
        "nazev": "Dubí",
        "popis": "[567507] Dubí",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567507,
        "val": "[567507] Dubi 4213 [567507] Dubí"
    },
    {
        "kod": 567515,
        "nazev": "Duchcov",
        "popis": "[567515] Duchcov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567515,
        "val": "[567515] Duchcov 4213 [567515] Duchcov"
    },
    {
        "kod": 567523,
        "nazev": "Háj u Duchcova",
        "popis": "[567523] Háj u Duchcova",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567523,
        "val": "[567523] Haj u Duchcova 4213 [567523] Háj u Duchcova"
    },
    {
        "kod": 567531,
        "nazev": "Hostomice",
        "popis": "[567531] Hostomice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567531,
        "val": "[567531] Hostomice 4201 [567531] Hostomice"
    },
    {
        "kod": 567558,
        "nazev": "Hrob",
        "popis": "[567558] Hrob",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567558,
        "val": "[567558] Hrob 4213 [567558] Hrob"
    },
    {
        "kod": 567566,
        "nazev": "Hrobčice",
        "popis": "[567566] Hrobčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567566,
        "val": "[567566] Hrobcice 4201 [567566] Hrobčice"
    },
    {
        "kod": 567582,
        "nazev": "Jeníkov",
        "popis": "[567582] Jeníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567582,
        "val": "[567582] Jenikov 4213 [567582] Jeníkov"
    },
    {
        "kod": 567604,
        "nazev": "Kladruby",
        "popis": "[567604] Kladruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567604,
        "val": "[567604] Kladruby 4213 [567604] Kladruby"
    },
    {
        "kod": 567612,
        "nazev": "Kostomlaty pod Milešovkou",
        "popis": "[567612] Kostomlaty pod Milešovkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567612,
        "val": "[567612] Kostomlaty pod Milesovkou 4213 [567612] Kostomlaty pod Milešovkou"
    },
    {
        "kod": 567621,
        "nazev": "Košťany",
        "popis": "[567621] Košťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567621,
        "val": "[567621] Kostany 4213 [567621] Košťany"
    },
    {
        "kod": 567639,
        "nazev": "Krupka",
        "popis": "[567639] Krupka",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567639,
        "val": "[567639] Krupka 4213 [567639] Krupka"
    },
    {
        "kod": 567647,
        "nazev": "Lahošť",
        "popis": "[567647] Lahošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567647,
        "val": "[567647] Lahost 4213 [567647] Lahošť"
    },
    {
        "kod": 567655,
        "nazev": "Ledvice",
        "popis": "[567655] Ledvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567655,
        "val": "[567655] Ledvice 4201 [567655] Ledvice"
    },
    {
        "kod": 546909,
        "nazev": "Lukov",
        "popis": "[546909] Lukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 546909,
        "val": "[546909] Lukov 4201 [546909] Lukov"
    },
    {
        "kod": 567698,
        "nazev": "Měrunice",
        "popis": "[567698] Měrunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567698,
        "val": "[567698] Merunice 4201 [567698] Měrunice"
    },
    {
        "kod": 567701,
        "nazev": "Mikulov",
        "popis": "[567701] Mikulov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567701,
        "val": "[567701] Mikulov 4213 [567701] Mikulov"
    },
    {
        "kod": 567710,
        "nazev": "Modlany",
        "popis": "[567710] Modlany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567710,
        "val": "[567710] Modlany 4213 [567710] Modlany"
    },
    {
        "kod": 567728,
        "nazev": "Moldava",
        "popis": "[567728] Moldava",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567728,
        "val": "[567728] Moldava 4213 [567728] Moldava"
    },
    {
        "kod": 567752,
        "nazev": "Novosedlice",
        "popis": "[567752] Novosedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567752,
        "val": "[567752] Novosedlice 4213 [567752] Novosedlice"
    },
    {
        "kod": 567761,
        "nazev": "Ohníč",
        "popis": "[567761] Ohníč",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567761,
        "val": "[567761] Ohnic 4201 [567761] Ohníč"
    },
    {
        "kod": 567779,
        "nazev": "Osek",
        "popis": "[567779] Osek",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567779,
        "val": "[567779] Osek 4213 [567779] Osek"
    },
    {
        "kod": 567787,
        "nazev": "Proboštov",
        "popis": "[567787] Proboštov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567787,
        "val": "[567787] Probostov 4213 [567787] Proboštov"
    },
    {
        "kod": 567809,
        "nazev": "Rtyně nad Bílinou",
        "popis": "[567809] Rtyně nad Bílinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567809,
        "val": "[567809] Rtyne nad Bilinou 4213 [567809] Rtyně nad Bílinou"
    },
    {
        "kod": 567833,
        "nazev": "Srbice",
        "popis": "[567833] Srbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567833,
        "val": "[567833] Srbice 4213 [567833] Srbice"
    },
    {
        "kod": 567841,
        "nazev": "Světec",
        "popis": "[567841] Světec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4201,
        "iczuj": 567841,
        "val": "[567841] Svetec 4201 [567841] Světec"
    },
    {
        "kod": 567442,
        "nazev": "Teplice",
        "popis": "[567442] Teplice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567442,
        "val": "[567442] Teplice 4213 [567442] Teplice"
    },
    {
        "kod": 567850,
        "nazev": "Újezdeček",
        "popis": "[567850] Újezdeček",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567850,
        "val": "[567850] Ujezdecek 4213 [567850] Újezdeček"
    },
    {
        "kod": 567868,
        "nazev": "Zabrušany",
        "popis": "[567868] Zabrušany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567868,
        "val": "[567868] Zabrusany 4213 [567868] Zabrušany"
    },
    {
        "kod": 567876,
        "nazev": "Žalany",
        "popis": "[567876] Žalany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567876,
        "val": "[567876] Zalany 4213 [567876] Žalany"
    },
    {
        "kod": 567884,
        "nazev": "Žim",
        "popis": "[567884] Žim",
        "datum_od": "",
        "datum_do": "",
        "orp": 4213,
        "iczuj": 567884,
        "val": "[567884] Zim 4213 [567884] Žim"
    },
    {
        "kod": 567931,
        "nazev": "Dolní Zálezly",
        "popis": "[567931] Dolní Zálezly",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 567931,
        "val": "[567931] Dolni Zalezly 4214 [567931] Dolní Zálezly"
    },
    {
        "kod": 567957,
        "nazev": "Habrovany",
        "popis": "[567957] Habrovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 567957,
        "val": "[567957] Habrovany 4214 [567957] Habrovany"
    },
    {
        "kod": 567973,
        "nazev": "Homole u Panny",
        "popis": "[567973] Homole u Panny",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 567973,
        "val": "[567973] Homole u Panny 4214 [567973] Homole u Panny"
    },
    {
        "kod": 568007,
        "nazev": "Chabařovice",
        "popis": "[568007] Chabařovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568007,
        "val": "[568007] Chabarovice 4214 [568007] Chabařovice"
    },
    {
        "kod": 568015,
        "nazev": "Chlumec",
        "popis": "[568015] Chlumec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568015,
        "val": "[568015] Chlumec 4214 [568015] Chlumec"
    },
    {
        "kod": 568023,
        "nazev": "Chuderov",
        "popis": "[568023] Chuderov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568023,
        "val": "[568023] Chuderov 4214 [568023] Chuderov"
    },
    {
        "kod": 568058,
        "nazev": "Libouchec",
        "popis": "[568058] Libouchec",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568058,
        "val": "[568058] Libouchec 4214 [568058] Libouchec"
    },
    {
        "kod": 568091,
        "nazev": "Malé Březno",
        "popis": "[568091] Malé Březno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568091,
        "val": "[568091] Male Brezno 4214 [568091] Malé Březno"
    },
    {
        "kod": 568104,
        "nazev": "Malečov",
        "popis": "[568104] Malečov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568104,
        "val": "[568104] Malecov 4214 [568104] Malečov"
    },
    {
        "kod": 568147,
        "nazev": "Petrovice",
        "popis": "[568147] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568147,
        "val": "[568147] Petrovice 4214 [568147] Petrovice"
    },
    {
        "kod": 568155,
        "nazev": "Povrly",
        "popis": "[568155] Povrly",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568155,
        "val": "[568155] Povrly 4214 [568155] Povrly"
    },
    {
        "kod": 530620,
        "nazev": "Přestanov",
        "popis": "[530620] Přestanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 530620,
        "val": "[530620] Prestanov 4214 [530620] Přestanov"
    },
    {
        "kod": 546186,
        "nazev": "Ryjice",
        "popis": "[546186] Ryjice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 546186,
        "val": "[546186] Ryjice 4214 [546186] Ryjice"
    },
    {
        "kod": 568201,
        "nazev": "Řehlovice",
        "popis": "[568201] Řehlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568201,
        "val": "[568201] Rehlovice 4214 [568201] Řehlovice"
    },
    {
        "kod": 546925,
        "nazev": "Stebno",
        "popis": "[546925] Stebno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 546925,
        "val": "[546925] Stebno 4214 [546925] Stebno"
    },
    {
        "kod": 568287,
        "nazev": "Tašov",
        "popis": "[568287] Tašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568287,
        "val": "[568287] Tasov 4214 [568287] Tašov"
    },
    {
        "kod": 568295,
        "nazev": "Telnice",
        "popis": "[568295] Telnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568295,
        "val": "[568295] Telnice 4214 [568295] Telnice"
    },
    {
        "kod": 568309,
        "nazev": "Tisá",
        "popis": "[568309] Tisá",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568309,
        "val": "[568309] Tisa 4214 [568309] Tisá"
    },
    {
        "kod": 553697,
        "nazev": "Trmice",
        "popis": "[553697] Trmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 553697,
        "val": "[553697] Trmice 4214 [553697] Trmice"
    },
    {
        "kod": 568350,
        "nazev": "Velké Březno",
        "popis": "[568350] Velké Březno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568350,
        "val": "[568350] Velke Brezno 4214 [568350] Velké Březno"
    },
    {
        "kod": 555223,
        "nazev": "Velké Chvojno",
        "popis": "[555223] Velké Chvojno",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 555223,
        "val": "[555223] Velke Chvojno 4214 [555223] Velké Chvojno"
    },
    {
        "kod": 568384,
        "nazev": "Zubrnice",
        "popis": "[568384] Zubrnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 568384,
        "val": "[568384] Zubrnice 4214 [568384] Zubrnice"
    },
    {
        "kod": 561398,
        "nazev": "Bezděz",
        "popis": "[561398] Bezděz",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561398,
        "val": "[561398] Bezdez 5101 [561398] Bezděz"
    },
    {
        "kod": 561401,
        "nazev": "Blatce",
        "popis": "[561401] Blatce",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561401,
        "val": "[561401] Blatce 5101 [561401] Blatce"
    },
    {
        "kod": 561410,
        "nazev": "Blíževedly",
        "popis": "[561410] Blíževedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561410,
        "val": "[561410] Blizevedly 5101 [561410] Blíževedly"
    },
    {
        "kod": 561428,
        "nazev": "Bohatice",
        "popis": "[561428] Bohatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561428,
        "val": "[561428] Bohatice 5101 [561428] Bohatice"
    },
    {
        "kod": 561444,
        "nazev": "Brniště",
        "popis": "[561444] Brniště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561444,
        "val": "[561444] Brniste 5101 [561444] Brniště"
    },
    {
        "kod": 561479,
        "nazev": "Cvikov",
        "popis": "[561479] Cvikov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561479,
        "val": "[561479] Cvikov 5106 [561479] Cvikov"
    },
    {
        "kod": 561380,
        "nazev": "Česká Lípa",
        "popis": "[561380] Česká Lípa",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561380,
        "val": "[561380] Ceska Lipa 5101 [561380] Česká Lípa"
    },
    {
        "kod": 561495,
        "nazev": "Doksy",
        "popis": "[561495] Doksy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561495,
        "val": "[561495] Doksy 5101 [561495] Doksy"
    },
    {
        "kod": 561533,
        "nazev": "Dubá",
        "popis": "[561533] Dubá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561533,
        "val": "[561533] Duba 5101 [561533] Dubá"
    },
    {
        "kod": 561541,
        "nazev": "Dubnice",
        "popis": "[561541] Dubnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561541,
        "val": "[561541] Dubnice 5101 [561541] Dubnice"
    },
    {
        "kod": 544337,
        "nazev": "Hamr na Jezeře",
        "popis": "[544337] Hamr na Jezeře",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 544337,
        "val": "[544337] Hamr na Jezere 5101 [544337] Hamr na Jezeře"
    },
    {
        "kod": 561584,
        "nazev": "Holany",
        "popis": "[561584] Holany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561584,
        "val": "[561584] Holany 5101 [561584] Holany"
    },
    {
        "kod": 561592,
        "nazev": "Horní Libchava",
        "popis": "[561592] Horní Libchava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561592,
        "val": "[561592] Horni Libchava 5101 [561592] Horní Libchava"
    },
    {
        "kod": 561606,
        "nazev": "Horní Police",
        "popis": "[561606] Horní Police",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561606,
        "val": "[561606] Horni Police 5101 [561606] Horní Police"
    },
    {
        "kod": 561614,
        "nazev": "Chlum",
        "popis": "[561614] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561614,
        "val": "[561614] Chlum 5101 [561614] Chlum"
    },
    {
        "kod": 561622,
        "nazev": "Chotovice",
        "popis": "[561622] Chotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561622,
        "val": "[561622] Chotovice 5106 [561622] Chotovice"
    },
    {
        "kod": 561665,
        "nazev": "Jestřebí",
        "popis": "[561665] Jestřebí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561665,
        "val": "[561665] Jestrebi 5101 [561665] Jestřebí"
    },
    {
        "kod": 561681,
        "nazev": "Kamenický Šenov",
        "popis": "[561681] Kamenický Šenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561681,
        "val": "[561681] Kamenicky Senov 5106 [561681] Kamenický Šenov"
    },
    {
        "kod": 546232,
        "nazev": "Kozly",
        "popis": "[546232] Kozly",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 546232,
        "val": "[546232] Kozly 5101 [546232] Kozly"
    },
    {
        "kod": 561720,
        "nazev": "Kravaře",
        "popis": "[561720] Kravaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561720,
        "val": "[561720] Kravare 5101 [561720] Kravaře"
    },
    {
        "kod": 561738,
        "nazev": "Krompach",
        "popis": "[561738] Krompach",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561738,
        "val": "[561738] Krompach 5106 [561738] Krompach"
    },
    {
        "kod": 561746,
        "nazev": "Kunratice u Cvikova",
        "popis": "[561746] Kunratice u Cvikova",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561746,
        "val": "[561746] Kunratice u Cvikova 5106 [561746] Kunratice u Cvikova"
    },
    {
        "kod": 546259,
        "nazev": "Kvítkov",
        "popis": "[546259] Kvítkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 546259,
        "val": "[546259] Kvitkov 5101 [546259] Kvítkov"
    },
    {
        "kod": 514161,
        "nazev": "Luka",
        "popis": "[514161] Luka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 514161,
        "val": "[514161] Luka 5101 [514161] Luka"
    },
    {
        "kod": 561827,
        "nazev": "Mařenice",
        "popis": "[561827] Mařenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561827,
        "val": "[561827] Marenice 5106 [561827] Mařenice"
    },
    {
        "kod": 561835,
        "nazev": "Mimoň",
        "popis": "[561835] Mimoň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561835,
        "val": "[561835] Mimon 5101 [561835] Mimoň"
    },
    {
        "kod": 561851,
        "nazev": "Noviny pod Ralskem",
        "popis": "[561851] Noviny pod Ralskem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561851,
        "val": "[561851] Noviny pod Ralskem 5101 [561851] Noviny pod Ralskem"
    },
    {
        "kod": 561860,
        "nazev": "Nový Bor",
        "popis": "[561860] Nový Bor",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561860,
        "val": "[561860] Novy Bor 5106 [561860] Nový Bor"
    },
    {
        "kod": 561878,
        "nazev": "Nový Oldřichov",
        "popis": "[561878] Nový Oldřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561878,
        "val": "[561878] Novy Oldrichov 5101 [561878] Nový Oldřichov"
    },
    {
        "kod": 561886,
        "nazev": "Okna",
        "popis": "[561886] Okna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561886,
        "val": "[561886] Okna 5101 [561886] Okna"
    },
    {
        "kod": 561894,
        "nazev": "Okrouhlá",
        "popis": "[561894] Okrouhlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561894,
        "val": "[561894] Okrouhla 5106 [561894] Okrouhlá"
    },
    {
        "kod": 514276,
        "nazev": "Pertoltice pod Ralskem",
        "popis": "[514276] Pertoltice pod Ralskem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 514276,
        "val": "[514276] Pertoltice pod Ralskem 5101 [514276] Pertoltice pod Ralskem"
    },
    {
        "kod": 561959,
        "nazev": "Polevsko",
        "popis": "[561959] Polevsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561959,
        "val": "[561959] Polevsko 5106 [561959] Polevsko"
    },
    {
        "kod": 561983,
        "nazev": "Provodín",
        "popis": "[561983] Provodín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 561983,
        "val": "[561983] Provodin 5101 [561983] Provodín"
    },
    {
        "kod": 561991,
        "nazev": "Prysk",
        "popis": "[561991] Prysk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 561991,
        "val": "[561991] Prysk 5106 [561991] Prysk"
    },
    {
        "kod": 530387,
        "nazev": "Radvanec",
        "popis": "[530387] Radvanec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 530387,
        "val": "[530387] Radvanec 5106 [530387] Radvanec"
    },
    {
        "kod": 562017,
        "nazev": "Ralsko",
        "popis": "[562017] Ralsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562017,
        "val": "[562017] Ralsko 5101 [562017] Ralsko"
    },
    {
        "kod": 562025,
        "nazev": "Skalice u České Lípy",
        "popis": "[562025] Skalice u České Lípy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 562025,
        "val": "[562025] Skalice u Ceske Lipy 5106 [562025] Skalice u České Lípy"
    },
    {
        "kod": 513890,
        "nazev": "Skalka u Doks",
        "popis": "[513890] Skalka u Doks",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 513890,
        "val": "[513890] Skalka u Doks 5101 [513890] Skalka u Doks"
    },
    {
        "kod": 562050,
        "nazev": "Sloup v Čechách",
        "popis": "[562050] Sloup v Čechách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 562050,
        "val": "[562050] Sloup v Cechach 5106 [562050] Sloup v Čechách"
    },
    {
        "kod": 546275,
        "nazev": "Slunečná",
        "popis": "[546275] Slunečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 546275,
        "val": "[546275] Slunecna 5106 [546275] Slunečná"
    },
    {
        "kod": 562076,
        "nazev": "Sosnová",
        "popis": "[562076] Sosnová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562076,
        "val": "[562076] Sosnova 5101 [562076] Sosnová"
    },
    {
        "kod": 562092,
        "nazev": "Stráž pod Ralskem",
        "popis": "[562092] Stráž pod Ralskem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562092,
        "val": "[562092] Straz pod Ralskem 5101 [562092] Stráž pod Ralskem"
    },
    {
        "kod": 562106,
        "nazev": "Stružnice",
        "popis": "[562106] Stružnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562106,
        "val": "[562106] Struznice 5101 [562106] Stružnice"
    },
    {
        "kod": 562114,
        "nazev": "Stvolínky",
        "popis": "[562114] Stvolínky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562114,
        "val": "[562114] Stvolinky 5101 [562114] Stvolínky"
    },
    {
        "kod": 546283,
        "nazev": "Svojkov",
        "popis": "[546283] Svojkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 546283,
        "val": "[546283] Svojkov 5106 [546283] Svojkov"
    },
    {
        "kod": 562131,
        "nazev": "Svor",
        "popis": "[562131] Svor",
        "datum_od": "",
        "datum_do": "",
        "orp": 5106,
        "iczuj": 562131,
        "val": "[562131] Svor 5106 [562131] Svor"
    },
    {
        "kod": 553638,
        "nazev": "Tachov",
        "popis": "[553638] Tachov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 553638,
        "val": "[553638] Tachov 5101 [553638] Tachov"
    },
    {
        "kod": 546267,
        "nazev": "Tuhaň",
        "popis": "[546267] Tuhaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 546267,
        "val": "[546267] Tuhan 5101 [546267] Tuhaň"
    },
    {
        "kod": 562173,
        "nazev": "Velenice",
        "popis": "[562173] Velenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562173,
        "val": "[562173] Velenice 5101 [562173] Velenice"
    },
    {
        "kod": 562203,
        "nazev": "Velký Valtinov",
        "popis": "[562203] Velký Valtinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562203,
        "val": "[562203] Velky Valtinov 5101 [562203] Velký Valtinov"
    },
    {
        "kod": 562220,
        "nazev": "Volfartice",
        "popis": "[562220] Volfartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562220,
        "val": "[562220] Volfartice 5101 [562220] Volfartice"
    },
    {
        "kod": 562238,
        "nazev": "Vrchovany",
        "popis": "[562238] Vrchovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562238,
        "val": "[562238] Vrchovany 5101 [562238] Vrchovany"
    },
    {
        "kod": 562246,
        "nazev": "Zahrádky",
        "popis": "[562246] Zahrádky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562246,
        "val": "[562246] Zahradky 5101 [562246] Zahrádky"
    },
    {
        "kod": 562262,
        "nazev": "Zákupy",
        "popis": "[562262] Zákupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562262,
        "val": "[562262] Zakupy 5101 [562262] Zákupy"
    },
    {
        "kod": 562297,
        "nazev": "Žandov",
        "popis": "[562297] Žandov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 562297,
        "val": "[562297] Zandov 5101 [562297] Žandov"
    },
    {
        "kod": 514195,
        "nazev": "Ždírec",
        "popis": "[514195] Ždírec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5101,
        "iczuj": 514195,
        "val": "[514195] Zdirec 5101 [514195] Ždírec"
    },
    {
        "kod": 563528,
        "nazev": "Albrechtice v Jizerských horách",
        "popis": "[563528] Albrechtice v Jizerských horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563528,
        "val": "[563528] Albrechtice v Jizerskych horach 5108 [563528] Albrechtice v Jizerských horách"
    },
    {
        "kod": 563536,
        "nazev": "Bedřichov",
        "popis": "[563536] Bedřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563536,
        "val": "[563536] Bedrichov 5103 [563536] Bedřichov"
    },
    {
        "kod": 530425,
        "nazev": "Dalešice",
        "popis": "[530425] Dalešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 530425,
        "val": "[530425] Dalesice 5103 [530425] Dalešice"
    },
    {
        "kod": 563552,
        "nazev": "Desná",
        "popis": "[563552] Desná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563552,
        "val": "[563552] Desna 5108 [563552] Desná"
    },
    {
        "kod": 563561,
        "nazev": "Držkov",
        "popis": "[563561] Držkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563561,
        "val": "[563561] Drzkov 5110 [563561] Držkov"
    },
    {
        "kod": 563579,
        "nazev": "Frýdštejn",
        "popis": "[563579] Frýdštejn",
        "datum_od": "",
        "datum_do": 2020,
        "orp": 5109,
        "iczuj": 563579,
        "val": "[563579] Frydstejn 5109 [563579] Frýdštejn"
    },
    {
        "kod": 563510,
        "nazev": "Jablonec nad Nisou",
        "popis": "[563510] Jablonec nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563510,
        "val": "[563510] Jablonec nad Nisou 5103 [563510] Jablonec nad Nisou"
    },
    {
        "kod": 563595,
        "nazev": "Janov nad Nisou",
        "popis": "[563595] Janov nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563595,
        "val": "[563595] Janov nad Nisou 5103 [563595] Janov nad Nisou"
    },
    {
        "kod": 563609,
        "nazev": "Jenišovice",
        "popis": "[563609] Jenišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 563609,
        "val": "[563609] Jenisovice 5109 [563609] Jenišovice"
    },
    {
        "kod": 563617,
        "nazev": "Jílové u Držkova",
        "popis": "[563617] Jílové u Držkova",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563617,
        "val": "[563617] Jilove u Drzkova 5110 [563617] Jílové u Držkova"
    },
    {
        "kod": 546585,
        "nazev": "Jiřetín pod Bukovou",
        "popis": "[546585] Jiřetín pod Bukovou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 546585,
        "val": "[546585] Jiretin pod Bukovou 5108 [546585] Jiřetín pod Bukovou"
    },
    {
        "kod": 563633,
        "nazev": "Josefův Důl",
        "popis": "[563633] Josefův Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563633,
        "val": "[563633] Josefuv Dul 5103 [563633] Josefův Důl"
    },
    {
        "kod": 563641,
        "nazev": "Koberovy",
        "popis": "[563641] Koberovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563641,
        "val": "[563641] Koberovy 5110 [563641] Koberovy"
    },
    {
        "kod": 563668,
        "nazev": "Kořenov",
        "popis": "[563668] Kořenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563668,
        "val": "[563668] Korenov 5108 [563668] Kořenov"
    },
    {
        "kod": 563676,
        "nazev": "Líšný",
        "popis": "[563676] Líšný",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563676,
        "val": "[563676] Lisny 5110 [563676] Líšný"
    },
    {
        "kod": 563684,
        "nazev": "Loužnice",
        "popis": "[563684] Loužnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563684,
        "val": "[563684] Louznice 5110 [563684] Loužnice"
    },
    {
        "kod": 563692,
        "nazev": "Lučany nad Nisou",
        "popis": "[563692] Lučany nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563692,
        "val": "[563692] Lucany nad Nisou 5103 [563692] Lučany nad Nisou"
    },
    {
        "kod": 563706,
        "nazev": "Malá Skála",
        "popis": "[563706] Malá Skála",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 563706,
        "val": "[563706] Mala Skala 5109 [563706] Malá Skála"
    },
    {
        "kod": 563714,
        "nazev": "Maršovice",
        "popis": "[563714] Maršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563714,
        "val": "[563714] Marsovice 5103 [563714] Maršovice"
    },
    {
        "kod": 563731,
        "nazev": "Nová Ves nad Nisou",
        "popis": "[563731] Nová Ves nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563731,
        "val": "[563731] Nova Ves nad Nisou 5103 [563731] Nová Ves nad Nisou"
    },
    {
        "kod": 563749,
        "nazev": "Pěnčín",
        "popis": "[563749] Pěnčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563749,
        "val": "[563749] Pencin 5110 [563749] Pěnčín"
    },
    {
        "kod": 563757,
        "nazev": "Plavy",
        "popis": "[563757] Plavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563757,
        "val": "[563757] Plavy 5108 [563757] Plavy"
    },
    {
        "kod": 546577,
        "nazev": "Pulečný",
        "popis": "[546577] Pulečný",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 546577,
        "val": "[546577] Pulecny 5103 [546577] Pulečný"
    },
    {
        "kod": 563773,
        "nazev": "Radčice",
        "popis": "[563773] Radčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563773,
        "val": "[563773] Radcice 5110 [563773] Radčice"
    },
    {
        "kod": 563781,
        "nazev": "Rádlo",
        "popis": "[563781] Rádlo",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563781,
        "val": "[563781] Radlo 5103 [563781] Rádlo"
    },
    {
        "kod": 563790,
        "nazev": "Rychnov u Jablonce nad Nisou",
        "popis": "[563790] Rychnov u Jablonce nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563790,
        "val": "[563790] Rychnov u Jablonce nad Nisou 5103 [563790] Rychnov u Jablonce nad Nisou"
    },
    {
        "kod": 563803,
        "nazev": "Skuhrov",
        "popis": "[563803] Skuhrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563803,
        "val": "[563803] Skuhrov 5110 [563803] Skuhrov"
    },
    {
        "kod": 563811,
        "nazev": "Smržovka",
        "popis": "[563811] Smržovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563811,
        "val": "[563811] Smrzovka 5108 [563811] Smržovka"
    },
    {
        "kod": 563820,
        "nazev": "Tanvald",
        "popis": "[563820] Tanvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563820,
        "val": "[563820] Tanvald 5108 [563820] Tanvald"
    },
    {
        "kod": 563838,
        "nazev": "Velké Hamry",
        "popis": "[563838] Velké Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563838,
        "val": "[563838] Velke Hamry 5108 [563838] Velké Hamry"
    },
    {
        "kod": 563846,
        "nazev": "Vlastiboř",
        "popis": "[563846] Vlastiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563846,
        "val": "[563846] Vlastibor 5110 [563846] Vlastiboř"
    },
    {
        "kod": 563854,
        "nazev": "Zásada",
        "popis": "[563854] Zásada",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563854,
        "val": "[563854] Zasada 5110 [563854] Zásada"
    },
    {
        "kod": 563862,
        "nazev": "Zlatá Olešnice",
        "popis": "[563862] Zlatá Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 563862,
        "val": "[563862] Zlata Olesnice 5108 [563862] Zlatá Olešnice"
    },
    {
        "kod": 563871,
        "nazev": "Železný Brod",
        "popis": "[563871] Železný Brod",
        "datum_od": "",
        "datum_do": "",
        "orp": 5110,
        "iczuj": 563871,
        "val": "[563871] Zelezny Brod 5110 [563871] Železný Brod"
    },
    {
        "kod": 563901,
        "nazev": "Bílá",
        "popis": "[563901] Bílá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563901,
        "val": "[563901] Bila 5105 [563901] Bílá"
    },
    {
        "kod": 563919,
        "nazev": "Bílý Kostel nad Nisou",
        "popis": "[563919] Bílý Kostel nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563919,
        "val": "[563919] Bily Kostel nad Nisou 5105 [563919] Bílý Kostel nad Nisou"
    },
    {
        "kod": 546631,
        "nazev": "Bílý Potok",
        "popis": "[546631] Bílý Potok",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 546631,
        "val": "[546631] Bily Potok 5102 [546631] Bílý Potok"
    },
    {
        "kod": 563935,
        "nazev": "Bulovka",
        "popis": "[563935] Bulovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 563935,
        "val": "[563935] Bulovka 5102 [563935] Bulovka"
    },
    {
        "kod": 563943,
        "nazev": "Cetenov",
        "popis": "[563943] Cetenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563943,
        "val": "[563943] Cetenov 5105 [563943] Cetenov"
    },
    {
        "kod": 545996,
        "nazev": "Černousy",
        "popis": "[545996] Černousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 545996,
        "val": "[545996] Cernousy 5102 [545996] Černousy"
    },
    {
        "kod": 563960,
        "nazev": "Český Dub",
        "popis": "[563960] Český Dub",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563960,
        "val": "[563960] Cesky Dub 5105 [563960] Český Dub"
    },
    {
        "kod": 544531,
        "nazev": "Čtveřín",
        "popis": "[544531] Čtveřín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 544531,
        "val": "[544531] Ctverin 5109 [544531] Čtveřín"
    },
    {
        "kod": 546607,
        "nazev": "Dětřichov",
        "popis": "[546607] Dětřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 546607,
        "val": "[546607] Detrichov 5102 [546607] Dětřichov"
    },
    {
        "kod": 530468,
        "nazev": "Dlouhý Most",
        "popis": "[530468] Dlouhý Most",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 530468,
        "val": "[530468] Dlouhy Most 5105 [530468] Dlouhý Most"
    },
    {
        "kod": 563994,
        "nazev": "Dolní Řasnice",
        "popis": "[563994] Dolní Řasnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 563994,
        "val": "[563994] Dolni Rasnice 5102 [563994] Dolní Řasnice"
    },
    {
        "kod": 564028,
        "nazev": "Frýdlant",
        "popis": "[564028] Frýdlant",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564028,
        "val": "[564028] Frydlant 5102 [564028] Frýdlant"
    },
    {
        "kod": 564036,
        "nazev": "Habartice",
        "popis": "[564036] Habartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564036,
        "val": "[564036] Habartice 5102 [564036] Habartice"
    },
    {
        "kod": 564044,
        "nazev": "Hejnice",
        "popis": "[564044] Hejnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564044,
        "val": "[564044] Hejnice 5102 [564044] Hejnice"
    },
    {
        "kod": 544353,
        "nazev": "Heřmanice",
        "popis": "[544353] Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 544353,
        "val": "[544353] Hermanice 5102 [544353] Heřmanice"
    },
    {
        "kod": 564052,
        "nazev": "Hlavice",
        "popis": "[564052] Hlavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564052,
        "val": "[564052] Hlavice 5105 [564052] Hlavice"
    },
    {
        "kod": 564061,
        "nazev": "Hodkovice nad Mohelkou",
        "popis": "[564061] Hodkovice nad Mohelkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564061,
        "val": "[564061] Hodkovice nad Mohelkou 5105 [564061] Hodkovice nad Mohelkou"
    },
    {
        "kod": 564079,
        "nazev": "Horní Řasnice",
        "popis": "[564079] Horní Řasnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564079,
        "val": "[564079] Horni Rasnice 5102 [564079] Horní Řasnice"
    },
    {
        "kod": 564095,
        "nazev": "Hrádek nad Nisou",
        "popis": "[564095] Hrádek nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564095,
        "val": "[564095] Hradek nad Nisou 5105 [564095] Hrádek nad Nisou"
    },
    {
        "kod": 564109,
        "nazev": "Chotyně",
        "popis": "[564109] Chotyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564109,
        "val": "[564109] Chotyne 5105 [564109] Chotyně"
    },
    {
        "kod": 564117,
        "nazev": "Chrastava",
        "popis": "[564117] Chrastava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564117,
        "val": "[564117] Chrastava 5105 [564117] Chrastava"
    },
    {
        "kod": 561631,
        "nazev": "Jablonné v Podještědí",
        "popis": "[561631] Jablonné v Podještědí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 561631,
        "val": "[561631] Jablonne v Podjestedi 5105 [561631] Jablonné v Podještědí"
    },
    {
        "kod": 561657,
        "nazev": "Janovice v Podještědí",
        "popis": "[561657] Janovice v Podještědí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 561657,
        "val": "[561657] Janovice v Podjestedi 5105 [561657] Janovice v Podještědí"
    },
    {
        "kod": 546658,
        "nazev": "Janův Důl",
        "popis": "[546658] Janův Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 546658,
        "val": "[546658] Januv Dul 5105 [546658] Janův Důl"
    },
    {
        "kod": 530484,
        "nazev": "Jeřmanice",
        "popis": "[530484] Jeřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 530484,
        "val": "[530484] Jermanice 5105 [530484] Jeřmanice"
    },
    {
        "kod": 564133,
        "nazev": "Jindřichovice pod Smrkem",
        "popis": "[564133] Jindřichovice pod Smrkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564133,
        "val": "[564133] Jindrichovice pod Smrkem 5102 [564133] Jindřichovice pod Smrkem"
    },
    {
        "kod": 564141,
        "nazev": "Kobyly",
        "popis": "[564141] Kobyly",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564141,
        "val": "[564141] Kobyly 5109 [564141] Kobyly"
    },
    {
        "kod": 564168,
        "nazev": "Krásný Les",
        "popis": "[564168] Krásný Les",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564168,
        "val": "[564168] Krasny Les 5102 [564168] Krásný Les"
    },
    {
        "kod": 564176,
        "nazev": "Kryštofovo Údolí",
        "popis": "[564176] Kryštofovo Údolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564176,
        "val": "[564176] Krystofovo Udoli 5105 [564176] Kryštofovo Údolí"
    },
    {
        "kod": 564184,
        "nazev": "Křižany",
        "popis": "[564184] Křižany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564184,
        "val": "[564184] Krizany 5105 [564184] Křižany"
    },
    {
        "kod": 530433,
        "nazev": "Kunratice",
        "popis": "[530433] Kunratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 530433,
        "val": "[530433] Kunratice 5102 [530433] Kunratice"
    },
    {
        "kod": 564206,
        "nazev": "Lázně Libverda",
        "popis": "[564206] Lázně Libverda",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564206,
        "val": "[564206] Lazne Libverda 5102 [564206] Lázně Libverda"
    },
    {
        "kod": 545937,
        "nazev": "Lažany",
        "popis": "[545937] Lažany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 545937,
        "val": "[545937] Lazany 5109 [545937] Lažany"
    },
    {
        "kod": 564231,
        "nazev": "Mníšek",
        "popis": "[564231] Mníšek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564231,
        "val": "[564231] Mnisek 5105 [564231] Mníšek"
    },
    {
        "kod": 546593,
        "nazev": "Nová Ves",
        "popis": "[546593] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 546593,
        "val": "[546593] Nova Ves 5105 [546593] Nová Ves"
    },
    {
        "kod": 564265,
        "nazev": "Nové Město pod Smrkem",
        "popis": "[564265] Nové Město pod Smrkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564265,
        "val": "[564265] Nove Mesto pod Smrkem 5102 [564265] Nové Město pod Smrkem"
    },
    {
        "kod": 564281,
        "nazev": "Oldřichov v Hájích",
        "popis": "[564281] Oldřichov v Hájích",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564281,
        "val": "[564281] Oldrichov v Hajich 5105 [564281] Oldřichov v Hájích"
    },
    {
        "kod": 564290,
        "nazev": "Osečná",
        "popis": "[564290] Osečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564290,
        "val": "[564290] Osecna 5105 [564290] Osečná"
    },
    {
        "kod": 545953,
        "nazev": "Paceřice",
        "popis": "[545953] Paceřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 545953,
        "val": "[545953] Pacerice 5109 [545953] Paceřice"
    },
    {
        "kod": 564303,
        "nazev": "Pěnčín",
        "popis": "[564303] Pěnčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564303,
        "val": "[564303] Pencin 5109 [564303] Pěnčín"
    },
    {
        "kod": 564311,
        "nazev": "Pertoltice",
        "popis": "[564311] Pertoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564311,
        "val": "[564311] Pertoltice 5102 [564311] Pertoltice"
    },
    {
        "kod": 544345,
        "nazev": "Proseč pod Ještědem",
        "popis": "[544345] Proseč pod Ještědem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 544345,
        "val": "[544345] Prosec pod Jestedem 5105 [544345] Proseč pod Ještědem"
    },
    {
        "kod": 564354,
        "nazev": "Příšovice",
        "popis": "[564354] Příšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564354,
        "val": "[564354] Prisovice 5109 [564354] Příšovice"
    },
    {
        "kod": 544582,
        "nazev": "Radimovice",
        "popis": "[544582] Radimovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 544582,
        "val": "[544582] Radimovice 5109 [544582] Radimovice"
    },
    {
        "kod": 564371,
        "nazev": "Raspenava",
        "popis": "[564371] Raspenava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564371,
        "val": "[564371] Raspenava 5102 [564371] Raspenava"
    },
    {
        "kod": 564397,
        "nazev": "Rynoltice",
        "popis": "[564397] Rynoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564397,
        "val": "[564397] Rynoltice 5105 [564397] Rynoltice"
    },
    {
        "kod": 564401,
        "nazev": "Soběslavice",
        "popis": "[564401] Soběslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564401,
        "val": "[564401] Sobeslavice 5109 [564401] Soběslavice"
    },
    {
        "kod": 544477,
        "nazev": "Stráž nad Nisou",
        "popis": "[544477] Stráž nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 544477,
        "val": "[544477] Straz nad Nisou 5105 [544477] Stráž nad Nisou"
    },
    {
        "kod": 564427,
        "nazev": "Světlá pod Ještědem",
        "popis": "[564427] Světlá pod Ještědem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564427,
        "val": "[564427] Svetla pod Jestedem 5105 [564427] Světlá pod Ještědem"
    },
    {
        "kod": 564435,
        "nazev": "Svijanský Újezd",
        "popis": "[564435] Svijanský Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564435,
        "val": "[564435] Svijansky Ujezd 5109 [564435] Svijanský Újezd"
    },
    {
        "kod": 564443,
        "nazev": "Svijany",
        "popis": "[564443] Svijany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564443,
        "val": "[564443] Svijany 5109 [564443] Svijany"
    },
    {
        "kod": 564451,
        "nazev": "Sychrov",
        "popis": "[564451] Sychrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564451,
        "val": "[564451] Sychrov 5109 [564451] Sychrov"
    },
    {
        "kod": 564460,
        "nazev": "Šimonovice",
        "popis": "[564460] Šimonovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564460,
        "val": "[564460] Simonovice 5105 [564460] Šimonovice"
    },
    {
        "kod": 564494,
        "nazev": "Višňová",
        "popis": "[564494] Višňová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5102,
        "iczuj": 564494,
        "val": "[564494] Visnova 5102 [564494] Višňová"
    },
    {
        "kod": 564516,
        "nazev": "Vlastibořice",
        "popis": "[564516] Vlastibořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 564516,
        "val": "[564516] Vlastiborice 5109 [564516] Vlastibořice"
    },
    {
        "kod": 564532,
        "nazev": "Všelibice",
        "popis": "[564532] Všelibice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564532,
        "val": "[564532] Vselibice 5105 [564532] Všelibice"
    },
    {
        "kod": 564541,
        "nazev": "Zdislava",
        "popis": "[564541] Zdislava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 564541,
        "val": "[564541] Zdislava 5105 [564541] Zdislava"
    },
    {
        "kod": 544604,
        "nazev": "Žďárek",
        "popis": "[544604] Žďárek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 544604,
        "val": "[544604] Zdarek 5109 [544604] Žďárek"
    },
    {
        "kod": 576972,
        "nazev": "Bělá",
        "popis": "[576972] Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 576972,
        "val": "[576972] Bela 5107 [576972] Bělá"
    },
    {
        "kod": 576981,
        "nazev": "Benecko",
        "popis": "[576981] Benecko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 576981,
        "val": "[576981] Benecko 5104 [576981] Benecko"
    },
    {
        "kod": 576999,
        "nazev": "Benešov u Semil",
        "popis": "[576999] Benešov u Semil",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 576999,
        "val": "[576999] Benesov u Semil 5107 [576999] Benešov u Semil"
    },
    {
        "kod": 577006,
        "nazev": "Bozkov",
        "popis": "[577006] Bozkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577006,
        "val": "[577006] Bozkov 5107 [577006] Bozkov"
    },
    {
        "kod": 577014,
        "nazev": "Bradlecká Lhota",
        "popis": "[577014] Bradlecká Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577014,
        "val": "[577014] Bradlecka Lhota 5107 [577014] Bradlecká Lhota"
    },
    {
        "kod": 577031,
        "nazev": "Bukovina u Čisté",
        "popis": "[577031] Bukovina u Čisté",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577031,
        "val": "[577031] Bukovina u Ciste 5104 [577031] Bukovina u Čisté"
    },
    {
        "kod": 577049,
        "nazev": "Bystrá nad Jizerou",
        "popis": "[577049] Bystrá nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577049,
        "val": "[577049] Bystra nad Jizerou 5107 [577049] Bystrá nad Jizerou"
    },
    {
        "kod": 577057,
        "nazev": "Čistá u Horek",
        "popis": "[577057] Čistá u Horek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577057,
        "val": "[577057] Cista u Horek 5104 [577057] Čistá u Horek"
    },
    {
        "kod": 577073,
        "nazev": "Háje nad Jizerou",
        "popis": "[577073] Háje nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577073,
        "val": "[577073] Haje nad Jizerou 5107 [577073] Háje nad Jizerou"
    },
    {
        "kod": 577081,
        "nazev": "Harrachov",
        "popis": "[577081] Harrachov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5108,
        "iczuj": 577081,
        "val": "[577081] Harrachov 5108 [577081] Harrachov"
    },
    {
        "kod": 577111,
        "nazev": "Holenice",
        "popis": "[577111] Holenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577111,
        "val": "[577111] Holenice 5109 [577111] Holenice"
    },
    {
        "kod": 574201,
        "nazev": "Horka u Staré Paky",
        "popis": "[574201] Horka u Staré Paky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 574201,
        "val": "[574201] Horka u Stare Paky 5104 [574201] Horka u Staré Paky"
    },
    {
        "kod": 577120,
        "nazev": "Horní Branná",
        "popis": "[577120] Horní Branná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577120,
        "val": "[577120] Horni Branna 5104 [577120] Horní Branná"
    },
    {
        "kod": 577146,
        "nazev": "Hrubá Skála",
        "popis": "[577146] Hrubá Skála",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577146,
        "val": "[577146] Hruba Skala 5109 [577146] Hrubá Skála"
    },
    {
        "kod": 577154,
        "nazev": "Chuchelna",
        "popis": "[577154] Chuchelna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577154,
        "val": "[577154] Chuchelna 5107 [577154] Chuchelna"
    },
    {
        "kod": 577162,
        "nazev": "Jablonec nad Jizerou",
        "popis": "[577162] Jablonec nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577162,
        "val": "[577162] Jablonec nad Jizerou 5104 [577162] Jablonec nad Jizerou"
    },
    {
        "kod": 577171,
        "nazev": "Jesenný",
        "popis": "[577171] Jesenný",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577171,
        "val": "[577171] Jesenny 5107 [577171] Jesenný"
    },
    {
        "kod": 577189,
        "nazev": "Jestřabí v Krkonoších",
        "popis": "[577189] Jestřabí v Krkonoších",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577189,
        "val": "[577189] Jestrabi v Krkonosich 5104 [577189] Jestřabí v Krkonoších"
    },
    {
        "kod": 577197,
        "nazev": "Jilemnice",
        "popis": "[577197] Jilemnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577197,
        "val": "[577197] Jilemnice 5104 [577197] Jilemnice"
    },
    {
        "kod": 577201,
        "nazev": "Kacanovy",
        "popis": "[577201] Kacanovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577201,
        "val": "[577201] Kacanovy 5109 [577201] Kacanovy"
    },
    {
        "kod": 577219,
        "nazev": "Karlovice",
        "popis": "[577219] Karlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577219,
        "val": "[577219] Karlovice 5109 [577219] Karlovice"
    },
    {
        "kod": 577227,
        "nazev": "Klokočí",
        "popis": "[577227] Klokočí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577227,
        "val": "[577227] Klokoci 5109 [577227] Klokočí"
    },
    {
        "kod": 577235,
        "nazev": "Košťálov",
        "popis": "[577235] Košťálov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577235,
        "val": "[577235] Kostalov 5107 [577235] Košťálov"
    },
    {
        "kod": 577243,
        "nazev": "Kruh",
        "popis": "[577243] Kruh",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577243,
        "val": "[577243] Kruh 5104 [577243] Kruh"
    },
    {
        "kod": 547484,
        "nazev": "Ktová",
        "popis": "[547484] Ktová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 547484,
        "val": "[547484] Ktova 5109 [547484] Ktová"
    },
    {
        "kod": 577375,
        "nazev": "Levínská Olešnice",
        "popis": "[577375] Levínská Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577375,
        "val": "[577375] Levinska Olesnice 5104 [577375] Levínská Olešnice"
    },
    {
        "kod": 577294,
        "nazev": "Libštát",
        "popis": "[577294] Libštát",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577294,
        "val": "[577294] Libstat 5107 [577294] Libštát"
    },
    {
        "kod": 577308,
        "nazev": "Lomnice nad Popelkou",
        "popis": "[577308] Lomnice nad Popelkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577308,
        "val": "[577308] Lomnice nad Popelkou 5107 [577308] Lomnice nad Popelkou"
    },
    {
        "kod": 573400,
        "nazev": "Loučky",
        "popis": "[573400] Loučky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 573400,
        "val": "[573400] Loucky 5109 [573400] Loučky"
    },
    {
        "kod": 573418,
        "nazev": "Martinice v Krkonoších",
        "popis": "[573418] Martinice v Krkonoších",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 573418,
        "val": "[573418] Martinice v Krkonosich 5104 [573418] Martinice v Krkonoších"
    },
    {
        "kod": 577316,
        "nazev": "Mírová pod Kozákovem",
        "popis": "[577316] Mírová pod Kozákovem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577316,
        "val": "[577316] Mirova pod Kozakovem 5109 [577316] Mírová pod Kozákovem"
    },
    {
        "kod": 577324,
        "nazev": "Modřišice",
        "popis": "[577324] Modřišice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577324,
        "val": "[577324] Modrisice 5109 [577324] Modřišice"
    },
    {
        "kod": 577332,
        "nazev": "Mříčná",
        "popis": "[577332] Mříčná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577332,
        "val": "[577332] Mricna 5104 [577332] Mříčná"
    },
    {
        "kod": 577341,
        "nazev": "Nová Ves nad Popelkou",
        "popis": "[577341] Nová Ves nad Popelkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577341,
        "val": "[577341] Nova Ves nad Popelkou 5107 [577341] Nová Ves nad Popelkou"
    },
    {
        "kod": 577359,
        "nazev": "Ohrazenice",
        "popis": "[577359] Ohrazenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577359,
        "val": "[577359] Ohrazenice 5109 [577359] Ohrazenice"
    },
    {
        "kod": 577367,
        "nazev": "Olešnice",
        "popis": "[577367] Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577367,
        "val": "[577367] Olesnice 5109 [577367] Olešnice"
    },
    {
        "kod": 547476,
        "nazev": "Paseky nad Jizerou",
        "popis": "[547476] Paseky nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 547476,
        "val": "[547476] Paseky nad Jizerou 5104 [547476] Paseky nad Jizerou"
    },
    {
        "kod": 577391,
        "nazev": "Peřimov",
        "popis": "[577391] Peřimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577391,
        "val": "[577391] Perimov 5104 [577391] Peřimov"
    },
    {
        "kod": 577405,
        "nazev": "Poniklá",
        "popis": "[577405] Poniklá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577405,
        "val": "[577405] Ponikla 5104 [577405] Poniklá"
    },
    {
        "kod": 577413,
        "nazev": "Přepeře",
        "popis": "[577413] Přepeře",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577413,
        "val": "[577413] Prepere 5109 [577413] Přepeře"
    },
    {
        "kod": 577421,
        "nazev": "Příkrý",
        "popis": "[577421] Příkrý",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577421,
        "val": "[577421] Prikry 5107 [577421] Příkrý"
    },
    {
        "kod": 577430,
        "nazev": "Radostná pod Kozákovem",
        "popis": "[577430] Radostná pod Kozákovem",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577430,
        "val": "[577430] Radostna pod Kozakovem 5109 [577430] Radostná pod Kozákovem"
    },
    {
        "kod": 577448,
        "nazev": "Rakousy",
        "popis": "[577448] Rakousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577448,
        "val": "[577448] Rakousy 5109 [577448] Rakousy"
    },
    {
        "kod": 577456,
        "nazev": "Rokytnice nad Jizerou",
        "popis": "[577456] Rokytnice nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577456,
        "val": "[577456] Rokytnice nad Jizerou 5104 [577456] Rokytnice nad Jizerou"
    },
    {
        "kod": 577464,
        "nazev": "Roprachtice",
        "popis": "[577464] Roprachtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577464,
        "val": "[577464] Roprachtice 5107 [577464] Roprachtice"
    },
    {
        "kod": 577472,
        "nazev": "Rovensko pod Troskami",
        "popis": "[577472] Rovensko pod Troskami",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577472,
        "val": "[577472] Rovensko pod Troskami 5109 [577472] Rovensko pod Troskami"
    },
    {
        "kod": 577499,
        "nazev": "Roztoky u Jilemnice",
        "popis": "[577499] Roztoky u Jilemnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577499,
        "val": "[577499] Roztoky u Jilemnice 5104 [577499] Roztoky u Jilemnice"
    },
    {
        "kod": 577481,
        "nazev": "Roztoky u Semil",
        "popis": "[577481] Roztoky u Semil",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577481,
        "val": "[577481] Roztoky u Semil 5107 [577481] Roztoky u Semil"
    },
    {
        "kod": 576964,
        "nazev": "Semily",
        "popis": "[576964] Semily",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 576964,
        "val": "[576964] Semily 5107 [576964] Semily"
    },
    {
        "kod": 577529,
        "nazev": "Slaná",
        "popis": "[577529] Slaná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577529,
        "val": "[577529] Slana 5107 [577529] Slaná"
    },
    {
        "kod": 577545,
        "nazev": "Stružinec",
        "popis": "[577545] Stružinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577545,
        "val": "[577545] Struzinec 5107 [577545] Stružinec"
    },
    {
        "kod": 577553,
        "nazev": "Studenec",
        "popis": "[577553] Studenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577553,
        "val": "[577553] Studenec 5104 [577553] Studenec"
    },
    {
        "kod": 577561,
        "nazev": "Svojek",
        "popis": "[577561] Svojek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577561,
        "val": "[577561] Svojek 5104 [577561] Svojek"
    },
    {
        "kod": 577570,
        "nazev": "Syřenov",
        "popis": "[577570] Syřenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577570,
        "val": "[577570] Syrenov 5107 [577570] Syřenov"
    },
    {
        "kod": 577596,
        "nazev": "Tatobity",
        "popis": "[577596] Tatobity",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577596,
        "val": "[577596] Tatobity 5109 [577596] Tatobity"
    },
    {
        "kod": 577600,
        "nazev": "Troskovice",
        "popis": "[577600] Troskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577600,
        "val": "[577600] Troskovice 5109 [577600] Troskovice"
    },
    {
        "kod": 577626,
        "nazev": "Turnov",
        "popis": "[577626] Turnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577626,
        "val": "[577626] Turnov 5109 [577626] Turnov"
    },
    {
        "kod": 577642,
        "nazev": "Veselá",
        "popis": "[577642] Veselá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577642,
        "val": "[577642] Vesela 5107 [577642] Veselá"
    },
    {
        "kod": 577651,
        "nazev": "Víchová nad Jizerou",
        "popis": "[577651] Víchová nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577651,
        "val": "[577651] Vichova nad Jizerou 5104 [577651] Víchová nad Jizerou"
    },
    {
        "kod": 577669,
        "nazev": "Vítkovice",
        "popis": "[577669] Vítkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5104,
        "iczuj": 577669,
        "val": "[577669] Vitkovice 5104 [577669] Vítkovice"
    },
    {
        "kod": 577677,
        "nazev": "Všeň",
        "popis": "[577677] Všeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577677,
        "val": "[577677] Vsen 5109 [577677] Všeň"
    },
    {
        "kod": 577685,
        "nazev": "Vyskeř",
        "popis": "[577685] Vyskeř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577685,
        "val": "[577685] Vysker 5109 [577685] Vyskeř"
    },
    {
        "kod": 577693,
        "nazev": "Vysoké nad Jizerou",
        "popis": "[577693] Vysoké nad Jizerou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577693,
        "val": "[577693] Vysoke nad Jizerou 5107 [577693] Vysoké nad Jizerou"
    },
    {
        "kod": 577707,
        "nazev": "Záhoří",
        "popis": "[577707] Záhoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 5107,
        "iczuj": 577707,
        "val": "[577707] Zahori 5107 [577707] Záhoří"
    },
    {
        "kod": 577723,
        "nazev": "Žernov",
        "popis": "[577723] Žernov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5109,
        "iczuj": 577723,
        "val": "[577723] Zernov 5109 [577723] Žernov"
    },
    {
        "kod": 569828,
        "nazev": "Babice",
        "popis": "[569828] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 569828,
        "val": "[569828] Babice 5212 [569828] Babice"
    },
    {
        "kod": 569836,
        "nazev": "Barchov",
        "popis": "[569836] Barchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 569836,
        "val": "[569836] Barchov 5212 [569836] Barchov"
    },
    {
        "kod": 569852,
        "nazev": "Běleč nad Orlicí",
        "popis": "[569852] Běleč nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569852,
        "val": "[569852] Belec nad Orlici 5205 [569852] Běleč nad Orlicí"
    },
    {
        "kod": 569861,
        "nazev": "Benátky",
        "popis": "[569861] Benátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569861,
        "val": "[569861] Benatky 5205 [569861] Benátky"
    },
    {
        "kod": 569879,
        "nazev": "Blešno",
        "popis": "[569879] Blešno",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569879,
        "val": "[569879] Blesno 5205 [569879] Blešno"
    },
    {
        "kod": 569887,
        "nazev": "Boharyně",
        "popis": "[569887] Boharyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569887,
        "val": "[569887] Boharyne 5205 [569887] Boharyně"
    },
    {
        "kod": 569917,
        "nazev": "Černilov",
        "popis": "[569917] Černilov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569917,
        "val": "[569917] Cernilov 5205 [569917] Černilov"
    },
    {
        "kod": 569925,
        "nazev": "Černožice",
        "popis": "[569925] Černožice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569925,
        "val": "[569925] Cernozice 5205 [569925] Černožice"
    },
    {
        "kod": 569933,
        "nazev": "Čistěves",
        "popis": "[569933] Čistěves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569933,
        "val": "[569933] Cisteves 5205 [569933] Čistěves"
    },
    {
        "kod": 569941,
        "nazev": "Divec",
        "popis": "[569941] Divec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569941,
        "val": "[569941] Divec 5205 [569941] Divec"
    },
    {
        "kod": 569968,
        "nazev": "Dobřenice",
        "popis": "[569968] Dobřenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569968,
        "val": "[569968] Dobrenice 5205 [569968] Dobřenice"
    },
    {
        "kod": 569976,
        "nazev": "Dohalice",
        "popis": "[569976] Dohalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569976,
        "val": "[569976] Dohalice 5205 [569976] Dohalice"
    },
    {
        "kod": 569984,
        "nazev": "Dolní Přím",
        "popis": "[569984] Dolní Přím",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569984,
        "val": "[569984] Dolni Prim 5205 [569984] Dolní Přím"
    },
    {
        "kod": 569992,
        "nazev": "Habřina",
        "popis": "[569992] Habřina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569992,
        "val": "[569992] Habrina 5205 [569992] Habřina"
    },
    {
        "kod": 570001,
        "nazev": "Hlušice",
        "popis": "[570001] Hlušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570001,
        "val": "[570001] Hlusice 5212 [570001] Hlušice"
    },
    {
        "kod": 570010,
        "nazev": "Hněvčeves",
        "popis": "[570010] Hněvčeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570010,
        "val": "[570010] Hnevceves 5205 [570010] Hněvčeves"
    },
    {
        "kod": 570028,
        "nazev": "Holohlavy",
        "popis": "[570028] Holohlavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570028,
        "val": "[570028] Holohlavy 5205 [570028] Holohlavy"
    },
    {
        "kod": 570044,
        "nazev": "Hořiněves",
        "popis": "[570044] Hořiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570044,
        "val": "[570044] Horineves 5205 [570044] Hořiněves"
    },
    {
        "kod": 569810,
        "nazev": "Hradec Králové",
        "popis": "[569810] Hradec Králové",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 569810,
        "val": "[569810] Hradec Kralove 5205 [569810] Hradec Králové"
    },
    {
        "kod": 570052,
        "nazev": "Hrádek",
        "popis": "[570052] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570052,
        "val": "[570052] Hradek 5205 [570052] Hrádek"
    },
    {
        "kod": 570087,
        "nazev": "Humburky",
        "popis": "[570087] Humburky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570087,
        "val": "[570087] Humburky 5212 [570087] Humburky"
    },
    {
        "kod": 573621,
        "nazev": "Hvozdnice",
        "popis": "[573621] Hvozdnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 573621,
        "val": "[573621] Hvozdnice 5205 [573621] Hvozdnice"
    },
    {
        "kod": 570109,
        "nazev": "Chlumec nad Cidlinou",
        "popis": "[570109] Chlumec nad Cidlinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570109,
        "val": "[570109] Chlumec nad Cidlinou 5205 [570109] Chlumec nad Cidlinou"
    },
    {
        "kod": 570125,
        "nazev": "Chudeřice",
        "popis": "[570125] Chudeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570125,
        "val": "[570125] Chuderice 5205 [570125] Chudeřice"
    },
    {
        "kod": 570133,
        "nazev": "Jeníkovice",
        "popis": "[570133] Jeníkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570133,
        "val": "[570133] Jenikovice 5205 [570133] Jeníkovice"
    },
    {
        "kod": 576352,
        "nazev": "Jílovice",
        "popis": "[576352] Jílovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 576352,
        "val": "[576352] Jilovice 5205 [576352] Jílovice"
    },
    {
        "kod": 570150,
        "nazev": "Káranice",
        "popis": "[570150] Káranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570150,
        "val": "[570150] Karanice 5205 [570150] Káranice"
    },
    {
        "kod": 570168,
        "nazev": "Klamoš",
        "popis": "[570168] Klamoš",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570168,
        "val": "[570168] Klamos 5205 [570168] Klamoš"
    },
    {
        "kod": 573710,
        "nazev": "Kobylice",
        "popis": "[573710] Kobylice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 573710,
        "val": "[573710] Kobylice 5212 [573710] Kobylice"
    },
    {
        "kod": 570176,
        "nazev": "Kosice",
        "popis": "[570176] Kosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570176,
        "val": "[570176] Kosice 5205 [570176] Kosice"
    },
    {
        "kod": 570184,
        "nazev": "Kosičky",
        "popis": "[570184] Kosičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570184,
        "val": "[570184] Kosicky 5205 [570184] Kosičky"
    },
    {
        "kod": 570192,
        "nazev": "Králíky",
        "popis": "[570192] Králíky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570192,
        "val": "[570192] Kraliky 5212 [570192] Králíky"
    },
    {
        "kod": 570206,
        "nazev": "Kratonohy",
        "popis": "[570206] Kratonohy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570206,
        "val": "[570206] Kratonohy 5205 [570206] Kratonohy"
    },
    {
        "kod": 570214,
        "nazev": "Kunčice",
        "popis": "[570214] Kunčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570214,
        "val": "[570214] Kuncice 5205 [570214] Kunčice"
    },
    {
        "kod": 576433,
        "nazev": "Ledce",
        "popis": "[576433] Ledce",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 576433,
        "val": "[576433] Ledce 5205 [576433] Ledce"
    },
    {
        "kod": 570222,
        "nazev": "Lejšovka",
        "popis": "[570222] Lejšovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570222,
        "val": "[570222] Lejsovka 5205 [570222] Lejšovka"
    },
    {
        "kod": 570231,
        "nazev": "Lhota pod Libčany",
        "popis": "[570231] Lhota pod Libčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570231,
        "val": "[570231] Lhota pod Libcany 5205 [570231] Lhota pod Libčany"
    },
    {
        "kod": 570249,
        "nazev": "Libčany",
        "popis": "[570249] Libčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570249,
        "val": "[570249] Libcany 5205 [570249] Libčany"
    },
    {
        "kod": 570257,
        "nazev": "Libníkovice",
        "popis": "[570257] Libníkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570257,
        "val": "[570257] Libnikovice 5205 [570257] Libníkovice"
    },
    {
        "kod": 570265,
        "nazev": "Librantice",
        "popis": "[570265] Librantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570265,
        "val": "[570265] Librantice 5205 [570265] Librantice"
    },
    {
        "kod": 570273,
        "nazev": "Libřice",
        "popis": "[570273] Libřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570273,
        "val": "[570273] Librice 5205 [570273] Libřice"
    },
    {
        "kod": 570290,
        "nazev": "Lišice",
        "popis": "[570290] Lišice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570290,
        "val": "[570290] Lisice 5205 [570290] Lišice"
    },
    {
        "kod": 570303,
        "nazev": "Lodín",
        "popis": "[570303] Lodín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570303,
        "val": "[570303] Lodin 5205 [570303] Lodín"
    },
    {
        "kod": 570311,
        "nazev": "Lochenice",
        "popis": "[570311] Lochenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570311,
        "val": "[570311] Lochenice 5205 [570311] Lochenice"
    },
    {
        "kod": 570320,
        "nazev": "Lovčice",
        "popis": "[570320] Lovčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570320,
        "val": "[570320] Lovcice 5205 [570320] Lovčice"
    },
    {
        "kod": 570354,
        "nazev": "Lužany",
        "popis": "[570354] Lužany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570354,
        "val": "[570354] Luzany 5205 [570354] Lužany"
    },
    {
        "kod": 570362,
        "nazev": "Lužec nad Cidlinou",
        "popis": "[570362] Lužec nad Cidlinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570362,
        "val": "[570362] Luzec nad Cidlinou 5212 [570362] Lužec nad Cidlinou"
    },
    {
        "kod": 573779,
        "nazev": "Máslojedy",
        "popis": "[573779] Máslojedy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 573779,
        "val": "[573779] Maslojedy 5205 [573779] Máslojedy"
    },
    {
        "kod": 570397,
        "nazev": "Měník",
        "popis": "[570397] Měník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570397,
        "val": "[570397] Menik 5212 [570397] Měník"
    },
    {
        "kod": 570401,
        "nazev": "Mlékosrby",
        "popis": "[570401] Mlékosrby",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570401,
        "val": "[570401] Mlekosrby 5212 [570401] Mlékosrby"
    },
    {
        "kod": 570419,
        "nazev": "Mokrovousy",
        "popis": "[570419] Mokrovousy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5205,
        "iczuj": 570419,
        "val": "[570419] Mokrovousy 5205 [570419] Mokrovousy"
    },
    {
        "kod": 570427,
        "nazev": "Myštěves",
        "popis": "[570427] Myštěves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5212,
        "iczuj": 570427,
        "val": "[570427] Mysteves 5212 [570427] Myštěves"
    },
    {
        "kod": 573507,
        "nazev": "Stará Paka",
        "popis": "[573507] Stará Paka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5210,
        "iczuj": 573507,
        "val": "[573507] Stara Paka 5210 [573507] Stará Paka"
    },
    {
        "kod": 530735,
        "nazev": "Staré Hrady",
        "popis": "[530735] Staré Hrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 530735,
        "val": "[530735] Stare Hrady 5207 [530735] Staré Hrady"
    },
    {
        "kod": 549096,
        "nazev": "Staré Místo",
        "popis": "[549096] Staré Místo",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549096,
        "val": "[549096] Stare Misto 5207 [549096] Staré Místo"
    },
    {
        "kod": 573523,
        "nazev": "Staré Smrkovice",
        "popis": "[573523] Staré Smrkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573523,
        "val": "[573523] Stare Smrkovice 5204 [573523] Staré Smrkovice"
    },
    {
        "kod": 573540,
        "nazev": "Střevač",
        "popis": "[573540] Střevač",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573540,
        "val": "[573540] Strevac 5207 [573540] Střevač"
    },
    {
        "kod": 548880,
        "nazev": "Sukorady",
        "popis": "[548880] Sukorady",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 548880,
        "val": "[548880] Sukorady 5204 [548880] Sukorady"
    },
    {
        "kod": 573302,
        "nazev": "Svatojanský Újezd",
        "popis": "[573302] Svatojanský Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573302,
        "val": "[573302] Svatojansky Ujezd 5207 [573302] Svatojanský Újezd"
    },
    {
        "kod": 573256,
        "nazev": "Šárovcova Lhota",
        "popis": "[573256] Šárovcova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573256,
        "val": "[573256] Sarovcova Lhota 5207 [573256] Šárovcova Lhota"
    },
    {
        "kod": 572756,
        "nazev": "Tetín",
        "popis": "[572756] Tetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 572756,
        "val": "[572756] Tetin 5204 [572756] Tetín"
    },
    {
        "kod": 573612,
        "nazev": "Třebnouševes",
        "popis": "[573612] Třebnouševes",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573612,
        "val": "[573612] Trebnouseves 5204 [573612] Třebnouševes"
    },
    {
        "kod": 573639,
        "nazev": "Třtěnice",
        "popis": "[573639] Třtěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573639,
        "val": "[573639] Trtenice 5207 [573639] Třtěnice"
    },
    {
        "kod": 573647,
        "nazev": "Tuř",
        "popis": "[573647] Tuř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573647,
        "val": "[573647] Tur 5207 [573647] Tuř"
    },
    {
        "kod": 573655,
        "nazev": "Úbislavice",
        "popis": "[573655] Úbislavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5210,
        "iczuj": 573655,
        "val": "[573655] Ubislavice 5210 [573655] Úbislavice"
    },
    {
        "kod": 573663,
        "nazev": "Údrnice",
        "popis": "[573663] Údrnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573663,
        "val": "[573663] Udrnice 5207 [573663] Údrnice"
    },
    {
        "kod": 573671,
        "nazev": "Úhlejov",
        "popis": "[573671] Úhlejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 573671,
        "val": "[573671] Uhlejov 5204 [573671] Úhlejov"
    },
    {
        "kod": 573680,
        "nazev": "Újezd pod Troskami",
        "popis": "[573680] Újezd pod Troskami",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573680,
        "val": "[573680] Ujezd pod Troskami 5207 [573680] Újezd pod Troskami"
    },
    {
        "kod": 573698,
        "nazev": "Úlibice",
        "popis": "[573698] Úlibice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573698,
        "val": "[573698] Ulibice 5207 [573698] Úlibice"
    },
    {
        "kod": 573701,
        "nazev": "Valdice",
        "popis": "[573701] Valdice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573701,
        "val": "[573701] Valdice 5207 [573701] Valdice"
    },
    {
        "kod": 573728,
        "nazev": "Veliš",
        "popis": "[573728] Veliš",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573728,
        "val": "[573728] Velis 5207 [573728] Veliš"
    },
    {
        "kod": 573736,
        "nazev": "Vidochov",
        "popis": "[573736] Vidochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5210,
        "iczuj": 573736,
        "val": "[573736] Vidochov 5210 [573736] Vidochov"
    },
    {
        "kod": 573752,
        "nazev": "Vitiněves",
        "popis": "[573752] Vitiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573752,
        "val": "[573752] Vitineves 5207 [573752] Vitiněves"
    },
    {
        "kod": 573761,
        "nazev": "Volanice",
        "popis": "[573761] Volanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573761,
        "val": "[573761] Volanice 5207 [573761] Volanice"
    },
    {
        "kod": 572128,
        "nazev": "Vrbice",
        "popis": "[572128] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 572128,
        "val": "[572128] Vrbice 5207 [572128] Vrbice"
    },
    {
        "kod": 573795,
        "nazev": "Vršce",
        "popis": "[573795] Vršce",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573795,
        "val": "[573795] Vrsce 5207 [573795] Vršce"
    },
    {
        "kod": 549029,
        "nazev": "Vřesník",
        "popis": "[549029] Vřesník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5204,
        "iczuj": 549029,
        "val": "[549029] Vresnik 5204 [549029] Vřesník"
    },
    {
        "kod": 573809,
        "nazev": "Vysoké Veselí",
        "popis": "[573809] Vysoké Veselí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573809,
        "val": "[573809] Vysoke Veseli 5207 [573809] Vysoké Veselí"
    },
    {
        "kod": 549193,
        "nazev": "Zámostí-Blata",
        "popis": "[549193] Zámostí-Blata",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 549193,
        "val": "[549193] Zamosti-Blata 5207 [549193] Zámostí-Blata"
    },
    {
        "kod": 573183,
        "nazev": "Zelenecká Lhota",
        "popis": "[573183] Zelenecká Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573183,
        "val": "[573183] Zelenecka Lhota 5207 [573183] Zelenecká Lhota"
    },
    {
        "kod": 573825,
        "nazev": "Železnice",
        "popis": "[573825] Železnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573825,
        "val": "[573825] Zeleznice 5207 [573825] Železnice"
    },
    {
        "kod": 573833,
        "nazev": "Žeretice",
        "popis": "[573833] Žeretice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573833,
        "val": "[573833] Zeretice 5207 [573833] Žeretice"
    },
    {
        "kod": 573841,
        "nazev": "Židovice",
        "popis": "[573841] Židovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573841,
        "val": "[573841] Zidovice 5207 [573841] Židovice"
    },
    {
        "kod": 573850,
        "nazev": "Žlunice",
        "popis": "[573850] Žlunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5207,
        "iczuj": 573850,
        "val": "[573850] Zlunice 5207 [573850] Žlunice"
    },
    {
        "kod": 547786,
        "nazev": "Adršpach",
        "popis": "[547786] Adršpach",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 547786,
        "val": "[547786] Adrspach 5201 [547786] Adršpach"
    },
    {
        "kod": 573884,
        "nazev": "Bezděkov nad Metují",
        "popis": "[573884] Bezděkov nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573884,
        "val": "[573884] Bezdekov nad Metuji 5209 [573884] Bezděkov nad Metují"
    },
    {
        "kod": 573892,
        "nazev": "Bohuslavice",
        "popis": "[573892] Bohuslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 573892,
        "val": "[573892] Bohuslavice 5211 [573892] Bohuslavice"
    },
    {
        "kod": 573906,
        "nazev": "Borová",
        "popis": "[573906] Borová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573906,
        "val": "[573906] Borova 5209 [573906] Borová"
    },
    {
        "kod": 573914,
        "nazev": "Božanov",
        "popis": "[573914] Božanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 573914,
        "val": "[573914] Bozanov 5201 [573914] Božanov"
    },
    {
        "kod": 573922,
        "nazev": "Broumov",
        "popis": "[573922] Broumov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 573922,
        "val": "[573922] Broumov 5201 [573922] Broumov"
    },
    {
        "kod": 573931,
        "nazev": "Brzice",
        "popis": "[573931] Brzice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573931,
        "val": "[573931] Brzice 5209 [573931] Brzice"
    },
    {
        "kod": 547751,
        "nazev": "Bukovice",
        "popis": "[547751] Bukovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 547751,
        "val": "[547751] Bukovice 5209 [547751] Bukovice"
    },
    {
        "kod": 573957,
        "nazev": "Černčice",
        "popis": "[573957] Černčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 573957,
        "val": "[573957] Cerncice 5211 [573957] Černčice"
    },
    {
        "kod": 505099,
        "nazev": "Červená Hora",
        "popis": "[505099] Červená Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 505099,
        "val": "[505099] Cervena Hora 5209 [505099] Červená Hora"
    },
    {
        "kod": 573965,
        "nazev": "Červený Kostelec",
        "popis": "[573965] Červený Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573965,
        "val": "[573965] Cerveny Kostelec 5209 [573965] Červený Kostelec"
    },
    {
        "kod": 573973,
        "nazev": "Česká Čermná",
        "popis": "[573973] Česká Čermná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573973,
        "val": "[573973] Ceska Cermna 5209 [573973] Česká Čermná"
    },
    {
        "kod": 573981,
        "nazev": "Česká Metuje",
        "popis": "[573981] Česká Metuje",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573981,
        "val": "[573981] Ceska Metuje 5209 [573981] Česká Metuje"
    },
    {
        "kod": 573990,
        "nazev": "Česká Skalice",
        "popis": "[573990] Česká Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573990,
        "val": "[573990] Ceska Skalice 5209 [573990] Česká Skalice"
    },
    {
        "kod": 574015,
        "nazev": "Dolany",
        "popis": "[574015] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574015,
        "val": "[574015] Dolany 5206 [574015] Dolany"
    },
    {
        "kod": 574023,
        "nazev": "Dolní Radechová",
        "popis": "[574023] Dolní Radechová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574023,
        "val": "[574023] Dolni Radechova 5209 [574023] Dolní Radechová"
    },
    {
        "kod": 574031,
        "nazev": "Hejtmánkovice",
        "popis": "[574031] Hejtmánkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574031,
        "val": "[574031] Hejtmankovice 5201 [574031] Hejtmánkovice"
    },
    {
        "kod": 574040,
        "nazev": "Heřmanice",
        "popis": "[574040] Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574040,
        "val": "[574040] Hermanice 5206 [574040] Heřmanice"
    },
    {
        "kod": 574058,
        "nazev": "Heřmánkovice",
        "popis": "[574058] Heřmánkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574058,
        "val": "[574058] Hermankovice 5201 [574058] Heřmánkovice"
    },
    {
        "kod": 574066,
        "nazev": "Horní Radechová",
        "popis": "[574066] Horní Radechová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574066,
        "val": "[574066] Horni Radechova 5209 [574066] Horní Radechová"
    },
    {
        "kod": 547531,
        "nazev": "Hořenice",
        "popis": "[547531] Hořenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 547531,
        "val": "[547531] Horenice 5206 [547531] Hořenice"
    },
    {
        "kod": 574074,
        "nazev": "Hořičky",
        "popis": "[574074] Hořičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574074,
        "val": "[574074] Horicky 5209 [574074] Hořičky"
    },
    {
        "kod": 574082,
        "nazev": "Hronov",
        "popis": "[574082] Hronov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574082,
        "val": "[574082] Hronov 5209 [574082] Hronov"
    },
    {
        "kod": 574163,
        "nazev": "Hynčice",
        "popis": "[574163] Hynčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574163,
        "val": "[574163] Hyncice 5201 [574163] Hynčice"
    },
    {
        "kod": 574112,
        "nazev": "Chvalkovice",
        "popis": "[574112] Chvalkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574112,
        "val": "[574112] Chvalkovice 5206 [574112] Chvalkovice"
    },
    {
        "kod": 574121,
        "nazev": "Jaroměř",
        "popis": "[574121] Jaroměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574121,
        "val": "[574121] Jaromer 5206 [574121] Jaroměř"
    },
    {
        "kod": 574139,
        "nazev": "Jasenná",
        "popis": "[574139] Jasenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574139,
        "val": "[574139] Jasenna 5206 [574139] Jasenná"
    },
    {
        "kod": 574147,
        "nazev": "Jestřebí",
        "popis": "[574147] Jestřebí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574147,
        "val": "[574147] Jestrebi 5211 [574147] Jestřebí"
    },
    {
        "kod": 574155,
        "nazev": "Jetřichov",
        "popis": "[574155] Jetřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574155,
        "val": "[574155] Jetrichov 5201 [574155] Jetřichov"
    },
    {
        "kod": 574546,
        "nazev": "Kramolna",
        "popis": "[574546] Kramolna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574546,
        "val": "[574546] Kramolna 5209 [574546] Kramolna"
    },
    {
        "kod": 574171,
        "nazev": "Křinice",
        "popis": "[574171] Křinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574171,
        "val": "[574171] Krinice 5201 [574171] Křinice"
    },
    {
        "kod": 574180,
        "nazev": "Lhota pod Hořičkami",
        "popis": "[574180] Lhota pod Hořičkami",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574180,
        "val": "[574180] Lhota pod Horickami 5209 [574180] Lhota pod Hořičkami"
    },
    {
        "kod": 547701,
        "nazev": "Libchyně",
        "popis": "[547701] Libchyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 547701,
        "val": "[547701] Libchyne 5211 [547701] Libchyně"
    },
    {
        "kod": 573388,
        "nazev": "Litoboř",
        "popis": "[573388] Litoboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573388,
        "val": "[573388] Litobor 5209 [573388] Litoboř"
    },
    {
        "kod": 574210,
        "nazev": "Machov",
        "popis": "[574210] Machov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574210,
        "val": "[574210] Machov 5209 [574210] Machov"
    },
    {
        "kod": 574228,
        "nazev": "Martínkovice",
        "popis": "[574228] Martínkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574228,
        "val": "[574228] Martinkovice 5201 [574228] Martínkovice"
    },
    {
        "kod": 574236,
        "nazev": "Mezilečí",
        "popis": "[574236] Mezilečí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574236,
        "val": "[574236] Mezileci 5209 [574236] Mezilečí"
    },
    {
        "kod": 574244,
        "nazev": "Mezilesí",
        "popis": "[574244] Mezilesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574244,
        "val": "[574244] Mezilesi 5211 [574244] Mezilesí"
    },
    {
        "kod": 574252,
        "nazev": "Meziměstí",
        "popis": "[574252] Meziměstí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574252,
        "val": "[574252] Mezimesti 5201 [574252] Meziměstí"
    },
    {
        "kod": 574261,
        "nazev": "Nahořany",
        "popis": "[574261] Nahořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574261,
        "val": "[574261] Nahorany 5211 [574261] Nahořany"
    },
    {
        "kod": 573868,
        "nazev": "Náchod",
        "popis": "[573868] Náchod",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 573868,
        "val": "[573868] Nachod 5209 [573868] Náchod"
    },
    {
        "kod": 574279,
        "nazev": "Nové Město nad Metují",
        "popis": "[574279] Nové Město nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574279,
        "val": "[574279] Nove Mesto nad Metuji 5211 [574279] Nové Město nad Metují"
    },
    {
        "kod": 574287,
        "nazev": "Nový Hrádek",
        "popis": "[574287] Nový Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574287,
        "val": "[574287] Novy Hradek 5209 [574287] Nový Hrádek"
    },
    {
        "kod": 574295,
        "nazev": "Nový Ples",
        "popis": "[574295] Nový Ples",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574295,
        "val": "[574295] Novy Ples 5206 [574295] Nový Ples"
    },
    {
        "kod": 574317,
        "nazev": "Otovice",
        "popis": "[574317] Otovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574317,
        "val": "[574317] Otovice 5201 [574317] Otovice"
    },
    {
        "kod": 574341,
        "nazev": "Police nad Metují",
        "popis": "[574341] Police nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574341,
        "val": "[574341] Police nad Metuji 5209 [574341] Police nad Metují"
    },
    {
        "kod": 574350,
        "nazev": "Provodov-Šonov",
        "popis": "[574350] Provodov-Šonov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574350,
        "val": "[574350] Provodov-Sonov 5211 [574350] Provodov-Šonov"
    },
    {
        "kod": 574368,
        "nazev": "Přibyslav",
        "popis": "[574368] Přibyslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574368,
        "val": "[574368] Pribyslav 5211 [574368] Přibyslav"
    },
    {
        "kod": 574376,
        "nazev": "Rasošky",
        "popis": "[574376] Rasošky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574376,
        "val": "[574376] Rasosky 5206 [574376] Rasošky"
    },
    {
        "kod": 574384,
        "nazev": "Rožnov",
        "popis": "[574384] Rožnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574384,
        "val": "[574384] Roznov 5206 [574384] Rožnov"
    },
    {
        "kod": 574406,
        "nazev": "Rychnovek",
        "popis": "[574406] Rychnovek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574406,
        "val": "[574406] Rychnovek 5206 [574406] Rychnovek"
    },
    {
        "kod": 530786,
        "nazev": "Říkov",
        "popis": "[530786] Říkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 530786,
        "val": "[530786] Rikov 5209 [530786] Říkov"
    },
    {
        "kod": 547727,
        "nazev": "Sendraž",
        "popis": "[547727] Sendraž",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 547727,
        "val": "[547727] Sendraz 5211 [547727] Sendraž"
    },
    {
        "kod": 574422,
        "nazev": "Slatina nad Úpou",
        "popis": "[574422] Slatina nad Úpou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574422,
        "val": "[574422] Slatina nad Upou 5209 [574422] Slatina nad Úpou"
    },
    {
        "kod": 574431,
        "nazev": "Slavětín nad Metují",
        "popis": "[574431] Slavětín nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574431,
        "val": "[574431] Slavetin nad Metuji 5211 [574431] Slavětín nad Metují"
    },
    {
        "kod": 574457,
        "nazev": "Slavoňov",
        "popis": "[574457] Slavoňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574457,
        "val": "[574457] Slavonov 5211 [574457] Slavoňov"
    },
    {
        "kod": 574465,
        "nazev": "Stárkov",
        "popis": "[574465] Stárkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574465,
        "val": "[574465] Starkov 5209 [574465] Stárkov"
    },
    {
        "kod": 574481,
        "nazev": "Studnice",
        "popis": "[574481] Studnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574481,
        "val": "[574481] Studnice 5209 [574481] Studnice"
    },
    {
        "kod": 574490,
        "nazev": "Suchý Důl",
        "popis": "[574490] Suchý Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574490,
        "val": "[574490] Suchy Dul 5209 [574490] Suchý Důl"
    },
    {
        "kod": 547654,
        "nazev": "Šestajovice",
        "popis": "[547654] Šestajovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 547654,
        "val": "[547654] Sestajovice 5206 [547654] Šestajovice"
    },
    {
        "kod": 574511,
        "nazev": "Šonov",
        "popis": "[574511] Šonov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574511,
        "val": "[574511] Sonov 5201 [574511] Šonov"
    },
    {
        "kod": 574538,
        "nazev": "Teplice nad Metují",
        "popis": "[574538] Teplice nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 574538,
        "val": "[574538] Teplice nad Metuji 5201 [574538] Teplice nad Metují"
    },
    {
        "kod": 574554,
        "nazev": "Velichovky",
        "popis": "[574554] Velichovky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574554,
        "val": "[574554] Velichovky 5206 [574554] Velichovky"
    },
    {
        "kod": 574562,
        "nazev": "Velká Jesenice",
        "popis": "[574562] Velká Jesenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574562,
        "val": "[574562] Velka Jesenice 5209 [574562] Velká Jesenice"
    },
    {
        "kod": 574571,
        "nazev": "Velké Petrovice",
        "popis": "[574571] Velké Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574571,
        "val": "[574571] Velke Petrovice 5209 [574571] Velké Petrovice"
    },
    {
        "kod": 547646,
        "nazev": "Velké Poříčí",
        "popis": "[547646] Velké Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 547646,
        "val": "[547646] Velke Porici 5209 [547646] Velké Poříčí"
    },
    {
        "kod": 574589,
        "nazev": "Velký Třebešov",
        "popis": "[574589] Velký Třebešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574589,
        "val": "[574589] Velky Trebesov 5206 [574589] Velký Třebešov"
    },
    {
        "kod": 547743,
        "nazev": "Vernéřovice",
        "popis": "[547743] Vernéřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5201,
        "iczuj": 547743,
        "val": "[547743] Vernerovice 5201 [547743] Vernéřovice"
    },
    {
        "kod": 547565,
        "nazev": "Vestec",
        "popis": "[547565] Vestec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 547565,
        "val": "[547565] Vestec 5209 [547565] Vestec"
    },
    {
        "kod": 574601,
        "nazev": "Vlkov",
        "popis": "[574601] Vlkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574601,
        "val": "[574601] Vlkov 5206 [574601] Vlkov"
    },
    {
        "kod": 574627,
        "nazev": "Vršovka",
        "popis": "[574627] Vršovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5211,
        "iczuj": 574627,
        "val": "[574627] Vrsovka 5211 [574627] Vršovka"
    },
    {
        "kod": 574635,
        "nazev": "Vysoká Srbská",
        "popis": "[574635] Vysoká Srbská",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574635,
        "val": "[574635] Vysoka Srbska 5209 [574635] Vysoká Srbská"
    },
    {
        "kod": 574643,
        "nazev": "Vysokov",
        "popis": "[574643] Vysokov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574643,
        "val": "[574643] Vysokov 5209 [574643] Vysokov"
    },
    {
        "kod": 574651,
        "nazev": "Zábrodí",
        "popis": "[574651] Zábrodí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574651,
        "val": "[574651] Zabrodi 5209 [574651] Zábrodí"
    },
    {
        "kod": 574660,
        "nazev": "Zaloňov",
        "popis": "[574660] Zaloňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5206,
        "iczuj": 574660,
        "val": "[574660] Zalonov 5206 [574660] Zaloňov"
    },
    {
        "kod": 574686,
        "nazev": "Žďár nad Metují",
        "popis": "[574686] Žďár nad Metují",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574686,
        "val": "[574686] Zdar nad Metuji 5209 [574686] Žďár nad Metují"
    },
    {
        "kod": 574694,
        "nazev": "Žďárky",
        "popis": "[574694] Žďárky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574694,
        "val": "[574694] Zdarky 5209 [574694] Žďárky"
    },
    {
        "kod": 574708,
        "nazev": "Žernov",
        "popis": "[574708] Žernov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5209,
        "iczuj": 574708,
        "val": "[574708] Zernov 5209 [574708] Žernov"
    },
    {
        "kod": 576077,
        "nazev": "Albrechtice nad Orlicí",
        "popis": "[576077] Albrechtice nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576077,
        "val": "[576077] Albrechtice nad Orlici 5208 [576077] Albrechtice nad Orlicí"
    },
    {
        "kod": 576085,
        "nazev": "Bačetín",
        "popis": "[576085] Bačetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576085,
        "val": "[576085] Bacetin 5202 [576085] Bačetín"
    },
    {
        "kod": 576093,
        "nazev": "Bartošovice v Orlických horách",
        "popis": "[576093] Bartošovice v Orlických horách",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576093,
        "val": "[576093] Bartosovice v Orlickych horach 5213 [576093] Bartošovice v Orlických horách"
    },
    {
        "kod": 576107,
        "nazev": "Bílý Újezd",
        "popis": "[576107] Bílý Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576107,
        "val": "[576107] Bily Ujezd 5213 [576107] Bílý Újezd"
    },
    {
        "kod": 576115,
        "nazev": "Bohdašín",
        "popis": "[576115] Bohdašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576115,
        "val": "[576115] Bohdasin 5202 [576115] Bohdašín"
    },
    {
        "kod": 576123,
        "nazev": "Bolehošť",
        "popis": "[576123] Bolehošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576123,
        "val": "[576123] Bolehost 5208 [576123] Bolehošť"
    },
    {
        "kod": 576131,
        "nazev": "Borohrádek",
        "popis": "[576131] Borohrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576131,
        "val": "[576131] Borohradek 5208 [576131] Borohrádek"
    },
    {
        "kod": 576140,
        "nazev": "Borovnice",
        "popis": "[576140] Borovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576140,
        "val": "[576140] Borovnice 5208 [576140] Borovnice"
    },
    {
        "kod": 576166,
        "nazev": "Bystré",
        "popis": "[576166] Bystré",
        "datum_od": "",
        "datum_do": "",
        "orp": 5202,
        "iczuj": 576166,
        "val": "[576166] Bystre 5202 [576166] Bystré"
    },
    {
        "kod": 576174,
        "nazev": "Byzhradec",
        "popis": "[576174] Byzhradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576174,
        "val": "[576174] Byzhradec 5213 [576174] Byzhradec"
    },
    {
        "kod": 576182,
        "nazev": "Častolovice",
        "popis": "[576182] Častolovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576182,
        "val": "[576182] Castolovice 5208 [576182] Častolovice"
    },
    {
        "kod": 576191,
        "nazev": "Čermná nad Orlicí",
        "popis": "[576191] Čermná nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5208,
        "iczuj": 576191,
        "val": "[576191] Cermna nad Orlici 5208 [576191] Čermná nad Orlicí"
    },
    {
        "kod": 576204,
        "nazev": "Černíkovice",
        "popis": "[576204] Černíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5213,
        "iczuj": 576204,
        "val": "[576204] Cernikovice 5213 [576204] Černíkovice"
    },
    {
        "kod": 577871,
        "nazev": "Březina",
        "popis": "[577871] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 577871,
        "val": "[577871] Brezina 5308 [577871] Březina"
    },
    {
        "kod": 572250,
        "nazev": "Březinky",
        "popis": "[572250] Březinky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572250,
        "val": "[572250] Brezinky 5308 [572250] Březinky"
    },
    {
        "kod": 577898,
        "nazev": "Březiny",
        "popis": "[577898] Březiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 577898,
        "val": "[577898] Breziny 5310 [577898] Březiny"
    },
    {
        "kod": 505145,
        "nazev": "Březová nad Svitavou",
        "popis": "[505145] Březová nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 505145,
        "val": "[505145] Brezova nad Svitavou 5312 [505145] Březová nad Svitavou"
    },
    {
        "kod": 577910,
        "nazev": "Budislav",
        "popis": "[577910] Budislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577910,
        "val": "[577910] Budislav 5307 [577910] Budislav"
    },
    {
        "kod": 577928,
        "nazev": "Bystré",
        "popis": "[577928] Bystré",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 577928,
        "val": "[577928] Bystre 5310 [577928] Bystré"
    },
    {
        "kod": 577936,
        "nazev": "Cerekvice nad Loučnou",
        "popis": "[577936] Cerekvice nad Loučnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577936,
        "val": "[577936] Cerekvice nad Loucnou 5307 [577936] Cerekvice nad Loučnou"
    },
    {
        "kod": 577944,
        "nazev": "Čistá",
        "popis": "[577944] Čistá",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577944,
        "val": "[577944] Cista 5307 [577944] Čistá"
    },
    {
        "kod": 572357,
        "nazev": "Desná",
        "popis": "[572357] Desná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572357,
        "val": "[572357] Desna 5307 [572357] Desná"
    },
    {
        "kod": 577961,
        "nazev": "Dětřichov",
        "popis": "[577961] Dětřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 577961,
        "val": "[577961] Detrichov 5312 [577961] Dětřichov"
    },
    {
        "kod": 572683,
        "nazev": "Dětřichov u Moravské Třebové",
        "popis": "[572683] Dětřichov u Moravské Třebové",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572683,
        "val": "[572683] Detrichov u Moravske Trebove 5308 [572683] Dětřichov u Moravské Třebové"
    },
    {
        "kod": 577987,
        "nazev": "Dlouhá Loučka",
        "popis": "[577987] Dlouhá Loučka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 577987,
        "val": "[577987] Dlouha Loucka 5308 [577987] Dlouhá Loučka"
    },
    {
        "kod": 577995,
        "nazev": "Dolní Újezd",
        "popis": "[577995] Dolní Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 577995,
        "val": "[577995] Dolni Ujezd 5307 [577995] Dolní Újezd"
    },
    {
        "kod": 574325,
        "nazev": "Gruna",
        "popis": "[574325] Gruna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 574325,
        "val": "[574325] Gruna 5308 [574325] Gruna"
    },
    {
        "kod": 572284,
        "nazev": "Hartinkov",
        "popis": "[572284] Hartinkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572284,
        "val": "[572284] Hartinkov 5308 [572284] Hartinkov"
    },
    {
        "kod": 578037,
        "nazev": "Hartmanice",
        "popis": "[578037] Hartmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578037,
        "val": "[578037] Hartmanice 5310 [578037] Hartmanice"
    },
    {
        "kod": 578053,
        "nazev": "Horky",
        "popis": "[578053] Horky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578053,
        "val": "[578053] Horky 5307 [578053] Horky"
    },
    {
        "kod": 572365,
        "nazev": "Horní Újezd",
        "popis": "[572365] Horní Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572365,
        "val": "[572365] Horni Ujezd 5307 [572365] Horní Újezd"
    },
    {
        "kod": 572691,
        "nazev": "Hradec nad Svitavou",
        "popis": "[572691] Hradec nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572691,
        "val": "[572691] Hradec nad Svitavou 5312 [572691] Hradec nad Svitavou"
    },
    {
        "kod": 572730,
        "nazev": "Chmelík",
        "popis": "[572730] Chmelík",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572730,
        "val": "[572730] Chmelik 5307 [572730] Chmelík"
    },
    {
        "kod": 578096,
        "nazev": "Chornice",
        "popis": "[578096] Chornice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578096,
        "val": "[578096] Chornice 5308 [578096] Chornice"
    },
    {
        "kod": 578100,
        "nazev": "Chotěnov",
        "popis": "[578100] Chotěnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578100,
        "val": "[578100] Chotenov 5307 [578100] Chotěnov"
    },
    {
        "kod": 578118,
        "nazev": "Chotovice",
        "popis": "[578118] Chotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578118,
        "val": "[578118] Chotovice 5307 [578118] Chotovice"
    },
    {
        "kod": 578126,
        "nazev": "Chrastavec",
        "popis": "[578126] Chrastavec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578126,
        "val": "[578126] Chrastavec 5312 [578126] Chrastavec"
    },
    {
        "kod": 578134,
        "nazev": "Janov",
        "popis": "[578134] Janov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578134,
        "val": "[578134] Janov 5307 [578134] Janov"
    },
    {
        "kod": 578142,
        "nazev": "Janůvky",
        "popis": "[578142] Janůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578142,
        "val": "[578142] Januvky 5308 [578142] Janůvky"
    },
    {
        "kod": 578151,
        "nazev": "Jaroměřice",
        "popis": "[578151] Jaroměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578151,
        "val": "[578151] Jaromerice 5308 [578151] Jaroměřice"
    },
    {
        "kod": 578169,
        "nazev": "Jarošov",
        "popis": "[578169] Jarošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578169,
        "val": "[578169] Jarosov 5307 [578169] Jarošov"
    },
    {
        "kod": 572713,
        "nazev": "Javorník",
        "popis": "[572713] Javorník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572713,
        "val": "[572713] Javornik 5312 [572713] Javorník"
    },
    {
        "kod": 578185,
        "nazev": "Jedlová",
        "popis": "[578185] Jedlová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578185,
        "val": "[578185] Jedlova 5310 [578185] Jedlová"
    },
    {
        "kod": 578193,
        "nazev": "Jevíčko",
        "popis": "[578193] Jevíčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578193,
        "val": "[578193] Jevicko 5308 [578193] Jevíčko"
    },
    {
        "kod": 578207,
        "nazev": "Kamenec u Poličky",
        "popis": "[578207] Kamenec u Poličky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578207,
        "val": "[578207] Kamenec u Policky 5310 [578207] Kamenec u Poličky"
    },
    {
        "kod": 578215,
        "nazev": "Kamenná Horka",
        "popis": "[578215] Kamenná Horka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578215,
        "val": "[578215] Kamenna Horka 5312 [578215] Kamenná Horka"
    },
    {
        "kod": 572748,
        "nazev": "Karle",
        "popis": "[572748] Karle",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572748,
        "val": "[572748] Karle 5312 [572748] Karle"
    },
    {
        "kod": 578231,
        "nazev": "Koclířov",
        "popis": "[578231] Koclířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578231,
        "val": "[578231] Koclirov 5312 [578231] Koclířov"
    },
    {
        "kod": 578258,
        "nazev": "Korouhev",
        "popis": "[578258] Korouhev",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578258,
        "val": "[578258] Korouhev 5310 [578258] Korouhev"
    },
    {
        "kod": 578266,
        "nazev": "Koruna",
        "popis": "[578266] Koruna",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578266,
        "val": "[578266] Koruna 5308 [578266] Koruna"
    },
    {
        "kod": 578274,
        "nazev": "Křenov",
        "popis": "[578274] Křenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578274,
        "val": "[578274] Krenov 5308 [578274] Křenov"
    },
    {
        "kod": 572594,
        "nazev": "Kukle",
        "popis": "[572594] Kukle",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572594,
        "val": "[572594] Kukle 5312 [572594] Kukle"
    },
    {
        "kod": 578282,
        "nazev": "Kunčina",
        "popis": "[578282] Kunčina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578282,
        "val": "[578282] Kuncina 5308 [578282] Kunčina"
    },
    {
        "kod": 578291,
        "nazev": "Květná",
        "popis": "[578291] Květná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578291,
        "val": "[578291] Kvetna 5310 [578291] Květná"
    },
    {
        "kod": 578304,
        "nazev": "Lavičné",
        "popis": "[578304] Lavičné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578304,
        "val": "[578304] Lavicne 5312 [578304] Lavičné"
    },
    {
        "kod": 578339,
        "nazev": "Linhartice",
        "popis": "[578339] Linhartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578339,
        "val": "[578339] Linhartice 5308 [578339] Linhartice"
    },
    {
        "kod": 578347,
        "nazev": "Litomyšl",
        "popis": "[578347] Litomyšl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578347,
        "val": "[578347] Litomysl 5307 [578347] Litomyšl"
    },
    {
        "kod": 578355,
        "nazev": "Lubná",
        "popis": "[578355] Lubná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578355,
        "val": "[578355] Lubna 5307 [578355] Lubná"
    },
    {
        "kod": 578363,
        "nazev": "Makov",
        "popis": "[578363] Makov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578363,
        "val": "[578363] Makov 5307 [578363] Makov"
    },
    {
        "kod": 578371,
        "nazev": "Malíkov",
        "popis": "[578371] Malíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578371,
        "val": "[578371] Malikov 5308 [578371] Malíkov"
    },
    {
        "kod": 578380,
        "nazev": "Městečko Trnávka",
        "popis": "[578380] Městečko Trnávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578380,
        "val": "[578380] Mestecko Trnavka 5308 [578380] Městečko Trnávka"
    },
    {
        "kod": 578398,
        "nazev": "Mikuleč",
        "popis": "[578398] Mikuleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578398,
        "val": "[578398] Mikulec 5312 [578398] Mikuleč"
    },
    {
        "kod": 578401,
        "nazev": "Mladějov na Moravě",
        "popis": "[578401] Mladějov na Moravě",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578401,
        "val": "[578401] Mladejov na Morave 5308 [578401] Mladějov na Moravě"
    },
    {
        "kod": 578428,
        "nazev": "Morašice",
        "popis": "[578428] Morašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578428,
        "val": "[578428] Morasice 5307 [578428] Morašice"
    },
    {
        "kod": 578444,
        "nazev": "Moravská Třebová",
        "popis": "[578444] Moravská Třebová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578444,
        "val": "[578444] Moravska Trebova 5308 [578444] Moravská Třebová"
    },
    {
        "kod": 578452,
        "nazev": "Nedvězí",
        "popis": "[578452] Nedvězí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578452,
        "val": "[578452] Nedvezi 5310 [578452] Nedvězí"
    },
    {
        "kod": 580694,
        "nazev": "Němčice",
        "popis": "[580694] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 580694,
        "val": "[580694] Nemcice 5307 [580694] Němčice"
    },
    {
        "kod": 572608,
        "nazev": "Nová Sídla",
        "popis": "[572608] Nová Sídla",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572608,
        "val": "[572608] Nova Sidla 5307 [572608] Nová Sídla"
    },
    {
        "kod": 572438,
        "nazev": "Nová Ves u Jarošova",
        "popis": "[572438] Nová Ves u Jarošova",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572438,
        "val": "[572438] Nova Ves u Jarosova 5307 [572438] Nová Ves u Jarošova"
    },
    {
        "kod": 578479,
        "nazev": "Oldřiš",
        "popis": "[578479] Oldřiš",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578479,
        "val": "[578479] Oldris 5310 [578479] Oldřiš"
    },
    {
        "kod": 578487,
        "nazev": "Opatov",
        "popis": "[578487] Opatov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578487,
        "val": "[578487] Opatov 5312 [578487] Opatov"
    },
    {
        "kod": 572721,
        "nazev": "Opatovec",
        "popis": "[572721] Opatovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572721,
        "val": "[572721] Opatovec 5312 [572721] Opatovec"
    },
    {
        "kod": 578509,
        "nazev": "Osík",
        "popis": "[578509] Osík",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578509,
        "val": "[578509] Osik 5307 [578509] Osík"
    },
    {
        "kod": 578550,
        "nazev": "Pohledy",
        "popis": "[578550] Pohledy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578550,
        "val": "[578550] Pohledy 5312 [578550] Pohledy"
    },
    {
        "kod": 578576,
        "nazev": "Polička",
        "popis": "[578576] Polička",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578576,
        "val": "[578576] Policka 5310 [578576] Polička"
    },
    {
        "kod": 578584,
        "nazev": "Pomezí",
        "popis": "[578584] Pomezí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578584,
        "val": "[578584] Pomezi 5310 [578584] Pomezí"
    },
    {
        "kod": 572373,
        "nazev": "Poříčí u Litomyšle",
        "popis": "[572373] Poříčí u Litomyšle",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572373,
        "val": "[572373] Porici u Litomysle 5307 [572373] Poříčí u Litomyšle"
    },
    {
        "kod": 578622,
        "nazev": "Příluka",
        "popis": "[578622] Příluka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578622,
        "val": "[578622] Priluka 5307 [578622] Příluka"
    },
    {
        "kod": 578631,
        "nazev": "Pustá Kamenice",
        "popis": "[578631] Pustá Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578631,
        "val": "[578631] Pusta Kamenice 5310 [578631] Pustá Kamenice"
    },
    {
        "kod": 578649,
        "nazev": "Pustá Rybná",
        "popis": "[578649] Pustá Rybná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578649,
        "val": "[578649] Pusta Rybna 5310 [578649] Pustá Rybná"
    },
    {
        "kod": 578657,
        "nazev": "Radiměř",
        "popis": "[578657] Radiměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578657,
        "val": "[578657] Radimer 5312 [578657] Radiměř"
    },
    {
        "kod": 574333,
        "nazev": "Radkov",
        "popis": "[574333] Radkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 574333,
        "val": "[574333] Radkov 5308 [574333] Radkov"
    },
    {
        "kod": 578673,
        "nazev": "Rohozná",
        "popis": "[578673] Rohozná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578673,
        "val": "[578673] Rohozna 5312 [578673] Rohozná"
    },
    {
        "kod": 578681,
        "nazev": "Rozhraní",
        "popis": "[578681] Rozhraní",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578681,
        "val": "[578681] Rozhrani 5312 [578681] Rozhraní"
    },
    {
        "kod": 578690,
        "nazev": "Rozstání",
        "popis": "[578690] Rozstání",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578690,
        "val": "[578690] Rozstani 5308 [578690] Rozstání"
    },
    {
        "kod": 578703,
        "nazev": "Rudná",
        "popis": "[578703] Rudná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578703,
        "val": "[578703] Rudna 5312 [578703] Rudná"
    },
    {
        "kod": 578711,
        "nazev": "Rychnov na Moravě",
        "popis": "[578711] Rychnov na Moravě",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578711,
        "val": "[578711] Rychnov na Morave 5308 [578711] Rychnov na Moravě"
    },
    {
        "kod": 572233,
        "nazev": "Řídký",
        "popis": "[572233] Řídký",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572233,
        "val": "[572233] Ridky 5307 [572233] Řídký"
    },
    {
        "kod": 578720,
        "nazev": "Sádek",
        "popis": "[578720] Sádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578720,
        "val": "[578720] Sadek 5310 [578720] Sádek"
    },
    {
        "kod": 578738,
        "nazev": "Sebranice",
        "popis": "[578738] Sebranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578738,
        "val": "[578738] Sebranice 5307 [578738] Sebranice"
    },
    {
        "kod": 578746,
        "nazev": "Sedliště",
        "popis": "[578746] Sedliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578746,
        "val": "[578746] Sedliste 5307 [578746] Sedliště"
    },
    {
        "kod": 578754,
        "nazev": "Sklené",
        "popis": "[578754] Sklené",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578754,
        "val": "[578754] Sklene 5312 [578754] Sklené"
    },
    {
        "kod": 578762,
        "nazev": "Slatina",
        "popis": "[578762] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578762,
        "val": "[578762] Slatina 5308 [578762] Slatina"
    },
    {
        "kod": 580325,
        "nazev": "Sloupnice",
        "popis": "[580325] Sloupnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 580325,
        "val": "[580325] Sloupnice 5307 [580325] Sloupnice"
    },
    {
        "kod": 578789,
        "nazev": "Staré Město",
        "popis": "[578789] Staré Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578789,
        "val": "[578789] Stare Mesto 5308 [578789] Staré Město"
    },
    {
        "kod": 578801,
        "nazev": "Stašov",
        "popis": "[578801] Stašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578801,
        "val": "[578801] Stasov 5310 [578801] Stašov"
    },
    {
        "kod": 578819,
        "nazev": "Strakov",
        "popis": "[578819] Strakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578819,
        "val": "[578819] Strakov 5307 [578819] Strakov"
    },
    {
        "kod": 578835,
        "nazev": "Suchá Lhota",
        "popis": "[578835] Suchá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578835,
        "val": "[578835] Sucha Lhota 5307 [578835] Suchá Lhota"
    },
    {
        "kod": 577731,
        "nazev": "Svitavy",
        "popis": "[577731] Svitavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 577731,
        "val": "[577731] Svitavy 5312 [577731] Svitavy"
    },
    {
        "kod": 578843,
        "nazev": "Svojanov",
        "popis": "[578843] Svojanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578843,
        "val": "[578843] Svojanov 5310 [578843] Svojanov"
    },
    {
        "kod": 578851,
        "nazev": "Široký Důl",
        "popis": "[578851] Široký Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578851,
        "val": "[578851] Siroky Dul 5310 [578851] Široký Důl"
    },
    {
        "kod": 578860,
        "nazev": "Študlov",
        "popis": "[578860] Študlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578860,
        "val": "[578860] Studlov 5312 [578860] Študlov"
    },
    {
        "kod": 578878,
        "nazev": "Telecí",
        "popis": "[578878] Telecí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578878,
        "val": "[578878] Teleci 5310 [578878] Telecí"
    },
    {
        "kod": 578886,
        "nazev": "Trpín",
        "popis": "[578886] Trpín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5310,
        "iczuj": 578886,
        "val": "[578886] Trpin 5310 [578886] Trpín"
    },
    {
        "kod": 578894,
        "nazev": "Trstěnice",
        "popis": "[578894] Trstěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578894,
        "val": "[578894] Trstenice 5307 [578894] Trstěnice"
    },
    {
        "kod": 572616,
        "nazev": "Tržek",
        "popis": "[572616] Tržek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 572616,
        "val": "[572616] Trzek 5307 [572616] Tržek"
    },
    {
        "kod": 578908,
        "nazev": "Třebařov",
        "popis": "[578908] Třebařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578908,
        "val": "[578908] Trebarov 5308 [578908] Třebařov"
    },
    {
        "kod": 578916,
        "nazev": "Újezdec",
        "popis": "[578916] Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578916,
        "val": "[578916] Ujezdec 5307 [578916] Újezdec"
    },
    {
        "kod": 572624,
        "nazev": "Útěchov",
        "popis": "[572624] Útěchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572624,
        "val": "[572624] Utechov 5308 [572624] Útěchov"
    },
    {
        "kod": 578932,
        "nazev": "Vendolí",
        "popis": "[578932] Vendolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578932,
        "val": "[578932] Vendoli 5312 [578932] Vendolí"
    },
    {
        "kod": 578941,
        "nazev": "Vidlatá Seč",
        "popis": "[578941] Vidlatá Seč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 578941,
        "val": "[578941] Vidlata Sec 5307 [578941] Vidlatá Seč"
    },
    {
        "kod": 578959,
        "nazev": "Víska u Jevíčka",
        "popis": "[578959] Víska u Jevíčka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578959,
        "val": "[578959] Viska u Jevicka 5308 [578959] Víska u Jevíčka"
    },
    {
        "kod": 578967,
        "nazev": "Vítějeves",
        "popis": "[578967] Vítějeves",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 578967,
        "val": "[578967] Vitejeves 5312 [578967] Vítějeves"
    },
    {
        "kod": 581127,
        "nazev": "Vlčkov",
        "popis": "[581127] Vlčkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5307,
        "iczuj": 581127,
        "val": "[581127] Vlckov 5307 [581127] Vlčkov"
    },
    {
        "kod": 578975,
        "nazev": "Vranová Lhota",
        "popis": "[578975] Vranová Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578975,
        "val": "[578975] Vranova Lhota 5308 [578975] Vranová Lhota"
    },
    {
        "kod": 572292,
        "nazev": "Vrážné",
        "popis": "[572292] Vrážné",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 572292,
        "val": "[572292] Vrazne 5308 [572292] Vrážné"
    },
    {
        "kod": 578991,
        "nazev": "Vysoká",
        "popis": "[578991] Vysoká",
        "datum_od": "",
        "datum_do": "",
        "orp": 5308,
        "iczuj": 578991,
        "val": "[578991] Vysoka 5308 [578991] Vysoká"
    },
    {
        "kod": 572195,
        "nazev": "Želivsko",
        "popis": "[572195] Želivsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5312,
        "iczuj": 572195,
        "val": "[572195] Zelivsko 5312 [572195] Želivsko"
    },
    {
        "kod": 547981,
        "nazev": "Albrechtice",
        "popis": "[547981] Albrechtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 547981,
        "val": "[547981] Albrechtice 5306 [547981] Albrechtice"
    },
    {
        "kod": 573426,
        "nazev": "Anenská Studánka",
        "popis": "[573426] Anenská Studánka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 573426,
        "val": "[573426] Anenska Studanka 5306 [573426] Anenská Studánka"
    },
    {
        "kod": 553760,
        "nazev": "Běstovice",
        "popis": "[553760] Běstovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 553760,
        "val": "[553760] Bestovice 5314 [553760] Běstovice"
    },
    {
        "kod": 548006,
        "nazev": "Bošín",
        "popis": "[548006] Bošín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 548006,
        "val": "[548006] Bosin 5314 [548006] Bošín"
    },
    {
        "kod": 579947,
        "nazev": "Brandýs nad Orlicí",
        "popis": "[579947] Brandýs nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 579947,
        "val": "[579947] Brandys nad Orlici 5313 [579947] Brandýs nad Orlicí"
    },
    {
        "kod": 579963,
        "nazev": "Bučina",
        "popis": "[579963] Bučina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 579963,
        "val": "[579963] Bucina 5314 [579963] Bučina"
    },
    {
        "kod": 579971,
        "nazev": "Bystřec",
        "popis": "[579971] Bystřec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 579971,
        "val": "[579971] Bystrec 5315 [579971] Bystřec"
    },
    {
        "kod": 579980,
        "nazev": "Cotkytle",
        "popis": "[579980] Cotkytle",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 579980,
        "val": "[579980] Cotkytle 5306 [579980] Cotkytle"
    },
    {
        "kod": 579998,
        "nazev": "Čenkovice",
        "popis": "[579998] Čenkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 579998,
        "val": "[579998] Cenkovice 5306 [579998] Čenkovice"
    },
    {
        "kod": 580015,
        "nazev": "Červená Voda",
        "popis": "[580015] Červená Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 5305,
        "iczuj": 580015,
        "val": "[580015] Cervena Voda 5305 [580015] Červená Voda"
    },
    {
        "kod": 580023,
        "nazev": "Česká Rybná",
        "popis": "[580023] Česká Rybná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580023,
        "val": "[580023] Ceska Rybna 5315 [580023] Česká Rybná"
    },
    {
        "kod": 580031,
        "nazev": "Česká Třebová",
        "popis": "[580031] Česká Třebová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5301,
        "iczuj": 580031,
        "val": "[580031] Ceska Trebova 5301 [580031] Česká Třebová"
    },
    {
        "kod": 580040,
        "nazev": "České Heřmanice",
        "popis": "[580040] České Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580040,
        "val": "[580040] Ceske Hermanice 5314 [580040] České Heřmanice"
    },
    {
        "kod": 580058,
        "nazev": "České Libchavy",
        "popis": "[580058] České Libchavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580058,
        "val": "[580058] Ceske Libchavy 5313 [580058] České Libchavy"
    },
    {
        "kod": 580066,
        "nazev": "České Petrovice",
        "popis": "[580066] České Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580066,
        "val": "[580066] Ceske Petrovice 5315 [580066] České Petrovice"
    },
    {
        "kod": 580074,
        "nazev": "Damníkov",
        "popis": "[580074] Damníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580074,
        "val": "[580074] Damnikov 5306 [580074] Damníkov"
    },
    {
        "kod": 548014,
        "nazev": "Dlouhá Třebová",
        "popis": "[548014] Dlouhá Třebová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 548014,
        "val": "[548014] Dlouha Trebova 5313 [548014] Dlouhá Třebová"
    },
    {
        "kod": 548031,
        "nazev": "Dlouhoňovice",
        "popis": "[548031] Dlouhoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 548031,
        "val": "[548031] Dlouhonovice 5315 [548031] Dlouhoňovice"
    },
    {
        "kod": 580091,
        "nazev": "Dobříkov",
        "popis": "[580091] Dobříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580091,
        "val": "[580091] Dobrikov 5314 [580091] Dobříkov"
    },
    {
        "kod": 580112,
        "nazev": "Dolní Čermná",
        "popis": "[580112] Dolní Čermná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580112,
        "val": "[580112] Dolni Cermna 5306 [580112] Dolní Čermná"
    },
    {
        "kod": 580121,
        "nazev": "Dolní Dobrouč",
        "popis": "[580121] Dolní Dobrouč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580121,
        "val": "[580121] Dolni Dobrouc 5313 [580121] Dolní Dobrouč"
    },
    {
        "kod": 580163,
        "nazev": "Dolní Morava",
        "popis": "[580163] Dolní Morava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5305,
        "iczuj": 580163,
        "val": "[580163] Dolni Morava 5305 [580163] Dolní Morava"
    },
    {
        "kod": 580210,
        "nazev": "Džbánov",
        "popis": "[580210] Džbánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580210,
        "val": "[580210] Dzbanov 5314 [580210] Džbánov"
    },
    {
        "kod": 580228,
        "nazev": "Hejnice",
        "popis": "[580228] Hejnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580228,
        "val": "[580228] Hejnice 5315 [580228] Hejnice"
    },
    {
        "kod": 548049,
        "nazev": "Helvíkovice",
        "popis": "[548049] Helvíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 548049,
        "val": "[548049] Helvikovice 5315 [548049] Helvíkovice"
    },
    {
        "kod": 580261,
        "nazev": "Hnátnice",
        "popis": "[580261] Hnátnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580261,
        "val": "[580261] Hnatnice 5313 [580261] Hnátnice"
    },
    {
        "kod": 580279,
        "nazev": "Horní Čermná",
        "popis": "[580279] Horní Čermná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580279,
        "val": "[580279] Horni Cermna 5306 [580279] Horní Čermná"
    },
    {
        "kod": 580295,
        "nazev": "Horní Heřmanice",
        "popis": "[580295] Horní Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580295,
        "val": "[580295] Horni Hermanice 5306 [580295] Horní Heřmanice"
    },
    {
        "kod": 580333,
        "nazev": "Horní Třešňovec",
        "popis": "[580333] Horní Třešňovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580333,
        "val": "[580333] Horni Tresnovec 5306 [580333] Horní Třešňovec"
    },
    {
        "kod": 547972,
        "nazev": "Hrádek",
        "popis": "[547972] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 547972,
        "val": "[547972] Hradek 5313 [547972] Hrádek"
    },
    {
        "kod": 580341,
        "nazev": "Hrušová",
        "popis": "[580341] Hrušová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580341,
        "val": "[580341] Hrusova 5314 [580341] Hrušová"
    },
    {
        "kod": 580350,
        "nazev": "Choceň",
        "popis": "[580350] Choceň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580350,
        "val": "[580350] Chocen 5314 [580350] Choceň"
    },
    {
        "kod": 580376,
        "nazev": "Jablonné nad Orlicí",
        "popis": "[580376] Jablonné nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580376,
        "val": "[580376] Jablonne nad Orlici 5315 [580376] Jablonné nad Orlicí"
    },
    {
        "kod": 580392,
        "nazev": "Jamné nad Orlicí",
        "popis": "[580392] Jamné nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580392,
        "val": "[580392] Jamne nad Orlici 5315 [580392] Jamné nad Orlicí"
    },
    {
        "kod": 580406,
        "nazev": "Javorník",
        "popis": "[580406] Javorník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580406,
        "val": "[580406] Javornik 5314 [580406] Javorník"
    },
    {
        "kod": 580414,
        "nazev": "Jehnědí",
        "popis": "[580414] Jehnědí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580414,
        "val": "[580414] Jehnedi 5313 [580414] Jehnědí"
    },
    {
        "kod": 580422,
        "nazev": "Kameničná",
        "popis": "[580422] Kameničná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580422,
        "val": "[580422] Kamenicna 5315 [580422] Kameničná"
    },
    {
        "kod": 580431,
        "nazev": "Klášterec nad Orlicí",
        "popis": "[580431] Klášterec nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580431,
        "val": "[580431] Klasterec nad Orlici 5315 [580431] Klášterec nad Orlicí"
    },
    {
        "kod": 580465,
        "nazev": "Koldín",
        "popis": "[580465] Koldín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580465,
        "val": "[580465] Koldin 5314 [580465] Koldín"
    },
    {
        "kod": 574449,
        "nazev": "Kosořín",
        "popis": "[574449] Kosořín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 574449,
        "val": "[574449] Kosorin 5314 [574449] Kosořín"
    },
    {
        "kod": 580481,
        "nazev": "Králíky",
        "popis": "[580481] Králíky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5305,
        "iczuj": 580481,
        "val": "[580481] Kraliky 5305 [580481] Králíky"
    },
    {
        "kod": 580490,
        "nazev": "Krasíkov",
        "popis": "[580490] Krasíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580490,
        "val": "[580490] Krasikov 5306 [580490] Krasíkov"
    },
    {
        "kod": 580503,
        "nazev": "Kunvald",
        "popis": "[580503] Kunvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580503,
        "val": "[580503] Kunvald 5315 [580503] Kunvald"
    },
    {
        "kod": 580511,
        "nazev": "Lanškroun",
        "popis": "[580511] Lanškroun",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580511,
        "val": "[580511] Lanskroun 5306 [580511] Lanškroun"
    },
    {
        "kod": 571695,
        "nazev": "Leština",
        "popis": "[571695] Leština",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 571695,
        "val": "[571695] Lestina 5314 [571695] Leština"
    },
    {
        "kod": 580538,
        "nazev": "Letohrad",
        "popis": "[580538] Letohrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580538,
        "val": "[580538] Letohrad 5315 [580538] Letohrad"
    },
    {
        "kod": 580562,
        "nazev": "Libecina",
        "popis": "[580562] Libecina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580562,
        "val": "[580562] Libecina 5314 [580562] Libecina"
    },
    {
        "kod": 580147,
        "nazev": "Libchavy",
        "popis": "[580147] Libchavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580147,
        "val": "[580147] Libchavy 5313 [580147] Libchavy"
    },
    {
        "kod": 580571,
        "nazev": "Lichkov",
        "popis": "[580571] Lichkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5305,
        "iczuj": 580571,
        "val": "[580571] Lichkov 5305 [580571] Lichkov"
    },
    {
        "kod": 580589,
        "nazev": "Líšnice",
        "popis": "[580589] Líšnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580589,
        "val": "[580589] Lisnice 5315 [580589] Líšnice"
    },
    {
        "kod": 580619,
        "nazev": "Lubník",
        "popis": "[580619] Lubník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580619,
        "val": "[580619] Lubnik 5306 [580619] Lubník"
    },
    {
        "kod": 580627,
        "nazev": "Lukavice",
        "popis": "[580627] Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580627,
        "val": "[580627] Lukavice 5315 [580627] Lukavice"
    },
    {
        "kod": 580635,
        "nazev": "Luková",
        "popis": "[580635] Luková",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580635,
        "val": "[580635] Lukova 5306 [580635] Luková"
    },
    {
        "kod": 580643,
        "nazev": "Mistrovice",
        "popis": "[580643] Mistrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580643,
        "val": "[580643] Mistrovice 5315 [580643] Mistrovice"
    },
    {
        "kod": 580651,
        "nazev": "Mladkov",
        "popis": "[580651] Mladkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5305,
        "iczuj": 580651,
        "val": "[580651] Mladkov 5305 [580651] Mladkov"
    },
    {
        "kod": 580660,
        "nazev": "Mostek",
        "popis": "[580660] Mostek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580660,
        "val": "[580660] Mostek 5314 [580660] Mostek"
    },
    {
        "kod": 580678,
        "nazev": "Nasavrky",
        "popis": "[580678] Nasavrky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580678,
        "val": "[580678] Nasavrky 5314 [580678] Nasavrky"
    },
    {
        "kod": 580686,
        "nazev": "Nekoř",
        "popis": "[580686] Nekoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580686,
        "val": "[580686] Nekor 5315 [580686] Nekoř"
    },
    {
        "kod": 571920,
        "nazev": "Nové Hrady",
        "popis": "[571920] Nové Hrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 571920,
        "val": "[571920] Nove Hrady 5314 [571920] Nové Hrady"
    },
    {
        "kod": 580716,
        "nazev": "Orlické Podhůří",
        "popis": "[580716] Orlické Podhůří",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580716,
        "val": "[580716] Orlicke Podhuri 5313 [580716] Orlické Podhůří"
    },
    {
        "kod": 580724,
        "nazev": "Orličky",
        "popis": "[580724] Orličky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580724,
        "val": "[580724] Orlicky 5315 [580724] Orličky"
    },
    {
        "kod": 580732,
        "nazev": "Ostrov",
        "popis": "[580732] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580732,
        "val": "[580732] Ostrov 5306 [580732] Ostrov"
    },
    {
        "kod": 580741,
        "nazev": "Oucmanice",
        "popis": "[580741] Oucmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580741,
        "val": "[580741] Oucmanice 5314 [580741] Oucmanice"
    },
    {
        "kod": 580759,
        "nazev": "Pastviny",
        "popis": "[580759] Pastviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580759,
        "val": "[580759] Pastviny 5315 [580759] Pastviny"
    },
    {
        "kod": 580767,
        "nazev": "Petrovice",
        "popis": "[580767] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580767,
        "val": "[580767] Petrovice 5306 [580767] Petrovice"
    },
    {
        "kod": 580775,
        "nazev": "Písečná",
        "popis": "[580775] Písečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580775,
        "val": "[580775] Pisecna 5315 [580775] Písečná"
    },
    {
        "kod": 580783,
        "nazev": "Plchovice",
        "popis": "[580783] Plchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580783,
        "val": "[580783] Plchovice 5314 [580783] Plchovice"
    },
    {
        "kod": 580805,
        "nazev": "Podlesí",
        "popis": "[580805] Podlesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580805,
        "val": "[580805] Podlesi 5314 [580805] Podlesí"
    },
    {
        "kod": 580821,
        "nazev": "Přívrat",
        "popis": "[580821] Přívrat",
        "datum_od": "",
        "datum_do": "",
        "orp": 5301,
        "iczuj": 580821,
        "val": "[580821] Privrat 5301 [580821] Přívrat"
    },
    {
        "kod": 580830,
        "nazev": "Pustina",
        "popis": "[580830] Pustina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580830,
        "val": "[580830] Pustina 5314 [580830] Pustina"
    },
    {
        "kod": 575542,
        "nazev": "Radhošť",
        "popis": "[575542] Radhošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 575542,
        "val": "[575542] Radhost 5314 [575542] Radhošť"
    },
    {
        "kod": 580848,
        "nazev": "Rudoltice",
        "popis": "[580848] Rudoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580848,
        "val": "[580848] Rudoltice 5306 [580848] Rudoltice"
    },
    {
        "kod": 547905,
        "nazev": "Rybník",
        "popis": "[547905] Rybník",
        "datum_od": "",
        "datum_do": "",
        "orp": 5301,
        "iczuj": 547905,
        "val": "[547905] Rybnik 5301 [547905] Rybník"
    },
    {
        "kod": 572209,
        "nazev": "Řepníky",
        "popis": "[572209] Řepníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 572209,
        "val": "[572209] Repniky 5314 [572209] Řepníky"
    },
    {
        "kod": 580872,
        "nazev": "Řetová",
        "popis": "[580872] Řetová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580872,
        "val": "[580872] Retova 5313 [580872] Řetová"
    },
    {
        "kod": 580881,
        "nazev": "Řetůvka",
        "popis": "[580881] Řetůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580881,
        "val": "[580881] Retuvka 5313 [580881] Řetůvka"
    },
    {
        "kod": 574392,
        "nazev": "Sázava",
        "popis": "[574392] Sázava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 574392,
        "val": "[574392] Sazava 5306 [574392] Sázava"
    },
    {
        "kod": 580902,
        "nazev": "Seč",
        "popis": "[580902] Seč",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580902,
        "val": "[580902] Sec 5314 [580902] Seč"
    },
    {
        "kod": 555240,
        "nazev": "Semanín",
        "popis": "[555240] Semanín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5301,
        "iczuj": 555240,
        "val": "[555240] Semanin 5301 [555240] Semanín"
    },
    {
        "kod": 580929,
        "nazev": "Skořenice",
        "popis": "[580929] Skořenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580929,
        "val": "[580929] Skorenice 5314 [580929] Skořenice"
    },
    {
        "kod": 580945,
        "nazev": "Slatina",
        "popis": "[580945] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580945,
        "val": "[580945] Slatina 5314 [580945] Slatina"
    },
    {
        "kod": 547964,
        "nazev": "Sobkovice",
        "popis": "[547964] Sobkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 547964,
        "val": "[547964] Sobkovice 5315 [547964] Sobkovice"
    },
    {
        "kod": 580961,
        "nazev": "Sopotnice",
        "popis": "[580961] Sopotnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 580961,
        "val": "[580961] Sopotnice 5313 [580961] Sopotnice"
    },
    {
        "kod": 580970,
        "nazev": "Sruby",
        "popis": "[580970] Sruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580970,
        "val": "[580970] Sruby 5314 [580970] Sruby"
    },
    {
        "kod": 572306,
        "nazev": "Stradouň",
        "popis": "[572306] Stradouň",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 572306,
        "val": "[572306] Stradoun 5314 [572306] Stradouň"
    },
    {
        "kod": 580988,
        "nazev": "Strážná",
        "popis": "[580988] Strážná",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 580988,
        "val": "[580988] Strazna 5306 [580988] Strážná"
    },
    {
        "kod": 580996,
        "nazev": "Studené",
        "popis": "[580996] Studené",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 580996,
        "val": "[580996] Studene 5315 [580996] Studené"
    },
    {
        "kod": 581003,
        "nazev": "Sudislav nad Orlicí",
        "popis": "[581003] Sudislav nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 581003,
        "val": "[581003] Sudislav nad Orlici 5313 [581003] Sudislav nad Orlicí"
    },
    {
        "kod": 581011,
        "nazev": "Sudslava",
        "popis": "[581011] Sudslava",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581011,
        "val": "[581011] Sudslava 5314 [581011] Sudslava"
    },
    {
        "kod": 580708,
        "nazev": "Svatý Jiří",
        "popis": "[580708] Svatý Jiří",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 580708,
        "val": "[580708] Svaty Jiri 5314 [580708] Svatý Jiří"
    },
    {
        "kod": 581038,
        "nazev": "Šedivec",
        "popis": "[581038] Šedivec",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581038,
        "val": "[581038] Sedivec 5315 [581038] Šedivec"
    },
    {
        "kod": 581046,
        "nazev": "Tatenice",
        "popis": "[581046] Tatenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 581046,
        "val": "[581046] Tatenice 5306 [581046] Tatenice"
    },
    {
        "kod": 581054,
        "nazev": "Těchonín",
        "popis": "[581054] Těchonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581054,
        "val": "[581054] Techonin 5315 [581054] Těchonín"
    },
    {
        "kod": 581062,
        "nazev": "Tisová",
        "popis": "[581062] Tisová",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581062,
        "val": "[581062] Tisova 5314 [581062] Tisová"
    },
    {
        "kod": 547921,
        "nazev": "Trpík",
        "popis": "[547921] Trpík",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 547921,
        "val": "[547921] Trpik 5306 [547921] Trpík"
    },
    {
        "kod": 581071,
        "nazev": "Třebovice",
        "popis": "[581071] Třebovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5301,
        "iczuj": 581071,
        "val": "[581071] Trebovice 5301 [581071] Třebovice"
    },
    {
        "kod": 575861,
        "nazev": "Týnišťko",
        "popis": "[575861] Týnišťko",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 575861,
        "val": "[575861] Tynistko 5314 [575861] Týnišťko"
    },
    {
        "kod": 581089,
        "nazev": "Újezd u Chocně",
        "popis": "[581089] Újezd u Chocně",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581089,
        "val": "[581089] Ujezd u Chocne 5314 [581089] Újezd u Chocně"
    },
    {
        "kod": 579891,
        "nazev": "Ústí nad Orlicí",
        "popis": "[579891] Ústí nad Orlicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 579891,
        "val": "[579891] Usti nad Orlici 5313 [579891] Ústí nad Orlicí"
    },
    {
        "kod": 581101,
        "nazev": "Velká Skrovnice",
        "popis": "[581101] Velká Skrovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 581101,
        "val": "[581101] Velka Skrovnice 5313 [581101] Velká Skrovnice"
    },
    {
        "kod": 581119,
        "nazev": "Verměřovice",
        "popis": "[581119] Verměřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581119,
        "val": "[581119] Vermerovice 5315 [581119] Verměřovice"
    },
    {
        "kod": 572489,
        "nazev": "Vinary",
        "popis": "[572489] Vinary",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 572489,
        "val": "[572489] Vinary 5314 [572489] Vinary"
    },
    {
        "kod": 581143,
        "nazev": "Voděrady",
        "popis": "[581143] Voděrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 5313,
        "iczuj": 581143,
        "val": "[581143] Voderady 5313 [581143] Voděrady"
    },
    {
        "kod": 581151,
        "nazev": "Vraclav",
        "popis": "[581151] Vraclav",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581151,
        "val": "[581151] Vraclav 5314 [581151] Vraclav"
    },
    {
        "kod": 548022,
        "nazev": "Vračovice-Orlov",
        "popis": "[548022] Vračovice-Orlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 548022,
        "val": "[548022] Vracovice-Orlov 5314 [548022] Vračovice-Orlov"
    },
    {
        "kod": 581178,
        "nazev": "Výprachtice",
        "popis": "[581178] Výprachtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 581178,
        "val": "[581178] Vyprachtice 5306 [581178] Výprachtice"
    },
    {
        "kod": 581186,
        "nazev": "Vysoké Mýto",
        "popis": "[581186] Vysoké Mýto",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581186,
        "val": "[581186] Vysoke Myto 5314 [581186] Vysoké Mýto"
    },
    {
        "kod": 581194,
        "nazev": "Zádolí",
        "popis": "[581194] Zádolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581194,
        "val": "[581194] Zadoli 5314 [581194] Zádolí"
    },
    {
        "kod": 581208,
        "nazev": "Záchlumí",
        "popis": "[581208] Záchlumí",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581208,
        "val": "[581208] Zachlumi 5315 [581208] Záchlumí"
    },
    {
        "kod": 581216,
        "nazev": "Zálší",
        "popis": "[581216] Zálší",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581216,
        "val": "[581216] Zalsi 5314 [581216] Zálší"
    },
    {
        "kod": 581224,
        "nazev": "Zámrsk",
        "popis": "[581224] Zámrsk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581224,
        "val": "[581224] Zamrsk 5314 [581224] Zámrsk"
    },
    {
        "kod": 581232,
        "nazev": "Zářecká Lhota",
        "popis": "[581232] Zářecká Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 5314,
        "iczuj": 581232,
        "val": "[581232] Zarecka Lhota 5314 [581232] Zářecká Lhota"
    },
    {
        "kod": 581259,
        "nazev": "Žamberk",
        "popis": "[581259] Žamberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581259,
        "val": "[581259] Zamberk 5315 [581259] Žamberk"
    },
    {
        "kod": 581267,
        "nazev": "Žampach",
        "popis": "[581267] Žampach",
        "datum_od": "",
        "datum_do": "",
        "orp": 5315,
        "iczuj": 581267,
        "val": "[581267] Zampach 5315 [581267] Žampach"
    },
    {
        "kod": 581275,
        "nazev": "Žichlínek",
        "popis": "[581275] Žichlínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 5306,
        "iczuj": 581275,
        "val": "[581275] Zichlinek 5306 [581275] Žichlínek"
    },
    {
        "kod": 546194,
        "nazev": "Bačkov",
        "popis": "[546194] Bačkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 546194,
        "val": "[546194] Backov 6102 [546194] Bačkov"
    },
    {
        "kod": 548260,
        "nazev": "Bartoušov",
        "popis": "[548260] Bartoušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548260,
        "val": "[548260] Bartousov 6102 [548260] Bartoušov"
    },
    {
        "kod": 573566,
        "nazev": "Bělá",
        "popis": "[573566] Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 573566,
        "val": "[573566] Bela 6111 [573566] Bělá"
    },
    {
        "kod": 548430,
        "nazev": "Bezděkov",
        "popis": "[548430] Bezděkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548430,
        "val": "[548430] Bezdekov 6104 [548430] Bezděkov"
    },
    {
        "kod": 568457,
        "nazev": "Bojiště",
        "popis": "[568457] Bojiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568457,
        "val": "[568457] Bojiste 6111 [568457] Bojiště"
    },
    {
        "kod": 573558,
        "nazev": "Boňkov",
        "popis": "[573558] Boňkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 573558,
        "val": "[573558] Bonkov 6102 [573558] Boňkov"
    },
    {
        "kod": 568465,
        "nazev": "Borek",
        "popis": "[568465] Borek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568465,
        "val": "[568465] Borek 6104 [568465] Borek"
    },
    {
        "kod": 548278,
        "nazev": "Břevnice",
        "popis": "[548278] Břevnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548278,
        "val": "[548278] Brevnice 6102 [548278] Břevnice"
    },
    {
        "kod": 568490,
        "nazev": "Čachotín",
        "popis": "[568490] Čachotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568490,
        "val": "[568490] Cachotin 6104 [568490] Čachotín"
    },
    {
        "kod": 548375,
        "nazev": "Čečkovice",
        "popis": "[548375] Čečkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548375,
        "val": "[548375] Ceckovice 6104 [548375] Čečkovice"
    },
    {
        "kod": 568503,
        "nazev": "Česká Bělá",
        "popis": "[568503] Česká Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568503,
        "val": "[568503] Ceska Bela 6102 [568503] Česká Bělá"
    },
    {
        "kod": 568520,
        "nazev": "Číhošť",
        "popis": "[568520] Číhošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568520,
        "val": "[568520] Cihost 6111 [568520] Číhošť"
    },
    {
        "kod": 568538,
        "nazev": "Dlouhá Ves",
        "popis": "[568538] Dlouhá Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568538,
        "val": "[568538] Dlouha Ves 6102 [568538] Dlouhá Ves"
    },
    {
        "kod": 568597,
        "nazev": "Dolní Krupá",
        "popis": "[568597] Dolní Krupá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568597,
        "val": "[568597] Dolni Krupa 6102 [568597] Dolní Krupá"
    },
    {
        "kod": 568601,
        "nazev": "Dolní Město",
        "popis": "[568601] Dolní Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568601,
        "val": "[568601] Dolni Mesto 6111 [568601] Dolní Město"
    },
    {
        "kod": 548448,
        "nazev": "Dolní Sokolovec",
        "popis": "[548448] Dolní Sokolovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548448,
        "val": "[548448] Dolni Sokolovec 6104 [548448] Dolní Sokolovec"
    },
    {
        "kod": 568619,
        "nazev": "Druhanov",
        "popis": "[568619] Druhanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568619,
        "val": "[568619] Druhanov 6111 [568619] Druhanov"
    },
    {
        "kod": 568635,
        "nazev": "Golčův Jeníkov",
        "popis": "[568635] Golčův Jeníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568635,
        "val": "[568635] Golcuv Jenikov 6102 [568635] Golčův Jeníkov"
    },
    {
        "kod": 568651,
        "nazev": "Habry",
        "popis": "[568651] Habry",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568651,
        "val": "[568651] Habry 6102 [568651] Habry"
    },
    {
        "kod": 568660,
        "nazev": "Havlíčkova Borová",
        "popis": "[568660] Havlíčkova Borová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568660,
        "val": "[568660] Havlickova Borova 6102 [568660] Havlíčkova Borová"
    },
    {
        "kod": 568414,
        "nazev": "Havlíčkův Brod",
        "popis": "[568414] Havlíčkův Brod",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568414,
        "val": "[568414] Havlickuv Brod 6102 [568414] Havlíčkův Brod"
    },
    {
        "kod": 568678,
        "nazev": "Herálec",
        "popis": "[568678] Herálec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568678,
        "val": "[568678] Heralec 6102 [568678] Herálec"
    },
    {
        "kod": 548596,
        "nazev": "Heřmanice",
        "popis": "[548596] Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548596,
        "val": "[548596] Hermanice 6104 [548596] Heřmanice"
    },
    {
        "kod": 568694,
        "nazev": "Hněvkovice",
        "popis": "[568694] Hněvkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568694,
        "val": "[568694] Hnevkovice 6111 [568694] Hněvkovice"
    },
    {
        "kod": 568708,
        "nazev": "Horní Krupá",
        "popis": "[568708] Horní Krupá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568708,
        "val": "[568708] Horni Krupa 6102 [568708] Horní Krupá"
    },
    {
        "kod": 548243,
        "nazev": "Horní Paseka",
        "popis": "[548243] Horní Paseka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 548243,
        "val": "[548243] Horni Paseka 6111 [548243] Horní Paseka"
    },
    {
        "kod": 568724,
        "nazev": "Hradec",
        "popis": "[568724] Hradec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568724,
        "val": "[568724] Hradec 6111 [568724] Hradec"
    },
    {
        "kod": 530646,
        "nazev": "Hurtova Lhota",
        "popis": "[530646] Hurtova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 530646,
        "val": "[530646] Hurtova Lhota 6102 [530646] Hurtova Lhota"
    },
    {
        "kod": 568759,
        "nazev": "Chotěboř",
        "popis": "[568759] Chotěboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568759,
        "val": "[568759] Chotebor 6104 [568759] Chotěboř"
    },
    {
        "kod": 568767,
        "nazev": "Chrtníč",
        "popis": "[568767] Chrtníč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568767,
        "val": "[568767] Chrtnic 6102 [568767] Chrtníč"
    },
    {
        "kod": 573574,
        "nazev": "Chřenovice",
        "popis": "[573574] Chřenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 573574,
        "val": "[573574] Chrenovice 6111 [573574] Chřenovice"
    },
    {
        "kod": 568783,
        "nazev": "Jedlá",
        "popis": "[568783] Jedlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568783,
        "val": "[568783] Jedla 6111 [568783] Jedlá"
    },
    {
        "kod": 568805,
        "nazev": "Jeřišno",
        "popis": "[568805] Jeřišno",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568805,
        "val": "[568805] Jerisno 6104 [568805] Jeřišno"
    },
    {
        "kod": 548413,
        "nazev": "Jilem",
        "popis": "[548413] Jilem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548413,
        "val": "[548413] Jilem 6104 [548413] Jilem"
    },
    {
        "kod": 546216,
        "nazev": "Jitkov",
        "popis": "[546216] Jitkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 546216,
        "val": "[546216] Jitkov 6104 [546216] Jitkov"
    },
    {
        "kod": 568821,
        "nazev": "Kámen",
        "popis": "[568821] Kámen",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568821,
        "val": "[568821] Kamen 6102 [568821] Kámen"
    },
    {
        "kod": 568848,
        "nazev": "Kamenná Lhota",
        "popis": "[568848] Kamenná Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568848,
        "val": "[568848] Kamenna Lhota 6111 [568848] Kamenná Lhota"
    },
    {
        "kod": 568856,
        "nazev": "Klokočov",
        "popis": "[568856] Klokočov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568856,
        "val": "[568856] Klokocov 6104 [568856] Klokočov"
    },
    {
        "kod": 548286,
        "nazev": "Knyk",
        "popis": "[548286] Knyk",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548286,
        "val": "[548286] Knyk 6102 [548286] Knyk"
    },
    {
        "kod": 548529,
        "nazev": "Kochánov",
        "popis": "[548529] Kochánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548529,
        "val": "[548529] Kochanov 6102 [548529] Kochánov"
    },
    {
        "kod": 568881,
        "nazev": "Kojetín",
        "popis": "[568881] Kojetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568881,
        "val": "[568881] Kojetin 6102 [568881] Kojetín"
    },
    {
        "kod": 548189,
        "nazev": "Kouty",
        "popis": "[548189] Kouty",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 548189,
        "val": "[548189] Kouty 6111 [548189] Kouty"
    },
    {
        "kod": 568899,
        "nazev": "Kozlov",
        "popis": "[568899] Kozlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568899,
        "val": "[568899] Kozlov 6111 [568899] Kozlov"
    },
    {
        "kod": 568902,
        "nazev": "Kožlí",
        "popis": "[568902] Kožlí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568902,
        "val": "[568902] Kozli 6111 [568902] Kožlí"
    },
    {
        "kod": 548618,
        "nazev": "Kraborovice",
        "popis": "[548618] Kraborovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548618,
        "val": "[548618] Kraborovice 6104 [548618] Kraborovice"
    },
    {
        "kod": 568929,
        "nazev": "Krásná Hora",
        "popis": "[568929] Krásná Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568929,
        "val": "[568929] Krasna Hora 6102 [568929] Krásná Hora"
    },
    {
        "kod": 568937,
        "nazev": "Krátká Ves",
        "popis": "[568937] Krátká Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568937,
        "val": "[568937] Kratka Ves 6102 [568937] Krátká Ves"
    },
    {
        "kod": 568945,
        "nazev": "Krucemburk",
        "popis": "[568945] Krucemburk",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 568945,
        "val": "[568945] Krucemburk 6104 [568945] Krucemburk"
    },
    {
        "kod": 548570,
        "nazev": "Kunemil",
        "popis": "[548570] Kunemil",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 548570,
        "val": "[548570] Kunemil 6111 [548570] Kunemil"
    },
    {
        "kod": 568953,
        "nazev": "Květinov",
        "popis": "[568953] Květinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568953,
        "val": "[568953] Kvetinov 6102 [568953] Květinov"
    },
    {
        "kod": 548308,
        "nazev": "Kyjov",
        "popis": "[548308] Kyjov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548308,
        "val": "[548308] Kyjov 6102 [548308] Kyjov"
    },
    {
        "kod": 568970,
        "nazev": "Kynice",
        "popis": "[568970] Kynice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568970,
        "val": "[568970] Kynice 6111 [568970] Kynice"
    },
    {
        "kod": 548481,
        "nazev": "Lány",
        "popis": "[548481] Lány",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548481,
        "val": "[548481] Lany 6104 [548481] Lány"
    },
    {
        "kod": 568988,
        "nazev": "Ledeč nad Sázavou",
        "popis": "[568988] Ledeč nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 568988,
        "val": "[568988] Ledec nad Sazavou 6111 [568988] Ledeč nad Sázavou"
    },
    {
        "kod": 568996,
        "nazev": "Leškovice",
        "popis": "[568996] Leškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 568996,
        "val": "[568996] Leskovice 6102 [568996] Leškovice"
    },
    {
        "kod": 569011,
        "nazev": "Leština u Světlé",
        "popis": "[569011] Leština u Světlé",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569011,
        "val": "[569011] Lestina u Svetle 6111 [569011] Leština u Světlé"
    },
    {
        "kod": 569020,
        "nazev": "Libice nad Doubravou",
        "popis": "[569020] Libice nad Doubravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569020,
        "val": "[569020] Libice nad Doubravou 6104 [569020] Libice nad Doubravou"
    },
    {
        "kod": 569038,
        "nazev": "Lípa",
        "popis": "[569038] Lípa",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569038,
        "val": "[569038] Lipa 6102 [569038] Lípa"
    },
    {
        "kod": 569046,
        "nazev": "Lipnice nad Sázavou",
        "popis": "[569046] Lipnice nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569046,
        "val": "[569046] Lipnice nad Sazavou 6102 [569046] Lipnice nad Sázavou"
    },
    {
        "kod": 569062,
        "nazev": "Lučice",
        "popis": "[569062] Lučice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569062,
        "val": "[569062] Lucice 6102 [569062] Lučice"
    },
    {
        "kod": 569071,
        "nazev": "Malčín",
        "popis": "[569071] Malčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569071,
        "val": "[569071] Malcin 6111 [569071] Malčín"
    },
    {
        "kod": 569089,
        "nazev": "Maleč",
        "popis": "[569089] Maleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569089,
        "val": "[569089] Malec 6104 [569089] Maleč"
    },
    {
        "kod": 548316,
        "nazev": "Michalovice",
        "popis": "[548316] Michalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548316,
        "val": "[548316] Michalovice 6102 [548316] Michalovice"
    },
    {
        "kod": 569127,
        "nazev": "Modlíkov",
        "popis": "[569127] Modlíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569127,
        "val": "[569127] Modlikov 6102 [569127] Modlíkov"
    },
    {
        "kod": 548197,
        "nazev": "Nejepín",
        "popis": "[548197] Nejepín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548197,
        "val": "[548197] Nejepin 6104 [548197] Nejepín"
    },
    {
        "kod": 569160,
        "nazev": "Nová Ves u Chotěboře",
        "popis": "[569160] Nová Ves u Chotěboře",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569160,
        "val": "[569160] Nova Ves u Chotebore 6104 [569160] Nová Ves u Chotěboře"
    },
    {
        "kod": 569151,
        "nazev": "Nová Ves u Leštiny",
        "popis": "[569151] Nová Ves u Leštiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569151,
        "val": "[569151] Nova Ves u Lestiny 6102 [569151] Nová Ves u Leštiny"
    },
    {
        "kod": 555266,
        "nazev": "Nová Ves u Světlé",
        "popis": "[555266] Nová Ves u Světlé",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 555266,
        "val": "[555266] Nova Ves u Svetle 6111 [555266] Nová Ves u Světlé"
    },
    {
        "kod": 569186,
        "nazev": "Okrouhlice",
        "popis": "[569186] Okrouhlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569186,
        "val": "[569186] Okrouhlice 6102 [569186] Okrouhlice"
    },
    {
        "kod": 548588,
        "nazev": "Okrouhlička",
        "popis": "[548588] Okrouhlička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548588,
        "val": "[548588] Okrouhlicka 6102 [548588] Okrouhlička"
    },
    {
        "kod": 569208,
        "nazev": "Olešenka",
        "popis": "[569208] Olešenka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569208,
        "val": "[569208] Olesenka 6102 [569208] Olešenka"
    },
    {
        "kod": 569216,
        "nazev": "Olešná",
        "popis": "[569216] Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569216,
        "val": "[569216] Olesna 6102 [569216] Olešná"
    },
    {
        "kod": 548359,
        "nazev": "Ostrov",
        "popis": "[548359] Ostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 548359,
        "val": "[548359] Ostrov 6111 [548359] Ostrov"
    },
    {
        "kod": 569224,
        "nazev": "Oudoleň",
        "popis": "[569224] Oudoleň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569224,
        "val": "[569224] Oudolen 6104 [569224] Oudoleň"
    },
    {
        "kod": 569232,
        "nazev": "Ovesná Lhota",
        "popis": "[569232] Ovesná Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569232,
        "val": "[569232] Ovesna Lhota 6111 [569232] Ovesná Lhota"
    },
    {
        "kod": 569241,
        "nazev": "Pavlov",
        "popis": "[569241] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569241,
        "val": "[569241] Pavlov 6111 [569241] Pavlov"
    },
    {
        "kod": 548634,
        "nazev": "Podmoklany",
        "popis": "[548634] Podmoklany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548634,
        "val": "[548634] Podmoklany 6104 [548634] Podmoklany"
    },
    {
        "kod": 548251,
        "nazev": "Podmoky",
        "popis": "[548251] Podmoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548251,
        "val": "[548251] Podmoky 6102 [548251] Podmoky"
    },
    {
        "kod": 569291,
        "nazev": "Pohled",
        "popis": "[569291] Pohled",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569291,
        "val": "[569291] Pohled 6102 [569291] Pohled"
    },
    {
        "kod": 573591,
        "nazev": "Pohleď",
        "popis": "[573591] Pohleď",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 573591,
        "val": "[573591] Pohled 6111 [573591] Pohleď"
    },
    {
        "kod": 569313,
        "nazev": "Prosíčka",
        "popis": "[569313] Prosíčka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569313,
        "val": "[569313] Prosicka 6111 [569313] Prosíčka"
    },
    {
        "kod": 569321,
        "nazev": "Přibyslav",
        "popis": "[569321] Přibyslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569321,
        "val": "[569321] Pribyslav 6102 [569321] Přibyslav"
    },
    {
        "kod": 569348,
        "nazev": "Příseka",
        "popis": "[569348] Příseka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569348,
        "val": "[569348] Priseka 6111 [569348] Příseka"
    },
    {
        "kod": 569364,
        "nazev": "Radostín",
        "popis": "[569364] Radostín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569364,
        "val": "[569364] Radostin 6102 [569364] Radostín"
    },
    {
        "kod": 569399,
        "nazev": "Rozsochatec",
        "popis": "[569399] Rozsochatec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569399,
        "val": "[569399] Rozsochatec 6102 [569399] Rozsochatec"
    },
    {
        "kod": 569402,
        "nazev": "Rušinov",
        "popis": "[569402] Rušinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569402,
        "val": "[569402] Rusinov 6104 [569402] Rušinov"
    },
    {
        "kod": 569411,
        "nazev": "Rybníček",
        "popis": "[569411] Rybníček",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569411,
        "val": "[569411] Rybnicek 6102 [569411] Rybníček"
    },
    {
        "kod": 569429,
        "nazev": "Sázavka",
        "popis": "[569429] Sázavka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569429,
        "val": "[569429] Sazavka 6111 [569429] Sázavka"
    },
    {
        "kod": 548421,
        "nazev": "Sedletín",
        "popis": "[548421] Sedletín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548421,
        "val": "[548421] Sedletin 6104 [548421] Sedletín"
    },
    {
        "kod": 548324,
        "nazev": "Skorkov",
        "popis": "[548324] Skorkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548324,
        "val": "[548324] Skorkov 6102 [548324] Skorkov"
    },
    {
        "kod": 569461,
        "nazev": "Skryje",
        "popis": "[569461] Skryje",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569461,
        "val": "[569461] Skryje 6102 [569461] Skryje"
    },
    {
        "kod": 569470,
        "nazev": "Skuhrov",
        "popis": "[569470] Skuhrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569470,
        "val": "[569470] Skuhrov 6102 [569470] Skuhrov"
    },
    {
        "kod": 548553,
        "nazev": "Slavětín",
        "popis": "[548553] Slavětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548553,
        "val": "[548553] Slavetin 6104 [548553] Slavětín"
    },
    {
        "kod": 569488,
        "nazev": "Slavíkov",
        "popis": "[569488] Slavíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569488,
        "val": "[569488] Slavikov 6104 [569488] Slavíkov"
    },
    {
        "kod": 548341,
        "nazev": "Slavníč",
        "popis": "[548341] Slavníč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548341,
        "val": "[548341] Slavnic 6102 [548341] Slavníč"
    },
    {
        "kod": 548499,
        "nazev": "Sloupno",
        "popis": "[548499] Sloupno",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 548499,
        "val": "[548499] Sloupno 6104 [548499] Sloupno"
    },
    {
        "kod": 573604,
        "nazev": "Služátky",
        "popis": "[573604] Služátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 573604,
        "val": "[573604] Sluzatky 6111 [573604] Služátky"
    },
    {
        "kod": 569518,
        "nazev": "Sobíňov",
        "popis": "[569518] Sobíňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569518,
        "val": "[569518] Sobinov 6104 [569518] Sobíňov"
    },
    {
        "kod": 569534,
        "nazev": "Stříbrné Hory",
        "popis": "[569534] Stříbrné Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569534,
        "val": "[569534] Stribrne Hory 6102 [569534] Stříbrné Hory"
    },
    {
        "kod": 569569,
        "nazev": "Světlá nad Sázavou",
        "popis": "[569569] Světlá nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569569,
        "val": "[569569] Svetla nad Sazavou 6111 [569569] Světlá nad Sázavou"
    },
    {
        "kod": 569585,
        "nazev": "Šlapanov",
        "popis": "[569585] Šlapanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569585,
        "val": "[569585] Slapanov 6102 [569585] Šlapanov"
    },
    {
        "kod": 569593,
        "nazev": "Štoky",
        "popis": "[569593] Štoky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569593,
        "val": "[569593] Stoky 6102 [569593] Štoky"
    },
    {
        "kod": 569615,
        "nazev": "Tis",
        "popis": "[569615] Tis",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569615,
        "val": "[569615] Tis 6102 [569615] Tis"
    },
    {
        "kod": 569623,
        "nazev": "Trpišovice",
        "popis": "[569623] Trpišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569623,
        "val": "[569623] Trpisovice 6111 [569623] Trpišovice"
    },
    {
        "kod": 569640,
        "nazev": "Uhelná Příbram",
        "popis": "[569640] Uhelná Příbram",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569640,
        "val": "[569640] Uhelna Pribram 6104 [569640] Uhelná Příbram"
    },
    {
        "kod": 548537,
        "nazev": "Úhořilka",
        "popis": "[548537] Úhořilka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548537,
        "val": "[548537] Uhorilka 6102 [548537] Úhořilka"
    },
    {
        "kod": 569658,
        "nazev": "Úsobí",
        "popis": "[569658] Úsobí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569658,
        "val": "[569658] Usobi 6102 [569658] Úsobí"
    },
    {
        "kod": 569674,
        "nazev": "Vepříkov",
        "popis": "[569674] Vepříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569674,
        "val": "[569674] Veprikov 6104 [569674] Vepříkov"
    },
    {
        "kod": 569682,
        "nazev": "Veselý Žďár",
        "popis": "[569682] Veselý Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569682,
        "val": "[569682] Vesely Zdar 6102 [569682] Veselý Žďár"
    },
    {
        "kod": 569691,
        "nazev": "Věž",
        "popis": "[569691] Věž",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569691,
        "val": "[569691] Vez 6102 [569691] Věž"
    },
    {
        "kod": 569704,
        "nazev": "Věžnice",
        "popis": "[569704] Věžnice",
        "datum_od": "",
        "datum_do": 2020,
        "orp": 6105,
        "iczuj": 569704,
        "val": "[569704] Veznice 6105 [569704] Věžnice"
    },
    {
        "kod": 569712,
        "nazev": "Vilémov",
        "popis": "[569712] Vilémov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569712,
        "val": "[569712] Vilemov 6104 [569712] Vilémov"
    },
    {
        "kod": 569721,
        "nazev": "Vilémovice",
        "popis": "[569721] Vilémovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569721,
        "val": "[569721] Vilemovice 6111 [569721] Vilémovice"
    },
    {
        "kod": 573582,
        "nazev": "Víska",
        "popis": "[573582] Víska",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 573582,
        "val": "[573582] Viska 6104 [573582] Víska"
    },
    {
        "kod": 569739,
        "nazev": "Vlkanov",
        "popis": "[569739] Vlkanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6111,
        "iczuj": 569739,
        "val": "[569739] Vlkanov 6111 [569739] Vlkanov"
    },
    {
        "kod": 530654,
        "nazev": "Vysoká",
        "popis": "[530654] Vysoká",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 530654,
        "val": "[530654] Vysoka 6102 [530654] Vysoká"
    },
    {
        "kod": 548626,
        "nazev": "Zvěstovice",
        "popis": "[548626] Zvěstovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 548626,
        "val": "[548626] Zvestovice 6102 [548626] Zvěstovice"
    },
    {
        "kod": 530662,
        "nazev": "Ždírec",
        "popis": "[530662] Ždírec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 530662,
        "val": "[530662] Zdirec 6102 [530662] Ždírec"
    },
    {
        "kod": 569780,
        "nazev": "Ždírec nad Doubravou",
        "popis": "[569780] Ždírec nad Doubravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6104,
        "iczuj": 569780,
        "val": "[569780] Zdirec nad Doubravou 6104 [569780] Ždírec nad Doubravou"
    },
    {
        "kod": 569801,
        "nazev": "Žižkovo Pole",
        "popis": "[569801] Žižkovo Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569801,
        "val": "[569801] Zizkovo Pole 6102 [569801] Žižkovo Pole"
    },
    {
        "kod": 586854,
        "nazev": "Arnolec",
        "popis": "[586854] Arnolec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586854,
        "val": "[586854] Arnolec 6105 [586854] Arnolec"
    },
    {
        "kod": 586862,
        "nazev": "Batelov",
        "popis": "[586862] Batelov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586862,
        "val": "[586862] Batelov 6105 [586862] Batelov"
    },
    {
        "kod": 586889,
        "nazev": "Bílý Kámen",
        "popis": "[586889] Bílý Kámen",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586889,
        "val": "[586889] Bily Kamen 6105 [586889] Bílý Kámen"
    },
    {
        "kod": 586897,
        "nazev": "Bítovčice",
        "popis": "[586897] Bítovčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586897,
        "val": "[586897] Bitovcice 6105 [586897] Bítovčice"
    },
    {
        "kod": 586901,
        "nazev": "Bohuslavice",
        "popis": "[586901] Bohuslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 586901,
        "val": "[586901] Bohuslavice 6112 [586901] Bohuslavice"
    },
    {
        "kod": 587184,
        "nazev": "Borovná",
        "popis": "[587184] Borovná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587184,
        "val": "[587184] Borovna 6112 [587184] Borovná"
    },
    {
        "kod": 586927,
        "nazev": "Boršov",
        "popis": "[586927] Boršov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586927,
        "val": "[586927] Borsov 6105 [586927] Boršov"
    },
    {
        "kod": 586943,
        "nazev": "Brtnice",
        "popis": "[586943] Brtnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586943,
        "val": "[586943] Brtnice 6105 [586943] Brtnice"
    },
    {
        "kod": 590371,
        "nazev": "Brtnička",
        "popis": "[590371] Brtnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 590371,
        "val": "[590371] Brtnicka 6105 [590371] Brtnička"
    },
    {
        "kod": 586951,
        "nazev": "Brzkov",
        "popis": "[586951] Brzkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586951,
        "val": "[586951] Brzkov 6105 [586951] Brzkov"
    },
    {
        "kod": 586978,
        "nazev": "Cejle",
        "popis": "[586978] Cejle",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586978,
        "val": "[586978] Cejle 6105 [586978] Cejle"
    },
    {
        "kod": 586986,
        "nazev": "Cerekvička-Rosice",
        "popis": "[586986] Cerekvička-Rosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586986,
        "val": "[586986] Cerekvicka-Rosice 6105 [586986] Cerekvička-Rosice"
    },
    {
        "kod": 587001,
        "nazev": "Černíč",
        "popis": "[587001] Černíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587001,
        "val": "[587001] Cernic 6112 [587001] Černíč"
    },
    {
        "kod": 587117,
        "nazev": "Čížov",
        "popis": "[587117] Čížov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587117,
        "val": "[587117] Cizov 6105 [587117] Čížov"
    },
    {
        "kod": 587010,
        "nazev": "Dlouhá Brtnice",
        "popis": "[587010] Dlouhá Brtnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587010,
        "val": "[587010] Dlouha Brtnice 6105 [587010] Dlouhá Brtnice"
    },
    {
        "kod": 587028,
        "nazev": "Dobronín",
        "popis": "[587028] Dobronín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587028,
        "val": "[587028] Dobronin 6105 [587028] Dobronín"
    },
    {
        "kod": 587036,
        "nazev": "Dobroutov",
        "popis": "[587036] Dobroutov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587036,
        "val": "[587036] Dobroutov 6105 [587036] Dobroutov"
    },
    {
        "kod": 587044,
        "nazev": "Dolní Cerekev",
        "popis": "[587044] Dolní Cerekev",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587044,
        "val": "[587044] Dolni Cerekev 6105 [587044] Dolní Cerekev"
    },
    {
        "kod": 587061,
        "nazev": "Dolní Vilímeč",
        "popis": "[587061] Dolní Vilímeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587061,
        "val": "[587061] Dolni Vilimec 6112 [587061] Dolní Vilímeč"
    },
    {
        "kod": 587079,
        "nazev": "Doupě",
        "popis": "[587079] Doupě",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587079,
        "val": "[587079] Doupe 6112 [587079] Doupě"
    },
    {
        "kod": 587087,
        "nazev": "Dudín",
        "popis": "[587087] Dudín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587087,
        "val": "[587087] Dudin 6105 [587087] Dudín"
    },
    {
        "kod": 587095,
        "nazev": "Dušejov",
        "popis": "[587095] Dušejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587095,
        "val": "[587095] Dusejov 6105 [587095] Dušejov"
    },
    {
        "kod": 506729,
        "nazev": "Dvorce",
        "popis": "[506729] Dvorce",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 506729,
        "val": "[506729] Dvorce 6105 [506729] Dvorce"
    },
    {
        "kod": 587109,
        "nazev": "Dyjice",
        "popis": "[587109] Dyjice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587109,
        "val": "[587109] Dyjice 6112 [587109] Dyjice"
    },
    {
        "kod": 587125,
        "nazev": "Hladov",
        "popis": "[587125] Hladov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587125,
        "val": "[587125] Hladov 6105 [587125] Hladov"
    },
    {
        "kod": 587141,
        "nazev": "Hodice",
        "popis": "[587141] Hodice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587141,
        "val": "[587141] Hodice 6105 [587141] Hodice"
    },
    {
        "kod": 587150,
        "nazev": "Hojkov",
        "popis": "[587150] Hojkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587150,
        "val": "[587150] Hojkov 6105 [587150] Hojkov"
    },
    {
        "kod": 587168,
        "nazev": "Horní Dubenky",
        "popis": "[587168] Horní Dubenky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587168,
        "val": "[587168] Horni Dubenky 6105 [587168] Horní Dubenky"
    },
    {
        "kod": 587206,
        "nazev": "Horní Myslová",
        "popis": "[587206] Horní Myslová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587206,
        "val": "[587206] Horni Myslova 6112 [587206] Horní Myslová"
    },
    {
        "kod": 587192,
        "nazev": "Hostětice",
        "popis": "[587192] Hostětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587192,
        "val": "[587192] Hostetice 6112 [587192] Hostětice"
    },
    {
        "kod": 590681,
        "nazev": "Hrutov",
        "popis": "[590681] Hrutov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 590681,
        "val": "[590681] Hrutov 6105 [590681] Hrutov"
    },
    {
        "kod": 587222,
        "nazev": "Hubenov",
        "popis": "[587222] Hubenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587222,
        "val": "[587222] Hubenov 6105 [587222] Hubenov"
    },
    {
        "kod": 550281,
        "nazev": "Hybrálec",
        "popis": "[550281] Hybrálec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 550281,
        "val": "[550281] Hybralec 6105 [550281] Hybrálec"
    },
    {
        "kod": 587249,
        "nazev": "Jamné",
        "popis": "[587249] Jamné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587249,
        "val": "[587249] Jamne 6105 [587249] Jamné"
    },
    {
        "kod": 587265,
        "nazev": "Jersín",
        "popis": "[587265] Jersín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587265,
        "val": "[587265] Jersin 6105 [587265] Jersín"
    },
    {
        "kod": 587273,
        "nazev": "Jezdovice",
        "popis": "[587273] Jezdovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587273,
        "val": "[587273] Jezdovice 6105 [587273] Jezdovice"
    },
    {
        "kod": 587281,
        "nazev": "Ježená",
        "popis": "[587281] Ježená",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587281,
        "val": "[587281] Jezena 6105 [587281] Ježená"
    },
    {
        "kod": 586846,
        "nazev": "Jihlava",
        "popis": "[586846] Jihlava",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 586846,
        "val": "[586846] Jihlava 6105 [586846] Jihlava"
    },
    {
        "kod": 587290,
        "nazev": "Jihlávka",
        "popis": "[587290] Jihlávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587290,
        "val": "[587290] Jihlavka 6105 [587290] Jihlávka"
    },
    {
        "kod": 587303,
        "nazev": "Jindřichovice",
        "popis": "[587303] Jindřichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587303,
        "val": "[587303] Jindrichovice 6112 [587303] Jindřichovice"
    },
    {
        "kod": 587320,
        "nazev": "Kalhov",
        "popis": "[587320] Kalhov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587320,
        "val": "[587320] Kalhov 6105 [587320] Kalhov"
    },
    {
        "kod": 587338,
        "nazev": "Kaliště",
        "popis": "[587338] Kaliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587338,
        "val": "[587338] Kaliste 6105 [587338] Kaliště"
    },
    {
        "kod": 587346,
        "nazev": "Kamenice",
        "popis": "[587346] Kamenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587346,
        "val": "[587346] Kamenice 6105 [587346] Kamenice"
    },
    {
        "kod": 587362,
        "nazev": "Kamenná",
        "popis": "[587362] Kamenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587362,
        "val": "[587362] Kamenna 6105 [587362] Kamenná"
    },
    {
        "kod": 587371,
        "nazev": "Klatovec",
        "popis": "[587371] Klatovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587371,
        "val": "[587371] Klatovec 6112 [587371] Klatovec"
    },
    {
        "kod": 590843,
        "nazev": "Kněžice",
        "popis": "[590843] Kněžice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 590843,
        "val": "[590843] Knezice 6105 [590843] Kněžice"
    },
    {
        "kod": 587389,
        "nazev": "Knínice",
        "popis": "[587389] Knínice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587389,
        "val": "[587389] Kninice 6112 [587389] Knínice"
    },
    {
        "kod": 587401,
        "nazev": "Kostelec",
        "popis": "[587401] Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587401,
        "val": "[587401] Kostelec 6105 [587401] Kostelec"
    },
    {
        "kod": 587419,
        "nazev": "Kostelní Myslová",
        "popis": "[587419] Kostelní Myslová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587419,
        "val": "[587419] Kostelni Myslova 6112 [587419] Kostelní Myslová"
    },
    {
        "kod": 587427,
        "nazev": "Kozlov",
        "popis": "[587427] Kozlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587427,
        "val": "[587427] Kozlov 6105 [587427] Kozlov"
    },
    {
        "kod": 587435,
        "nazev": "Krahulčí",
        "popis": "[587435] Krahulčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587435,
        "val": "[587435] Krahulci 6112 [587435] Krahulčí"
    },
    {
        "kod": 587443,
        "nazev": "Krasonice",
        "popis": "[587443] Krasonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587443,
        "val": "[587443] Krasonice 6112 [587443] Krasonice"
    },
    {
        "kod": 587451,
        "nazev": "Lhotka",
        "popis": "[587451] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587451,
        "val": "[587451] Lhotka 6112 [587451] Lhotka"
    },
    {
        "kod": 587478,
        "nazev": "Luka nad Jihlavou",
        "popis": "[587478] Luka nad Jihlavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587478,
        "val": "[587478] Luka nad Jihlavou 6105 [587478] Luka nad Jihlavou"
    },
    {
        "kod": 587486,
        "nazev": "Malý Beranov",
        "popis": "[587486] Malý Beranov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587486,
        "val": "[587486] Maly Beranov 6105 [587486] Malý Beranov"
    },
    {
        "kod": 587494,
        "nazev": "Markvartice",
        "popis": "[587494] Markvartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587494,
        "val": "[587494] Markvartice 6112 [587494] Markvartice"
    },
    {
        "kod": 587508,
        "nazev": "Měšín",
        "popis": "[587508] Měšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587508,
        "val": "[587508] Mesin 6105 [587508] Měšín"
    },
    {
        "kod": 587524,
        "nazev": "Milíčov",
        "popis": "[587524] Milíčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587524,
        "val": "[587524] Milicov 6105 [587524] Milíčov"
    },
    {
        "kod": 587532,
        "nazev": "Mirošov",
        "popis": "[587532] Mirošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587532,
        "val": "[587532] Mirosov 6105 [587532] Mirošov"
    },
    {
        "kod": 587541,
        "nazev": "Mrákotín",
        "popis": "[587541] Mrákotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587541,
        "val": "[587541] Mrakotin 6112 [587541] Mrákotín"
    },
    {
        "kod": 587559,
        "nazev": "Mysletice",
        "popis": "[587559] Mysletice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587559,
        "val": "[587559] Mysletice 6112 [587559] Mysletice"
    },
    {
        "kod": 587567,
        "nazev": "Mysliboř",
        "popis": "[587567] Mysliboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587567,
        "val": "[587567] Myslibor 6112 [587567] Mysliboř"
    },
    {
        "kod": 587575,
        "nazev": "Nadějov",
        "popis": "[587575] Nadějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587575,
        "val": "[587575] Nadejov 6105 [587575] Nadějov"
    },
    {
        "kod": 587583,
        "nazev": "Nevcehle",
        "popis": "[587583] Nevcehle",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587583,
        "val": "[587583] Nevcehle 6112 [587583] Nevcehle"
    },
    {
        "kod": 587591,
        "nazev": "Nová Říše",
        "popis": "[587591] Nová Říše",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587591,
        "val": "[587591] Nova Rise 6112 [587591] Nová Říše"
    },
    {
        "kod": 587613,
        "nazev": "Olšany",
        "popis": "[587613] Olšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587613,
        "val": "[587613] Olsany 6112 [587613] Olšany"
    },
    {
        "kod": 587214,
        "nazev": "Olší",
        "popis": "[587214] Olší",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587214,
        "val": "[587214] Olsi 6112 [587214] Olší"
    },
    {
        "kod": 587621,
        "nazev": "Opatov",
        "popis": "[587621] Opatov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587621,
        "val": "[587621] Opatov 6105 [587621] Opatov"
    },
    {
        "kod": 587630,
        "nazev": "Ořechov",
        "popis": "[587630] Ořechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587630,
        "val": "[587630] Orechov 6112 [587630] Ořechov"
    },
    {
        "kod": 587648,
        "nazev": "Otín",
        "popis": "[587648] Otín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587648,
        "val": "[587648] Otin 6105 [587648] Otín"
    },
    {
        "kod": 587656,
        "nazev": "Panenská Rozsíčka",
        "popis": "[587656] Panenská Rozsíčka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587656,
        "val": "[587656] Panenska Rozsicka 6105 [587656] Panenská Rozsíčka"
    },
    {
        "kod": 587672,
        "nazev": "Panské Dubenky",
        "popis": "[587672] Panské Dubenky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587672,
        "val": "[587672] Panske Dubenky 6112 [587672] Panské Dubenky"
    },
    {
        "kod": 587681,
        "nazev": "Pavlov",
        "popis": "[587681] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587681,
        "val": "[587681] Pavlov 6105 [587681] Pavlov"
    },
    {
        "kod": 587702,
        "nazev": "Plandry",
        "popis": "[587702] Plandry",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587702,
        "val": "[587702] Plandry 6105 [587702] Plandry"
    },
    {
        "kod": 587711,
        "nazev": "Polná",
        "popis": "[587711] Polná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587711,
        "val": "[587711] Polna 6105 [587711] Polná"
    },
    {
        "kod": 587745,
        "nazev": "Puklice",
        "popis": "[587745] Puklice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587745,
        "val": "[587745] Puklice 6105 [587745] Puklice"
    },
    {
        "kod": 587761,
        "nazev": "Radkov",
        "popis": "[587761] Radkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587761,
        "val": "[587761] Radkov 6112 [587761] Radkov"
    },
    {
        "kod": 587176,
        "nazev": "Rančířov",
        "popis": "[587176] Rančířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587176,
        "val": "[587176] Rancirov 6105 [587176] Rančířov"
    },
    {
        "kod": 587788,
        "nazev": "Rantířov",
        "popis": "[587788] Rantířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587788,
        "val": "[587788] Rantirov 6105 [587788] Rantířov"
    },
    {
        "kod": 587796,
        "nazev": "Rohozná",
        "popis": "[587796] Rohozná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587796,
        "val": "[587796] Rohozna 6105 [587796] Rohozná"
    },
    {
        "kod": 587800,
        "nazev": "Rozseč",
        "popis": "[587800] Rozseč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587800,
        "val": "[587800] Rozsec 6112 [587800] Rozseč"
    },
    {
        "kod": 587818,
        "nazev": "Růžená",
        "popis": "[587818] Růžená",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587818,
        "val": "[587818] Ruzena 6105 [587818] Růžená"
    },
    {
        "kod": 587826,
        "nazev": "Rybné",
        "popis": "[587826] Rybné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587826,
        "val": "[587826] Rybne 6105 [587826] Rybné"
    },
    {
        "kod": 587834,
        "nazev": "Řásná",
        "popis": "[587834] Řásná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587834,
        "val": "[587834] Rasna 6112 [587834] Řásná"
    },
    {
        "kod": 587851,
        "nazev": "Řídelov",
        "popis": "[587851] Řídelov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587851,
        "val": "[587851] Ridelov 6112 [587851] Řídelov"
    },
    {
        "kod": 587877,
        "nazev": "Sedlatice",
        "popis": "[587877] Sedlatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587877,
        "val": "[587877] Sedlatice 6112 [587877] Sedlatice"
    },
    {
        "kod": 587885,
        "nazev": "Sedlejov",
        "popis": "[587885] Sedlejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587885,
        "val": "[587885] Sedlejov 6112 [587885] Sedlejov"
    },
    {
        "kod": 550299,
        "nazev": "Smrčná",
        "popis": "[550299] Smrčná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 550299,
        "val": "[550299] Smrcna 6105 [550299] Smrčná"
    },
    {
        "kod": 587915,
        "nazev": "Stáj",
        "popis": "[587915] Stáj",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587915,
        "val": "[587915] Staj 6105 [587915] Stáj"
    },
    {
        "kod": 587923,
        "nazev": "Stará Říše",
        "popis": "[587923] Stará Říše",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587923,
        "val": "[587923] Stara Rise 6112 [587923] Stará Říše"
    },
    {
        "kod": 587931,
        "nazev": "Stonařov",
        "popis": "[587931] Stonařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587931,
        "val": "[587931] Stonarov 6105 [587931] Stonařov"
    },
    {
        "kod": 587940,
        "nazev": "Strachoňovice",
        "popis": "[587940] Strachoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587940,
        "val": "[587940] Strachonovice 6112 [587940] Strachoňovice"
    },
    {
        "kod": 587958,
        "nazev": "Střítež",
        "popis": "[587958] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587958,
        "val": "[587958] Stritez 6105 [587958] Střítež"
    },
    {
        "kod": 587982,
        "nazev": "Suchá",
        "popis": "[587982] Suchá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 587982,
        "val": "[587982] Sucha 6105 [587982] Suchá"
    },
    {
        "kod": 587991,
        "nazev": "Svojkovice",
        "popis": "[587991] Svojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587991,
        "val": "[587991] Svojkovice 6112 [587991] Svojkovice"
    },
    {
        "kod": 588008,
        "nazev": "Šimanov",
        "popis": "[588008] Šimanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588008,
        "val": "[588008] Simanov 6105 [588008] Šimanov"
    },
    {
        "kod": 547255,
        "nazev": "Švábov",
        "popis": "[547255] Švábov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 547255,
        "val": "[547255] Svabov 6105 [547255] Švábov"
    },
    {
        "kod": 588024,
        "nazev": "Telč",
        "popis": "[588024] Telč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588024,
        "val": "[588024] Telc 6112 [588024] Telč"
    },
    {
        "kod": 588032,
        "nazev": "Třešť",
        "popis": "[588032] Třešť",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588032,
        "val": "[588032] Trest 6105 [588032] Třešť"
    },
    {
        "kod": 588041,
        "nazev": "Třeštice",
        "popis": "[588041] Třeštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588041,
        "val": "[588041] Trestice 6105 [588041] Třeštice"
    },
    {
        "kod": 588067,
        "nazev": "Urbanov",
        "popis": "[588067] Urbanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588067,
        "val": "[588067] Urbanov 6112 [588067] Urbanov"
    },
    {
        "kod": 588075,
        "nazev": "Ústí",
        "popis": "[588075] Ústí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588075,
        "val": "[588075] Usti 6105 [588075] Ústí"
    },
    {
        "kod": 588083,
        "nazev": "Vanov",
        "popis": "[588083] Vanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588083,
        "val": "[588083] Vanov 6112 [588083] Vanov"
    },
    {
        "kod": 588091,
        "nazev": "Vanůvek",
        "popis": "[588091] Vanůvek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588091,
        "val": "[588091] Vanuvek 6112 [588091] Vanůvek"
    },
    {
        "kod": 588105,
        "nazev": "Vápovice",
        "popis": "[588105] Vápovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588105,
        "val": "[588105] Vapovice 6112 [588105] Vápovice"
    },
    {
        "kod": 588113,
        "nazev": "Velký Beranov",
        "popis": "[588113] Velký Beranov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588113,
        "val": "[588113] Velky Beranov 6105 [588113] Velký Beranov"
    },
    {
        "kod": 588121,
        "nazev": "Větrný Jeníkov",
        "popis": "[588121] Větrný Jeníkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588121,
        "val": "[588121] Vetrny Jenikov 6105 [588121] Větrný Jeníkov"
    },
    {
        "kod": 588130,
        "nazev": "Věžnice",
        "popis": "[588130] Věžnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588130,
        "val": "[588130] Veznice 6105 [588130] Věžnice"
    },
    {
        "kod": 588148,
        "nazev": "Věžnička",
        "popis": "[588148] Věžnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588148,
        "val": "[588148] Veznicka 6105 [588148] Věžnička"
    },
    {
        "kod": 588156,
        "nazev": "Vílanec",
        "popis": "[588156] Vílanec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588156,
        "val": "[588156] Vilanec 6105 [588156] Vílanec"
    },
    {
        "kod": 588164,
        "nazev": "Volevčice",
        "popis": "[588164] Volevčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588164,
        "val": "[588164] Volevcice 6112 [588164] Volevčice"
    },
    {
        "kod": 588172,
        "nazev": "Vyskytná nad Jihlavou",
        "popis": "[588172] Vyskytná nad Jihlavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588172,
        "val": "[588172] Vyskytna nad Jihlavou 6105 [588172] Vyskytná nad Jihlavou"
    },
    {
        "kod": 588181,
        "nazev": "Vysoké Studnice",
        "popis": "[588181] Vysoké Studnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588181,
        "val": "[588181] Vysoke Studnice 6105 [588181] Vysoké Studnice"
    },
    {
        "kod": 588199,
        "nazev": "Vystrčenovice",
        "popis": "[588199] Vystrčenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588199,
        "val": "[588199] Vystrcenovice 6112 [588199] Vystrčenovice"
    },
    {
        "kod": 588202,
        "nazev": "Záborná",
        "popis": "[588202] Záborná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588202,
        "val": "[588202] Zaborna 6105 [588202] Záborná"
    },
    {
        "kod": 587231,
        "nazev": "Zadní Vydří",
        "popis": "[587231] Zadní Vydří",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 587231,
        "val": "[587231] Zadni Vydri 6112 [587231] Zadní Vydří"
    },
    {
        "kod": 588211,
        "nazev": "Zbilidy",
        "popis": "[588211] Zbilidy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588211,
        "val": "[588211] Zbilidy 6105 [588211] Zbilidy"
    },
    {
        "kod": 588229,
        "nazev": "Zbinohy",
        "popis": "[588229] Zbinohy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588229,
        "val": "[588229] Zbinohy 6105 [588229] Zbinohy"
    },
    {
        "kod": 588245,
        "nazev": "Zdeňkov",
        "popis": "[588245] Zdeňkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588245,
        "val": "[588245] Zdenkov 6112 [588245] Zdeňkov"
    },
    {
        "kod": 588253,
        "nazev": "Zhoř",
        "popis": "[588253] Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588253,
        "val": "[588253] Zhor 6105 [588253] Zhoř"
    },
    {
        "kod": 588261,
        "nazev": "Zvolenovice",
        "popis": "[588261] Zvolenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588261,
        "val": "[588261] Zvolenovice 6112 [588261] Zvolenovice"
    },
    {
        "kod": 588270,
        "nazev": "Žatec",
        "popis": "[588270] Žatec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6112,
        "iczuj": 588270,
        "val": "[588270] Zatec 6112 [588270] Žatec"
    },
    {
        "kod": 588288,
        "nazev": "Ždírec",
        "popis": "[588288] Ždírec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6105,
        "iczuj": 588288,
        "val": "[588288] Zdirec 6105 [588288] Ždírec"
    },
    {
        "kod": 509388,
        "nazev": "Arneštovice",
        "popis": "[509388] Arneštovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 509388,
        "val": "[509388] Arnestovice 6110 [509388] Arneštovice"
    },
    {
        "kod": 561118,
        "nazev": "Bácovice",
        "popis": "[561118] Bácovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561118,
        "val": "[561118] Bacovice 6110 [561118] Bácovice"
    },
    {
        "kod": 561126,
        "nazev": "Bělá",
        "popis": "[561126] Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561126,
        "val": "[561126] Bela 6110 [561126] Bělá"
    },
    {
        "kod": 547549,
        "nazev": "Bohdalín",
        "popis": "[547549] Bohdalín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547549,
        "val": "[547549] Bohdalin 6110 [547549] Bohdalín"
    },
    {
        "kod": 561240,
        "nazev": "Bořetice",
        "popis": "[561240] Bořetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561240,
        "val": "[561240] Boretice 6110 [561240] Bořetice"
    },
    {
        "kod": 509418,
        "nazev": "Bořetín",
        "popis": "[509418] Bořetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 509418,
        "val": "[509418] Boretin 6110 [509418] Bořetín"
    },
    {
        "kod": 547581,
        "nazev": "Božejov",
        "popis": "[547581] Božejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547581,
        "val": "[547581] Bozejov 6110 [547581] Božejov"
    },
    {
        "kod": 547603,
        "nazev": "Bratřice",
        "popis": "[547603] Bratřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 547603,
        "val": "[547603] Bratrice 6109 [547603] Bratřice"
    },
    {
        "kod": 547638,
        "nazev": "Budíkov",
        "popis": "[547638] Budíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 547638,
        "val": "[547638] Budikov 6103 [547638] Budíkov"
    },
    {
        "kod": 561312,
        "nazev": "Buřenice",
        "popis": "[561312] Buřenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561312,
        "val": "[561312] Burenice 6109 [561312] Buřenice"
    },
    {
        "kod": 561801,
        "nazev": "Bystrá",
        "popis": "[561801] Bystrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 561801,
        "val": "[561801] Bystra 6103 [561801] Bystrá"
    },
    {
        "kod": 547662,
        "nazev": "Cetoraz",
        "popis": "[547662] Cetoraz",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 547662,
        "val": "[547662] Cetoraz 6109 [547662] Cetoraz"
    },
    {
        "kod": 547689,
        "nazev": "Čáslavsko",
        "popis": "[547689] Čáslavsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 547689,
        "val": "[547689] Caslavsko 6109 [547689] Čáslavsko"
    },
    {
        "kod": 547719,
        "nazev": "Častrov",
        "popis": "[547719] Častrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547719,
        "val": "[547719] Castrov 6110 [547719] Častrov"
    },
    {
        "kod": 547735,
        "nazev": "Čejov",
        "popis": "[547735] Čejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 547735,
        "val": "[547735] Cejov 6103 [547735] Čejov"
    },
    {
        "kod": 529826,
        "nazev": "Čelistná",
        "popis": "[529826] Čelistná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 529826,
        "val": "[529826] Celistna 6110 [529826] Čelistná"
    },
    {
        "kod": 561142,
        "nazev": "Černov",
        "popis": "[561142] Černov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561142,
        "val": "[561142] Cernov 6110 [561142] Černov"
    },
    {
        "kod": 547760,
        "nazev": "Černovice",
        "popis": "[547760] Černovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547760,
        "val": "[547760] Cernovice 6110 [547760] Černovice"
    },
    {
        "kod": 547778,
        "nazev": "Červená Řečice",
        "popis": "[547778] Červená Řečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547778,
        "val": "[547778] Cervena Recice 6110 [547778] Červená Řečice"
    },
    {
        "kod": 598704,
        "nazev": "Čížkov",
        "popis": "[598704] Čížkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 598704,
        "val": "[598704] Cizkov 6110 [598704] Čížkov"
    },
    {
        "kod": 561924,
        "nazev": "Dehtáře",
        "popis": "[561924] Dehtáře",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561924,
        "val": "[561924] Dehtare 6110 [561924] Dehtáře"
    },
    {
        "kod": 561932,
        "nazev": "Dobrá Voda",
        "popis": "[561932] Dobrá Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561932,
        "val": "[561932] Dobra Voda 6110 [561932] Dobrá Voda"
    },
    {
        "kod": 561762,
        "nazev": "Dobrá Voda u Pacova",
        "popis": "[561762] Dobrá Voda u Pacova",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561762,
        "val": "[561762] Dobra Voda u Pacova 6109 [561762] Dobrá Voda u Pacova"
    },
    {
        "kod": 551546,
        "nazev": "Dubovice",
        "popis": "[551546] Dubovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 551546,
        "val": "[551546] Dubovice 6110 [551546] Dubovice"
    },
    {
        "kod": 529869,
        "nazev": "Důl",
        "popis": "[529869] Důl",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 529869,
        "val": "[529869] Dul 6109 [529869] Důl"
    },
    {
        "kod": 561754,
        "nazev": "Eš",
        "popis": "[561754] Eš",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561754,
        "val": "[561754] Es 6109 [561754] Eš"
    },
    {
        "kod": 547883,
        "nazev": "Hojanovice",
        "popis": "[547883] Hojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 547883,
        "val": "[547883] Hojanovice 6103 [547883] Hojanovice"
    },
    {
        "kod": 561096,
        "nazev": "Hojovice",
        "popis": "[561096] Hojovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561096,
        "val": "[561096] Hojovice 6110 [561096] Hojovice"
    },
    {
        "kod": 547913,
        "nazev": "Horní Cerekev",
        "popis": "[547913] Horní Cerekev",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547913,
        "val": "[547913] Horni Cerekev 6110 [547913] Horní Cerekev"
    },
    {
        "kod": 551589,
        "nazev": "Horní Rápotice",
        "popis": "[551589] Horní Rápotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 551589,
        "val": "[551589] Horni Rapotice 6103 [551589] Horní Rápotice"
    },
    {
        "kod": 547930,
        "nazev": "Horní Ves",
        "popis": "[547930] Horní Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547930,
        "val": "[547930] Horni Ves 6110 [547930] Horní Ves"
    },
    {
        "kod": 547948,
        "nazev": "Hořepník",
        "popis": "[547948] Hořepník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547948,
        "val": "[547948] Horepnik 6110 [547948] Hořepník"
    },
    {
        "kod": 547956,
        "nazev": "Hořice",
        "popis": "[547956] Hořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 547956,
        "val": "[547956] Horice 6103 [547956] Hořice"
    },
    {
        "kod": 547999,
        "nazev": "Humpolec",
        "popis": "[547999] Humpolec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 547999,
        "val": "[547999] Humpolec 6103 [547999] Humpolec"
    },
    {
        "kod": 561339,
        "nazev": "Chýstovice",
        "popis": "[561339] Chýstovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561339,
        "val": "[561339] Chystovice 6110 [561339] Chýstovice"
    },
    {
        "kod": 561321,
        "nazev": "Chyšná",
        "popis": "[561321] Chyšná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561321,
        "val": "[561321] Chysna 6110 [561321] Chyšná"
    },
    {
        "kod": 561461,
        "nazev": "Jankov",
        "popis": "[561461] Jankov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561461,
        "val": "[561461] Jankov 6110 [561461] Jankov"
    },
    {
        "kod": 548073,
        "nazev": "Ježov",
        "popis": "[548073] Ježov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548073,
        "val": "[548073] Jezov 6103 [548073] Ježov"
    },
    {
        "kod": 548081,
        "nazev": "Jiřice",
        "popis": "[548081] Jiřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548081,
        "val": "[548081] Jirice 6103 [548081] Jiřice"
    },
    {
        "kod": 548090,
        "nazev": "Kaliště",
        "popis": "[548090] Kaliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548090,
        "val": "[548090] Kaliste 6103 [548090] Kaliště"
    },
    {
        "kod": 548103,
        "nazev": "Kámen",
        "popis": "[548103] Kámen",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548103,
        "val": "[548103] Kamen 6109 [548103] Kámen"
    },
    {
        "kod": 548111,
        "nazev": "Kamenice nad Lipou",
        "popis": "[548111] Kamenice nad Lipou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548111,
        "val": "[548111] Kamenice nad Lipou 6110 [548111] Kamenice nad Lipou"
    },
    {
        "kod": 548120,
        "nazev": "Kejžlice",
        "popis": "[548120] Kejžlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548120,
        "val": "[548120] Kejzlice 6103 [548120] Kejžlice"
    },
    {
        "kod": 548146,
        "nazev": "Koberovice",
        "popis": "[548146] Koberovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548146,
        "val": "[548146] Koberovice 6103 [548146] Koberovice"
    },
    {
        "kod": 598712,
        "nazev": "Kojčice",
        "popis": "[598712] Kojčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 598712,
        "val": "[598712] Kojcice 6110 [598712] Kojčice"
    },
    {
        "kod": 548162,
        "nazev": "Komorovice",
        "popis": "[548162] Komorovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548162,
        "val": "[548162] Komorovice 6103 [548162] Komorovice"
    },
    {
        "kod": 548171,
        "nazev": "Košetice",
        "popis": "[548171] Košetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548171,
        "val": "[548171] Kosetice 6110 [548171] Košetice"
    },
    {
        "kod": 561371,
        "nazev": "Krasíkovice",
        "popis": "[561371] Krasíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561371,
        "val": "[561371] Krasikovice 6110 [561371] Krasíkovice"
    },
    {
        "kod": 548201,
        "nazev": "Křeč",
        "popis": "[548201] Křeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548201,
        "val": "[548201] Krec 6110 [548201] Křeč"
    },
    {
        "kod": 548219,
        "nazev": "Křelovice",
        "popis": "[548219] Křelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548219,
        "val": "[548219] Krelovice 6110 [548219] Křelovice"
    },
    {
        "kod": 548227,
        "nazev": "Křešín",
        "popis": "[548227] Křešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548227,
        "val": "[548227] Kresin 6110 [548227] Křešín"
    },
    {
        "kod": 548235,
        "nazev": "Leskovice",
        "popis": "[548235] Leskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548235,
        "val": "[548235] Leskovice 6110 [548235] Leskovice"
    },
    {
        "kod": 562041,
        "nazev": "Lesná",
        "popis": "[562041] Lesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 562041,
        "val": "[562041] Lesna 6109 [562041] Lesná"
    },
    {
        "kod": 561282,
        "nazev": "Lhota-Vlasenice",
        "popis": "[561282] Lhota-Vlasenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561282,
        "val": "[561282] Lhota-Vlasenice 6110 [561282] Lhota-Vlasenice"
    },
    {
        "kod": 598721,
        "nazev": "Libkova Voda",
        "popis": "[598721] Libkova Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 598721,
        "val": "[598721] Libkova Voda 6110 [598721] Libkova Voda"
    },
    {
        "kod": 561100,
        "nazev": "Lidmaň",
        "popis": "[561100] Lidmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561100,
        "val": "[561100] Lidman 6110 [561100] Lidmaň"
    },
    {
        "kod": 561266,
        "nazev": "Litohošť",
        "popis": "[561266] Litohošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561266,
        "val": "[561266] Litohost 6110 [561266] Litohošť"
    },
    {
        "kod": 548332,
        "nazev": "Lukavec",
        "popis": "[548332] Lukavec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548332,
        "val": "[548332] Lukavec 6109 [548332] Lukavec"
    },
    {
        "kod": 561347,
        "nazev": "Martinice u Onšova",
        "popis": "[561347] Martinice u Onšova",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561347,
        "val": "[561347] Martinice u Onsova 6110 [561347] Martinice u Onšova"
    },
    {
        "kod": 548367,
        "nazev": "Mezilesí",
        "popis": "[548367] Mezilesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548367,
        "val": "[548367] Mezilesi 6109 [548367] Mezilesí"
    },
    {
        "kod": 529834,
        "nazev": "Mezná",
        "popis": "[529834] Mezná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 529834,
        "val": "[529834] Mezna 6110 [529834] Mezná"
    },
    {
        "kod": 548383,
        "nazev": "Mladé Bříště",
        "popis": "[548383] Mladé Bříště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548383,
        "val": "[548383] Mlade Briste 6103 [548383] Mladé Bříště"
    },
    {
        "kod": 548391,
        "nazev": "Mnich",
        "popis": "[548391] Mnich",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548391,
        "val": "[548391] Mnich 6110 [548391] Mnich"
    },
    {
        "kod": 548405,
        "nazev": "Moraveč",
        "popis": "[548405] Moraveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548405,
        "val": "[548405] Moravec 6110 [548405] Moraveč"
    },
    {
        "kod": 561819,
        "nazev": "Mysletín",
        "popis": "[561819] Mysletín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 561819,
        "val": "[561819] Mysletin 6103 [561819] Mysletín"
    },
    {
        "kod": 561177,
        "nazev": "Nová Buková",
        "popis": "[561177] Nová Buková",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561177,
        "val": "[561177] Nova Bukova 6110 [561177] Nová Buková"
    },
    {
        "kod": 548456,
        "nazev": "Nová Cerekev",
        "popis": "[548456] Nová Cerekev",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548456,
        "val": "[548456] Nova Cerekev 6110 [548456] Nová Cerekev"
    },
    {
        "kod": 548464,
        "nazev": "Nový Rychnov",
        "popis": "[548464] Nový Rychnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548464,
        "val": "[548464] Novy Rychnov 6110 [548464] Nový Rychnov"
    },
    {
        "kod": 548472,
        "nazev": "Obrataň",
        "popis": "[548472] Obrataň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548472,
        "val": "[548472] Obratan 6109 [548472] Obrataň"
    },
    {
        "kod": 561967,
        "nazev": "Olešná",
        "popis": "[561967] Olešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561967,
        "val": "[561967] Olesna 6110 [561967] Olešná"
    },
    {
        "kod": 537691,
        "nazev": "Ondřejov",
        "popis": "[537691] Ondřejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 537691,
        "val": "[537691] Ondrejov 6110 [537691] Ondřejov"
    },
    {
        "kod": 548502,
        "nazev": "Onšov",
        "popis": "[548502] Onšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548502,
        "val": "[548502] Onsov 6110 [548502] Onšov"
    },
    {
        "kod": 548511,
        "nazev": "Pacov",
        "popis": "[548511] Pacov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548511,
        "val": "[548511] Pacov 6109 [548511] Pacov"
    },
    {
        "kod": 561916,
        "nazev": "Pavlov",
        "popis": "[561916] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561916,
        "val": "[561916] Pavlov 6110 [561916] Pavlov"
    },
    {
        "kod": 547492,
        "nazev": "Pelhřimov",
        "popis": "[547492] Pelhřimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 547492,
        "val": "[547492] Pelhrimov 6110 [547492] Pelhřimov"
    },
    {
        "kod": 548545,
        "nazev": "Píšť",
        "popis": "[548545] Píšť",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548545,
        "val": "[548545] Pist 6103 [548545] Píšť"
    },
    {
        "kod": 548561,
        "nazev": "Počátky",
        "popis": "[548561] Počátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548561,
        "val": "[548561] Pocatky 6110 [548561] Počátky"
    },
    {
        "kod": 561436,
        "nazev": "Polesí",
        "popis": "[561436] Polesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561436,
        "val": "[561436] Polesi 6110 [561436] Polesí"
    },
    {
        "kod": 548600,
        "nazev": "Pošná",
        "popis": "[548600] Pošná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548600,
        "val": "[548600] Posna 6109 [548600] Pošná"
    },
    {
        "kod": 537829,
        "nazev": "Proseč",
        "popis": "[537829] Proseč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 537829,
        "val": "[537829] Prosec 6103 [537829] Proseč"
    },
    {
        "kod": 561941,
        "nazev": "Proseč pod Křemešníkem",
        "popis": "[561941] Proseč pod Křemešníkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561941,
        "val": "[561941] Prosec pod Kremesnikem 6110 [561941] Proseč pod Křemešníkem"
    },
    {
        "kod": 598755,
        "nazev": "Putimov",
        "popis": "[598755] Putimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 598755,
        "val": "[598755] Putimov 6110 [598755] Putimov"
    },
    {
        "kod": 561789,
        "nazev": "Rodinov",
        "popis": "[561789] Rodinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561789,
        "val": "[561789] Rodinov 6110 [561789] Rodinov"
    },
    {
        "kod": 561274,
        "nazev": "Rovná",
        "popis": "[561274] Rovná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561274,
        "val": "[561274] Rovna 6110 [561274] Rovná"
    },
    {
        "kod": 562009,
        "nazev": "Rynárec",
        "popis": "[562009] Rynárec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 562009,
        "val": "[562009] Rynarec 6110 [562009] Rynárec"
    },
    {
        "kod": 548715,
        "nazev": "Řečice",
        "popis": "[548715] Řečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548715,
        "val": "[548715] Recice 6103 [548715] Řečice"
    },
    {
        "kod": 548731,
        "nazev": "Salačova Lhota",
        "popis": "[548731] Salačova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548731,
        "val": "[548731] Salacova Lhota 6109 [548731] Salačova Lhota"
    },
    {
        "kod": 548740,
        "nazev": "Samšín",
        "popis": "[548740] Samšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 548740,
        "val": "[548740] Samsin 6109 [548740] Samšín"
    },
    {
        "kod": 548766,
        "nazev": "Sedlice",
        "popis": "[548766] Sedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548766,
        "val": "[548766] Sedlice 6103 [548766] Sedlice"
    },
    {
        "kod": 548774,
        "nazev": "Senožaty",
        "popis": "[548774] Senožaty",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 548774,
        "val": "[548774] Senozaty 6103 [548774] Senožaty"
    },
    {
        "kod": 561843,
        "nazev": "Staré Bříště",
        "popis": "[561843] Staré Bříště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 561843,
        "val": "[561843] Stare Briste 6103 [561843] Staré Bříště"
    },
    {
        "kod": 561452,
        "nazev": "Stojčín",
        "popis": "[561452] Stojčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561452,
        "val": "[561452] Stojcin 6110 [561452] Stojčín"
    },
    {
        "kod": 537594,
        "nazev": "Střítež",
        "popis": "[537594] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 537594,
        "val": "[537594] Stritez 6110 [537594] Střítež"
    },
    {
        "kod": 561487,
        "nazev": "Střítež pod Křemešníkem",
        "popis": "[561487] Střítež pod Křemešníkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561487,
        "val": "[561487] Stritez pod Kremesnikem 6110 [561487] Střítež pod Křemešníkem"
    },
    {
        "kod": 598763,
        "nazev": "Svépravice",
        "popis": "[598763] Svépravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 598763,
        "val": "[598763] Svepravice 6110 [598763] Svépravice"
    },
    {
        "kod": 598771,
        "nazev": "Syrov",
        "popis": "[598771] Syrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 598771,
        "val": "[598771] Syrov 6103 [598771] Syrov"
    },
    {
        "kod": 561355,
        "nazev": "Těchobuz",
        "popis": "[561355] Těchobuz",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561355,
        "val": "[561355] Techobuz 6109 [561355] Těchobuz"
    },
    {
        "kod": 548936,
        "nazev": "Těmice",
        "popis": "[548936] Těmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548936,
        "val": "[548936] Temice 6110 [548936] Těmice"
    },
    {
        "kod": 537608,
        "nazev": "Ústrašín",
        "popis": "[537608] Ústrašín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 537608,
        "val": "[537608] Ustrasin 6110 [537608] Ústrašín"
    },
    {
        "kod": 548987,
        "nazev": "Útěchovice",
        "popis": "[548987] Útěchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 548987,
        "val": "[548987] Utechovice 6110 [548987] Útěchovice"
    },
    {
        "kod": 562033,
        "nazev": "Útěchovice pod Stražištěm",
        "popis": "[562033] Útěchovice pod Stražištěm",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 562033,
        "val": "[562033] Utechovice pod Strazistem 6109 [562033] Útěchovice pod Stražištěm"
    },
    {
        "kod": 537730,
        "nazev": "Útěchovičky",
        "popis": "[537730] Útěchovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 537730,
        "val": "[537730] Utechovicky 6110 [537730] Útěchovičky"
    },
    {
        "kod": 549002,
        "nazev": "Včelnička",
        "popis": "[549002] Včelnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549002,
        "val": "[549002] Vcelnicka 6110 [549002] Včelnička"
    },
    {
        "kod": 549011,
        "nazev": "Velká Chyška",
        "popis": "[549011] Velká Chyška",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 549011,
        "val": "[549011] Velka Chyska 6109 [549011] Velká Chyška"
    },
    {
        "kod": 549045,
        "nazev": "Velký Rybník",
        "popis": "[549045] Velký Rybník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549045,
        "val": "[549045] Velky Rybnik 6110 [549045] Velký Rybník"
    },
    {
        "kod": 549053,
        "nazev": "Veselá",
        "popis": "[549053] Veselá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549053,
        "val": "[549053] Vesela 6110 [549053] Veselá"
    },
    {
        "kod": 549061,
        "nazev": "Věžná",
        "popis": "[549061] Věžná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 549061,
        "val": "[549061] Vezna 6109 [549061] Věžná"
    },
    {
        "kod": 549126,
        "nazev": "Vojslavice",
        "popis": "[549126] Vojslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 549126,
        "val": "[549126] Vojslavice 6103 [549126] Vojslavice"
    },
    {
        "kod": 599239,
        "nazev": "Vokov",
        "popis": "[599239] Vokov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 599239,
        "val": "[599239] Vokov 6110 [599239] Vokov"
    },
    {
        "kod": 549134,
        "nazev": "Vyklantice",
        "popis": "[549134] Vyklantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 549134,
        "val": "[549134] Vyklantice 6109 [549134] Vyklantice"
    },
    {
        "kod": 549142,
        "nazev": "Vyskytná",
        "popis": "[549142] Vyskytná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549142,
        "val": "[549142] Vyskytna 6110 [549142] Vyskytná"
    },
    {
        "kod": 561771,
        "nazev": "Vysoká Lhota",
        "popis": "[561771] Vysoká Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561771,
        "val": "[561771] Vysoka Lhota 6109 [561771] Vysoká Lhota"
    },
    {
        "kod": 561797,
        "nazev": "Vystrkov",
        "popis": "[561797] Vystrkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 561797,
        "val": "[561797] Vystrkov 6103 [561797] Vystrkov"
    },
    {
        "kod": 549177,
        "nazev": "Zachotín",
        "popis": "[549177] Zachotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549177,
        "val": "[549177] Zachotin 6110 [549177] Zachotín"
    },
    {
        "kod": 561975,
        "nazev": "Zajíčkov",
        "popis": "[561975] Zajíčkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561975,
        "val": "[561975] Zajickov 6110 [561975] Zajíčkov"
    },
    {
        "kod": 561363,
        "nazev": "Zhořec",
        "popis": "[561363] Zhořec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 561363,
        "val": "[561363] Zhorec 6109 [561363] Zhořec"
    },
    {
        "kod": 598666,
        "nazev": "Zlátenka",
        "popis": "[598666] Zlátenka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6109,
        "iczuj": 598666,
        "val": "[598666] Zlatenka 6109 [598666] Zlátenka"
    },
    {
        "kod": 549215,
        "nazev": "Želiv",
        "popis": "[549215] Želiv",
        "datum_od": "",
        "datum_do": "",
        "orp": 6103,
        "iczuj": 549215,
        "val": "[549215] Zeliv 6103 [549215] Želiv"
    },
    {
        "kod": 561908,
        "nazev": "Žirov",
        "popis": "[561908] Žirov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 561908,
        "val": "[561908] Zirov 6110 [561908] Žirov"
    },
    {
        "kod": 549231,
        "nazev": "Žirovnice",
        "popis": "[549231] Žirovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6110,
        "iczuj": 549231,
        "val": "[549231] Zirovnice 6110 [549231] Žirovnice"
    },
    {
        "kod": 590274,
        "nazev": "Babice",
        "popis": "[590274] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590274,
        "val": "[590274] Babice 6106 [590274] Babice"
    },
    {
        "kod": 590282,
        "nazev": "Bačice",
        "popis": "[590282] Bačice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590282,
        "val": "[590282] Bacice 6113 [590282] Bačice"
    },
    {
        "kod": 544833,
        "nazev": "Bačkovice",
        "popis": "[544833] Bačkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 544833,
        "val": "[544833] Backovice 6106 [544833] Bačkovice"
    },
    {
        "kod": 590304,
        "nazev": "Benetice",
        "popis": "[590304] Benetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590304,
        "val": "[590304] Benetice 6113 [590304] Benetice"
    },
    {
        "kod": 590312,
        "nazev": "Biskupice-Pulkov",
        "popis": "[590312] Biskupice-Pulkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590312,
        "val": "[590312] Biskupice-Pulkov 6113 [590312] Biskupice-Pulkov"
    },
    {
        "kod": 590321,
        "nazev": "Blatnice",
        "popis": "[590321] Blatnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590321,
        "val": "[590321] Blatnice 6106 [590321] Blatnice"
    },
    {
        "kod": 550400,
        "nazev": "Bohušice",
        "popis": "[550400] Bohušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550400,
        "val": "[550400] Bohusice 6106 [550400] Bohušice"
    },
    {
        "kod": 590347,
        "nazev": "Bochovice",
        "popis": "[590347] Bochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590347,
        "val": "[590347] Bochovice 6113 [590347] Bochovice"
    },
    {
        "kod": 590363,
        "nazev": "Bransouze",
        "popis": "[590363] Bransouze",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590363,
        "val": "[590363] Bransouze 6113 [590363] Bransouze"
    },
    {
        "kod": 590380,
        "nazev": "Březník",
        "popis": "[590380] Březník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590380,
        "val": "[590380] Breznik 6107 [590380] Březník"
    },
    {
        "kod": 590401,
        "nazev": "Budišov",
        "popis": "[590401] Budišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590401,
        "val": "[590401] Budisov 6113 [590401] Budišov"
    },
    {
        "kod": 590410,
        "nazev": "Budkov",
        "popis": "[590410] Budkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590410,
        "val": "[590410] Budkov 6106 [590410] Budkov"
    },
    {
        "kod": 590428,
        "nazev": "Cidlina",
        "popis": "[590428] Cidlina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590428,
        "val": "[590428] Cidlina 6106 [590428] Cidlina"
    },
    {
        "kod": 590436,
        "nazev": "Čáslavice",
        "popis": "[590436] Čáslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590436,
        "val": "[590436] Caslavice 6113 [590436] Čáslavice"
    },
    {
        "kod": 553964,
        "nazev": "Častohostice",
        "popis": "[553964] Častohostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 553964,
        "val": "[553964] Castohostice 6106 [553964] Častohostice"
    },
    {
        "kod": 590444,
        "nazev": "Čechočovice",
        "popis": "[590444] Čechočovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590444,
        "val": "[590444] Cechocovice 6113 [590444] Čechočovice"
    },
    {
        "kod": 590452,
        "nazev": "Čechtín",
        "popis": "[590452] Čechtín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590452,
        "val": "[590452] Cechtin 6113 [590452] Čechtín"
    },
    {
        "kod": 590461,
        "nazev": "Červená Lhota",
        "popis": "[590461] Červená Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590461,
        "val": "[590461] Cervena Lhota 6113 [590461] Červená Lhota"
    },
    {
        "kod": 590479,
        "nazev": "Číhalín",
        "popis": "[590479] Číhalín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590479,
        "val": "[590479] Cihalin 6113 [590479] Číhalín"
    },
    {
        "kod": 590487,
        "nazev": "Číchov",
        "popis": "[590487] Číchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590487,
        "val": "[590487] Cichov 6113 [590487] Číchov"
    },
    {
        "kod": 590495,
        "nazev": "Čikov",
        "popis": "[590495] Čikov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590495,
        "val": "[590495] Cikov 6107 [590495] Čikov"
    },
    {
        "kod": 590509,
        "nazev": "Číměř",
        "popis": "[590509] Číměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590509,
        "val": "[590509] Cimer 6113 [590509] Číměř"
    },
    {
        "kod": 590517,
        "nazev": "Dalešice",
        "popis": "[590517] Dalešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590517,
        "val": "[590517] Dalesice 6113 [590517] Dalešice"
    },
    {
        "kod": 590525,
        "nazev": "Dědice",
        "popis": "[590525] Dědice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590525,
        "val": "[590525] Dedice 6106 [590525] Dědice"
    },
    {
        "kod": 590533,
        "nazev": "Dešov",
        "popis": "[590533] Dešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590533,
        "val": "[590533] Desov 6106 [590533] Dešov"
    },
    {
        "kod": 587664,
        "nazev": "Dolní Lažany",
        "popis": "[587664] Dolní Lažany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 587664,
        "val": "[587664] Dolni Lazany 6106 [587664] Dolní Lažany"
    },
    {
        "kod": 590550,
        "nazev": "Dolní Vilémovice",
        "popis": "[590550] Dolní Vilémovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590550,
        "val": "[590550] Dolni Vilemovice 6113 [590550] Dolní Vilémovice"
    },
    {
        "kod": 590568,
        "nazev": "Domamil",
        "popis": "[590568] Domamil",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590568,
        "val": "[590568] Domamil 6106 [590568] Domamil"
    },
    {
        "kod": 590576,
        "nazev": "Dukovany",
        "popis": "[590576] Dukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590576,
        "val": "[590576] Dukovany 6113 [590576] Dukovany"
    },
    {
        "kod": 590584,
        "nazev": "Hartvíkovice",
        "popis": "[590584] Hartvíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590584,
        "val": "[590584] Hartvikovice 6107 [590584] Hartvíkovice"
    },
    {
        "kod": 590592,
        "nazev": "Heraltice",
        "popis": "[590592] Heraltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590592,
        "val": "[590592] Heraltice 6113 [590592] Heraltice"
    },
    {
        "kod": 590614,
        "nazev": "Hluboké",
        "popis": "[590614] Hluboké",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590614,
        "val": "[590614] Hluboke 6107 [590614] Hluboké"
    },
    {
        "kod": 590622,
        "nazev": "Hodov",
        "popis": "[590622] Hodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590622,
        "val": "[590622] Hodov 6113 [590622] Hodov"
    },
    {
        "kod": 590631,
        "nazev": "Horní Heřmanice",
        "popis": "[590631] Horní Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590631,
        "val": "[590631] Horni Hermanice 6113 [590631] Horní Heřmanice"
    },
    {
        "kod": 550612,
        "nazev": "Horní Smrčné",
        "popis": "[550612] Horní Smrčné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 550612,
        "val": "[550612] Horni Smrcne 6113 [550612] Horní Smrčné"
    },
    {
        "kod": 590649,
        "nazev": "Horní Újezd",
        "popis": "[590649] Horní Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590649,
        "val": "[590649] Horni Ujezd 6113 [590649] Horní Újezd"
    },
    {
        "kod": 590657,
        "nazev": "Horní Vilémovice",
        "popis": "[590657] Horní Vilémovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590657,
        "val": "[590657] Horni Vilemovice 6113 [590657] Horní Vilémovice"
    },
    {
        "kod": 590665,
        "nazev": "Hornice",
        "popis": "[590665] Hornice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590665,
        "val": "[590665] Hornice 6106 [590665] Hornice"
    },
    {
        "kod": 590673,
        "nazev": "Hrotovice",
        "popis": "[590673] Hrotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590673,
        "val": "[590673] Hrotovice 6113 [590673] Hrotovice"
    },
    {
        "kod": 550639,
        "nazev": "Hroznatín",
        "popis": "[550639] Hroznatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 550639,
        "val": "[550639] Hroznatin 6113 [550639] Hroznatín"
    },
    {
        "kod": 590690,
        "nazev": "Hvězdoňovice",
        "popis": "[590690] Hvězdoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590690,
        "val": "[590690] Hvezdonovice 6113 [590690] Hvězdoňovice"
    },
    {
        "kod": 590703,
        "nazev": "Chlístov",
        "popis": "[590703] Chlístov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590703,
        "val": "[590703] Chlistov 6113 [590703] Chlístov"
    },
    {
        "kod": 590711,
        "nazev": "Chlum",
        "popis": "[590711] Chlum",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590711,
        "val": "[590711] Chlum 6113 [590711] Chlum"
    },
    {
        "kod": 550477,
        "nazev": "Chotěbudice",
        "popis": "[550477] Chotěbudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550477,
        "val": "[550477] Chotebudice 6106 [550477] Chotěbudice"
    },
    {
        "kod": 590746,
        "nazev": "Jakubov u Moravských Budějovic",
        "popis": "[590746] Jakubov u Moravských Budějovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590746,
        "val": "[590746] Jakubov u Moravskych Budejovic 6106 [590746] Jakubov u Moravských Budějovic"
    },
    {
        "kod": 590754,
        "nazev": "Jaroměřice nad Rokytnou",
        "popis": "[590754] Jaroměřice nad Rokytnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590754,
        "val": "[590754] Jaromerice nad Rokytnou 6113 [590754] Jaroměřice nad Rokytnou"
    },
    {
        "kod": 590762,
        "nazev": "Jasenice",
        "popis": "[590762] Jasenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590762,
        "val": "[590762] Jasenice 6107 [590762] Jasenice"
    },
    {
        "kod": 590789,
        "nazev": "Jemnice",
        "popis": "[590789] Jemnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590789,
        "val": "[590789] Jemnice 6106 [590789] Jemnice"
    },
    {
        "kod": 590797,
        "nazev": "Jinošov",
        "popis": "[590797] Jinošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590797,
        "val": "[590797] Jinosov 6107 [590797] Jinošov"
    },
    {
        "kod": 550591,
        "nazev": "Jiratice",
        "popis": "[550591] Jiratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550591,
        "val": "[550591] Jiratice 6106 [550591] Jiratice"
    },
    {
        "kod": 590801,
        "nazev": "Kamenná",
        "popis": "[590801] Kamenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590801,
        "val": "[590801] Kamenna 6113 [590801] Kamenná"
    },
    {
        "kod": 590819,
        "nazev": "Kdousov",
        "popis": "[590819] Kdousov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590819,
        "val": "[590819] Kdousov 6106 [590819] Kdousov"
    },
    {
        "kod": 590827,
        "nazev": "Kladeruby nad Oslavou",
        "popis": "[590827] Kladeruby nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590827,
        "val": "[590827] Kladeruby nad Oslavou 6107 [590827] Kladeruby nad Oslavou"
    },
    {
        "kod": 590835,
        "nazev": "Klučov",
        "popis": "[590835] Klučov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590835,
        "val": "[590835] Klucov 6113 [590835] Klučov"
    },
    {
        "kod": 590851,
        "nazev": "Kojatice",
        "popis": "[590851] Kojatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590851,
        "val": "[590851] Kojatice 6106 [590851] Kojatice"
    },
    {
        "kod": 510645,
        "nazev": "Kojatín",
        "popis": "[510645] Kojatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 510645,
        "val": "[510645] Kojatin 6113 [510645] Kojatín"
    },
    {
        "kod": 590860,
        "nazev": "Kojetice",
        "popis": "[590860] Kojetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590860,
        "val": "[590860] Kojetice 6113 [590860] Kojetice"
    },
    {
        "kod": 590878,
        "nazev": "Komárovice",
        "popis": "[590878] Komárovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590878,
        "val": "[590878] Komarovice 6106 [590878] Komárovice"
    },
    {
        "kod": 590886,
        "nazev": "Koněšín",
        "popis": "[590886] Koněšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590886,
        "val": "[590886] Konesin 6113 [590886] Koněšín"
    },
    {
        "kod": 590894,
        "nazev": "Kostníky",
        "popis": "[590894] Kostníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590894,
        "val": "[590894] Kostniky 6106 [590894] Kostníky"
    },
    {
        "kod": 590908,
        "nazev": "Kouty",
        "popis": "[590908] Kouty",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590908,
        "val": "[590908] Kouty 6113 [590908] Kouty"
    },
    {
        "kod": 590916,
        "nazev": "Kozlany",
        "popis": "[590916] Kozlany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590916,
        "val": "[590916] Kozlany 6113 [590916] Kozlany"
    },
    {
        "kod": 545309,
        "nazev": "Kožichovice",
        "popis": "[545309] Kožichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 545309,
        "val": "[545309] Kozichovice 6113 [545309] Kožichovice"
    },
    {
        "kod": 550710,
        "nazev": "Krahulov",
        "popis": "[550710] Krahulov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 550710,
        "val": "[550710] Krahulov 6113 [550710] Krahulov"
    },
    {
        "kod": 590941,
        "nazev": "Kralice nad Oslavou",
        "popis": "[590941] Kralice nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590941,
        "val": "[590941] Kralice nad Oslavou 6107 [590941] Kralice nad Oslavou"
    },
    {
        "kod": 590959,
        "nazev": "Kramolín",
        "popis": "[590959] Kramolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590959,
        "val": "[590959] Kramolin 6107 [590959] Kramolín"
    },
    {
        "kod": 590967,
        "nazev": "Krhov",
        "popis": "[590967] Krhov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590967,
        "val": "[590967] Krhov 6113 [590967] Krhov"
    },
    {
        "kod": 590975,
        "nazev": "Krokočín",
        "popis": "[590975] Krokočín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590975,
        "val": "[590975] Krokocin 6107 [590975] Krokočín"
    },
    {
        "kod": 550302,
        "nazev": "Kuroslepy",
        "popis": "[550302] Kuroslepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 550302,
        "val": "[550302] Kuroslepy 6107 [550302] Kuroslepy"
    },
    {
        "kod": 510556,
        "nazev": "Láz",
        "popis": "[510556] Láz",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 510556,
        "val": "[510556] Laz 6106 [510556] Láz"
    },
    {
        "kod": 590983,
        "nazev": "Lesná",
        "popis": "[590983] Lesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 590983,
        "val": "[590983] Lesna 6106 [590983] Lesná"
    },
    {
        "kod": 590991,
        "nazev": "Lesní Jakubov",
        "popis": "[590991] Lesní Jakubov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 590991,
        "val": "[590991] Lesni Jakubov 6107 [590991] Lesní Jakubov"
    },
    {
        "kod": 591009,
        "nazev": "Lesonice",
        "popis": "[591009] Lesonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591009,
        "val": "[591009] Lesonice 6106 [591009] Lesonice"
    },
    {
        "kod": 573485,
        "nazev": "Lesůňky",
        "popis": "[573485] Lesůňky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 573485,
        "val": "[573485] Lesunky 6113 [573485] Lesůňky"
    },
    {
        "kod": 591025,
        "nazev": "Lhánice",
        "popis": "[591025] Lhánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591025,
        "val": "[591025] Lhanice 6107 [591025] Lhánice"
    },
    {
        "kod": 544876,
        "nazev": "Lhotice",
        "popis": "[544876] Lhotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 544876,
        "val": "[544876] Lhotice 6106 [544876] Lhotice"
    },
    {
        "kod": 591041,
        "nazev": "Lipník",
        "popis": "[591041] Lipník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591041,
        "val": "[591041] Lipnik 6113 [591041] Lipník"
    },
    {
        "kod": 550507,
        "nazev": "Litohoř",
        "popis": "[550507] Litohoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550507,
        "val": "[550507] Litohor 6106 [550507] Litohoř"
    },
    {
        "kod": 591068,
        "nazev": "Litovany",
        "popis": "[591068] Litovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591068,
        "val": "[591068] Litovany 6113 [591068] Litovany"
    },
    {
        "kod": 587605,
        "nazev": "Lomy",
        "popis": "[587605] Lomy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 587605,
        "val": "[587605] Lomy 6106 [587605] Lomy"
    },
    {
        "kod": 591092,
        "nazev": "Loukovice",
        "popis": "[591092] Loukovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591092,
        "val": "[591092] Loukovice 6113 [591092] Loukovice"
    },
    {
        "kod": 544957,
        "nazev": "Lovčovice",
        "popis": "[544957] Lovčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 544957,
        "val": "[544957] Lovcovice 6106 [544957] Lovčovice"
    },
    {
        "kod": 550566,
        "nazev": "Lukov",
        "popis": "[550566] Lukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550566,
        "val": "[550566] Lukov 6106 [550566] Lukov"
    },
    {
        "kod": 591114,
        "nazev": "Markvartice",
        "popis": "[591114] Markvartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591114,
        "val": "[591114] Markvartice 6113 [591114] Markvartice"
    },
    {
        "kod": 550388,
        "nazev": "Martínkov",
        "popis": "[550388] Martínkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550388,
        "val": "[550388] Martinkov 6106 [550388] Martínkov"
    },
    {
        "kod": 591122,
        "nazev": "Mastník",
        "popis": "[591122] Mastník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591122,
        "val": "[591122] Mastnik 6113 [591122] Mastník"
    },
    {
        "kod": 545031,
        "nazev": "Menhartice",
        "popis": "[545031] Menhartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 545031,
        "val": "[545031] Menhartice 6106 [545031] Menhartice"
    },
    {
        "kod": 591149,
        "nazev": "Meziříčko",
        "popis": "[591149] Meziříčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591149,
        "val": "[591149] Meziricko 6106 [591149] Meziříčko"
    },
    {
        "kod": 591157,
        "nazev": "Mikulovice",
        "popis": "[591157] Mikulovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591157,
        "val": "[591157] Mikulovice 6113 [591157] Mikulovice"
    },
    {
        "kod": 591165,
        "nazev": "Mladoňovice",
        "popis": "[591165] Mladoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591165,
        "val": "[591165] Mladonovice 6106 [591165] Mladoňovice"
    },
    {
        "kod": 591173,
        "nazev": "Mohelno",
        "popis": "[591173] Mohelno",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591173,
        "val": "[591173] Mohelno 6107 [591173] Mohelno"
    },
    {
        "kod": 591181,
        "nazev": "Moravské Budějovice",
        "popis": "[591181] Moravské Budějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591181,
        "val": "[591181] Moravske Budejovice 6106 [591181] Moravské Budějovice"
    },
    {
        "kod": 591190,
        "nazev": "Myslibořice",
        "popis": "[591190] Myslibořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591190,
        "val": "[591190] Mysliborice 6113 [591190] Myslibořice"
    },
    {
        "kod": 550779,
        "nazev": "Naloučany",
        "popis": "[550779] Naloučany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 550779,
        "val": "[550779] Naloucany 6107 [550779] Naloučany"
    },
    {
        "kod": 591211,
        "nazev": "Náměšť nad Oslavou",
        "popis": "[591211] Náměšť nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591211,
        "val": "[591211] Namest nad Oslavou 6107 [591211] Náměšť nad Oslavou"
    },
    {
        "kod": 591220,
        "nazev": "Nárameč",
        "popis": "[591220] Nárameč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591220,
        "val": "[591220] Naramec 6113 [591220] Nárameč"
    },
    {
        "kod": 591238,
        "nazev": "Nimpšov",
        "popis": "[591238] Nimpšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591238,
        "val": "[591238] Nimpsov 6106 [591238] Nimpšov"
    },
    {
        "kod": 591246,
        "nazev": "Nová Ves",
        "popis": "[591246] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591246,
        "val": "[591246] Nova Ves 6113 [591246] Nová Ves"
    },
    {
        "kod": 591254,
        "nazev": "Nové Syrovice",
        "popis": "[591254] Nové Syrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591254,
        "val": "[591254] Nove Syrovice 6106 [591254] Nové Syrovice"
    },
    {
        "kod": 591262,
        "nazev": "Nový Telečkov",
        "popis": "[591262] Nový Telečkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591262,
        "val": "[591262] Novy Teleckov 6113 [591262] Nový Telečkov"
    },
    {
        "kod": 510980,
        "nazev": "Ocmanice",
        "popis": "[510980] Ocmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 510980,
        "val": "[510980] Ocmanice 6107 [510980] Ocmanice"
    },
    {
        "kod": 591289,
        "nazev": "Odunec",
        "popis": "[591289] Odunec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591289,
        "val": "[591289] Odunec 6113 [591289] Odunec"
    },
    {
        "kod": 591297,
        "nazev": "Okarec",
        "popis": "[591297] Okarec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591297,
        "val": "[591297] Okarec 6107 [591297] Okarec"
    },
    {
        "kod": 546933,
        "nazev": "Okřešice",
        "popis": "[546933] Okřešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 546933,
        "val": "[546933] Okresice 6113 [546933] Okřešice"
    },
    {
        "kod": 591301,
        "nazev": "Okříšky",
        "popis": "[591301] Okříšky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591301,
        "val": "[591301] Okrisky 6113 [591301] Okříšky"
    },
    {
        "kod": 591319,
        "nazev": "Opatov",
        "popis": "[591319] Opatov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591319,
        "val": "[591319] Opatov 6113 [591319] Opatov"
    },
    {
        "kod": 591327,
        "nazev": "Oponešice",
        "popis": "[591327] Oponešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591327,
        "val": "[591327] Oponesice 6106 [591327] Oponešice"
    },
    {
        "kod": 591335,
        "nazev": "Ostašov",
        "popis": "[591335] Ostašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591335,
        "val": "[591335] Ostasov 6113 [591335] Ostašov"
    },
    {
        "kod": 550469,
        "nazev": "Pálovice",
        "popis": "[550469] Pálovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550469,
        "val": "[550469] Palovice 6106 [550469] Pálovice"
    },
    {
        "kod": 591360,
        "nazev": "Petrovice",
        "popis": "[591360] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591360,
        "val": "[591360] Petrovice 6113 [591360] Petrovice"
    },
    {
        "kod": 591378,
        "nazev": "Petrůvky",
        "popis": "[591378] Petrůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591378,
        "val": "[591378] Petruvky 6113 [591378] Petrůvky"
    },
    {
        "kod": 550370,
        "nazev": "Pokojovice",
        "popis": "[550370] Pokojovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 550370,
        "val": "[550370] Pokojovice 6113 [550370] Pokojovice"
    },
    {
        "kod": 591394,
        "nazev": "Police",
        "popis": "[591394] Police",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591394,
        "val": "[591394] Police 6106 [591394] Police"
    },
    {
        "kod": 591408,
        "nazev": "Popůvky",
        "popis": "[591408] Popůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591408,
        "val": "[591408] Popuvky 6107 [591408] Popůvky"
    },
    {
        "kod": 591416,
        "nazev": "Pozďatín",
        "popis": "[591416] Pozďatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591416,
        "val": "[591416] Pozdatin 6113 [591416] Pozďatín"
    },
    {
        "kod": 591424,
        "nazev": "Přeckov",
        "popis": "[591424] Přeckov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591424,
        "val": "[591424] Preckov 6113 [591424] Přeckov"
    },
    {
        "kod": 591432,
        "nazev": "Předín",
        "popis": "[591432] Předín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591432,
        "val": "[591432] Predin 6113 [591432] Předín"
    },
    {
        "kod": 591441,
        "nazev": "Přešovice",
        "popis": "[591441] Přešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591441,
        "val": "[591441] Presovice 6113 [591441] Přešovice"
    },
    {
        "kod": 591459,
        "nazev": "Přibyslavice",
        "popis": "[591459] Přibyslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591459,
        "val": "[591459] Pribyslavice 6113 [591459] Přibyslavice"
    },
    {
        "kod": 544752,
        "nazev": "Příštpo",
        "popis": "[544752] Příštpo",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 544752,
        "val": "[544752] Pristpo 6113 [544752] Příštpo"
    },
    {
        "kod": 591491,
        "nazev": "Pucov",
        "popis": "[591491] Pucov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591491,
        "val": "[591491] Pucov 6107 [591491] Pucov"
    },
    {
        "kod": 591505,
        "nazev": "Pyšel",
        "popis": "[591505] Pyšel",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591505,
        "val": "[591505] Pysel 6113 [591505] Pyšel"
    },
    {
        "kod": 511307,
        "nazev": "Rácovice",
        "popis": "[511307] Rácovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 511307,
        "val": "[511307] Racovice 6106 [511307] Rácovice"
    },
    {
        "kod": 591521,
        "nazev": "Račice",
        "popis": "[591521] Račice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591521,
        "val": "[591521] Racice 6113 [591521] Račice"
    },
    {
        "kod": 550493,
        "nazev": "Radkovice u Budče",
        "popis": "[550493] Radkovice u Budče",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 550493,
        "val": "[550493] Radkovice u Budce 6106 [550493] Radkovice u Budče"
    },
    {
        "kod": 591548,
        "nazev": "Radkovice u Hrotovic",
        "popis": "[591548] Radkovice u Hrotovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591548,
        "val": "[591548] Radkovice u Hrotovic 6113 [591548] Radkovice u Hrotovic"
    },
    {
        "kod": 591556,
        "nazev": "Radonín",
        "popis": "[591556] Radonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591556,
        "val": "[591556] Radonin 6113 [591556] Radonín"
    },
    {
        "kod": 591564,
        "nazev": "Radošov",
        "popis": "[591564] Radošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591564,
        "val": "[591564] Radosov 6113 [591564] Radošov"
    },
    {
        "kod": 545040,
        "nazev": "Radotice",
        "popis": "[545040] Radotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 545040,
        "val": "[545040] Radotice 6106 [545040] Radotice"
    },
    {
        "kod": 591581,
        "nazev": "Rapotice",
        "popis": "[591581] Rapotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591581,
        "val": "[591581] Rapotice 6107 [591581] Rapotice"
    },
    {
        "kod": 591602,
        "nazev": "Rohy",
        "popis": "[591602] Rohy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591602,
        "val": "[591602] Rohy 6113 [591602] Rohy"
    },
    {
        "kod": 591611,
        "nazev": "Rokytnice nad Rokytnou",
        "popis": "[591611] Rokytnice nad Rokytnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591611,
        "val": "[591611] Rokytnice nad Rokytnou 6113 [591611] Rokytnice nad Rokytnou"
    },
    {
        "kod": 591629,
        "nazev": "Rouchovany",
        "popis": "[591629] Rouchovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591629,
        "val": "[591629] Rouchovany 6113 [591629] Rouchovany"
    },
    {
        "kod": 591637,
        "nazev": "Rudíkov",
        "popis": "[591637] Rudíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591637,
        "val": "[591637] Rudikov 6113 [591637] Rudíkov"
    },
    {
        "kod": 591645,
        "nazev": "Římov",
        "popis": "[591645] Římov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591645,
        "val": "[591645] Rimov 6113 [591645] Římov"
    },
    {
        "kod": 511081,
        "nazev": "Sedlec",
        "popis": "[511081] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 511081,
        "val": "[511081] Sedlec 6107 [511081] Sedlec"
    },
    {
        "kod": 591688,
        "nazev": "Slavětice",
        "popis": "[591688] Slavětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591688,
        "val": "[591688] Slavetice 6113 [591688] Slavětice"
    },
    {
        "kod": 591700,
        "nazev": "Slavičky",
        "popis": "[591700] Slavičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591700,
        "val": "[591700] Slavicky 6113 [591700] Slavičky"
    },
    {
        "kod": 545180,
        "nazev": "Slavíkovice",
        "popis": "[545180] Slavíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 545180,
        "val": "[545180] Slavikovice 6106 [545180] Slavíkovice"
    },
    {
        "kod": 591726,
        "nazev": "Smrk",
        "popis": "[591726] Smrk",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591726,
        "val": "[591726] Smrk 6113 [591726] Smrk"
    },
    {
        "kod": 591742,
        "nazev": "Stařeč",
        "popis": "[591742] Stařeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591742,
        "val": "[591742] Starec 6113 [591742] Stařeč"
    },
    {
        "kod": 587460,
        "nazev": "Stropešín",
        "popis": "[587460] Stropešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 587460,
        "val": "[587460] Stropesin 6113 [587460] Stropešín"
    },
    {
        "kod": 554871,
        "nazev": "Střítež",
        "popis": "[554871] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 554871,
        "val": "[554871] Stritez 6113 [554871] Střítež"
    },
    {
        "kod": 591769,
        "nazev": "Studenec",
        "popis": "[591769] Studenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591769,
        "val": "[591769] Studenec 6107 [591769] Studenec"
    },
    {
        "kod": 591777,
        "nazev": "Studnice",
        "popis": "[591777] Studnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591777,
        "val": "[591777] Studnice 6113 [591777] Studnice"
    },
    {
        "kod": 591785,
        "nazev": "Sudice",
        "popis": "[591785] Sudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591785,
        "val": "[591785] Sudice 6107 [591785] Sudice"
    },
    {
        "kod": 591793,
        "nazev": "Svatoslav",
        "popis": "[591793] Svatoslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591793,
        "val": "[591793] Svatoslav 6113 [591793] Svatoslav"
    },
    {
        "kod": 591807,
        "nazev": "Šebkovice",
        "popis": "[591807] Šebkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591807,
        "val": "[591807] Sebkovice 6113 [591807] Šebkovice"
    },
    {
        "kod": 591815,
        "nazev": "Štěměchy",
        "popis": "[591815] Štěměchy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591815,
        "val": "[591815] Stemechy 6113 [591815] Štěměchy"
    },
    {
        "kod": 591823,
        "nazev": "Štěpkov",
        "popis": "[591823] Štěpkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591823,
        "val": "[591823] Stepkov 6106 [591823] Štěpkov"
    },
    {
        "kod": 591840,
        "nazev": "Trnava",
        "popis": "[591840] Trnava",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591840,
        "val": "[591840] Trnava 6113 [591840] Trnava"
    },
    {
        "kod": 591858,
        "nazev": "Třebelovice",
        "popis": "[591858] Třebelovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591858,
        "val": "[591858] Trebelovice 6106 [591858] Třebelovice"
    },
    {
        "kod": 591866,
        "nazev": "Třebenice",
        "popis": "[591866] Třebenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591866,
        "val": "[591866] Trebenice 6113 [591866] Třebenice"
    },
    {
        "kod": 590266,
        "nazev": "Třebíč",
        "popis": "[590266] Třebíč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 590266,
        "val": "[590266] Trebic 6113 [590266] Třebíč"
    },
    {
        "kod": 550311,
        "nazev": "Třesov",
        "popis": "[550311] Třesov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 550311,
        "val": "[550311] Tresov 6107 [550311] Třesov"
    },
    {
        "kod": 587699,
        "nazev": "Valdíkov",
        "popis": "[587699] Valdíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 587699,
        "val": "[587699] Valdikov 6113 [587699] Valdíkov"
    },
    {
        "kod": 591874,
        "nazev": "Valeč",
        "popis": "[591874] Valeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591874,
        "val": "[591874] Valec 6113 [591874] Valeč"
    },
    {
        "kod": 588342,
        "nazev": "Vícenice",
        "popis": "[588342] Vícenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 588342,
        "val": "[588342] Vicenice 6106 [588342] Vícenice"
    },
    {
        "kod": 511242,
        "nazev": "Vícenice u Náměště nad Oslavou",
        "popis": "[511242] Vícenice u Náměště nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 511242,
        "val": "[511242] Vicenice u Nameste nad Oslavou 6107 [511242] Vícenice u Náměště nad Oslavou"
    },
    {
        "kod": 591904,
        "nazev": "Vladislav",
        "popis": "[591904] Vladislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591904,
        "val": "[591904] Vladislav 6113 [591904] Vladislav"
    },
    {
        "kod": 591912,
        "nazev": "Vlčatín",
        "popis": "[591912] Vlčatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591912,
        "val": "[591912] Vlcatin 6113 [591912] Vlčatín"
    },
    {
        "kod": 591939,
        "nazev": "Výčapy",
        "popis": "[591939] Výčapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591939,
        "val": "[591939] Vycapy 6113 [591939] Výčapy"
    },
    {
        "kod": 591947,
        "nazev": "Zahrádka",
        "popis": "[591947] Zahrádka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6107,
        "iczuj": 591947,
        "val": "[591947] Zahradka 6107 [591947] Zahrádka"
    },
    {
        "kod": 591955,
        "nazev": "Zárubice",
        "popis": "[591955] Zárubice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591955,
        "val": "[591955] Zarubice 6113 [591955] Zárubice"
    },
    {
        "kod": 591963,
        "nazev": "Zašovice",
        "popis": "[591963] Zašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6113,
        "iczuj": 591963,
        "val": "[591963] Zasovice 6113 [591963] Zašovice"
    },
    {
        "kod": 591980,
        "nazev": "Zvěrkovice",
        "popis": "[591980] Zvěrkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591980,
        "val": "[591980] Zverkovice 6106 [591980] Zvěrkovice"
    },
    {
        "kod": 591998,
        "nazev": "Želetava",
        "popis": "[591998] Želetava",
        "datum_od": "",
        "datum_do": "",
        "orp": 6106,
        "iczuj": 591998,
        "val": "[591998] Zeletava 6106 [591998] Želetava"
    },
    {
        "kod": 595217,
        "nazev": "Baliny",
        "popis": "[595217] Baliny",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595217,
        "val": "[595217] Baliny 6114 [595217] Baliny"
    },
    {
        "kod": 595241,
        "nazev": "Blažkov",
        "popis": "[595241] Blažkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595241,
        "val": "[595241] Blazkov 6101 [595241] Blažkov"
    },
    {
        "kod": 595250,
        "nazev": "Blízkov",
        "popis": "[595250] Blízkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595250,
        "val": "[595250] Blizkov 6114 [595250] Blízkov"
    },
    {
        "kod": 595268,
        "nazev": "Bobrová",
        "popis": "[595268] Bobrová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595268,
        "val": "[595268] Bobrova 6108 [595268] Bobrová"
    },
    {
        "kod": 595276,
        "nazev": "Bobrůvka",
        "popis": "[595276] Bobrůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595276,
        "val": "[595276] Bobruvka 6108 [595276] Bobrůvka"
    },
    {
        "kod": 595284,
        "nazev": "Bohdalec",
        "popis": "[595284] Bohdalec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595284,
        "val": "[595284] Bohdalec 6115 [595284] Bohdalec"
    },
    {
        "kod": 595292,
        "nazev": "Bohdalov",
        "popis": "[595292] Bohdalov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595292,
        "val": "[595292] Bohdalov 6115 [595292] Bohdalov"
    },
    {
        "kod": 595306,
        "nazev": "Bohuňov",
        "popis": "[595306] Bohuňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595306,
        "val": "[595306] Bohunov 6101 [595306] Bohuňov"
    },
    {
        "kod": 595322,
        "nazev": "Borovnice",
        "popis": "[595322] Borovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595322,
        "val": "[595322] Borovnice 6108 [595322] Borovnice"
    },
    {
        "kod": 595641,
        "nazev": "Bory",
        "popis": "[595641] Bory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595641,
        "val": "[595641] Bory 6114 [595641] Bory"
    },
    {
        "kod": 595349,
        "nazev": "Březejc",
        "popis": "[595349] Březejc",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595349,
        "val": "[595349] Brezejc 6114 [595349] Březejc"
    },
    {
        "kod": 595357,
        "nazev": "Březí",
        "popis": "[595357] Březí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595357,
        "val": "[595357] Brezi 6114 [595357] Březí"
    },
    {
        "kod": 595365,
        "nazev": "Březí nad Oslavou",
        "popis": "[595365] Březí nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595365,
        "val": "[595365] Brezi nad Oslavou 6115 [595365] Březí nad Oslavou"
    },
    {
        "kod": 595381,
        "nazev": "Březské",
        "popis": "[595381] Březské",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595381,
        "val": "[595381] Brezske 6114 [595381] Březské"
    },
    {
        "kod": 595390,
        "nazev": "Budeč",
        "popis": "[595390] Budeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595390,
        "val": "[595390] Budec 6115 [595390] Budeč"
    },
    {
        "kod": 595403,
        "nazev": "Bukov",
        "popis": "[595403] Bukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595403,
        "val": "[595403] Bukov 6101 [595403] Bukov"
    },
    {
        "kod": 583669,
        "nazev": "Popůvky",
        "popis": "[583669] Popůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583669,
        "val": "[583669] Popuvky 6216 [583669] Popůvky"
    },
    {
        "kod": 595411,
        "nazev": "Bystřice nad Pernštejnem",
        "popis": "[595411] Bystřice nad Pernštejnem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595411,
        "val": "[595411] Bystrice nad Pernstejnem 6101 [595411] Bystřice nad Pernštejnem"
    },
    {
        "kod": 595420,
        "nazev": "Býšovec",
        "popis": "[595420] Býšovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595420,
        "val": "[595420] Bysovec 6101 [595420] Býšovec"
    },
    {
        "kod": 588016,
        "nazev": "Cikháj",
        "popis": "[588016] Cikháj",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 588016,
        "val": "[588016] Cikhaj 6115 [588016] Cikháj"
    },
    {
        "kod": 595438,
        "nazev": "Černá",
        "popis": "[595438] Černá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595438,
        "val": "[595438] Cerna 6114 [595438] Černá"
    },
    {
        "kod": 595454,
        "nazev": "Dalečín",
        "popis": "[595454] Dalečín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595454,
        "val": "[595454] Dalecin 6101 [595454] Dalečín"
    },
    {
        "kod": 595462,
        "nazev": "Daňkovice",
        "popis": "[595462] Daňkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595462,
        "val": "[595462] Dankovice 6108 [595462] Daňkovice"
    },
    {
        "kod": 595471,
        "nazev": "Dlouhé",
        "popis": "[595471] Dlouhé",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595471,
        "val": "[595471] Dlouhe 6108 [595471] Dlouhé"
    },
    {
        "kod": 595489,
        "nazev": "Dobrá Voda",
        "popis": "[595489] Dobrá Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595489,
        "val": "[595489] Dobra Voda 6114 [595489] Dobrá Voda"
    },
    {
        "kod": 595501,
        "nazev": "Dolní Heřmanice",
        "popis": "[595501] Dolní Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595501,
        "val": "[595501] Dolni Hermanice 6114 [595501] Dolní Heřmanice"
    },
    {
        "kod": 595519,
        "nazev": "Dolní Libochová",
        "popis": "[595519] Dolní Libochová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595519,
        "val": "[595519] Dolni Libochova 6114 [595519] Dolní Libochová"
    },
    {
        "kod": 595535,
        "nazev": "Dolní Rožínka",
        "popis": "[595535] Dolní Rožínka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595535,
        "val": "[595535] Dolni Rozinka 6101 [595535] Dolní Rožínka"
    },
    {
        "kod": 595578,
        "nazev": "Fryšava pod Žákovou horou",
        "popis": "[595578] Fryšava pod Žákovou horou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595578,
        "val": "[595578] Frysava pod Zakovou horou 6108 [595578] Fryšava pod Žákovou horou"
    },
    {
        "kod": 595586,
        "nazev": "Hamry nad Sázavou",
        "popis": "[595586] Hamry nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595586,
        "val": "[595586] Hamry nad Sazavou 6115 [595586] Hamry nad Sázavou"
    },
    {
        "kod": 595594,
        "nazev": "Herálec",
        "popis": "[595594] Herálec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595594,
        "val": "[595594] Heralec 6115 [595594] Herálec"
    },
    {
        "kod": 595608,
        "nazev": "Heřmanov",
        "popis": "[595608] Heřmanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595608,
        "val": "[595608] Hermanov 6114 [595608] Heřmanov"
    },
    {
        "kod": 595624,
        "nazev": "Hodíškov",
        "popis": "[595624] Hodíškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595624,
        "val": "[595624] Hodiskov 6115 [595624] Hodíškov"
    },
    {
        "kod": 595659,
        "nazev": "Horní Libochová",
        "popis": "[595659] Horní Libochová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595659,
        "val": "[595659] Horni Libochova 6114 [595659] Horní Libochová"
    },
    {
        "kod": 595675,
        "nazev": "Horní Radslavice",
        "popis": "[595675] Horní Radslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595675,
        "val": "[595675] Horni Radslavice 6114 [595675] Horní Radslavice"
    },
    {
        "kod": 595683,
        "nazev": "Horní Rožínka",
        "popis": "[595683] Horní Rožínka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595683,
        "val": "[595683] Horni Rozinka 6101 [595683] Horní Rožínka"
    },
    {
        "kod": 595705,
        "nazev": "Chlum-Korouhvice",
        "popis": "[595705] Chlum-Korouhvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595705,
        "val": "[595705] Chlum-Korouhvice 6101 [595705] Chlum-Korouhvice"
    },
    {
        "kod": 595713,
        "nazev": "Chlumek",
        "popis": "[595713] Chlumek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595713,
        "val": "[595713] Chlumek 6114 [595713] Chlumek"
    },
    {
        "kod": 595721,
        "nazev": "Chlumětín",
        "popis": "[595721] Chlumětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595721,
        "val": "[595721] Chlumetin 6115 [595721] Chlumětín"
    },
    {
        "kod": 595730,
        "nazev": "Jabloňov",
        "popis": "[595730] Jabloňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595730,
        "val": "[595730] Jablonov 6114 [595730] Jabloňov"
    },
    {
        "kod": 595756,
        "nazev": "Jámy",
        "popis": "[595756] Jámy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595756,
        "val": "[595756] Jamy 6115 [595756] Jámy"
    },
    {
        "kod": 595748,
        "nazev": "Javorek",
        "popis": "[595748] Javorek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595748,
        "val": "[595748] Javorek 6108 [595748] Javorek"
    },
    {
        "kod": 595772,
        "nazev": "Jimramov",
        "popis": "[595772] Jimramov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595772,
        "val": "[595772] Jimramov 6108 [595772] Jimramov"
    },
    {
        "kod": 595802,
        "nazev": "Jívoví",
        "popis": "[595802] Jívoví",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595802,
        "val": "[595802] Jivovi 6114 [595802] Jívoví"
    },
    {
        "kod": 595811,
        "nazev": "Kadolec",
        "popis": "[595811] Kadolec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595811,
        "val": "[595811] Kadolec 6114 [595811] Kadolec"
    },
    {
        "kod": 595829,
        "nazev": "Kadov",
        "popis": "[595829] Kadov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595829,
        "val": "[595829] Kadov 6108 [595829] Kadov"
    },
    {
        "kod": 595845,
        "nazev": "Karlov",
        "popis": "[595845] Karlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595845,
        "val": "[595845] Karlov 6115 [595845] Karlov"
    },
    {
        "kod": 595853,
        "nazev": "Kněževes",
        "popis": "[595853] Kněževes",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595853,
        "val": "[595853] Knezeves 6115 [595853] Kněževes"
    },
    {
        "kod": 595861,
        "nazev": "Koroužné",
        "popis": "[595861] Koroužné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 595861,
        "val": "[595861] Korouzne 6101 [595861] Koroužné"
    },
    {
        "kod": 595870,
        "nazev": "Kotlasy",
        "popis": "[595870] Kotlasy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595870,
        "val": "[595870] Kotlasy 6115 [595870] Kotlasy"
    },
    {
        "kod": 595888,
        "nazev": "Kozlov",
        "popis": "[595888] Kozlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595888,
        "val": "[595888] Kozlov 6114 [595888] Kozlov"
    },
    {
        "kod": 595896,
        "nazev": "Krásné",
        "popis": "[595896] Krásné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595896,
        "val": "[595896] Krasne 6108 [595896] Krásné"
    },
    {
        "kod": 595900,
        "nazev": "Krásněves",
        "popis": "[595900] Krásněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595900,
        "val": "[595900] Krasneves 6115 [595900] Krásněves"
    },
    {
        "kod": 587842,
        "nazev": "Křídla",
        "popis": "[587842] Křídla",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 587842,
        "val": "[587842] Kridla 6108 [587842] Křídla"
    },
    {
        "kod": 595918,
        "nazev": "Křižánky",
        "popis": "[595918] Křižánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595918,
        "val": "[595918] Krizanky 6108 [595918] Křižánky"
    },
    {
        "kod": 595926,
        "nazev": "Křižanov",
        "popis": "[595926] Křižanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595926,
        "val": "[595926] Krizanov 6114 [595926] Křižanov"
    },
    {
        "kod": 595951,
        "nazev": "Křoví",
        "popis": "[595951] Křoví",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595951,
        "val": "[595951] Krovi 6114 [595951] Křoví"
    },
    {
        "kod": 595969,
        "nazev": "Kuklík",
        "popis": "[595969] Kuklík",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 595969,
        "val": "[595969] Kuklik 6108 [595969] Kuklík"
    },
    {
        "kod": 595977,
        "nazev": "Kundratice",
        "popis": "[595977] Kundratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 595977,
        "val": "[595977] Kundratice 6114 [595977] Kundratice"
    },
    {
        "kod": 596001,
        "nazev": "Kyjov",
        "popis": "[596001] Kyjov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596001,
        "val": "[596001] Kyjov 6115 [596001] Kyjov"
    },
    {
        "kod": 596019,
        "nazev": "Lavičky",
        "popis": "[596019] Lavičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596019,
        "val": "[596019] Lavicky 6114 [596019] Lavičky"
    },
    {
        "kod": 596035,
        "nazev": "Lhotka",
        "popis": "[596035] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596035,
        "val": "[596035] Lhotka 6115 [596035] Lhotka"
    },
    {
        "kod": 596051,
        "nazev": "Lísek",
        "popis": "[596051] Lísek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596051,
        "val": "[596051] Lisek 6101 [596051] Lísek"
    },
    {
        "kod": 596060,
        "nazev": "Líšná",
        "popis": "[596060] Líšná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596060,
        "val": "[596060] Lisna 6108 [596060] Líšná"
    },
    {
        "kod": 596086,
        "nazev": "Malá Losenice",
        "popis": "[596086] Malá Losenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596086,
        "val": "[596086] Mala Losenice 6115 [596086] Malá Losenice"
    },
    {
        "kod": 596094,
        "nazev": "Martinice",
        "popis": "[596094] Martinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596094,
        "val": "[596094] Martinice 6114 [596094] Martinice"
    },
    {
        "kod": 596108,
        "nazev": "Matějov",
        "popis": "[596108] Matějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596108,
        "val": "[596108] Matejov 6115 [596108] Matějov"
    },
    {
        "kod": 596116,
        "nazev": "Měřín",
        "popis": "[596116] Měřín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596116,
        "val": "[596116] Merin 6114 [596116] Měřín"
    },
    {
        "kod": 587516,
        "nazev": "Meziříčko",
        "popis": "[587516] Meziříčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 587516,
        "val": "[587516] Meziricko 6114 [587516] Meziříčko"
    },
    {
        "kod": 549835,
        "nazev": "Milasín",
        "popis": "[549835] Milasín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 549835,
        "val": "[549835] Milasin 6101 [549835] Milasín"
    },
    {
        "kod": 587770,
        "nazev": "Milešín",
        "popis": "[587770] Milešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 587770,
        "val": "[587770] Milesin 6114 [587770] Milešín"
    },
    {
        "kod": 596132,
        "nazev": "Mirošov",
        "popis": "[596132] Mirošov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596132,
        "val": "[596132] Mirosov 6108 [596132] Mirošov"
    },
    {
        "kod": 596141,
        "nazev": "Moravec",
        "popis": "[596141] Moravec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596141,
        "val": "[596141] Moravec 6114 [596141] Moravec"
    },
    {
        "kod": 596159,
        "nazev": "Moravecké Pavlovice",
        "popis": "[596159] Moravecké Pavlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596159,
        "val": "[596159] Moravecke Pavlovice 6101 [596159] Moravecké Pavlovice"
    },
    {
        "kod": 596183,
        "nazev": "Netín",
        "popis": "[596183] Netín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596183,
        "val": "[596183] Netin 6114 [596183] Netín"
    },
    {
        "kod": 596205,
        "nazev": "Nížkov",
        "popis": "[596205] Nížkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596205,
        "val": "[596205] Nizkov 6115 [596205] Nížkov"
    },
    {
        "kod": 596213,
        "nazev": "Nová Ves",
        "popis": "[596213] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596213,
        "val": "[596213] Nova Ves 6114 [596213] Nová Ves"
    },
    {
        "kod": 596221,
        "nazev": "Nová Ves u Nového Města na Moravě",
        "popis": "[596221] Nová Ves u Nového Města na Moravě",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596221,
        "val": "[596221] Nova Ves u Noveho Mesta na Morave 6108 [596221] Nová Ves u Nového Města na Moravě"
    },
    {
        "kod": 587974,
        "nazev": "Nové Dvory",
        "popis": "[587974] Nové Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 587974,
        "val": "[587974] Nove Dvory 6115 [587974] Nové Dvory"
    },
    {
        "kod": 596230,
        "nazev": "Nové Město na Moravě",
        "popis": "[596230] Nové Město na Moravě",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596230,
        "val": "[596230] Nove Mesto na Morave 6108 [596230] Nové Město na Moravě"
    },
    {
        "kod": 596248,
        "nazev": "Nové Sady",
        "popis": "[596248] Nové Sady",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596248,
        "val": "[596248] Nove Sady 6114 [596248] Nové Sady"
    },
    {
        "kod": 596256,
        "nazev": "Nové Veselí",
        "popis": "[596256] Nové Veselí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596256,
        "val": "[596256] Nove Veseli 6115 [596256] Nové Veselí"
    },
    {
        "kod": 596264,
        "nazev": "Nový Jimramov",
        "popis": "[596264] Nový Jimramov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596264,
        "val": "[596264] Novy Jimramov 6108 [596264] Nový Jimramov"
    },
    {
        "kod": 596272,
        "nazev": "Nyklovice",
        "popis": "[596272] Nyklovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596272,
        "val": "[596272] Nyklovice 6101 [596272] Nyklovice"
    },
    {
        "kod": 596281,
        "nazev": "Obyčtov",
        "popis": "[596281] Obyčtov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596281,
        "val": "[596281] Obyctov 6115 [596281] Obyčtov"
    },
    {
        "kod": 596329,
        "nazev": "Ořechov",
        "popis": "[596329] Ořechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596329,
        "val": "[596329] Orechov 6114 [596329] Ořechov"
    },
    {
        "kod": 596337,
        "nazev": "Oslavice",
        "popis": "[596337] Oslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596337,
        "val": "[596337] Oslavice 6114 [596337] Oslavice"
    },
    {
        "kod": 511412,
        "nazev": "Oslavička",
        "popis": "[511412] Oslavička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 511412,
        "val": "[511412] Oslavicka 6114 [511412] Oslavička"
    },
    {
        "kod": 596345,
        "nazev": "Osová Bítýška",
        "popis": "[596345] Osová Bítýška",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596345,
        "val": "[596345] Osova Bityska 6114 [596345] Osová Bítýška"
    },
    {
        "kod": 596353,
        "nazev": "Osové",
        "popis": "[596353] Osové",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596353,
        "val": "[596353] Osove 6114 [596353] Osové"
    },
    {
        "kod": 596361,
        "nazev": "Ostrov nad Oslavou",
        "popis": "[596361] Ostrov nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596361,
        "val": "[596361] Ostrov nad Oslavou 6115 [596361] Ostrov nad Oslavou"
    },
    {
        "kod": 596370,
        "nazev": "Otín",
        "popis": "[596370] Otín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596370,
        "val": "[596370] Otin 6114 [596370] Otín"
    },
    {
        "kod": 596388,
        "nazev": "Pavlínov",
        "popis": "[596388] Pavlínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596388,
        "val": "[596388] Pavlinov 6114 [596388] Pavlínov"
    },
    {
        "kod": 596396,
        "nazev": "Pavlov",
        "popis": "[596396] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596396,
        "val": "[596396] Pavlov 6115 [596396] Pavlov"
    },
    {
        "kod": 596418,
        "nazev": "Petráveč",
        "popis": "[596418] Petráveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596418,
        "val": "[596418] Petravec 6114 [596418] Petráveč"
    },
    {
        "kod": 549916,
        "nazev": "Pikárec",
        "popis": "[549916] Pikárec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 549916,
        "val": "[549916] Pikarec 6114 [549916] Pikárec"
    },
    {
        "kod": 596434,
        "nazev": "Písečné",
        "popis": "[596434] Písečné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596434,
        "val": "[596434] Pisecne 6101 [596434] Písečné"
    },
    {
        "kod": 596442,
        "nazev": "Počítky",
        "popis": "[596442] Počítky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596442,
        "val": "[596442] Pocitky 6115 [596442] Počítky"
    },
    {
        "kod": 596451,
        "nazev": "Poděšín",
        "popis": "[596451] Poděšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596451,
        "val": "[596451] Podesin 6115 [596451] Poděšín"
    },
    {
        "kod": 596469,
        "nazev": "Podolí",
        "popis": "[596469] Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596469,
        "val": "[596469] Podoli 6108 [596469] Podolí"
    },
    {
        "kod": 596477,
        "nazev": "Pokojov",
        "popis": "[596477] Pokojov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596477,
        "val": "[596477] Pokojov 6115 [596477] Pokojov"
    },
    {
        "kod": 596485,
        "nazev": "Polnička",
        "popis": "[596485] Polnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596485,
        "val": "[596485] Polnicka 6115 [596485] Polnička"
    },
    {
        "kod": 596493,
        "nazev": "Prosetín",
        "popis": "[596493] Prosetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596493,
        "val": "[596493] Prosetin 6101 [596493] Prosetín"
    },
    {
        "kod": 596507,
        "nazev": "Račice",
        "popis": "[596507] Račice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596507,
        "val": "[596507] Racice 6108 [596507] Račice"
    },
    {
        "kod": 588059,
        "nazev": "Račín",
        "popis": "[588059] Račín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 588059,
        "val": "[588059] Racin 6115 [588059] Račín"
    },
    {
        "kod": 596515,
        "nazev": "Radenice",
        "popis": "[596515] Radenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596515,
        "val": "[596515] Radenice 6114 [596515] Radenice"
    },
    {
        "kod": 596523,
        "nazev": "Radešín",
        "popis": "[596523] Radešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596523,
        "val": "[596523] Radesin 6108 [596523] Radešín"
    },
    {
        "kod": 596531,
        "nazev": "Radešínská Svratka",
        "popis": "[596531] Radešínská Svratka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596531,
        "val": "[596531] Radesinska Svratka 6108 [596531] Radešínská Svratka"
    },
    {
        "kod": 549924,
        "nazev": "Radkov",
        "popis": "[549924] Radkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 549924,
        "val": "[549924] Radkov 6101 [549924] Radkov"
    },
    {
        "kod": 596540,
        "nazev": "Radňoves",
        "popis": "[596540] Radňoves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596540,
        "val": "[596540] Radnoves 6114 [596540] Radňoves"
    },
    {
        "kod": 596558,
        "nazev": "Radňovice",
        "popis": "[596558] Radňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596558,
        "val": "[596558] Radnovice 6108 [596558] Radňovice"
    },
    {
        "kod": 596566,
        "nazev": "Radostín",
        "popis": "[596566] Radostín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596566,
        "val": "[596566] Radostin 6115 [596566] Radostín"
    },
    {
        "kod": 596574,
        "nazev": "Radostín nad Oslavou",
        "popis": "[596574] Radostín nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596574,
        "val": "[596574] Radostin nad Oslavou 6115 [596574] Radostín nad Oslavou"
    },
    {
        "kod": 587737,
        "nazev": "Rodkov",
        "popis": "[587737] Rodkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 587737,
        "val": "[587737] Rodkov 6101 [587737] Rodkov"
    },
    {
        "kod": 549941,
        "nazev": "Rosička",
        "popis": "[549941] Rosička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 549941,
        "val": "[549941] Rosicka 6115 [549941] Rosička"
    },
    {
        "kod": 596604,
        "nazev": "Rousměrov",
        "popis": "[596604] Rousměrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596604,
        "val": "[596604] Rousmerov 6114 [596604] Rousměrov"
    },
    {
        "kod": 596612,
        "nazev": "Rovečné",
        "popis": "[596612] Rovečné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596612,
        "val": "[596612] Rovecne 6101 [596612] Rovečné"
    },
    {
        "kod": 596639,
        "nazev": "Rozseč",
        "popis": "[596639] Rozseč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596639,
        "val": "[596639] Rozsec 6114 [596639] Rozseč"
    },
    {
        "kod": 596647,
        "nazev": "Rozsochy",
        "popis": "[596647] Rozsochy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596647,
        "val": "[596647] Rozsochy 6101 [596647] Rozsochy"
    },
    {
        "kod": 596655,
        "nazev": "Rožná",
        "popis": "[596655] Rožná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596655,
        "val": "[596655] Rozna 6101 [596655] Rožná"
    },
    {
        "kod": 596663,
        "nazev": "Ruda",
        "popis": "[596663] Ruda",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596663,
        "val": "[596663] Ruda 6114 [596663] Ruda"
    },
    {
        "kod": 596671,
        "nazev": "Rudolec",
        "popis": "[596671] Rudolec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596671,
        "val": "[596671] Rudolec 6115 [596671] Rudolec"
    },
    {
        "kod": 596680,
        "nazev": "Řečice",
        "popis": "[596680] Řečice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596680,
        "val": "[596680] Recice 6108 [596680] Řečice"
    },
    {
        "kod": 596701,
        "nazev": "Sázava",
        "popis": "[596701] Sázava",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596701,
        "val": "[596701] Sazava 6115 [596701] Sázava"
    },
    {
        "kod": 588237,
        "nazev": "Sazomín",
        "popis": "[588237] Sazomín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 588237,
        "val": "[588237] Sazomin 6115 [588237] Sazomín"
    },
    {
        "kod": 596710,
        "nazev": "Sejřek",
        "popis": "[596710] Sejřek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596710,
        "val": "[596710] Sejrek 6101 [596710] Sejřek"
    },
    {
        "kod": 596728,
        "nazev": "Sirákov",
        "popis": "[596728] Sirákov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596728,
        "val": "[596728] Sirakov 6115 [596728] Sirákov"
    },
    {
        "kod": 596736,
        "nazev": "Sklené",
        "popis": "[596736] Sklené",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596736,
        "val": "[596736] Sklene 6115 [596736] Sklené"
    },
    {
        "kod": 596744,
        "nazev": "Sklené nad Oslavou",
        "popis": "[596744] Sklené nad Oslavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596744,
        "val": "[596744] Sklene nad Oslavou 6114 [596744] Sklené nad Oslavou"
    },
    {
        "kod": 596752,
        "nazev": "Skorotice",
        "popis": "[596752] Skorotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596752,
        "val": "[596752] Skorotice 6101 [596752] Skorotice"
    },
    {
        "kod": 596761,
        "nazev": "Skřinářov",
        "popis": "[596761] Skřinářov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596761,
        "val": "[596761] Skrinarov 6114 [596761] Skřinářov"
    },
    {
        "kod": 596787,
        "nazev": "Sněžné",
        "popis": "[596787] Sněžné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596787,
        "val": "[596787] Snezne 6108 [596787] Sněžné"
    },
    {
        "kod": 596795,
        "nazev": "Spělkov",
        "popis": "[596795] Spělkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596795,
        "val": "[596795] Spelkov 6108 [596795] Spělkov"
    },
    {
        "kod": 596809,
        "nazev": "Strachujov",
        "popis": "[596809] Strachujov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596809,
        "val": "[596809] Strachujov 6101 [596809] Strachujov"
    },
    {
        "kod": 596817,
        "nazev": "Stránecká Zhoř",
        "popis": "[596817] Stránecká Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596817,
        "val": "[596817] Stranecka Zhor 6114 [596817] Stránecká Zhoř"
    },
    {
        "kod": 596825,
        "nazev": "Strážek",
        "popis": "[596825] Strážek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596825,
        "val": "[596825] Strazek 6101 [596825] Strážek"
    },
    {
        "kod": 549886,
        "nazev": "Střítež",
        "popis": "[549886] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 549886,
        "val": "[549886] Stritez 6101 [549886] Střítež"
    },
    {
        "kod": 596833,
        "nazev": "Sulkovec",
        "popis": "[596833] Sulkovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596833,
        "val": "[596833] Sulkovec 6101 [596833] Sulkovec"
    },
    {
        "kod": 596841,
        "nazev": "Světnov",
        "popis": "[596841] Světnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596841,
        "val": "[596841] Svetnov 6115 [596841] Světnov"
    },
    {
        "kod": 596850,
        "nazev": "Sviny",
        "popis": "[596850] Sviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596850,
        "val": "[596850] Sviny 6114 [596850] Sviny"
    },
    {
        "kod": 596868,
        "nazev": "Svratka",
        "popis": "[596868] Svratka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596868,
        "val": "[596868] Svratka 6115 [596868] Svratka"
    },
    {
        "kod": 596876,
        "nazev": "Škrdlovice",
        "popis": "[596876] Škrdlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596876,
        "val": "[596876] Skrdlovice 6115 [596876] Škrdlovice"
    },
    {
        "kod": 596884,
        "nazev": "Štěpánov nad Svratkou",
        "popis": "[596884] Štěpánov nad Svratkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596884,
        "val": "[596884] Stepanov nad Svratkou 6101 [596884] Štěpánov nad Svratkou"
    },
    {
        "kod": 594512,
        "nazev": "Našiměřice",
        "popis": "[594512] Našiměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594512,
        "val": "[594512] Nasimerice 6212 [594512] Našiměřice"
    },
    {
        "kod": 594521,
        "nazev": "Němčičky",
        "popis": "[594521] Němčičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594521,
        "val": "[594521] Nemcicky 6220 [594521] Němčičky"
    },
    {
        "kod": 587729,
        "nazev": "Nový Šaldorf-Sedlešovice",
        "popis": "[587729] Nový Šaldorf-Sedlešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 587729,
        "val": "[587729] Novy Saldorf-Sedlesovice 6220 [587729] Nový Šaldorf-Sedlešovice"
    },
    {
        "kod": 594555,
        "nazev": "Olbramkostel",
        "popis": "[594555] Olbramkostel",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594555,
        "val": "[594555] Olbramkostel 6220 [594555] Olbramkostel"
    },
    {
        "kod": 594563,
        "nazev": "Olbramovice",
        "popis": "[594563] Olbramovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594563,
        "val": "[594563] Olbramovice 6212 [594563] Olbramovice"
    },
    {
        "kod": 594571,
        "nazev": "Oleksovice",
        "popis": "[594571] Oleksovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594571,
        "val": "[594571] Oleksovice 6220 [594571] Oleksovice"
    },
    {
        "kod": 594580,
        "nazev": "Onšov",
        "popis": "[594580] Onšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594580,
        "val": "[594580] Onsov 6220 [594580] Onšov"
    },
    {
        "kod": 594598,
        "nazev": "Oslnovice",
        "popis": "[594598] Oslnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594598,
        "val": "[594598] Oslnovice 6220 [594598] Oslnovice"
    },
    {
        "kod": 594601,
        "nazev": "Pavlice",
        "popis": "[594601] Pavlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594601,
        "val": "[594601] Pavlice 6220 [594601] Pavlice"
    },
    {
        "kod": 594610,
        "nazev": "Petrovice",
        "popis": "[594610] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594610,
        "val": "[594610] Petrovice 6212 [594610] Petrovice"
    },
    {
        "kod": 594628,
        "nazev": "Plaveč",
        "popis": "[594628] Plaveč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594628,
        "val": "[594628] Plavec 6220 [594628] Plaveč"
    },
    {
        "kod": 550051,
        "nazev": "Plenkovice",
        "popis": "[550051] Plenkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 550051,
        "val": "[550051] Plenkovice 6220 [550051] Plenkovice"
    },
    {
        "kod": 594636,
        "nazev": "Podhradí nad Dyjí",
        "popis": "[594636] Podhradí nad Dyjí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594636,
        "val": "[594636] Podhradi nad Dyji 6220 [594636] Podhradí nad Dyjí"
    },
    {
        "kod": 594644,
        "nazev": "Podmolí",
        "popis": "[594644] Podmolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594644,
        "val": "[594644] Podmoli 6220 [594644] Podmolí"
    },
    {
        "kod": 594652,
        "nazev": "Podmyče",
        "popis": "[594652] Podmyče",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594652,
        "val": "[594652] Podmyce 6220 [594652] Podmyče"
    },
    {
        "kod": 594679,
        "nazev": "Práče",
        "popis": "[594679] Práče",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594679,
        "val": "[594679] Prace 6220 [594679] Práče"
    },
    {
        "kod": 594687,
        "nazev": "Pravice",
        "popis": "[594687] Pravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594687,
        "val": "[594687] Pravice 6220 [594687] Pravice"
    },
    {
        "kod": 594695,
        "nazev": "Prokopov",
        "popis": "[594695] Prokopov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594695,
        "val": "[594695] Prokopov 6220 [594695] Prokopov"
    },
    {
        "kod": 594709,
        "nazev": "Prosiměřice",
        "popis": "[594709] Prosiměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594709,
        "val": "[594709] Prosimerice 6220 [594709] Prosiměřice"
    },
    {
        "kod": 550078,
        "nazev": "Přeskače",
        "popis": "[550078] Přeskače",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 550078,
        "val": "[550078] Preskace 6220 [550078] Přeskače"
    },
    {
        "kod": 594725,
        "nazev": "Rešice",
        "popis": "[594725] Rešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594725,
        "val": "[594725] Resice 6212 [594725] Rešice"
    },
    {
        "kod": 594733,
        "nazev": "Rozkoš",
        "popis": "[594733] Rozkoš",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594733,
        "val": "[594733] Rozkos 6220 [594733] Rozkoš"
    },
    {
        "kod": 594741,
        "nazev": "Rudlice",
        "popis": "[594741] Rudlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594741,
        "val": "[594741] Rudlice 6220 [594741] Rudlice"
    },
    {
        "kod": 594750,
        "nazev": "Rybníky",
        "popis": "[594750] Rybníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594750,
        "val": "[594750] Rybniky 6212 [594750] Rybníky"
    },
    {
        "kod": 594768,
        "nazev": "Skalice",
        "popis": "[594768] Skalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594768,
        "val": "[594768] Skalice 6212 [594768] Skalice"
    },
    {
        "kod": 594776,
        "nazev": "Slatina",
        "popis": "[594776] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594776,
        "val": "[594776] Slatina 6220 [594776] Slatina"
    },
    {
        "kod": 594784,
        "nazev": "Slup",
        "popis": "[594784] Slup",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594784,
        "val": "[594784] Slup 6220 [594784] Slup"
    },
    {
        "kod": 594792,
        "nazev": "Stálky",
        "popis": "[594792] Stálky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594792,
        "val": "[594792] Stalky 6220 [594792] Stálky"
    },
    {
        "kod": 594806,
        "nazev": "Starý Petřín",
        "popis": "[594806] Starý Petřín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594806,
        "val": "[594806] Stary Petrin 6220 [594806] Starý Petřín"
    },
    {
        "kod": 594814,
        "nazev": "Stošíkovice na Louce",
        "popis": "[594814] Stošíkovice na Louce",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594814,
        "val": "[594814] Stosikovice na Louce 6220 [594814] Stošíkovice na Louce"
    },
    {
        "kod": 594822,
        "nazev": "Strachotice",
        "popis": "[594822] Strachotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594822,
        "val": "[594822] Strachotice 6220 [594822] Strachotice"
    },
    {
        "kod": 594831,
        "nazev": "Střelice",
        "popis": "[594831] Střelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594831,
        "val": "[594831] Strelice 6220 [594831] Střelice"
    },
    {
        "kod": 555231,
        "nazev": "Suchohrdly",
        "popis": "[555231] Suchohrdly",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 555231,
        "val": "[555231] Suchohrdly 6220 [555231] Suchohrdly"
    },
    {
        "kod": 594849,
        "nazev": "Suchohrdly u Miroslavi",
        "popis": "[594849] Suchohrdly u Miroslavi",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594849,
        "val": "[594849] Suchohrdly u Miroslavi 6212 [594849] Suchohrdly u Miroslavi"
    },
    {
        "kod": 594865,
        "nazev": "Šafov",
        "popis": "[594865] Šafov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594865,
        "val": "[594865] Safov 6220 [594865] Šafov"
    },
    {
        "kod": 594873,
        "nazev": "Šanov",
        "popis": "[594873] Šanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594873,
        "val": "[594873] Sanov 6220 [594873] Šanov"
    },
    {
        "kod": 594881,
        "nazev": "Šatov",
        "popis": "[594881] Šatov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594881,
        "val": "[594881] Satov 6220 [594881] Šatov"
    },
    {
        "kod": 594890,
        "nazev": "Štítary",
        "popis": "[594890] Štítary",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594890,
        "val": "[594890] Stitary 6220 [594890] Štítary"
    },
    {
        "kod": 594911,
        "nazev": "Šumná",
        "popis": "[594911] Šumná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594911,
        "val": "[594911] Sumna 6220 [594911] Šumná"
    },
    {
        "kod": 594920,
        "nazev": "Tasovice",
        "popis": "[594920] Tasovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594920,
        "val": "[594920] Tasovice 6220 [594920] Tasovice"
    },
    {
        "kod": 594938,
        "nazev": "Tavíkovice",
        "popis": "[594938] Tavíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594938,
        "val": "[594938] Tavikovice 6212 [594938] Tavíkovice"
    },
    {
        "kod": 594946,
        "nazev": "Těšetice",
        "popis": "[594946] Těšetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594946,
        "val": "[594946] Tesetice 6220 [594946] Těšetice"
    },
    {
        "kod": 594954,
        "nazev": "Trnové Pole",
        "popis": "[594954] Trnové Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594954,
        "val": "[594954] Trnove Pole 6212 [594954] Trnové Pole"
    },
    {
        "kod": 594971,
        "nazev": "Trstěnice",
        "popis": "[594971] Trstěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594971,
        "val": "[594971] Trstenice 6212 [594971] Trstěnice"
    },
    {
        "kod": 594989,
        "nazev": "Tulešice",
        "popis": "[594989] Tulešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594989,
        "val": "[594989] Tulesice 6212 [594989] Tulešice"
    },
    {
        "kod": 594997,
        "nazev": "Tvořihráz",
        "popis": "[594997] Tvořihráz",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594997,
        "val": "[594997] Tvorihraz 6220 [594997] Tvořihráz"
    },
    {
        "kod": 595004,
        "nazev": "Uherčice",
        "popis": "[595004] Uherčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595004,
        "val": "[595004] Uhercice 6220 [595004] Uherčice"
    },
    {
        "kod": 595012,
        "nazev": "Újezd",
        "popis": "[595012] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595012,
        "val": "[595012] Ujezd 6220 [595012] Újezd"
    },
    {
        "kod": 595021,
        "nazev": "Únanov",
        "popis": "[595021] Únanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595021,
        "val": "[595021] Unanov 6220 [595021] Únanov"
    },
    {
        "kod": 595039,
        "nazev": "Valtrovice",
        "popis": "[595039] Valtrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595039,
        "val": "[595039] Valtrovice 6220 [595039] Valtrovice"
    },
    {
        "kod": 595047,
        "nazev": "Vedrovice",
        "popis": "[595047] Vedrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 595047,
        "val": "[595047] Vedrovice 6212 [595047] Vedrovice"
    },
    {
        "kod": 545325,
        "nazev": "Velký Karlov",
        "popis": "[545325] Velký Karlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 545325,
        "val": "[545325] Velky Karlov 6220 [545325] Velký Karlov"
    },
    {
        "kod": 595055,
        "nazev": "Vémyslice",
        "popis": "[595055] Vémyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 595055,
        "val": "[595055] Vemyslice 6212 [595055] Vémyslice"
    },
    {
        "kod": 595063,
        "nazev": "Vevčice",
        "popis": "[595063] Vevčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595063,
        "val": "[595063] Vevcice 6220 [595063] Vevčice"
    },
    {
        "kod": 595071,
        "nazev": "Višňové",
        "popis": "[595071] Višňové",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595071,
        "val": "[595071] Visnove 6220 [595071] Višňové"
    },
    {
        "kod": 595080,
        "nazev": "Vítonice",
        "popis": "[595080] Vítonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595080,
        "val": "[595080] Vitonice 6220 [595080] Vítonice"
    },
    {
        "kod": 550019,
        "nazev": "Vracovice",
        "popis": "[550019] Vracovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 550019,
        "val": "[550019] Vracovice 6220 [550019] Vracovice"
    },
    {
        "kod": 595098,
        "nazev": "Vranov nad Dyjí",
        "popis": "[595098] Vranov nad Dyjí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595098,
        "val": "[595098] Vranov nad Dyji 6220 [595098] Vranov nad Dyjí"
    },
    {
        "kod": 595101,
        "nazev": "Vranovská Ves",
        "popis": "[595101] Vranovská Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595101,
        "val": "[595101] Vranovska Ves 6220 [595101] Vranovská Ves"
    },
    {
        "kod": 595110,
        "nazev": "Vratěnín",
        "popis": "[595110] Vratěnín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595110,
        "val": "[595110] Vratenin 6220 [595110] Vratěnín"
    },
    {
        "kod": 595128,
        "nazev": "Vrbovec",
        "popis": "[595128] Vrbovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595128,
        "val": "[595128] Vrbovec 6220 [595128] Vrbovec"
    },
    {
        "kod": 595136,
        "nazev": "Výrovice",
        "popis": "[595136] Výrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595136,
        "val": "[595136] Vyrovice 6220 [595136] Výrovice"
    },
    {
        "kod": 595144,
        "nazev": "Vysočany",
        "popis": "[595144] Vysočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595144,
        "val": "[595144] Vysocany 6220 [595144] Vysočany"
    },
    {
        "kod": 595152,
        "nazev": "Zálesí",
        "popis": "[595152] Zálesí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595152,
        "val": "[595152] Zalesi 6220 [595152] Zálesí"
    },
    {
        "kod": 595161,
        "nazev": "Zblovice",
        "popis": "[595161] Zblovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595161,
        "val": "[595161] Zblovice 6220 [595161] Zblovice"
    },
    {
        "kod": 593711,
        "nazev": "Znojmo",
        "popis": "[593711] Znojmo",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593711,
        "val": "[593711] Znojmo 6220 [593711] Znojmo"
    },
    {
        "kod": 595179,
        "nazev": "Želetice",
        "popis": "[595179] Želetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595179,
        "val": "[595179] Zeletice 6220 [595179] Želetice"
    },
    {
        "kod": 595187,
        "nazev": "Žerotice",
        "popis": "[595187] Žerotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595187,
        "val": "[595187] Zerotice 6220 [595187] Žerotice"
    },
    {
        "kod": 595195,
        "nazev": "Žerůtky",
        "popis": "[595195] Žerůtky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 595195,
        "val": "[595195] Zerutky 6220 [595195] Žerůtky"
    },
    {
        "kod": 523917,
        "nazev": "Bělá pod Pradědem",
        "popis": "[523917] Bělá pod Pradědem",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 523917,
        "val": "[523917] Bela pod Pradedem 7102 [523917] Bělá pod Pradědem"
    },
    {
        "kod": 524891,
        "nazev": "Bernartice",
        "popis": "[524891] Bernartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 524891,
        "val": "[524891] Bernartice 7102 [524891] Bernartice"
    },
    {
        "kod": 525227,
        "nazev": "Bílá Voda",
        "popis": "[525227] Bílá Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 525227,
        "val": "[525227] Bila Voda 7102 [525227] Bílá Voda"
    },
    {
        "kod": 533491,
        "nazev": "Černá Voda",
        "popis": "[533491] Černá Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 533491,
        "val": "[533491] Cerna Voda 7102 [533491] Černá Voda"
    },
    {
        "kod": 569356,
        "nazev": "Česká Ves",
        "popis": "[569356] Česká Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 569356,
        "val": "[569356] Ceska Ves 7102 [569356] Česká Ves"
    },
    {
        "kod": 553301,
        "nazev": "Hradec-Nová Ves",
        "popis": "[553301] Hradec-Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 553301,
        "val": "[553301] Hradec-Nova Ves 7102 [553301] Hradec-Nová Ves"
    },
    {
        "kod": 536148,
        "nazev": "Javorník",
        "popis": "[536148] Javorník",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 536148,
        "val": "[536148] Javornik 7102 [536148] Javorník"
    },
    {
        "kod": 536385,
        "nazev": "Jeseník",
        "popis": "[536385] Jeseník",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 536385,
        "val": "[536385] Jesenik 7102 [536385] Jeseník"
    },
    {
        "kod": 557218,
        "nazev": "Kobylá nad Vidnavkou",
        "popis": "[557218] Kobylá nad Vidnavkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 557218,
        "val": "[557218] Kobyla nad Vidnavkou 7102 [557218] Kobylá nad Vidnavkou"
    },
    {
        "kod": 540030,
        "nazev": "Lipová-lázně",
        "popis": "[540030] Lipová-lázně",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 540030,
        "val": "[540030] Lipova-lazne 7102 [540030] Lipová-lázně"
    },
    {
        "kod": 540382,
        "nazev": "Mikulovice",
        "popis": "[540382] Mikulovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 540382,
        "val": "[540382] Mikulovice 7102 [540382] Mikulovice"
    },
    {
        "kod": 569330,
        "nazev": "Ostružná",
        "popis": "[569330] Ostružná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 569330,
        "val": "[569330] Ostruzna 7102 [569330] Ostružná"
    },
    {
        "kod": 540684,
        "nazev": "Písečná",
        "popis": "[540684] Písečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 540684,
        "val": "[540684] Pisecna 7102 [540684] Písečná"
    },
    {
        "kod": 553484,
        "nazev": "Skorošice",
        "popis": "[553484] Skorošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 553484,
        "val": "[553484] Skorosice 7102 [553484] Skorošice"
    },
    {
        "kod": 541036,
        "nazev": "Stará Červená Voda",
        "popis": "[541036] Stará Červená Voda",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541036,
        "val": "[541036] Stara Cervena Voda 7102 [541036] Stará Červená Voda"
    },
    {
        "kod": 541117,
        "nazev": "Supíkovice",
        "popis": "[541117] Supíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541117,
        "val": "[541117] Supikovice 7102 [541117] Supíkovice"
    },
    {
        "kod": 541214,
        "nazev": "Uhelná",
        "popis": "[541214] Uhelná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541214,
        "val": "[541214] Uhelna 7102 [541214] Uhelná"
    },
    {
        "kod": 541249,
        "nazev": "Vápenná",
        "popis": "[541249] Vápenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541249,
        "val": "[541249] Vapenna 7102 [541249] Vápenná"
    },
    {
        "kod": 553468,
        "nazev": "Velká Kraš",
        "popis": "[553468] Velká Kraš",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 553468,
        "val": "[553468] Velka Kras 7102 [553468] Velká Kraš"
    },
    {
        "kod": 569453,
        "nazev": "Velké Kunětice",
        "popis": "[569453] Velké Kunětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 569453,
        "val": "[569453] Velke Kunetice 7102 [569453] Velké Kunětice"
    },
    {
        "kod": 541303,
        "nazev": "Vidnava",
        "popis": "[541303] Vidnava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541303,
        "val": "[541303] Vidnava 7102 [541303] Vidnava"
    },
    {
        "kod": 541346,
        "nazev": "Vlčice",
        "popis": "[541346] Vlčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541346,
        "val": "[541346] Vlcice 7102 [541346] Vlčice"
    },
    {
        "kod": 597996,
        "nazev": "Zlaté Hory",
        "popis": "[597996] Zlaté Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 597996,
        "val": "[597996] Zlate Hory 7102 [597996] Zlaté Hory"
    },
    {
        "kod": 541575,
        "nazev": "Žulová",
        "popis": "[541575] Žulová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7102,
        "iczuj": 541575,
        "val": "[541575] Zulova 7102 [541575] Žulová"
    },
    {
        "kod": 552356,
        "nazev": "Babice",
        "popis": "[552356] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552356,
        "val": "[552356] Babice 7110 [552356] Babice"
    },
    {
        "kod": 500526,
        "nazev": "Bělkovice-Lašťany",
        "popis": "[500526] Bělkovice-Lašťany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500526,
        "val": "[500526] Belkovice-Lastany 7107 [500526] Bělkovice-Lašťany"
    },
    {
        "kod": 500623,
        "nazev": "Bílá Lhota",
        "popis": "[500623] Bílá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 500623,
        "val": "[500623] Bila Lhota 7105 [500623] Bílá Lhota"
    },
    {
        "kod": 552062,
        "nazev": "Bílsko",
        "popis": "[552062] Bílsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552062,
        "val": "[552062] Bilsko 7105 [552062] Bílsko"
    },
    {
        "kod": 500801,
        "nazev": "Blatec",
        "popis": "[500801] Blatec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500801,
        "val": "[500801] Blatec 7107 [500801] Blatec"
    },
    {
        "kod": 500852,
        "nazev": "Bohuňovice",
        "popis": "[500852] Bohuňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500852,
        "val": "[500852] Bohunovice 7107 [500852] Bohuňovice"
    },
    {
        "kod": 500861,
        "nazev": "Bouzov",
        "popis": "[500861] Bouzov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 500861,
        "val": "[500861] Bouzov 7105 [500861] Bouzov"
    },
    {
        "kod": 552402,
        "nazev": "Bukovany",
        "popis": "[552402] Bukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552402,
        "val": "[552402] Bukovany 7107 [552402] Bukovany"
    },
    {
        "kod": 500879,
        "nazev": "Bystročice",
        "popis": "[500879] Bystročice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500879,
        "val": "[500879] Bystrocice 7107 [500879] Bystročice"
    },
    {
        "kod": 547026,
        "nazev": "Bystrovany",
        "popis": "[547026] Bystrovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 547026,
        "val": "[547026] Bystrovany 7107 [547026] Bystrovany"
    },
    {
        "kod": 552186,
        "nazev": "Červenka",
        "popis": "[552186] Červenka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552186,
        "val": "[552186] Cervenka 7105 [552186] Červenka"
    },
    {
        "kod": 552445,
        "nazev": "Daskabát",
        "popis": "[552445] Daskabát",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552445,
        "val": "[552445] Daskabat 7107 [552445] Daskabát"
    },
    {
        "kod": 501476,
        "nazev": "Dlouhá Loučka",
        "popis": "[501476] Dlouhá Loučka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 501476,
        "val": "[501476] Dlouha Loucka 7112 [501476] Dlouhá Loučka"
    },
    {
        "kod": 501646,
        "nazev": "Dolany",
        "popis": "[501646] Dolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 501646,
        "val": "[501646] Dolany 7107 [501646] Dolany"
    },
    {
        "kod": 568392,
        "nazev": "Doloplazy",
        "popis": "[568392] Doloplazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 568392,
        "val": "[568392] Doloplazy 7107 [568392] Doloplazy"
    },
    {
        "kod": 545279,
        "nazev": "Domašov nad Bystřicí",
        "popis": "[545279] Domašov nad Bystřicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 545279,
        "val": "[545279] Domasov nad Bystrici 7110 [545279] Domašov nad Bystřicí"
    },
    {
        "kod": 552313,
        "nazev": "Domašov u Šternberka",
        "popis": "[552313] Domašov u Šternberka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552313,
        "val": "[552313] Domasov u Sternberka 7110 [552313] Domašov u Šternberka"
    },
    {
        "kod": 501751,
        "nazev": "Drahanovice",
        "popis": "[501751] Drahanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 501751,
        "val": "[501751] Drahanovice 7107 [501751] Drahanovice"
    },
    {
        "kod": 501794,
        "nazev": "Dub nad Moravou",
        "popis": "[501794] Dub nad Moravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 501794,
        "val": "[501794] Dub nad Moravou 7107 [501794] Dub nad Moravou"
    },
    {
        "kod": 552071,
        "nazev": "Dubčany",
        "popis": "[552071] Dubčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552071,
        "val": "[552071] Dubcany 7105 [552071] Dubčany"
    },
    {
        "kod": 501841,
        "nazev": "Grygov",
        "popis": "[501841] Grygov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 501841,
        "val": "[501841] Grygov 7107 [501841] Grygov"
    },
    {
        "kod": 552178,
        "nazev": "Haňovice",
        "popis": "[552178] Haňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552178,
        "val": "[552178] Hanovice 7105 [552178] Haňovice"
    },
    {
        "kod": 552330,
        "nazev": "Hlásnice",
        "popis": "[552330] Hlásnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552330,
        "val": "[552330] Hlasnice 7110 [552330] Hlásnice"
    },
    {
        "kod": 502146,
        "nazev": "Hlubočky",
        "popis": "[502146] Hlubočky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 502146,
        "val": "[502146] Hlubocky 7107 [502146] Hlubočky"
    },
    {
        "kod": 552020,
        "nazev": "Hlušovice",
        "popis": "[552020] Hlušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552020,
        "val": "[552020] Hlusovice 7107 [552020] Hlušovice"
    },
    {
        "kod": 502235,
        "nazev": "Hněvotín",
        "popis": "[502235] Hněvotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 502235,
        "val": "[502235] Hnevotin 7107 [502235] Hněvotín"
    },
    {
        "kod": 502405,
        "nazev": "Hnojice",
        "popis": "[502405] Hnojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 502405,
        "val": "[502405] Hnojice 7110 [502405] Hnojice"
    },
    {
        "kod": 502545,
        "nazev": "Horka nad Moravou",
        "popis": "[502545] Horka nad Moravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 502545,
        "val": "[502545] Horka nad Moravou 7107 [502545] Horka nad Moravou"
    },
    {
        "kod": 569798,
        "nazev": "Horní Loděnice",
        "popis": "[569798] Horní Loděnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 569798,
        "val": "[569798] Horni Lodenice 7110 [569798] Horní Loděnice"
    },
    {
        "kod": 546976,
        "nazev": "Hraničné Petrovice",
        "popis": "[546976] Hraničné Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 546976,
        "val": "[546976] Hranicne Petrovice 7110 [546976] Hraničné Petrovice"
    },
    {
        "kod": 597414,
        "nazev": "Huzová",
        "popis": "[597414] Huzová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 597414,
        "val": "[597414] Huzova 7110 [597414] Huzová"
    },
    {
        "kod": 568872,
        "nazev": "Charváty",
        "popis": "[568872] Charváty",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 568872,
        "val": "[568872] Charvaty 7107 [568872] Charváty"
    },
    {
        "kod": 583677,
        "nazev": "Pozořice",
        "popis": "[583677] Pozořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583677,
        "val": "[583677] Pozorice 6216 [583677] Pozořice"
    },
    {
        "kod": 583685,
        "nazev": "Prace",
        "popis": "[583685] Prace",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583685,
        "val": "[583685] Prace 6216 [583685] Prace"
    },
    {
        "kod": 583693,
        "nazev": "Pravlov",
        "popis": "[583693] Pravlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583693,
        "val": "[583693] Pravlov 6208 [583693] Pravlov"
    },
    {
        "kod": 583707,
        "nazev": "Prštice",
        "popis": "[583707] Prštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583707,
        "val": "[583707] Prstice 6216 [583707] Prštice"
    },
    {
        "kod": 549746,
        "nazev": "Předklášteří",
        "popis": "[549746] Předklášteří",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 549746,
        "val": "[549746] Predklasteri 6217 [549746] Předklášteří"
    },
    {
        "kod": 584843,
        "nazev": "Přibice",
        "popis": "[584843] Přibice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 584843,
        "val": "[584843] Pribice 6213 [584843] Přibice"
    },
    {
        "kod": 583715,
        "nazev": "Příbram na Moravě",
        "popis": "[583715] Příbram na Moravě",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583715,
        "val": "[583715] Pribram na Morave 6214 [583715] Příbram na Moravě"
    },
    {
        "kod": 583723,
        "nazev": "Přibyslavice",
        "popis": "[583723] Přibyslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583723,
        "val": "[583723] Pribyslavice 6214 [583723] Přibyslavice"
    },
    {
        "kod": 583731,
        "nazev": "Přísnotice",
        "popis": "[583731] Přísnotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583731,
        "val": "[583731] Prisnotice 6221 [583731] Přísnotice"
    },
    {
        "kod": 583740,
        "nazev": "Radostice",
        "popis": "[583740] Radostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583740,
        "val": "[583740] Radostice 6216 [583740] Radostice"
    },
    {
        "kod": 583758,
        "nazev": "Rajhrad",
        "popis": "[583758] Rajhrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583758,
        "val": "[583758] Rajhrad 6221 [583758] Rajhrad"
    },
    {
        "kod": 583766,
        "nazev": "Rajhradice",
        "popis": "[583766] Rajhradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583766,
        "val": "[583766] Rajhradice 6221 [583766] Rajhradice"
    },
    {
        "kod": 582255,
        "nazev": "Rašov",
        "popis": "[582255] Rašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582255,
        "val": "[582255] Rasov 6217 [582255] Rašov"
    },
    {
        "kod": 583774,
        "nazev": "Rebešovice",
        "popis": "[583774] Rebešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583774,
        "val": "[583774] Rebesovice 6216 [583774] Rebešovice"
    },
    {
        "kod": 582263,
        "nazev": "Rohozec",
        "popis": "[582263] Rohozec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582263,
        "val": "[582263] Rohozec 6217 [582263] Rohozec"
    },
    {
        "kod": 596582,
        "nazev": "Rojetín",
        "popis": "[596582] Rojetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596582,
        "val": "[596582] Rojetin 6217 [596582] Rojetín"
    },
    {
        "kod": 583782,
        "nazev": "Rosice",
        "popis": "[583782] Rosice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583782,
        "val": "[583782] Rosice 6214 [583782] Rosice"
    },
    {
        "kod": 583791,
        "nazev": "Rozdrojovice",
        "popis": "[583791] Rozdrojovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583791,
        "val": "[583791] Rozdrojovice 6209 [583791] Rozdrojovice"
    },
    {
        "kod": 583804,
        "nazev": "Rudka",
        "popis": "[583804] Rudka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583804,
        "val": "[583804] Rudka 6214 [583804] Rudka"
    },
    {
        "kod": 583821,
        "nazev": "Řícmanice",
        "popis": "[583821] Řícmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583821,
        "val": "[583821] Ricmanice 6216 [583821] Řícmanice"
    },
    {
        "kod": 583839,
        "nazev": "Říčany",
        "popis": "[583839] Říčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583839,
        "val": "[583839] Ricany 6214 [583839] Říčany"
    },
    {
        "kod": 549789,
        "nazev": "Říčky",
        "popis": "[549789] Říčky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 549789,
        "val": "[549789] Ricky 6214 [549789] Říčky"
    },
    {
        "kod": 596698,
        "nazev": "Řikonín",
        "popis": "[596698] Řikonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596698,
        "val": "[596698] Rikonin 6217 [596698] Řikonín"
    },
    {
        "kod": 591661,
        "nazev": "Senorady",
        "popis": "[591661] Senorady",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 591661,
        "val": "[591661] Senorady 6208 [591661] Senorady"
    },
    {
        "kod": 583847,
        "nazev": "Sentice",
        "popis": "[583847] Sentice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583847,
        "val": "[583847] Sentice 6217 [583847] Sentice"
    },
    {
        "kod": 583855,
        "nazev": "Silůvky",
        "popis": "[583855] Silůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583855,
        "val": "[583855] Siluvky 6216 [583855] Silůvky"
    },
    {
        "kod": 583863,
        "nazev": "Sivice",
        "popis": "[583863] Sivice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583863,
        "val": "[583863] Sivice 6216 [583863] Sivice"
    },
    {
        "kod": 545295,
        "nazev": "Skalička",
        "popis": "[545295] Skalička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 545295,
        "val": "[545295] Skalicka 6217 [545295] Skalička"
    },
    {
        "kod": 549894,
        "nazev": "Skryje",
        "popis": "[549894] Skryje",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 549894,
        "val": "[549894] Skryje 6217 [549894] Skryje"
    },
    {
        "kod": 583880,
        "nazev": "Sobotovice",
        "popis": "[583880] Sobotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583880,
        "val": "[583880] Sobotovice 6221 [583880] Sobotovice"
    },
    {
        "kod": 583898,
        "nazev": "Sokolnice",
        "popis": "[583898] Sokolnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583898,
        "val": "[583898] Sokolnice 6216 [583898] Sokolnice"
    },
    {
        "kod": 583901,
        "nazev": "Stanoviště",
        "popis": "[583901] Stanoviště",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583901,
        "val": "[583901] Stanoviste 6214 [583901] Stanoviště"
    },
    {
        "kod": 582379,
        "nazev": "Strhaře",
        "popis": "[582379] Strhaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582379,
        "val": "[582379] Strhare 6217 [582379] Strhaře"
    },
    {
        "kod": 583910,
        "nazev": "Střelice",
        "popis": "[583910] Střelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583910,
        "val": "[583910] Strelice 6216 [583910] Střelice"
    },
    {
        "kod": 583928,
        "nazev": "Svatoslav",
        "popis": "[583928] Svatoslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583928,
        "val": "[583928] Svatoslav 6217 [583928] Svatoslav"
    },
    {
        "kod": 582450,
        "nazev": "Synalov",
        "popis": "[582450] Synalov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582450,
        "val": "[582450] Synalov 6217 [582450] Synalov"
    },
    {
        "kod": 583936,
        "nazev": "Syrovice",
        "popis": "[583936] Syrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583936,
        "val": "[583936] Syrovice 6221 [583936] Syrovice"
    },
    {
        "kod": 583944,
        "nazev": "Šerkovice",
        "popis": "[583944] Šerkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583944,
        "val": "[583944] Serkovice 6217 [583944] Šerkovice"
    },
    {
        "kod": 583952,
        "nazev": "Šlapanice",
        "popis": "[583952] Šlapanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583952,
        "val": "[583952] Slapanice 6216 [583952] Šlapanice"
    },
    {
        "kod": 583961,
        "nazev": "Štěpánovice",
        "popis": "[583961] Štěpánovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583961,
        "val": "[583961] Stepanovice 6217 [583961] Štěpánovice"
    },
    {
        "kod": 594903,
        "nazev": "Šumice",
        "popis": "[594903] Šumice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 594903,
        "val": "[594903] Sumice 6213 [594903] Šumice"
    },
    {
        "kod": 583979,
        "nazev": "Telnice",
        "popis": "[583979] Telnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583979,
        "val": "[583979] Telnice 6216 [583979] Telnice"
    },
    {
        "kod": 583995,
        "nazev": "Těšany",
        "popis": "[583995] Těšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583995,
        "val": "[583995] Tesany 6221 [583995] Těšany"
    },
    {
        "kod": 583987,
        "nazev": "Tetčice",
        "popis": "[583987] Tetčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583987,
        "val": "[583987] Tetcice 6214 [583987] Tetčice"
    },
    {
        "kod": 584002,
        "nazev": "Tišnov",
        "popis": "[584002] Tišnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 584002,
        "val": "[584002] Tisnov 6217 [584002] Tišnov"
    },
    {
        "kod": 596892,
        "nazev": "Tišnovská Nová Ves",
        "popis": "[596892] Tišnovská Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596892,
        "val": "[596892] Tisnovska Nova Ves 6217 [596892] Tišnovská Nová Ves"
    },
    {
        "kod": 584011,
        "nazev": "Trboušany",
        "popis": "[584011] Trboušany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 584011,
        "val": "[584011] Trbousany 6208 [584011] Trboušany"
    },
    {
        "kod": 594962,
        "nazev": "Troskotovice",
        "popis": "[594962] Troskotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 594962,
        "val": "[594962] Troskotovice 6213 [594962] Troskotovice"
    },
    {
        "kod": 584029,
        "nazev": "Troubsko",
        "popis": "[584029] Troubsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584029,
        "val": "[584029] Troubsko 6216 [584029] Troubsko"
    },
    {
        "kod": 584037,
        "nazev": "Tvarožná",
        "popis": "[584037] Tvarožná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584037,
        "val": "[584037] Tvarozna 6216 [584037] Tvarožná"
    },
    {
        "kod": 584045,
        "nazev": "Újezd u Brna",
        "popis": "[584045] Újezd u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584045,
        "val": "[584045] Ujezd u Brna 6216 [584045] Újezd u Brna"
    },
    {
        "kod": 584053,
        "nazev": "Újezd u Rosic",
        "popis": "[584053] Újezd u Rosic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584053,
        "val": "[584053] Ujezd u Rosic 6214 [584053] Újezd u Rosic"
    },
    {
        "kod": 549908,
        "nazev": "Újezd u Tišnova",
        "popis": "[549908] Újezd u Tišnova",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 549908,
        "val": "[549908] Ujezd u Tisnova 6217 [549908] Újezd u Tišnova"
    },
    {
        "kod": 582565,
        "nazev": "Unín",
        "popis": "[582565] Unín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582565,
        "val": "[582565] Unin 6217 [582565] Unín"
    },
    {
        "kod": 584061,
        "nazev": "Unkovice",
        "popis": "[584061] Unkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584061,
        "val": "[584061] Unkovice 6221 [584061] Unkovice"
    },
    {
        "kod": 584070,
        "nazev": "Úsuší",
        "popis": "[584070] Úsuší",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 584070,
        "val": "[584070] Ususi 6217 [584070] Úsuší"
    },
    {
        "kod": 584096,
        "nazev": "Velatice",
        "popis": "[584096] Velatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584096,
        "val": "[584096] Velatice 6216 [584096] Velatice"
    },
    {
        "kod": 584100,
        "nazev": "Veverská Bítýška",
        "popis": "[584100] Veverská Bítýška",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 584100,
        "val": "[584100] Veverska Bityska 6209 [584100] Veverská Bítýška"
    },
    {
        "kod": 584118,
        "nazev": "Veverské Knínice",
        "popis": "[584118] Veverské Knínice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584118,
        "val": "[584118] Veverske Kninice 6214 [584118] Veverské Knínice"
    },
    {
        "kod": 584126,
        "nazev": "Viničné Šumice",
        "popis": "[584126] Viničné Šumice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584126,
        "val": "[584126] Vinicne Sumice 6216 [584126] Viničné Šumice"
    },
    {
        "kod": 585025,
        "nazev": "Vlasatice",
        "popis": "[585025] Vlasatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 585025,
        "val": "[585025] Vlasatice 6213 [585025] Vlasatice"
    },
    {
        "kod": 584134,
        "nazev": "Vohančice",
        "popis": "[584134] Vohančice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 584134,
        "val": "[584134] Vohancice 6217 [584134] Vohančice"
    },
    {
        "kod": 584142,
        "nazev": "Vojkovice",
        "popis": "[584142] Vojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584142,
        "val": "[584142] Vojkovice 6221 [584142] Vojkovice"
    },
    {
        "kod": 584151,
        "nazev": "Vranov",
        "popis": "[584151] Vranov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584151,
        "val": "[584151] Vranov 6216 [584151] Vranov"
    },
    {
        "kod": 585033,
        "nazev": "Vranovice",
        "popis": "[585033] Vranovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 585033,
        "val": "[585033] Vranovice 6213 [585033] Vranovice"
    },
    {
        "kod": 597104,
        "nazev": "Vratislávka",
        "popis": "[597104] Vratislávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 597104,
        "val": "[597104] Vratislavka 6217 [597104] Vratislávka"
    },
    {
        "kod": 584169,
        "nazev": "Všechovice",
        "popis": "[584169] Všechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 584169,
        "val": "[584169] Vsechovice 6217 [584169] Všechovice"
    },
    {
        "kod": 584177,
        "nazev": "Vysoké Popovice",
        "popis": "[584177] Vysoké Popovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584177,
        "val": "[584177] Vysoke Popovice 6214 [584177] Vysoké Popovice"
    },
    {
        "kod": 584185,
        "nazev": "Zakřany",
        "popis": "[584185] Zakřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584185,
        "val": "[584185] Zakrany 6214 [584185] Zakřany"
    },
    {
        "kod": 584193,
        "nazev": "Zálesná Zhoř",
        "popis": "[584193] Zálesná Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584193,
        "val": "[584193] Zalesna Zhor 6214 [584193] Zálesná Zhoř"
    },
    {
        "kod": 584207,
        "nazev": "Zastávka",
        "popis": "[584207] Zastávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584207,
        "val": "[584207] Zastavka 6214 [584207] Zastávka"
    },
    {
        "kod": 584215,
        "nazev": "Zbraslav",
        "popis": "[584215] Zbraslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584215,
        "val": "[584215] Zbraslav 6214 [584215] Zbraslav"
    },
    {
        "kod": 584223,
        "nazev": "Zbýšov",
        "popis": "[584223] Zbýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 584223,
        "val": "[584223] Zbysov 6214 [584223] Zbýšov"
    },
    {
        "kod": 582735,
        "nazev": "Zhoř",
        "popis": "[582735] Zhoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582735,
        "val": "[582735] Zhor 6217 [582735] Zhoř"
    },
    {
        "kod": 584231,
        "nazev": "Žabčice",
        "popis": "[584231] Žabčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584231,
        "val": "[584231] Zabcice 6221 [584231] Žabčice"
    },
    {
        "kod": 584240,
        "nazev": "Žatčany",
        "popis": "[584240] Žatčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584240,
        "val": "[584240] Zatcany 6221 [584240] Žatčany"
    },
    {
        "kod": 597171,
        "nazev": "Žďárec",
        "popis": "[597171] Žďárec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 597171,
        "val": "[597171] Zdarec 6217 [597171] Žďárec"
    },
    {
        "kod": 584266,
        "nazev": "Želešice",
        "popis": "[584266] Želešice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 584266,
        "val": "[584266] Zelesice 6216 [584266] Želešice"
    },
    {
        "kod": 584274,
        "nazev": "Železné",
        "popis": "[584274] Železné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 584274,
        "val": "[584274] Zelezne 6217 [584274] Železné"
    },
    {
        "kod": 584282,
        "nazev": "Židlochovice",
        "popis": "[584282] Židlochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584282,
        "val": "[584282] Zidlochovice 6221 [584282] Židlochovice"
    },
    {
        "kod": 584304,
        "nazev": "Bavory",
        "popis": "[584304] Bavory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584304,
        "val": "[584304] Bavory 6211 [584304] Bavory"
    },
    {
        "kod": 584321,
        "nazev": "Boleradice",
        "popis": "[584321] Boleradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584321,
        "val": "[584321] Boleradice 6207 [584321] Boleradice"
    },
    {
        "kod": 584339,
        "nazev": "Borkovany",
        "popis": "[584339] Borkovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584339,
        "val": "[584339] Borkovany 6207 [584339] Borkovany"
    },
    {
        "kod": 584347,
        "nazev": "Bořetice",
        "popis": "[584347] Bořetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584347,
        "val": "[584347] Boretice 6207 [584347] Bořetice"
    },
    {
        "kod": 584355,
        "nazev": "Brod nad Dyjí",
        "popis": "[584355] Brod nad Dyjí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584355,
        "val": "[584355] Brod nad Dyji 6211 [584355] Brod nad Dyjí"
    },
    {
        "kod": 584363,
        "nazev": "Brumovice",
        "popis": "[584363] Brumovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584363,
        "val": "[584363] Brumovice 6207 [584363] Brumovice"
    },
    {
        "kod": 584291,
        "nazev": "Břeclav",
        "popis": "[584291] Břeclav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584291,
        "val": "[584291] Breclav 6204 [584291] Břeclav"
    },
    {
        "kod": 584371,
        "nazev": "Březí",
        "popis": "[584371] Březí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584371,
        "val": "[584371] Brezi 6211 [584371] Březí"
    },
    {
        "kod": 584380,
        "nazev": "Bulhary",
        "popis": "[584380] Bulhary",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584380,
        "val": "[584380] Bulhary 6204 [584380] Bulhary"
    },
    {
        "kod": 584401,
        "nazev": "Diváky",
        "popis": "[584401] Diváky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584401,
        "val": "[584401] Divaky 6207 [584401] Diváky"
    },
    {
        "kod": 584410,
        "nazev": "Dobré Pole",
        "popis": "[584410] Dobré Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584410,
        "val": "[584410] Dobre Pole 6211 [584410] Dobré Pole"
    },
    {
        "kod": 584428,
        "nazev": "Dolní Dunajovice",
        "popis": "[584428] Dolní Dunajovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584428,
        "val": "[584428] Dolni Dunajovice 6211 [584428] Dolní Dunajovice"
    },
    {
        "kod": 584436,
        "nazev": "Dolní Věstonice",
        "popis": "[584436] Dolní Věstonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584436,
        "val": "[584436] Dolni Vestonice 6211 [584436] Dolní Věstonice"
    },
    {
        "kod": 584444,
        "nazev": "Drnholec",
        "popis": "[584444] Drnholec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584444,
        "val": "[584444] Drnholec 6211 [584444] Drnholec"
    },
    {
        "kod": 584452,
        "nazev": "Hlohovec",
        "popis": "[584452] Hlohovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584452,
        "val": "[584452] Hlohovec 6204 [584452] Hlohovec"
    },
    {
        "kod": 584461,
        "nazev": "Horní Bojanovice",
        "popis": "[584461] Horní Bojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584461,
        "val": "[584461] Horni Bojanovice 6207 [584461] Horní Bojanovice"
    },
    {
        "kod": 584479,
        "nazev": "Horní Věstonice",
        "popis": "[584479] Horní Věstonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584479,
        "val": "[584479] Horni Vestonice 6211 [584479] Horní Věstonice"
    },
    {
        "kod": 584487,
        "nazev": "Hrušky",
        "popis": "[584487] Hrušky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584487,
        "val": "[584487] Hrusky 6204 [584487] Hrušky"
    },
    {
        "kod": 584495,
        "nazev": "Hustopeče",
        "popis": "[584495] Hustopeče",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584495,
        "val": "[584495] Hustopece 6207 [584495] Hustopeče"
    },
    {
        "kod": 584525,
        "nazev": "Jevišovka",
        "popis": "[584525] Jevišovka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584525,
        "val": "[584525] Jevisovka 6211 [584525] Jevišovka"
    },
    {
        "kod": 550256,
        "nazev": "Kašnice",
        "popis": "[550256] Kašnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 550256,
        "val": "[550256] Kasnice 6207 [550256] Kašnice"
    },
    {
        "kod": 584541,
        "nazev": "Klentnice",
        "popis": "[584541] Klentnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584541,
        "val": "[584541] Klentnice 6211 [584541] Klentnice"
    },
    {
        "kod": 584550,
        "nazev": "Klobouky u Brna",
        "popis": "[584550] Klobouky u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584550,
        "val": "[584550] Klobouky u Brna 6207 [584550] Klobouky u Brna"
    },
    {
        "kod": 584568,
        "nazev": "Kobylí",
        "popis": "[584568] Kobylí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584568,
        "val": "[584568] Kobyli 6207 [584568] Kobylí"
    },
    {
        "kod": 584576,
        "nazev": "Kostice",
        "popis": "[584576] Kostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584576,
        "val": "[584576] Kostice 6204 [584576] Kostice"
    },
    {
        "kod": 584584,
        "nazev": "Krumvíř",
        "popis": "[584584] Krumvíř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584584,
        "val": "[584584] Krumvir 6207 [584584] Krumvíř"
    },
    {
        "kod": 584592,
        "nazev": "Křepice",
        "popis": "[584592] Křepice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584592,
        "val": "[584592] Krepice 6207 [584592] Křepice"
    },
    {
        "kod": 555282,
        "nazev": "Kurdějov",
        "popis": "[555282] Kurdějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 555282,
        "val": "[555282] Kurdejov 6207 [555282] Kurdějov"
    },
    {
        "kod": 558443,
        "nazev": "Ladná",
        "popis": "[558443] Ladná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 558443,
        "val": "[558443] Ladna 6204 [558443] Ladná"
    },
    {
        "kod": 584622,
        "nazev": "Lanžhot",
        "popis": "[584622] Lanžhot",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584622,
        "val": "[584622] Lanzhot 6204 [584622] Lanžhot"
    },
    {
        "kod": 584631,
        "nazev": "Lednice",
        "popis": "[584631] Lednice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584631,
        "val": "[584631] Lednice 6204 [584631] Lednice"
    },
    {
        "kod": 584649,
        "nazev": "Mikulov",
        "popis": "[584649] Mikulov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584649,
        "val": "[584649] Mikulov 6211 [584649] Mikulov"
    },
    {
        "kod": 584657,
        "nazev": "Milovice",
        "popis": "[584657] Milovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584657,
        "val": "[584657] Milovice 6211 [584657] Milovice"
    },
    {
        "kod": 584665,
        "nazev": "Moravská Nová Ves",
        "popis": "[584665] Moravská Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584665,
        "val": "[584665] Moravska Nova Ves 6204 [584665] Moravská Nová Ves"
    },
    {
        "kod": 584673,
        "nazev": "Moravský Žižkov",
        "popis": "[584673] Moravský Žižkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584673,
        "val": "[584673] Moravsky Zizkov 6204 [584673] Moravský Žižkov"
    },
    {
        "kod": 584681,
        "nazev": "Morkůvky",
        "popis": "[584681] Morkůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584681,
        "val": "[584681] Morkuvky 6207 [584681] Morkůvky"
    },
    {
        "kod": 584703,
        "nazev": "Němčičky",
        "popis": "[584703] Němčičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584703,
        "val": "[584703] Nemcicky 6207 [584703] Němčičky"
    },
    {
        "kod": 584711,
        "nazev": "Nikolčice",
        "popis": "[584711] Nikolčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584711,
        "val": "[584711] Nikolcice 6207 [584711] Nikolčice"
    },
    {
        "kod": 584746,
        "nazev": "Novosedly",
        "popis": "[584746] Novosedly",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584746,
        "val": "[584746] Novosedly 6211 [584746] Novosedly"
    },
    {
        "kod": 584754,
        "nazev": "Nový Přerov",
        "popis": "[584754] Nový Přerov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584754,
        "val": "[584754] Novy Prerov 6211 [584754] Nový Přerov"
    },
    {
        "kod": 584771,
        "nazev": "Pavlov",
        "popis": "[584771] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584771,
        "val": "[584771] Pavlov 6211 [584771] Pavlov"
    },
    {
        "kod": 584789,
        "nazev": "Perná",
        "popis": "[584789] Perná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584789,
        "val": "[584789] Perna 6211 [584789] Perná"
    },
    {
        "kod": 584797,
        "nazev": "Podivín",
        "popis": "[584797] Podivín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584797,
        "val": "[584797] Podivin 6204 [584797] Podivín"
    },
    {
        "kod": 584819,
        "nazev": "Popice",
        "popis": "[584819] Popice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584819,
        "val": "[584819] Popice 6207 [584819] Popice"
    },
    {
        "kod": 584835,
        "nazev": "Pouzdřany",
        "popis": "[584835] Pouzdřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584835,
        "val": "[584835] Pouzdrany 6207 [584835] Pouzdřany"
    },
    {
        "kod": 584851,
        "nazev": "Přítluky",
        "popis": "[584851] Přítluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584851,
        "val": "[584851] Pritluky 6204 [584851] Přítluky"
    },
    {
        "kod": 584860,
        "nazev": "Rakvice",
        "popis": "[584860] Rakvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584860,
        "val": "[584860] Rakvice 6204 [584860] Rakvice"
    },
    {
        "kod": 584878,
        "nazev": "Sedlec",
        "popis": "[584878] Sedlec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6211,
        "iczuj": 584878,
        "val": "[584878] Sedlec 6211 [584878] Sedlec"
    },
    {
        "kod": 589896,
        "nazev": "Plumlov",
        "popis": "[589896] Plumlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589896,
        "val": "[589896] Plumlov 7108 [589896] Plumlov"
    },
    {
        "kod": 549983,
        "nazev": "Polomí",
        "popis": "[549983] Polomí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 549983,
        "val": "[549983] Polomi 7103 [549983] Polomí"
    },
    {
        "kod": 589250,
        "nazev": "Prostějov",
        "popis": "[589250] Prostějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589250,
        "val": "[589250] Prostejov 7108 [589250] Prostějov"
    },
    {
        "kod": 589918,
        "nazev": "Prostějovičky",
        "popis": "[589918] Prostějovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589918,
        "val": "[589918] Prostejovicky 7108 [589918] Prostějovičky"
    },
    {
        "kod": 589926,
        "nazev": "Protivanov",
        "popis": "[589926] Protivanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589926,
        "val": "[589926] Protivanov 7108 [589926] Protivanov"
    },
    {
        "kod": 589934,
        "nazev": "Přemyslovice",
        "popis": "[589934] Přemyslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589934,
        "val": "[589934] Premyslovice 7108 [589934] Přemyslovice"
    },
    {
        "kod": 589942,
        "nazev": "Ptení",
        "popis": "[589942] Ptení",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589942,
        "val": "[589942] Pteni 7108 [589942] Ptení"
    },
    {
        "kod": 589951,
        "nazev": "Raková u Konice",
        "popis": "[589951] Raková u Konice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589951,
        "val": "[589951] Rakova u Konice 7103 [589951] Raková u Konice"
    },
    {
        "kod": 589969,
        "nazev": "Rakůvka",
        "popis": "[589969] Rakůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589969,
        "val": "[589969] Rakuvka 7103 [589969] Rakůvka"
    },
    {
        "kod": 589977,
        "nazev": "Rozstání",
        "popis": "[589977] Rozstání",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589977,
        "val": "[589977] Rozstani 7108 [589977] Rozstání"
    },
    {
        "kod": 506770,
        "nazev": "Seloutky",
        "popis": "[506770] Seloutky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 506770,
        "val": "[506770] Seloutky 7108 [506770] Seloutky"
    },
    {
        "kod": 589993,
        "nazev": "Skalka",
        "popis": "[589993] Skalka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589993,
        "val": "[589993] Skalka 7108 [589993] Skalka"
    },
    {
        "kod": 590002,
        "nazev": "Skřípov",
        "popis": "[590002] Skřípov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 590002,
        "val": "[590002] Skripov 7103 [590002] Skřípov"
    },
    {
        "kod": 590011,
        "nazev": "Slatinky",
        "popis": "[590011] Slatinky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590011,
        "val": "[590011] Slatinky 7108 [590011] Slatinky"
    },
    {
        "kod": 590029,
        "nazev": "Smržice",
        "popis": "[590029] Smržice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590029,
        "val": "[590029] Smrzice 7108 [590029] Smržice"
    },
    {
        "kod": 590045,
        "nazev": "Srbce",
        "popis": "[590045] Srbce",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590045,
        "val": "[590045] Srbce 7108 [590045] Srbce"
    },
    {
        "kod": 590053,
        "nazev": "Stařechovice",
        "popis": "[590053] Stařechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590053,
        "val": "[590053] Starechovice 7108 [590053] Stařechovice"
    },
    {
        "kod": 590061,
        "nazev": "Stínava",
        "popis": "[590061] Stínava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590061,
        "val": "[590061] Stinava 7108 [590061] Stínava"
    },
    {
        "kod": 590070,
        "nazev": "Stražisko",
        "popis": "[590070] Stražisko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 590070,
        "val": "[590070] Strazisko 7103 [590070] Stražisko"
    },
    {
        "kod": 590088,
        "nazev": "Suchdol",
        "popis": "[590088] Suchdol",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 590088,
        "val": "[590088] Suchdol 7103 [590088] Suchdol"
    },
    {
        "kod": 590096,
        "nazev": "Šubířov",
        "popis": "[590096] Šubířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 590096,
        "val": "[590096] Subirov 7103 [590096] Šubířov"
    },
    {
        "kod": 590100,
        "nazev": "Tištín",
        "popis": "[590100] Tištín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590100,
        "val": "[590100] Tistin 7108 [590100] Tištín"
    },
    {
        "kod": 590118,
        "nazev": "Tvorovice",
        "popis": "[590118] Tvorovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590118,
        "val": "[590118] Tvorovice 7108 [590118] Tvorovice"
    },
    {
        "kod": 590126,
        "nazev": "Určice",
        "popis": "[590126] Určice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590126,
        "val": "[590126] Urcice 7108 [590126] Určice"
    },
    {
        "kod": 590134,
        "nazev": "Víceměřice",
        "popis": "[590134] Víceměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590134,
        "val": "[590134] Vicemerice 7108 [590134] Víceměřice"
    },
    {
        "kod": 590142,
        "nazev": "Vícov",
        "popis": "[590142] Vícov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590142,
        "val": "[590142] Vicov 7108 [590142] Vícov"
    },
    {
        "kod": 544710,
        "nazev": "Vincencov",
        "popis": "[544710] Vincencov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 544710,
        "val": "[544710] Vincencov 7108 [544710] Vincencov"
    },
    {
        "kod": 590151,
        "nazev": "Vitčice",
        "popis": "[590151] Vitčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590151,
        "val": "[590151] Vitcice 7108 [590151] Vitčice"
    },
    {
        "kod": 590177,
        "nazev": "Vranovice-Kelčice",
        "popis": "[590177] Vranovice-Kelčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590177,
        "val": "[590177] Vranovice-Kelcice 7108 [590177] Vranovice-Kelčice"
    },
    {
        "kod": 590185,
        "nazev": "Vrbátky",
        "popis": "[590185] Vrbátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590185,
        "val": "[590185] Vrbatky 7108 [590185] Vrbátky"
    },
    {
        "kod": 590193,
        "nazev": "Vrchoslavice",
        "popis": "[590193] Vrchoslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590193,
        "val": "[590193] Vrchoslavice 7108 [590193] Vrchoslavice"
    },
    {
        "kod": 590207,
        "nazev": "Vřesovice",
        "popis": "[590207] Vřesovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590207,
        "val": "[590207] Vresovice 7108 [590207] Vřesovice"
    },
    {
        "kod": 590215,
        "nazev": "Výšovice",
        "popis": "[590215] Výšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590215,
        "val": "[590215] Vysovice 7108 [590215] Výšovice"
    },
    {
        "kod": 590223,
        "nazev": "Zdětín",
        "popis": "[590223] Zdětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590223,
        "val": "[590223] Zdetin 7108 [590223] Zdětín"
    },
    {
        "kod": 590240,
        "nazev": "Želeč",
        "popis": "[590240] Želeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 590240,
        "val": "[590240] Zelec 7108 [590240] Želeč"
    },
    {
        "kod": 512231,
        "nazev": "Bělotín",
        "popis": "[512231] Bělotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 512231,
        "val": "[512231] Belotin 7101 [512231] Bělotín"
    },
    {
        "kod": 512281,
        "nazev": "Beňov",
        "popis": "[512281] Beňov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512281,
        "val": "[512281] Benov 7109 [512281] Beňov"
    },
    {
        "kod": 512401,
        "nazev": "Bezuchov",
        "popis": "[512401] Bezuchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512401,
        "val": "[512401] Bezuchov 7109 [512401] Bezuchov"
    },
    {
        "kod": 569178,
        "nazev": "Bohuslávky",
        "popis": "[569178] Bohuslávky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 569178,
        "val": "[569178] Bohuslavky 7104 [569178] Bohuslávky"
    },
    {
        "kod": 512532,
        "nazev": "Bochoř",
        "popis": "[512532] Bochoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512532,
        "val": "[512532] Bochor 7109 [512532] Bochoř"
    },
    {
        "kod": 512800,
        "nazev": "Brodek u Přerova",
        "popis": "[512800] Brodek u Přerova",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512800,
        "val": "[512800] Brodek u Prerova 7109 [512800] Brodek u Přerova"
    },
    {
        "kod": 512826,
        "nazev": "Buk",
        "popis": "[512826] Buk",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512826,
        "val": "[512826] Buk 7109 [512826] Buk"
    },
    {
        "kod": 512877,
        "nazev": "Býškovice",
        "popis": "[512877] Býškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 512877,
        "val": "[512877] Byskovice 7101 [512877] Býškovice"
    },
    {
        "kod": 569135,
        "nazev": "Císařov",
        "popis": "[569135] Císařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 569135,
        "val": "[569135] Cisarov 7109 [569135] Císařov"
    },
    {
        "kod": 512982,
        "nazev": "Citov",
        "popis": "[512982] Citov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 512982,
        "val": "[512982] Citov 7109 [512982] Citov"
    },
    {
        "kod": 552771,
        "nazev": "Čechy",
        "popis": "[552771] Čechy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552771,
        "val": "[552771] Cechy 7109 [552771] Čechy"
    },
    {
        "kod": 513059,
        "nazev": "Čelechovice",
        "popis": "[513059] Čelechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513059,
        "val": "[513059] Celechovice 7109 [513059] Čelechovice"
    },
    {
        "kod": 513067,
        "nazev": "Černotín",
        "popis": "[513067] Černotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 513067,
        "val": "[513067] Cernotin 7101 [513067] Černotín"
    },
    {
        "kod": 513105,
        "nazev": "Dobrčice",
        "popis": "[513105] Dobrčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513105,
        "val": "[513105] Dobrcice 7109 [513105] Dobrčice"
    },
    {
        "kod": 569259,
        "nazev": "Dolní Nětčice",
        "popis": "[569259] Dolní Nětčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 569259,
        "val": "[569259] Dolni Netcice 7104 [569259] Dolní Nětčice"
    },
    {
        "kod": 552984,
        "nazev": "Dolní Těšice",
        "popis": "[552984] Dolní Těšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 552984,
        "val": "[552984] Dolni Tesice 7101 [552984] Dolní Těšice"
    },
    {
        "kod": 513199,
        "nazev": "Dolní Újezd",
        "popis": "[513199] Dolní Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 513199,
        "val": "[513199] Dolni Ujezd 7104 [513199] Dolní Újezd"
    },
    {
        "kod": 513211,
        "nazev": "Domaželice",
        "popis": "[513211] Domaželice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513211,
        "val": "[513211] Domazelice 7109 [513211] Domaželice"
    },
    {
        "kod": 513229,
        "nazev": "Dřevohostice",
        "popis": "[513229] Dřevohostice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513229,
        "val": "[513229] Drevohostice 7109 [513229] Dřevohostice"
    },
    {
        "kod": 569194,
        "nazev": "Grymov",
        "popis": "[569194] Grymov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 569194,
        "val": "[569194] Grymov 7109 [569194] Grymov"
    },
    {
        "kod": 569267,
        "nazev": "Hlinsko",
        "popis": "[569267] Hlinsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 569267,
        "val": "[569267] Hlinsko 7104 [569267] Hlinsko"
    },
    {
        "kod": 513491,
        "nazev": "Horní Moštěnice",
        "popis": "[513491] Horní Moštěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513491,
        "val": "[513491] Horni Mostenice 7109 [513491] Horní Moštěnice"
    },
    {
        "kod": 569275,
        "nazev": "Horní Nětčice",
        "popis": "[569275] Horní Nětčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 569275,
        "val": "[569275] Horni Netcice 7104 [569275] Horní Nětčice"
    },
    {
        "kod": 552968,
        "nazev": "Horní Těšice",
        "popis": "[552968] Horní Těšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 552968,
        "val": "[552968] Horni Tesice 7101 [552968] Horní Těšice"
    },
    {
        "kod": 569542,
        "nazev": "Horní Újezd",
        "popis": "[569542] Horní Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 569542,
        "val": "[569542] Horni Ujezd 7101 [569542] Horní Újezd"
    },
    {
        "kod": 513636,
        "nazev": "Hrabůvka",
        "popis": "[513636] Hrabůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 513636,
        "val": "[513636] Hrabuvka 7101 [513636] Hrabůvka"
    },
    {
        "kod": 513733,
        "nazev": "Hradčany",
        "popis": "[513733] Hradčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 513733,
        "val": "[513733] Hradcany 7109 [513733] Hradčany"
    },
    {
        "kod": 513750,
        "nazev": "Hranice",
        "popis": "[513750] Hranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 513750,
        "val": "[513750] Hranice 7101 [513750] Hranice"
    },
    {
        "kod": 513768,
        "nazev": "Hustopeče nad Bečvou",
        "popis": "[513768] Hustopeče nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 513768,
        "val": "[513768] Hustopece nad Becvou 7101 [513768] Hustopeče nad Bečvou"
    },
    {
        "kod": 556998,
        "nazev": "Jezernice",
        "popis": "[556998] Jezernice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 556998,
        "val": "[556998] Jezernice 7104 [556998] Jezernice"
    },
    {
        "kod": 513873,
        "nazev": "Jindřichov",
        "popis": "[513873] Jindřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 513873,
        "val": "[513873] Jindrichov 7101 [513873] Jindřichov"
    },
    {
        "kod": 569283,
        "nazev": "Kladníky",
        "popis": "[569283] Kladníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 569283,
        "val": "[569283] Kladniky 7104 [569283] Kladníky"
    },
    {
        "kod": 514047,
        "nazev": "Klokočí",
        "popis": "[514047] Klokočí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 514047,
        "val": "[514047] Klokoci 7101 [514047] Klokočí"
    },
    {
        "kod": 514055,
        "nazev": "Kojetín",
        "popis": "[514055] Kojetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514055,
        "val": "[514055] Kojetin 7109 [514055] Kojetín"
    },
    {
        "kod": 514152,
        "nazev": "Kokory",
        "popis": "[514152] Kokory",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514152,
        "val": "[514152] Kokory 7109 [514152] Kokory"
    },
    {
        "kod": 569143,
        "nazev": "Křenovice",
        "popis": "[569143] Křenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 569143,
        "val": "[569143] Krenovice 7109 [569143] Křenovice"
    },
    {
        "kod": 552780,
        "nazev": "Křtomil",
        "popis": "[552780] Křtomil",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552780,
        "val": "[552780] Krtomil 7109 [552780] Křtomil"
    },
    {
        "kod": 514446,
        "nazev": "Lazníčky",
        "popis": "[514446] Lazníčky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514446,
        "val": "[514446] Laznicky 7109 [514446] Lazníčky"
    },
    {
        "kod": 514471,
        "nazev": "Lazníky",
        "popis": "[514471] Lazníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514471,
        "val": "[514471] Lazniky 7109 [514471] Lazníky"
    },
    {
        "kod": 514497,
        "nazev": "Lhota",
        "popis": "[514497] Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 514497,
        "val": "[514497] Lhota 7104 [514497] Lhota"
    },
    {
        "kod": 514527,
        "nazev": "Lhotka",
        "popis": "[514527] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514527,
        "val": "[514527] Lhotka 7109 [514527] Lhotka"
    },
    {
        "kod": 514705,
        "nazev": "Lipník nad Bečvou",
        "popis": "[514705] Lipník nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 514705,
        "val": "[514705] Lipnik nad Becvou 7104 [514705] Lipník nad Bečvou"
    },
    {
        "kod": 514772,
        "nazev": "Lipová",
        "popis": "[514772] Lipová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514772,
        "val": "[514772] Lipova 7109 [514772] Lipová"
    },
    {
        "kod": 514802,
        "nazev": "Líšná",
        "popis": "[514802] Líšná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 514802,
        "val": "[514802] Lisna 7109 [514802] Líšná"
    },
    {
        "kod": 515191,
        "nazev": "Lobodice",
        "popis": "[515191] Lobodice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 515191,
        "val": "[515191] Lobodice 7109 [515191] Lobodice"
    },
    {
        "kod": 515329,
        "nazev": "Malhotice",
        "popis": "[515329] Malhotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 515329,
        "val": "[515329] Malhotice 7101 [515329] Malhotice"
    },
    {
        "kod": 552909,
        "nazev": "Měrovice nad Hanou",
        "popis": "[552909] Měrovice nad Hanou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552909,
        "val": "[552909] Merovice nad Hanou 7109 [552909] Měrovice nad Hanou"
    },
    {
        "kod": 515418,
        "nazev": "Milenov",
        "popis": "[515418] Milenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 515418,
        "val": "[515418] Milenov 7101 [515418] Milenov"
    },
    {
        "kod": 515477,
        "nazev": "Milotice nad Bečvou",
        "popis": "[515477] Milotice nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 515477,
        "val": "[515477] Milotice nad Becvou 7101 [515477] Milotice nad Bečvou"
    },
    {
        "kod": 552810,
        "nazev": "Nahošovice",
        "popis": "[552810] Nahošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552810,
        "val": "[552810] Nahosovice 7109 [552810] Nahošovice"
    },
    {
        "kod": 515787,
        "nazev": "Nelešovice",
        "popis": "[515787] Nelešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 515787,
        "val": "[515787] Nelesovice 7109 [515787] Nelešovice"
    },
    {
        "kod": 515825,
        "nazev": "Oldřichov",
        "popis": "[515825] Oldřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 515825,
        "val": "[515825] Oldrichov 7109 [515825] Oldřichov"
    },
    {
        "kod": 552844,
        "nazev": "Olšovec",
        "popis": "[552844] Olšovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 552844,
        "val": "[552844] Olsovec 7101 [552844] Olšovec"
    },
    {
        "kod": 516201,
        "nazev": "Opatovice",
        "popis": "[516201] Opatovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 516201,
        "val": "[516201] Opatovice 7101 [516201] Opatovice"
    },
    {
        "kod": 553000,
        "nazev": "Oplocany",
        "popis": "[553000] Oplocany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 553000,
        "val": "[553000] Oplocany 7109 [553000] Oplocany"
    },
    {
        "kod": 516350,
        "nazev": "Oprostovice",
        "popis": "[516350] Oprostovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 516350,
        "val": "[516350] Oprostovice 7109 [516350] Oprostovice"
    },
    {
        "kod": 516619,
        "nazev": "Osek nad Bečvou",
        "popis": "[516619] Osek nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 516619,
        "val": "[516619] Osek nad Becvou 7104 [516619] Osek nad Bečvou"
    },
    {
        "kod": 516635,
        "nazev": "Paršovice",
        "popis": "[516635] Paršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 516635,
        "val": "[516635] Parsovice 7101 [516635] Paršovice"
    },
    {
        "kod": 516686,
        "nazev": "Partutovice",
        "popis": "[516686] Partutovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 516686,
        "val": "[516686] Partutovice 7101 [516686] Partutovice"
    },
    {
        "kod": 516694,
        "nazev": "Pavlovice u Přerova",
        "popis": "[516694] Pavlovice u Přerova",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 516694,
        "val": "[516694] Pavlovice u Prerova 7109 [516694] Pavlovice u Přerova"
    },
    {
        "kod": 516864,
        "nazev": "Podolí",
        "popis": "[516864] Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 516864,
        "val": "[516864] Podoli 7109 [516864] Podolí"
    },
    {
        "kod": 516899,
        "nazev": "Polkovice",
        "popis": "[516899] Polkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 516899,
        "val": "[516899] Polkovice 7109 [516899] Polkovice"
    },
    {
        "kod": 516911,
        "nazev": "Polom",
        "popis": "[516911] Polom",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 516911,
        "val": "[516911] Polom 7101 [516911] Polom"
    },
    {
        "kod": 517101,
        "nazev": "Potštát",
        "popis": "[517101] Potštát",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517101,
        "val": "[517101] Potstat 7101 [517101] Potštát"
    },
    {
        "kod": 517151,
        "nazev": "Prosenice",
        "popis": "[517151] Prosenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517151,
        "val": "[517151] Prosenice 7109 [517151] Prosenice"
    },
    {
        "kod": 517208,
        "nazev": "Provodovice",
        "popis": "[517208] Provodovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517208,
        "val": "[517208] Provodovice 7101 [517208] Provodovice"
    },
    {
        "kod": 511382,
        "nazev": "Přerov",
        "popis": "[511382] Přerov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 511382,
        "val": "[511382] Prerov 7109 [511382] Přerov"
    },
    {
        "kod": 517224,
        "nazev": "Přestavlky",
        "popis": "[517224] Přestavlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517224,
        "val": "[517224] Prestavlky 7109 [517224] Přestavlky"
    },
    {
        "kod": 517275,
        "nazev": "Radíkov",
        "popis": "[517275] Radíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517275,
        "val": "[517275] Radikov 7101 [517275] Radíkov"
    },
    {
        "kod": 517321,
        "nazev": "Radkova Lhota",
        "popis": "[517321] Radkova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517321,
        "val": "[517321] Radkova Lhota 7109 [517321] Radkova Lhota"
    },
    {
        "kod": 517437,
        "nazev": "Radkovy",
        "popis": "[517437] Radkovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517437,
        "val": "[517437] Radkovy 7109 [517437] Radkovy"
    },
    {
        "kod": 517445,
        "nazev": "Radotín",
        "popis": "[517445] Radotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 517445,
        "val": "[517445] Radotin 7104 [517445] Radotín"
    },
    {
        "kod": 517534,
        "nazev": "Radslavice",
        "popis": "[517534] Radslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517534,
        "val": "[517534] Radslavice 7109 [517534] Radslavice"
    },
    {
        "kod": 517569,
        "nazev": "Radvanice",
        "popis": "[517569] Radvanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517569,
        "val": "[517569] Radvanice 7109 [517569] Radvanice"
    },
    {
        "kod": 517585,
        "nazev": "Rakov",
        "popis": "[517585] Rakov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517585,
        "val": "[517585] Rakov 7101 [517585] Rakov"
    },
    {
        "kod": 517607,
        "nazev": "Rokytnice",
        "popis": "[517607] Rokytnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517607,
        "val": "[517607] Rokytnice 7109 [517607] Rokytnice"
    },
    {
        "kod": 517615,
        "nazev": "Rouské",
        "popis": "[517615] Rouské",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517615,
        "val": "[517615] Rouske 7101 [517615] Rouské"
    },
    {
        "kod": 517666,
        "nazev": "Říkovice",
        "popis": "[517666] Říkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517666,
        "val": "[517666] Rikovice 7109 [517666] Říkovice"
    },
    {
        "kod": 517747,
        "nazev": "Skalička",
        "popis": "[517747] Skalička",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517747,
        "val": "[517747] Skalicka 7101 [517747] Skalička"
    },
    {
        "kod": 517844,
        "nazev": "Soběchleby",
        "popis": "[517844] Soběchleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 517844,
        "val": "[517844] Sobechleby 7104 [517844] Soběchleby"
    },
    {
        "kod": 517836,
        "nazev": "Sobíšky",
        "popis": "[517836] Sobíšky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517836,
        "val": "[517836] Sobisky 7109 [517836] Sobíšky"
    },
    {
        "kod": 517887,
        "nazev": "Stará Ves",
        "popis": "[517887] Stará Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 517887,
        "val": "[517887] Stara Ves 7109 [517887] Stará Ves"
    },
    {
        "kod": 552887,
        "nazev": "Stříbrnice",
        "popis": "[552887] Stříbrnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552887,
        "val": "[552887] Stribrnice 7109 [552887] Stříbrnice"
    },
    {
        "kod": 517909,
        "nazev": "Střítež nad Ludinou",
        "popis": "[517909] Střítež nad Ludinou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 517909,
        "val": "[517909] Stritez nad Ludinou 7101 [517909] Střítež nad Ludinou"
    },
    {
        "kod": 518026,
        "nazev": "Sušice",
        "popis": "[518026] Sušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 518026,
        "val": "[518026] Susice 7109 [518026] Sušice"
    },
    {
        "kod": 552950,
        "nazev": "Šišma",
        "popis": "[552950] Šišma",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552950,
        "val": "[552950] Sisma 7109 [552950] Šišma"
    },
    {
        "kod": 570061,
        "nazev": "Špičky",
        "popis": "[570061] Špičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 570061,
        "val": "[570061] Spicky 7101 [570061] Špičky"
    },
    {
        "kod": 519031,
        "nazev": "Teplice nad Bečvou",
        "popis": "[519031] Teplice nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 519031,
        "val": "[519031] Teplice nad Becvou 7101 [519031] Teplice nad Bečvou"
    },
    {
        "kod": 519146,
        "nazev": "Tovačov",
        "popis": "[519146] Tovačov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 519146,
        "val": "[519146] Tovacov 7109 [519146] Tovačov"
    },
    {
        "kod": 519651,
        "nazev": "Troubky",
        "popis": "[519651] Troubky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 519651,
        "val": "[519651] Troubky 7109 [519651] Troubky"
    },
    {
        "kod": 520047,
        "nazev": "Tučín",
        "popis": "[520047] Tučín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 520047,
        "val": "[520047] Tucin 7109 [520047] Tučín"
    },
    {
        "kod": 584894,
        "nazev": "Starovice",
        "popis": "[584894] Starovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584894,
        "val": "[584894] Starovice 6207 [584894] Starovice"
    },
    {
        "kod": 584908,
        "nazev": "Starovičky",
        "popis": "[584908] Starovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584908,
        "val": "[584908] Starovicky 6207 [584908] Starovičky"
    },
    {
        "kod": 584916,
        "nazev": "Strachotín",
        "popis": "[584916] Strachotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584916,
        "val": "[584916] Strachotin 6207 [584916] Strachotín"
    },
    {
        "kod": 584924,
        "nazev": "Šakvice",
        "popis": "[584924] Šakvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584924,
        "val": "[584924] Sakvice 6207 [584924] Šakvice"
    },
    {
        "kod": 584932,
        "nazev": "Šitbořice",
        "popis": "[584932] Šitbořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584932,
        "val": "[584932] Sitborice 6207 [584932] Šitbořice"
    },
    {
        "kod": 584941,
        "nazev": "Tvrdonice",
        "popis": "[584941] Tvrdonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584941,
        "val": "[584941] Tvrdonice 6204 [584941] Tvrdonice"
    },
    {
        "kod": 584959,
        "nazev": "Týnec",
        "popis": "[584959] Týnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584959,
        "val": "[584959] Tynec 6204 [584959] Týnec"
    },
    {
        "kod": 584967,
        "nazev": "Uherčice",
        "popis": "[584967] Uherčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584967,
        "val": "[584967] Uhercice 6207 [584967] Uherčice"
    },
    {
        "kod": 584975,
        "nazev": "Valtice",
        "popis": "[584975] Valtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584975,
        "val": "[584975] Valtice 6204 [584975] Valtice"
    },
    {
        "kod": 584983,
        "nazev": "Velké Bílovice",
        "popis": "[584983] Velké Bílovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 584983,
        "val": "[584983] Velke Bilovice 6204 [584983] Velké Bílovice"
    },
    {
        "kod": 584991,
        "nazev": "Velké Hostěrádky",
        "popis": "[584991] Velké Hostěrádky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 584991,
        "val": "[584991] Velke Hosteradky 6207 [584991] Velké Hostěrádky"
    },
    {
        "kod": 585009,
        "nazev": "Velké Němčice",
        "popis": "[585009] Velké Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 585009,
        "val": "[585009] Velke Nemcice 6207 [585009] Velké Němčice"
    },
    {
        "kod": 585017,
        "nazev": "Velké Pavlovice",
        "popis": "[585017] Velké Pavlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 585017,
        "val": "[585017] Velke Pavlovice 6207 [585017] Velké Pavlovice"
    },
    {
        "kod": 585041,
        "nazev": "Vrbice",
        "popis": "[585041] Vrbice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6207,
        "iczuj": 585041,
        "val": "[585041] Vrbice 6207 [585041] Vrbice"
    },
    {
        "kod": 585050,
        "nazev": "Zaječí",
        "popis": "[585050] Zaječí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6204,
        "iczuj": 585050,
        "val": "[585050] Zajeci 6204 [585050] Zaječí"
    },
    {
        "kod": 586030,
        "nazev": "Archlebov",
        "popis": "[586030] Archlebov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586030,
        "val": "[586030] Archlebov 6210 [586030] Archlebov"
    },
    {
        "kod": 586048,
        "nazev": "Blatnice pod Svatým Antonínkem",
        "popis": "[586048] Blatnice pod Svatým Antonínkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586048,
        "val": "[586048] Blatnice pod Svatym Antoninkem 6218 [586048] Blatnice pod Svatým Antonínkem"
    },
    {
        "kod": 586056,
        "nazev": "Blatnička",
        "popis": "[586056] Blatnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586056,
        "val": "[586056] Blatnicka 6218 [586056] Blatnička"
    },
    {
        "kod": 586072,
        "nazev": "Bukovany",
        "popis": "[586072] Bukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586072,
        "val": "[586072] Bukovany 6210 [586072] Bukovany"
    },
    {
        "kod": 586081,
        "nazev": "Bzenec",
        "popis": "[586081] Bzenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586081,
        "val": "[586081] Bzenec 6210 [586081] Bzenec"
    },
    {
        "kod": 586099,
        "nazev": "Čejč",
        "popis": "[586099] Čejč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586099,
        "val": "[586099] Cejc 6206 [586099] Čejč"
    },
    {
        "kod": 586102,
        "nazev": "Čejkovice",
        "popis": "[586102] Čejkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586102,
        "val": "[586102] Cejkovice 6206 [586102] Čejkovice"
    },
    {
        "kod": 586111,
        "nazev": "Čeložnice",
        "popis": "[586111] Čeložnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586111,
        "val": "[586111] Celoznice 6210 [586111] Čeložnice"
    },
    {
        "kod": 586129,
        "nazev": "Dambořice",
        "popis": "[586129] Dambořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586129,
        "val": "[586129] Damborice 6210 [586129] Dambořice"
    },
    {
        "kod": 586137,
        "nazev": "Dolní Bojanovice",
        "popis": "[586137] Dolní Bojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586137,
        "val": "[586137] Dolni Bojanovice 6206 [586137] Dolní Bojanovice"
    },
    {
        "kod": 586145,
        "nazev": "Domanín",
        "popis": "[586145] Domanín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586145,
        "val": "[586145] Domanin 6210 [586145] Domanín"
    },
    {
        "kod": 586153,
        "nazev": "Dražůvky",
        "popis": "[586153] Dražůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586153,
        "val": "[586153] Drazuvky 6210 [586153] Dražůvky"
    },
    {
        "kod": 586161,
        "nazev": "Dubňany",
        "popis": "[586161] Dubňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586161,
        "val": "[586161] Dubnany 6206 [586161] Dubňany"
    },
    {
        "kod": 586021,
        "nazev": "Hodonín",
        "popis": "[586021] Hodonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586021,
        "val": "[586021] Hodonin 6206 [586021] Hodonín"
    },
    {
        "kod": 586170,
        "nazev": "Hovorany",
        "popis": "[586170] Hovorany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586170,
        "val": "[586170] Hovorany 6210 [586170] Hovorany"
    },
    {
        "kod": 586188,
        "nazev": "Hroznová Lhota",
        "popis": "[586188] Hroznová Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586188,
        "val": "[586188] Hroznova Lhota 6218 [586188] Hroznová Lhota"
    },
    {
        "kod": 586196,
        "nazev": "Hrubá Vrbka",
        "popis": "[586196] Hrubá Vrbka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586196,
        "val": "[586196] Hruba Vrbka 6218 [586196] Hrubá Vrbka"
    },
    {
        "kod": 586200,
        "nazev": "Hýsly",
        "popis": "[586200] Hýsly",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586200,
        "val": "[586200] Hysly 6210 [586200] Hýsly"
    },
    {
        "kod": 586218,
        "nazev": "Javorník",
        "popis": "[586218] Javorník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586218,
        "val": "[586218] Javornik 6218 [586218] Javorník"
    },
    {
        "kod": 586226,
        "nazev": "Ježov",
        "popis": "[586226] Ježov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586226,
        "val": "[586226] Jezov 6210 [586226] Ježov"
    },
    {
        "kod": 586234,
        "nazev": "Josefov",
        "popis": "[586234] Josefov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586234,
        "val": "[586234] Josefov 6206 [586234] Josefov"
    },
    {
        "kod": 586242,
        "nazev": "Karlín",
        "popis": "[586242] Karlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586242,
        "val": "[586242] Karlin 6206 [586242] Karlín"
    },
    {
        "kod": 586251,
        "nazev": "Kelčany",
        "popis": "[586251] Kelčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586251,
        "val": "[586251] Kelcany 6210 [586251] Kelčany"
    },
    {
        "kod": 586269,
        "nazev": "Kněždub",
        "popis": "[586269] Kněždub",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586269,
        "val": "[586269] Knezdub 6218 [586269] Kněždub"
    },
    {
        "kod": 586277,
        "nazev": "Kostelec",
        "popis": "[586277] Kostelec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586277,
        "val": "[586277] Kostelec 6210 [586277] Kostelec"
    },
    {
        "kod": 586285,
        "nazev": "Kozojídky",
        "popis": "[586285] Kozojídky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586285,
        "val": "[586285] Kozojidky 6218 [586285] Kozojídky"
    },
    {
        "kod": 586293,
        "nazev": "Kuželov",
        "popis": "[586293] Kuželov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586293,
        "val": "[586293] Kuzelov 6218 [586293] Kuželov"
    },
    {
        "kod": 586307,
        "nazev": "Kyjov",
        "popis": "[586307] Kyjov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586307,
        "val": "[586307] Kyjov 6210 [586307] Kyjov"
    },
    {
        "kod": 586315,
        "nazev": "Labuty",
        "popis": "[586315] Labuty",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586315,
        "val": "[586315] Labuty 6210 [586315] Labuty"
    },
    {
        "kod": 586323,
        "nazev": "Lipov",
        "popis": "[586323] Lipov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586323,
        "val": "[586323] Lipov 6218 [586323] Lipov"
    },
    {
        "kod": 586331,
        "nazev": "Louka",
        "popis": "[586331] Louka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586331,
        "val": "[586331] Louka 6218 [586331] Louka"
    },
    {
        "kod": 586340,
        "nazev": "Lovčice",
        "popis": "[586340] Lovčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586340,
        "val": "[586340] Lovcice 6210 [586340] Lovčice"
    },
    {
        "kod": 586358,
        "nazev": "Lužice",
        "popis": "[586358] Lužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586358,
        "val": "[586358] Luzice 6206 [586358] Lužice"
    },
    {
        "kod": 586366,
        "nazev": "Malá Vrbka",
        "popis": "[586366] Malá Vrbka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586366,
        "val": "[586366] Mala Vrbka 6218 [586366] Malá Vrbka"
    },
    {
        "kod": 586374,
        "nazev": "Mikulčice",
        "popis": "[586374] Mikulčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586374,
        "val": "[586374] Mikulcice 6206 [586374] Mikulčice"
    },
    {
        "kod": 586382,
        "nazev": "Milotice",
        "popis": "[586382] Milotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586382,
        "val": "[586382] Milotice 6210 [586382] Milotice"
    },
    {
        "kod": 586391,
        "nazev": "Moravany",
        "popis": "[586391] Moravany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586391,
        "val": "[586391] Moravany 6210 [586391] Moravany"
    },
    {
        "kod": 586404,
        "nazev": "Moravský Písek",
        "popis": "[586404] Moravský Písek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586404,
        "val": "[586404] Moravsky Pisek 6218 [586404] Moravský Písek"
    },
    {
        "kod": 593354,
        "nazev": "Mouchnice",
        "popis": "[593354] Mouchnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 593354,
        "val": "[593354] Mouchnice 6210 [593354] Mouchnice"
    },
    {
        "kod": 586412,
        "nazev": "Mutěnice",
        "popis": "[586412] Mutěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586412,
        "val": "[586412] Mutenice 6206 [586412] Mutěnice"
    },
    {
        "kod": 586421,
        "nazev": "Násedlovice",
        "popis": "[586421] Násedlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586421,
        "val": "[586421] Nasedlovice 6210 [586421] Násedlovice"
    },
    {
        "kod": 586439,
        "nazev": "Nechvalín",
        "popis": "[586439] Nechvalín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586439,
        "val": "[586439] Nechvalin 6210 [586439] Nechvalín"
    },
    {
        "kod": 586447,
        "nazev": "Nenkovice",
        "popis": "[586447] Nenkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586447,
        "val": "[586447] Nenkovice 6210 [586447] Nenkovice"
    },
    {
        "kod": 586455,
        "nazev": "Nová Lhota",
        "popis": "[586455] Nová Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586455,
        "val": "[586455] Nova Lhota 6218 [586455] Nová Lhota"
    },
    {
        "kod": 586463,
        "nazev": "Nový Poddvorov",
        "popis": "[586463] Nový Poddvorov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586463,
        "val": "[586463] Novy Poddvorov 6206 [586463] Nový Poddvorov"
    },
    {
        "kod": 586471,
        "nazev": "Ostrovánky",
        "popis": "[586471] Ostrovánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586471,
        "val": "[586471] Ostrovanky 6210 [586471] Ostrovánky"
    },
    {
        "kod": 586480,
        "nazev": "Petrov",
        "popis": "[586480] Petrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586480,
        "val": "[586480] Petrov 6206 [586480] Petrov"
    },
    {
        "kod": 586498,
        "nazev": "Prušánky",
        "popis": "[586498] Prušánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586498,
        "val": "[586498] Prusanky 6206 [586498] Prušánky"
    },
    {
        "kod": 586501,
        "nazev": "Radějov",
        "popis": "[586501] Radějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586501,
        "val": "[586501] Radejov 6218 [586501] Radějov"
    },
    {
        "kod": 586510,
        "nazev": "Ratíškovice",
        "popis": "[586510] Ratíškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586510,
        "val": "[586510] Ratiskovice 6206 [586510] Ratíškovice"
    },
    {
        "kod": 586528,
        "nazev": "Rohatec",
        "popis": "[586528] Rohatec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586528,
        "val": "[586528] Rohatec 6206 [586528] Rohatec"
    },
    {
        "kod": 586536,
        "nazev": "Skalka",
        "popis": "[586536] Skalka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586536,
        "val": "[586536] Skalka 6210 [586536] Skalka"
    },
    {
        "kod": 586544,
        "nazev": "Skoronice",
        "popis": "[586544] Skoronice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586544,
        "val": "[586544] Skoronice 6210 [586544] Skoronice"
    },
    {
        "kod": 586552,
        "nazev": "Sobůlky",
        "popis": "[586552] Sobůlky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586552,
        "val": "[586552] Sobulky 6210 [586552] Sobůlky"
    },
    {
        "kod": 586561,
        "nazev": "Starý Poddvorov",
        "popis": "[586561] Starý Poddvorov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586561,
        "val": "[586561] Stary Poddvorov 6206 [586561] Starý Poddvorov"
    },
    {
        "kod": 586579,
        "nazev": "Stavěšice",
        "popis": "[586579] Stavěšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586579,
        "val": "[586579] Stavesice 6210 [586579] Stavěšice"
    },
    {
        "kod": 586587,
        "nazev": "Strážnice",
        "popis": "[586587] Strážnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586587,
        "val": "[586587] Straznice 6218 [586587] Strážnice"
    },
    {
        "kod": 586595,
        "nazev": "Strážovice",
        "popis": "[586595] Strážovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586595,
        "val": "[586595] Strazovice 6210 [586595] Strážovice"
    },
    {
        "kod": 586609,
        "nazev": "Sudoměřice",
        "popis": "[586609] Sudoměřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586609,
        "val": "[586609] Sudomerice 6206 [586609] Sudoměřice"
    },
    {
        "kod": 586617,
        "nazev": "Suchov",
        "popis": "[586617] Suchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586617,
        "val": "[586617] Suchov 6218 [586617] Suchov"
    },
    {
        "kod": 586625,
        "nazev": "Svatobořice-Mistřín",
        "popis": "[586625] Svatobořice-Mistřín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586625,
        "val": "[586625] Svatoborice-Mistrin 6210 [586625] Svatobořice-Mistřín"
    },
    {
        "kod": 586633,
        "nazev": "Syrovín",
        "popis": "[586633] Syrovín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586633,
        "val": "[586633] Syrovin 6210 [586633] Syrovín"
    },
    {
        "kod": 586641,
        "nazev": "Šardice",
        "popis": "[586641] Šardice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586641,
        "val": "[586641] Sardice 6210 [586641] Šardice"
    },
    {
        "kod": 586650,
        "nazev": "Tasov",
        "popis": "[586650] Tasov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586650,
        "val": "[586650] Tasov 6218 [586650] Tasov"
    },
    {
        "kod": 586668,
        "nazev": "Těmice",
        "popis": "[586668] Těmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586668,
        "val": "[586668] Temice 6210 [586668] Těmice"
    },
    {
        "kod": 586676,
        "nazev": "Terezín",
        "popis": "[586676] Terezín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6206,
        "iczuj": 586676,
        "val": "[586676] Terezin 6206 [586676] Terezín"
    },
    {
        "kod": 586684,
        "nazev": "Tvarožná Lhota",
        "popis": "[586684] Tvarožná Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586684,
        "val": "[586684] Tvarozna Lhota 6218 [586684] Tvarožná Lhota"
    },
    {
        "kod": 586692,
        "nazev": "Uhřice",
        "popis": "[586692] Uhřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586692,
        "val": "[586692] Uhrice 6210 [586692] Uhřice"
    },
    {
        "kod": 586706,
        "nazev": "Vacenovice",
        "popis": "[586706] Vacenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586706,
        "val": "[586706] Vacenovice 6210 [586706] Vacenovice"
    },
    {
        "kod": 586714,
        "nazev": "Velká nad Veličkou",
        "popis": "[586714] Velká nad Veličkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586714,
        "val": "[586714] Velka nad Velickou 6218 [586714] Velká nad Veličkou"
    },
    {
        "kod": 586722,
        "nazev": "Veselí nad Moravou",
        "popis": "[586722] Veselí nad Moravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586722,
        "val": "[586722] Veseli nad Moravou 6218 [586722] Veselí nad Moravou"
    },
    {
        "kod": 586731,
        "nazev": "Věteřov",
        "popis": "[586731] Věteřov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586731,
        "val": "[586731] Veterov 6210 [586731] Věteřov"
    },
    {
        "kod": 586749,
        "nazev": "Vlkoš",
        "popis": "[586749] Vlkoš",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586749,
        "val": "[586749] Vlkos 6210 [586749] Vlkoš"
    },
    {
        "kod": 586757,
        "nazev": "Vnorovy",
        "popis": "[586757] Vnorovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586757,
        "val": "[586757] Vnorovy 6218 [586757] Vnorovy"
    },
    {
        "kod": 586765,
        "nazev": "Vracov",
        "popis": "[586765] Vracov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586765,
        "val": "[586765] Vracov 6210 [586765] Vracov"
    },
    {
        "kod": 586773,
        "nazev": "Vřesovice",
        "popis": "[586773] Vřesovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586773,
        "val": "[586773] Vresovice 6210 [586773] Vřesovice"
    },
    {
        "kod": 586781,
        "nazev": "Žádovice",
        "popis": "[586781] Žádovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586781,
        "val": "[586781] Zadovice 6210 [586781] Žádovice"
    },
    {
        "kod": 586790,
        "nazev": "Žarošice",
        "popis": "[586790] Žarošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586790,
        "val": "[586790] Zarosice 6210 [586790] Žarošice"
    },
    {
        "kod": 586803,
        "nazev": "Ždánice",
        "popis": "[586803] Ždánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586803,
        "val": "[586803] Zdanice 6210 [586803] Ždánice"
    },
    {
        "kod": 586811,
        "nazev": "Želetice",
        "popis": "[586811] Želetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586811,
        "val": "[586811] Zeletice 6210 [586811] Želetice"
    },
    {
        "kod": 586820,
        "nazev": "Žeravice",
        "popis": "[586820] Žeravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6210,
        "iczuj": 586820,
        "val": "[586820] Zeravice 6210 [586820] Žeravice"
    },
    {
        "kod": 586838,
        "nazev": "Žeraviny",
        "popis": "[586838] Žeraviny",
        "datum_od": "",
        "datum_do": "",
        "orp": 6218,
        "iczuj": 586838,
        "val": "[586838] Zeraviny 6218 [586838] Žeraviny"
    },
    {
        "kod": 592897,
        "nazev": "Bohaté Málkovice",
        "popis": "[592897] Bohaté Málkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 592897,
        "val": "[592897] Bohate Malkovice 6205 [592897] Bohaté Málkovice"
    },
    {
        "kod": 592901,
        "nazev": "Bohdalice-Pavlovice",
        "popis": "[592901] Bohdalice-Pavlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 592901,
        "val": "[592901] Bohdalice-Pavlovice 6219 [592901] Bohdalice-Pavlovice"
    },
    {
        "kod": 592919,
        "nazev": "Bošovice",
        "popis": "[592919] Bošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 592919,
        "val": "[592919] Bosovice 6215 [592919] Bošovice"
    },
    {
        "kod": 592927,
        "nazev": "Brankovice",
        "popis": "[592927] Brankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 592927,
        "val": "[592927] Brankovice 6205 [592927] Brankovice"
    },
    {
        "kod": 592935,
        "nazev": "Březina",
        "popis": "[592935] Březina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 592935,
        "val": "[592935] Brezina 6219 [592935] Březina"
    },
    {
        "kod": 592943,
        "nazev": "Bučovice",
        "popis": "[592943] Bučovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 592943,
        "val": "[592943] Bucovice 6205 [592943] Bučovice"
    },
    {
        "kod": 592978,
        "nazev": "Dětkovice",
        "popis": "[592978] Dětkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 592978,
        "val": "[592978] Detkovice 6219 [592978] Dětkovice"
    },
    {
        "kod": 592986,
        "nazev": "Dobročkovice",
        "popis": "[592986] Dobročkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 592986,
        "val": "[592986] Dobrockovice 6205 [592986] Dobročkovice"
    },
    {
        "kod": 592994,
        "nazev": "Dražovice",
        "popis": "[592994] Dražovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 592994,
        "val": "[592994] Drazovice 6205 [592994] Dražovice"
    },
    {
        "kod": 593001,
        "nazev": "Drnovice",
        "popis": "[593001] Drnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593001,
        "val": "[593001] Drnovice 6219 [593001] Drnovice"
    },
    {
        "kod": 593010,
        "nazev": "Drysice",
        "popis": "[593010] Drysice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593010,
        "val": "[593010] Drysice 6219 [593010] Drysice"
    },
    {
        "kod": 593028,
        "nazev": "Habrovany",
        "popis": "[593028] Habrovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593028,
        "val": "[593028] Habrovany 6219 [593028] Habrovany"
    },
    {
        "kod": 550213,
        "nazev": "Heršpice",
        "popis": "[550213] Heršpice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 550213,
        "val": "[550213] Herspice 6215 [550213] Heršpice"
    },
    {
        "kod": 593036,
        "nazev": "Hlubočany",
        "popis": "[593036] Hlubočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593036,
        "val": "[593036] Hlubocany 6219 [593036] Hlubočany"
    },
    {
        "kod": 593044,
        "nazev": "Hodějice",
        "popis": "[593044] Hodějice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593044,
        "val": "[593044] Hodejice 6215 [593044] Hodějice"
    },
    {
        "kod": 550825,
        "nazev": "Holubice",
        "popis": "[550825] Holubice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 550825,
        "val": "[550825] Holubice 6215 [550825] Holubice"
    },
    {
        "kod": 593052,
        "nazev": "Hostěrádky-Rešov",
        "popis": "[593052] Hostěrádky-Rešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593052,
        "val": "[593052] Hosteradky-Resov 6215 [593052] Hostěrádky-Rešov"
    },
    {
        "kod": 593061,
        "nazev": "Hoštice-Heroltice",
        "popis": "[593061] Hoštice-Heroltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593061,
        "val": "[593061] Hostice-Heroltice 6219 [593061] Hoštice-Heroltice"
    },
    {
        "kod": 593079,
        "nazev": "Hrušky",
        "popis": "[593079] Hrušky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593079,
        "val": "[593079] Hrusky 6215 [593079] Hrušky"
    },
    {
        "kod": 593087,
        "nazev": "Hvězdlice",
        "popis": "[593087] Hvězdlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593087,
        "val": "[593087] Hvezdlice 6219 [593087] Hvězdlice"
    },
    {
        "kod": 593095,
        "nazev": "Chvalkovice",
        "popis": "[593095] Chvalkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593095,
        "val": "[593095] Chvalkovice 6205 [593095] Chvalkovice"
    },
    {
        "kod": 593117,
        "nazev": "Ivanovice na Hané",
        "popis": "[593117] Ivanovice na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593117,
        "val": "[593117] Ivanovice na Hane 6219 [593117] Ivanovice na Hané"
    },
    {
        "kod": 593125,
        "nazev": "Ježkovice",
        "popis": "[593125] Ježkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593125,
        "val": "[593125] Jezkovice 6219 [593125] Ježkovice"
    },
    {
        "kod": 593141,
        "nazev": "Kobeřice u Brna",
        "popis": "[593141] Kobeřice u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593141,
        "val": "[593141] Koberice u Brna 6215 [593141] Kobeřice u Brna"
    },
    {
        "kod": 593150,
        "nazev": "Kojátky",
        "popis": "[593150] Kojátky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593150,
        "val": "[593150] Kojatky 6205 [593150] Kojátky"
    },
    {
        "kod": 593168,
        "nazev": "Komořany",
        "popis": "[593168] Komořany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593168,
        "val": "[593168] Komorany 6219 [593168] Komořany"
    },
    {
        "kod": 550108,
        "nazev": "Kozlany",
        "popis": "[550108] Kozlany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 550108,
        "val": "[550108] Kozlany 6219 [550108] Kozlany"
    },
    {
        "kod": 593184,
        "nazev": "Kožušice",
        "popis": "[593184] Kožušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593184,
        "val": "[593184] Kozusice 6205 [593184] Kožušice"
    },
    {
        "kod": 593192,
        "nazev": "Krásensko",
        "popis": "[593192] Krásensko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593192,
        "val": "[593192] Krasensko 6219 [593192] Krásensko"
    },
    {
        "kod": 593214,
        "nazev": "Křenovice",
        "popis": "[593214] Křenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593214,
        "val": "[593214] Krenovice 6215 [593214] Křenovice"
    },
    {
        "kod": 587753,
        "nazev": "Tři Studně",
        "popis": "[587753] Tři Studně",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 587753,
        "val": "[587753] Tri Studne 6108 [587753] Tři Studně"
    },
    {
        "kod": 549959,
        "nazev": "Ubušínek",
        "popis": "[549959] Ubušínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 549959,
        "val": "[549959] Ubusinek 6101 [549959] Ubušínek"
    },
    {
        "kod": 596906,
        "nazev": "Uhřínov",
        "popis": "[596906] Uhřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596906,
        "val": "[596906] Uhrinov 6114 [596906] Uhřínov"
    },
    {
        "kod": 596914,
        "nazev": "Ujčov",
        "popis": "[596914] Ujčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596914,
        "val": "[596914] Ujcov 6101 [596914] Ujčov"
    },
    {
        "kod": 596922,
        "nazev": "Újezd",
        "popis": "[596922] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596922,
        "val": "[596922] Ujezd 6115 [596922] Újezd"
    },
    {
        "kod": 596931,
        "nazev": "Unčín",
        "popis": "[596931] Unčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596931,
        "val": "[596931] Uncin 6101 [596931] Unčín"
    },
    {
        "kod": 596949,
        "nazev": "Vatín",
        "popis": "[596949] Vatín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596949,
        "val": "[596949] Vatin 6115 [596949] Vatín"
    },
    {
        "kod": 596957,
        "nazev": "Věcov",
        "popis": "[596957] Věcov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 596957,
        "val": "[596957] Vecov 6108 [596957] Věcov"
    },
    {
        "kod": 596965,
        "nazev": "Věchnov",
        "popis": "[596965] Věchnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596965,
        "val": "[596965] Vechnov 6101 [596965] Věchnov"
    },
    {
        "kod": 596973,
        "nazev": "Velká Bíteš",
        "popis": "[596973] Velká Bíteš",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 596973,
        "val": "[596973] Velka Bites 6114 [596973] Velká Bíteš"
    },
    {
        "kod": 596981,
        "nazev": "Velká Losenice",
        "popis": "[596981] Velká Losenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 596981,
        "val": "[596981] Velka Losenice 6115 [596981] Velká Losenice"
    },
    {
        "kod": 596990,
        "nazev": "Velké Janovice",
        "popis": "[596990] Velké Janovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 596990,
        "val": "[596990] Velke Janovice 6101 [596990] Velké Janovice"
    },
    {
        "kod": 597007,
        "nazev": "Velké Meziříčí",
        "popis": "[597007] Velké Meziříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597007,
        "val": "[597007] Velke Mezirici 6114 [597007] Velké Meziříčí"
    },
    {
        "kod": 587893,
        "nazev": "Velké Tresné",
        "popis": "[587893] Velké Tresné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 587893,
        "val": "[587893] Velke Tresne 6101 [587893] Velké Tresné"
    },
    {
        "kod": 597015,
        "nazev": "Vepřová",
        "popis": "[597015] Vepřová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 597015,
        "val": "[597015] Veprova 6115 [597015] Vepřová"
    },
    {
        "kod": 597031,
        "nazev": "Věstín",
        "popis": "[597031] Věstín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 597031,
        "val": "[597031] Vestin 6101 [597031] Věstín"
    },
    {
        "kod": 597040,
        "nazev": "Věžná",
        "popis": "[597040] Věžná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 597040,
        "val": "[597040] Vezna 6101 [597040] Věžná"
    },
    {
        "kod": 597058,
        "nazev": "Vídeň",
        "popis": "[597058] Vídeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597058,
        "val": "[597058] Viden 6114 [597058] Vídeň"
    },
    {
        "kod": 597066,
        "nazev": "Vidonín",
        "popis": "[597066] Vidonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597066,
        "val": "[597066] Vidonin 6114 [597066] Vidonín"
    },
    {
        "kod": 597074,
        "nazev": "Vír",
        "popis": "[597074] Vír",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 597074,
        "val": "[597074] Vir 6101 [597074] Vír"
    },
    {
        "kod": 587869,
        "nazev": "Vlachovice",
        "popis": "[587869] Vlachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 587869,
        "val": "[587869] Vlachovice 6108 [587869] Vlachovice"
    },
    {
        "kod": 597082,
        "nazev": "Vlkov",
        "popis": "[597082] Vlkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597082,
        "val": "[597082] Vlkov 6114 [597082] Vlkov"
    },
    {
        "kod": 597091,
        "nazev": "Vojnův Městec",
        "popis": "[597091] Vojnův Městec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 597091,
        "val": "[597091] Vojnuv Mestec 6115 [597091] Vojnův Městec"
    },
    {
        "kod": 588334,
        "nazev": "Vysoké",
        "popis": "[588334] Vysoké",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 588334,
        "val": "[588334] Vysoke 6115 [588334] Vysoké"
    },
    {
        "kod": 597112,
        "nazev": "Záblatí",
        "popis": "[597112] Záblatí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597112,
        "val": "[597112] Zablati 6114 [597112] Záblatí"
    },
    {
        "kod": 597121,
        "nazev": "Zadní Zhořec",
        "popis": "[597121] Zadní Zhořec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 597121,
        "val": "[597121] Zadni Zhorec 6114 [597121] Zadní Zhořec"
    },
    {
        "kod": 597139,
        "nazev": "Znětínek",
        "popis": "[597139] Znětínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 597139,
        "val": "[597139] Znetinek 6115 [597139] Znětínek"
    },
    {
        "kod": 597147,
        "nazev": "Zubří",
        "popis": "[597147] Zubří",
        "datum_od": "",
        "datum_do": "",
        "orp": 6108,
        "iczuj": 597147,
        "val": "[597147] Zubri 6108 [597147] Zubří"
    },
    {
        "kod": 597155,
        "nazev": "Zvole",
        "popis": "[597155] Zvole",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 597155,
        "val": "[597155] Zvole 6101 [597155] Zvole"
    },
    {
        "kod": 597163,
        "nazev": "Ždánice",
        "popis": "[597163] Ždánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6101,
        "iczuj": 597163,
        "val": "[597163] Zdanice 6101 [597163] Ždánice"
    },
    {
        "kod": 595209,
        "nazev": "Žďár nad Sázavou",
        "popis": "[595209] Žďár nad Sázavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6115,
        "iczuj": 595209,
        "val": "[595209] Zdar nad Sazavou 6115 [595209] Žďár nad Sázavou"
    },
    {
        "kod": 581291,
        "nazev": "Adamov",
        "popis": "[581291] Adamov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581291,
        "val": "[581291] Adamov 6201 [581291] Adamov"
    },
    {
        "kod": 581313,
        "nazev": "Bedřichov",
        "popis": "[581313] Bedřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581313,
        "val": "[581313] Bedrichov 6202 [581313] Bedřichov"
    },
    {
        "kod": 581330,
        "nazev": "Benešov",
        "popis": "[581330] Benešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581330,
        "val": "[581330] Benesov 6202 [581330] Benešov"
    },
    {
        "kod": 581283,
        "nazev": "Blansko",
        "popis": "[581283] Blansko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581283,
        "val": "[581283] Blansko 6201 [581283] Blansko"
    },
    {
        "kod": 581356,
        "nazev": "Borotín",
        "popis": "[581356] Borotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581356,
        "val": "[581356] Borotin 6202 [581356] Borotín"
    },
    {
        "kod": 581364,
        "nazev": "Bořitov",
        "popis": "[581364] Bořitov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581364,
        "val": "[581364] Boritov 6201 [581364] Bořitov"
    },
    {
        "kod": 581372,
        "nazev": "Boskovice",
        "popis": "[581372] Boskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581372,
        "val": "[581372] Boskovice 6202 [581372] Boskovice"
    },
    {
        "kod": 581381,
        "nazev": "Brťov-Jeneč",
        "popis": "[581381] Brťov-Jeneč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581381,
        "val": "[581381] Brtov-Jenec 6201 [581381] Brťov-Jeneč"
    },
    {
        "kod": 581445,
        "nazev": "Bukovina",
        "popis": "[581445] Bukovina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581445,
        "val": "[581445] Bukovina 6201 [581445] Bukovina"
    },
    {
        "kod": 581453,
        "nazev": "Bukovinka",
        "popis": "[581453] Bukovinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581453,
        "val": "[581453] Bukovinka 6201 [581453] Bukovinka"
    },
    {
        "kod": 581461,
        "nazev": "Býkovice",
        "popis": "[581461] Býkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581461,
        "val": "[581461] Bykovice 6201 [581461] Býkovice"
    },
    {
        "kod": 581470,
        "nazev": "Cetkovice",
        "popis": "[581470] Cetkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581470,
        "val": "[581470] Cetkovice 6202 [581470] Cetkovice"
    },
    {
        "kod": 554162,
        "nazev": "Crhov",
        "popis": "[554162] Crhov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 554162,
        "val": "[554162] Crhov 6202 [554162] Crhov"
    },
    {
        "kod": 581496,
        "nazev": "Černá Hora",
        "popis": "[581496] Černá Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581496,
        "val": "[581496] Cerna Hora 6201 [581496] Černá Hora"
    },
    {
        "kod": 581500,
        "nazev": "Černovice",
        "popis": "[581500] Černovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581500,
        "val": "[581500] Cernovice 6202 [581500] Černovice"
    },
    {
        "kod": 581518,
        "nazev": "Deštná",
        "popis": "[581518] Deštná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581518,
        "val": "[581518] Destna 6202 [581518] Deštná"
    },
    {
        "kod": 581526,
        "nazev": "Dlouhá Lhota",
        "popis": "[581526] Dlouhá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581526,
        "val": "[581526] Dlouha Lhota 6201 [581526] Dlouhá Lhota"
    },
    {
        "kod": 581542,
        "nazev": "Doubravice nad Svitavou",
        "popis": "[581542] Doubravice nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581542,
        "val": "[581542] Doubravice nad Svitavou 6201 [581542] Doubravice nad Svitavou"
    },
    {
        "kod": 581551,
        "nazev": "Drnovice",
        "popis": "[581551] Drnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581551,
        "val": "[581551] Drnovice 6202 [581551] Drnovice"
    },
    {
        "kod": 581569,
        "nazev": "Habrůvka",
        "popis": "[581569] Habrůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581569,
        "val": "[581569] Habruvka 6201 [581569] Habrůvka"
    },
    {
        "kod": 581593,
        "nazev": "Hodonín",
        "popis": "[581593] Hodonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581593,
        "val": "[581593] Hodonin 6202 [581593] Hodonín"
    },
    {
        "kod": 581615,
        "nazev": "Holštejn",
        "popis": "[581615] Holštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581615,
        "val": "[581615] Holstejn 6201 [581615] Holštejn"
    },
    {
        "kod": 581631,
        "nazev": "Horní Poříčí",
        "popis": "[581631] Horní Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581631,
        "val": "[581631] Horni Porici 6202 [581631] Horní Poříčí"
    },
    {
        "kod": 513695,
        "nazev": "Horní Smržov",
        "popis": "[513695] Horní Smržov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 513695,
        "val": "[513695] Horni Smrzov 6202 [513695] Horní Smržov"
    },
    {
        "kod": 581534,
        "nazev": "Chrudichromy",
        "popis": "[581534] Chrudichromy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581534,
        "val": "[581534] Chrudichromy 6202 [581534] Chrudichromy"
    },
    {
        "kod": 581666,
        "nazev": "Jabloňany",
        "popis": "[581666] Jabloňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581666,
        "val": "[581666] Jablonany 6202 [581666] Jabloňany"
    },
    {
        "kod": 581682,
        "nazev": "Jedovnice",
        "popis": "[581682] Jedovnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581682,
        "val": "[581682] Jedovnice 6201 [581682] Jedovnice"
    },
    {
        "kod": 581721,
        "nazev": "Kněževes",
        "popis": "[581721] Kněževes",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581721,
        "val": "[581721] Knezeves 6202 [581721] Kněževes"
    },
    {
        "kod": 581739,
        "nazev": "Knínice u Boskovic",
        "popis": "[581739] Knínice u Boskovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581739,
        "val": "[581739] Kninice u Boskovic 6202 [581739] Knínice u Boskovic"
    },
    {
        "kod": 581755,
        "nazev": "Kořenec",
        "popis": "[581755] Kořenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581755,
        "val": "[581755] Korenec 6202 [581755] Kořenec"
    },
    {
        "kod": 581763,
        "nazev": "Kotvrdovice",
        "popis": "[581763] Kotvrdovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581763,
        "val": "[581763] Kotvrdovice 6201 [581763] Kotvrdovice"
    },
    {
        "kod": 581771,
        "nazev": "Kozárov",
        "popis": "[581771] Kozárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581771,
        "val": "[581771] Kozarov 6202 [581771] Kozárov"
    },
    {
        "kod": 581780,
        "nazev": "Krasová",
        "popis": "[581780] Krasová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581780,
        "val": "[581780] Krasova 6201 [581780] Krasová"
    },
    {
        "kod": 581798,
        "nazev": "Krhov",
        "popis": "[581798] Krhov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581798,
        "val": "[581798] Krhov 6202 [581798] Krhov"
    },
    {
        "kod": 581801,
        "nazev": "Křetín",
        "popis": "[581801] Křetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581801,
        "val": "[581801] Kretin 6202 [581801] Křetín"
    },
    {
        "kod": 581810,
        "nazev": "Křtěnov",
        "popis": "[581810] Křtěnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581810,
        "val": "[581810] Krtenov 6202 [581810] Křtěnov"
    },
    {
        "kod": 581828,
        "nazev": "Křtiny",
        "popis": "[581828] Křtiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581828,
        "val": "[581828] Krtiny 6201 [581828] Křtiny"
    },
    {
        "kod": 581836,
        "nazev": "Kulířov",
        "popis": "[581836] Kulířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581836,
        "val": "[581836] Kulirov 6201 [581836] Kulířov"
    },
    {
        "kod": 581844,
        "nazev": "Kunčina Ves",
        "popis": "[581844] Kunčina Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581844,
        "val": "[581844] Kuncina Ves 6202 [581844] Kunčina Ves"
    },
    {
        "kod": 581852,
        "nazev": "Kunice",
        "popis": "[581852] Kunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581852,
        "val": "[581852] Kunice 6202 [581852] Kunice"
    },
    {
        "kod": 581861,
        "nazev": "Kuničky",
        "popis": "[581861] Kuničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581861,
        "val": "[581861] Kunicky 6201 [581861] Kuničky"
    },
    {
        "kod": 581879,
        "nazev": "Kunštát",
        "popis": "[581879] Kunštát",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581879,
        "val": "[581879] Kunstat 6202 [581879] Kunštát"
    },
    {
        "kod": 581887,
        "nazev": "Lazinov",
        "popis": "[581887] Lazinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581887,
        "val": "[581887] Lazinov 6202 [581887] Lazinov"
    },
    {
        "kod": 581909,
        "nazev": "Lažany",
        "popis": "[581909] Lažany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581909,
        "val": "[581909] Lazany 6201 [581909] Lažany"
    },
    {
        "kod": 581917,
        "nazev": "Letovice",
        "popis": "[581917] Letovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581917,
        "val": "[581917] Letovice 6202 [581917] Letovice"
    },
    {
        "kod": 581925,
        "nazev": "Lhota Rapotina",
        "popis": "[581925] Lhota Rapotina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581925,
        "val": "[581925] Lhota Rapotina 6202 [581925] Lhota Rapotina"
    },
    {
        "kod": 581933,
        "nazev": "Lhota u Lysic",
        "popis": "[581933] Lhota u Lysic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581933,
        "val": "[581933] Lhota u Lysic 6202 [581933] Lhota u Lysic"
    },
    {
        "kod": 581941,
        "nazev": "Lhota u Olešnice",
        "popis": "[581941] Lhota u Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 581941,
        "val": "[581941] Lhota u Olesnice 6202 [581941] Lhota u Olešnice"
    },
    {
        "kod": 581950,
        "nazev": "Lipovec",
        "popis": "[581950] Lipovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581950,
        "val": "[581950] Lipovec 6201 [581950] Lipovec"
    },
    {
        "kod": 581968,
        "nazev": "Lipůvka",
        "popis": "[581968] Lipůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581968,
        "val": "[581968] Lipuvka 6201 [581968] Lipůvka"
    },
    {
        "kod": 553875,
        "nazev": "Louka",
        "popis": "[553875] Louka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 553875,
        "val": "[553875] Louka 6202 [553875] Louka"
    },
    {
        "kod": 581992,
        "nazev": "Lubě",
        "popis": "[581992] Lubě",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 581992,
        "val": "[581992] Lube 6201 [581992] Lubě"
    },
    {
        "kod": 531006,
        "nazev": "Ludíkov",
        "popis": "[531006] Ludíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 531006,
        "val": "[531006] Ludikov 6202 [531006] Ludíkov"
    },
    {
        "kod": 582018,
        "nazev": "Lysice",
        "popis": "[582018] Lysice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582018,
        "val": "[582018] Lysice 6202 [582018] Lysice"
    },
    {
        "kod": 582026,
        "nazev": "Makov",
        "popis": "[582026] Makov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582026,
        "val": "[582026] Makov 6202 [582026] Makov"
    },
    {
        "kod": 582034,
        "nazev": "Malá Lhota",
        "popis": "[582034] Malá Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582034,
        "val": "[582034] Mala Lhota 6201 [582034] Malá Lhota"
    },
    {
        "kod": 582042,
        "nazev": "Malá Roudka",
        "popis": "[582042] Malá Roudka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582042,
        "val": "[582042] Mala Roudka 6202 [582042] Malá Roudka"
    },
    {
        "kod": 582069,
        "nazev": "Míchov",
        "popis": "[582069] Míchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582069,
        "val": "[582069] Michov 6202 [582069] Míchov"
    },
    {
        "kod": 582077,
        "nazev": "Milonice",
        "popis": "[582077] Milonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582077,
        "val": "[582077] Milonice 6201 [582077] Milonice"
    },
    {
        "kod": 582085,
        "nazev": "Němčice",
        "popis": "[582085] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582085,
        "val": "[582085] Nemcice 6202 [582085] Němčice"
    },
    {
        "kod": 582107,
        "nazev": "Nýrov",
        "popis": "[582107] Nýrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582107,
        "val": "[582107] Nyrov 6202 [582107] Nýrov"
    },
    {
        "kod": 582115,
        "nazev": "Obora",
        "popis": "[582115] Obora",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582115,
        "val": "[582115] Obora 6202 [582115] Obora"
    },
    {
        "kod": 582131,
        "nazev": "Okrouhlá",
        "popis": "[582131] Okrouhlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582131,
        "val": "[582131] Okrouhla 6202 [582131] Okrouhlá"
    },
    {
        "kod": 582158,
        "nazev": "Olešnice",
        "popis": "[582158] Olešnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582158,
        "val": "[582158] Olesnice 6202 [582158] Olešnice"
    },
    {
        "kod": 582166,
        "nazev": "Olomučany",
        "popis": "[582166] Olomučany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582166,
        "val": "[582166] Olomucany 6201 [582166] Olomučany"
    },
    {
        "kod": 582182,
        "nazev": "Ostrov u Macochy",
        "popis": "[582182] Ostrov u Macochy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582182,
        "val": "[582182] Ostrov u Macochy 6201 [582182] Ostrov u Macochy"
    },
    {
        "kod": 582191,
        "nazev": "Pamětice",
        "popis": "[582191] Pamětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582191,
        "val": "[582191] Pametice 6202 [582191] Pamětice"
    },
    {
        "kod": 582204,
        "nazev": "Petrov",
        "popis": "[582204] Petrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582204,
        "val": "[582204] Petrov 6202 [582204] Petrov"
    },
    {
        "kod": 582212,
        "nazev": "Petrovice",
        "popis": "[582212] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582212,
        "val": "[582212] Petrovice 6201 [582212] Petrovice"
    },
    {
        "kod": 582221,
        "nazev": "Prostřední Poříčí",
        "popis": "[582221] Prostřední Poříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582221,
        "val": "[582221] Prostredni Porici 6202 [582221] Prostřední Poříčí"
    },
    {
        "kod": 582239,
        "nazev": "Rájec-Jestřebí",
        "popis": "[582239] Rájec-Jestřebí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582239,
        "val": "[582239] Rajec-Jestrebi 6201 [582239] Rájec-Jestřebí"
    },
    {
        "kod": 582247,
        "nazev": "Ráječko",
        "popis": "[582247] Ráječko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582247,
        "val": "[582247] Rajecko 6201 [582247] Ráječko"
    },
    {
        "kod": 513709,
        "nazev": "Roubanina",
        "popis": "[513709] Roubanina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 513709,
        "val": "[513709] Roubanina 6202 [513709] Roubanina"
    },
    {
        "kod": 582271,
        "nazev": "Rozseč nad Kunštátem",
        "popis": "[582271] Rozseč nad Kunštátem",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582271,
        "val": "[582271] Rozsec nad Kunstatem 6202 [582271] Rozseč nad Kunštátem"
    },
    {
        "kod": 582280,
        "nazev": "Rozsíčka",
        "popis": "[582280] Rozsíčka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582280,
        "val": "[582280] Rozsicka 6202 [582280] Rozsíčka"
    },
    {
        "kod": 582298,
        "nazev": "Rudice",
        "popis": "[582298] Rudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582298,
        "val": "[582298] Rudice 6201 [582298] Rudice"
    },
    {
        "kod": 582310,
        "nazev": "Sebranice",
        "popis": "[582310] Sebranice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582310,
        "val": "[582310] Sebranice 6202 [582310] Sebranice"
    },
    {
        "kod": 582328,
        "nazev": "Senetářov",
        "popis": "[582328] Senetářov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582328,
        "val": "[582328] Senetarov 6201 [582328] Senetářov"
    },
    {
        "kod": 582336,
        "nazev": "Skalice nad Svitavou",
        "popis": "[582336] Skalice nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582336,
        "val": "[582336] Skalice nad Svitavou 6202 [582336] Skalice nad Svitavou"
    },
    {
        "kod": 582344,
        "nazev": "Skrchov",
        "popis": "[582344] Skrchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582344,
        "val": "[582344] Skrchov 6202 [582344] Skrchov"
    },
    {
        "kod": 582352,
        "nazev": "Sloup",
        "popis": "[582352] Sloup",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582352,
        "val": "[582352] Sloup 6201 [582352] Sloup"
    },
    {
        "kod": 556963,
        "nazev": "Spešov",
        "popis": "[556963] Spešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 556963,
        "val": "[556963] Spesov 6201 [556963] Spešov"
    },
    {
        "kod": 582620,
        "nazev": "Stvolová",
        "popis": "[582620] Stvolová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582620,
        "val": "[582620] Stvolova 6202 [582620] Stvolová"
    },
    {
        "kod": 582395,
        "nazev": "Sudice",
        "popis": "[582395] Sudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582395,
        "val": "[582395] Sudice 6202 [582395] Sudice"
    },
    {
        "kod": 582409,
        "nazev": "Suchý",
        "popis": "[582409] Suchý",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582409,
        "val": "[582409] Suchy 6202 [582409] Suchý"
    },
    {
        "kod": 582417,
        "nazev": "Sulíkov",
        "popis": "[582417] Sulíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582417,
        "val": "[582417] Sulikov 6202 [582417] Sulíkov"
    },
    {
        "kod": 586064,
        "nazev": "Světlá",
        "popis": "[586064] Světlá",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 586064,
        "val": "[586064] Svetla 6202 [586064] Světlá"
    },
    {
        "kod": 582433,
        "nazev": "Svinošice",
        "popis": "[582433] Svinošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582433,
        "val": "[582433] Svinosice 6201 [582433] Svinošice"
    },
    {
        "kod": 582441,
        "nazev": "Svitávka",
        "popis": "[582441] Svitávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582441,
        "val": "[582441] Svitavka 6202 [582441] Svitávka"
    },
    {
        "kod": 582468,
        "nazev": "Šebetov",
        "popis": "[582468] Šebetov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582468,
        "val": "[582468] Sebetov 6202 [582468] Šebetov"
    },
    {
        "kod": 582476,
        "nazev": "Šebrov-Kateřina",
        "popis": "[582476] Šebrov-Kateřina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582476,
        "val": "[582476] Sebrov-Katerina 6201 [582476] Šebrov-Kateřina"
    },
    {
        "kod": 582484,
        "nazev": "Šošůvka",
        "popis": "[582484] Šošůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582484,
        "val": "[582484] Sosuvka 6201 [582484] Šošůvka"
    },
    {
        "kod": 582492,
        "nazev": "Štěchov",
        "popis": "[582492] Štěchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582492,
        "val": "[582492] Stechov 6202 [582492] Štěchov"
    },
    {
        "kod": 582506,
        "nazev": "Tasovice",
        "popis": "[582506] Tasovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582506,
        "val": "[582506] Tasovice 6202 [582506] Tasovice"
    },
    {
        "kod": 582531,
        "nazev": "Uhřice",
        "popis": "[582531] Uhřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582531,
        "val": "[582531] Uhrice 6202 [582531] Uhřice"
    },
    {
        "kod": 534692,
        "nazev": "Újezd u Boskovic",
        "popis": "[534692] Újezd u Boskovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 534692,
        "val": "[534692] Ujezd u Boskovic 6202 [534692] Újezd u Boskovic"
    },
    {
        "kod": 582557,
        "nazev": "Újezd u Černé Hory",
        "popis": "[582557] Újezd u Černé Hory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582557,
        "val": "[582557] Ujezd u Cerne Hory 6201 [582557] Újezd u Černé Hory"
    },
    {
        "kod": 582573,
        "nazev": "Úsobrno",
        "popis": "[582573] Úsobrno",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582573,
        "val": "[582573] Usobrno 6202 [582573] Úsobrno"
    },
    {
        "kod": 553883,
        "nazev": "Ústup",
        "popis": "[553883] Ústup",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 553883,
        "val": "[553883] Ustup 6202 [553883] Ústup"
    },
    {
        "kod": 582581,
        "nazev": "Valchov",
        "popis": "[582581] Valchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582581,
        "val": "[582581] Valchov 6202 [582581] Valchov"
    },
    {
        "kod": 582590,
        "nazev": "Vanovice",
        "popis": "[582590] Vanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582590,
        "val": "[582590] Vanovice 6202 [582590] Vanovice"
    },
    {
        "kod": 582603,
        "nazev": "Vavřinec",
        "popis": "[582603] Vavřinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582603,
        "val": "[582603] Vavrinec 6201 [582603] Vavřinec"
    },
    {
        "kod": 582611,
        "nazev": "Vážany",
        "popis": "[582611] Vážany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582611,
        "val": "[582611] Vazany 6202 [582611] Vážany"
    },
    {
        "kod": 530824,
        "nazev": "Velenov",
        "popis": "[530824] Velenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 530824,
        "val": "[530824] Velenov 6202 [530824] Velenov"
    },
    {
        "kod": 582646,
        "nazev": "Velké Opatovice",
        "popis": "[582646] Velké Opatovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582646,
        "val": "[582646] Velke Opatovice 6202 [582646] Velké Opatovice"
    },
    {
        "kod": 582654,
        "nazev": "Vilémovice",
        "popis": "[582654] Vilémovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582654,
        "val": "[582654] Vilemovice 6201 [582654] Vilémovice"
    },
    {
        "kod": 582662,
        "nazev": "Vísky",
        "popis": "[582662] Vísky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582662,
        "val": "[582662] Visky 6202 [582662] Vísky"
    },
    {
        "kod": 582671,
        "nazev": "Voděrady",
        "popis": "[582671] Voděrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582671,
        "val": "[582671] Voderady 6202 [582671] Voděrady"
    },
    {
        "kod": 582689,
        "nazev": "Vranová",
        "popis": "[582689] Vranová",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582689,
        "val": "[582689] Vranova 6202 [582689] Vranová"
    },
    {
        "kod": 582701,
        "nazev": "Vysočany",
        "popis": "[582701] Vysočany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582701,
        "val": "[582701] Vysocany 6201 [582701] Vysočany"
    },
    {
        "kod": 586005,
        "nazev": "Závist",
        "popis": "[586005] Závist",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 586005,
        "val": "[586005] Zavist 6201 [586005] Závist"
    },
    {
        "kod": 582727,
        "nazev": "Zbraslavec",
        "popis": "[582727] Zbraslavec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582727,
        "val": "[582727] Zbraslavec 6202 [582727] Zbraslavec"
    },
    {
        "kod": 582743,
        "nazev": "Žďár",
        "popis": "[582743] Žďár",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582743,
        "val": "[582743] Zdar 6201 [582743] Žďár"
    },
    {
        "kod": 582751,
        "nazev": "Žďárná",
        "popis": "[582751] Žďárná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582751,
        "val": "[582751] Zdarna 6202 [582751] Žďárná"
    },
    {
        "kod": 582760,
        "nazev": "Žernovník",
        "popis": "[582760] Žernovník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6201,
        "iczuj": 582760,
        "val": "[582760] Zernovnik 6201 [582760] Žernovník"
    },
    {
        "kod": 582778,
        "nazev": "Žerůtky",
        "popis": "[582778] Žerůtky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6202,
        "iczuj": 582778,
        "val": "[582778] Zerutky 6202 [582778] Žerůtky"
    },
    {
        "kod": 582794,
        "nazev": "Babice nad Svitavou",
        "popis": "[582794] Babice nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 582794,
        "val": "[582794] Babice nad Svitavou 6216 [582794] Babice nad Svitavou"
    },
    {
        "kod": 582808,
        "nazev": "Babice u Rosic",
        "popis": "[582808] Babice u Rosic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 582808,
        "val": "[582808] Babice u Rosic 6214 [582808] Babice u Rosic"
    },
    {
        "kod": 581321,
        "nazev": "Běleč",
        "popis": "[581321] Běleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 581321,
        "val": "[581321] Belec 6217 [581321] Běleč"
    },
    {
        "kod": 582824,
        "nazev": "Bílovice nad Svitavou",
        "popis": "[582824] Bílovice nad Svitavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 582824,
        "val": "[582824] Bilovice nad Svitavou 6216 [582824] Bílovice nad Svitavou"
    },
    {
        "kod": 582832,
        "nazev": "Biskoupky",
        "popis": "[582832] Biskoupky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 582832,
        "val": "[582832] Biskoupky 6208 [582832] Biskoupky"
    },
    {
        "kod": 582841,
        "nazev": "Blažovice",
        "popis": "[582841] Blažovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 582841,
        "val": "[582841] Blazovice 6216 [582841] Blažovice"
    },
    {
        "kod": 582859,
        "nazev": "Blučina",
        "popis": "[582859] Blučina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 582859,
        "val": "[582859] Blucina 6221 [582859] Blučina"
    },
    {
        "kod": 595314,
        "nazev": "Borač",
        "popis": "[595314] Borač",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595314,
        "val": "[595314] Borac 6217 [595314] Borač"
    },
    {
        "kod": 595331,
        "nazev": "Borovník",
        "popis": "[595331] Borovník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595331,
        "val": "[595331] Borovnik 6217 [595331] Borovník"
    },
    {
        "kod": 582875,
        "nazev": "Braníškov",
        "popis": "[582875] Braníškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582875,
        "val": "[582875] Braniskov 6217 [582875] Braníškov"
    },
    {
        "kod": 593834,
        "nazev": "Branišovice",
        "popis": "[593834] Branišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 593834,
        "val": "[593834] Branisovice 6213 [593834] Branišovice"
    },
    {
        "kod": 582883,
        "nazev": "Bratčice",
        "popis": "[582883] Bratčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 582883,
        "val": "[582883] Bratcice 6221 [582883] Bratčice"
    },
    {
        "kod": 581402,
        "nazev": "Brumov",
        "popis": "[581402] Brumov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 581402,
        "val": "[581402] Brumov 6217 [581402] Brumov"
    },
    {
        "kod": 581429,
        "nazev": "Březina (dříve okres Blansko)",
        "popis": "[581429] Březina (dříve okres Blansko)",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 581429,
        "val": "[581429] Brezina (drive okres Blansko) 6216 [581429] Březina (dříve okres Blansko)"
    },
    {
        "kod": 582891,
        "nazev": "Březina (dříve okres Tišnov)",
        "popis": "[582891] Březina (dříve okres Tišnov)",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582891,
        "val": "[582891] Brezina (drive okres Tisnov) 6217 [582891] Březina (dříve okres Tišnov)"
    },
    {
        "kod": 581437,
        "nazev": "Bukovice",
        "popis": "[581437] Bukovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 581437,
        "val": "[581437] Bukovice 6217 [581437] Bukovice"
    },
    {
        "kod": 550272,
        "nazev": "Cvrčovice",
        "popis": "[550272] Cvrčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 550272,
        "val": "[550272] Cvrcovice 6213 [550272] Cvrčovice"
    },
    {
        "kod": 582913,
        "nazev": "Čebín",
        "popis": "[582913] Čebín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 582913,
        "val": "[582913] Cebin 6209 [582913] Čebín"
    },
    {
        "kod": 595446,
        "nazev": "Černvír",
        "popis": "[595446] Černvír",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595446,
        "val": "[595446] Cernvir 6217 [595446] Černvír"
    },
    {
        "kod": 582921,
        "nazev": "Česká",
        "popis": "[582921] Česká",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 582921,
        "val": "[582921] Ceska 6209 [582921] Česká"
    },
    {
        "kod": 582930,
        "nazev": "Čučice",
        "popis": "[582930] Čučice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 582930,
        "val": "[582930] Cucice 6208 [582930] Čučice"
    },
    {
        "kod": 582948,
        "nazev": "Deblín",
        "popis": "[582948] Deblín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582948,
        "val": "[582948] Deblin 6217 [582948] Deblín"
    },
    {
        "kod": 582956,
        "nazev": "Dolní Kounice",
        "popis": "[582956] Dolní Kounice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 582956,
        "val": "[582956] Dolni Kounice 6208 [582956] Dolní Kounice"
    },
    {
        "kod": 595527,
        "nazev": "Dolní Loučky",
        "popis": "[595527] Dolní Loučky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595527,
        "val": "[595527] Dolni Loucky 6217 [595527] Dolní Loučky"
    },
    {
        "kod": 582964,
        "nazev": "Domašov",
        "popis": "[582964] Domašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 582964,
        "val": "[582964] Domasov 6214 [582964] Domašov"
    },
    {
        "kod": 595551,
        "nazev": "Doubravník",
        "popis": "[595551] Doubravník",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595551,
        "val": "[595551] Doubravnik 6217 [595551] Doubravník"
    },
    {
        "kod": 595560,
        "nazev": "Drahonín",
        "popis": "[595560] Drahonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595560,
        "val": "[595560] Drahonin 6217 [595560] Drahonín"
    },
    {
        "kod": 582972,
        "nazev": "Drásov",
        "popis": "[582972] Drásov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582972,
        "val": "[582972] Drasov 6217 [582972] Drásov"
    },
    {
        "kod": 582999,
        "nazev": "Hajany",
        "popis": "[582999] Hajany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 582999,
        "val": "[582999] Hajany 6216 [582999] Hajany"
    },
    {
        "kod": 583014,
        "nazev": "Heroltice",
        "popis": "[583014] Heroltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583014,
        "val": "[583014] Heroltice 6217 [583014] Heroltice"
    },
    {
        "kod": 583022,
        "nazev": "Hlína",
        "popis": "[583022] Hlína",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583022,
        "val": "[583022] Hlina 6208 [583022] Hlína"
    },
    {
        "kod": 581577,
        "nazev": "Hluboké Dvory",
        "popis": "[581577] Hluboké Dvory",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 581577,
        "val": "[581577] Hluboke Dvory 6217 [581577] Hluboké Dvory"
    },
    {
        "kod": 583031,
        "nazev": "Holasice",
        "popis": "[583031] Holasice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583031,
        "val": "[583031] Holasice 6221 [583031] Holasice"
    },
    {
        "kod": 595667,
        "nazev": "Horní Loučky",
        "popis": "[595667] Horní Loučky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595667,
        "val": "[595667] Horni Loucky 6217 [595667] Horní Loučky"
    },
    {
        "kod": 583057,
        "nazev": "Hostěnice",
        "popis": "[583057] Hostěnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583057,
        "val": "[583057] Hostenice 6216 [583057] Hostěnice"
    },
    {
        "kod": 583065,
        "nazev": "Hradčany",
        "popis": "[583065] Hradčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583065,
        "val": "[583065] Hradcany 6217 [583065] Hradčany"
    },
    {
        "kod": 583081,
        "nazev": "Hrušovany u Brna",
        "popis": "[583081] Hrušovany u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583081,
        "val": "[583081] Hrusovany u Brna 6221 [583081] Hrušovany u Brna"
    },
    {
        "kod": 583090,
        "nazev": "Hvozdec",
        "popis": "[583090] Hvozdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583090,
        "val": "[583090] Hvozdec 6209 [583090] Hvozdec"
    },
    {
        "kod": 583111,
        "nazev": "Chudčice",
        "popis": "[583111] Chudčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583111,
        "val": "[583111] Chudcice 6209 [583111] Chudčice"
    },
    {
        "kod": 584517,
        "nazev": "Ivaň",
        "popis": "[584517] Ivaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 584517,
        "val": "[584517] Ivan 6213 [584517] Ivaň"
    },
    {
        "kod": 583120,
        "nazev": "Ivančice",
        "popis": "[583120] Ivančice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583120,
        "val": "[583120] Ivancice 6208 [583120] Ivančice"
    },
    {
        "kod": 583154,
        "nazev": "Javůrek",
        "popis": "[583154] Javůrek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583154,
        "val": "[583154] Javurek 6214 [583154] Javůrek"
    },
    {
        "kod": 583171,
        "nazev": "Jinačovice",
        "popis": "[583171] Jinačovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583171,
        "val": "[583171] Jinacovice 6209 [583171] Jinačovice"
    },
    {
        "kod": 583189,
        "nazev": "Jiříkovice",
        "popis": "[583189] Jiříkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583189,
        "val": "[583189] Jirikovice 6216 [583189] Jiříkovice"
    },
    {
        "kod": 595837,
        "nazev": "Kaly",
        "popis": "[595837] Kaly",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595837,
        "val": "[595837] Kaly 6217 [595837] Kaly"
    },
    {
        "kod": 583197,
        "nazev": "Kanice",
        "popis": "[583197] Kanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583197,
        "val": "[583197] Kanice 6216 [583197] Kanice"
    },
    {
        "kod": 587907,
        "nazev": "Katov",
        "popis": "[587907] Katov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 587907,
        "val": "[587907] Katov 6217 [587907] Katov"
    },
    {
        "kod": 583201,
        "nazev": "Ketkovice",
        "popis": "[583201] Ketkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583201,
        "val": "[583201] Ketkovice 6208 [583201] Ketkovice"
    },
    {
        "kod": 583219,
        "nazev": "Kobylnice",
        "popis": "[583219] Kobylnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583219,
        "val": "[583219] Kobylnice 6216 [583219] Kobylnice"
    },
    {
        "kod": 583227,
        "nazev": "Kovalovice",
        "popis": "[583227] Kovalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583227,
        "val": "[583227] Kovalovice 6216 [583227] Kovalovice"
    },
    {
        "kod": 583235,
        "nazev": "Kratochvilka",
        "popis": "[583235] Kratochvilka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583235,
        "val": "[583235] Kratochvilka 6214 [583235] Kratochvilka"
    },
    {
        "kod": 595934,
        "nazev": "Křižínkov",
        "popis": "[595934] Křižínkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595934,
        "val": "[595934] Krizinkov 6217 [595934] Křižínkov"
    },
    {
        "kod": 583243,
        "nazev": "Kupařovice",
        "popis": "[583243] Kupařovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583243,
        "val": "[583243] Kuparovice 6208 [583243] Kupařovice"
    },
    {
        "kod": 583251,
        "nazev": "Kuřim",
        "popis": "[583251] Kuřim",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583251,
        "val": "[583251] Kurim 6209 [583251] Kuřim"
    },
    {
        "kod": 595985,
        "nazev": "Kuřimská Nová Ves",
        "popis": "[595985] Kuřimská Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595985,
        "val": "[595985] Kurimska Nova Ves 6217 [595985] Kuřimská Nová Ves"
    },
    {
        "kod": 595993,
        "nazev": "Kuřimské Jestřabí",
        "popis": "[595993] Kuřimské Jestřabí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 595993,
        "val": "[595993] Kurimske Jestrabi 6217 [595993] Kuřimské Jestřabí"
    },
    {
        "kod": 583260,
        "nazev": "Lažánky",
        "popis": "[583260] Lažánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583260,
        "val": "[583260] Lazanky 6217 [583260] Lažánky"
    },
    {
        "kod": 583278,
        "nazev": "Ledce",
        "popis": "[583278] Ledce",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583278,
        "val": "[583278] Ledce 6221 [583278] Ledce"
    },
    {
        "kod": 583286,
        "nazev": "Lelekovice",
        "popis": "[583286] Lelekovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583286,
        "val": "[583286] Lelekovice 6209 [583286] Lelekovice"
    },
    {
        "kod": 583294,
        "nazev": "Lesní Hluboké",
        "popis": "[583294] Lesní Hluboké",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583294,
        "val": "[583294] Lesni Hluboke 6214 [583294] Lesní Hluboké"
    },
    {
        "kod": 583308,
        "nazev": "Litostrov",
        "popis": "[583308] Litostrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583308,
        "val": "[583308] Litostrov 6214 [583308] Litostrov"
    },
    {
        "kod": 594377,
        "nazev": "Loděnice",
        "popis": "[594377] Loděnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 594377,
        "val": "[594377] Lodenice 6213 [594377] Loděnice"
    },
    {
        "kod": 581976,
        "nazev": "Lomnice",
        "popis": "[581976] Lomnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 581976,
        "val": "[581976] Lomnice 6217 [581976] Lomnice"
    },
    {
        "kod": 583316,
        "nazev": "Lomnička",
        "popis": "[583316] Lomnička",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583316,
        "val": "[583316] Lomnicka 6217 [583316] Lomnička"
    },
    {
        "kod": 596078,
        "nazev": "Lubné",
        "popis": "[596078] Lubné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596078,
        "val": "[596078] Lubne 6217 [596078] Lubné"
    },
    {
        "kod": 583324,
        "nazev": "Lukovany",
        "popis": "[583324] Lukovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583324,
        "val": "[583324] Lukovany 6214 [583324] Lukovany"
    },
    {
        "kod": 583332,
        "nazev": "Malešovice",
        "popis": "[583332] Malešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 583332,
        "val": "[583332] Malesovice 6213 [583332] Malešovice"
    },
    {
        "kod": 583341,
        "nazev": "Malhostovice",
        "popis": "[583341] Malhostovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583341,
        "val": "[583341] Malhostovice 6217 [583341] Malhostovice"
    },
    {
        "kod": 583359,
        "nazev": "Maršov",
        "popis": "[583359] Maršov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583359,
        "val": "[583359] Marsov 6217 [583359] Maršov"
    },
    {
        "kod": 583367,
        "nazev": "Medlov",
        "popis": "[583367] Medlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583367,
        "val": "[583367] Medlov 6221 [583367] Medlov"
    },
    {
        "kod": 583375,
        "nazev": "Mělčany",
        "popis": "[583375] Mělčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583375,
        "val": "[583375] Melcany 6208 [583375] Mělčany"
    },
    {
        "kod": 583383,
        "nazev": "Měnín",
        "popis": "[583383] Měnín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583383,
        "val": "[583383] Menin 6221 [583383] Měnín"
    },
    {
        "kod": 583391,
        "nazev": "Modřice",
        "popis": "[583391] Modřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583391,
        "val": "[583391] Modrice 6216 [583391] Modřice"
    },
    {
        "kod": 583405,
        "nazev": "Mokrá-Horákov",
        "popis": "[583405] Mokrá-Horákov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583405,
        "val": "[583405] Mokra-Horakov 6216 [583405] Mokrá-Horákov"
    },
    {
        "kod": 583413,
        "nazev": "Moravany",
        "popis": "[583413] Moravany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583413,
        "val": "[583413] Moravany 6216 [583413] Moravany"
    },
    {
        "kod": 583421,
        "nazev": "Moravské Bránice",
        "popis": "[583421] Moravské Bránice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583421,
        "val": "[583421] Moravske Branice 6208 [583421] Moravské Bránice"
    },
    {
        "kod": 583430,
        "nazev": "Moravské Knínice",
        "popis": "[583430] Moravské Knínice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6209,
        "iczuj": 583430,
        "val": "[583430] Moravske Kninice 6209 [583430] Moravské Knínice"
    },
    {
        "kod": 583448,
        "nazev": "Moutnice",
        "popis": "[583448] Moutnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583448,
        "val": "[583448] Moutnice 6221 [583448] Moutnice"
    },
    {
        "kod": 583456,
        "nazev": "Nebovidy",
        "popis": "[583456] Nebovidy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583456,
        "val": "[583456] Nebovidy 6216 [583456] Nebovidy"
    },
    {
        "kod": 596175,
        "nazev": "Nedvědice",
        "popis": "[596175] Nedvědice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596175,
        "val": "[596175] Nedvedice 6217 [596175] Nedvědice"
    },
    {
        "kod": 583464,
        "nazev": "Nelepeč-Žernůvka",
        "popis": "[583464] Nelepeč-Žernůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 583464,
        "val": "[583464] Nelepec-Zernuvka 6217 [583464] Nelepeč-Žernůvka"
    },
    {
        "kod": 583472,
        "nazev": "Němčičky",
        "popis": "[583472] Němčičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583472,
        "val": "[583472] Nemcicky 6208 [583472] Němčičky"
    },
    {
        "kod": 583481,
        "nazev": "Neslovice",
        "popis": "[583481] Neslovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583481,
        "val": "[583481] Neslovice 6208 [583481] Neslovice"
    },
    {
        "kod": 583499,
        "nazev": "Nesvačilka",
        "popis": "[583499] Nesvačilka",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583499,
        "val": "[583499] Nesvacilka 6221 [583499] Nesvačilka"
    },
    {
        "kod": 596191,
        "nazev": "Níhov",
        "popis": "[596191] Níhov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596191,
        "val": "[596191] Nihov 6217 [596191] Níhov"
    },
    {
        "kod": 584720,
        "nazev": "Nosislav",
        "popis": "[584720] Nosislav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 584720,
        "val": "[584720] Nosislav 6221 [584720] Nosislav"
    },
    {
        "kod": 583502,
        "nazev": "Nová Ves",
        "popis": "[583502] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583502,
        "val": "[583502] Nova Ves 6208 [583502] Nová Ves"
    },
    {
        "kod": 583511,
        "nazev": "Nové Bránice",
        "popis": "[583511] Nové Bránice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583511,
        "val": "[583511] Nove Branice 6208 [583511] Nové Bránice"
    },
    {
        "kod": 583529,
        "nazev": "Odrovice",
        "popis": "[583529] Odrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 583529,
        "val": "[583529] Odrovice 6213 [583529] Odrovice"
    },
    {
        "kod": 583537,
        "nazev": "Ochoz u Brna",
        "popis": "[583537] Ochoz u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583537,
        "val": "[583537] Ochoz u Brna 6216 [583537] Ochoz u Brna"
    },
    {
        "kod": 582123,
        "nazev": "Ochoz u Tišnova",
        "popis": "[582123] Ochoz u Tišnova",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582123,
        "val": "[582123] Ochoz u Tisnova 6217 [582123] Ochoz u Tišnova"
    },
    {
        "kod": 596302,
        "nazev": "Olší",
        "popis": "[596302] Olší",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596302,
        "val": "[596302] Olsi 6217 [596302] Olší"
    },
    {
        "kod": 583545,
        "nazev": "Omice",
        "popis": "[583545] Omice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583545,
        "val": "[583545] Omice 6216 [583545] Omice"
    },
    {
        "kod": 583553,
        "nazev": "Opatovice",
        "popis": "[583553] Opatovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583553,
        "val": "[583553] Opatovice 6221 [583553] Opatovice"
    },
    {
        "kod": 583561,
        "nazev": "Ořechov",
        "popis": "[583561] Ořechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583561,
        "val": "[583561] Orechov 6216 [583561] Ořechov"
    },
    {
        "kod": 582174,
        "nazev": "Osiky",
        "popis": "[582174] Osiky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 582174,
        "val": "[582174] Osiky 6217 [582174] Osiky"
    },
    {
        "kod": 583588,
        "nazev": "Oslavany",
        "popis": "[583588] Oslavany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6208,
        "iczuj": 583588,
        "val": "[583588] Oslavany 6208 [583588] Oslavany"
    },
    {
        "kod": 583596,
        "nazev": "Ostopovice",
        "popis": "[583596] Ostopovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583596,
        "val": "[583596] Ostopovice 6216 [583596] Ostopovice"
    },
    {
        "kod": 583600,
        "nazev": "Ostrovačice",
        "popis": "[583600] Ostrovačice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6214,
        "iczuj": 583600,
        "val": "[583600] Ostrovacice 6214 [583600] Ostrovačice"
    },
    {
        "kod": 506699,
        "nazev": "Otmarov",
        "popis": "[506699] Otmarov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 506699,
        "val": "[506699] Otmarov 6221 [506699] Otmarov"
    },
    {
        "kod": 584762,
        "nazev": "Pasohlávky",
        "popis": "[584762] Pasohlávky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 584762,
        "val": "[584762] Pasohlavky 6213 [584762] Pasohlávky"
    },
    {
        "kod": 596400,
        "nazev": "Pernštejnské Jestřabí",
        "popis": "[596400] Pernštejnské Jestřabí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6217,
        "iczuj": 596400,
        "val": "[596400] Pernstejnske Jestrabi 6217 [596400] Pernštejnské Jestřabí"
    },
    {
        "kod": 583634,
        "nazev": "Podolí",
        "popis": "[583634] Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 583634,
        "val": "[583634] Podoli 6216 [583634] Podolí"
    },
    {
        "kod": 584801,
        "nazev": "Pohořelice",
        "popis": "[584801] Pohořelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6213,
        "iczuj": 584801,
        "val": "[584801] Pohorelice 6213 [584801] Pohořelice"
    },
    {
        "kod": 549738,
        "nazev": "Ponětovice",
        "popis": "[549738] Ponětovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6216,
        "iczuj": 549738,
        "val": "[549738] Ponetovice 6216 [549738] Ponětovice"
    },
    {
        "kod": 583651,
        "nazev": "Popovice",
        "popis": "[583651] Popovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6221,
        "iczuj": 583651,
        "val": "[583651] Popovice 6221 [583651] Popovice"
    },
    {
        "kod": 547409,
        "nazev": "Praha-Štěrboholy",
        "popis": "[547409] Praha-Štěrboholy",
        "datum_od": "",
        "datum_do": "",
        "orp": 1115,
        "iczuj": 554782,
        "val": "[547409] Praha-Sterboholy 1115 [547409] Praha-Štěrboholy"
    },
    {
        "kod": 502839,
        "nazev": "Cholina",
        "popis": "[502839] Cholina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 502839,
        "val": "[502839] Cholina 7105 [502839] Cholina"
    },
    {
        "kod": 503142,
        "nazev": "Jívová",
        "popis": "[503142] Jívová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 503142,
        "val": "[503142] Jivova 7110 [503142] Jívová"
    },
    {
        "kod": 547123,
        "nazev": "Komárov",
        "popis": "[547123] Komárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 547123,
        "val": "[547123] Komarov 7110 [547123] Komárov"
    },
    {
        "kod": 503304,
        "nazev": "Kožušany-Tážaly",
        "popis": "[503304] Kožušany-Tážaly",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 503304,
        "val": "[503304] Kozusany-Tazaly 7107 [503304] Kožušany-Tážaly"
    },
    {
        "kod": 552437,
        "nazev": "Krčmaň",
        "popis": "[552437] Krčmaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552437,
        "val": "[552437] Krcman 7107 [552437] Krčmaň"
    },
    {
        "kod": 554901,
        "nazev": "Křelov-Břuchotín",
        "popis": "[554901] Křelov-Břuchotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 554901,
        "val": "[554901] Krelov-Bruchotin 7107 [554901] Křelov-Břuchotín"
    },
    {
        "kod": 503941,
        "nazev": "Libavá",
        "popis": "[503941] Libavá",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 503941,
        "val": "[503941] Libava 7107 [503941] Libavá"
    },
    {
        "kod": 569003,
        "nazev": "Liboš",
        "popis": "[569003] Liboš",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 569003,
        "val": "[569003] Libos 7107 [569003] Liboš"
    },
    {
        "kod": 552305,
        "nazev": "Lipina",
        "popis": "[552305] Lipina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552305,
        "val": "[552305] Lipina 7110 [552305] Lipina"
    },
    {
        "kod": 540005,
        "nazev": "Lipinka",
        "popis": "[540005] Lipinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 540005,
        "val": "[540005] Lipinka 7112 [540005] Lipinka"
    },
    {
        "kod": 503444,
        "nazev": "Litovel",
        "popis": "[503444] Litovel",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 503444,
        "val": "[503444] Litovel 7105 [503444] Litovel"
    },
    {
        "kod": 552232,
        "nazev": "Loučany",
        "popis": "[552232] Loučany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552232,
        "val": "[552232] Loucany 7107 [552232] Loučany"
    },
    {
        "kod": 552038,
        "nazev": "Loučka",
        "popis": "[552038] Loučka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552038,
        "val": "[552038] Loucka 7105 [552038] Loučka"
    },
    {
        "kod": 552216,
        "nazev": "Luběnice",
        "popis": "[552216] Luběnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552216,
        "val": "[552216] Lubenice 7107 [552216] Luběnice"
    },
    {
        "kod": 503622,
        "nazev": "Luká",
        "popis": "[503622] Luká",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 503622,
        "val": "[503622] Luka 7105 [503622] Luká"
    },
    {
        "kod": 503657,
        "nazev": "Lutín",
        "popis": "[503657] Lutín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 503657,
        "val": "[503657] Lutin 7107 [503657] Lutín"
    },
    {
        "kod": 569844,
        "nazev": "Lužice",
        "popis": "[569844] Lužice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 569844,
        "val": "[569844] Luzice 7110 [569844] Lužice"
    },
    {
        "kod": 503738,
        "nazev": "Majetín",
        "popis": "[503738] Majetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 503738,
        "val": "[503738] Majetin 7107 [503738] Majetín"
    },
    {
        "kod": 552372,
        "nazev": "Medlov",
        "popis": "[552372] Medlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 552372,
        "val": "[552372] Medlov 7112 [552372] Medlov"
    },
    {
        "kod": 568911,
        "nazev": "Měrotín",
        "popis": "[568911] Měrotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 568911,
        "val": "[568911] Merotin 7105 [568911] Měrotín"
    },
    {
        "kod": 504246,
        "nazev": "Mladeč",
        "popis": "[504246] Mladeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 504246,
        "val": "[504246] Mladec 7105 [504246] Mladeč"
    },
    {
        "kod": 552348,
        "nazev": "Mladějovice",
        "popis": "[552348] Mladějovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552348,
        "val": "[552348] Mladejovice 7110 [552348] Mladějovice"
    },
    {
        "kod": 597678,
        "nazev": "Moravský Beroun",
        "popis": "[597678] Moravský Beroun",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 597678,
        "val": "[597678] Moravsky Beroun 7110 [597678] Moravský Beroun"
    },
    {
        "kod": 554944,
        "nazev": "Mrsklesy",
        "popis": "[554944] Mrsklesy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 554944,
        "val": "[554944] Mrsklesy 7107 [554944] Mrsklesy"
    },
    {
        "kod": 547093,
        "nazev": "Mutkov",
        "popis": "[547093] Mutkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 547093,
        "val": "[547093] Mutkov 7110 [547093] Mutkov"
    },
    {
        "kod": 504441,
        "nazev": "Náklo",
        "popis": "[504441] Náklo",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 504441,
        "val": "[504441] Naklo 7105 [504441] Náklo"
    },
    {
        "kod": 504505,
        "nazev": "Náměšť na Hané",
        "popis": "[504505] Náměšť na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 504505,
        "val": "[504505] Namest na Hane 7107 [504505] Náměšť na Hané"
    },
    {
        "kod": 597686,
        "nazev": "Norberčany",
        "popis": "[597686] Norberčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 597686,
        "val": "[597686] Norbercany 7110 [597686] Norberčany"
    },
    {
        "kod": 552381,
        "nazev": "Nová Hradečná",
        "popis": "[552381] Nová Hradečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 552381,
        "val": "[552381] Nova Hradecna 7112 [552381] Nová Hradečná"
    },
    {
        "kod": 552259,
        "nazev": "Olbramice",
        "popis": "[552259] Olbramice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552259,
        "val": "[552259] Olbramice 7105 [552259] Olbramice"
    },
    {
        "kod": 500496,
        "nazev": "Olomouc",
        "popis": "[500496] Olomouc",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500496,
        "val": "[500496] Olomouc 7107 [500496] Olomouc"
    },
    {
        "kod": 504785,
        "nazev": "Paseka",
        "popis": "[504785] Paseka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 504785,
        "val": "[504785] Paseka 7112 [504785] Paseka"
    },
    {
        "kod": 552160,
        "nazev": "Pňovice",
        "popis": "[552160] Pňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552160,
        "val": "[552160] Pnovice 7105 [552160] Pňovice"
    },
    {
        "kod": 552411,
        "nazev": "Přáslavice",
        "popis": "[552411] Přáslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552411,
        "val": "[552411] Praslavice 7107 [552411] Přáslavice"
    },
    {
        "kod": 505013,
        "nazev": "Příkazy",
        "popis": "[505013] Příkazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505013,
        "val": "[505013] Prikazy 7107 [505013] Příkazy"
    },
    {
        "kod": 554103,
        "nazev": "Řídeč",
        "popis": "[554103] Řídeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 554103,
        "val": "[554103] Ridec 7110 [554103] Řídeč"
    },
    {
        "kod": 547077,
        "nazev": "Samotišky",
        "popis": "[547077] Samotišky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 547077,
        "val": "[547077] Samotisky 7107 [547077] Samotišky"
    },
    {
        "kod": 505081,
        "nazev": "Senice na Hané",
        "popis": "[505081] Senice na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 505081,
        "val": "[505081] Senice na Hane 7105 [505081] Senice na Hané"
    },
    {
        "kod": 552267,
        "nazev": "Senička",
        "popis": "[552267] Senička",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552267,
        "val": "[552267] Senicka 7105 [552267] Senička"
    },
    {
        "kod": 552151,
        "nazev": "Skrbeň",
        "popis": "[552151] Skrbeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552151,
        "val": "[552151] Skrben 7107 [552151] Skrbeň"
    },
    {
        "kod": 505111,
        "nazev": "Slatinice",
        "popis": "[505111] Slatinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505111,
        "val": "[505111] Slatinice 7107 [505111] Slatinice"
    },
    {
        "kod": 552194,
        "nazev": "Slavětín",
        "popis": "[552194] Slavětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 552194,
        "val": "[552194] Slavetin 7105 [552194] Slavětín"
    },
    {
        "kod": 569054,
        "nazev": "Strukov",
        "popis": "[569054] Strukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 569054,
        "val": "[569054] Strukov 7110 [569054] Strukov"
    },
    {
        "kod": 547018,
        "nazev": "Střeň",
        "popis": "[547018] Střeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 547018,
        "val": "[547018] Stren 7105 [547018] Střeň"
    },
    {
        "kod": 569771,
        "nazev": "Suchonice",
        "popis": "[569771] Suchonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 569771,
        "val": "[569771] Suchonice 7107 [569771] Suchonice"
    },
    {
        "kod": 552429,
        "nazev": "Svésedlice",
        "popis": "[552429] Svésedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552429,
        "val": "[552429] Svesedlice 7107 [552429] Svésedlice"
    },
    {
        "kod": 552011,
        "nazev": "Štarnov",
        "popis": "[552011] Štarnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 552011,
        "val": "[552011] Starnov 7110 [552011] Štarnov"
    },
    {
        "kod": 505161,
        "nazev": "Štěpánov",
        "popis": "[505161] Štěpánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505161,
        "val": "[505161] Stepanov 7107 [505161] Štěpánov"
    },
    {
        "kod": 505188,
        "nazev": "Šternberk",
        "popis": "[505188] Šternberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 505188,
        "val": "[505188] Sternberk 7110 [505188] Šternberk"
    },
    {
        "kod": 505218,
        "nazev": "Šumvald",
        "popis": "[505218] Šumvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 505218,
        "val": "[505218] Sumvald 7112 [505218] Šumvald"
    },
    {
        "kod": 505269,
        "nazev": "Těšetice",
        "popis": "[505269] Těšetice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505269,
        "val": "[505269] Tesetice 7107 [505269] Těšetice"
    },
    {
        "kod": 552089,
        "nazev": "Tovéř",
        "popis": "[552089] Tovéř",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552089,
        "val": "[552089] Tover 7107 [552089] Tovéř"
    },
    {
        "kod": 505293,
        "nazev": "Troubelice",
        "popis": "[505293] Troubelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 505293,
        "val": "[505293] Troubelice 7112 [505293] Troubelice"
    },
    {
        "kod": 505366,
        "nazev": "Tršice",
        "popis": "[505366] Tršice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505366,
        "val": "[505366] Trsice 7107 [505366] Tršice"
    },
    {
        "kod": 505501,
        "nazev": "Újezd",
        "popis": "[505501] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 505501,
        "val": "[505501] Ujezd 7112 [505501] Újezd"
    },
    {
        "kod": 505587,
        "nazev": "Uničov",
        "popis": "[505587] Uničov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 505587,
        "val": "[505587] Unicov 7112 [505587] Uničov"
    },
    {
        "kod": 552364,
        "nazev": "Ústín",
        "popis": "[552364] Ústín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552364,
        "val": "[552364] Ustin 7107 [552364] Ústín"
    },
    {
        "kod": 505609,
        "nazev": "Velká Bystřice",
        "popis": "[505609] Velká Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505609,
        "val": "[505609] Velka Bystrice 7107 [505609] Velká Bystřice"
    },
    {
        "kod": 505650,
        "nazev": "Velký Týnec",
        "popis": "[505650] Velký Týnec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505650,
        "val": "[505650] Velky Tynec 7107 [505650] Velký Týnec"
    },
    {
        "kod": 505668,
        "nazev": "Velký Újezd",
        "popis": "[505668] Velký Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 505668,
        "val": "[505668] Velky Ujezd 7107 [505668] Velký Újezd"
    },
    {
        "kod": 552119,
        "nazev": "Věrovany",
        "popis": "[552119] Věrovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7107,
        "iczuj": 552119,
        "val": "[552119] Verovany 7107 [552119] Věrovany"
    },
    {
        "kod": 568961,
        "nazev": "Vilémov",
        "popis": "[568961] Vilémov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7105,
        "iczuj": 568961,
        "val": "[568961] Vilemov 7105 [568961] Vilémov"
    },
    {
        "kod": 552399,
        "nazev": "Želechovice",
        "popis": "[552399] Želechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7112,
        "iczuj": 552399,
        "val": "[552399] Zelechovice 7112 [552399] Želechovice"
    },
    {
        "kod": 505862,
        "nazev": "Žerotín",
        "popis": "[505862] Žerotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7110,
        "iczuj": 505862,
        "val": "[505862] Zerotin 7110 [505862] Žerotín"
    },
    {
        "kod": 506761,
        "nazev": "Alojzov",
        "popis": "[506761] Alojzov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 506761,
        "val": "[506761] Alojzov 7108 [506761] Alojzov"
    },
    {
        "kod": 589268,
        "nazev": "Bedihošť",
        "popis": "[589268] Bedihošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589268,
        "val": "[589268] Bedihost 7108 [589268] Bedihošť"
    },
    {
        "kod": 589276,
        "nazev": "Bílovice-Lutotín",
        "popis": "[589276] Bílovice-Lutotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589276,
        "val": "[589276] Bilovice-Lutotin 7108 [589276] Bílovice-Lutotín"
    },
    {
        "kod": 589284,
        "nazev": "Biskupice",
        "popis": "[589284] Biskupice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589284,
        "val": "[589284] Biskupice 7108 [589284] Biskupice"
    },
    {
        "kod": 589292,
        "nazev": "Bohuslavice",
        "popis": "[589292] Bohuslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589292,
        "val": "[589292] Bohuslavice 7103 [589292] Bohuslavice"
    },
    {
        "kod": 589306,
        "nazev": "Bousín",
        "popis": "[589306] Bousín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589306,
        "val": "[589306] Bousin 7108 [589306] Bousín"
    },
    {
        "kod": 589314,
        "nazev": "Brodek u Konice",
        "popis": "[589314] Brodek u Konice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589314,
        "val": "[589314] Brodek u Konice 7103 [589314] Brodek u Konice"
    },
    {
        "kod": 589322,
        "nazev": "Brodek u Prostějova",
        "popis": "[589322] Brodek u Prostějova",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589322,
        "val": "[589322] Brodek u Prostejova 7108 [589322] Brodek u Prostějova"
    },
    {
        "kod": 589331,
        "nazev": "Březsko",
        "popis": "[589331] Březsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589331,
        "val": "[589331] Brezsko 7103 [589331] Březsko"
    },
    {
        "kod": 589349,
        "nazev": "Budětsko",
        "popis": "[589349] Budětsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589349,
        "val": "[589349] Budetsko 7103 [589349] Budětsko"
    },
    {
        "kod": 589357,
        "nazev": "Buková",
        "popis": "[589357] Buková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589357,
        "val": "[589357] Bukova 7108 [589357] Buková"
    },
    {
        "kod": 589365,
        "nazev": "Čehovice",
        "popis": "[589365] Čehovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589365,
        "val": "[589365] Cehovice 7108 [589365] Čehovice"
    },
    {
        "kod": 589381,
        "nazev": "Čechy pod Kosířem",
        "popis": "[589381] Čechy pod Kosířem",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589381,
        "val": "[589381] Cechy pod Kosirem 7108 [589381] Čechy pod Kosířem"
    },
    {
        "kod": 589390,
        "nazev": "Čelčice",
        "popis": "[589390] Čelčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589390,
        "val": "[589390] Celcice 7108 [589390] Čelčice"
    },
    {
        "kod": 589403,
        "nazev": "Čelechovice na Hané",
        "popis": "[589403] Čelechovice na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589403,
        "val": "[589403] Celechovice na Hane 7108 [589403] Čelechovice na Hané"
    },
    {
        "kod": 589420,
        "nazev": "Dětkovice",
        "popis": "[589420] Dětkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589420,
        "val": "[589420] Detkovice 7108 [589420] Dětkovice"
    },
    {
        "kod": 589438,
        "nazev": "Dobrochov",
        "popis": "[589438] Dobrochov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589438,
        "val": "[589438] Dobrochov 7108 [589438] Dobrochov"
    },
    {
        "kod": 589446,
        "nazev": "Dobromilice",
        "popis": "[589446] Dobromilice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589446,
        "val": "[589446] Dobromilice 7108 [589446] Dobromilice"
    },
    {
        "kod": 589454,
        "nazev": "Doloplazy",
        "popis": "[589454] Doloplazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589454,
        "val": "[589454] Doloplazy 7108 [589454] Doloplazy"
    },
    {
        "kod": 589462,
        "nazev": "Drahany",
        "popis": "[589462] Drahany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589462,
        "val": "[589462] Drahany 7108 [589462] Drahany"
    },
    {
        "kod": 558419,
        "nazev": "Držovice",
        "popis": "[558419] Držovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 558419,
        "val": "[558419] Drzovice 7108 [558419] Držovice"
    },
    {
        "kod": 589489,
        "nazev": "Dřevnovice",
        "popis": "[589489] Dřevnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589489,
        "val": "[589489] Drevnovice 7108 [589489] Dřevnovice"
    },
    {
        "kod": 589497,
        "nazev": "Dzbel",
        "popis": "[589497] Dzbel",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589497,
        "val": "[589497] Dzbel 7103 [589497] Dzbel"
    },
    {
        "kod": 549967,
        "nazev": "Hačky",
        "popis": "[549967] Hačky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 549967,
        "val": "[549967] Hacky 7103 [549967] Hačky"
    },
    {
        "kod": 589501,
        "nazev": "Hluchov",
        "popis": "[589501] Hluchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589501,
        "val": "[589501] Hluchov 7108 [589501] Hluchov"
    },
    {
        "kod": 589519,
        "nazev": "Horní Štěpánov",
        "popis": "[589519] Horní Štěpánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589519,
        "val": "[589519] Horni Stepanov 7103 [589519] Horní Štěpánov"
    },
    {
        "kod": 589527,
        "nazev": "Hradčany-Kobeřice",
        "popis": "[589527] Hradčany-Kobeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589527,
        "val": "[589527] Hradcany-Koberice 7108 [589527] Hradčany-Kobeřice"
    },
    {
        "kod": 589535,
        "nazev": "Hrdibořice",
        "popis": "[589535] Hrdibořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589535,
        "val": "[589535] Hrdiborice 7108 [589535] Hrdibořice"
    },
    {
        "kod": 589543,
        "nazev": "Hrubčice",
        "popis": "[589543] Hrubčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589543,
        "val": "[589543] Hrubcice 7108 [589543] Hrubčice"
    },
    {
        "kod": 543543,
        "nazev": "Hruška",
        "popis": "[543543] Hruška",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 543543,
        "val": "[543543] Hruska 7108 [543543] Hruška"
    },
    {
        "kod": 589560,
        "nazev": "Hvozd",
        "popis": "[589560] Hvozd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589560,
        "val": "[589560] Hvozd 7103 [589560] Hvozd"
    },
    {
        "kod": 589578,
        "nazev": "Ivaň",
        "popis": "[589578] Ivaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589578,
        "val": "[589578] Ivan 7108 [589578] Ivaň"
    },
    {
        "kod": 589586,
        "nazev": "Jesenec",
        "popis": "[589586] Jesenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589586,
        "val": "[589586] Jesenec 7103 [589586] Jesenec"
    },
    {
        "kod": 589594,
        "nazev": "Kladky",
        "popis": "[589594] Kladky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589594,
        "val": "[589594] Kladky 7103 [589594] Kladky"
    },
    {
        "kod": 589608,
        "nazev": "Klenovice na Hané",
        "popis": "[589608] Klenovice na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589608,
        "val": "[589608] Klenovice na Hane 7108 [589608] Klenovice na Hané"
    },
    {
        "kod": 589616,
        "nazev": "Klopotovice",
        "popis": "[589616] Klopotovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589616,
        "val": "[589616] Klopotovice 7108 [589616] Klopotovice"
    },
    {
        "kod": 589624,
        "nazev": "Konice",
        "popis": "[589624] Konice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589624,
        "val": "[589624] Konice 7103 [589624] Konice"
    },
    {
        "kod": 589632,
        "nazev": "Kostelec na Hané",
        "popis": "[589632] Kostelec na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589632,
        "val": "[589632] Kostelec na Hane 7108 [589632] Kostelec na Hané"
    },
    {
        "kod": 589641,
        "nazev": "Koválovice-Osíčany",
        "popis": "[589641] Koválovice-Osíčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589641,
        "val": "[589641] Kovalovice-Osicany 7108 [589641] Koválovice-Osíčany"
    },
    {
        "kod": 589659,
        "nazev": "Kralice na Hané",
        "popis": "[589659] Kralice na Hané",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589659,
        "val": "[589659] Kralice na Hane 7108 [589659] Kralice na Hané"
    },
    {
        "kod": 589667,
        "nazev": "Krumsín",
        "popis": "[589667] Krumsín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589667,
        "val": "[589667] Krumsin 7108 [589667] Krumsín"
    },
    {
        "kod": 589675,
        "nazev": "Laškov",
        "popis": "[589675] Laškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589675,
        "val": "[589675] Laskov 7108 [589675] Laškov"
    },
    {
        "kod": 589683,
        "nazev": "Lešany",
        "popis": "[589683] Lešany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589683,
        "val": "[589683] Lesany 7108 [589683] Lešany"
    },
    {
        "kod": 589691,
        "nazev": "Lipová",
        "popis": "[589691] Lipová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589691,
        "val": "[589691] Lipova 7103 [589691] Lipová"
    },
    {
        "kod": 589705,
        "nazev": "Ludmírov",
        "popis": "[589705] Ludmírov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589705,
        "val": "[589705] Ludmirov 7103 [589705] Ludmírov"
    },
    {
        "kod": 589713,
        "nazev": "Malé Hradisko",
        "popis": "[589713] Malé Hradisko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589713,
        "val": "[589713] Male Hradisko 7108 [589713] Malé Hradisko"
    },
    {
        "kod": 589721,
        "nazev": "Mořice",
        "popis": "[589721] Mořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589721,
        "val": "[589721] Morice 7108 [589721] Mořice"
    },
    {
        "kod": 589730,
        "nazev": "Mostkovice",
        "popis": "[589730] Mostkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589730,
        "val": "[589730] Mostkovice 7108 [589730] Mostkovice"
    },
    {
        "kod": 589748,
        "nazev": "Myslejovice",
        "popis": "[589748] Myslejovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589748,
        "val": "[589748] Myslejovice 7108 [589748] Myslejovice"
    },
    {
        "kod": 589756,
        "nazev": "Němčice nad Hanou",
        "popis": "[589756] Němčice nad Hanou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589756,
        "val": "[589756] Nemcice nad Hanou 7108 [589756] Němčice nad Hanou"
    },
    {
        "kod": 589764,
        "nazev": "Nezamyslice",
        "popis": "[589764] Nezamyslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589764,
        "val": "[589764] Nezamyslice 7108 [589764] Nezamyslice"
    },
    {
        "kod": 589772,
        "nazev": "Niva",
        "popis": "[589772] Niva",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589772,
        "val": "[589772] Niva 7108 [589772] Niva"
    },
    {
        "kod": 589799,
        "nazev": "Obědkovice",
        "popis": "[589799] Obědkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589799,
        "val": "[589799] Obedkovice 7108 [589799] Obědkovice"
    },
    {
        "kod": 589802,
        "nazev": "Ohrozim",
        "popis": "[589802] Ohrozim",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589802,
        "val": "[589802] Ohrozim 7108 [589802] Ohrozim"
    },
    {
        "kod": 589811,
        "nazev": "Ochoz",
        "popis": "[589811] Ochoz",
        "datum_od": "",
        "datum_do": "",
        "orp": 7103,
        "iczuj": 589811,
        "val": "[589811] Ochoz 7103 [589811] Ochoz"
    },
    {
        "kod": 589829,
        "nazev": "Olšany u Prostějova",
        "popis": "[589829] Olšany u Prostějova",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589829,
        "val": "[589829] Olsany u Prostejova 7108 [589829] Olšany u Prostějova"
    },
    {
        "kod": 589837,
        "nazev": "Ondratice",
        "popis": "[589837] Ondratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589837,
        "val": "[589837] Ondratice 7108 [589837] Ondratice"
    },
    {
        "kod": 589845,
        "nazev": "Otaslavice",
        "popis": "[589845] Otaslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589845,
        "val": "[589845] Otaslavice 7108 [589845] Otaslavice"
    },
    {
        "kod": 589853,
        "nazev": "Otinoves",
        "popis": "[589853] Otinoves",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589853,
        "val": "[589853] Otinoves 7108 [589853] Otinoves"
    },
    {
        "kod": 557196,
        "nazev": "Pavlovice u Kojetína",
        "popis": "[557196] Pavlovice u Kojetína",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 557196,
        "val": "[557196] Pavlovice u Kojetina 7108 [557196] Pavlovice u Kojetína"
    },
    {
        "kod": 589870,
        "nazev": "Pěnčín",
        "popis": "[589870] Pěnčín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589870,
        "val": "[589870] Pencin 7108 [589870] Pěnčín"
    },
    {
        "kod": 589888,
        "nazev": "Pivín",
        "popis": "[589888] Pivín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7108,
        "iczuj": 589888,
        "val": "[589888] Pivin 7108 [589888] Pivín"
    },
    {
        "kod": 591831,
        "nazev": "Tasov",
        "popis": "[591831] Tasov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6114,
        "iczuj": 591831,
        "val": "[591831] Tasov 6114 [591831] Tasov"
    },
    {
        "kod": 593222,
        "nazev": "Křižanovice",
        "popis": "[593222] Křižanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593222,
        "val": "[593222] Krizanovice 6205 [593222] Křižanovice"
    },
    {
        "kod": 593231,
        "nazev": "Křižanovice u Vyškova",
        "popis": "[593231] Křižanovice u Vyškova",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593231,
        "val": "[593231] Krizanovice u Vyskova 6219 [593231] Křižanovice u Vyškova"
    },
    {
        "kod": 593249,
        "nazev": "Kučerov",
        "popis": "[593249] Kučerov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593249,
        "val": "[593249] Kucerov 6219 [593249] Kučerov"
    },
    {
        "kod": 593257,
        "nazev": "Letonice",
        "popis": "[593257] Letonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593257,
        "val": "[593257] Letonice 6205 [593257] Letonice"
    },
    {
        "kod": 593265,
        "nazev": "Lovčičky",
        "popis": "[593265] Lovčičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593265,
        "val": "[593265] Lovcicky 6215 [593265] Lovčičky"
    },
    {
        "kod": 593273,
        "nazev": "Luleč",
        "popis": "[593273] Luleč",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593273,
        "val": "[593273] Lulec 6219 [593273] Luleč"
    },
    {
        "kod": 593281,
        "nazev": "Lysovice",
        "popis": "[593281] Lysovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593281,
        "val": "[593281] Lysovice 6219 [593281] Lysovice"
    },
    {
        "kod": 593290,
        "nazev": "Malínky",
        "popis": "[593290] Malínky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593290,
        "val": "[593290] Malinky 6205 [593290] Malínky"
    },
    {
        "kod": 550141,
        "nazev": "Medlovice",
        "popis": "[550141] Medlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 550141,
        "val": "[550141] Medlovice 6219 [550141] Medlovice"
    },
    {
        "kod": 593320,
        "nazev": "Milešovice",
        "popis": "[593320] Milešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593320,
        "val": "[593320] Milesovice 6215 [593320] Milešovice"
    },
    {
        "kod": 593338,
        "nazev": "Milonice",
        "popis": "[593338] Milonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593338,
        "val": "[593338] Milonice 6205 [593338] Milonice"
    },
    {
        "kod": 593346,
        "nazev": "Moravské Málkovice",
        "popis": "[593346] Moravské Málkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593346,
        "val": "[593346] Moravske Malkovice 6219 [593346] Moravské Málkovice"
    },
    {
        "kod": 557048,
        "nazev": "Mouřínov",
        "popis": "[557048] Mouřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 557048,
        "val": "[557048] Mourinov 6205 [557048] Mouřínov"
    },
    {
        "kod": 593371,
        "nazev": "Němčany",
        "popis": "[593371] Němčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593371,
        "val": "[593371] Nemcany 6215 [593371] Němčany"
    },
    {
        "kod": 593389,
        "nazev": "Nemochovice",
        "popis": "[593389] Nemochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593389,
        "val": "[593389] Nemochovice 6205 [593389] Nemochovice"
    },
    {
        "kod": 593397,
        "nazev": "Nemojany",
        "popis": "[593397] Nemojany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593397,
        "val": "[593397] Nemojany 6219 [593397] Nemojany"
    },
    {
        "kod": 593401,
        "nazev": "Nemotice",
        "popis": "[593401] Nemotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593401,
        "val": "[593401] Nemotice 6205 [593401] Nemotice"
    },
    {
        "kod": 593419,
        "nazev": "Nesovice",
        "popis": "[593419] Nesovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593419,
        "val": "[593419] Nesovice 6205 [593419] Nesovice"
    },
    {
        "kod": 593427,
        "nazev": "Nevojice",
        "popis": "[593427] Nevojice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593427,
        "val": "[593427] Nevojice 6205 [593427] Nevojice"
    },
    {
        "kod": 593435,
        "nazev": "Nížkovice",
        "popis": "[593435] Nížkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593435,
        "val": "[593435] Nizkovice 6215 [593435] Nížkovice"
    },
    {
        "kod": 593443,
        "nazev": "Nové Sady",
        "popis": "[593443] Nové Sady",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593443,
        "val": "[593443] Nove Sady 6219 [593443] Nové Sady"
    },
    {
        "kod": 550132,
        "nazev": "Olšany",
        "popis": "[550132] Olšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 550132,
        "val": "[550132] Olsany 6219 [550132] Olšany"
    },
    {
        "kod": 593460,
        "nazev": "Orlovice",
        "popis": "[593460] Orlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593460,
        "val": "[593460] Orlovice 6219 [593460] Orlovice"
    },
    {
        "kod": 593478,
        "nazev": "Otnice",
        "popis": "[593478] Otnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593478,
        "val": "[593478] Otnice 6215 [593478] Otnice"
    },
    {
        "kod": 550795,
        "nazev": "Podbřežice",
        "popis": "[550795] Podbřežice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 550795,
        "val": "[550795] Podbrezice 6219 [550795] Podbřežice"
    },
    {
        "kod": 593486,
        "nazev": "Podivice",
        "popis": "[593486] Podivice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593486,
        "val": "[593486] Podivice 6219 [593486] Podivice"
    },
    {
        "kod": 550175,
        "nazev": "Podomí",
        "popis": "[550175] Podomí",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 550175,
        "val": "[550175] Podomi 6219 [550175] Podomí"
    },
    {
        "kod": 593494,
        "nazev": "Prusy-Boškůvky",
        "popis": "[593494] Prusy-Boškůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593494,
        "val": "[593494] Prusy-Boskuvky 6219 [593494] Prusy-Boškůvky"
    },
    {
        "kod": 593508,
        "nazev": "Pustiměř",
        "popis": "[593508] Pustiměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593508,
        "val": "[593508] Pustimer 6219 [593508] Pustiměř"
    },
    {
        "kod": 593516,
        "nazev": "Račice-Pístovice",
        "popis": "[593516] Račice-Pístovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593516,
        "val": "[593516] Racice-Pistovice 6219 [593516] Račice-Pístovice"
    },
    {
        "kod": 593524,
        "nazev": "Radslavice",
        "popis": "[593524] Radslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593524,
        "val": "[593524] Radslavice 6219 [593524] Radslavice"
    },
    {
        "kod": 593532,
        "nazev": "Rašovice",
        "popis": "[593532] Rašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593532,
        "val": "[593532] Rasovice 6205 [593532] Rašovice"
    },
    {
        "kod": 554898,
        "nazev": "Rostěnice-Zvonovice",
        "popis": "[554898] Rostěnice-Zvonovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 554898,
        "val": "[554898] Rostenice-Zvonovice 6219 [554898] Rostěnice-Zvonovice"
    },
    {
        "kod": 593559,
        "nazev": "Rousínov",
        "popis": "[593559] Rousínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593559,
        "val": "[593559] Rousinov 6219 [593559] Rousínov"
    },
    {
        "kod": 593567,
        "nazev": "Ruprechtov",
        "popis": "[593567] Ruprechtov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593567,
        "val": "[593567] Ruprechtov 6219 [593567] Ruprechtov"
    },
    {
        "kod": 553972,
        "nazev": "Rybníček",
        "popis": "[553972] Rybníček",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 553972,
        "val": "[553972] Rybnicek 6219 [553972] Rybníček"
    },
    {
        "kod": 593583,
        "nazev": "Slavkov u Brna",
        "popis": "[593583] Slavkov u Brna",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593583,
        "val": "[593583] Slavkov u Brna 6215 [593583] Slavkov u Brna"
    },
    {
        "kod": 593591,
        "nazev": "Snovídky",
        "popis": "[593591] Snovídky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 593591,
        "val": "[593591] Snovidky 6205 [593591] Snovídky"
    },
    {
        "kod": 593605,
        "nazev": "Studnice",
        "popis": "[593605] Studnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593605,
        "val": "[593605] Studnice 6219 [593605] Studnice"
    },
    {
        "kod": 593613,
        "nazev": "Šaratice",
        "popis": "[593613] Šaratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593613,
        "val": "[593613] Saratice 6215 [593613] Šaratice"
    },
    {
        "kod": 593621,
        "nazev": "Švábenice",
        "popis": "[593621] Švábenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593621,
        "val": "[593621] Svabenice 6219 [593621] Švábenice"
    },
    {
        "kod": 593630,
        "nazev": "Topolany",
        "popis": "[593630] Topolany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593630,
        "val": "[593630] Topolany 6219 [593630] Topolany"
    },
    {
        "kod": 593648,
        "nazev": "Tučapy",
        "popis": "[593648] Tučapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593648,
        "val": "[593648] Tucapy 6219 [593648] Tučapy"
    },
    {
        "kod": 550191,
        "nazev": "Uhřice",
        "popis": "[550191] Uhřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6205,
        "iczuj": 550191,
        "val": "[550191] Uhrice 6205 [550191] Uhřice"
    },
    {
        "kod": 593656,
        "nazev": "Vážany",
        "popis": "[593656] Vážany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593656,
        "val": "[593656] Vazany 6219 [593656] Vážany"
    },
    {
        "kod": 593664,
        "nazev": "Vážany nad Litavou",
        "popis": "[593664] Vážany nad Litavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593664,
        "val": "[593664] Vazany nad Litavou 6215 [593664] Vážany nad Litavou"
    },
    {
        "kod": 593681,
        "nazev": "Velešovice",
        "popis": "[593681] Velešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593681,
        "val": "[593681] Velesovice 6215 [593681] Velešovice"
    },
    {
        "kod": 592889,
        "nazev": "Vyškov",
        "popis": "[592889] Vyškov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 592889,
        "val": "[592889] Vyskov 6219 [592889] Vyškov"
    },
    {
        "kod": 593699,
        "nazev": "Zbýšov",
        "popis": "[593699] Zbýšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6215,
        "iczuj": 593699,
        "val": "[593699] Zbysov 6215 [593699] Zbýšov"
    },
    {
        "kod": 593702,
        "nazev": "Zelená Hora",
        "popis": "[593702] Zelená Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 6219,
        "iczuj": 593702,
        "val": "[593702] Zelena Hora 6219 [593702] Zelená Hora"
    },
    {
        "kod": 593729,
        "nazev": "Bantice",
        "popis": "[593729] Bantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593729,
        "val": "[593729] Bantice 6220 [593729] Bantice"
    },
    {
        "kod": 593737,
        "nazev": "Běhařovice",
        "popis": "[593737] Běhařovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593737,
        "val": "[593737] Beharovice 6220 [593737] Běhařovice"
    },
    {
        "kod": 593745,
        "nazev": "Bezkov",
        "popis": "[593745] Bezkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593745,
        "val": "[593745] Bezkov 6220 [593745] Bezkov"
    },
    {
        "kod": 593753,
        "nazev": "Bítov",
        "popis": "[593753] Bítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593753,
        "val": "[593753] Bitov 6220 [593753] Bítov"
    },
    {
        "kod": 593761,
        "nazev": "Blanné",
        "popis": "[593761] Blanné",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593761,
        "val": "[593761] Blanne 6220 [593761] Blanné"
    },
    {
        "kod": 593770,
        "nazev": "Blížkovice",
        "popis": "[593770] Blížkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593770,
        "val": "[593770] Blizkovice 6220 [593770] Blížkovice"
    },
    {
        "kod": 593788,
        "nazev": "Bohutice",
        "popis": "[593788] Bohutice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593788,
        "val": "[593788] Bohutice 6212 [593788] Bohutice"
    },
    {
        "kod": 593796,
        "nazev": "Bojanovice",
        "popis": "[593796] Bojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593796,
        "val": "[593796] Bojanovice 6220 [593796] Bojanovice"
    },
    {
        "kod": 593800,
        "nazev": "Borotice",
        "popis": "[593800] Borotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593800,
        "val": "[593800] Borotice 6220 [593800] Borotice"
    },
    {
        "kod": 593818,
        "nazev": "Boskovštejn",
        "popis": "[593818] Boskovštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593818,
        "val": "[593818] Boskovstejn 6220 [593818] Boskovštejn"
    },
    {
        "kod": 593826,
        "nazev": "Božice",
        "popis": "[593826] Božice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593826,
        "val": "[593826] Bozice 6220 [593826] Božice"
    },
    {
        "kod": 593842,
        "nazev": "Břežany",
        "popis": "[593842] Břežany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593842,
        "val": "[593842] Brezany 6220 [593842] Břežany"
    },
    {
        "kod": 593851,
        "nazev": "Citonice",
        "popis": "[593851] Citonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593851,
        "val": "[593851] Citonice 6220 [593851] Citonice"
    },
    {
        "kod": 593869,
        "nazev": "Ctidružice",
        "popis": "[593869] Ctidružice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593869,
        "val": "[593869] Ctidruzice 6220 [593869] Ctidružice"
    },
    {
        "kod": 593877,
        "nazev": "Čejkovice",
        "popis": "[593877] Čejkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593877,
        "val": "[593877] Cejkovice 6220 [593877] Čejkovice"
    },
    {
        "kod": 593885,
        "nazev": "Čermákovice",
        "popis": "[593885] Čermákovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593885,
        "val": "[593885] Cermakovice 6212 [593885] Čermákovice"
    },
    {
        "kod": 593893,
        "nazev": "Černín",
        "popis": "[593893] Černín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593893,
        "val": "[593893] Cernin 6220 [593893] Černín"
    },
    {
        "kod": 593907,
        "nazev": "Damnice",
        "popis": "[593907] Damnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593907,
        "val": "[593907] Damnice 6212 [593907] Damnice"
    },
    {
        "kod": 593923,
        "nazev": "Dobelice",
        "popis": "[593923] Dobelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593923,
        "val": "[593923] Dobelice 6212 [593923] Dobelice"
    },
    {
        "kod": 593931,
        "nazev": "Dobřínsko",
        "popis": "[593931] Dobřínsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593931,
        "val": "[593931] Dobrinsko 6212 [593931] Dobřínsko"
    },
    {
        "kod": 546941,
        "nazev": "Dobšice",
        "popis": "[546941] Dobšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 546941,
        "val": "[546941] Dobsice 6220 [546941] Dobšice"
    },
    {
        "kod": 593958,
        "nazev": "Dolenice",
        "popis": "[593958] Dolenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593958,
        "val": "[593958] Dolenice 6212 [593958] Dolenice"
    },
    {
        "kod": 593966,
        "nazev": "Dolní Dubňany",
        "popis": "[593966] Dolní Dubňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 593966,
        "val": "[593966] Dolni Dubnany 6212 [593966] Dolní Dubňany"
    },
    {
        "kod": 593974,
        "nazev": "Dyjákovice",
        "popis": "[593974] Dyjákovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593974,
        "val": "[593974] Dyjakovice 6220 [593974] Dyjákovice"
    },
    {
        "kod": 593982,
        "nazev": "Dyjákovičky",
        "popis": "[593982] Dyjákovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593982,
        "val": "[593982] Dyjakovicky 6220 [593982] Dyjákovičky"
    },
    {
        "kod": 593991,
        "nazev": "Dyje",
        "popis": "[593991] Dyje",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 593991,
        "val": "[593991] Dyje 6220 [593991] Dyje"
    },
    {
        "kod": 594008,
        "nazev": "Džbánice",
        "popis": "[594008] Džbánice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594008,
        "val": "[594008] Dzbanice 6212 [594008] Džbánice"
    },
    {
        "kod": 594016,
        "nazev": "Grešlové Mýto",
        "popis": "[594016] Grešlové Mýto",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594016,
        "val": "[594016] Greslove Myto 6220 [594016] Grešlové Mýto"
    },
    {
        "kod": 594024,
        "nazev": "Havraníky",
        "popis": "[594024] Havraníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594024,
        "val": "[594024] Havraniky 6220 [594024] Havraníky"
    },
    {
        "kod": 594032,
        "nazev": "Hevlín",
        "popis": "[594032] Hevlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594032,
        "val": "[594032] Hevlin 6220 [594032] Hevlín"
    },
    {
        "kod": 594041,
        "nazev": "Hluboké Mašůvky",
        "popis": "[594041] Hluboké Mašůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594041,
        "val": "[594041] Hluboke Masuvky 6220 [594041] Hluboké Mašůvky"
    },
    {
        "kod": 594059,
        "nazev": "Hnanice",
        "popis": "[594059] Hnanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594059,
        "val": "[594059] Hnanice 6220 [594059] Hnanice"
    },
    {
        "kod": 594067,
        "nazev": "Hodonice",
        "popis": "[594067] Hodonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594067,
        "val": "[594067] Hodonice 6220 [594067] Hodonice"
    },
    {
        "kod": 594075,
        "nazev": "Horní Břečkov",
        "popis": "[594075] Horní Břečkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594075,
        "val": "[594075] Horni Breckov 6220 [594075] Horní Břečkov"
    },
    {
        "kod": 594083,
        "nazev": "Horní Dubňany",
        "popis": "[594083] Horní Dubňany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594083,
        "val": "[594083] Horni Dubnany 6212 [594083] Horní Dubňany"
    },
    {
        "kod": 594091,
        "nazev": "Horní Dunajovice",
        "popis": "[594091] Horní Dunajovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594091,
        "val": "[594091] Horni Dunajovice 6220 [594091] Horní Dunajovice"
    },
    {
        "kod": 594105,
        "nazev": "Horní Kounice",
        "popis": "[594105] Horní Kounice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594105,
        "val": "[594105] Horni Kounice 6212 [594105] Horní Kounice"
    },
    {
        "kod": 594113,
        "nazev": "Hostěradice",
        "popis": "[594113] Hostěradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594113,
        "val": "[594113] Hosteradice 6212 [594113] Hostěradice"
    },
    {
        "kod": 594121,
        "nazev": "Hostim",
        "popis": "[594121] Hostim",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594121,
        "val": "[594121] Hostim 6220 [594121] Hostim"
    },
    {
        "kod": 594130,
        "nazev": "Hrabětice",
        "popis": "[594130] Hrabětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594130,
        "val": "[594130] Hrabetice 6220 [594130] Hrabětice"
    },
    {
        "kod": 594148,
        "nazev": "Hrádek",
        "popis": "[594148] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594148,
        "val": "[594148] Hradek 6220 [594148] Hrádek"
    },
    {
        "kod": 594156,
        "nazev": "Hrušovany nad Jevišovkou",
        "popis": "[594156] Hrušovany nad Jevišovkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594156,
        "val": "[594156] Hrusovany nad Jevisovkou 6220 [594156] Hrušovany nad Jevišovkou"
    },
    {
        "kod": 594164,
        "nazev": "Chvalatice",
        "popis": "[594164] Chvalatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594164,
        "val": "[594164] Chvalatice 6220 [594164] Chvalatice"
    },
    {
        "kod": 594172,
        "nazev": "Chvalovice",
        "popis": "[594172] Chvalovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594172,
        "val": "[594172] Chvalovice 6220 [594172] Chvalovice"
    },
    {
        "kod": 594181,
        "nazev": "Jamolice",
        "popis": "[594181] Jamolice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594181,
        "val": "[594181] Jamolice 6212 [594181] Jamolice"
    },
    {
        "kod": 594199,
        "nazev": "Jaroslavice",
        "popis": "[594199] Jaroslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594199,
        "val": "[594199] Jaroslavice 6220 [594199] Jaroslavice"
    },
    {
        "kod": 594202,
        "nazev": "Jevišovice",
        "popis": "[594202] Jevišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594202,
        "val": "[594202] Jevisovice 6220 [594202] Jevišovice"
    },
    {
        "kod": 594211,
        "nazev": "Jezeřany-Maršovice",
        "popis": "[594211] Jezeřany-Maršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594211,
        "val": "[594211] Jezerany-Marsovice 6212 [594211] Jezeřany-Maršovice"
    },
    {
        "kod": 594229,
        "nazev": "Jiřice u Miroslavi",
        "popis": "[594229] Jiřice u Miroslavi",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594229,
        "val": "[594229] Jirice u Miroslavi 6212 [594229] Jiřice u Miroslavi"
    },
    {
        "kod": 550841,
        "nazev": "Jiřice u Moravských Budějovic",
        "popis": "[550841] Jiřice u Moravských Budějovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 550841,
        "val": "[550841] Jirice u Moravskych Budejovic 6220 [550841] Jiřice u Moravských Budějovic"
    },
    {
        "kod": 594237,
        "nazev": "Kadov",
        "popis": "[594237] Kadov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594237,
        "val": "[594237] Kadov 6212 [594237] Kadov"
    },
    {
        "kod": 594253,
        "nazev": "Korolupy",
        "popis": "[594253] Korolupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594253,
        "val": "[594253] Korolupy 6220 [594253] Korolupy"
    },
    {
        "kod": 594261,
        "nazev": "Kravsko",
        "popis": "[594261] Kravsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594261,
        "val": "[594261] Kravsko 6220 [594261] Kravsko"
    },
    {
        "kod": 594270,
        "nazev": "Krhovice",
        "popis": "[594270] Krhovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594270,
        "val": "[594270] Krhovice 6220 [594270] Krhovice"
    },
    {
        "kod": 594288,
        "nazev": "Křepice",
        "popis": "[594288] Křepice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594288,
        "val": "[594288] Krepice 6220 [594288] Křepice"
    },
    {
        "kod": 550086,
        "nazev": "Křídlůvky",
        "popis": "[550086] Křídlůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 550086,
        "val": "[550086] Kridluvky 6220 [550086] Křídlůvky"
    },
    {
        "kod": 594296,
        "nazev": "Kubšice",
        "popis": "[594296] Kubšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594296,
        "val": "[594296] Kubsice 6212 [594296] Kubšice"
    },
    {
        "kod": 594300,
        "nazev": "Kuchařovice",
        "popis": "[594300] Kuchařovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594300,
        "val": "[594300] Kucharovice 6220 [594300] Kuchařovice"
    },
    {
        "kod": 594318,
        "nazev": "Kyjovice",
        "popis": "[594318] Kyjovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594318,
        "val": "[594318] Kyjovice 6220 [594318] Kyjovice"
    },
    {
        "kod": 594326,
        "nazev": "Lančov",
        "popis": "[594326] Lančov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594326,
        "val": "[594326] Lancov 6220 [594326] Lančov"
    },
    {
        "kod": 594334,
        "nazev": "Lechovice",
        "popis": "[594334] Lechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594334,
        "val": "[594334] Lechovice 6220 [594334] Lechovice"
    },
    {
        "kod": 594342,
        "nazev": "Lesná",
        "popis": "[594342] Lesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594342,
        "val": "[594342] Lesna 6220 [594342] Lesná"
    },
    {
        "kod": 594351,
        "nazev": "Lesonice",
        "popis": "[594351] Lesonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594351,
        "val": "[594351] Lesonice 6212 [594351] Lesonice"
    },
    {
        "kod": 594369,
        "nazev": "Litobratřice",
        "popis": "[594369] Litobratřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594369,
        "val": "[594369] Litobratrice 6220 [594369] Litobratřice"
    },
    {
        "kod": 594385,
        "nazev": "Lubnice",
        "popis": "[594385] Lubnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594385,
        "val": "[594385] Lubnice 6220 [594385] Lubnice"
    },
    {
        "kod": 594393,
        "nazev": "Lukov",
        "popis": "[594393] Lukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594393,
        "val": "[594393] Lukov 6220 [594393] Lukov"
    },
    {
        "kod": 594407,
        "nazev": "Mackovice",
        "popis": "[594407] Mackovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594407,
        "val": "[594407] Mackovice 6220 [594407] Mackovice"
    },
    {
        "kod": 594415,
        "nazev": "Mašovice",
        "popis": "[594415] Mašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594415,
        "val": "[594415] Masovice 6220 [594415] Mašovice"
    },
    {
        "kod": 594423,
        "nazev": "Medlice",
        "popis": "[594423] Medlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594423,
        "val": "[594423] Medlice 6220 [594423] Medlice"
    },
    {
        "kod": 594431,
        "nazev": "Mikulovice",
        "popis": "[594431] Mikulovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594431,
        "val": "[594431] Mikulovice 6220 [594431] Mikulovice"
    },
    {
        "kod": 594440,
        "nazev": "Milíčovice",
        "popis": "[594440] Milíčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594440,
        "val": "[594440] Milicovice 6220 [594440] Milíčovice"
    },
    {
        "kod": 594458,
        "nazev": "Miroslav",
        "popis": "[594458] Miroslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594458,
        "val": "[594458] Miroslav 6212 [594458] Miroslav"
    },
    {
        "kod": 594466,
        "nazev": "Miroslavské Knínice",
        "popis": "[594466] Miroslavské Knínice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594466,
        "val": "[594466] Miroslavske Kninice 6212 [594466] Miroslavské Knínice"
    },
    {
        "kod": 594474,
        "nazev": "Morašice",
        "popis": "[594474] Morašice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6220,
        "iczuj": 594474,
        "val": "[594474] Morasice 6220 [594474] Morašice"
    },
    {
        "kod": 594482,
        "nazev": "Moravský Krumlov",
        "popis": "[594482] Moravský Krumlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6212,
        "iczuj": 594482,
        "val": "[594482] Moravsky Krumlov 6212 [594482] Moravský Krumlov"
    },
    {
        "kod": 540226,
        "nazev": "Loučná nad Desnou",
        "popis": "[540226] Loučná nad Desnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540226,
        "val": "[540226] Loucna nad Desnou 7111 [540226] Loučná nad Desnou"
    },
    {
        "kod": 540234,
        "nazev": "Lukavice",
        "popis": "[540234] Lukavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 540234,
        "val": "[540234] Lukavice 7113 [540234] Lukavice"
    },
    {
        "kod": 540331,
        "nazev": "Malá Morava",
        "popis": "[540331] Malá Morava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540331,
        "val": "[540331] Mala Morava 7111 [540331] Malá Morava"
    },
    {
        "kod": 540366,
        "nazev": "Maletín",
        "popis": "[540366] Maletín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540366,
        "val": "[540366] Maletin 7106 [540366] Maletín"
    },
    {
        "kod": 569381,
        "nazev": "Mírov",
        "popis": "[569381] Mírov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 569381,
        "val": "[569381] Mirov 7106 [569381] Mírov"
    },
    {
        "kod": 540471,
        "nazev": "Mohelnice",
        "popis": "[540471] Mohelnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540471,
        "val": "[540471] Mohelnice 7106 [540471] Mohelnice"
    },
    {
        "kod": 540480,
        "nazev": "Moravičany",
        "popis": "[540480] Moravičany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540480,
        "val": "[540480] Moravicany 7106 [540480] Moravičany"
    },
    {
        "kod": 553476,
        "nazev": "Nemile",
        "popis": "[553476] Nemile",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 553476,
        "val": "[553476] Nemile 7113 [553476] Nemile"
    },
    {
        "kod": 540501,
        "nazev": "Nový Malín",
        "popis": "[540501] Nový Malín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540501,
        "val": "[540501] Novy Malin 7111 [540501] Nový Malín"
    },
    {
        "kod": 540510,
        "nazev": "Olšany",
        "popis": "[540510] Olšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540510,
        "val": "[540510] Olsany 7111 [540510] Olšany"
    },
    {
        "kod": 540544,
        "nazev": "Oskava",
        "popis": "[540544] Oskava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540544,
        "val": "[540544] Oskava 7111 [540544] Oskava"
    },
    {
        "kod": 540595,
        "nazev": "Palonín",
        "popis": "[540595] Palonín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540595,
        "val": "[540595] Palonin 7106 [540595] Palonín"
    },
    {
        "kod": 540609,
        "nazev": "Pavlov",
        "popis": "[540609] Pavlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540609,
        "val": "[540609] Pavlov 7106 [540609] Pavlov"
    },
    {
        "kod": 500020,
        "nazev": "Petrov nad Desnou",
        "popis": "[500020] Petrov nad Desnou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 500020,
        "val": "[500020] Petrov nad Desnou 7111 [500020] Petrov nad Desnou"
    },
    {
        "kod": 540650,
        "nazev": "Písařov",
        "popis": "[540650] Písařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540650,
        "val": "[540650] Pisarov 7111 [540650] Písařov"
    },
    {
        "kod": 540731,
        "nazev": "Police",
        "popis": "[540731] Police",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540731,
        "val": "[540731] Police 7106 [540731] Police"
    },
    {
        "kod": 540773,
        "nazev": "Postřelmov",
        "popis": "[540773] Postřelmov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 540773,
        "val": "[540773] Postrelmov 7113 [540773] Postřelmov"
    },
    {
        "kod": 553352,
        "nazev": "Postřelmůvek",
        "popis": "[553352] Postřelmůvek",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 553352,
        "val": "[553352] Postrelmuvek 7113 [553352] Postřelmůvek"
    },
    {
        "kod": 540854,
        "nazev": "Rájec",
        "popis": "[540854] Rájec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 540854,
        "val": "[540854] Rajec 7113 [540854] Rájec"
    },
    {
        "kod": 540862,
        "nazev": "Rapotín",
        "popis": "[540862] Rapotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540862,
        "val": "[540862] Rapotin 7111 [540862] Rapotín"
    },
    {
        "kod": 553395,
        "nazev": "Rejchartice",
        "popis": "[553395] Rejchartice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553395,
        "val": "[553395] Rejchartice 7111 [553395] Rejchartice"
    },
    {
        "kod": 540871,
        "nazev": "Rohle",
        "popis": "[540871] Rohle",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 540871,
        "val": "[540871] Rohle 7113 [540871] Rohle"
    },
    {
        "kod": 540919,
        "nazev": "Rovensko",
        "popis": "[540919] Rovensko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 540919,
        "val": "[540919] Rovensko 7113 [540919] Rovensko"
    },
    {
        "kod": 540978,
        "nazev": "Ruda nad Moravou",
        "popis": "[540978] Ruda nad Moravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540978,
        "val": "[540978] Ruda nad Moravou 7111 [540978] Ruda nad Moravou"
    },
    {
        "kod": 540986,
        "nazev": "Sobotín",
        "popis": "[540986] Sobotín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 540986,
        "val": "[540986] Sobotin 7111 [540986] Sobotín"
    },
    {
        "kod": 541079,
        "nazev": "Staré Město",
        "popis": "[541079] Staré Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 541079,
        "val": "[541079] Stare Mesto 7111 [541079] Staré Město"
    },
    {
        "kod": 570281,
        "nazev": "Stavenice",
        "popis": "[570281] Stavenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 570281,
        "val": "[570281] Stavenice 7106 [570281] Stavenice"
    },
    {
        "kod": 541109,
        "nazev": "Sudkov",
        "popis": "[541109] Sudkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 541109,
        "val": "[541109] Sudkov 7111 [541109] Sudkov"
    },
    {
        "kod": 541125,
        "nazev": "Svébohov",
        "popis": "[541125] Svébohov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 541125,
        "val": "[541125] Svebohov 7113 [541125] Svébohov"
    },
    {
        "kod": 570117,
        "nazev": "Šléglov",
        "popis": "[570117] Šléglov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 570117,
        "val": "[570117] Sleglov 7111 [570117] Šléglov"
    },
    {
        "kod": 541168,
        "nazev": "Štíty",
        "popis": "[541168] Štíty",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 541168,
        "val": "[541168] Stity 7113 [541168] Štíty"
    },
    {
        "kod": 523704,
        "nazev": "Šumperk",
        "popis": "[523704] Šumperk",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 523704,
        "val": "[523704] Sumperk 7111 [523704] Šumperk"
    },
    {
        "kod": 553336,
        "nazev": "Třeština",
        "popis": "[553336] Třeština",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 553336,
        "val": "[553336] Trestina 7106 [553336] Třeština"
    },
    {
        "kod": 541222,
        "nazev": "Úsov",
        "popis": "[541222] Úsov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 541222,
        "val": "[541222] Usov 7106 [541222] Úsov"
    },
    {
        "kod": 541265,
        "nazev": "Velké Losiny",
        "popis": "[541265] Velké Losiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 541265,
        "val": "[541265] Velke Losiny 7111 [541265] Velké Losiny"
    },
    {
        "kod": 554146,
        "nazev": "Vernířovice",
        "popis": "[554146] Vernířovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 554146,
        "val": "[554146] Vernirovice 7111 [554146] Vernířovice"
    },
    {
        "kod": 553191,
        "nazev": "Vikantice",
        "popis": "[553191] Vikantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553191,
        "val": "[553191] Vikantice 7111 [553191] Vikantice"
    },
    {
        "kod": 569445,
        "nazev": "Vikýřovice",
        "popis": "[569445] Vikýřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 569445,
        "val": "[569445] Vikyrovice 7111 [569445] Vikýřovice"
    },
    {
        "kod": 570095,
        "nazev": "Vyšehoří",
        "popis": "[570095] Vyšehoří",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 570095,
        "val": "[570095] Vysehori 7113 [570095] Vyšehoří"
    },
    {
        "kod": 541354,
        "nazev": "Zábřeh",
        "popis": "[541354] Zábřeh",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 541354,
        "val": "[541354] Zabreh 7113 [541354] Zábřeh"
    },
    {
        "kod": 570338,
        "nazev": "Zborov",
        "popis": "[570338] Zborov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 570338,
        "val": "[570338] Zborov 7113 [570338] Zborov"
    },
    {
        "kod": 541478,
        "nazev": "Zvole",
        "popis": "[541478] Zvole",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 541478,
        "val": "[541478] Zvole 7113 [541478] Zvole"
    },
    {
        "kod": 588300,
        "nazev": "Bařice-Velké Těšany",
        "popis": "[588300] Bařice-Velké Těšany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588300,
        "val": "[588300] Barice-Velke Tesany 7203 [588300] Bařice-Velké Těšany"
    },
    {
        "kod": 588326,
        "nazev": "Bezměrov",
        "popis": "[588326] Bezměrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588326,
        "val": "[588326] Bezmerov 7203 [588326] Bezměrov"
    },
    {
        "kod": 542318,
        "nazev": "Blazice",
        "popis": "[542318] Blazice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 542318,
        "val": "[542318] Blazice 7201 [542318] Blazice"
    },
    {
        "kod": 549690,
        "nazev": "Bořenovice",
        "popis": "[549690] Bořenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 549690,
        "val": "[549690] Borenovice 7202 [549690] Bořenovice"
    },
    {
        "kod": 588377,
        "nazev": "Brusné",
        "popis": "[588377] Brusné",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588377,
        "val": "[588377] Brusne 7201 [588377] Brusné"
    },
    {
        "kod": 588385,
        "nazev": "Břest",
        "popis": "[588385] Břest",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588385,
        "val": "[588385] Brest 7203 [588385] Břest"
    },
    {
        "kod": 588393,
        "nazev": "Bystřice pod Hostýnem",
        "popis": "[588393] Bystřice pod Hostýnem",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588393,
        "val": "[588393] Bystrice pod Hostynem 7201 [588393] Bystřice pod Hostýnem"
    },
    {
        "kod": 588407,
        "nazev": "Cetechovice",
        "popis": "[588407] Cetechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588407,
        "val": "[588407] Cetechovice 7203 [588407] Cetechovice"
    },
    {
        "kod": 588431,
        "nazev": "Dřínov",
        "popis": "[588431] Dřínov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588431,
        "val": "[588431] Drinov 7203 [588431] Dřínov"
    },
    {
        "kod": 588458,
        "nazev": "Holešov",
        "popis": "[588458] Holešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588458,
        "val": "[588458] Holesov 7202 [588458] Holešov"
    },
    {
        "kod": 542342,
        "nazev": "Honětice",
        "popis": "[542342] Honětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 542342,
        "val": "[542342] Honetice 7203 [542342] Honětice"
    },
    {
        "kod": 588474,
        "nazev": "Horní Lapač",
        "popis": "[588474] Horní Lapač",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588474,
        "val": "[588474] Horni Lapac 7202 [588474] Horní Lapač"
    },
    {
        "kod": 588482,
        "nazev": "Hoštice",
        "popis": "[588482] Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588482,
        "val": "[588482] Hostice 7203 [588482] Hoštice"
    },
    {
        "kod": 588491,
        "nazev": "Hulín",
        "popis": "[588491] Hulín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588491,
        "val": "[588491] Hulin 7203 [588491] Hulín"
    },
    {
        "kod": 588504,
        "nazev": "Chomýž",
        "popis": "[588504] Chomýž",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588504,
        "val": "[588504] Chomyz 7201 [588504] Chomýž"
    },
    {
        "kod": 588512,
        "nazev": "Chropyně",
        "popis": "[588512] Chropyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588512,
        "val": "[588512] Chropyne 7203 [588512] Chropyně"
    },
    {
        "kod": 506737,
        "nazev": "Chvalčov",
        "popis": "[506737] Chvalčov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 506737,
        "val": "[506737] Chvalcov 7201 [506737] Chvalčov"
    },
    {
        "kod": 588547,
        "nazev": "Chvalnov-Lísky",
        "popis": "[588547] Chvalnov-Lísky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588547,
        "val": "[588547] Chvalnov-Lisky 7203 [588547] Chvalnov-Lísky"
    },
    {
        "kod": 588555,
        "nazev": "Jankovice",
        "popis": "[588555] Jankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588555,
        "val": "[588555] Jankovice 7202 [588555] Jankovice"
    },
    {
        "kod": 588563,
        "nazev": "Jarohněvice",
        "popis": "[588563] Jarohněvice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588563,
        "val": "[588563] Jarohnevice 7203 [588563] Jarohněvice"
    },
    {
        "kod": 587354,
        "nazev": "Karolín",
        "popis": "[587354] Karolín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 587354,
        "val": "[587354] Karolin 7203 [587354] Karolín"
    },
    {
        "kod": 588598,
        "nazev": "Komárno",
        "popis": "[588598] Komárno",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588598,
        "val": "[588598] Komarno 7201 [588598] Komárno"
    },
    {
        "kod": 588601,
        "nazev": "Koryčany",
        "popis": "[588601] Koryčany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588601,
        "val": "[588601] Korycany 7203 [588601] Koryčany"
    },
    {
        "kod": 588521,
        "nazev": "Kostelany",
        "popis": "[588521] Kostelany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588521,
        "val": "[588521] Kostelany 7203 [588521] Kostelany"
    },
    {
        "kod": 588610,
        "nazev": "Kostelec u Holešova",
        "popis": "[588610] Kostelec u Holešova",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588610,
        "val": "[588610] Kostelec u Holesova 7202 [588610] Kostelec u Holešova"
    },
    {
        "kod": 588296,
        "nazev": "Kroměříž",
        "popis": "[588296] Kroměříž",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588296,
        "val": "[588296] Kromeriz 7203 [588296] Kroměříž"
    },
    {
        "kod": 588628,
        "nazev": "Kunkovice",
        "popis": "[588628] Kunkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588628,
        "val": "[588628] Kunkovice 7203 [588628] Kunkovice"
    },
    {
        "kod": 588636,
        "nazev": "Kurovice",
        "popis": "[588636] Kurovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588636,
        "val": "[588636] Kurovice 7202 [588636] Kurovice"
    },
    {
        "kod": 588644,
        "nazev": "Kvasice",
        "popis": "[588644] Kvasice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588644,
        "val": "[588644] Kvasice 7203 [588644] Kvasice"
    },
    {
        "kod": 588652,
        "nazev": "Kyselovice",
        "popis": "[588652] Kyselovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588652,
        "val": "[588652] Kyselovice 7203 [588652] Kyselovice"
    },
    {
        "kod": 588661,
        "nazev": "Lechotice",
        "popis": "[588661] Lechotice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588661,
        "val": "[588661] Lechotice 7202 [588661] Lechotice"
    },
    {
        "kod": 588695,
        "nazev": "Litenčice",
        "popis": "[588695] Litenčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588695,
        "val": "[588695] Litencice 7203 [588695] Litenčice"
    },
    {
        "kod": 588709,
        "nazev": "Loukov",
        "popis": "[588709] Loukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588709,
        "val": "[588709] Loukov 7201 [588709] Loukov"
    },
    {
        "kod": 588717,
        "nazev": "Lubná",
        "popis": "[588717] Lubná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588717,
        "val": "[588717] Lubna 7203 [588717] Lubná"
    },
    {
        "kod": 588725,
        "nazev": "Ludslavice",
        "popis": "[588725] Ludslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588725,
        "val": "[588725] Ludslavice 7202 [588725] Ludslavice"
    },
    {
        "kod": 588733,
        "nazev": "Lutopecny",
        "popis": "[588733] Lutopecny",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588733,
        "val": "[588733] Lutopecny 7203 [588733] Lutopecny"
    },
    {
        "kod": 588741,
        "nazev": "Martinice",
        "popis": "[588741] Martinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588741,
        "val": "[588741] Martinice 7202 [588741] Martinice"
    },
    {
        "kod": 588750,
        "nazev": "Míškovice",
        "popis": "[588750] Míškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588750,
        "val": "[588750] Miskovice 7202 [588750] Míškovice"
    },
    {
        "kod": 588768,
        "nazev": "Morkovice-Slížany",
        "popis": "[588768] Morkovice-Slížany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588768,
        "val": "[588768] Morkovice-Slizany 7203 [588768] Morkovice-Slížany"
    },
    {
        "kod": 553905,
        "nazev": "Mrlínek",
        "popis": "[553905] Mrlínek",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 553905,
        "val": "[553905] Mrlinek 7201 [553905] Mrlínek"
    },
    {
        "kod": 588784,
        "nazev": "Němčice",
        "popis": "[588784] Němčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588784,
        "val": "[588784] Nemcice 7202 [588784] Němčice"
    },
    {
        "kod": 588806,
        "nazev": "Nítkovice",
        "popis": "[588806] Nítkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588806,
        "val": "[588806] Nitkovice 7203 [588806] Nítkovice"
    },
    {
        "kod": 588814,
        "nazev": "Nová Dědina",
        "popis": "[588814] Nová Dědina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588814,
        "val": "[588814] Nova Dedina 7203 [588814] Nová Dědina"
    },
    {
        "kod": 588822,
        "nazev": "Osíčko",
        "popis": "[588822] Osíčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588822,
        "val": "[588822] Osicko 7201 [588822] Osíčko"
    },
    {
        "kod": 588831,
        "nazev": "Pacetluky",
        "popis": "[588831] Pacetluky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588831,
        "val": "[588831] Pacetluky 7202 [588831] Pacetluky"
    },
    {
        "kod": 588849,
        "nazev": "Pačlavice",
        "popis": "[588849] Pačlavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588849,
        "val": "[588849] Paclavice 7203 [588849] Pačlavice"
    },
    {
        "kod": 588865,
        "nazev": "Počenice-Tetětice",
        "popis": "[588865] Počenice-Tetětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588865,
        "val": "[588865] Pocenice-Tetetice 7203 [588865] Počenice-Tetětice"
    },
    {
        "kod": 588873,
        "nazev": "Podhradní Lhota",
        "popis": "[588873] Podhradní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588873,
        "val": "[588873] Podhradni Lhota 7201 [588873] Podhradní Lhota"
    },
    {
        "kod": 587397,
        "nazev": "Prasklice",
        "popis": "[587397] Prasklice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 587397,
        "val": "[587397] Prasklice 7203 [587397] Prasklice"
    },
    {
        "kod": 588890,
        "nazev": "Pravčice",
        "popis": "[588890] Pravčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588890,
        "val": "[588890] Pravcice 7203 [588890] Pravčice"
    },
    {
        "kod": 588903,
        "nazev": "Prusinovice",
        "popis": "[588903] Prusinovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588903,
        "val": "[588903] Prusinovice 7202 [588903] Prusinovice"
    },
    {
        "kod": 549720,
        "nazev": "Přílepy",
        "popis": "[549720] Přílepy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 549720,
        "val": "[549720] Prilepy 7202 [549720] Přílepy"
    },
    {
        "kod": 588920,
        "nazev": "Rajnochovice",
        "popis": "[588920] Rajnochovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588920,
        "val": "[588920] Rajnochovice 7201 [588920] Rajnochovice"
    },
    {
        "kod": 588938,
        "nazev": "Rataje",
        "popis": "[588938] Rataje",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588938,
        "val": "[588938] Rataje 7203 [588938] Rataje"
    },
    {
        "kod": 588946,
        "nazev": "Roštění",
        "popis": "[588946] Roštění",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588946,
        "val": "[588946] Rosteni 7202 [588946] Roštění"
    },
    {
        "kod": 588954,
        "nazev": "Roštín",
        "popis": "[588954] Roštín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588954,
        "val": "[588954] Rostin 7203 [588954] Roštín"
    },
    {
        "kod": 588962,
        "nazev": "Rusava",
        "popis": "[588962] Rusava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588962,
        "val": "[588962] Rusava 7201 [588962] Rusava"
    },
    {
        "kod": 588971,
        "nazev": "Rymice",
        "popis": "[588971] Rymice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 588971,
        "val": "[588971] Rymice 7202 [588971] Rymice"
    },
    {
        "kod": 588989,
        "nazev": "Skaštice",
        "popis": "[588989] Skaštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 588989,
        "val": "[588989] Skastice 7203 [588989] Skaštice"
    },
    {
        "kod": 588997,
        "nazev": "Slavkov pod Hostýnem",
        "popis": "[588997] Slavkov pod Hostýnem",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 588997,
        "val": "[588997] Slavkov pod Hostynem 7201 [588997] Slavkov pod Hostýnem"
    },
    {
        "kod": 589004,
        "nazev": "Soběsuky",
        "popis": "[589004] Soběsuky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589004,
        "val": "[589004] Sobesuky 7203 [589004] Soběsuky"
    },
    {
        "kod": 589039,
        "nazev": "Střílky",
        "popis": "[589039] Střílky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589039,
        "val": "[589039] Strilky 7203 [589039] Střílky"
    },
    {
        "kod": 589047,
        "nazev": "Střížovice",
        "popis": "[589047] Střížovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589047,
        "val": "[589047] Strizovice 7203 [589047] Střížovice"
    },
    {
        "kod": 589055,
        "nazev": "Sulimov",
        "popis": "[589055] Sulimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589055,
        "val": "[589055] Sulimov 7203 [589055] Sulimov"
    },
    {
        "kod": 557188,
        "nazev": "Šelešovice",
        "popis": "[557188] Šelešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 557188,
        "val": "[557188] Selesovice 7203 [557188] Šelešovice"
    },
    {
        "kod": 589080,
        "nazev": "Troubky-Zdislavice",
        "popis": "[589080] Troubky-Zdislavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589080,
        "val": "[589080] Troubky-Zdislavice 7203 [589080] Troubky-Zdislavice"
    },
    {
        "kod": 589098,
        "nazev": "Třebětice",
        "popis": "[589098] Třebětice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 589098,
        "val": "[589098] Trebetice 7202 [589098] Třebětice"
    },
    {
        "kod": 589110,
        "nazev": "Uhřice",
        "popis": "[589110] Uhřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589110,
        "val": "[589110] Uhrice 7203 [589110] Uhřice"
    },
    {
        "kod": 589128,
        "nazev": "Věžky",
        "popis": "[589128] Věžky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589128,
        "val": "[589128] Vezky 7203 [589128] Věžky"
    },
    {
        "kod": 589136,
        "nazev": "Vítonice",
        "popis": "[589136] Vítonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7201,
        "iczuj": 589136,
        "val": "[589136] Vitonice 7201 [589136] Vítonice"
    },
    {
        "kod": 542393,
        "nazev": "Vrbka",
        "popis": "[542393] Vrbka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 542393,
        "val": "[542393] Vrbka 7203 [542393] Vrbka"
    },
    {
        "kod": 589152,
        "nazev": "Zahnašovice",
        "popis": "[589152] Zahnašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 589152,
        "val": "[589152] Zahnasovice 7202 [589152] Zahnašovice"
    },
    {
        "kod": 589161,
        "nazev": "Záříčí",
        "popis": "[589161] Záříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589161,
        "val": "[589161] Zarici 7203 [589161] Záříčí"
    },
    {
        "kod": 587257,
        "nazev": "Zástřizly",
        "popis": "[587257] Zástřizly",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 587257,
        "val": "[587257] Zastrizly 7203 [587257] Zástřizly"
    },
    {
        "kod": 589187,
        "nazev": "Zborovice",
        "popis": "[589187] Zborovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589187,
        "val": "[589187] Zborovice 7203 [589187] Zborovice"
    },
    {
        "kod": 589195,
        "nazev": "Zdounky",
        "popis": "[589195] Zdounky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589195,
        "val": "[589195] Zdounky 7203 [589195] Zdounky"
    },
    {
        "kod": 589217,
        "nazev": "Zlobice",
        "popis": "[589217] Zlobice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589217,
        "val": "[589217] Zlobice 7203 [589217] Zlobice"
    },
    {
        "kod": 589225,
        "nazev": "Žalkovice",
        "popis": "[589225] Žalkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7203,
        "iczuj": 589225,
        "val": "[589225] Zalkovice 7203 [589225] Žalkovice"
    },
    {
        "kod": 589233,
        "nazev": "Žeranovice",
        "popis": "[589233] Žeranovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7202,
        "iczuj": 589233,
        "val": "[589233] Zeranovice 7202 [589233] Žeranovice"
    },
    {
        "kod": 592013,
        "nazev": "Babice",
        "popis": "[592013] Babice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592013,
        "val": "[592013] Babice 7207 [592013] Babice"
    },
    {
        "kod": 592021,
        "nazev": "Bánov",
        "popis": "[592021] Bánov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592021,
        "val": "[592021] Banov 7208 [592021] Bánov"
    },
    {
        "kod": 592030,
        "nazev": "Bílovice",
        "popis": "[592030] Bílovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592030,
        "val": "[592030] Bilovice 7207 [592030] Bílovice"
    },
    {
        "kod": 592048,
        "nazev": "Bojkovice",
        "popis": "[592048] Bojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592048,
        "val": "[592048] Bojkovice 7208 [592048] Bojkovice"
    },
    {
        "kod": 592064,
        "nazev": "Boršice",
        "popis": "[592064] Boršice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592064,
        "val": "[592064] Borsice 7207 [592064] Boršice"
    },
    {
        "kod": 592056,
        "nazev": "Boršice u Blatnice",
        "popis": "[592056] Boršice u Blatnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592056,
        "val": "[592056] Borsice u Blatnice 7207 [592056] Boršice u Blatnice"
    },
    {
        "kod": 592072,
        "nazev": "Břestek",
        "popis": "[592072] Břestek",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592072,
        "val": "[592072] Brestek 7207 [592072] Břestek"
    },
    {
        "kod": 592081,
        "nazev": "Březolupy",
        "popis": "[592081] Březolupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592081,
        "val": "[592081] Brezolupy 7207 [592081] Březolupy"
    },
    {
        "kod": 592099,
        "nazev": "Březová",
        "popis": "[592099] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592099,
        "val": "[592099] Brezova 7208 [592099] Březová"
    },
    {
        "kod": 592102,
        "nazev": "Buchlovice",
        "popis": "[592102] Buchlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592102,
        "val": "[592102] Buchlovice 7207 [592102] Buchlovice"
    },
    {
        "kod": 592111,
        "nazev": "Bystřice pod Lopeníkem",
        "popis": "[592111] Bystřice pod Lopeníkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592111,
        "val": "[592111] Bystrice pod Lopenikem 7208 [592111] Bystřice pod Lopeníkem"
    },
    {
        "kod": 592137,
        "nazev": "Částkov",
        "popis": "[592137] Částkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592137,
        "val": "[592137] Castkov 7207 [592137] Částkov"
    },
    {
        "kod": 592145,
        "nazev": "Dolní Němčí",
        "popis": "[592145] Dolní Němčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592145,
        "val": "[592145] Dolni Nemci 7208 [592145] Dolní Němčí"
    },
    {
        "kod": 592153,
        "nazev": "Drslavice",
        "popis": "[592153] Drslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592153,
        "val": "[592153] Drslavice 7208 [592153] Drslavice"
    },
    {
        "kod": 592170,
        "nazev": "Hluk",
        "popis": "[592170] Hluk",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592170,
        "val": "[592170] Hluk 7207 [592170] Hluk"
    },
    {
        "kod": 592188,
        "nazev": "Horní Němčí",
        "popis": "[592188] Horní Němčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592188,
        "val": "[592188] Horni Nemci 7208 [592188] Horní Němčí"
    },
    {
        "kod": 592196,
        "nazev": "Hostějov",
        "popis": "[592196] Hostějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592196,
        "val": "[592196] Hostejov 7207 [592196] Hostějov"
    },
    {
        "kod": 550736,
        "nazev": "Hostětín",
        "popis": "[550736] Hostětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 550736,
        "val": "[550736] Hostetin 7208 [550736] Hostětín"
    },
    {
        "kod": 592200,
        "nazev": "Hradčovice",
        "popis": "[592200] Hradčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592200,
        "val": "[592200] Hradcovice 7208 [592200] Hradčovice"
    },
    {
        "kod": 592218,
        "nazev": "Huštěnovice",
        "popis": "[592218] Huštěnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592218,
        "val": "[592218] Hustenovice 7207 [592218] Huštěnovice"
    },
    {
        "kod": 592226,
        "nazev": "Jalubí",
        "popis": "[592226] Jalubí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592226,
        "val": "[592226] Jalubi 7207 [592226] Jalubí"
    },
    {
        "kod": 592234,
        "nazev": "Jankovice",
        "popis": "[592234] Jankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592234,
        "val": "[592234] Jankovice 7207 [592234] Jankovice"
    },
    {
        "kod": 592269,
        "nazev": "Kněžpole",
        "popis": "[592269] Kněžpole",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592269,
        "val": "[592269] Knezpole 7207 [592269] Kněžpole"
    },
    {
        "kod": 592277,
        "nazev": "Komňa",
        "popis": "[592277] Komňa",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592277,
        "val": "[592277] Komna 7208 [592277] Komňa"
    },
    {
        "kod": 592285,
        "nazev": "Korytná",
        "popis": "[592285] Korytná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592285,
        "val": "[592285] Korytna 7208 [592285] Korytná"
    },
    {
        "kod": 592293,
        "nazev": "Kostelany nad Moravou",
        "popis": "[592293] Kostelany nad Moravou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592293,
        "val": "[592293] Kostelany nad Moravou 7207 [592293] Kostelany nad Moravou"
    },
    {
        "kod": 592307,
        "nazev": "Košíky",
        "popis": "[592307] Košíky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592307,
        "val": "[592307] Kosiky 7207 [592307] Košíky"
    },
    {
        "kod": 592323,
        "nazev": "Kudlovice",
        "popis": "[592323] Kudlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592323,
        "val": "[592323] Kudlovice 7207 [592323] Kudlovice"
    },
    {
        "kod": 550744,
        "nazev": "Kunovice",
        "popis": "[550744] Kunovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 550744,
        "val": "[550744] Kunovice 7207 [550744] Kunovice"
    },
    {
        "kod": 592340,
        "nazev": "Lopeník",
        "popis": "[592340] Lopeník",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592340,
        "val": "[592340] Lopenik 7208 [592340] Lopeník"
    },
    {
        "kod": 592366,
        "nazev": "Medlovice",
        "popis": "[592366] Medlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592366,
        "val": "[592366] Medlovice 7207 [592366] Medlovice"
    },
    {
        "kod": 592382,
        "nazev": "Mistřice",
        "popis": "[592382] Mistřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592382,
        "val": "[592382] Mistrice 7207 [592382] Mistřice"
    },
    {
        "kod": 592391,
        "nazev": "Modrá",
        "popis": "[592391] Modrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592391,
        "val": "[592391] Modra 7207 [592391] Modrá"
    },
    {
        "kod": 592404,
        "nazev": "Nedachlebice",
        "popis": "[592404] Nedachlebice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592404,
        "val": "[592404] Nedachlebice 7207 [592404] Nedachlebice"
    },
    {
        "kod": 592412,
        "nazev": "Nedakonice",
        "popis": "[592412] Nedakonice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592412,
        "val": "[592412] Nedakonice 7207 [592412] Nedakonice"
    },
    {
        "kod": 592421,
        "nazev": "Nezdenice",
        "popis": "[592421] Nezdenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592421,
        "val": "[592421] Nezdenice 7208 [592421] Nezdenice"
    },
    {
        "kod": 592439,
        "nazev": "Nivnice",
        "popis": "[592439] Nivnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592439,
        "val": "[592439] Nivnice 7208 [592439] Nivnice"
    },
    {
        "kod": 592447,
        "nazev": "Ořechov",
        "popis": "[592447] Ořechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592447,
        "val": "[592447] Orechov 7207 [592447] Ořechov"
    },
    {
        "kod": 592455,
        "nazev": "Ostrožská Lhota",
        "popis": "[592455] Ostrožská Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592455,
        "val": "[592455] Ostrozska Lhota 7207 [592455] Ostrožská Lhota"
    },
    {
        "kod": 592463,
        "nazev": "Ostrožská Nová Ves",
        "popis": "[592463] Ostrožská Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592463,
        "val": "[592463] Ostrozska Nova Ves 7207 [592463] Ostrožská Nová Ves"
    },
    {
        "kod": 592471,
        "nazev": "Osvětimany",
        "popis": "[592471] Osvětimany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592471,
        "val": "[592471] Osvetimany 7207 [592471] Osvětimany"
    },
    {
        "kod": 592480,
        "nazev": "Pašovice",
        "popis": "[592480] Pašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592480,
        "val": "[592480] Pasovice 7208 [592480] Pašovice"
    },
    {
        "kod": 592498,
        "nazev": "Pitín",
        "popis": "[592498] Pitín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592498,
        "val": "[592498] Pitin 7208 [592498] Pitín"
    },
    {
        "kod": 592501,
        "nazev": "Podolí",
        "popis": "[592501] Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592501,
        "val": "[592501] Podoli 7207 [592501] Podolí"
    },
    {
        "kod": 592510,
        "nazev": "Polešovice",
        "popis": "[592510] Polešovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592510,
        "val": "[592510] Polesovice 7207 [592510] Polešovice"
    },
    {
        "kod": 592528,
        "nazev": "Popovice",
        "popis": "[592528] Popovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592528,
        "val": "[592528] Popovice 7207 [592528] Popovice"
    },
    {
        "kod": 592536,
        "nazev": "Prakšice",
        "popis": "[592536] Prakšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592536,
        "val": "[592536] Praksice 7208 [592536] Prakšice"
    },
    {
        "kod": 592552,
        "nazev": "Rudice",
        "popis": "[592552] Rudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592552,
        "val": "[592552] Rudice 7208 [592552] Rudice"
    },
    {
        "kod": 592561,
        "nazev": "Salaš",
        "popis": "[592561] Salaš",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592561,
        "val": "[592561] Salas 7207 [592561] Salaš"
    },
    {
        "kod": 592579,
        "nazev": "Slavkov",
        "popis": "[592579] Slavkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592579,
        "val": "[592579] Slavkov 7208 [592579] Slavkov"
    },
    {
        "kod": 592587,
        "nazev": "Staré Hutě",
        "popis": "[592587] Staré Hutě",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592587,
        "val": "[592587] Stare Hute 7207 [592587] Staré Hutě"
    },
    {
        "kod": 550752,
        "nazev": "Staré Město",
        "popis": "[550752] Staré Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 550752,
        "val": "[550752] Stare Mesto 7207 [550752] Staré Město"
    },
    {
        "kod": 592609,
        "nazev": "Starý Hrozenkov",
        "popis": "[592609] Starý Hrozenkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592609,
        "val": "[592609] Stary Hrozenkov 7208 [592609] Starý Hrozenkov"
    },
    {
        "kod": 592617,
        "nazev": "Strání",
        "popis": "[592617] Strání",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592617,
        "val": "[592617] Strani 7208 [592617] Strání"
    },
    {
        "kod": 592625,
        "nazev": "Stříbrnice",
        "popis": "[592625] Stříbrnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592625,
        "val": "[592625] Stribrnice 7207 [592625] Stříbrnice"
    },
    {
        "kod": 592633,
        "nazev": "Stupava",
        "popis": "[592633] Stupava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592633,
        "val": "[592633] Stupava 7207 [592633] Stupava"
    },
    {
        "kod": 592641,
        "nazev": "Suchá Loz",
        "popis": "[592641] Suchá Loz",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592641,
        "val": "[592641] Sucha Loz 7208 [592641] Suchá Loz"
    },
    {
        "kod": 592650,
        "nazev": "Sušice",
        "popis": "[592650] Sušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592650,
        "val": "[592650] Susice 7207 [592650] Sušice"
    },
    {
        "kod": 592668,
        "nazev": "Svárov",
        "popis": "[592668] Svárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592668,
        "val": "[592668] Svarov 7207 [592668] Svárov"
    },
    {
        "kod": 592676,
        "nazev": "Šumice",
        "popis": "[592676] Šumice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592676,
        "val": "[592676] Sumice 7208 [592676] Šumice"
    },
    {
        "kod": 592692,
        "nazev": "Topolná",
        "popis": "[592692] Topolná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592692,
        "val": "[592692] Topolna 7207 [592692] Topolná"
    },
    {
        "kod": 592706,
        "nazev": "Traplice",
        "popis": "[592706] Traplice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592706,
        "val": "[592706] Traplice 7207 [592706] Traplice"
    },
    {
        "kod": 592714,
        "nazev": "Tučapy",
        "popis": "[592714] Tučapy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592714,
        "val": "[592714] Tucapy 7207 [592714] Tučapy"
    },
    {
        "kod": 592722,
        "nazev": "Tupesy",
        "popis": "[592722] Tupesy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592722,
        "val": "[592722] Tupesy 7207 [592722] Tupesy"
    },
    {
        "kod": 592005,
        "nazev": "Uherské Hradiště",
        "popis": "[592005] Uherské Hradiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592005,
        "val": "[592005] Uherske Hradiste 7207 [592005] Uherské Hradiště"
    },
    {
        "kod": 592731,
        "nazev": "Uherský Brod",
        "popis": "[592731] Uherský Brod",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592731,
        "val": "[592731] Uhersky Brod 7208 [592731] Uherský Brod"
    },
    {
        "kod": 592749,
        "nazev": "Uherský Ostroh",
        "popis": "[592749] Uherský Ostroh",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592749,
        "val": "[592749] Uhersky Ostroh 7207 [592749] Uherský Ostroh"
    },
    {
        "kod": 592757,
        "nazev": "Újezdec",
        "popis": "[592757] Újezdec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592757,
        "val": "[592757] Ujezdec 7207 [592757] Újezdec"
    },
    {
        "kod": 592773,
        "nazev": "Vápenice",
        "popis": "[592773] Vápenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592773,
        "val": "[592773] Vapenice 7208 [592773] Vápenice"
    },
    {
        "kod": 592781,
        "nazev": "Vážany",
        "popis": "[592781] Vážany",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592781,
        "val": "[592781] Vazany 7207 [592781] Vážany"
    },
    {
        "kod": 592790,
        "nazev": "Velehrad",
        "popis": "[592790] Velehrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592790,
        "val": "[592790] Velehrad 7207 [592790] Velehrad"
    },
    {
        "kod": 592803,
        "nazev": "Veletiny",
        "popis": "[592803] Veletiny",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592803,
        "val": "[592803] Veletiny 7208 [592803] Veletiny"
    },
    {
        "kod": 592820,
        "nazev": "Vlčnov",
        "popis": "[592820] Vlčnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592820,
        "val": "[592820] Vlcnov 7208 [592820] Vlčnov"
    },
    {
        "kod": 592838,
        "nazev": "Vyškovec",
        "popis": "[592838] Vyškovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592838,
        "val": "[592838] Vyskovec 7208 [592838] Vyškovec"
    },
    {
        "kod": 592846,
        "nazev": "Záhorovice",
        "popis": "[592846] Záhorovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592846,
        "val": "[592846] Zahorovice 7208 [592846] Záhorovice"
    },
    {
        "kod": 592854,
        "nazev": "Zlámanec",
        "popis": "[592854] Zlámanec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592854,
        "val": "[592854] Zlamanec 7207 [592854] Zlámanec"
    },
    {
        "kod": 592862,
        "nazev": "Zlechov",
        "popis": "[592862] Zlechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7207,
        "iczuj": 592862,
        "val": "[592862] Zlechov 7207 [592862] Zlechov"
    },
    {
        "kod": 592871,
        "nazev": "Žítková",
        "popis": "[592871] Žítková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7208,
        "iczuj": 592871,
        "val": "[592871] Zitkova 7208 [592871] Žítková"
    },
    {
        "kod": 541648,
        "nazev": "Branky",
        "popis": "[541648] Branky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 541648,
        "val": "[541648] Branky 7210 [541648] Branky"
    },
    {
        "kod": 541711,
        "nazev": "Bystřička",
        "popis": "[541711] Bystřička",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 541711,
        "val": "[541711] Bystricka 7212 [541711] Bystřička"
    },
    {
        "kod": 541800,
        "nazev": "Dolní Bečva",
        "popis": "[541800] Dolní Bečva",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 541800,
        "val": "[541800] Dolni Becva 7206 [541800] Dolní Bečva"
    },
    {
        "kod": 542644,
        "nazev": "Francova Lhota",
        "popis": "[542644] Francova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542644,
        "val": "[542644] Francova Lhota 7212 [542644] Francova Lhota"
    },
    {
        "kod": 542679,
        "nazev": "Halenkov",
        "popis": "[542679] Halenkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542679,
        "val": "[542679] Halenkov 7212 [542679] Halenkov"
    },
    {
        "kod": 542687,
        "nazev": "Horní Bečva",
        "popis": "[542687] Horní Bečva",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 542687,
        "val": "[542687] Horni Becva 7206 [542687] Horní Bečva"
    },
    {
        "kod": 542725,
        "nazev": "Horní Lideč",
        "popis": "[542725] Horní Lideč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542725,
        "val": "[542725] Horni Lidec 7212 [542725] Horní Lideč"
    },
    {
        "kod": 542750,
        "nazev": "Hošťálková",
        "popis": "[542750] Hošťálková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542750,
        "val": "[542750] Hostalkova 7212 [542750] Hošťálková"
    },
    {
        "kod": 542768,
        "nazev": "Hovězí",
        "popis": "[542768] Hovězí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542768,
        "val": "[542768] Hovezi 7212 [542768] Hovězí"
    },
    {
        "kod": 542784,
        "nazev": "Huslenky",
        "popis": "[542784] Huslenky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542784,
        "val": "[542784] Huslenky 7212 [542784] Huslenky"
    },
    {
        "kod": 542814,
        "nazev": "Hutisko-Solanec",
        "popis": "[542814] Hutisko-Solanec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 542814,
        "val": "[542814] Hutisko-Solanec 7206 [542814] Hutisko-Solanec"
    },
    {
        "kod": 542831,
        "nazev": "Choryně",
        "popis": "[542831] Choryně",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 542831,
        "val": "[542831] Choryne 7210 [542831] Choryně"
    },
    {
        "kod": 542865,
        "nazev": "Jablůnka",
        "popis": "[542865] Jablůnka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542865,
        "val": "[542865] Jablunka 7212 [542865] Jablůnka"
    },
    {
        "kod": 570346,
        "nazev": "Janová",
        "popis": "[570346] Janová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 570346,
        "val": "[570346] Janova 7212 [570346] Janová"
    },
    {
        "kod": 542903,
        "nazev": "Jarcová",
        "popis": "[542903] Jarcová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 542903,
        "val": "[542903] Jarcova 7210 [542903] Jarcová"
    },
    {
        "kod": 542911,
        "nazev": "Karolinka",
        "popis": "[542911] Karolinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542911,
        "val": "[542911] Karolinka 7212 [542911] Karolinka"
    },
    {
        "kod": 542946,
        "nazev": "Kateřinice",
        "popis": "[542946] Kateřinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 542946,
        "val": "[542946] Katerinice 7212 [542946] Kateřinice"
    },
    {
        "kod": 542989,
        "nazev": "Kelč",
        "popis": "[542989] Kelč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 542989,
        "val": "[542989] Kelc 7210 [542989] Kelč"
    },
    {
        "kod": 542997,
        "nazev": "Kladeruby",
        "popis": "[542997] Kladeruby",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 542997,
        "val": "[542997] Kladeruby 7210 [542997] Kladeruby"
    },
    {
        "kod": 543021,
        "nazev": "Kunovice",
        "popis": "[543021] Kunovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 543021,
        "val": "[543021] Kunovice 7210 [543021] Kunovice"
    },
    {
        "kod": 543098,
        "nazev": "Lačnov",
        "popis": "[543098] Lačnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 543098,
        "val": "[543098] Lacnov 7212 [543098] Lačnov"
    },
    {
        "kod": 544264,
        "nazev": "Leskovec",
        "popis": "[544264] Leskovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544264,
        "val": "[544264] Leskovec 7212 [544264] Leskovec"
    },
    {
        "kod": 544302,
        "nazev": "Lešná",
        "popis": "[544302] Lešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544302,
        "val": "[544302] Lesna 7210 [544302] Lešná"
    },
    {
        "kod": 556866,
        "nazev": "Lhota u Vsetína",
        "popis": "[556866] Lhota u Vsetína",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 556866,
        "val": "[556866] Lhota u Vsetina 7212 [556866] Lhota u Vsetína"
    },
    {
        "kod": 544370,
        "nazev": "Lidečko",
        "popis": "[544370] Lidečko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544370,
        "val": "[544370] Lidecko 7212 [544370] Lidečko"
    },
    {
        "kod": 544396,
        "nazev": "Liptál",
        "popis": "[544396] Liptál",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544396,
        "val": "[544396] Liptal 7212 [544396] Liptál"
    },
    {
        "kod": 544418,
        "nazev": "Loučka",
        "popis": "[544418] Loučka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544418,
        "val": "[544418] Loucka 7210 [544418] Loučka"
    },
    {
        "kod": 544434,
        "nazev": "Lužná",
        "popis": "[544434] Lužná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544434,
        "val": "[544434] Luzna 7212 [544434] Lužná"
    },
    {
        "kod": 544469,
        "nazev": "Malá Bystřice",
        "popis": "[544469] Malá Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544469,
        "val": "[544469] Mala Bystrice 7212 [544469] Malá Bystřice"
    },
    {
        "kod": 544507,
        "nazev": "Mikulůvka",
        "popis": "[544507] Mikulůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544507,
        "val": "[544507] Mikuluvka 7210 [544507] Mikulůvka"
    },
    {
        "kod": 544566,
        "nazev": "Nový Hrozenkov",
        "popis": "[544566] Nový Hrozenkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544566,
        "val": "[544566] Novy Hrozenkov 7212 [544566] Nový Hrozenkov"
    },
    {
        "kod": 544574,
        "nazev": "Oznice",
        "popis": "[544574] Oznice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544574,
        "val": "[544574] Oznice 7210 [544574] Oznice"
    },
    {
        "kod": 569496,
        "nazev": "Podolí",
        "popis": "[569496] Podolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 569496,
        "val": "[569496] Podoli 7210 [569496] Podolí"
    },
    {
        "kod": 544621,
        "nazev": "Police",
        "popis": "[544621] Police",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544621,
        "val": "[544621] Police 7210 [544621] Police"
    },
    {
        "kod": 544655,
        "nazev": "Pozděchov",
        "popis": "[544655] Pozděchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544655,
        "val": "[544655] Pozdechov 7212 [544655] Pozděchov"
    },
    {
        "kod": 544671,
        "nazev": "Prlov",
        "popis": "[544671] Prlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544671,
        "val": "[544671] Prlov 7212 [544671] Prlov"
    },
    {
        "kod": 544698,
        "nazev": "Prostřední Bečva",
        "popis": "[544698] Prostřední Bečva",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 544698,
        "val": "[544698] Prostredni Becva 7206 [544698] Prostřední Bečva"
    },
    {
        "kod": 544728,
        "nazev": "Pržno",
        "popis": "[544728] Pržno",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544728,
        "val": "[544728] Przno 7212 [544728] Pržno"
    },
    {
        "kod": 544787,
        "nazev": "Ratiboř",
        "popis": "[544787] Ratiboř",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544787,
        "val": "[544787] Ratibor 7212 [544787] Ratiboř"
    },
    {
        "kod": 544841,
        "nazev": "Rožnov pod Radhoštěm",
        "popis": "[544841] Rožnov pod Radhoštěm",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 544841,
        "val": "[544841] Roznov pod Radhostem 7206 [544841] Rožnov pod Radhoštěm"
    },
    {
        "kod": 544850,
        "nazev": "Růžďka",
        "popis": "[544850] Růžďka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544850,
        "val": "[544850] Ruzdka 7212 [544850] Růžďka"
    },
    {
        "kod": 544906,
        "nazev": "Seninka",
        "popis": "[544906] Seninka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544906,
        "val": "[544906] Seninka 7212 [544906] Seninka"
    },
    {
        "kod": 544914,
        "nazev": "Střelná",
        "popis": "[544914] Střelná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544914,
        "val": "[544914] Strelna 7212 [544914] Střelná"
    },
    {
        "kod": 544922,
        "nazev": "Střítež nad Bečvou",
        "popis": "[544922] Střítež nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 544922,
        "val": "[544922] Stritez nad Becvou 7210 [544922] Střítež nad Bečvou"
    },
    {
        "kod": 544931,
        "nazev": "Študlov",
        "popis": "[544931] Študlov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 544931,
        "val": "[544931] Studlov 7209 [544931] Študlov"
    },
    {
        "kod": 570371,
        "nazev": "Ústí",
        "popis": "[570371] Ústí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 570371,
        "val": "[570371] Usti 7212 [570371] Ústí"
    },
    {
        "kod": 544949,
        "nazev": "Valašská Bystřice",
        "popis": "[544949] Valašská Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 544949,
        "val": "[544949] Valasska Bystrice 7206 [544949] Valašská Bystřice"
    },
    {
        "kod": 544990,
        "nazev": "Valašská Polanka",
        "popis": "[544990] Valašská Polanka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 544990,
        "val": "[544990] Valasska Polanka 7212 [544990] Valašská Polanka"
    },
    {
        "kod": 553026,
        "nazev": "Valašská Senice",
        "popis": "[553026] Valašská Senice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 553026,
        "val": "[553026] Valasska Senice 7212 [553026] Valašská Senice"
    },
    {
        "kod": 545058,
        "nazev": "Valašské Meziříčí",
        "popis": "[545058] Valašské Meziříčí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 545058,
        "val": "[545058] Valasske Mezirici 7210 [545058] Valašské Meziříčí"
    },
    {
        "kod": 545112,
        "nazev": "Valašské Příkazy",
        "popis": "[545112] Valašské Příkazy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 545112,
        "val": "[545112] Valasske Prikazy 7209 [545112] Valašské Příkazy"
    },
    {
        "kod": 545147,
        "nazev": "Velká Lhota",
        "popis": "[545147] Velká Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 545147,
        "val": "[545147] Velka Lhota 7210 [545147] Velká Lhota"
    },
    {
        "kod": 545163,
        "nazev": "Velké Karlovice",
        "popis": "[545163] Velké Karlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 545163,
        "val": "[545163] Velke Karlovice 7212 [545163] Velké Karlovice"
    },
    {
        "kod": 545198,
        "nazev": "Vidče",
        "popis": "[545198] Vidče",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 545198,
        "val": "[545198] Vidce 7206 [545198] Vidče"
    },
    {
        "kod": 545210,
        "nazev": "Vigantice",
        "popis": "[545210] Vigantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 545210,
        "val": "[545210] Vigantice 7206 [545210] Vigantice"
    },
    {
        "kod": 541630,
        "nazev": "Vsetín",
        "popis": "[541630] Vsetín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 541630,
        "val": "[541630] Vsetin 7212 [541630] Vsetín"
    },
    {
        "kod": 545236,
        "nazev": "Zašová",
        "popis": "[545236] Zašová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7210,
        "iczuj": 545236,
        "val": "[545236] Zasova 7210 [545236] Zašová"
    },
    {
        "kod": 545244,
        "nazev": "Zděchov",
        "popis": "[545244] Zděchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7212,
        "iczuj": 545244,
        "val": "[545244] Zdechov 7212 [545244] Zděchov"
    },
    {
        "kod": 545252,
        "nazev": "Zubří",
        "popis": "[545252] Zubří",
        "datum_od": "",
        "datum_do": "",
        "orp": 7206,
        "iczuj": 545252,
        "val": "[545252] Zubri 7206 [545252] Zubří"
    },
    {
        "kod": 588318,
        "nazev": "Bělov",
        "popis": "[588318] Bělov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 588318,
        "val": "[588318] Belov 7205 [588318] Bělov"
    },
    {
        "kod": 585076,
        "nazev": "Biskupice",
        "popis": "[585076] Biskupice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585076,
        "val": "[585076] Biskupice 7204 [585076] Biskupice"
    },
    {
        "kod": 557102,
        "nazev": "Bohuslavice nad Vláří",
        "popis": "[557102] Bohuslavice nad Vláří",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 557102,
        "val": "[557102] Bohuslavice nad Vlari 7204 [557102] Bohuslavice nad Vláří"
    },
    {
        "kod": 585092,
        "nazev": "Bohuslavice u Zlína",
        "popis": "[585092] Bohuslavice u Zlína",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585092,
        "val": "[585092] Bohuslavice u Zlina 7213 [585092] Bohuslavice u Zlína"
    },
    {
        "kod": 585106,
        "nazev": "Bratřejov",
        "popis": "[585106] Bratřejov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585106,
        "val": "[585106] Bratrejov 7211 [585106] Bratřejov"
    },
    {
        "kod": 585114,
        "nazev": "Brumov-Bylnice",
        "popis": "[585114] Brumov-Bylnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585114,
        "val": "[585114] Brumov-Bylnice 7209 [585114] Brumov-Bylnice"
    },
    {
        "kod": 538744,
        "nazev": "Březnice",
        "popis": "[538744] Březnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 538744,
        "val": "[538744] Breznice 7213 [538744] Březnice"
    },
    {
        "kod": 585131,
        "nazev": "Březová",
        "popis": "[585131] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585131,
        "val": "[585131] Brezova 7211 [585131] Březová"
    },
    {
        "kod": 585149,
        "nazev": "Březůvky",
        "popis": "[585149] Březůvky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585149,
        "val": "[585149] Brezuvky 7213 [585149] Březůvky"
    },
    {
        "kod": 585157,
        "nazev": "Dešná",
        "popis": "[585157] Dešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585157,
        "val": "[585157] Desna 7211 [585157] Dešná"
    },
    {
        "kod": 585165,
        "nazev": "Dobrkovice",
        "popis": "[585165] Dobrkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585165,
        "val": "[585165] Dobrkovice 7213 [585165] Dobrkovice"
    },
    {
        "kod": 585173,
        "nazev": "Dolní Lhota",
        "popis": "[585173] Dolní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585173,
        "val": "[585173] Dolni Lhota 7204 [585173] Dolní Lhota"
    },
    {
        "kod": 585181,
        "nazev": "Doubravy",
        "popis": "[585181] Doubravy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585181,
        "val": "[585181] Doubravy 7213 [585181] Doubravy"
    },
    {
        "kod": 585190,
        "nazev": "Drnovice",
        "popis": "[585190] Drnovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585190,
        "val": "[585190] Drnovice 7209 [585190] Drnovice"
    },
    {
        "kod": 585203,
        "nazev": "Držková",
        "popis": "[585203] Držková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585203,
        "val": "[585203] Drzkova 7213 [585203] Držková"
    },
    {
        "kod": 585211,
        "nazev": "Fryšták",
        "popis": "[585211] Fryšták",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585211,
        "val": "[585211] Frystak 7213 [585211] Fryšták"
    },
    {
        "kod": 585220,
        "nazev": "Halenkovice",
        "popis": "[585220] Halenkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 585220,
        "val": "[585220] Halenkovice 7205 [585220] Halenkovice"
    },
    {
        "kod": 585238,
        "nazev": "Haluzice",
        "popis": "[585238] Haluzice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585238,
        "val": "[585238] Haluzice 7209 [585238] Haluzice"
    },
    {
        "kod": 585246,
        "nazev": "Horní Lhota",
        "popis": "[585246] Horní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585246,
        "val": "[585246] Horni Lhota 7204 [585246] Horní Lhota"
    },
    {
        "kod": 585254,
        "nazev": "Hostišová",
        "popis": "[585254] Hostišová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585254,
        "val": "[585254] Hostisova 7213 [585254] Hostišová"
    },
    {
        "kod": 585262,
        "nazev": "Hrobice",
        "popis": "[585262] Hrobice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585262,
        "val": "[585262] Hrobice 7211 [585262] Hrobice"
    },
    {
        "kod": 585271,
        "nazev": "Hřivínův Újezd",
        "popis": "[585271] Hřivínův Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585271,
        "val": "[585271] Hrivinuv Ujezd 7213 [585271] Hřivínův Újezd"
    },
    {
        "kod": 585289,
        "nazev": "Hvozdná",
        "popis": "[585289] Hvozdná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585289,
        "val": "[585289] Hvozdna 7213 [585289] Hvozdná"
    },
    {
        "kod": 585301,
        "nazev": "Jasenná",
        "popis": "[585301] Jasenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585301,
        "val": "[585301] Jasenna 7211 [585301] Jasenná"
    },
    {
        "kod": 585319,
        "nazev": "Jestřabí",
        "popis": "[585319] Jestřabí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585319,
        "val": "[585319] Jestrabi 7209 [585319] Jestřabí"
    },
    {
        "kod": 585327,
        "nazev": "Kaňovice",
        "popis": "[585327] Kaňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585327,
        "val": "[585327] Kanovice 7213 [585327] Kaňovice"
    },
    {
        "kod": 587052,
        "nazev": "Karlovice",
        "popis": "[587052] Karlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 587052,
        "val": "[587052] Karlovice 7213 [587052] Karlovice"
    },
    {
        "kod": 585343,
        "nazev": "Kašava",
        "popis": "[585343] Kašava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585343,
        "val": "[585343] Kasava 7213 [585343] Kašava"
    },
    {
        "kod": 592251,
        "nazev": "Kelníky",
        "popis": "[592251] Kelníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 592251,
        "val": "[592251] Kelniky 7213 [592251] Kelníky"
    },
    {
        "kod": 549436,
        "nazev": "Komárov",
        "popis": "[549436] Komárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 549436,
        "val": "[549436] Komarov 7205 [549436] Komárov"
    },
    {
        "kod": 586960,
        "nazev": "Křekov",
        "popis": "[586960] Křekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 586960,
        "val": "[586960] Krekov 7209 [586960] Křekov"
    },
    {
        "kod": 573434,
        "nazev": "Lhota",
        "popis": "[573434] Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 573434,
        "val": "[573434] Lhota 7213 [573434] Lhota"
    },
    {
        "kod": 549550,
        "nazev": "Lhotsko",
        "popis": "[549550] Lhotsko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 549550,
        "val": "[549550] Lhotsko 7211 [549550] Lhotsko"
    },
    {
        "kod": 549622,
        "nazev": "Lípa",
        "popis": "[549622] Lípa",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 549622,
        "val": "[549622] Lipa 7213 [549622] Lípa"
    },
    {
        "kod": 586871,
        "nazev": "Lipová",
        "popis": "[586871] Lipová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 586871,
        "val": "[586871] Lipova 7204 [586871] Lipová"
    },
    {
        "kod": 585432,
        "nazev": "Loučka",
        "popis": "[585432] Loučka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585432,
        "val": "[585432] Loucka 7209 [585432] Loučka"
    },
    {
        "kod": 585441,
        "nazev": "Ludkovice",
        "popis": "[585441] Ludkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585441,
        "val": "[585441] Ludkovice 7204 [585441] Ludkovice"
    },
    {
        "kod": 585459,
        "nazev": "Luhačovice",
        "popis": "[585459] Luhačovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585459,
        "val": "[585459] Luhacovice 7204 [585459] Luhačovice"
    },
    {
        "kod": 585467,
        "nazev": "Lukov",
        "popis": "[585467] Lukov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585467,
        "val": "[585467] Lukov 7213 [585467] Lukov"
    },
    {
        "kod": 557145,
        "nazev": "Lukoveček",
        "popis": "[557145] Lukoveček",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 557145,
        "val": "[557145] Lukovecek 7213 [557145] Lukoveček"
    },
    {
        "kod": 585483,
        "nazev": "Lutonina",
        "popis": "[585483] Lutonina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585483,
        "val": "[585483] Lutonina 7211 [585483] Lutonina"
    },
    {
        "kod": 585491,
        "nazev": "Machová",
        "popis": "[585491] Machová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585491,
        "val": "[585491] Machova 7213 [585491] Machová"
    },
    {
        "kod": 585505,
        "nazev": "Mysločovice",
        "popis": "[585505] Mysločovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585505,
        "val": "[585505] Myslocovice 7213 [585505] Mysločovice"
    },
    {
        "kod": 585513,
        "nazev": "Napajedla",
        "popis": "[585513] Napajedla",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 585513,
        "val": "[585513] Napajedla 7205 [585513] Napajedla"
    },
    {
        "kod": 585521,
        "nazev": "Návojná",
        "popis": "[585521] Návojná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585521,
        "val": "[585521] Navojna 7209 [585521] Návojná"
    },
    {
        "kod": 585530,
        "nazev": "Nedašov",
        "popis": "[585530] Nedašov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585530,
        "val": "[585530] Nedasov 7209 [585530] Nedašov"
    },
    {
        "kod": 585548,
        "nazev": "Nedašova Lhota",
        "popis": "[585548] Nedašova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585548,
        "val": "[585548] Nedasova Lhota 7209 [585548] Nedašova Lhota"
    },
    {
        "kod": 585556,
        "nazev": "Neubuz",
        "popis": "[585556] Neubuz",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585556,
        "val": "[585556] Neubuz 7211 [585556] Neubuz"
    },
    {
        "kod": 549444,
        "nazev": "Oldřichovice",
        "popis": "[549444] Oldřichovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 549444,
        "val": "[549444] Oldrichovice 7205 [549444] Oldřichovice"
    },
    {
        "kod": 557170,
        "nazev": "Ostrata",
        "popis": "[557170] Ostrata",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 557170,
        "val": "[557170] Ostrata 7213 [557170] Ostrata"
    },
    {
        "kod": 585599,
        "nazev": "Otrokovice",
        "popis": "[585599] Otrokovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 585599,
        "val": "[585599] Otrokovice 7205 [585599] Otrokovice"
    },
    {
        "kod": 556874,
        "nazev": "Petrůvka",
        "popis": "[556874] Petrůvka",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 556874,
        "val": "[556874] Petruvka 7204 [556874] Petrůvka"
    },
    {
        "kod": 534811,
        "nazev": "Podhradí",
        "popis": "[534811] Podhradí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 534811,
        "val": "[534811] Podhradi 7204 [534811] Podhradí"
    },
    {
        "kod": 585611,
        "nazev": "Podkopná Lhota",
        "popis": "[585611] Podkopná Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585611,
        "val": "[585611] Podkopna Lhota 7211 [585611] Podkopná Lhota"
    },
    {
        "kod": 549461,
        "nazev": "Pohořelice",
        "popis": "[549461] Pohořelice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 549461,
        "val": "[549461] Pohorelice 7205 [549461] Pohořelice"
    },
    {
        "kod": 549533,
        "nazev": "Poteč",
        "popis": "[549533] Poteč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 549533,
        "val": "[549533] Potec 7209 [549533] Poteč"
    },
    {
        "kod": 549401,
        "nazev": "Pozlovice",
        "popis": "[549401] Pozlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 549401,
        "val": "[549401] Pozlovice 7204 [549401] Pozlovice"
    },
    {
        "kod": 585661,
        "nazev": "Provodov",
        "popis": "[585661] Provodov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585661,
        "val": "[585661] Provodov 7213 [585661] Provodov"
    },
    {
        "kod": 585670,
        "nazev": "Racková",
        "popis": "[585670] Racková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585670,
        "val": "[585670] Rackova 7213 [585670] Racková"
    },
    {
        "kod": 556980,
        "nazev": "Rokytnice",
        "popis": "[556980] Rokytnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 556980,
        "val": "[556980] Rokytnice 7209 [556980] Rokytnice"
    },
    {
        "kod": 586919,
        "nazev": "Rudimov",
        "popis": "[586919] Rudimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 586919,
        "val": "[586919] Rudimov 7204 [586919] Rudimov"
    },
    {
        "kod": 585726,
        "nazev": "Sazovice",
        "popis": "[585726] Sazovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585726,
        "val": "[585726] Sazovice 7213 [585726] Sazovice"
    },
    {
        "kod": 585734,
        "nazev": "Sehradice",
        "popis": "[585734] Sehradice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585734,
        "val": "[585734] Sehradice 7204 [585734] Sehradice"
    },
    {
        "kod": 585751,
        "nazev": "Slavičín",
        "popis": "[585751] Slavičín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585751,
        "val": "[585751] Slavicin 7204 [585751] Slavičín"
    },
    {
        "kod": 585769,
        "nazev": "Slopné",
        "popis": "[585769] Slopné",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585769,
        "val": "[585769] Slopne 7204 [585769] Slopné"
    },
    {
        "kod": 585777,
        "nazev": "Slušovice",
        "popis": "[585777] Slušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585777,
        "val": "[585777] Slusovice 7211 [585777] Slušovice"
    },
    {
        "kod": 585793,
        "nazev": "Spytihněv",
        "popis": "[585793] Spytihněv",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 585793,
        "val": "[585793] Spytihnev 7205 [585793] Spytihněv"
    },
    {
        "kod": 585807,
        "nazev": "Šanov",
        "popis": "[585807] Šanov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7204,
        "iczuj": 585807,
        "val": "[585807] Sanov 7204 [585807] Šanov"
    },
    {
        "kod": 585815,
        "nazev": "Šarovy",
        "popis": "[585815] Šarovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585815,
        "val": "[585815] Sarovy 7213 [585815] Šarovy"
    },
    {
        "kod": 585831,
        "nazev": "Štítná nad Vláří-Popov",
        "popis": "[585831] Štítná nad Vláří-Popov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585831,
        "val": "[585831] Stitna nad Vlari-Popov 7209 [585831] Štítná nad Vláří-Popov"
    },
    {
        "kod": 549649,
        "nazev": "Tečovice",
        "popis": "[549649] Tečovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 549649,
        "val": "[549649] Tecovice 7213 [549649] Tečovice"
    },
    {
        "kod": 535184,
        "nazev": "Tichov",
        "popis": "[535184] Tichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 535184,
        "val": "[535184] Tichov 7209 [535184] Tichov"
    },
    {
        "kod": 585858,
        "nazev": "Tlumačov",
        "popis": "[585858] Tlumačov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 585858,
        "val": "[585858] Tlumacov 7205 [585858] Tlumačov"
    },
    {
        "kod": 585866,
        "nazev": "Trnava",
        "popis": "[585866] Trnava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585866,
        "val": "[585866] Trnava 7211 [585866] Trnava"
    },
    {
        "kod": 585874,
        "nazev": "Ublo",
        "popis": "[585874] Ublo",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585874,
        "val": "[585874] Ublo 7211 [585874] Ublo"
    },
    {
        "kod": 585882,
        "nazev": "Újezd",
        "popis": "[585882] Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585882,
        "val": "[585882] Ujezd 7209 [585882] Újezd"
    },
    {
        "kod": 585891,
        "nazev": "Valašské Klobouky",
        "popis": "[585891] Valašské Klobouky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585891,
        "val": "[585891] Valasske Klobouky 7209 [585891] Valašské Klobouky"
    },
    {
        "kod": 585912,
        "nazev": "Velký Ořechov",
        "popis": "[585912] Velký Ořechov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585912,
        "val": "[585912] Velky Orechov 7213 [585912] Velký Ořechov"
    },
    {
        "kod": 585921,
        "nazev": "Veselá",
        "popis": "[585921] Veselá",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585921,
        "val": "[585921] Vesela 7211 [585921] Veselá"
    },
    {
        "kod": 585939,
        "nazev": "Vizovice",
        "popis": "[585939] Vizovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585939,
        "val": "[585939] Vizovice 7211 [585939] Vizovice"
    },
    {
        "kod": 586994,
        "nazev": "Vlachova Lhota",
        "popis": "[586994] Vlachova Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 586994,
        "val": "[586994] Vlachova Lhota 7209 [586994] Vlachova Lhota"
    },
    {
        "kod": 585955,
        "nazev": "Vlachovice",
        "popis": "[585955] Vlachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585955,
        "val": "[585955] Vlachovice 7209 [585955] Vlachovice"
    },
    {
        "kod": 585963,
        "nazev": "Vlčková",
        "popis": "[585963] Vlčková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585963,
        "val": "[585963] Vlckova 7213 [585963] Vlčková"
    },
    {
        "kod": 585971,
        "nazev": "Všemina",
        "popis": "[585971] Všemina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585971,
        "val": "[585971] Vsemina 7211 [585971] Všemina"
    },
    {
        "kod": 585980,
        "nazev": "Vysoké Pole",
        "popis": "[585980] Vysoké Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 7209,
        "iczuj": 585980,
        "val": "[585980] Vysoke Pole 7209 [585980] Vysoké Pole"
    },
    {
        "kod": 585998,
        "nazev": "Zádveřice-Raková",
        "popis": "[585998] Zádveřice-Raková",
        "datum_od": "",
        "datum_do": "",
        "orp": 7211,
        "iczuj": 585998,
        "val": "[585998] Zadverice-Rakova 7211 [585998] Zádveřice-Raková"
    },
    {
        "kod": 585068,
        "nazev": "Zlín",
        "popis": "[585068] Zlín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 585068,
        "val": "[585068] Zlin 7213 [585068] Zlín"
    },
    {
        "kod": 500011,
        "nazev": "Želechovice nad Dřevnicí",
        "popis": "[500011] Želechovice nad Dřevnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7213,
        "iczuj": 500011,
        "val": "[500011] Zelechovice nad Drevnici 7213 [500011] Želechovice nad Dřevnicí"
    },
    {
        "kod": 586013,
        "nazev": "Žlutava",
        "popis": "[586013] Žlutava",
        "datum_od": "",
        "datum_do": "",
        "orp": 7205,
        "iczuj": 586013,
        "val": "[586013] Zlutava 7205 [586013] Žlutava"
    },
    {
        "kod": 551929,
        "nazev": "Andělská Hora",
        "popis": "[551929] Andělská Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551929,
        "val": "[551929] Andelska Hora 8103 [551929] Andělská Hora"
    },
    {
        "kod": 597198,
        "nazev": "Bílčice",
        "popis": "[597198] Bílčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597198,
        "val": "[597198] Bilcice 8103 [597198] Bílčice"
    },
    {
        "kod": 597201,
        "nazev": "Bohušov",
        "popis": "[597201] Bohušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597201,
        "val": "[597201] Bohusov 8114 [597201] Bohušov"
    },
    {
        "kod": 597210,
        "nazev": "Brantice",
        "popis": "[597210] Brantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597210,
        "val": "[597210] Brantice 8114 [597210] Brantice"
    },
    {
        "kod": 597180,
        "nazev": "Bruntál",
        "popis": "[597180] Bruntál",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597180,
        "val": "[597180] Bruntal 8103 [597180] Bruntál"
    },
    {
        "kod": 597228,
        "nazev": "Břidličná",
        "popis": "[597228] Břidličná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597228,
        "val": "[597228] Bridlicna 8120 [597228] Břidličná"
    },
    {
        "kod": 569607,
        "nazev": "Býkov-Láryšov",
        "popis": "[569607] Býkov-Láryšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 569607,
        "val": "[569607] Bykov-Larysov 8114 [569607] Býkov-Láryšov"
    },
    {
        "kod": 552003,
        "nazev": "Čaková",
        "popis": "[552003] Čaková",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 552003,
        "val": "[552003] Cakova 8114 [552003] Čaková"
    },
    {
        "kod": 597252,
        "nazev": "Dětřichov nad Bystřicí",
        "popis": "[597252] Dětřichov nad Bystřicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597252,
        "val": "[597252] Detrichov nad Bystrici 8103 [597252] Dětřichov nad Bystřicí"
    },
    {
        "kod": 551864,
        "nazev": "Dívčí Hrad",
        "popis": "[551864] Dívčí Hrad",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 551864,
        "val": "[551864] Divci Hrad 8114 [551864] Dívčí Hrad"
    },
    {
        "kod": 551708,
        "nazev": "Dlouhá Stráň",
        "popis": "[551708] Dlouhá Stráň",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551708,
        "val": "[551708] Dlouha Stran 8103 [551708] Dlouhá Stráň"
    },
    {
        "kod": 597287,
        "nazev": "Dolní Moravice",
        "popis": "[597287] Dolní Moravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597287,
        "val": "[597287] Dolni Moravice 8120 [597287] Dolní Moravice"
    },
    {
        "kod": 597317,
        "nazev": "Dvorce",
        "popis": "[597317] Dvorce",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597317,
        "val": "[597317] Dvorce 8103 [597317] Dvorce"
    },
    {
        "kod": 597325,
        "nazev": "Heřmanovice",
        "popis": "[597325] Heřmanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597325,
        "val": "[597325] Hermanovice 8114 [597325] Heřmanovice"
    },
    {
        "kod": 551872,
        "nazev": "Hlinka",
        "popis": "[551872] Hlinka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 551872,
        "val": "[551872] Hlinka 8114 [551872] Hlinka"
    },
    {
        "kod": 597341,
        "nazev": "Holčovice",
        "popis": "[597341] Holčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597341,
        "val": "[597341] Holcovice 8114 [597341] Holčovice"
    },
    {
        "kod": 597350,
        "nazev": "Horní Benešov",
        "popis": "[597350] Horní Benešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597350,
        "val": "[597350] Horni Benesov 8103 [597350] Horní Benešov"
    },
    {
        "kod": 597368,
        "nazev": "Horní Město",
        "popis": "[597368] Horní Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597368,
        "val": "[597368] Horni Mesto 8120 [597368] Horní Město"
    },
    {
        "kod": 551805,
        "nazev": "Horní Životice",
        "popis": "[551805] Horní Životice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551805,
        "val": "[551805] Horni Zivotice 8103 [551805] Horní Životice"
    },
    {
        "kod": 597392,
        "nazev": "Hošťálkovy",
        "popis": "[597392] Hošťálkovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597392,
        "val": "[597392] Hostalkovy 8114 [597392] Hošťálkovy"
    },
    {
        "kod": 597431,
        "nazev": "Janov",
        "popis": "[597431] Janov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597431,
        "val": "[597431] Janov 8114 [597431] Janov"
    },
    {
        "kod": 597449,
        "nazev": "Jindřichov",
        "popis": "[597449] Jindřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597449,
        "val": "[597449] Jindrichov 8114 [597449] Jindřichov"
    },
    {
        "kod": 597457,
        "nazev": "Jiříkov",
        "popis": "[597457] Jiříkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597457,
        "val": "[597457] Jirikov 8120 [597457] Jiříkov"
    },
    {
        "kod": 597473,
        "nazev": "Karlova Studánka",
        "popis": "[597473] Karlova Studánka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597473,
        "val": "[597473] Karlova Studanka 8103 [597473] Karlova Studánka"
    },
    {
        "kod": 597481,
        "nazev": "Karlovice",
        "popis": "[597481] Karlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597481,
        "val": "[597481] Karlovice 8103 [597481] Karlovice"
    },
    {
        "kod": 597511,
        "nazev": "Krasov",
        "popis": "[597511] Krasov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597511,
        "val": "[597511] Krasov 8114 [597511] Krasov"
    },
    {
        "kod": 597520,
        "nazev": "Krnov",
        "popis": "[597520] Krnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597520,
        "val": "[597520] Krnov 8114 [597520] Krnov"
    },
    {
        "kod": 597538,
        "nazev": "Křišťanovice",
        "popis": "[597538] Křišťanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597538,
        "val": "[597538] Kristanovice 8103 [597538] Křišťanovice"
    },
    {
        "kod": 597546,
        "nazev": "Leskovec nad Moravicí",
        "popis": "[597546] Leskovec nad Moravicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597546,
        "val": "[597546] Leskovec nad Moravici 8103 [597546] Leskovec nad Moravicí"
    },
    {
        "kod": 597554,
        "nazev": "Lichnov",
        "popis": "[597554] Lichnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597554,
        "val": "[597554] Lichnov 8114 [597554] Lichnov"
    },
    {
        "kod": 597571,
        "nazev": "Liptaň",
        "popis": "[597571] Liptaň",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597571,
        "val": "[597571] Liptan 8114 [597571] Liptaň"
    },
    {
        "kod": 597589,
        "nazev": "Lomnice",
        "popis": "[597589] Lomnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597589,
        "val": "[597589] Lomnice 8103 [597589] Lomnice"
    },
    {
        "kod": 551996,
        "nazev": "Ludvíkov",
        "popis": "[551996] Ludvíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551996,
        "val": "[551996] Ludvikov 8103 [551996] Ludvíkov"
    },
    {
        "kod": 597601,
        "nazev": "Malá Morávka",
        "popis": "[597601] Malá Morávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597601,
        "val": "[597601] Mala Moravka 8120 [597601] Malá Morávka"
    },
    {
        "kod": 551902,
        "nazev": "Malá Štáhle",
        "popis": "[551902] Malá Štáhle",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 551902,
        "val": "[551902] Mala Stahle 8120 [551902] Malá Štáhle"
    },
    {
        "kod": 597635,
        "nazev": "Město Albrechtice",
        "popis": "[597635] Město Albrechtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597635,
        "val": "[597635] Mesto Albrechtice 8114 [597635] Město Albrechtice"
    },
    {
        "kod": 551724,
        "nazev": "Mezina",
        "popis": "[551724] Mezina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551724,
        "val": "[551724] Mezina 8103 [551724] Mezina"
    },
    {
        "kod": 569526,
        "nazev": "Milotice nad Opavou",
        "popis": "[569526] Milotice nad Opavou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 569526,
        "val": "[569526] Milotice nad Opavou 8103 [569526] Milotice nad Opavou"
    },
    {
        "kod": 551732,
        "nazev": "Moravskoslezský Kočov",
        "popis": "[551732] Moravskoslezský Kočov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551732,
        "val": "[551732] Moravskoslezsky Kocov 8103 [551732] Moravskoslezský Kočov"
    },
    {
        "kod": 546950,
        "nazev": "Nová Pláň",
        "popis": "[546950] Nová Pláň",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 546950,
        "val": "[546950] Nova Plan 8103 [546950] Nová Pláň"
    },
    {
        "kod": 569551,
        "nazev": "Nové Heřminovy",
        "popis": "[569551] Nové Heřminovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 569551,
        "val": "[569551] Nove Herminovy 8103 [569551] Nové Heřminovy"
    },
    {
        "kod": 569577,
        "nazev": "Oborná",
        "popis": "[569577] Oborná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 569577,
        "val": "[569577] Oborna 8103 [569577] Oborná"
    },
    {
        "kod": 597716,
        "nazev": "Osoblaha",
        "popis": "[597716] Osoblaha",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597716,
        "val": "[597716] Osoblaha 8114 [597716] Osoblaha"
    },
    {
        "kod": 551848,
        "nazev": "Petrovice",
        "popis": "[551848] Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 551848,
        "val": "[551848] Petrovice 8114 [551848] Petrovice"
    },
    {
        "kod": 597724,
        "nazev": "Razová",
        "popis": "[597724] Razová",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597724,
        "val": "[597724] Razova 8103 [597724] Razová"
    },
    {
        "kod": 597741,
        "nazev": "Roudno",
        "popis": "[597741] Roudno",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597741,
        "val": "[597741] Roudno 8103 [597741] Roudno"
    },
    {
        "kod": 551945,
        "nazev": "Rudná pod Pradědem",
        "popis": "[551945] Rudná pod Pradědem",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551945,
        "val": "[551945] Rudna pod Pradedem 8103 [551945] Rudná pod Pradědem"
    },
    {
        "kod": 597775,
        "nazev": "Rusín",
        "popis": "[597775] Rusín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597775,
        "val": "[597775] Rusin 8114 [597775] Rusín"
    },
    {
        "kod": 597783,
        "nazev": "Rýmařov",
        "popis": "[597783] Rýmařov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597783,
        "val": "[597783] Rymarov 8120 [597783] Rýmařov"
    },
    {
        "kod": 597791,
        "nazev": "Ryžoviště",
        "popis": "[597791] Ryžoviště",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 597791,
        "val": "[597791] Ryzoviste 8120 [597791] Ryžoviště"
    },
    {
        "kod": 551881,
        "nazev": "Slezské Pavlovice",
        "popis": "[551881] Slezské Pavlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 551881,
        "val": "[551881] Slezske Pavlovice 8114 [551881] Slezské Pavlovice"
    },
    {
        "kod": 597813,
        "nazev": "Slezské Rudoltice",
        "popis": "[597813] Slezské Rudoltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597813,
        "val": "[597813] Slezske Rudoltice 8114 [597813] Slezské Rudoltice"
    },
    {
        "kod": 551911,
        "nazev": "Stará Ves",
        "popis": "[551911] Stará Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 551911,
        "val": "[551911] Stara Ves 8120 [551911] Stará Ves"
    },
    {
        "kod": 551813,
        "nazev": "Staré Heřminovy",
        "popis": "[551813] Staré Heřminovy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551813,
        "val": "[551813] Stare Herminovy 8103 [551813] Staré Heřminovy"
    },
    {
        "kod": 551767,
        "nazev": "Staré Město",
        "popis": "[551767] Staré Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551767,
        "val": "[551767] Stare Mesto 8103 [551767] Staré Město"
    },
    {
        "kod": 597872,
        "nazev": "Světlá Hora",
        "popis": "[597872] Světlá Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597872,
        "val": "[597872] Svetla Hora 8103 [597872] Světlá Hora"
    },
    {
        "kod": 597881,
        "nazev": "Svobodné Heřmanice",
        "popis": "[597881] Svobodné Heřmanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597881,
        "val": "[597881] Svobodne Hermanice 8103 [597881] Svobodné Heřmanice"
    },
    {
        "kod": 597899,
        "nazev": "Široká Niva",
        "popis": "[597899] Široká Niva",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597899,
        "val": "[597899] Siroka Niva 8103 [597899] Široká Niva"
    },
    {
        "kod": 597911,
        "nazev": "Třemešná",
        "popis": "[597911] Třemešná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597911,
        "val": "[597911] Tremesna 8114 [597911] Třemešná"
    },
    {
        "kod": 551821,
        "nazev": "Tvrdkov",
        "popis": "[551821] Tvrdkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 551821,
        "val": "[551821] Tvrdkov 8120 [551821] Tvrdkov"
    },
    {
        "kod": 597937,
        "nazev": "Úvalno",
        "popis": "[597937] Úvalno",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597937,
        "val": "[597937] Uvalno 8114 [597937] Úvalno"
    },
    {
        "kod": 597945,
        "nazev": "Václavov u Bruntálu",
        "popis": "[597945] Václavov u Bruntálu",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597945,
        "val": "[597945] Vaclavov u Bruntalu 8103 [597945] Václavov u Bruntálu"
    },
    {
        "kod": 551783,
        "nazev": "Valšov",
        "popis": "[551783] Valšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 551783,
        "val": "[551783] Valsov 8103 [551783] Valšov"
    },
    {
        "kod": 551694,
        "nazev": "Velká Štáhle",
        "popis": "[551694] Velká Štáhle",
        "datum_od": "",
        "datum_do": "",
        "orp": 8120,
        "iczuj": 551694,
        "val": "[551694] Velka Stahle 8120 [551694] Velká Štáhle"
    },
    {
        "kod": 597961,
        "nazev": "Vrbno pod Pradědem",
        "popis": "[597961] Vrbno pod Pradědem",
        "datum_od": "",
        "datum_do": "",
        "orp": 8103,
        "iczuj": 597961,
        "val": "[597961] Vrbno pod Pradedem 8103 [597961] Vrbno pod Pradědem"
    },
    {
        "kod": 597970,
        "nazev": "Vysoká",
        "popis": "[597970] Vysoká",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597970,
        "val": "[597970] Vysoka 8114 [597970] Vysoká"
    },
    {
        "kod": 597988,
        "nazev": "Zátor",
        "popis": "[597988] Zátor",
        "datum_od": "",
        "datum_do": "",
        "orp": 8114,
        "iczuj": 597988,
        "val": "[597988] Zator 8114 [597988] Zátor"
    },
    {
        "kod": 598011,
        "nazev": "Baška",
        "popis": "[598011] Baška",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598011,
        "val": "[598011] Baska 8106 [598011] Baška"
    },
    {
        "kod": 598020,
        "nazev": "Bílá",
        "popis": "[598020] Bílá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598020,
        "val": "[598020] Bila 8107 [598020] Bílá"
    },
    {
        "kod": 511633,
        "nazev": "Bocanovice",
        "popis": "[511633] Bocanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 511633,
        "val": "[511633] Bocanovice 8110 [511633] Bocanovice"
    },
    {
        "kod": 598038,
        "nazev": "Brušperk",
        "popis": "[598038] Brušperk",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598038,
        "val": "[598038] Brusperk 8106 [598038] Brušperk"
    },
    {
        "kod": 598046,
        "nazev": "Bruzovice",
        "popis": "[598046] Bruzovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598046,
        "val": "[598046] Bruzovice 8106 [598046] Bruzovice"
    },
    {
        "kod": 511935,
        "nazev": "Bukovec",
        "popis": "[511935] Bukovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 511935,
        "val": "[511935] Bukovec 8110 [511935] Bukovec"
    },
    {
        "kod": 598062,
        "nazev": "Bystřice",
        "popis": "[598062] Bystřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 598062,
        "val": "[598062] Bystrice 8121 [598062] Bystřice"
    },
    {
        "kod": 598071,
        "nazev": "Čeladná",
        "popis": "[598071] Čeladná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598071,
        "val": "[598071] Celadna 8107 [598071] Čeladná"
    },
    {
        "kod": 598089,
        "nazev": "Dobrá",
        "popis": "[598089] Dobrá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598089,
        "val": "[598089] Dobra 8106 [598089] Dobrá"
    },
    {
        "kod": 552542,
        "nazev": "Dobratice",
        "popis": "[552542] Dobratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552542,
        "val": "[552542] Dobratice 8106 [552542] Dobratice"
    },
    {
        "kod": 598101,
        "nazev": "Dolní Domaslavice",
        "popis": "[598101] Dolní Domaslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598101,
        "val": "[598101] Dolni Domaslavice 8106 [598101] Dolní Domaslavice"
    },
    {
        "kod": 511951,
        "nazev": "Dolní Lomná",
        "popis": "[511951] Dolní Lomná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 511951,
        "val": "[511951] Dolni Lomna 8110 [511951] Dolní Lomná"
    },
    {
        "kod": 552607,
        "nazev": "Dolní Tošanovice",
        "popis": "[552607] Dolní Tošanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552607,
        "val": "[552607] Dolni Tosanovice 8106 [552607] Dolní Tošanovice"
    },
    {
        "kod": 598135,
        "nazev": "Fryčovice",
        "popis": "[598135] Fryčovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598135,
        "val": "[598135] Frycovice 8106 [598135] Fryčovice"
    },
    {
        "kod": 598003,
        "nazev": "Frýdek-Místek",
        "popis": "[598003] Frýdek-Místek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598003,
        "val": "[598003] Frydek-Mistek 8106 [598003] Frýdek-Místek"
    },
    {
        "kod": 598143,
        "nazev": "Frýdlant nad Ostravicí",
        "popis": "[598143] Frýdlant nad Ostravicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598143,
        "val": "[598143] Frydlant nad Ostravici 8107 [598143] Frýdlant nad Ostravicí"
    },
    {
        "kod": 598160,
        "nazev": "Hnojník",
        "popis": "[598160] Hnojník",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 598160,
        "val": "[598160] Hnojnik 8121 [598160] Hnojník"
    },
    {
        "kod": 512192,
        "nazev": "Horní Domaslavice",
        "popis": "[512192] Horní Domaslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 512192,
        "val": "[512192] Horni Domaslavice 8106 [512192] Horní Domaslavice"
    },
    {
        "kod": 511986,
        "nazev": "Horní Lomná",
        "popis": "[511986] Horní Lomná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 511986,
        "val": "[511986] Horni Lomna 8110 [511986] Horní Lomná"
    },
    {
        "kod": 552631,
        "nazev": "Horní Tošanovice",
        "popis": "[552631] Horní Tošanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552631,
        "val": "[552631] Horni Tosanovice 8106 [552631] Horní Tošanovice"
    },
    {
        "kod": 512176,
        "nazev": "Hrádek",
        "popis": "[512176] Hrádek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 512176,
        "val": "[512176] Hradek 8110 [512176] Hrádek"
    },
    {
        "kod": 598232,
        "nazev": "Hrčava",
        "popis": "[598232] Hrčava",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 598232,
        "val": "[598232] Hrcava 8110 [598232] Hrčava"
    },
    {
        "kod": 598691,
        "nazev": "Hukvaldy",
        "popis": "[598691] Hukvaldy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598691,
        "val": "[598691] Hukvaldy 8106 [598691] Hukvaldy"
    },
    {
        "kod": 598259,
        "nazev": "Jablunkov",
        "popis": "[598259] Jablunkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 598259,
        "val": "[598259] Jablunkov 8110 [598259] Jablunkov"
    },
    {
        "kod": 507423,
        "nazev": "Janovice",
        "popis": "[507423] Janovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 507423,
        "val": "[507423] Janovice 8107 [507423] Janovice"
    },
    {
        "kod": 598275,
        "nazev": "Kaňovice",
        "popis": "[598275] Kaňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598275,
        "val": "[598275] Kanovice 8106 [598275] Kaňovice"
    },
    {
        "kod": 507237,
        "nazev": "Komorní Lhotka",
        "popis": "[507237] Komorní Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 507237,
        "val": "[507237] Komorni Lhotka 8121 [507237] Komorní Lhotka"
    },
    {
        "kod": 507458,
        "nazev": "Košařiska",
        "popis": "[507458] Košařiska",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 507458,
        "val": "[507458] Kosariska 8121 [507458] Košařiska"
    },
    {
        "kod": 598321,
        "nazev": "Kozlovice",
        "popis": "[598321] Kozlovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598321,
        "val": "[598321] Kozlovice 8106 [598321] Kozlovice"
    },
    {
        "kod": 549673,
        "nazev": "Krásná",
        "popis": "[549673] Krásná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 549673,
        "val": "[549673] Krasna 8106 [549673] Krásná"
    },
    {
        "kod": 598348,
        "nazev": "Krmelín",
        "popis": "[598348] Krmelín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598348,
        "val": "[598348] Krmelin 8106 [598348] Krmelín"
    },
    {
        "kod": 598356,
        "nazev": "Kunčice pod Ondřejníkem",
        "popis": "[598356] Kunčice pod Ondřejníkem",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598356,
        "val": "[598356] Kuncice pod Ondrejnikem 8107 [598356] Kunčice pod Ondřejníkem"
    },
    {
        "kod": 598364,
        "nazev": "Lhotka",
        "popis": "[598364] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598364,
        "val": "[598364] Lhotka 8106 [598364] Lhotka"
    },
    {
        "kod": 598399,
        "nazev": "Lučina",
        "popis": "[598399] Lučina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598399,
        "val": "[598399] Lucina 8106 [598399] Lučina"
    },
    {
        "kod": 552593,
        "nazev": "Malenovice",
        "popis": "[552593] Malenovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 552593,
        "val": "[552593] Malenovice 8107 [552593] Malenovice"
    },
    {
        "kod": 512184,
        "nazev": "Metylovice",
        "popis": "[512184] Metylovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 512184,
        "val": "[512184] Metylovice 8107 [512184] Metylovice"
    },
    {
        "kod": 507547,
        "nazev": "Milíkov",
        "popis": "[507547] Milíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 507547,
        "val": "[507547] Milikov 8110 [507547] Milíkov"
    },
    {
        "kod": 598445,
        "nazev": "Morávka",
        "popis": "[598445] Morávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598445,
        "val": "[598445] Moravka 8106 [598445] Morávka"
    },
    {
        "kod": 598453,
        "nazev": "Mosty u Jablunkova",
        "popis": "[598453] Mosty u Jablunkova",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 598453,
        "val": "[598453] Mosty u Jablunkova 8110 [598453] Mosty u Jablunkova"
    },
    {
        "kod": 554014,
        "nazev": "Návsí",
        "popis": "[554014] Návsí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 554014,
        "val": "[554014] Navsi 8110 [554014] Návsí"
    },
    {
        "kod": 552526,
        "nazev": "Nižní Lhoty",
        "popis": "[552526] Nižní Lhoty",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552526,
        "val": "[552526] Nizni Lhoty 8106 [552526] Nižní Lhoty"
    },
    {
        "kod": 552518,
        "nazev": "Nošovice",
        "popis": "[552518] Nošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552518,
        "val": "[552518] Nosovice 8106 [552518] Nošovice"
    },
    {
        "kod": 507091,
        "nazev": "Nýdek",
        "popis": "[507091] Nýdek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 507091,
        "val": "[507091] Nydek 8121 [507091] Nýdek"
    },
    {
        "kod": 598542,
        "nazev": "Ostravice",
        "popis": "[598542] Ostravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598542,
        "val": "[598542] Ostravice 8107 [598542] Ostravice"
    },
    {
        "kod": 598551,
        "nazev": "Palkovice",
        "popis": "[598551] Palkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598551,
        "val": "[598551] Palkovice 8106 [598551] Palkovice"
    },
    {
        "kod": 598569,
        "nazev": "Paskov",
        "popis": "[598569] Paskov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598569,
        "val": "[598569] Paskov 8106 [598569] Paskov"
    },
    {
        "kod": 552500,
        "nazev": "Pazderna",
        "popis": "[552500] Pazderna",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552500,
        "val": "[552500] Pazderna 8106 [552500] Pazderna"
    },
    {
        "kod": 557226,
        "nazev": "Písečná",
        "popis": "[557226] Písečná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 557226,
        "val": "[557226] Pisecna 8110 [557226] Písečná"
    },
    {
        "kod": 512028,
        "nazev": "Písek",
        "popis": "[512028] Písek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8110,
        "iczuj": 512028,
        "val": "[512028] Pisek 8110 [512028] Písek"
    },
    {
        "kod": 568813,
        "nazev": "Pražmo",
        "popis": "[568813] Pražmo",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 568813,
        "val": "[568813] Prazmo 8106 [568813] Pražmo"
    },
    {
        "kod": 507181,
        "nazev": "Pržno",
        "popis": "[507181] Pržno",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 507181,
        "val": "[507181] Przno 8107 [507181] Pržno"
    },
    {
        "kod": 552577,
        "nazev": "Pstruží",
        "popis": "[552577] Pstruží",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 552577,
        "val": "[552577] Pstruzi 8107 [552577] Pstruží"
    },
    {
        "kod": 549665,
        "nazev": "Raškovice",
        "popis": "[549665] Raškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 549665,
        "val": "[549665] Raskovice 8106 [549665] Raškovice"
    },
    {
        "kod": 556971,
        "nazev": "Ropice",
        "popis": "[556971] Ropice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 556971,
        "val": "[556971] Ropice 8121 [556971] Ropice"
    },
    {
        "kod": 552640,
        "nazev": "Řeka",
        "popis": "[552640] Řeka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 552640,
        "val": "[552640] Reka 8121 [552640] Řeka"
    },
    {
        "kod": 568830,
        "nazev": "Řepiště",
        "popis": "[568830] Řepiště",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 568830,
        "val": "[568830] Repiste 8106 [568830] Řepiště"
    },
    {
        "kod": 598674,
        "nazev": "Sedliště",
        "popis": "[598674] Sedliště",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 598674,
        "val": "[598674] Sedliste 8106 [598674] Sedliště"
    },
    {
        "kod": 552658,
        "nazev": "Smilovice",
        "popis": "[552658] Smilovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 552658,
        "val": "[552658] Smilovice 8121 [552658] Smilovice"
    },
    {
        "kod": 568791,
        "nazev": "Soběšovice",
        "popis": "[568791] Soběšovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 568791,
        "val": "[568791] Sobesovice 8106 [568791] Soběšovice"
    },
    {
        "kod": 598747,
        "nazev": "Staré Hamry",
        "popis": "[598747] Staré Hamry",
        "datum_od": "",
        "datum_do": "",
        "orp": 8107,
        "iczuj": 598747,
        "val": "[598747] Stare Hamry 8107 [598747] Staré Hamry"
    },
    {
        "kod": 552551,
        "nazev": "Staré Město",
        "popis": "[552551] Staré Město",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552551,
        "val": "[552551] Stare Mesto 8106 [552551] Staré Město"
    },
    {
        "kod": 552569,
        "nazev": "Staříč",
        "popis": "[552569] Staříč",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552569,
        "val": "[552569] Staric 8106 [552569] Staříč"
    },
    {
        "kod": 552674,
        "nazev": "Střítež",
        "popis": "[552674] Střítež",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 552674,
        "val": "[552674] Stritez 8121 [552674] Střítež"
    },
    {
        "kod": 569631,
        "nazev": "Sviadnov",
        "popis": "[569631] Sviadnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 569631,
        "val": "[569631] Sviadnov 8106 [569631] Sviadnov"
    },
    {
        "kod": 552623,
        "nazev": "Třanovice",
        "popis": "[552623] Třanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552623,
        "val": "[552623] Tranovice 8106 [552623] Třanovice"
    },
    {
        "kod": 598810,
        "nazev": "Třinec",
        "popis": "[598810] Třinec",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 598810,
        "val": "[598810] Trinec 8121 [598810] Třinec"
    },
    {
        "kod": 552615,
        "nazev": "Vělopolí",
        "popis": "[552615] Vělopolí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 552615,
        "val": "[552615] Velopoli 8121 [552615] Vělopolí"
    },
    {
        "kod": 554928,
        "nazev": "Vendryně",
        "popis": "[554928] Vendryně",
        "datum_od": "",
        "datum_do": "",
        "orp": 8121,
        "iczuj": 554928,
        "val": "[554928] Vendryne 8121 [554928] Vendryně"
    },
    {
        "kod": 552488,
        "nazev": "Vojkovice",
        "popis": "[552488] Vojkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552488,
        "val": "[552488] Vojkovice 8106 [552488] Vojkovice"
    },
    {
        "kod": 552682,
        "nazev": "Vyšní Lhoty",
        "popis": "[552682] Vyšní Lhoty",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552682,
        "val": "[552682] Vysni Lhoty 8106 [552682] Vyšní Lhoty"
    },
    {
        "kod": 552691,
        "nazev": "Žabeň",
        "popis": "[552691] Žabeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 552691,
        "val": "[552691] Zaben 8106 [552691] Žabeň"
    },
    {
        "kod": 568163,
        "nazev": "Žermanice",
        "popis": "[568163] Žermanice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8106,
        "iczuj": 568163,
        "val": "[568163] Zermanice 8106 [568163] Žermanice"
    },
    {
        "kod": 598925,
        "nazev": "Albrechtice",
        "popis": "[598925] Albrechtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8108,
        "iczuj": 598925,
        "val": "[598925] Albrechtice 8108 [598925] Albrechtice"
    },
    {
        "kod": 599051,
        "nazev": "Bohumín",
        "popis": "[599051] Bohumín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8102,
        "iczuj": 599051,
        "val": "[599051] Bohumin 8102 [599051] Bohumín"
    },
    {
        "kod": 598933,
        "nazev": "Český Těšín",
        "popis": "[598933] Český Těšín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8104,
        "iczuj": 598933,
        "val": "[598933] Cesky Tesin 8104 [598933] Český Těšín"
    },
    {
        "kod": 598941,
        "nazev": "Dětmarovice",
        "popis": "[598941] Dětmarovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8111,
        "iczuj": 598941,
        "val": "[598941] Detmarovice 8111 [598941] Dětmarovice"
    },
    {
        "kod": 598968,
        "nazev": "Dolní Lutyně",
        "popis": "[598968] Dolní Lutyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 8102,
        "iczuj": 598968,
        "val": "[598968] Dolni Lutyne 8102 [598968] Dolní Lutyně"
    },
    {
        "kod": 568864,
        "nazev": "Doubrava",
        "popis": "[568864] Doubrava",
        "datum_od": "",
        "datum_do": "",
        "orp": 8118,
        "iczuj": 568864,
        "val": "[568864] Doubrava 8118 [568864] Doubrava"
    },
    {
        "kod": 555088,
        "nazev": "Havířov",
        "popis": "[555088] Havířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8108,
        "iczuj": 555088,
        "val": "[555088] Havirov 8108 [555088] Havířov"
    },
    {
        "kod": 598178,
        "nazev": "Horní Bludovice",
        "popis": "[598178] Horní Bludovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8108,
        "iczuj": 598178,
        "val": "[598178] Horni Bludovice 8108 [598178] Horní Bludovice"
    },
    {
        "kod": 552739,
        "nazev": "Horní Suchá",
        "popis": "[552739] Horní Suchá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8108,
        "iczuj": 552739,
        "val": "[552739] Horni Sucha 8108 [552739] Horní Suchá"
    },
    {
        "kod": 555291,
        "nazev": "Chotěbuz",
        "popis": "[555291] Chotěbuz",
        "datum_od": "",
        "datum_do": "",
        "orp": 8104,
        "iczuj": 555291,
        "val": "[555291] Chotebuz 8104 [555291] Chotěbuz"
    },
    {
        "kod": 598917,
        "nazev": "Karviná",
        "popis": "[598917] Karviná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8111,
        "iczuj": 598917,
        "val": "[598917] Karvina 8111 [598917] Karviná"
    },
    {
        "kod": 599069,
        "nazev": "Orlová",
        "popis": "[599069] Orlová",
        "datum_od": "",
        "datum_do": "",
        "orp": 8118,
        "iczuj": 599069,
        "val": "[599069] Orlova 8118 [599069] Orlová"
    },
    {
        "kod": 599077,
        "nazev": "Petrovice u Karviné",
        "popis": "[599077] Petrovice u Karviné",
        "datum_od": "",
        "datum_do": "",
        "orp": 8111,
        "iczuj": 599077,
        "val": "[599077] Petrovice u Karvine 8111 [599077] Petrovice u Karviné"
    },
    {
        "kod": 599085,
        "nazev": "Petřvald",
        "popis": "[599085] Petřvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 8118,
        "iczuj": 599085,
        "val": "[599085] Petrvald 8118 [599085] Petřvald"
    },
    {
        "kod": 599107,
        "nazev": "Rychvald",
        "popis": "[599107] Rychvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 8102,
        "iczuj": 599107,
        "val": "[599107] Rychvald 8102 [599107] Rychvald"
    },
    {
        "kod": 599140,
        "nazev": "Stonava",
        "popis": "[599140] Stonava",
        "datum_od": "",
        "datum_do": "",
        "orp": 8111,
        "iczuj": 599140,
        "val": "[599140] Stonava 8111 [599140] Stonava"
    },
    {
        "kod": 599158,
        "nazev": "Těrlicko",
        "popis": "[599158] Těrlicko",
        "datum_od": "",
        "datum_do": "",
        "orp": 8108,
        "iczuj": 599158,
        "val": "[599158] Terlicko 8108 [599158] Těrlicko"
    },
    {
        "kod": 568741,
        "nazev": "Albrechtičky",
        "popis": "[568741] Albrechtičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 568741,
        "val": "[568741] Albrechticky 8101 [568741] Albrechtičky"
    },
    {
        "kod": 599212,
        "nazev": "Bartošovice",
        "popis": "[599212] Bartošovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599212,
        "val": "[599212] Bartosovice 8115 [599212] Bartošovice"
    },
    {
        "kod": 568481,
        "nazev": "Bernartice nad Odrou",
        "popis": "[568481] Bernartice nad Odrou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 568481,
        "val": "[568481] Bernartice nad Odrou 8115 [568481] Bernartice nad Odrou"
    },
    {
        "kod": 546984,
        "nazev": "Bílov",
        "popis": "[546984] Bílov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 546984,
        "val": "[546984] Bilov 8101 [546984] Bílov"
    },
    {
        "kod": 599247,
        "nazev": "Bílovec",
        "popis": "[599247] Bílovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 599247,
        "val": "[599247] Bilovec 8101 [599247] Bílovec"
    },
    {
        "kod": 554936,
        "nazev": "Bítov",
        "popis": "[554936] Bítov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 554936,
        "val": "[554936] Bitov 8101 [554936] Bítov"
    },
    {
        "kod": 568431,
        "nazev": "Bordovice",
        "popis": "[568431] Bordovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 568431,
        "val": "[568431] Bordovice 8105 [568431] Bordovice"
    },
    {
        "kod": 556858,
        "nazev": "Bravantice",
        "popis": "[556858] Bravantice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 556858,
        "val": "[556858] Bravantice 8101 [556858] Bravantice"
    },
    {
        "kod": 599344,
        "nazev": "Frenštát pod Radhoštěm",
        "popis": "[599344] Frenštát pod Radhoštěm",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 599344,
        "val": "[599344] Frenstat pod Radhostem 8105 [599344] Frenštát pod Radhoštěm"
    },
    {
        "kod": 599352,
        "nazev": "Fulnek",
        "popis": "[599352] Fulnek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 599352,
        "val": "[599352] Fulnek 8116 [599352] Fulnek"
    },
    {
        "kod": 568562,
        "nazev": "Heřmanice u Oder",
        "popis": "[568562] Heřmanice u Oder",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 568562,
        "val": "[568562] Hermanice u Oder 8116 [568562] Heřmanice u Oder"
    },
    {
        "kod": 568571,
        "nazev": "Heřmánky",
        "popis": "[568571] Heřmánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 568571,
        "val": "[568571] Hermanky 8116 [568571] Heřmánky"
    },
    {
        "kod": 569666,
        "nazev": "Hladké Životice",
        "popis": "[569666] Hladké Životice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 569666,
        "val": "[569666] Hladke Zivotice 8115 [569666] Hladké Životice"
    },
    {
        "kod": 599409,
        "nazev": "Hodslavice",
        "popis": "[599409] Hodslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599409,
        "val": "[599409] Hodslavice 8115 [599409] Hodslavice"
    },
    {
        "kod": 568511,
        "nazev": "Hostašovice",
        "popis": "[568511] Hostašovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 568511,
        "val": "[568511] Hostasovice 8115 [568511] Hostašovice"
    },
    {
        "kod": 554065,
        "nazev": "Jakubčovice nad Odrou",
        "popis": "[554065] Jakubčovice nad Odrou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 554065,
        "val": "[554065] Jakubcovice nad Odrou 8116 [554065] Jakubčovice nad Odrou"
    },
    {
        "kod": 599468,
        "nazev": "Jeseník nad Odrou",
        "popis": "[599468] Jeseník nad Odrou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599468,
        "val": "[599468] Jesenik nad Odrou 8115 [599468] Jeseník nad Odrou"
    },
    {
        "kod": 599506,
        "nazev": "Jistebník",
        "popis": "[599506] Jistebník",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 599506,
        "val": "[599506] Jistebnik 8101 [599506] Jistebník"
    },
    {
        "kod": 568643,
        "nazev": "Kateřinice",
        "popis": "[568643] Kateřinice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 568643,
        "val": "[568643] Katerinice 8112 [568643] Kateřinice"
    },
    {
        "kod": 599565,
        "nazev": "Kopřivnice",
        "popis": "[599565] Kopřivnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 599565,
        "val": "[599565] Koprivnice 8112 [599565] Kopřivnice"
    },
    {
        "kod": 555312,
        "nazev": "Kujavy",
        "popis": "[555312] Kujavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 555312,
        "val": "[555312] Kujavy 8101 [555312] Kujavy"
    },
    {
        "kod": 568546,
        "nazev": "Kunín",
        "popis": "[568546] Kunín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 568546,
        "val": "[568546] Kunin 8115 [568546] Kunín"
    },
    {
        "kod": 500046,
        "nazev": "Libhošť",
        "popis": "[500046] Libhošť",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 500046,
        "val": "[500046] Libhost 8115 [500046] Libhošť"
    },
    {
        "kod": 599603,
        "nazev": "Lichnov",
        "popis": "[599603] Lichnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 599603,
        "val": "[599603] Lichnov 8105 [599603] Lichnov"
    },
    {
        "kod": 599646,
        "nazev": "Luboměř",
        "popis": "[599646] Luboměř",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 599646,
        "val": "[599646] Lubomer 8116 [599646] Luboměř"
    },
    {
        "kod": 568589,
        "nazev": "Mankovice",
        "popis": "[568589] Mankovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 568589,
        "val": "[568589] Mankovice 8116 [568589] Mankovice"
    },
    {
        "kod": 599689,
        "nazev": "Mořkov",
        "popis": "[599689] Mořkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599689,
        "val": "[599689] Morkov 8115 [599689] Mořkov"
    },
    {
        "kod": 568686,
        "nazev": "Mošnov",
        "popis": "[568686] Mošnov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 568686,
        "val": "[568686] Mosnov 8112 [568686] Mošnov"
    },
    {
        "kod": 599191,
        "nazev": "Nový Jičín",
        "popis": "[599191] Nový Jičín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599191,
        "val": "[599191] Novy Jicin 8115 [599191] Nový Jičín"
    },
    {
        "kod": 599701,
        "nazev": "Odry",
        "popis": "[599701] Odry",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 599701,
        "val": "[599701] Odry 8116 [599701] Odry"
    },
    {
        "kod": 599743,
        "nazev": "Petřvald",
        "popis": "[599743] Petřvald",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 599743,
        "val": "[599743] Petrvald 8112 [599743] Petřvald"
    },
    {
        "kod": 599808,
        "nazev": "Příbor",
        "popis": "[599808] Příbor",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 599808,
        "val": "[599808] Pribor 8112 [599808] Příbor"
    },
    {
        "kod": 568775,
        "nazev": "Pustějov",
        "popis": "[568775] Pustějov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 568775,
        "val": "[568775] Pustejov 8101 [568775] Pustějov"
    },
    {
        "kod": 568554,
        "nazev": "Rybí",
        "popis": "[568554] Rybí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 568554,
        "val": "[568554] Rybi 8115 [568554] Rybí"
    },
    {
        "kod": 599832,
        "nazev": "Sedlnice",
        "popis": "[599832] Sedlnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599832,
        "val": "[599832] Sedlnice 8115 [599832] Sedlnice"
    },
    {
        "kod": 568716,
        "nazev": "Skotnice",
        "popis": "[568716] Skotnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 568716,
        "val": "[568716] Skotnice 8112 [568716] Skotnice"
    },
    {
        "kod": 568406,
        "nazev": "Slatina",
        "popis": "[568406] Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 568406,
        "val": "[568406] Slatina 8101 [568406] Slatina"
    },
    {
        "kod": 599867,
        "nazev": "Spálov",
        "popis": "[599867] Spálov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 599867,
        "val": "[599867] Spalov 8116 [599867] Spálov"
    },
    {
        "kod": 599905,
        "nazev": "Starý Jičín",
        "popis": "[599905] Starý Jičín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599905,
        "val": "[599905] Stary Jicin 8115 [599905] Starý Jičín"
    },
    {
        "kod": 599921,
        "nazev": "Studénka",
        "popis": "[599921] Studénka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 599921,
        "val": "[599921] Studenka 8101 [599921] Studénka"
    },
    {
        "kod": 599930,
        "nazev": "Suchdol nad Odrou",
        "popis": "[599930] Suchdol nad Odrou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 599930,
        "val": "[599930] Suchdol nad Odrou 8115 [599930] Suchdol nad Odrou"
    },
    {
        "kod": 554171,
        "nazev": "Šenov u Nového Jičína",
        "popis": "[554171] Šenov u Nového Jičína",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 554171,
        "val": "[554171] Senov u Noveho Jicina 8115 [554171] Šenov u Nového Jičína"
    },
    {
        "kod": 599948,
        "nazev": "Štramberk",
        "popis": "[599948] Štramberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 599948,
        "val": "[599948] Stramberk 8112 [599948] Štramberk"
    },
    {
        "kod": 599956,
        "nazev": "Tichá",
        "popis": "[599956] Tichá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 599956,
        "val": "[599956] Ticha 8105 [599956] Tichá"
    },
    {
        "kod": 599964,
        "nazev": "Tísek",
        "popis": "[599964] Tísek",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 599964,
        "val": "[599964] Tisek 8101 [599964] Tísek"
    },
    {
        "kod": 569755,
        "nazev": "Trnávka",
        "popis": "[569755] Trnávka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 569755,
        "val": "[569755] Trnavka 8112 [569755] Trnávka"
    },
    {
        "kod": 599999,
        "nazev": "Trojanovice",
        "popis": "[599999] Trojanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 599999,
        "val": "[599999] Trojanovice 8105 [599999] Trojanovice"
    },
    {
        "kod": 568422,
        "nazev": "Velké Albrechtice",
        "popis": "[568422] Velké Albrechtice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8101,
        "iczuj": 568422,
        "val": "[568422] Velke Albrechtice 8101 [568422] Velké Albrechtice"
    },
    {
        "kod": 500259,
        "nazev": "Veřovice",
        "popis": "[500259] Veřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8105,
        "iczuj": 500259,
        "val": "[500259] Verovice 8105 [500259] Veřovice"
    },
    {
        "kod": 554910,
        "nazev": "Vražné",
        "popis": "[554910] Vražné",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 554910,
        "val": "[554910] Vrazne 8116 [554910] Vražné"
    },
    {
        "kod": 569747,
        "nazev": "Vrchy",
        "popis": "[569747] Vrchy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8116,
        "iczuj": 569747,
        "val": "[569747] Vrchy 8116 [569747] Vrchy"
    },
    {
        "kod": 568473,
        "nazev": "Závišice",
        "popis": "[568473] Závišice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 568473,
        "val": "[568473] Zavisice 8112 [568473] Závišice"
    },
    {
        "kod": 568732,
        "nazev": "Ženklava",
        "popis": "[568732] Ženklava",
        "datum_od": "",
        "datum_do": "",
        "orp": 8112,
        "iczuj": 568732,
        "val": "[568732] Zenklava 8112 [568732] Ženklava"
    },
    {
        "kod": 547000,
        "nazev": "Životice u Nového Jičína",
        "popis": "[547000] Životice u Nového Jičína",
        "datum_od": "",
        "datum_do": "",
        "orp": 8115,
        "iczuj": 547000,
        "val": "[547000] Zivotice u Noveho Jicina 8115 [547000] Životice u Nového Jičína"
    },
    {
        "kod": 512974,
        "nazev": "Bělá",
        "popis": "[512974] Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 512974,
        "val": "[512974] Bela 8109 [512974] Bělá"
    },
    {
        "kod": 506192,
        "nazev": "Bohuslavice",
        "popis": "[506192] Bohuslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 506192,
        "val": "[506192] Bohuslavice 8109 [506192] Bohuslavice"
    },
    {
        "kod": 506214,
        "nazev": "Bolatice",
        "popis": "[506214] Bolatice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 506214,
        "val": "[506214] Bolatice 8113 [506214] Bolatice"
    },
    {
        "kod": 554197,
        "nazev": "Branka u Opavy",
        "popis": "[554197] Branka u Opavy",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 554197,
        "val": "[554197] Branka u Opavy 8117 [554197] Branka u Opavy"
    },
    {
        "kod": 553107,
        "nazev": "Bratříkovice",
        "popis": "[553107] Bratříkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553107,
        "val": "[553107] Bratrikovice 8117 [553107] Bratříkovice"
    },
    {
        "kod": 506320,
        "nazev": "Brumovice",
        "popis": "[506320] Brumovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 506320,
        "val": "[506320] Brumovice 8117 [506320] Brumovice"
    },
    {
        "kod": 506451,
        "nazev": "Březová",
        "popis": "[506451] Březová",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 506451,
        "val": "[506451] Brezova 8122 [506451] Březová"
    },
    {
        "kod": 506460,
        "nazev": "Budišov nad Budišovkou",
        "popis": "[506460] Budišov nad Budišovkou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 506460,
        "val": "[506460] Budisov nad Budisovkou 8122 [506460] Budišov nad Budišovkou"
    },
    {
        "kod": 568261,
        "nazev": "Budišovice",
        "popis": "[568261] Budišovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 568261,
        "val": "[568261] Budisovice 8117 [568261] Budišovice"
    },
    {
        "kod": 569950,
        "nazev": "Čermná ve Slezsku",
        "popis": "[569950] Čermná ve Slezsku",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 569950,
        "val": "[569950] Cermna ve Slezsku 8122 [569950] Čermná ve Slezsku"
    },
    {
        "kod": 568228,
        "nazev": "Darkovice",
        "popis": "[568228] Darkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 568228,
        "val": "[568228] Darkovice 8109 [568228] Darkovice"
    },
    {
        "kod": 568236,
        "nazev": "Děhylov",
        "popis": "[568236] Děhylov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 568236,
        "val": "[568236] Dehylov 8109 [568236] Děhylov"
    },
    {
        "kod": 569895,
        "nazev": "Dobroslavice",
        "popis": "[569895] Dobroslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 569895,
        "val": "[569895] Dobroslavice 8109 [569895] Dobroslavice"
    },
    {
        "kod": 506702,
        "nazev": "Dolní Benešov",
        "popis": "[506702] Dolní Benešov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 506702,
        "val": "[506702] Dolni Benesov 8109 [506702] Dolní Benešov"
    },
    {
        "kod": 553051,
        "nazev": "Dolní Životice",
        "popis": "[553051] Dolní Životice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553051,
        "val": "[553051] Dolni Zivotice 8117 [553051] Dolní Životice"
    },
    {
        "kod": 506753,
        "nazev": "Háj ve Slezsku",
        "popis": "[506753] Háj ve Slezsku",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 506753,
        "val": "[506753] Haj ve Slezsku 8117 [506753] Háj ve Slezsku"
    },
    {
        "kod": 568210,
        "nazev": "Hať",
        "popis": "[568210] Hať",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 568210,
        "val": "[568210] Hat 8109 [568210] Hať"
    },
    {
        "kod": 553093,
        "nazev": "Hlavnice",
        "popis": "[553093] Hlavnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553093,
        "val": "[553093] Hlavnice 8117 [553093] Hlavnice"
    },
    {
        "kod": 568368,
        "nazev": "Hlubočec",
        "popis": "[568368] Hlubočec",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 568368,
        "val": "[568368] Hlubocec 8117 [568368] Hlubočec"
    },
    {
        "kod": 507016,
        "nazev": "Hlučín",
        "popis": "[507016] Hlučín",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 507016,
        "val": "[507016] Hlucin 8109 [507016] Hlučín"
    },
    {
        "kod": 507105,
        "nazev": "Hněvošice",
        "popis": "[507105] Hněvošice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507105,
        "val": "[507105] Hnevosice 8117 [507105] Hněvošice"
    },
    {
        "kod": 507113,
        "nazev": "Holasovice",
        "popis": "[507113] Holasovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507113,
        "val": "[507113] Holasovice 8117 [507113] Holasovice"
    },
    {
        "kod": 507261,
        "nazev": "Hrabyně",
        "popis": "[507261] Hrabyně",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507261,
        "val": "[507261] Hrabyne 8117 [507261] Hrabyně"
    },
    {
        "kod": 507270,
        "nazev": "Hradec nad Moravicí",
        "popis": "[507270] Hradec nad Moravicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507270,
        "val": "[507270] Hradec nad Moravici 8117 [507270] Hradec nad Moravicí"
    },
    {
        "kod": 512923,
        "nazev": "Chlebičov",
        "popis": "[512923] Chlebičov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 512923,
        "val": "[512923] Chlebicov 8117 [512923] Chlebičov"
    },
    {
        "kod": 507334,
        "nazev": "Chuchelná",
        "popis": "[507334] Chuchelná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 507334,
        "val": "[507334] Chuchelna 8113 [507334] Chuchelná"
    },
    {
        "kod": 569909,
        "nazev": "Chvalíkovice",
        "popis": "[569909] Chvalíkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 569909,
        "val": "[569909] Chvalikovice 8117 [569909] Chvalíkovice"
    },
    {
        "kod": 507377,
        "nazev": "Jakartovice",
        "popis": "[507377] Jakartovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507377,
        "val": "[507377] Jakartovice 8117 [507377] Jakartovice"
    },
    {
        "kod": 547191,
        "nazev": "Jezdkovice",
        "popis": "[547191] Jezdkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 547191,
        "val": "[547191] Jezdkovice 8117 [547191] Jezdkovice"
    },
    {
        "kod": 507504,
        "nazev": "Kobeřice",
        "popis": "[507504] Kobeřice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 507504,
        "val": "[507504] Koberice 8113 [507504] Kobeřice"
    },
    {
        "kod": 547182,
        "nazev": "Kozmice",
        "popis": "[547182] Kozmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 547182,
        "val": "[547182] Kozmice 8109 [547182] Kozmice"
    },
    {
        "kod": 507580,
        "nazev": "Kravaře",
        "popis": "[507580] Kravaře",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 507580,
        "val": "[507580] Kravare 8113 [507580] Kravaře"
    },
    {
        "kod": 568180,
        "nazev": "Kružberk",
        "popis": "[568180] Kružberk",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 568180,
        "val": "[568180] Kruzberk 8122 [568180] Kružberk"
    },
    {
        "kod": 512907,
        "nazev": "Kyjovice",
        "popis": "[512907] Kyjovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 512907,
        "val": "[512907] Kyjovice 8117 [512907] Kyjovice"
    },
    {
        "kod": 553115,
        "nazev": "Lhotka u Litultovic",
        "popis": "[553115] Lhotka u Litultovic",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553115,
        "val": "[553115] Lhotka u Litultovic 8117 [553115] Lhotka u Litultovic"
    },
    {
        "kod": 507920,
        "nazev": "Litultovice",
        "popis": "[507920] Litultovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 507920,
        "val": "[507920] Litultovice 8117 [507920] Litultovice"
    },
    {
        "kod": 507971,
        "nazev": "Ludgeřovice",
        "popis": "[507971] Ludgeřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 507971,
        "val": "[507971] Ludgerovice 8109 [507971] Ludgeřovice"
    },
    {
        "kod": 508128,
        "nazev": "Markvartovice",
        "popis": "[508128] Markvartovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 508128,
        "val": "[508128] Markvartovice 8109 [508128] Markvartovice"
    },
    {
        "kod": 508144,
        "nazev": "Melč",
        "popis": "[508144] Melč",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 508144,
        "val": "[508144] Melc 8122 [508144] Melč"
    },
    {
        "kod": 568279,
        "nazev": "Mikolajice",
        "popis": "[568279] Mikolajice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 568279,
        "val": "[568279] Mikolajice 8117 [568279] Mikolajice"
    },
    {
        "kod": 553042,
        "nazev": "Mladecko",
        "popis": "[553042] Mladecko",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553042,
        "val": "[553042] Mladecko 8117 [553042] Mladecko"
    },
    {
        "kod": 508373,
        "nazev": "Mokré Lazce",
        "popis": "[508373] Mokré Lazce",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 508373,
        "val": "[508373] Mokre Lazce 8117 [508373] Mokré Lazce"
    },
    {
        "kod": 569097,
        "nazev": "Moravice",
        "popis": "[569097] Moravice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 569097,
        "val": "[569097] Moravice 8122 [569097] Moravice"
    },
    {
        "kod": 553158,
        "nazev": "Neplachovice",
        "popis": "[553158] Neplachovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 553158,
        "val": "[553158] Neplachovice 8117 [553158] Neplachovice"
    },
    {
        "kod": 512893,
        "nazev": "Nové Lublice",
        "popis": "[512893] Nové Lublice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 512893,
        "val": "[512893] Nove Lublice 8122 [512893] Nové Lublice"
    },
    {
        "kod": 555274,
        "nazev": "Nové Sedlice",
        "popis": "[555274] Nové Sedlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 555274,
        "val": "[555274] Nove Sedlice 8117 [555274] Nové Sedlice"
    },
    {
        "kod": 509574,
        "nazev": "Oldřišov",
        "popis": "[509574] Oldřišov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 509574,
        "val": "[509574] Oldrisov 8117 [509574] Oldřišov"
    },
    {
        "kod": 509612,
        "nazev": "Otice",
        "popis": "[509612] Otice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 509612,
        "val": "[509612] Otice 8117 [509612] Otice"
    },
    {
        "kod": 509647,
        "nazev": "Píšť",
        "popis": "[509647] Píšť",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 509647,
        "val": "[509647] Pist 8109 [509647] Píšť"
    },
    {
        "kod": 509736,
        "nazev": "Pustá Polom",
        "popis": "[509736] Pustá Polom",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 509736,
        "val": "[509736] Pusta Polom 8117 [509736] Pustá Polom"
    },
    {
        "kod": 568317,
        "nazev": "Radkov",
        "popis": "[568317] Radkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 568317,
        "val": "[568317] Radkov 8122 [568317] Radkov"
    },
    {
        "kod": 509841,
        "nazev": "Raduň",
        "popis": "[509841] Raduň",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 509841,
        "val": "[509841] Radun 8117 [509841] Raduň"
    },
    {
        "kod": 568376,
        "nazev": "Rohov",
        "popis": "[568376] Rohov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 568376,
        "val": "[568376] Rohov 8113 [568376] Rohov"
    },
    {
        "kod": 510131,
        "nazev": "Skřipov",
        "popis": "[510131] Skřipov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510131,
        "val": "[510131] Skripov 8117 [510131] Skřipov"
    },
    {
        "kod": 510289,
        "nazev": "Slavkov",
        "popis": "[510289] Slavkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510289,
        "val": "[510289] Slavkov 8117 [510289] Slavkov"
    },
    {
        "kod": 510297,
        "nazev": "Služovice",
        "popis": "[510297] Služovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510297,
        "val": "[510297] Sluzovice 8117 [510297] Služovice"
    },
    {
        "kod": 597821,
        "nazev": "Sosnová",
        "popis": "[597821] Sosnová",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 597821,
        "val": "[597821] Sosnova 8117 [597821] Sosnová"
    },
    {
        "kod": 568198,
        "nazev": "Staré Těchanovice",
        "popis": "[568198] Staré Těchanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 568198,
        "val": "[568198] Stare Techanovice 8122 [568198] Staré Těchanovice"
    },
    {
        "kod": 510343,
        "nazev": "Stěbořice",
        "popis": "[510343] Stěbořice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510343,
        "val": "[510343] Steborice 8117 [510343] Stěbořice"
    },
    {
        "kod": 512869,
        "nazev": "Strahovice",
        "popis": "[512869] Strahovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 512869,
        "val": "[512869] Strahovice 8113 [512869] Strahovice"
    },
    {
        "kod": 510378,
        "nazev": "Sudice",
        "popis": "[510378] Sudice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 510378,
        "val": "[510378] Sudice 8113 [510378] Sudice"
    },
    {
        "kod": 547131,
        "nazev": "Svatoňovice",
        "popis": "[547131] Svatoňovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 547131,
        "val": "[547131] Svatonovice 8122 [547131] Svatoňovice"
    },
    {
        "kod": 510432,
        "nazev": "Šilheřovice",
        "popis": "[510432] Šilheřovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 510432,
        "val": "[510432] Silherovice 8109 [510432] Šilheřovice"
    },
    {
        "kod": 568333,
        "nazev": "Štáblovice",
        "popis": "[568333] Štáblovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 568333,
        "val": "[568333] Stablovice 8117 [568333] Štáblovice"
    },
    {
        "kod": 510483,
        "nazev": "Štěpánkovice",
        "popis": "[510483] Štěpánkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 510483,
        "val": "[510483] Stepankovice 8113 [510483] Štěpánkovice"
    },
    {
        "kod": 510491,
        "nazev": "Štítina",
        "popis": "[510491] Štítina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510491,
        "val": "[510491] Stitina 8117 [510491] Štítina"
    },
    {
        "kod": 512745,
        "nazev": "Těškovice",
        "popis": "[512745] Těškovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 512745,
        "val": "[512745] Teskovice 8117 [512745] Těškovice"
    },
    {
        "kod": 569101,
        "nazev": "Třebom",
        "popis": "[569101] Třebom",
        "datum_od": "",
        "datum_do": "",
        "orp": 8113,
        "iczuj": 569101,
        "val": "[569101] Trebom 8113 [569101] Třebom"
    },
    {
        "kod": 568341,
        "nazev": "Uhlířov",
        "popis": "[568341] Uhlířov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 568341,
        "val": "[568341] Uhlirov 8117 [568341] Uhlířov"
    },
    {
        "kod": 510891,
        "nazev": "Velké Heraltice",
        "popis": "[510891] Velké Heraltice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510891,
        "val": "[510891] Velke Heraltice 8117 [510891] Velké Heraltice"
    },
    {
        "kod": 510939,
        "nazev": "Velké Hoštice",
        "popis": "[510939] Velké Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 510939,
        "val": "[510939] Velke Hostice 8117 [510939] Velké Hoštice"
    },
    {
        "kod": 570036,
        "nazev": "Větřkovice",
        "popis": "[570036] Větřkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 570036,
        "val": "[570036] Vetrkovice 8122 [570036] Větřkovice"
    },
    {
        "kod": 511021,
        "nazev": "Vítkov",
        "popis": "[511021] Vítkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8122,
        "iczuj": 511021,
        "val": "[511021] Vitkov 8122 [511021] Vítkov"
    },
    {
        "kod": 511161,
        "nazev": "Vršovice",
        "popis": "[511161] Vršovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 511161,
        "val": "[511161] Vrsovice 8117 [511161] Vršovice"
    },
    {
        "kod": 568244,
        "nazev": "Vřesina",
        "popis": "[568244] Vřesina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 568244,
        "val": "[568244] Vresina 8109 [568244] Vřesina"
    },
    {
        "kod": 553492,
        "nazev": "Závada",
        "popis": "[553492] Závada",
        "datum_od": "",
        "datum_do": "",
        "orp": 8109,
        "iczuj": 553492,
        "val": "[553492] Zavada 8109 [553492] Závada"
    },
    {
        "kod": 569119,
        "nazev": "Čavisov",
        "popis": "[569119] Čavisov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 569119,
        "val": "[569119] Cavisov 8119 [569119] Čavisov"
    },
    {
        "kod": 506711,
        "nazev": "Dolní Lhota",
        "popis": "[506711] Dolní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 506711,
        "val": "[506711] Dolni Lhota 8119 [506711] Dolní Lhota"
    },
    {
        "kod": 569500,
        "nazev": "Horní Lhota",
        "popis": "[569500] Horní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 569500,
        "val": "[569500] Horni Lhota 8119 [569500] Horní Lhota"
    },
    {
        "kod": 599549,
        "nazev": "Klimkovice",
        "popis": "[599549] Klimkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 599549,
        "val": "[599549] Klimkovice 8119 [599549] Klimkovice"
    },
    {
        "kod": 554049,
        "nazev": "Olbramice",
        "popis": "[554049] Olbramice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554049,
        "val": "[554049] Olbramice 8119 [554049] Olbramice"
    },
    {
        "kod": 598739,
        "nazev": "Stará Ves nad Ondřejnicí",
        "popis": "[598739] Stará Ves nad Ondřejnicí",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 598739,
        "val": "[598739] Stara Ves nad Ondrejnici 8119 [598739] Stará Ves nad Ondřejnicí"
    },
    {
        "kod": 598798,
        "nazev": "Šenov",
        "popis": "[598798] Šenov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 598798,
        "val": "[598798] Senov 8119 [598798] Šenov"
    },
    {
        "kod": 598836,
        "nazev": "Václavovice",
        "popis": "[598836] Václavovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 598836,
        "val": "[598836] Vaclavovice 8119 [598836] Václavovice"
    },
    {
        "kod": 510882,
        "nazev": "Velká Polom",
        "popis": "[510882] Velká Polom",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 510882,
        "val": "[510882] Velka Polom 8119 [510882] Velká Polom"
    },
    {
        "kod": 598879,
        "nazev": "Vratimov",
        "popis": "[598879] Vratimov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 598879,
        "val": "[598879] Vratimov 8119 [598879] Vratimov"
    },
    {
        "kod": 500291,
        "nazev": "Vřesina",
        "popis": "[500291] Vřesina",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 500291,
        "val": "[500291] Vresina 8119 [500291] Vřesina"
    },
    {
        "kod": 568449,
        "nazev": "Zbyslavice",
        "popis": "[568449] Zbyslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 568449,
        "val": "[568449] Zbyslavice 8119 [568449] Zbyslavice"
    },
    {
        "kod": 500054,
        "nazev": "Praha 1",
        "popis": "[500054] Praha 1",
        "datum_od": "",
        "datum_do": "",
        "orp": 1101,
        "iczuj": 554782,
        "val": "[500054] Praha 1 1101 [500054] Praha 1"
    },
    {
        "kod": 500089,
        "nazev": "Praha 2",
        "popis": "[500089] Praha 2",
        "datum_od": "",
        "datum_do": "",
        "orp": 1102,
        "iczuj": 554782,
        "val": "[500089] Praha 2 1102 [500089] Praha 2"
    },
    {
        "kod": 500097,
        "nazev": "Praha 3",
        "popis": "[500097] Praha 3",
        "datum_od": "",
        "datum_do": "",
        "orp": 1103,
        "iczuj": 554782,
        "val": "[500097] Praha 3 1103 [500097] Praha 3"
    },
    {
        "kod": 500119,
        "nazev": "Praha 4",
        "popis": "[500119] Praha 4",
        "datum_od": "",
        "datum_do": "",
        "orp": 1104,
        "iczuj": 554782,
        "val": "[500119] Praha 4 1104 [500119] Praha 4"
    },
    {
        "kod": 547034,
        "nazev": "Praha 11",
        "popis": "[547034] Praha 11",
        "datum_od": "",
        "datum_do": "",
        "orp": 1111,
        "iczuj": 554782,
        "val": "[547034] Praha 11 1111 [547034] Praha 11"
    },
    {
        "kod": 547107,
        "nazev": "Praha 12",
        "popis": "[547107] Praha 12",
        "datum_od": "",
        "datum_do": "",
        "orp": 1112,
        "iczuj": 554782,
        "val": "[547107] Praha 12 1112 [547107] Praha 12"
    },
    {
        "kod": 547042,
        "nazev": "Praha-Kunratice",
        "popis": "[547042] Praha-Kunratice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1104,
        "iczuj": 554782,
        "val": "[547042] Praha-Kunratice 1104 [547042] Praha-Kunratice"
    },
    {
        "kod": 547051,
        "nazev": "Praha-Libuš",
        "popis": "[547051] Praha-Libuš",
        "datum_od": "",
        "datum_do": "",
        "orp": 1112,
        "iczuj": 554782,
        "val": "[547051] Praha-Libus 1112 [547051] Praha-Libuš"
    },
    {
        "kod": 539724,
        "nazev": "Praha-Šeberov",
        "popis": "[539724] Praha-Šeberov",
        "datum_od": "",
        "datum_do": "",
        "orp": 1111,
        "iczuj": 554782,
        "val": "[539724] Praha-Seberov 1111 [539724] Praha-Šeberov"
    },
    {
        "kod": 539791,
        "nazev": "Praha-Újezd",
        "popis": "[539791] Praha-Újezd",
        "datum_od": "",
        "datum_do": "",
        "orp": 1111,
        "iczuj": 554782,
        "val": "[539791] Praha-Ujezd 1111 [539791] Praha-Újezd"
    },
    {
        "kod": 500143,
        "nazev": "Praha 5",
        "popis": "[500143] Praha 5",
        "datum_od": "",
        "datum_do": "",
        "orp": 1105,
        "iczuj": 554782,
        "val": "[500143] Praha 5 1105 [500143] Praha 5"
    },
    {
        "kod": 539694,
        "nazev": "Praha 13",
        "popis": "[539694] Praha 13",
        "datum_od": "",
        "datum_do": "",
        "orp": 1113,
        "iczuj": 554782,
        "val": "[539694] Praha 13 1113 [539694] Praha 13"
    },
    {
        "kod": 539601,
        "nazev": "Praha 16",
        "popis": "[539601] Praha 16",
        "datum_od": "",
        "datum_do": "",
        "orp": 1116,
        "iczuj": 554782,
        "val": "[539601] Praha 16 1116 [539601] Praha 16"
    },
    {
        "kod": 539449,
        "nazev": "Praha-Lipence",
        "popis": "[539449] Praha-Lipence",
        "datum_od": "",
        "datum_do": "",
        "orp": 1116,
        "iczuj": 554782,
        "val": "[539449] Praha-Lipence 1116 [539449] Praha-Lipence"
    },
    {
        "kod": 539465,
        "nazev": "Praha-Lochkov",
        "popis": "[539465] Praha-Lochkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 1116,
        "iczuj": 554782,
        "val": "[539465] Praha-Lochkov 1116 [539465] Praha-Lochkov"
    },
    {
        "kod": 539635,
        "nazev": "Praha-Řeporyje",
        "popis": "[539635] Praha-Řeporyje",
        "datum_od": "",
        "datum_do": "",
        "orp": 1113,
        "iczuj": 554782,
        "val": "[539635] Praha-Reporyje 1113 [539635] Praha-Řeporyje"
    },
    {
        "kod": 539678,
        "nazev": "Praha-Slivenec",
        "popis": "[539678] Praha-Slivenec",
        "datum_od": "",
        "datum_do": "",
        "orp": 1105,
        "iczuj": 554782,
        "val": "[539678] Praha-Slivenec 1105 [539678] Praha-Slivenec"
    },
    {
        "kod": 547115,
        "nazev": "Praha-Velká Chuchle",
        "popis": "[547115] Praha-Velká Chuchle",
        "datum_od": "",
        "datum_do": "",
        "orp": 1116,
        "iczuj": 554782,
        "val": "[547115] Praha-Velka Chuchle 1116 [547115] Praha-Velká Chuchle"
    },
    {
        "kod": 539864,
        "nazev": "Praha-Zbraslav",
        "popis": "[539864] Praha-Zbraslav",
        "datum_od": "",
        "datum_do": "",
        "orp": 1116,
        "iczuj": 554782,
        "val": "[539864] Praha-Zbraslav 1116 [539864] Praha-Zbraslav"
    },
    {
        "kod": 539899,
        "nazev": "Praha-Zličín",
        "popis": "[539899] Praha-Zličín",
        "datum_od": "",
        "datum_do": "",
        "orp": 1117,
        "iczuj": 554782,
        "val": "[539899] Praha-Zlicin 1117 [539899] Praha-Zličín"
    },
    {
        "kod": 500178,
        "nazev": "Praha 6",
        "popis": "[500178] Praha 6",
        "datum_od": "",
        "datum_do": "",
        "orp": 1106,
        "iczuj": 554782,
        "val": "[500178] Praha 6 1106 [500178] Praha 6"
    },
    {
        "kod": 547174,
        "nazev": "Praha 17",
        "popis": "[547174] Praha 17",
        "datum_od": "",
        "datum_do": "",
        "orp": 1117,
        "iczuj": 554782,
        "val": "[547174] Praha 17 1117 [547174] Praha 17"
    },
    {
        "kod": 547140,
        "nazev": "Praha-Lysolaje",
        "popis": "[547140] Praha-Lysolaje",
        "datum_od": "",
        "datum_do": "",
        "orp": 1106,
        "iczuj": 554782,
        "val": "[547140] Praha-Lysolaje 1106 [547140] Praha-Lysolaje"
    },
    {
        "kod": 547158,
        "nazev": "Praha-Nebušice",
        "popis": "[547158] Praha-Nebušice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1106,
        "iczuj": 554782,
        "val": "[547158] Praha-Nebusice 1106 [547158] Praha-Nebušice"
    },
    {
        "kod": 539589,
        "nazev": "Praha-Přední Kopanina",
        "popis": "[539589] Praha-Přední Kopanina",
        "datum_od": "",
        "datum_do": "",
        "orp": 1106,
        "iczuj": 554782,
        "val": "[539589] Praha-Predni Kopanina 1106 [539589] Praha-Přední Kopanina"
    },
    {
        "kod": 547271,
        "nazev": "Praha-Suchdol",
        "popis": "[547271] Praha-Suchdol",
        "datum_od": "",
        "datum_do": "",
        "orp": 1106,
        "iczuj": 554782,
        "val": "[547271] Praha-Suchdol 1106 [547271] Praha-Suchdol"
    },
    {
        "kod": 500186,
        "nazev": "Praha 7",
        "popis": "[500186] Praha 7",
        "datum_od": "",
        "datum_do": "",
        "orp": 1107,
        "iczuj": 554782,
        "val": "[500186] Praha 7 1107 [500186] Praha 7"
    },
    {
        "kod": 547328,
        "nazev": "Praha-Troja",
        "popis": "[547328] Praha-Troja",
        "datum_od": "",
        "datum_do": "",
        "orp": 1107,
        "iczuj": 554782,
        "val": "[547328] Praha-Troja 1107 [547328] Praha-Troja"
    },
    {
        "kod": 500208,
        "nazev": "Praha 8",
        "popis": "[500208] Praha 8",
        "datum_od": "",
        "datum_do": "",
        "orp": 1108,
        "iczuj": 554782,
        "val": "[500208] Praha 8 1108 [500208] Praha 8"
    },
    {
        "kod": 538124,
        "nazev": "Praha-Březiněves",
        "popis": "[538124] Praha-Březiněves",
        "datum_od": "",
        "datum_do": "",
        "orp": 1108,
        "iczuj": 554782,
        "val": "[538124] Praha-Brezineves 1108 [538124] Praha-Březiněves"
    },
    {
        "kod": 547298,
        "nazev": "Praha-Ďáblice",
        "popis": "[547298] Praha-Ďáblice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1108,
        "iczuj": 554782,
        "val": "[547298] Praha-Dablice 1108 [547298] Praha-Ďáblice"
    },
    {
        "kod": 547301,
        "nazev": "Praha-Dolní Chabry",
        "popis": "[547301] Praha-Dolní Chabry",
        "datum_od": "",
        "datum_do": "",
        "orp": 1108,
        "iczuj": 554782,
        "val": "[547301] Praha-Dolni Chabry 1108 [547301] Praha-Dolní Chabry"
    },
    {
        "kod": 500216,
        "nazev": "Praha 9",
        "popis": "[500216] Praha 9",
        "datum_od": "",
        "datum_do": "",
        "orp": 1109,
        "iczuj": 554782,
        "val": "[500216] Praha 9 1109 [500216] Praha 9"
    },
    {
        "kod": 547361,
        "nazev": "Praha 14",
        "popis": "[547361] Praha 14",
        "datum_od": "",
        "datum_do": "",
        "orp": 1114,
        "iczuj": 554782,
        "val": "[547361] Praha 14 1114 [547361] Praha 14"
    },
    {
        "kod": 547417,
        "nazev": "Praha 18",
        "popis": "[547417] Praha 18",
        "datum_od": "",
        "datum_do": "",
        "orp": 1118,
        "iczuj": 554782,
        "val": "[547417] Praha 18 1118 [547417] Praha 18"
    },
    {
        "kod": 547344,
        "nazev": "Praha 19",
        "popis": "[547344] Praha 19",
        "datum_od": "",
        "datum_do": "",
        "orp": 1119,
        "iczuj": 554782,
        "val": "[547344] Praha 19 1119 [547344] Praha 19"
    },
    {
        "kod": 538213,
        "nazev": "Praha 20",
        "popis": "[538213] Praha 20",
        "datum_od": "",
        "datum_do": "",
        "orp": 1120,
        "iczuj": 554782,
        "val": "[538213] Praha 20 1120 [538213] Praha 20"
    },
    {
        "kod": 538949,
        "nazev": "Praha 21",
        "popis": "[538949] Praha 21",
        "datum_od": "",
        "datum_do": "",
        "orp": 1121,
        "iczuj": 554782,
        "val": "[538949] Praha 21 1121 [538949] Praha 21"
    },
    {
        "kod": 538060,
        "nazev": "Praha-Běchovice",
        "popis": "[538060] Praha-Běchovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1121,
        "iczuj": 554782,
        "val": "[538060] Praha-Bechovice 1121 [538060] Praha-Běchovice"
    },
    {
        "kod": 547310,
        "nazev": "Praha-Čakovice",
        "popis": "[547310] Praha-Čakovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1118,
        "iczuj": 554782,
        "val": "[547310] Praha-Cakovice 1118 [547310] Praha-Čakovice"
    },
    {
        "kod": 538175,
        "nazev": "Praha-Dolní Počernice",
        "popis": "[538175] Praha-Dolní Počernice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1114,
        "iczuj": 554782,
        "val": "[538175] Praha-Dolni Pocernice 1114 [538175] Praha-Dolní Počernice"
    },
    {
        "kod": 538302,
        "nazev": "Praha-Klánovice",
        "popis": "[538302] Praha-Klánovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1121,
        "iczuj": 554782,
        "val": "[538302] Praha-Klanovice 1121 [538302] Praha-Klánovice"
    },
    {
        "kod": 538353,
        "nazev": "Praha-Koloděje",
        "popis": "[538353] Praha-Koloděje",
        "datum_od": "",
        "datum_do": "",
        "orp": 1121,
        "iczuj": 554782,
        "val": "[538353] Praha-Kolodeje 1121 [538353] Praha-Koloděje"
    },
    {
        "kod": 538736,
        "nazev": "Praha-Satalice",
        "popis": "[538736] Praha-Satalice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1119,
        "iczuj": 554782,
        "val": "[538736] Praha-Satalice 1119 [538736] Praha-Satalice"
    },
    {
        "kod": 539007,
        "nazev": "Praha-Vinoř",
        "popis": "[539007] Praha-Vinoř",
        "datum_od": "",
        "datum_do": "",
        "orp": 1119,
        "iczuj": 554782,
        "val": "[539007] Praha-Vinor 1119 [539007] Praha-Vinoř"
    },
    {
        "kod": 500224,
        "nazev": "Praha 10",
        "popis": "[500224] Praha 10",
        "datum_od": "",
        "datum_do": "",
        "orp": 1110,
        "iczuj": 554782,
        "val": "[500224] Praha 10 1110 [500224] Praha 10"
    },
    {
        "kod": 547387,
        "nazev": "Praha 15",
        "popis": "[547387] Praha 15",
        "datum_od": "",
        "datum_do": "",
        "orp": 1115,
        "iczuj": 554782,
        "val": "[547387] Praha 15 1115 [547387] Praha 15"
    },
    {
        "kod": 538931,
        "nazev": "Praha 22",
        "popis": "[538931] Praha 22",
        "datum_od": "",
        "datum_do": "",
        "orp": 1122,
        "iczuj": 554782,
        "val": "[538931] Praha 22 1122 [538931] Praha 22"
    },
    {
        "kod": 538078,
        "nazev": "Praha-Benice",
        "popis": "[538078] Praha-Benice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1122,
        "iczuj": 554782,
        "val": "[538078] Praha-Benice 1122 [538078] Praha-Benice"
    },
    {
        "kod": 547379,
        "nazev": "Praha-Dolní Měcholupy",
        "popis": "[547379] Praha-Dolní Měcholupy",
        "datum_od": "",
        "datum_do": "",
        "orp": 1115,
        "iczuj": 554782,
        "val": "[547379] Praha-Dolni Mecholupy 1115 [547379] Praha-Dolní Měcholupy"
    },
    {
        "kod": 538205,
        "nazev": "Praha-Dubeč",
        "popis": "[538205] Praha-Dubeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 1115,
        "iczuj": 554782,
        "val": "[538205] Praha-Dubec 1115 [538205] Praha-Dubeč"
    },
    {
        "kod": 538361,
        "nazev": "Praha-Kolovraty",
        "popis": "[538361] Praha-Kolovraty",
        "datum_od": "",
        "datum_do": "",
        "orp": 1122,
        "iczuj": 554782,
        "val": "[538361] Praha-Kolovraty 1122 [538361] Praha-Kolovraty"
    },
    {
        "kod": 538388,
        "nazev": "Praha-Královice",
        "popis": "[538388] Praha-Královice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1122,
        "iczuj": 554782,
        "val": "[538388] Praha-Kralovice 1122 [538388] Praha-Královice"
    },
    {
        "kod": 538400,
        "nazev": "Praha-Křeslice",
        "popis": "[538400] Praha-Křeslice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1111,
        "iczuj": 554782,
        "val": "[538400] Praha-Kreslice 1111 [538400] Praha-Křeslice"
    },
    {
        "kod": 538531,
        "nazev": "Praha-Nedvězí",
        "popis": "[538531] Praha-Nedvězí",
        "datum_od": "",
        "datum_do": "",
        "orp": 1122,
        "iczuj": 554782,
        "val": "[538531] Praha-Nedvezi 1122 [538531] Praha-Nedvězí"
    },
    {
        "kod": 547395,
        "nazev": "Praha-Petrovice",
        "popis": "[547395] Praha-Petrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 1115,
        "iczuj": 554782,
        "val": "[547395] Praha-Petrovice 1115 [547395] Praha-Petrovice"
    },
    {
        "kod": 500071,
        "nazev": "Poličná",
        "popis": "[500071] Poličná",
        "datum_od": 2013,
        "datum_do": "",
        "orp": 7210,
        "iczuj": 500071,
        "val": "[500071] Policna 7210 [500071] Poličná"
    },
    {
        "kod": 500062,
        "nazev": "Krhová",
        "popis": "[500062] Krhová",
        "datum_od": 2013,
        "datum_do": "",
        "orp": 7210,
        "iczuj": 500062,
        "val": "[500062] Krhova 7210 [500062] Krhová"
    },
    {
        "kod": 545970,
        "nazev": "Plzeň 1",
        "popis": "[545970] Plzeň 1",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[545970] Plzen 1 3209 [545970] Plzeň 1"
    },
    {
        "kod": 545988,
        "nazev": "Plzeň 2-Slovany",
        "popis": "[545988] Plzeň 2-Slovany",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[545988] Plzen 2-Slovany 3209 [545988] Plzeň 2-Slovany"
    },
    {
        "kod": 546003,
        "nazev": "Plzeň 3",
        "popis": "[546003] Plzeň 3",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[546003] Plzen 3 3209 [546003] Plzeň 3"
    },
    {
        "kod": 546208,
        "nazev": "Plzeň 4",
        "popis": "[546208] Plzeň 4",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[546208] Plzen 4 3209 [546208] Plzeň 4"
    },
    {
        "kod": 554731,
        "nazev": "Plzeň 5-Křimice",
        "popis": "[554731] Plzeň 5-Křimice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[554731] Plzen 5-Krimice 3209 [554731] Plzeň 5-Křimice"
    },
    {
        "kod": 554758,
        "nazev": "Plzeň 6-Litice",
        "popis": "[554758] Plzeň 6-Litice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[554758] Plzen 6-Litice 3209 [554758] Plzeň 6-Litice"
    },
    {
        "kod": 554766,
        "nazev": "Plzeň 7-Radčice",
        "popis": "[554766] Plzeň 7-Radčice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[554766] Plzen 7-Radcice 3209 [554766] Plzeň 7-Radčice"
    },
    {
        "kod": 554774,
        "nazev": "Plzeň 8-Černice",
        "popis": "[554774] Plzeň 8-Černice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[554774] Plzen 8-Cernice 3209 [554774] Plzeň 8-Černice"
    },
    {
        "kod": 559199,
        "nazev": "Plzeň 9-Malesice",
        "popis": "[559199] Plzeň 9-Malesice",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[559199] Plzen 9-Malesice 3209 [559199] Plzeň 9-Malesice"
    },
    {
        "kod": 557978,
        "nazev": "Plzeň 10-Lhota",
        "popis": "[557978] Plzeň 10-Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 3209,
        "iczuj": 554791,
        "val": "[557978] Plzen 10-Lhota 3209 [557978] Plzeň 10-Lhota"
    },
    {
        "kod": 567892,
        "nazev": "Ústí nad Labem-město",
        "popis": "[567892] Ústí nad Labem-město",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 554804,
        "val": "[567892] Usti nad Labem-mesto 4214 [567892] Ústí nad Labem-město"
    },
    {
        "kod": 501298,
        "nazev": "Ústí nad Labem-Severní Terasa",
        "popis": "[501298] Ústí nad Labem-Severní Terasa",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 554804,
        "val": "[501298] Usti nad Labem-Severni Terasa 4214 [501298] Ústí nad Labem-Severní Terasa"
    },
    {
        "kod": 502081,
        "nazev": "Ústí nad Labem-Neštěmice",
        "popis": "[502081] Ústí nad Labem-Neštěmice",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 554804,
        "val": "[502081] Usti nad Labem-Nestemice 4214 [502081] Ústí nad Labem-Neštěmice"
    },
    {
        "kod": 502316,
        "nazev": "Ústí nad Labem-Střekov",
        "popis": "[502316] Ústí nad Labem-Střekov",
        "datum_od": "",
        "datum_do": "",
        "orp": 4214,
        "iczuj": 554804,
        "val": "[502316] Usti nad Labem-Strekov 4214 [502316] Ústí nad Labem-Střekov"
    },
    {
        "kod": 556904,
        "nazev": "Liberec (nečleněné město)",
        "popis": "[556904] Liberec (nečleněné město)",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563889,
        "val": "[556904] Liberec (neclenene mesto) 5105 [556904] Liberec (nečleněné město)"
    },
    {
        "kod": 556891,
        "nazev": "Liberec-Vratislavice nad Nisou",
        "popis": "[556891] Liberec-Vratislavice nad Nisou",
        "datum_od": "",
        "datum_do": "",
        "orp": 5105,
        "iczuj": 563889,
        "val": "[556891] Liberec-Vratislavice nad Nisou 5105 [556891] Liberec-Vratislavice nad Nisou"
    },
    {
        "kod": 574716,
        "nazev": "Pardubice I",
        "popis": "[574716] Pardubice I",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[574716] Pardubice I 5309 [574716] Pardubice I"
    },
    {
        "kod": 555126,
        "nazev": "Pardubice II",
        "popis": "[555126] Pardubice II",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[555126] Pardubice II 5309 [555126] Pardubice II"
    },
    {
        "kod": 557064,
        "nazev": "Pardubice III",
        "popis": "[557064] Pardubice III",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[557064] Pardubice III 5309 [557064] Pardubice III"
    },
    {
        "kod": 555096,
        "nazev": "Pardubice IV",
        "popis": "[555096] Pardubice IV",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[555096] Pardubice IV 5309 [555096] Pardubice IV"
    },
    {
        "kod": 557072,
        "nazev": "Pardubice V",
        "popis": "[557072] Pardubice V",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[557072] Pardubice V 5309 [557072] Pardubice V"
    },
    {
        "kod": 555100,
        "nazev": "Pardubice VI",
        "popis": "[555100] Pardubice VI",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[555100] Pardubice VI 5309 [555100] Pardubice VI"
    },
    {
        "kod": 555118,
        "nazev": "Pardubice VII",
        "popis": "[555118] Pardubice VII",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[555118] Pardubice VII 5309 [555118] Pardubice VII"
    },
    {
        "kod": 575020,
        "nazev": "Pardubice VIII",
        "popis": "[575020] Pardubice VIII",
        "datum_od": "",
        "datum_do": "",
        "orp": 5309,
        "iczuj": 555134,
        "val": "[575020] Pardubice VIII 5309 [575020] Pardubice VIII"
    },
    {
        "kod": 550973,
        "nazev": "Brno-střed",
        "popis": "[550973] Brno-střed",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[550973] Brno-stred 6203 [550973] Brno-střed"
    },
    {
        "kod": 550990,
        "nazev": "Brno-Žabovřesky",
        "popis": "[550990] Brno-Žabovřesky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[550990] Brno-Zabovresky 6203 [550990] Brno-Žabovřesky"
    },
    {
        "kod": 551007,
        "nazev": "Brno-Královo Pole",
        "popis": "[551007] Brno-Královo Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551007] Brno-Kralovo Pole 6203 [551007] Brno-Královo Pole"
    },
    {
        "kod": 551031,
        "nazev": "Brno-sever",
        "popis": "[551031] Brno-sever",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551031] Brno-sever 6203 [551031] Brno-sever"
    },
    {
        "kod": 551058,
        "nazev": "Brno-Židenice",
        "popis": "[551058] Brno-Židenice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551058] Brno-Zidenice 6203 [551058] Brno-Židenice"
    },
    {
        "kod": 551066,
        "nazev": "Brno-Černovice",
        "popis": "[551066] Brno-Černovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551066] Brno-Cernovice 6203 [551066] Brno-Černovice"
    },
    {
        "kod": 551074,
        "nazev": "Brno-jih",
        "popis": "[551074] Brno-jih",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551074] Brno-jih 6203 [551074] Brno-jih"
    },
    {
        "kod": 551082,
        "nazev": "Brno-Bohunice",
        "popis": "[551082] Brno-Bohunice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551082] Brno-Bohunice 6203 [551082] Brno-Bohunice"
    },
    {
        "kod": 551091,
        "nazev": "Brno-Starý Lískovec",
        "popis": "[551091] Brno-Starý Lískovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551091] Brno-Stary Liskovec 6203 [551091] Brno-Starý Lískovec"
    },
    {
        "kod": 551112,
        "nazev": "Brno-Nový Lískovec",
        "popis": "[551112] Brno-Nový Lískovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551112] Brno-Novy Liskovec 6203 [551112] Brno-Nový Lískovec"
    },
    {
        "kod": 551147,
        "nazev": "Brno-Kohoutovice",
        "popis": "[551147] Brno-Kohoutovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551147] Brno-Kohoutovice 6203 [551147] Brno-Kohoutovice"
    },
    {
        "kod": 551171,
        "nazev": "Brno-Jundrov",
        "popis": "[551171] Brno-Jundrov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551171] Brno-Jundrov 6203 [551171] Brno-Jundrov"
    },
    {
        "kod": 551198,
        "nazev": "Brno-Bystrc",
        "popis": "[551198] Brno-Bystrc",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551198] Brno-Bystrc 6203 [551198] Brno-Bystrc"
    },
    {
        "kod": 551210,
        "nazev": "Brno-Kníničky",
        "popis": "[551210] Brno-Kníničky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551210] Brno-Kninicky 6203 [551210] Brno-Kníničky"
    },
    {
        "kod": 551228,
        "nazev": "Brno-Komín",
        "popis": "[551228] Brno-Komín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551228] Brno-Komin 6203 [551228] Brno-Komín"
    },
    {
        "kod": 551236,
        "nazev": "Brno-Medlánky",
        "popis": "[551236] Brno-Medlánky",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551236] Brno-Medlanky 6203 [551236] Brno-Medlánky"
    },
    {
        "kod": 551244,
        "nazev": "Brno-Řečkovice a Mokrá Hora",
        "popis": "[551244] Brno-Řečkovice a Mokrá Hora",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551244] Brno-Reckovice a Mokra Hora 6203 [551244] Brno-Řečkovice a Mokrá Hora"
    },
    {
        "kod": 551252,
        "nazev": "Brno-Maloměřice a Obřany",
        "popis": "[551252] Brno-Maloměřice a Obřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551252] Brno-Malomerice a Obrany 6203 [551252] Brno-Maloměřice a Obřany"
    },
    {
        "kod": 551279,
        "nazev": "Brno-Vinohrady",
        "popis": "[551279] Brno-Vinohrady",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551279] Brno-Vinohrady 6203 [551279] Brno-Vinohrady"
    },
    {
        "kod": 551287,
        "nazev": "Brno-Líšeň",
        "popis": "[551287] Brno-Líšeň",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551287] Brno-Lisen 6203 [551287] Brno-Líšeň"
    },
    {
        "kod": 551295,
        "nazev": "Brno-Slatina",
        "popis": "[551295] Brno-Slatina",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551295] Brno-Slatina 6203 [551295] Brno-Slatina"
    },
    {
        "kod": 551309,
        "nazev": "Brno-Tuřany",
        "popis": "[551309] Brno-Tuřany",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551309] Brno-Turany 6203 [551309] Brno-Tuřany"
    },
    {
        "kod": 551317,
        "nazev": "Brno-Chrlice",
        "popis": "[551317] Brno-Chrlice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551317] Brno-Chrlice 6203 [551317] Brno-Chrlice"
    },
    {
        "kod": 551325,
        "nazev": "Brno-Bosonohy",
        "popis": "[551325] Brno-Bosonohy",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551325] Brno-Bosonohy 6203 [551325] Brno-Bosonohy"
    },
    {
        "kod": 551368,
        "nazev": "Brno-Žebětín",
        "popis": "[551368] Brno-Žebětín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551368] Brno-Zebetin 6203 [551368] Brno-Žebětín"
    },
    {
        "kod": 551376,
        "nazev": "Brno-Ivanovice",
        "popis": "[551376] Brno-Ivanovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551376] Brno-Ivanovice 6203 [551376] Brno-Ivanovice"
    },
    {
        "kod": 551406,
        "nazev": "Brno-Jehnice",
        "popis": "[551406] Brno-Jehnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551406] Brno-Jehnice 6203 [551406] Brno-Jehnice"
    },
    {
        "kod": 551422,
        "nazev": "Brno-Ořešín",
        "popis": "[551422] Brno-Ořešín",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551422] Brno-Oresin 6203 [551422] Brno-Ořešín"
    },
    {
        "kod": 551431,
        "nazev": "Brno-Útěchov",
        "popis": "[551431] Brno-Útěchov",
        "datum_od": "",
        "datum_do": "",
        "orp": 6203,
        "iczuj": 582786,
        "val": "[551431] Brno-Utechov 6203 [551431] Brno-Útěchov"
    },
    {
        "kod": 555321,
        "nazev": "Opava (nečleněná část města)",
        "popis": "[555321] Opava (nečleněná část města)",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555321] Opava (neclenena cast mesta) 8117 [555321] Opava (nečleněná část města)"
    },
    {
        "kod": 555339,
        "nazev": "Malé Hoštice",
        "popis": "[555339] Malé Hoštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555339] Male Hostice 8117 [555339] Malé Hoštice"
    },
    {
        "kod": 555355,
        "nazev": "Komárov",
        "popis": "[555355] Komárov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555355] Komarov 8117 [555355] Komárov"
    },
    {
        "kod": 555371,
        "nazev": "Suché Lazce",
        "popis": "[555371] Suché Lazce",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555371] Suche Lazce 8117 [555371] Suché Lazce"
    },
    {
        "kod": 555401,
        "nazev": "Podvihov",
        "popis": "[555401] Podvihov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555401] Podvihov 8117 [555401] Podvihov"
    },
    {
        "kod": 555410,
        "nazev": "Zlatníky",
        "popis": "[555410] Zlatníky",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555410] Zlatniky 8117 [555410] Zlatníky"
    },
    {
        "kod": 555436,
        "nazev": "Milostovice",
        "popis": "[555436] Milostovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555436] Milostovice 8117 [555436] Milostovice"
    },
    {
        "kod": 555461,
        "nazev": "Vlaštovičky",
        "popis": "[555461] Vlaštovičky",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[555461] Vlastovicky 8117 [555461] Vlaštovičky"
    },
    {
        "kod": 556700,
        "nazev": "Vávrovice",
        "popis": "[556700] Vávrovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8117,
        "iczuj": 505927,
        "val": "[556700] Vavrovice 8117 [556700] Vávrovice"
    },
    {
        "kod": 545911,
        "nazev": "Moravská Ostrava a Přívoz",
        "popis": "[545911] Moravská Ostrava a Přívoz",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[545911] Moravska Ostrava a Privoz 8119 [545911] Moravská Ostrava a Přívoz"
    },
    {
        "kod": 546046,
        "nazev": "Slezská Ostrava",
        "popis": "[546046] Slezská Ostrava",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[546046] Slezska Ostrava 8119 [546046] Slezská Ostrava"
    },
    {
        "kod": 546135,
        "nazev": "Ostrava-Jih",
        "popis": "[546135] Ostrava-Jih",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[546135] Ostrava-Jih 8119 [546135] Ostrava-Jih"
    },
    {
        "kod": 546224,
        "nazev": "Poruba",
        "popis": "[546224] Poruba",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[546224] Poruba 8119 [546224] Poruba"
    },
    {
        "kod": 554219,
        "nazev": "Nová Bělá",
        "popis": "[554219] Nová Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554219] Nova Bela 8119 [554219] Nová Bělá"
    },
    {
        "kod": 554227,
        "nazev": "Vítkovice",
        "popis": "[554227] Vítkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554227] Vitkovice 8119 [554227] Vítkovice"
    },
    {
        "kod": 554235,
        "nazev": "Stará Bělá",
        "popis": "[554235] Stará Bělá",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554235] Stara Bela 8119 [554235] Stará Bělá"
    },
    {
        "kod": 554243,
        "nazev": "Pustkovec",
        "popis": "[554243] Pustkovec",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554243] Pustkovec 8119 [554243] Pustkovec"
    },
    {
        "kod": 554286,
        "nazev": "Mariánské Hory a Hulváky",
        "popis": "[554286] Mariánské Hory a Hulváky",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554286] Marianske Hory a Hulvaky 8119 [554286] Mariánské Hory a Hulváky"
    },
    {
        "kod": 554308,
        "nazev": "Petřkovice",
        "popis": "[554308] Petřkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554308] Petrkovice 8119 [554308] Petřkovice"
    },
    {
        "kod": 554324,
        "nazev": "Lhotka",
        "popis": "[554324] Lhotka",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554324] Lhotka 8119 [554324] Lhotka"
    },
    {
        "kod": 554332,
        "nazev": "Hošťálkovice",
        "popis": "[554332] Hošťálkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554332] Hostalkovice 8119 [554332] Hošťálkovice"
    },
    {
        "kod": 554367,
        "nazev": "Nová Ves",
        "popis": "[554367] Nová Ves",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554367] Nova Ves 8119 [554367] Nová Ves"
    },
    {
        "kod": 554375,
        "nazev": "Proskovice",
        "popis": "[554375] Proskovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554375] Proskovice 8119 [554375] Proskovice"
    },
    {
        "kod": 554430,
        "nazev": "Michálkovice",
        "popis": "[554430] Michálkovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554430] Michalkovice 8119 [554430] Michálkovice"
    },
    {
        "kod": 554537,
        "nazev": "Radvanice a Bartovice",
        "popis": "[554537] Radvanice a Bartovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554537] Radvanice a Bartovice 8119 [554537] Radvanice a Bartovice"
    },
    {
        "kod": 554561,
        "nazev": "Krásné Pole",
        "popis": "[554561] Krásné Pole",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554561] Krasne Pole 8119 [554561] Krásné Pole"
    },
    {
        "kod": 554570,
        "nazev": "Martinov",
        "popis": "[554570] Martinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554570] Martinov 8119 [554570] Martinov"
    },
    {
        "kod": 554588,
        "nazev": "Polanka nad Odrou",
        "popis": "[554588] Polanka nad Odrou",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554588] Polanka nad Odrou 8119 [554588] Polanka nad Odrou"
    },
    {
        "kod": 554669,
        "nazev": "Hrabová",
        "popis": "[554669] Hrabová",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554669] Hrabova 8119 [554669] Hrabová"
    },
    {
        "kod": 554685,
        "nazev": "Svinov",
        "popis": "[554685] Svinov",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554685] Svinov 8119 [554685] Svinov"
    },
    {
        "kod": 554715,
        "nazev": "Třebovice",
        "popis": "[554715] Třebovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554715] Trebovice 8119 [554715] Třebovice"
    },
    {
        "kod": 554723,
        "nazev": "Plesná",
        "popis": "[554723] Plesná",
        "datum_od": "",
        "datum_do": "",
        "orp": 8119,
        "iczuj": 554821,
        "val": "[554723] Plesna 8119 [554723] Plesná"
    },
    {
        "kod": 552836,
        "nazev": "Turovice",
        "popis": "[552836] Turovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552836,
        "val": "[552836] Turovice 7109 [552836] Turovice"
    },
    {
        "kod": 570079,
        "nazev": "Týn nad Bečvou",
        "popis": "[570079] Týn nad Bečvou",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 570079,
        "val": "[570079] Tyn nad Becvou 7104 [570079] Týn nad Bečvou"
    },
    {
        "kod": 552879,
        "nazev": "Uhřičice",
        "popis": "[552879] Uhřičice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552879,
        "val": "[552879] Uhricice 7109 [552879] Uhřičice"
    },
    {
        "kod": 520306,
        "nazev": "Ústí",
        "popis": "[520306] Ústí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 520306,
        "val": "[520306] Usti 7101 [520306] Ústí"
    },
    {
        "kod": 520420,
        "nazev": "Veselíčko",
        "popis": "[520420] Veselíčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7104,
        "iczuj": 520420,
        "val": "[520420] Veselicko 7104 [520420] Veselíčko"
    },
    {
        "kod": 552755,
        "nazev": "Věžky",
        "popis": "[552755] Věžky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 552755,
        "val": "[552755] Vezky 7109 [552755] Věžky"
    },
    {
        "kod": 547433,
        "nazev": "Vlkoš",
        "popis": "[547433] Vlkoš",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 547433,
        "val": "[547433] Vlkos 7109 [547433] Vlkoš"
    },
    {
        "kod": 521531,
        "nazev": "Všechovice",
        "popis": "[521531] Všechovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 521531,
        "val": "[521531] Vsechovice 7101 [521531] Všechovice"
    },
    {
        "kod": 547450,
        "nazev": "Výkleky",
        "popis": "[547450] Výkleky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 547450,
        "val": "[547450] Vykleky 7109 [547450] Výkleky"
    },
    {
        "kod": 547514,
        "nazev": "Zábeštní Lhota",
        "popis": "[547514] Zábeštní Lhota",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 547514,
        "val": "[547514] Zabestni Lhota 7109 [547514] Zábeštní Lhota"
    },
    {
        "kod": 522775,
        "nazev": "Zámrsky",
        "popis": "[522775] Zámrsky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7101,
        "iczuj": 522775,
        "val": "[522775] Zamrsky 7101 [522775] Zámrsky"
    },
    {
        "kod": 523453,
        "nazev": "Žákovice",
        "popis": "[523453] Žákovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 523453,
        "val": "[523453] Zakovice 7109 [523453] Žákovice"
    },
    {
        "kod": 523640,
        "nazev": "Želatovice",
        "popis": "[523640] Želatovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7109,
        "iczuj": 523640,
        "val": "[523640] Zelatovice 7109 [523640] Želatovice"
    },
    {
        "kod": 525588,
        "nazev": "Bludov",
        "popis": "[525588] Bludov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 525588,
        "val": "[525588] Bludov 7111 [525588] Bludov"
    },
    {
        "kod": 525804,
        "nazev": "Bohdíkov",
        "popis": "[525804] Bohdíkov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 525804,
        "val": "[525804] Bohdikov 7111 [525804] Bohdíkov"
    },
    {
        "kod": 525880,
        "nazev": "Bohuslavice",
        "popis": "[525880] Bohuslavice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 525880,
        "val": "[525880] Bohuslavice 7113 [525880] Bohuslavice"
    },
    {
        "kod": 525979,
        "nazev": "Bohutín",
        "popis": "[525979] Bohutín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 525979,
        "val": "[525979] Bohutin 7111 [525979] Bohutín"
    },
    {
        "kod": 526169,
        "nazev": "Branná",
        "popis": "[526169] Branná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 526169,
        "val": "[526169] Branna 7111 [526169] Branná"
    },
    {
        "kod": 569437,
        "nazev": "Bratrušov",
        "popis": "[569437] Bratrušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 569437,
        "val": "[569437] Bratrusov 7111 [569437] Bratrušov"
    },
    {
        "kod": 530727,
        "nazev": "Brníčko",
        "popis": "[530727] Brníčko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 530727,
        "val": "[530727] Brnicko 7113 [530727] Brníčko"
    },
    {
        "kod": 532894,
        "nazev": "Bušín",
        "popis": "[532894] Bušín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 532894,
        "val": "[532894] Busin 7111 [532894] Bušín"
    },
    {
        "kod": 533688,
        "nazev": "Dlouhomilov",
        "popis": "[533688] Dlouhomilov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 533688,
        "val": "[533688] Dlouhomilov 7111 [533688] Dlouhomilov"
    },
    {
        "kod": 553379,
        "nazev": "Dolní Studénky",
        "popis": "[553379] Dolní Studénky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553379,
        "val": "[553379] Dolni Studenky 7111 [553379] Dolní Studénky"
    },
    {
        "kod": 570141,
        "nazev": "Drozdov",
        "popis": "[570141] Drozdov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 570141,
        "val": "[570141] Drozdov 7113 [570141] Drozdov"
    },
    {
        "kod": 534927,
        "nazev": "Dubicko",
        "popis": "[534927] Dubicko",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 534927,
        "val": "[534927] Dubicko 7113 [534927] Dubicko"
    },
    {
        "kod": 535532,
        "nazev": "Hanušovice",
        "popis": "[535532] Hanušovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 535532,
        "val": "[535532] Hanusovice 7111 [535532] Hanušovice"
    },
    {
        "kod": 535770,
        "nazev": "Horní Studénky",
        "popis": "[535770] Horní Studénky",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 535770,
        "val": "[535770] Horni Studenky 7113 [535770] Horní Studénky"
    },
    {
        "kod": 535885,
        "nazev": "Hoštejn",
        "popis": "[535885] Hoštejn",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 535885,
        "val": "[535885] Hostejn 7113 [535885] Hoštejn"
    },
    {
        "kod": 553387,
        "nazev": "Hraběšice",
        "popis": "[553387] Hraběšice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553387,
        "val": "[553387] Hrabesice 7111 [553387] Hraběšice"
    },
    {
        "kod": 536091,
        "nazev": "Hrabišín",
        "popis": "[536091] Hrabišín",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 536091,
        "val": "[536091] Hrabisin 7111 [536091] Hrabišín"
    },
    {
        "kod": 553221,
        "nazev": "Hrabová",
        "popis": "[553221] Hrabová",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 553221,
        "val": "[553221] Hrabova 7113 [553221] Hrabová"
    },
    {
        "kod": 536113,
        "nazev": "Hynčina",
        "popis": "[536113] Hynčina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536113,
        "val": "[536113] Hyncina 7113 [536113] Hynčina"
    },
    {
        "kod": 569305,
        "nazev": "Chromeč",
        "popis": "[569305] Chromeč",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 569305,
        "val": "[569305] Chromec 7111 [569305] Chromeč"
    },
    {
        "kod": 553344,
        "nazev": "Jakubovice",
        "popis": "[553344] Jakubovice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553344,
        "val": "[553344] Jakubovice 7111 [553344] Jakubovice"
    },
    {
        "kod": 553212,
        "nazev": "Janoušov",
        "popis": "[553212] Janoušov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553212,
        "val": "[553212] Janousov 7111 [553212] Janoušov"
    },
    {
        "kod": 536288,
        "nazev": "Jedlí",
        "popis": "[536288] Jedlí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536288,
        "val": "[536288] Jedli 7113 [536288] Jedlí"
    },
    {
        "kod": 536393,
        "nazev": "Jestřebí",
        "popis": "[536393] Jestřebí",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536393,
        "val": "[536393] Jestrebi 7113 [536393] Jestřebí"
    },
    {
        "kod": 536521,
        "nazev": "Jindřichov",
        "popis": "[536521] Jindřichov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 536521,
        "val": "[536521] Jindrichov 7111 [536521] Jindřichov"
    },
    {
        "kod": 536571,
        "nazev": "Kamenná",
        "popis": "[536571] Kamenná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536571,
        "val": "[536571] Kamenna 7113 [536571] Kamenná"
    },
    {
        "kod": 536687,
        "nazev": "Klopina",
        "popis": "[536687] Klopina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 536687,
        "val": "[536687] Klopina 7106 [536687] Klopina"
    },
    {
        "kod": 536733,
        "nazev": "Kolšov",
        "popis": "[536733] Kolšov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536733,
        "val": "[536733] Kolsov 7113 [536733] Kolšov"
    },
    {
        "kod": 553247,
        "nazev": "Kopřivná",
        "popis": "[553247] Kopřivná",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 553247,
        "val": "[553247] Koprivna 7111 [553247] Kopřivná"
    },
    {
        "kod": 536814,
        "nazev": "Kosov",
        "popis": "[536814] Kosov",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 536814,
        "val": "[536814] Kosov 7113 [536814] Kosov"
    },
    {
        "kod": 569372,
        "nazev": "Krchleby",
        "popis": "[569372] Krchleby",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 569372,
        "val": "[569372] Krchleby 7106 [569372] Krchleby"
    },
    {
        "kod": 537284,
        "nazev": "Lesnice",
        "popis": "[537284] Lesnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 537284,
        "val": "[537284] Lesnice 7113 [537284] Lesnice"
    },
    {
        "kod": 537713,
        "nazev": "Leština",
        "popis": "[537713] Leština",
        "datum_od": "",
        "datum_do": "",
        "orp": 7113,
        "iczuj": 537713,
        "val": "[537713] Lestina 7113 [537713] Leština"
    },
    {
        "kod": 539961,
        "nazev": "Libina",
        "popis": "[539961] Libina",
        "datum_od": "",
        "datum_do": "",
        "orp": 7111,
        "iczuj": 539961,
        "val": "[539961] Libina 7111 [539961] Libina"
    },
    {
        "kod": 540161,
        "nazev": "Líšnice",
        "popis": "[540161] Líšnice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540161,
        "val": "[540161] Lisnice 7106 [540161] Líšnice"
    },
    {
        "kod": 540196,
        "nazev": "Loštice",
        "popis": "[540196] Loštice",
        "datum_od": "",
        "datum_do": "",
        "orp": 7106,
        "iczuj": 540196,
        "val": "[540196] Lostice 7106 [540196] Loštice"
    },
    {
        "kod": 500101,
        "nazev": "Bražec",
        "popis": "[500101] Bražec",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 4103,
        "iczuj": 500101,
        "val": "[500101] Brazec 4103 [500101] Bražec"
    },
    {
        "kod": 500127,
        "nazev": "Doupovské Hradiště",
        "popis": "[500127] Doupovské Hradiště",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 4106,
        "iczuj": 500127,
        "val": "[500127] Doupovske Hradiste 4106 [500127] Doupovské Hradiště"
    },
    {
        "kod": 500135,
        "nazev": "Kozlov",
        "popis": "[500135] Kozlov",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 7107,
        "iczuj": 500135,
        "val": "[500135] Kozlov 7107 [500135] Kozlov"
    },
    {
        "kod": 500151,
        "nazev": "Luboměř pod Strážnou",
        "popis": "[500151] Luboměř pod Strážnou",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 7101,
        "iczuj": 500151,
        "val": "[500151] Lubomer pod Straznou 7101 [500151] Luboměř pod Strážnou"
    },
    {
        "kod": 500160,
        "nazev": "Město Libavá",
        "popis": "[500160] Město Libavá",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 7110,
        "iczuj": 500160,
        "val": "[500160] Mesto Libava 7110 [500160] Město Libavá"
    },
    {
        "kod": 500194,
        "nazev": "Polná na Šumavě",
        "popis": "[500194] Polná na Šumavě",
        "datum_od": 2016,
        "datum_do": "",
        "orp": 3103,
        "iczuj": 500194,
        "val": "[500194] Polna na Sumave 3103 [500194] Polná na Šumavě"
    },
    {
        "kod": 537047,
        "nazev": "Bříství",
        "popis": "[537047] Bříství",
        "datum_od": 2021,
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537047,
        "val": "[537047] Bristvi 2113 [537047] Bříství"
    },
    {
        "kod": 537357,
        "nazev": "Kounice",
        "popis": "[537357] Kounice",
        "datum_od": 2021,
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537357,
        "val": "[537357] Kounice 2113 [537357] Kounice"
    },
    {
        "kod": 537993,
        "nazev": "Vykáň",
        "popis": "[537993] Vykáň",
        "datum_od": 2021,
        "datum_do": "",
        "orp": 2113,
        "iczuj": 537993,
        "val": "[537993] Vykan 2113 [537993] Vykáň"
    },
    {
        "kod": 563579,
        "nazev": "Frýdštejn",
        "popis": "[563579] Frýdštejn",
        "datum_od": 2021,
        "datum_do": "",
        "orp": 5103,
        "iczuj": 563579,
        "val": "[563579] Frydstejn 5103[563579] Frýdštejn"
    },
    {
        "kod": 569704,
        "nazev": "Věžnice",
        "popis": "[569704] Věžnice",
        "datum_od": 2021,
        "datum_do": "",
        "orp": 6102,
        "iczuj": 569704,
        "val": "[569704] Veznice 6102 [569704] Věžnice"
    }
]



// WEBPACK FOOTER //
// build/services/pscDimensions/orpZujData.js